import React, { useState, useEffect, useRef, useCallback, useReducer, memo, useMemo, createContext, useContext, Component } from 'react';
import { Ticket, Mail, Calendar, Phone, Image as ImageIcon, Send, Trash2, Loader2, Mic, Volume2, VolumeX, Copy, Check, Download, ThumbsUp, ThumbsDown, XCircle, X, Coffee, FileText, Notebook, Link as LinkIcon, Lightbulb, BrainCircuit, User, Settings2, Search, Linkedin, Facebook, Instagram, AlertTriangle, Shield, KeyRound, AtSign, Fish, GraduationCap, Sparkles, Globe, Server, Bug, ShieldCheck, CheckCircle, CheckCircle2, ClipboardList, BookKey, Link2Off, FileScan, Bell, BellOff, BellRing, StopCircle, ChevronDown, ChevronUp, ChevronLeft, ChevronRight, Building2, Laptop, Monitor, Wifi, PlugZag, Timer, ArrowDownCircle, ArrowUpCircle, Video, Eye, EyeOff, RefreshCw, ExternalLink, Link2, RotateCcw, ArrowLeft, FolderOpen, Clock, Settings, MessageSquare, Key, Moon, Sun, Camera, History, Star, StarOff, MessageCircle, HelpCircle, PlugZap, Smartphone, Keyboard, SlidersHorizontal, Lock, Info, Plus } from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { QRCodeSVG } from 'qrcode.react';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import DOMPurify from 'dompurify';
import OperationsHub from './OperationsHub';
import SparkControlAdmin from './SparkControlAdmin';
import AdminManager from './AdminManager';
import { useTicketFilter, applyTicketFilter, TicketFilterBar } from './TicketFilters';

// ============================================================================
// 🔒 PROTEZIONE ANTI-CLONE & ANTI-REVERSE ENGINEERING - 86BIT PROPRIETARY
// ============================================================================
(() => {
    const _0x86BIT = {
        // Domini autorizzati
        _d: ['spark.86bit.it', 'localhost', '127.0.0.1', 'preview.emergentagent.com'],
        // Timestamp build
        _t: Date.now(),
        // Signature
        _s: 'SPK-86BIT-2026-SEC',
        
        // Verifica dominio
        _v: function() {
            const h = window.location.hostname;
            const ok = this._d.some(d => h === d || h.endsWith('.' + d) || h.includes(d));
            if (!ok) {
                document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#1a1a2e;color:#e94560;font-family:system-ui;flex-direction:column;"><h1>⛔ ACCESSO NON AUTORIZZATO</h1><p>Questo software è proprietario di 86BIT srl</p><p style="color:#666;font-size:12px;">Unauthorized domain detected</p></div>';
                throw new Error('[86BIT] Unauthorized domain');
            }
        },
        
        // Anti-DevTools (soft)
        _a: function() {
            const threshold = 160;
            const check = () => {
                const w = window.outerWidth - window.innerWidth > threshold;
                const h = window.outerHeight - window.innerHeight > threshold;
                if (w || h) {
                    console.clear();
                    console.log('%c⚠️ 86BIT SPARK - SOFTWARE PROPRIETARIO', 'color:#e94560;font-size:20px;font-weight:bold;');
                    console.log('%cQuesto software è protetto da copyright. La copia o il reverse engineering è vietato.', 'color:#666;font-size:12px;');
                    console.log('%c© 2026 86BIT srl Unipersonale - Tutti i diritti riservati', 'color:#888;font-size:10px;');
                }
            };
            setInterval(check, 1000);
            window.addEventListener('resize', check);
        },
        
        // Disabilita tasto destro OVUNQUE
        _r: function() {
            document.addEventListener('contextmenu', (e) => {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }, true);
        },
        
        // Anti-iframe embedding
        _f: function() {
            if (window.self !== window.top) {
                const parentHost = window.parent.location.hostname;
                const ok = this._d.some(d => parentHost === d || parentHost.endsWith('.' + d));
                if (!ok) {
                    window.top.location = window.self.location;
                }
            }
        },
        
        // Blocca copy del codice sorgente
        _c: function() {
            // Blocca selezione testo (eccetto input/textarea)
            document.addEventListener('selectstart', (e) => {
                if (!['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
                    e.preventDefault();
                    return false;
                }
            });
            
            // Blocca drag (eccetto elementi marcati come trascinabili, es. link Preferiti)
            document.addEventListener('dragstart', (e) => {
                if (e.target && e.target.closest && e.target.closest('[data-allow-drag="true"]')) {
                    return; // consenti il drag nativo (trascina sulla barra dei preferiti)
                }
                e.preventDefault();
                return false;
            });
            
            // Blocca copia (eccetto input/textarea)
            document.addEventListener('copy', (e) => {
                if (!['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                    e.preventDefault();
                    return false;
                }
            });
            
            document.addEventListener('keydown', (e) => {
                // Blocca Ctrl+U (view source)
                if (e.ctrlKey && e.key === 'u') {
                    e.preventDefault();
                    return false;
                }
                // Blocca Ctrl+Shift+I (DevTools)
                if (e.ctrlKey && e.shiftKey && e.key === 'I') {
                    e.preventDefault();
                    return false;
                }
                // Blocca Ctrl+Shift+J (Console)
                if (e.ctrlKey && e.shiftKey && e.key === 'J') {
                    e.preventDefault();
                    return false;
                }
                // Blocca Ctrl+Shift+C (Inspect)
                if (e.ctrlKey && e.shiftKey && e.key === 'C') {
                    e.preventDefault();
                    return false;
                }
                // Blocca F12
                if (e.key === 'F12') {
                    e.preventDefault();
                    return false;
                }
                // Blocca Ctrl+S (Save)
                if (e.ctrlKey && e.key === 's') {
                    e.preventDefault();
                    return false;
                }
                // Blocca Ctrl+P (Print)
                if (e.ctrlKey && e.key === 'p') {
                    e.preventDefault();
                    return false;
                }
            });
        },
        
        // Watermark invisibile
        _w: function() {
            const wm = document.createElement('div');
            wm.style.cssText = 'position:fixed;bottom:0;right:0;font-size:1px;color:transparent;pointer-events:none;z-index:-1;';
            wm.textContent = '86BIT-SPARK-' + this._s + '-' + this._t;
            wm.setAttribute('data-86bit', btoa(JSON.stringify({v:this._s,t:this._t,d:window.location.hostname})));
            document.body.appendChild(wm);
        },
        
        // Init
        init: function() {
            try {
                this._v(); // Verifica dominio
                this._f(); // Anti-iframe
                this._a(); // Anti-DevTools
                this._r(); // Anti-right click
                this._c(); // Anti-copy
                this._xss(); // Anti-XSS
                this._timing(); // Anti-timing attacks
                setTimeout(() => this._w(), 2000); // Watermark
            } catch(e) {
                console.error('[86BIT] Security init failed');
            }
        },
        
        // Protezione Anti-XSS avanzata
        _xss: function() {
            // Intercetta e sanitizza tutti gli input
            const sanitize = (str) => {
                if (typeof str !== 'string') return str;
                return str
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#x27;')
                    .replace(/\//g, '&#x2F;')
                    .replace(/javascript:/gi, '')
                    .replace(/on\w+=/gi, '');
            };
            window.__sanitize = sanitize;
        },
        
        // Protezione contro timing attacks
        _timing: function() {
            // Aggiungi delay random per prevenire timing attacks
            const originalFetch = window.fetch;
            window.fetch = function(...args) {
                return new Promise((resolve, reject) => {
                    const delay = Math.random() * 50; // 0-50ms random delay
                    setTimeout(() => {
                        originalFetch.apply(this, args).then(resolve).catch(reject);
                    }, delay);
                });
            };
        }
    };
    
    // Avvia protezioni
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => _0x86BIT.init());
    } else {
        _0x86BIT.init();
    }
})();

// 🛡️ DOMPURIFY GLOBAL CONFIGURATION - Enterprise Security
// Configura DOMPurify per rimuovere contenuti pericolosi globalmente
DOMPurify.setConfig({
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'select', 'textarea'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout', 'onfocus', 'onblur', 'onchange', 'onsubmit'],
    ALLOW_DATA_ATTR: false,
    ALLOW_UNKNOWN_PROTOCOLS: false
});

// 🚫 BLOCCA PROMPT INDESIDERATI (es. "Enter your email for notifications")
// Questo blocca qualsiasi window.prompt() che potrebbe venire da script esterni
const originalPrompt = window.prompt;
window.prompt = function(message, defaultValue) {
    // Blocca prompt relativi a email/notifiche
    if (message && (
        message.toLowerCase().includes('email') || 
        message.toLowerCase().includes('notification') ||
        message.toLowerCase().includes('notifiche')
    )) {
        console.warn('[SPARK] Blocked unwanted prompt:', message);
        return null; // Simula click su "Annulla"
    }
    // Permetti altri prompt se necessario
    return originalPrompt.call(window, message, defaultValue);
};

// Hook per rimuovere javascript: URLs
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.hasAttribute('href')) {
        const href = node.getAttribute('href');
        if (href && href.toLowerCase().startsWith('javascript:')) {
            node.removeAttribute('href');
        }
    }
    if (node.hasAttribute('src')) {
        const src = node.getAttribute('src');
        if (src && src.toLowerCase().startsWith('javascript:')) {
            node.removeAttribute('src');
        }
    }
});

// App Configuration Manager
const AppConfig = (() => {
    const _isProd = window.location.hostname !== 'localhost' && !window.location.hostname.includes('preview');
    const _token = Math.random().toString(36).substring(2) + Date.now().toString(36);
    
    // Console optimization for production
    const _optimizeLogging = () => {
        if (_isProd) {
            const empty = () => {};
            ['log', 'debug', 'info', 'table', 'dir', 'trace'].forEach(m => {
                console[m] = empty;
            });
        }
    };
    
    // Developer notice
    const _showDevNotice = () => {
        if (_isProd) {
            console.clear();
            console.log('%c⚠️ ATTENZIONE', 'color: red; font-size: 40px; font-weight: bold;');
            console.log('%cQuesto browser è destinato agli sviluppatori.', 'font-size: 16px;');
            console.log('%cSe qualcuno ti ha detto di copiare/incollare qualcosa qui, è una truffa.', 'font-size: 14px; color: red;');
        }
    };
    
    // Input cleaner for forms
    const _cleanInput = (input) => {
        if (typeof input !== 'string') return input;
        return input
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;')
            .replace(/\//g, '&#x2F;')
            .replace(/javascript:/gi, '')
            .replace(/on\w+=/gi, '');
    };
    
    // Session manager
    const _initSession = () => {
        const stored = sessionStorage.getItem('_st');
        if (!stored) {
            sessionStorage.setItem('_st', _token);
        }
        return true;
    };
    
    // Request tracker
    const _tracker = (() => {
        const reqs = new Map();
        const WINDOW = 60000;
        const MAX = 100;
        
        return (key) => {
            const now = Date.now();
            const start = now - WINDOW;
            
            if (!reqs.has(key)) {
                reqs.set(key, []);
            }
            
            const list = reqs.get(key).filter(t => t > start);
            list.push(now);
            reqs.set(key, list);
            
            return list.length <= MAX;
        };
    })();
    
    // Frame check
    const _checkFrame = () => {
        if (_isProd && window.self !== window.top) {
            try {
                const parent = window.parent.location.hostname;
                const allowed = ['86bit.it', 'spark.86bit.it', 'localhost'];
                if (!allowed.some(d => parent.includes(d))) {
                    document.body.innerHTML = '<h1>Accesso non autorizzato</h1>';
                }
            } catch (e) {
                document.body.innerHTML = '<h1>Accesso non autorizzato</h1>';
            }
        }
    };
    
    // Setup
    const setup = () => {
        _optimizeLogging();
        _checkFrame();
        _initSession();
        
        // Show notice when dev tools open (non-blocking)
        let noticeShown = false;
        const checkSize = () => {
            const diff = window.outerWidth - window.innerWidth > 160 || 
                        window.outerHeight - window.innerHeight > 160;
            if (diff && !noticeShown) {
                noticeShown = true;
                _showDevNotice();
            } else if (!diff) {
                noticeShown = false;
            }
        };
        setInterval(checkSize, 2000);
        
        if (!_isProd) {
            console.log('App Configuration initialized (dev mode)');
        }
    };
    
    return {
        setup,
        sanitize: _cleanInput,
        checkLimit: _tracker,
        isProd: _isProd,
        token: () => _token
    };
})();

// Initialize app config
AppConfig.setup();

// Initialize AI Sync system (dopo che AppConfig è pronto)
if (typeof window !== 'undefined') {
    // Ritarda l'init per assicurarsi che tutto sia caricato
    setTimeout(() => {
        initAISync().catch(e => console.warn('[AI_SYNC] Init fallito:', e));
    }, 2000);
}

// ============================================================================
// ERROR BOUNDARY - Previene schermo bianco su errori
// ============================================================================
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('🔴 ErrorBoundary caught error:', error, errorInfo);
        // Pulisci localStorage corrotto se necessario
        try {
            const keysToCheck = ['spark-chat-session-v4', 'spark-user-details-v4'];
            keysToCheck.forEach(key => {
                try {
                    const data = localStorage.getItem(key);
                    if (data) JSON.parse(data); // Test if valid JSON
                } catch (e) {
                    console.warn(`Removing corrupted localStorage key: ${key}`);
                    localStorage.removeItem(key);
                }
            });
        } catch (e) {
            console.error('Error cleaning localStorage:', e);
        }
    }

    handleReload = () => {
        // Pulisci stato corrotto e ricarica
        try {
            localStorage.removeItem('spark-chat-session-v4');
        } catch (e) {}
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-100 p-4">
                    <div className="bg-white rounded-xl shadow-xl p-8 max-w-md text-center">
                        <AlertTriangle className="h-16 w-16 text-yellow-500 mx-auto mb-4" />
                        <h2 className="text-xl font-bold text-gray-800 mb-2">Oops! Qualcosa è andato storto</h2>
                        <p className="text-gray-600 mb-6">Non preoccuparti, puoi riprovare cliccando il pulsante qui sotto.</p>
                        <button
                            onClick={this.handleReload}
                            className="px-6 py-3 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 transition-colors"
                        >
                            🔄 Ricarica l'app
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

// ============================================================================
// TOUCH OPTIMIZATION STYLES - Rimuove delay 300ms e migliora reattività
// ============================================================================
const TouchOptimizationStyles = () => (
    <style>{`
        /* Rimuove il delay 300ms sui dispositivi touch - escludi input/textarea */
        *:not(input):not(textarea):not(select) {
            touch-action: manipulation;
        }
        
        /* Input/textarea devono permettere la scrittura */
        input, textarea, select {
            touch-action: auto;
            -webkit-user-select: text;
            user-select: text;
        }
        
        /* Disabilita il tap highlight su iOS/Android - solo pulsanti */
        button, a, [role="button"] {
            -webkit-tap-highlight-color: transparent;
            -webkit-touch-callout: none;
            touch-action: manipulation;
        }
        
        /* Feedback visivo immediato sui pulsanti */
        button:active, a:active, [role="button"]:active {
            transform: scale(0.97);
            opacity: 0.9;
        }
        
        /* Transizioni veloci per feedback immediato */
        button, a, [role="button"] {
            transition: transform 0.1s ease, opacity 0.1s ease, background-color 0.15s ease;
        }
        
        /* Previene zoom accidentale su input (iOS) - font-size 16px */
        input, textarea, select {
            font-size: 16px !important;
        }
        
        /* Migliora lo scrolling su iOS */
        .overflow-y-auto, .overflow-x-auto {
            -webkit-overflow-scrolling: touch;
        }
        
        /* Cursor pointer per elementi cliccabili */
        button, a, [role="button"], input[type="submit"], input[type="button"] {
            cursor: pointer;
        }
    `}</style>
);

// ============================================================================
// CONFIGURATION
// ============================================================================
// Risolve la base URL delle API in modo robusto:
// - In sviluppo/preview usa REACT_APP_BACKEND_URL (stesso host della pagina)
// - In produzione, se il build ha un REACT_APP_BACKEND_URL con host DIVERSO da
//   quello corrente (es. URL preview rimasto nel build), usa l'origine corrente.
//   Questo evita errori di connessione/CORS quando l'app gira su spark.86bit.it.
const resolveApiBaseUrl = () => {
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    if (typeof window === 'undefined') return envUrl || 'https://spark.86bit.it';
    const origin = window.location.origin;
    if (!envUrl) return origin;
    try {
        const envHost = new URL(envUrl).host;
        if (envHost !== window.location.host) return origin; // host diverso -> usa origine corrente
    } catch (e) {
        return origin;
    }
    return envUrl;
};
const API_BASE_URL = resolveApiBaseUrl();
const CHAT_SESSION_STORAGE_KEY = 'spark-chat-session-v4';

// Handoff mobile via QR: codifica/decodifica identita' in base64url
const encodeHandoff = (obj) => {
    try {
        const json = JSON.stringify(obj);
        return btoa(unescape(encodeURIComponent(json)))
            .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (e) { return ''; }
};
const USER_DETAILS_STORAGE_KEY = 'spark-user-details-v4';
const DAILY_WELCOME_SHOWN_KEY = 'spark-daily-welcome-shown-v2';
const DAILY_BAT_WELCOME_SHOWN_KEY = 'spark-bat-welcome-shown-today-v2';
const HISTORY_STORAGE_KEY = 'spark-user-history-v4';
const NOTIFICATION_PERMISSION_KEY = 'spark-notification-permission-v1';
const FCM_TOKEN_KEY = 'spark-fcm-token-v1';
const JWT_TOKEN_KEY = 'spark-jwt-token-v1';
const SYNC_LAST_TIMESTAMP_KEY = 'spark-ai-sync-timestamp-v1';
const APP_VERSION = "V.12.15-FORCEUPD";

// ============================================================================
// 🔄 CENTRALIZZAZIONE APPRENDIMENTO AI - SYNC CON BACKEND
// ============================================================================
// Sincronizza i dati di apprendimento con il server centrale ogni 24 ore
// e alla chiusura della sessione, per condividere la conoscenza tra tutti gli Spark

const AI_SYNC_CONFIG = {
    endpoint: '/api/v1/ai/sync',
    syncIntervalHours: 24,
    enabled: true
};

// Raccoglie tutti i dati di apprendimento AI da sincronizzare
const collectAILearningData = () => {
    try {
        // Dati utente corrente dalla sessione
        const sessionData = JSON.parse(localStorage.getItem(CHAT_SESSION_STORAGE_KEY) || '{}');
        
        return {
            // Metadata
            syncTimestamp: new Date().toISOString(),
            sparkVersion: APP_VERSION,
            
            // Identificazione (NON anonimizzato come richiesto)
            user: {
                userName: sessionData.userName || null,
                userComputer: sessionData.userComputer || null,
                userCompany: sessionData.userCompany || sessionData.userSiteName || null,
                userEmail: sessionData.userEmail || localStorage.getItem('spark-user-email-v1') || null
            },
            
            // Memoria AI (soluzioni, topic, feedback)
            aiMemory: JSON.parse(localStorage.getItem('spark-ai-memory-v2') || 'null'),
            
            // Profilo utente dinamico
            userProfile: JSON.parse(localStorage.getItem('spark-user-profile-v2') || 'null'),
            
            // Memoria cross-session (storico problemi, pattern successo)
            crossSessionMemory: JSON.parse(localStorage.getItem('spark-cross-session-memory-v1') || 'null'),
            
            // Knowledge Base locale
            knowledgeBase: JSON.parse(localStorage.getItem('spark-knowledge-base-v1') || 'null'),
            
            // Feedback raccolti
            feedbacks: JSON.parse(localStorage.getItem('spark-feedbacks') || '[]'),
            
            // Statistiche sessione
            sessionStats: {
                messageCount: sessionData.messages?.length || 0,
                sessionStartTime: sessionData.sessionStartTime || null,
                hardwareType: sessionData.userPCHardwareType || null,
                connectionType: sessionData.userConnectionType || null,
                isDeviceManaged: sessionData.isDeviceManaged || null
            }
        };
    } catch (e) {
        console.error('[AI_SYNC] Errore raccolta dati:', e);
        return null;
    }
};

// Verifica se è passato abbastanza tempo dall'ultima sincronizzazione
const shouldSyncNow = () => {
    if (!AI_SYNC_CONFIG.enabled) return false;
    
    try {
        const lastSync = localStorage.getItem(SYNC_LAST_TIMESTAMP_KEY);
        if (!lastSync) return true; // Mai sincronizzato
        
        const lastSyncDate = new Date(lastSync);
        const now = new Date();
        const hoursSinceLastSync = (now - lastSyncDate) / (1000 * 60 * 60);
        
        return hoursSinceLastSync >= AI_SYNC_CONFIG.syncIntervalHours;
    } catch (e) {
        return true; // In caso di errore, prova a sincronizzare
    }
};

// Esegue la sincronizzazione con il backend
const syncAILearningToBackend = async (force = false) => {
    if (!AI_SYNC_CONFIG.enabled) {
        console.log('[AI_SYNC] Sincronizzazione disabilitata');
        return { success: false, reason: 'disabled' };
    }
    
    if (!force && !shouldSyncNow()) {
        console.log('[AI_SYNC] Sync non necessaria (ultima sync < 24h)');
        return { success: false, reason: 'not_needed' };
    }
    
    const learningData = collectAILearningData();
    if (!learningData) {
        console.error('[AI_SYNC] Nessun dato da sincronizzare');
        return { success: false, reason: 'no_data' };
    }
    
    // Se non c'è un utente identificato, non sincronizzare
    if (!learningData.user?.userName && !learningData.user?.userEmail) {
        console.log('[AI_SYNC] Utente non identificato, skip sync');
        return { success: false, reason: 'no_user' };
    }
    
    try {
        console.log('[AI_SYNC] 🔄 Avvio sincronizzazione...');
        
        const response = await fetch(`${API_BASE_URL}${AI_SYNC_CONFIG.endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(learningData)
        });
        
        if (response.ok) {
            const result = await response.json();
            
            // Salva timestamp ultima sync
            localStorage.setItem(SYNC_LAST_TIMESTAMP_KEY, new Date().toISOString());
            
            console.log('[AI_SYNC] ✅ Sincronizzazione completata:', result);
            
            // Se il server ha restituito una Knowledge Base aggiornata, salvala localmente
            if (result.updatedKnowledgeBase) {
                localStorage.setItem('spark-knowledge-base-v1', JSON.stringify(result.updatedKnowledgeBase));
                console.log('[AI_SYNC] 📚 Knowledge Base aggiornata dal server');
            }
            
            return { success: true, result };
        } else {
            console.warn('[AI_SYNC] ⚠️ Risposta server non OK:', response.status);
            return { success: false, reason: 'server_error', status: response.status };
        }
    } catch (e) {
        console.error('[AI_SYNC] ❌ Errore sincronizzazione:', e);
        return { success: false, reason: 'network_error', error: e.message };
    }
};

// Sincronizzazione alla chiusura della pagina/sessione
const setupSyncOnSessionEnd = () => {
    // Sync quando l'utente chiude la pagina o naviga via
    window.addEventListener('beforeunload', () => {
        // Usa sendBeacon per invio affidabile anche durante chiusura
        const learningData = collectAILearningData();
        if (learningData && (learningData.user?.userName || learningData.user?.userEmail)) {
            const blob = new Blob([JSON.stringify(learningData)], { type: 'application/json' });
            navigator.sendBeacon(`${API_BASE_URL}${AI_SYNC_CONFIG.endpoint}`, blob);
            console.log('[AI_SYNC] 📤 Sync inviata alla chiusura sessione');
        }
    });
    
    // Sync anche quando la pagina diventa nascosta (mobile, cambio tab)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            // Usa sendBeacon per affidabilità
            const learningData = collectAILearningData();
            if (learningData && shouldSyncNow() && (learningData.user?.userName || learningData.user?.userEmail)) {
                const blob = new Blob([JSON.stringify(learningData)], { type: 'application/json' });
                navigator.sendBeacon(`${API_BASE_URL}${AI_SYNC_CONFIG.endpoint}`, blob);
            }
        }
    });
    
    console.log('[AI_SYNC] 🔧 Listener sync sessione configurati');
};

// Scarica la Knowledge Base centralizzata dal server
const downloadCentralizedKnowledgeBase = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/v1/ai/knowledge`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        if (response.ok) {
            const kb = await response.json();
            if (kb && kb.solutions?.length > 0) {
                // Merge con KB locale
                const localKB = JSON.parse(localStorage.getItem('spark-knowledge-base-v1') || '{"solutions":[],"commonPatterns":[]}');
                
                // Aggiungi soluzioni dal server che non abbiamo localmente
                const existingPatterns = new Set(localKB.commonPatterns.map(p => p.problemSummary));
                kb.commonPatterns?.forEach(pattern => {
                    if (!existingPatterns.has(pattern.problemSummary)) {
                        localKB.commonPatterns.push(pattern);
                    }
                });
                
                // Limita a 200 pattern
                if (localKB.commonPatterns.length > 200) {
                    localKB.commonPatterns = localKB.commonPatterns.slice(-200);
                }
                
                localStorage.setItem('spark-knowledge-base-v1', JSON.stringify(localKB));
                console.log('[AI_SYNC] 📚 Knowledge Base scaricata dal server:', kb.commonPatterns?.length, 'pattern');
                return true;
            }
        }
        return false;
    } catch (e) {
        console.warn('[AI_SYNC] Impossibile scaricare KB centralizzata:', e);
        return false;
    }
};

// Inizializza il sistema di sync all'avvio
const initAISync = async () => {
    console.log('[AI_SYNC] 🚀 Inizializzazione sistema sync AI...');
    
    // Setup listener per sync alla chiusura
    setupSyncOnSessionEnd();
    
    // Scarica KB aggiornata dal server
    await downloadCentralizedKnowledgeBase();
    
    // Controlla se serve una sync periodica
    if (shouldSyncNow()) {
        // Ritarda la sync di qualche secondo per non bloccare il caricamento
        setTimeout(() => {
            syncAILearningToBackend();
        }, 5000);
    }
    
    console.log('[AI_SYNC] ✅ Sistema sync AI inizializzato');
};

// Esporta per uso esterno se necessario
window.SparkAISync = {
    sync: syncAILearningToBackend,
    collect: collectAILearningData,
    downloadKB: downloadCentralizedKnowledgeBase
};

// Helper per ottenere il JWT token
const getAuthToken = () => localStorage.getItem(JWT_TOKEN_KEY);

// Helper per salvare il JWT token
const saveAuthToken = (token) => {
    if (token) {
        localStorage.setItem(JWT_TOKEN_KEY, token);
    }
};

// Helper per rimuovere il JWT token (logout)
const clearAuthToken = () => localStorage.removeItem(JWT_TOKEN_KEY);

// Identificativo persistente del dispositivo/browser (per "ricordami 30 giorni")
const getSparkDeviceId = () => {
    let id = localStorage.getItem('spark-device-id');
    if (!id) {
        id = (window.crypto?.randomUUID?.() || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`);
        localStorage.setItem('spark-device-id', id);
    }
    return id;
};

// Gestione Spark (Admin): pulsanti nascosti / servizio oscurato
const SPARK_CONTROL_CACHE_KEY = 'spark-control-v1';
const OPS_CARDS = ['ops_riassegnazione', 'ops_nuova', 'ops_uscita'];
const SPARK_DEFAULT_HIDDEN = ['cambio_pc', ...OPS_CARDS];
const sparkHiddenRaw = (state, key) => (state.sparkControl && Array.isArray(state.sparkControl.hidden)) ? state.sparkControl.hidden.includes(key) : SPARK_DEFAULT_HIDDEN.includes(key);
const sparkHidden = (state, key) => sparkHiddenRaw(state, key) || (key === 'cambio_pc' && OPS_CARDS.every(k => sparkHiddenRaw(state, k)));

// ============================================================================
// 🔄 CONTINUITÀ CHAT TRA DISPOSITIVI (PC <-> telefono)
// La conversazione "segue" l'utente: salvata sul server legata all'email Jira.
// ============================================================================
const CHAT_SYNC_UPDATED_AT_KEY = 'spark-chat-sync-updatedat-v1';

// Rimuove i campi pesanti (immagini/allegati) per mantenere il payload leggero.
const stripMessagesForSync = (messages) => {
    if (!Array.isArray(messages)) return [];
    return messages.slice(-200).map((m) => {
        const { image, imageData, attachment, previewUrl, inlineData, audio, ...rest } = m || {};
        return rest;
    });
};

const syncChatToServer = async ({ email, userName, userCompany, messages, updatedAt }) => {
    if (!email) return null;
    try {
        const res = await fetch(`${API_BASE_URL}/api/v1/chat/sync`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: email.toLowerCase().trim(),
                user_name: userName || '',
                user_company: userCompany || '',
                messages: stripMessagesForSync(messages),
                updated_at: updatedAt,
                device_id: getSparkDeviceId(),
            }),
        });
        if (!res.ok) return null;
        return await res.json();
    } catch (e) {
        console.warn('[chat-sync] salvataggio fallito:', e);
        return null;
    }
};

const fetchChatFromServer = async (email) => {
    if (!email) return null;
    try {
        const res = await fetch(`${API_BASE_URL}/api/v1/chat/sync?email=${encodeURIComponent(email.toLowerCase().trim())}`);
        if (!res.ok) return null;
        return await res.json();
    } catch (e) {
        console.warn('[chat-sync] recupero fallito:', e);
        return null;
    }
};


// Forza subito un controllo dei ticket su Jira (usato dal pulsante "Aggiorna")
const triggerTicketSync = (e) => {
    try { window.dispatchEvent(new CustomEvent('spark:sync-tickets')); } catch (_) {}
    const icon = e?.currentTarget?.querySelector('svg');
    if (icon) { icon.classList.add('animate-spin'); setTimeout(() => icon.classList.remove('animate-spin'), 1200); }
};

// Helper per creare headers con autenticazione
const getAuthHeaders = () => {
    const token = getAuthToken();
    const headers = { 'Content-Type': 'application/json' };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

// Imposta titolo pagina
document.title = "Spark - 86BIT IT Service Desk";

// Avatar image embedded as base64 (128x128 JPEG, optimized) - works everywhere
const SPARK_AVATAR_BASE64 = 'data:image/jpeg;base64,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';

// 86BIT Logo SVG - WHITE version (for dark backgrounds)
const LOGO_86BIT_BASE64 = 'data:image/svg+xml;base64,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';

// Imposta favicon (dopo le costanti)
if (!document.querySelector("link[rel='icon']")) {
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/jpeg';
    favicon.href = SPARK_AVATAR_BASE64;
    document.head.appendChild(favicon);
}

// 86BIT Logo SVG - BLACK version (original from 86bit.it)
const LOGO_86BIT_DARK_BASE64 = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4gPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMaXZlbGxvXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMzEyIDE2MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzEyIDE2MDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPiA8c3R5bGUgdHlwZT0idGV4dC9jc3MiPiAuc3Qwe2ZpbGw6IzM0MzQzNDt9IDwvc3R5bGU+IDxnPiA8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjM5LjgsMTQ4LjFINzIuMlYxMS45aDE2Ny42VjE0OC4xeiBNNzcuNiwxNDIuN2gxNTYuOFYxNy4zSDc3LjZWMTQyLjd6Ij48L3BhdGg+IDwvZz4gPGc+IDxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik05OCwxMTkuM0w5OCwxMTkuM2MzLDAuNyw2LjMsMS4yLDkuOSwxLjdjMy43LDAuNCw3LjUsMC42LDExLjYsMC42czgtMC4yLDExLjYtMC42YzMuNy0wLjQsNy0xLDkuOS0xLjd2LTcuNyBjLTMtMC43LTYuMy0xLjItOS45LTEuN2MtMy43LTAuNC03LjYtMC42LTExLjYtMC42cy03LjksMC4yLTExLjYsMC42cy03LDEtOS45LDEuN0M5OCwxMTEuNiw5OCwxMTkuMyw5OCwxMTkuM3ogTTk4LDEwMy4zIEw5OCwxMDMuM2M2LjQtMS40LDEzLjYtMi4xLDIxLjUtMi4xYzIuNCwwLDQuNywwLjEsNi45LDAuMmMyLjIsMC4yLDQuNCwwLjMsNi41LDAuNnYtOC44Yy00LjEtMC42LTguNi0wLjktMTMuNS0wLjkgYy00LDAtNy45LDAuMi0xMS42LDAuNnMtNywxLTkuOSwxLjd2OC43TDk4LDEwMy4zTDk4LDEwMy4zeiBNMTE5LjUsMTI5LjdjLTUuMSwwLTkuOS0wLjQtMTQuNC0wLjljLTQuNS0wLjYtOC42LTEuNC0xMi4yLTIuNSBsLTIuOS0wLjh2LTM3bDIuOS0wLjljMy42LTEuMSw3LjctMS45LDEyLjItMi41czkuMy0wLjksMTQuNC0wLjljMi40LDAsNC43LDAuMSw2LjksMC4yczQuNCwwLjMsNi41LDAuNmMyLjgsMC4zLDUuNSwwLjgsOC4xLDEuMyB2MTdjMC45LDAuMiwxLjgsMC40LDIuNiwwLjZjMC45LDAuMiwxLjcsMC40LDIuNiwwLjdsMi45LDAuOXYyMGwtMi45LDAuOGMtMy42LDEuMS03LjcsMi0xMi4yLDIuNiBDMTI5LjUsMTI5LjQsMTI0LjcsMTI5LjcsMTE5LjUsMTI5Ljd6Ij48L3BhdGg+IDwvZz4gPGc+IDxyZWN0IHg9IjE1Ni41IiB5PSI4OC41IiBjbGFzcz0ic3QwIiB3aWR0aD0iOC4xIiBoZWlnaHQ9IjQxLjIiPjwvcmVjdD4gPC9nPiA8Zz4gPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4MS4yLDkzLjRjLTMuNCwwLjUtNi41LDEuMi05LjIsMlY4N2MzLjQtMC44LDcuMi0xLjUsMTEuMy0yczguNS0wLjcsMTMuMS0wLjdzOSwwLjIsMTMuMSwwLjcgczcuOSwxLjIsMTEuMywydjguNGMtMi43LTAuOC01LjctMS41LTkuMi0yYy0zLjQtMC41LTcuMi0wLjktMTEuMi0xdjM3LjNoLTguMVY5Mi40QzE4OC40LDkyLjUsMTg0LjcsOTIuOSwxODEuMiw5My40Ij48L3BhdGg+IDwvZz4gPGc+IDxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNDYuMyw1Ny42TDE0Ni4zLDU3LjZIOTkuN3YxMC4xYzMuMiwwLjcsNi44LDEuNCwxMC43LDEuOGM0LDAuNSw4LjEsMC43LDEyLjYsMC43YzQuNCwwLDguNi0wLjIsMTIuNi0wLjcgYzMuOS0wLjQsNy41LTEuMSwxMC43LTEuOEwxNDYuMyw1Ny42TDE0Ni4zLDU3LjZ6IE0xNDYuMyw0MC45TDE0Ni4zLDQwLjljLTMuMi0wLjgtNi44LTEuNC0xMC43LTEuOWMtNC0wLjUtOC4xLTAuNy0xMi42LTAuNyBjLTQuNCwwLjEtOC42LDAuMy0xMi42LDAuN2MtMy45LDAuNC03LjUsMS0xMC43LDEuOHY3LjloNDYuNkwxNDYuMyw0MC45TDE0Ni4zLDQwLjl6IE0xMjMsMjkuNmM1LjYsMCwxMC44LDAuMywxNS43LDEgYzQuOSwwLjYsOS4zLDEuNSwxMy4zLDIuN2wzLjEsMXY0MC4xbC0zLjEsMWMtMy45LDEuMi04LjQsMi4xLTEzLjMsMi43Yy00LjksMC42LTEwLjEsMS0xNS43LDFjLTUuNiwwLTEwLjgtMC4zLTE1LjctMSBjLTQuOS0wLjYtOS4zLTEuNi0xMy4zLTIuN2wtMy4xLTFWMzQuM2wzLjEtMWMzLjktMS4yLDguNC0yLjEsMTMuMy0yLjdDMTEyLjMsMjkuOSwxMTcuNSwyOS42LDEyMywyOS42eiI+PC9wYXRoPiA8L2c+IDxnPiA8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjE1LjUsNjAuMUwyMTUuNSw2MC4xYy0zLjItMC43LTYuOC0xLjMtMTAuOC0xLjhjLTQtMC40LTguMi0wLjctMTIuNi0wLjdoLTIwLjJ2MTAuOGMyLjksMC42LDYuMSwxLDkuNSwxLjMgczcsMC40LDEwLjYsMC40YzQuNCwwLDguNi0wLjIsMTIuNi0wLjdzNy42LTEuMSwxMC44LTEuOEwyMTUuNSw2MC4xTDIxNS41LDYwLjF6IE0xNjMuMiw3NS4zVjM1LjVsMy4xLTFjMy45LTEuMiw4LjQtMi4xLDEzLjMtMi43IGM0LjktMC42LDEwLjEtMSwxNS43LTFjNSwwLDkuNywwLjMsMTQuMSwwLjhjNC41LDAuNSw4LjYsMS4zLDEyLjMsMi4ydjljLTMuNC0xLTcuMy0xLjgtMTEuOS0yLjRjLTQuNS0wLjYtOS40LTAuOS0xNC42LTAuOSBjLTQuNCwwLTguNiwwLjItMTIuNiwwLjdzLTcuNiwxLjEtMTAuOCwxLjh2Ni43SDE5MmMyLjIsMCw0LjUsMC4xLDYuOSwwLjJjMi40LDAuMSw0LjgsMC4zLDcuMywwLjZzNC45LDAuNiw3LjMsMS4xIGMyLjQsMC41LDQuOCwxLDcsMS43YzEuMywwLjQsMi41LDAuOCwzLjYsMS4ydjIwLjdsLTMuMSwxYy00LDEuMi04LjQsMi4xLTEzLjMsMi43Yy00LjksMC42LTEwLjEsMS0xNS43LDFjLTUuNiwwLTEwLjgtMC4zLTE1LjctMSBDMTcxLjUsNzcuNCwxNjcuMSw3Ni41LDE2My4yLDc1LjN6Ij48L3BhdGg+IDwvZz4gPC9zdmc+IA==';

// Legacy URL for backward compatibility (not used - using Base64 instead)
const LOGO_86BIT_URL = LOGO_86BIT_BASE64;

// SparkAvatar Component - Uses Base64 embedded image (CSP compliant)
const SparkAvatar = ({ className = "", size = "md", animate = false }) => {
    const sizeClasses = {
        sm: "h-12 w-12",
        md: "h-20 w-20 sm:h-24 sm:w-24",
        lg: "h-24 w-24 sm:h-28 sm:w-28",
        xl: "h-28 w-28 sm:h-32 sm:w-32"
    };
    
    return (
        <img 
            src={SPARK_AVATAR_BASE64}
            alt="Spark"
            className={`${sizeClasses[size] || sizeClasses.md} rounded-full shadow-xl border-2 border-white/30 object-cover ${animate ? 'animate-pulse' : ''} ${className}`}
        />
    );
};

// Legacy constants for backward compatibility
const SPARK_AVATAR_LOCAL = SPARK_AVATAR_BASE64;
const SPARK_AVATAR_PRIMARY = SPARK_AVATAR_BASE64;
const SPARK_AVATAR_FALLBACK = SPARK_AVATAR_BASE64;

// ============================================================================
// FIREBASE CONFIGURATION - 86BIT SPARK
// ============================================================================
const firebaseConfig = {
    apiKey: "AIzaSyBqd6uKRKrPQc3nJ9Q2qydOClNuuAZ_T5E",
    authDomain: "spark-c101e.firebaseapp.com",
    projectId: "spark-c101e",
    storageBucket: "spark-c101e.firebasestorage.app",
    messagingSenderId: "876499504782",
    appId: "1:876499504782:web:32646aa6c3cccc8b1683df",
    measurementId: "G-5R2YP2Q6NR"
};

// VAPID Key per le notifiche push
const VAPID_KEY = "BMB-lU89S2FDDXw8mJKVJ0ATiaQ27pfI-Qq9ivnnbt7Dj-PaD0Z7kx9wp5iFNjXR_otyTr1LWD5z2AMptUlIwAA";

// ============================================================================
// LISTE NOMI ITALIANI PER RICONOSCIMENTO GENERE
// ============================================================================
const NOMI_FEMMINILI = new Set([
    'adele', 'agata', 'alessandra', 'alessia', 'alice', 'amalia', 'amanda', 'ambra', 'anita', 'anna',
    'annalisa', 'angelica', 'antonella', 'arianna', 'asia', 'aurora', 'azzurra', 'barbara', 'beatrice', 'benedetta',
    'bianca', 'camilla', 'carla', 'carlotta', 'carmen', 'caterina', 'cecilia', 'celeste', 'chiara', 'clara',
    'claudia', 'clelia', 'costanza', 'cristina', 'daniela', 'daria', 'debora', 'diana', 'diletta', 'elena',
    'eleonora', 'elisa', 'elisabetta', 'elvira', 'emma', 'erica', 'ester', 'eva', 'federica', 'flavia',
    'francesca', 'gabriella', 'gaia', 'giada', 'ginevra', 'gioia', 'giorgia', 'giovanna', 'giulia', 'greta',
    'ilaria', 'irene', 'isabella', 'lara', 'laura', 'lavinia', 'letizia', 'lidia', 'linda', 'lisa',
    'livia', 'lucia', 'lucrezia', 'ludovica', 'maddalena', 'margherita', 'maria', 'marina', 'marta', 'martina',
    'matilde', 'melissa', 'mia', 'michela', 'miriam', 'monica', 'nadia', 'nicole', 'nina', 'noemi',
    'olimpia', 'paola', 'rachele', 'rebecca', 'roberta', 'rosa', 'rossella', 'sabrina', 'sara', 'serena',
    'silvia', 'simona', 'sofia', 'sonia', 'stefania', 'stella', 'susanna', 'sveva', 'teresa', 'valentina',
    'valeria', 'vanessa', 'veronica', 'viola', 'virginia', 'vittoria', 'viviana', 'zoe'
]);

const NOMI_MASCHILI = new Set([
    'achille', 'adriano', 'alberto', 'aldo', 'alessandro', 'alessio', 'alfonso', 'alfredo', 'andrea', 'angelo',
    'antonio', 'arturo', 'augusto', 'biagio', 'bruno', 'carlo', 'carmelo', 'cesare', 'christian', 'ciro',
    'claudio', 'corrado', 'cosimo', 'cristiano', 'damiano', 'daniele', 'dario', 'davide', 'diego', 'domenico',
    'edoardo', 'elia', 'elio', 'emanuele', 'emiliano', 'enea', 'enrico', 'enzo', 'ettore', 'eugenio',
    'fabio', 'fabrizio', 'fausto', 'federico', 'filippo', 'flavio', 'francesco', 'gabriele', 'gaetano', 'giacomo',
    'gianluca', 'gioele', 'giorgio', 'giovanni', 'giulio', 'giuseppe', 'guido', 'iacopo', 'jacopo', 'ivan',
    'lapo', 'leonardo', 'leone', 'lorenzo', 'luca', 'luciano', 'luigi', 'manuel', 'marcello', 'marco',
    'mario', 'martino', 'massimo', 'matteo', 'mattia', 'maurizio', 'mauro', 'michele', 'mirko', 'nicola',
    'niccolò', 'noah', 'paolo', 'pasquale', 'pietro', 'raffaele', 'riccardo', 'roberto', 'rocco', 'rosario',
    'salvatore', 'samuele', 'saverio', 'sebastiano', 'sergio', 'simone', 'stefano', 'tommaso', 'valerio', 'vincenzo', 'vittorio'
]);

// Funzione per determinare il genere dal nome
const getGenderFromName = (fullName) => {
    if (!fullName) return 'unknown';
    
    // Estrai il primo nome (prima del punto, spazio o underscore)
    const firstName = fullName.toLowerCase()
        .split(/[.\s_-]/)[0]
        .trim();
    
    if (NOMI_FEMMINILI.has(firstName)) return 'female';
    if (NOMI_MASCHILI.has(firstName)) return 'male';
    
    // Euristica: nomi che finiscono in 'a' spesso femminili (tranne eccezioni già in lista)
    if (firstName.endsWith('a') && !['luca', 'andrea', 'mattia', 'elia', 'enea', 'nicola', 'noah', 'battista', 'niccaela'].includes(firstName)) {
        return 'female';
    }
    
    // Euristica: nomi che finiscono in 'o' sono tipicamente maschili in italiano
    // (es. Silvano, Ottaviano, Fiorenzo...) - poche eccezioni femminili
    if (firstName.endsWith('o')) {
        return 'male';
    }
    
    return 'unknown';
};

// Funzione per ottenere saluto personalizzato per genere
const getGenderedGreeting = (fullName, type = 'welcome') => {
    const gender = getGenderFromName(fullName);
    const firstName = fullName?.split(/[.\s_-]/)[0] || 'Utente';
    const capitalizedName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    
    const greetings = {
        welcome: {
            female: `Benvenuta, ${capitalizedName}!`,
            male: `Benvenuto, ${capitalizedName}!`,
            unknown: `Benvenuto/a, ${capitalizedName}!`
        },
        welcomeFirst: {
            female: `Ciao ${capitalizedName}! Benvenuta in Spark 🚀`,
            male: `Ciao ${capitalizedName}! Benvenuto in Spark 🚀`,
            unknown: `Ciao ${capitalizedName}! Benvenuto/a in Spark 🚀`
        },
        welcomeBack: {
            female: `Bentornata, ${capitalizedName}!`,
            male: `Bentornato, ${capitalizedName}!`,
            unknown: `Bentornato/a, ${capitalizedName}!`
        },
        greeting: {
            female: `Ciao ${capitalizedName}!`,
            male: `Ciao ${capitalizedName}!`,
            unknown: `Ciao ${capitalizedName}!`
        },
        askCompany: {
            female: `Per iniziare, potresti dirmi il nome della tua azienda?`,
            male: `Per iniziare, potresti dirmi il nome della tua azienda?`,
            unknown: `Per iniziare, potresti dirmi il nome della tua azienda?`
        },
        perfect: {
            female: `Perfetto, ${capitalizedName}!`,
            male: `Perfetto, ${capitalizedName}!`,
            unknown: `Perfetto, ${capitalizedName}!`
        }
    };
    
    return greetings[type]?.[gender] || greetings[type]?.unknown || `Ciao ${capitalizedName}!`;
};

// ============================================================================
// DAILY TRAINING TIPS - Contenuti formativi statici
// ============================================================================
const DAILY_TRAINING_TIPS = {
    general_tips: [
        { title: "🖥️ L'Esperienza di Nonno Sandro", tip: "Per selezionare tutto il testo in un documento, premi **CTRL + A**. Funziona ovunque: Word, email, browser!", example: "Utile per copiare rapidamente tutto il contenuto di una pagina." },
        { title: "🖥️ Scorciatoia Magica", tip: "**Windows + D** minimizza tutte le finestre e mostra il desktop. Premiamolo di nuovo per ripristinarle!", example: "Perfetto quando il capo passa e stai guardando video di gattini." },
        { title: "🖥️ Trova Tutto", tip: "Perso un file? Premi **Windows + S** e scrivi il nome. Windows lo troverà per te!", example: "Cerca anche dentro i documenti, non solo nel nome file." },
        { title: "🖥️ Screenshot Facile", tip: "**Windows + Shift + S** cattura una porzione di schermo e la copia negli appunti!", example: "Poi puoi incollarla direttamente in una email o chat con CTRL+V." },
        { title: "🖥️ Torna Indietro", tip: "Hai sbagliato qualcosa? **CTRL + Z** annulla l'ultima azione. **CTRL + Y** la ripristina!", example: "Funziona in quasi tutti i programmi: Word, Excel, browser..." },
        { title: "🖥️ Tab del Browser", tip: "Chiuso un tab per sbaglio? **CTRL + Shift + T** lo riapre magicamente!", example: "Funziona anche più volte per riaprire più tab chiusi." },
        { title: "🖥️ Blocca il PC", tip: "Ti allontani? Premi **Windows + L** per bloccare il PC istantaneamente!", example: "Nessuno potrà accedere senza la tua password." },
        { title: "🖥️ Gestione Finestre", tip: "**Windows + Freccia** sposta e ridimensiona le finestre. Prova con freccia sinistra o destra!", example: "Perfetto per lavorare con due programmi affiancati." },
        { title: "🖥️ Task Manager Rapido", tip: "PC bloccato? **CTRL + Shift + ESC** apre direttamente il Task Manager!", example: "Da lì puoi terminare i programmi che non rispondono." },
        { title: "🖥️ Zoom Universale", tip: "**CTRL + rotella mouse** fa zoom in/out ovunque: browser, PDF, Word...", example: "CTRL + 0 riporta allo zoom predefinito." }
    ],
    security_rules: [
        { title: "🔐 Regola d'Oro #1", tip: "**MAI** condividere la tua password, nemmeno con colleghi o IT. Noi non te la chiederemo mai!", example: "Se qualcuno la chiede, segnalalo immediatamente." },
        { title: "🔐 Regola d'Oro #2", tip: "Prima di cliccare un link in una email, **passa il mouse sopra** per vedere dove porta davvero.", example: "Se l'URL sembra strano (es: g00gle.com invece di google.com), non cliccare!" },
        { title: "🔐 Regola d'Oro #3", tip: "**Non installare** software senza approvazione IT. Anche programmi 'innocui' possono contenere malware.", example: "Hai bisogno di un programma? Apri un ticket!" },
        { title: "🔐 Regola d'Oro #4", tip: "**Blocca sempre** il PC quando ti allontani (Windows + L). Anche per 30 secondi!", example: "Un accesso non autorizzato può compromettere dati aziendali." },
        { title: "🔐 Regola d'Oro #5", tip: "Gli **allegati** sono il veicolo preferito dei virus. Attenzione a .exe, .zip, .docm!", example: "Se non aspettavi quel file, verifica prima con il mittente." }
    ],
    password_management: [
        { title: "🔑 Password Forte", tip: "Una password sicura ha: **12+ caratteri**, maiuscole, minuscole, numeri e simboli.", example: "Usa una frase: 'IlMioCane@Mangia3Biscotti!' è perfetta!" },
        { title: "🔑 Mai Riciclare", tip: "**MAI** usare la stessa password per account diversi. Se ne bucano uno, li bucano tutti!", example: "Usa un password manager per gestirle tutte." },
        { title: "🔑 Cambio Periodico", tip: "Cambia le password critiche ogni **90 giorni**. Quelle meno importanti ogni 6 mesi.", example: "Imposta un promemoria nel calendario!" },
        { title: "🔑 Autenticazione 2FA", tip: "Attiva sempre la **verifica in due passaggi** dove possibile. È il secondo lucchetto!", example: "Anche se rubano la password, senza il codice non entrano." },
        { title: "🔑 Non Annotare", tip: "**MAI** scrivere password su post-it o file di testo non protetti!", example: "Usa Spark > Centro Sicurezza > Genera Password per crearne di sicure!" }
    ],
    phishing_awareness: [
        { title: "🎣 Segnali d'Allarme", tip: "Le email di phishing hanno spesso: urgenza ('SUBITO!'), errori grammaticali, mittenti sospetti.", example: "La tua banca non ti scrive mai 'Caro Clienti'!" },
        { title: "🎣 Verifica il Mittente", tip: "L'indirizzo email **deve** corrispondere al dominio ufficiale. mario@banca-sicura.com NON è la tua banca!", example: "Il dominio reale è dopo la @ e prima del /" },
        { title: "🎣 Link Mascherati", tip: "Un link può mostrare 'www.banca.it' ma portare altrove. **Passa il mouse sopra** prima di cliccare!", example: "Nel dubbio, vai direttamente al sito digitando l'indirizzo." },
        { title: "🎣 Allegati Pericolosi", tip: "Non aprire MAI allegati inaspettati, soprattutto **.exe, .zip, .docm, .xlsm**!", example: "Se il collega ti manda un file strano, chiamalo per confermare." },
        { title: "🎣 Richieste di Dati", tip: "Nessuna azienda seria chiede password, PIN o dati bancari via email!", example: "Se hai dubbi, chiama il numero ufficiale (non quello nell'email)." }
    ]
};

// Quiz Phishing - Simulazioni statiche
const PHISHING_SIMULATIONS = [
    {
        id: 1,
        image: "https://customer-assets.emergentagent.com/job_helpdesk-ai-21/artifacts/phishing_example_1.png",
        question: "Questa email è legittima o è phishing?",
        isPhishing: true,
        explanation: "🚨 **PHISHING!** Ecco i segnali:\n\n• Indirizzo mittente sospetto (support@bancaitalia-secure.net invece di @bancaditalia.it)\n• Urgenza eccessiva ('Il tuo conto sarà BLOCCATO')\n• Link che porta a un dominio diverso\n• Errori grammaticali ('Gentile Clienti')"
    },
    {
        id: 2,
        image: "https://customer-assets.emergentagent.com/job_helpdesk-ai-21/artifacts/phishing_example_2.png",
        question: "Riconosci i segnali di questa email truffa?",
        isPhishing: true,
        explanation: "🚨 **PHISHING!** Segnali evidenti:\n\n• Richiesta di 'verificare' credenziali\n• Senso di urgenza ('entro 24 ore')\n• Il logo sembra ufficiale ma il dominio è falso\n• Chiede di cliccare su un link invece di andare sul sito ufficiale"
    }
];

// Funzione per ottenere il tip del giorno basato sul giorno dell'anno
const getDailyTip = (category) => {
    const tips = DAILY_TRAINING_TIPS[category];
    if (!tips || tips.length === 0) return null;
    
    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 0);
    const diff = today - startOfYear;
    const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
    
    const tipIndex = dayOfYear % tips.length;
    return tips[tipIndex];
};

// ============================================================================
// NOTIFICATION SERVICE - Compatibile con backend 86BIT
// ============================================================================
const NotificationService = {
    isSupported: () => {
        return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
    },

    getPermissionStatus: () => {
        if (!NotificationService.isSupported()) return 'unsupported';
        return Notification.permission;
    },

    requestPermission: async () => {
        if (!NotificationService.isSupported()) {
            return { success: false, error: 'Notifiche non supportate' };
        }
        try {
            const permission = await Notification.requestPermission();
            return { success: permission === 'granted', permission };
        } catch (error) {
            return { success: false, error: error.message };
        }
    },

    subscribeToBackend: async (token, userName) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/notification/subscribe`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, userName })
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return { success: true };
        } catch (error) {
            console.error('Errore sottoscrizione:', error);
            return { success: false, error: error.message };
        }
    },

    subscribe: async (userName) => {
        // Questo metodo viene ora gestito nel ChatProvider con Firebase diretto
        return { success: false, error: 'Use subscribeToFcm in ChatProvider' };
    },

    setupForegroundListener: (callback) => {
        // Questo viene gestito nel ChatProvider con onMessage di Firebase
        console.log('Foreground listener setup - managed by ChatProvider');
    },

    showLocalNotification: (title, body, options = {}) => {
        if (Notification.permission !== 'granted') return;
        
        const notification = new Notification(title, {
            body,
            icon: options.icon || SPARK_AVATAR_BASE64,
            tag: options.tag || 'spark-local',
            ...options
        });

        notification.onclick = () => {
            window.focus();
            notification.close();
            if (options.onClick) options.onClick();
        };

        return notification;
    }
};

// Helper per notifiche
const showNotification = (title, options) => {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'granted') {
        navigator.serviceWorker.getRegistration().then(reg => {
            if (reg) reg.showNotification(title, options);
        });
    }
};

// ============================================================================
// API SERVICE - INTEGRATO CON BACKEND 86BIT
// ============================================================================
const initializeMockData = () => {
    console.log('[START] Spark API initialized - Backend:', API_BASE_URL);
};

// Mock AI responses per categoria (chat rimane mock)
const MOCK_AI_RESPONSES = {
    stampante: [
        "**🖨️ PROBLEMA STAMPANTE**\n\n━━━━━━━━━━━━━━━━━━━━\n\nCapisco, la stampante fa le bizze! Noi tecnici lo vediamo spesso, tranquillo.\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Guardiamo se è accesa** - Vedi una lucina verde sulla stampante? Se è spenta o arancione, proviamo a spegnerla e riaccenderla\n\n2️⃣ **Controlliamo i fili** - Dietro al computer c'è un cavo che va alla stampante. Verifica che sia inserito bene fino in fondo\n\n3️⃣ **Facciamola riposare** - Spegnila, conta fino a 30, poi riaccendila\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Se lampeggia arancione, spesso vuol dire che manca carta o il toner è finito!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    password: [
        "**🔐 PROBLEMA PASSWORD**\n\n━━━━━━━━━━━━━━━━━━━━\n\nNessun problema! Le password a volte fanno i capricci, ma ci pensiamo noi.\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Password dimenticata?** - Nella schermata di accesso, cerca la scritta 'Password dimenticata' e cliccaci sopra\n\n2️⃣ **Vuoi cambiarla?** - Premi insieme CTRL + ALT + CANC sulla tastiera, poi scegli 'Cambia password'\n\n3️⃣ **Serve una nuova?** - Clicca sullo Scudo Giallo 🛡️ qui sopra: c'è uno strumento che te ne crea una super sicura!\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Una buona password è come una ricetta segreta: mescola maiuscole, minuscole, numeri e simboli!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    rete: [
        "**🌐 PROBLEMA CONNESSIONE**\n\n━━━━━━━━━━━━━━━━━━━━\n\nInternet che non va è proprio fastidioso! Vediamo di sistemare insieme.\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Guardiamo le tacchette** - Vicino all'orologio in basso a destra, vedi le tacchette come sul cellulare? Se c'è una X rossa, la connessione è interrotta\n\n2️⃣ **Riavviamo la scatoletta** - Quella con le lucine che lampeggia (il router): spegnila, conta fino a 30, riaccendila\n\n3️⃣ **Aspettiamo un attimo** - Ci vogliono circa 2 minuti perché si ricolleghi tutto\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Se usi il Wi-Fi, prova ad avvicinarti alla scatoletta con le lucine. Funziona meglio!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    email: [
        "**📧 PROBLEMA EMAIL**\n\n━━━━━━━━━━━━━━━━━━━━\n\nProblemi con la posta? Ne stavo giusto parlando con i colleghi, capita più spesso di quanto pensi!\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Outlook non si apre?** - Chiudilo completamente (anche dalla barra in basso) e riaprilo\n\n2️⃣ **Email sparite?** - Controlla la cartella 'Posta indesiderata' - a volte finiscono lì per sbaglio!\n\n3️⃣ **Non riesci ad accedere?** - Prova ad andare su outlook.com dal browser e accedi da lì\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Se cerchi una mail importante, usa la lente di ingrandimento in alto e scrivi il nome di chi te l'ha mandata!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    lento: [
        "**🐌 PC LENTO**\n\n━━━━━━━━━━━━━━━━━━━━\n\nIl computer che va piano è proprio snervante! Ma niente paura, ho qualche trucchetto.\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Facciamo riposare il PC** - Clicca sulla bandierina in basso, poi sul cerchietto con la stanghetta, e scegli 'Riavvia il sistema'\n\n2️⃣ **Chiudiamo i programmi aperti** - In basso nella barra, clicca col tasto destro sui programmi che non usi e chiudili\n\n3️⃣ **Controlliamo lo spazio** - Il disco del computer è come un armadio: se è troppo pieno, tutto rallenta!\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Premi insieme CTRL + SHIFT + ESC per vedere cosa sta 'mangiando' la potenza del computer!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    office: [
        "**📄 PROBLEMA CON WORD/OFFICE**\n\n━━━━━━━━━━━━━━━━━━━━\n\nWord che non si apre è un problema che vedo spesso! Niente paura, proviamo a sistemare.\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Chiudi tutto e riprova** - Se Word sembra bloccato, premi insieme CTRL + ALT + CANC, scegli 'Gestione Attività' e chiudi Word da lì\n\n2️⃣ **Avvia in modalità sicura** - Tieni premuto il tasto CTRL mentre clicchi sull'icona di Word. Ti chiederà se vuoi avviarlo in modalità provvisoria: di' Sì!\n\n3️⃣ **Ripara Office** - Cerca 'Pannello di controllo' nella barra di ricerca, poi 'Programmi', trova Microsoft Office e clicca 'Ripara'\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Se hai un file importante aperto, Word spesso lo salva automaticamente! Cerca nella cartella 'Documenti' o prova File > Apri > Recupera documenti non salvati\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    audioVideo: [
        "**🎥 PROBLEMA WEBCAM/AUDIO**\n\n━━━━━━━━━━━━━━━━━━━━\n\nWebcam o microfono che non funzionano? Capita spesso, soprattutto con le videochiamate!\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Controlla il blocco fisico** - Molti notebook hanno una levetta che copre la webcam o un tasto (spesso F4 o F8) con l'icona della telecamera barrata. Guardalo!\n\n2️⃣ **Verifica le impostazioni** - Clicca sulla bandierina Start, poi sull'ingranaggio (Impostazioni), cerca 'Privacy' e poi 'Fotocamera' o 'Microfono'. Deve essere su 'Attivo'!\n\n3️⃣ **Prova a riavviare** - A volte basta spegnere e riaccendere il PC per far funzionare di nuovo webcam e microfono\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Se usi Teams o Zoom, controlla anche le impostazioni DENTRO il programma: c'è un menu 'Dispositivi' dove puoi scegliere webcam e microfono!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    monitor: [
        "**🖥️ PROBLEMA MONITOR/SCHERMO**\n\n━━━━━━━━━━━━━━━━━━━━\n\nProblemi con lo schermo? Vediamo di capire cosa succede!\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Cosa fare:**\n\n1️⃣ **Controlla i cavi** - Dietro al monitor ci sono uno o più cavi. Verifica che siano tutti ben inseriti, sia nel monitor che nel computer\n\n2️⃣ **Prova il tasto Windows + P** - Premi insieme questi due tasti: appare un menu per scegliere come usare lo schermo. Prova 'Solo schermo PC' o 'Duplica'\n\n3️⃣ **Schermo nero?** - Se non vedi proprio niente, prova a premere un tasto qualsiasi o muovere il mouse. Il PC potrebbe essere in standby!\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Se usi una docking station (quella scatoletta dove attacchi il portatile), prova a scollegarla e ricollegarla. Spesso risolve!\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Non funziona?** Clicca su 🎫 e apriamo un ticket insieme!"
    ],
    default: [
        "**🎯 CIAO, SONO SPARK!**\n\n━━━━━━━━━━━━━━━━━━━━\n\nSono il tuo collega IT di 86BIT! Raccontami cosa sta succedendo e vediamo di risolvere insieme.\n\n━━━━━━━━━━━━━━━━━━━━\n\n**📋 Dimmi un po':**\n\n1️⃣ **Cosa non funziona?** - Stampante, internet, email, PC lento, Word...\n\n2️⃣ **Da quando succede?** - È appena iniziato o va avanti da un po'?\n\n3️⃣ **Vedi messaggi strani?** - Se appare qualche errore, fammi una foto col cellulare e mandamela qui!\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 **Trucchetto:** Più dettagli mi dai, più velocemente risolviamo! Fai pure con calma, ti aspetto qui.\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Urgente?** Clicca su 🎫 e apriamo subito un ticket!"
    ]
};

const getMockResponse = (message) => {
    const msgLower = message.toLowerCase();
    
    // Word, Excel, PowerPoint, Office
    if (msgLower.match(/word|excel|powerpoint|office|documento|foglio|presentazione/)) {
        return MOCK_AI_RESPONSES.office[0];
    }
    // Stampante
    if (msgLower.match(/stampante|stampa|print|toner/)) {
        return MOCK_AI_RESPONSES.stampante[Math.floor(Math.random() * MOCK_AI_RESPONSES.stampante.length)];
    }
    // Password
    if (msgLower.match(/password|login|accesso|credenziali/)) {
        return MOCK_AI_RESPONSES.password[0];
    }
    // Rete
    if (msgLower.match(/rete|internet|wifi|connessione|network/)) {
        return MOCK_AI_RESPONSES.rete[0];
    }
    // Email
    if (msgLower.match(/email|posta|outlook|mail/)) {
        return MOCK_AI_RESPONSES.email[0];
    }
    // PC Lento
    if (msgLower.match(/lento|rallenta|blocca|freeze|slow/)) {
        return MOCK_AI_RESPONSES.lento[0];
    }
    // Webcam/Audio
    if (msgLower.match(/webcam|videocamera|telecamera|microfono|audio|cuffie|suono/)) {
        return MOCK_AI_RESPONSES.audioVideo[0];
    }
    // Monitor/Schermo
    if (msgLower.match(/monitor|schermo|display|risoluzione/)) {
        return MOCK_AI_RESPONSES.monitor[0];
    }
    // Default - ma più utile
    return MOCK_AI_RESPONSES.default[0];
};

// ============================================================================
// API - Mix di REALI (tuo backend) e MOCK (chat)
// ============================================================================
// ============================================================================
// API REALI - Integrazione con Backend 86BIT
// ============================================================================

// GEMINI CHAT - Chiamata reale, supporta sia streaming SSE che JSON normale
// ============================================================================
// AI MEMORY: Costruisce il contesto conversazionale per Gemini
// ============================================================================
const buildConversationHistory = (messages, maxMessages = 10) => {
    if (!messages || messages.length === 0) return [];
    
    // Prendi solo gli ultimi N messaggi rilevanti (user + ai, escludi system-prompt)
    const relevantMessages = messages
        .filter(m => m.sender && m.text && m.type !== 'system-prompt' && !m.isStreaming)
        .slice(-maxMessages);
    
    // Converti in formato Gemini
    return relevantMessages.map(msg => ({
        role: msg.sender === 'user' ? 'user' : 'model',
        parts: [{ text: msg.text }]
    }));
};

const streamGeminiChat = async function*(message, attachment, systemPrompt, userData = {}, conversationHistory = []) {
    console.log('📤 Chat API:', message, attachment ? 'with attachment' : 'no attachment');
    console.log('🔗 API_BASE_URL:', API_BASE_URL);
    console.log('🧠 Conversation history:', conversationHistory.length, 'messages');
    
    let apiSuccess = false;
    
    try {
        const userMessageParts = [{ text: message }];
        if (attachment && attachment.data) {
            userMessageParts.push({
                inlineData: {
                    mimeType: attachment.data.split(';')[0].split(':')[1],
                    data: attachment.data.split(',')[1]
                }
            });
        }
        
        // Costruisci il payload con memoria conversazionale
        const contents = [
            { role: "user", parts: [{ text: systemPrompt || getSystemPrompt(userData) }] },
            { role: "model", parts: [{ text: "Perfetto, sono pronto ad aiutarti." }] },
        ];
        
        // Aggiungi la cronologia conversazione (memoria)
        if (conversationHistory.length > 0) {
            contents.push(...conversationHistory);
        }
        
        // Aggiungi il messaggio corrente
        contents.push({ role: "user", parts: userMessageParts });
        
        // Passa il system prompt anche come system_instruction NATIVO (aderenza massima).
        // Manteniamo il prompt anche nei contents per compatibilità con backend che non
        // supportano systemInstruction (es. proxy Node di produzione).
        const payload = {
            contents,
            systemInstruction: (systemPrompt || getSystemPrompt(userData)),
            company: userData.userSiteName || userData.userCompany || userData.company || ''
        };

        const apiUrl = `${API_BASE_URL}/api/v1/gemini/stream`;
        console.log('🌐 Calling:', apiUrl);
        
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        console.log('📥 Response status:', response.status);
        console.log('📥 Content-Type:', response.headers.get('content-type'));
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        const contentType = response.headers.get('content-type') || '';
        
        // Se è JSON normale (non streaming), gestiscilo direttamente
        if (contentType.includes('application/json')) {
            console.log('📦 Risposta JSON normale (non streaming)');
            const json = await response.json();
            const text = json?.candidates?.[0]?.content?.parts?.[0]?.text || 
                         json?.text || 
                         json?.response ||
                         '';
            
            if (text) {
                console.log('✅ Testo ricevuto:', text.substring(0, 100) + '...');
                yield text;
                apiSuccess = true;
            } else {
                console.warn('⚠️ Nessun testo nella risposta JSON:', JSON.stringify(json).substring(0, 200));
                throw new Error('No text in JSON response');
            }
        } else {
            // Streaming SSE
            console.log('📦 Risposta streaming SSE');
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let accumulatedText = '';
            let buffer = '';
            let chunkCount = 0;

            while (true) {
                const { value, done } = await reader.read();
                if (done) {
                    console.log('📦 Stream completato, chunks ricevuti:', chunkCount);
                    break;
                }

                const chunk = decoder.decode(value, { stream: true });
                chunkCount++;
                console.log(`📦 Chunk #${chunkCount}:`, chunk.substring(0, 100));
                buffer += chunk;
                
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    const trimmedLine = line.trim();
                    if (!trimmedLine) continue;
                    
                    let data = trimmedLine;
                    while (data.startsWith('data:')) {
                        data = data.slice(5).trim();
                    }
                    
                    if (data === '[DONE]') {
                        console.log('✅ Stream [DONE] ricevuto');
                        return;
                    }
                    if (!data) continue;
                    
                    try {
                        const json = JSON.parse(data);
                        const newFullText = json?.candidates?.[0]?.content?.parts?.[0]?.text || 
                                            json?.text || '';
                        
                        if (newFullText) {
                            if (newFullText.length > accumulatedText.length && 
                                newFullText.startsWith(accumulatedText)) {
                                const newPart = newFullText.slice(accumulatedText.length);
                                if (newPart) {
                                    yield newPart;
                                    accumulatedText = newFullText;
                                    apiSuccess = true;
                                }
                            } else if (newFullText !== accumulatedText) {
                                yield newFullText;
                                accumulatedText += newFullText;
                                apiSuccess = true;
                            }
                        }
                    } catch (parseError) {
                        console.warn('⚠️ Parse error:', parseError.message, 'Data:', data.substring(0, 50));
                    }
                }
            }
            
            console.log('📊 Totale testo accumulato:', accumulatedText.length, 'caratteri');
        }
        
        if (!apiSuccess) {
            throw new Error('No content received from API');
        }
    } catch (error) {
        console.error('❌ API Gemini non disponibile:', error.message);
        console.error('❌ Stack:', error.stack);
        // Rilancia l'errore - nessun fallback mock
        throw error;
    }
};

// JIRA TICKET - Creazione reale
const createJiraTicket = async (summary, description, reporter, reporterEmail = '', extra = {}) => {
    try {
        // Nome cliente/azienda per il titolo "NOME CLIENTE | titolo"
        let clientName = '';
        try {
            const raw = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
            if (raw) {
                const d = JSON.parse(raw);
                clientName = d.userSiteName || d.userCompany || '';
            }
        } catch (e) {}
        const response = await fetch(`${API_BASE_URL}/api/v1/jira/ticket`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({
                summary, description, reporter, reporter_email: reporterEmail, client_name: clientName,
                reporter_phone: extra.phone || '',
                reporter_pc: extra.pc || '',
                reporter_connection: extra.connection || '',
                images: extra.images || []
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Errore sconosciuto' }));
            throw new Error(errorData.message || `HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Errore creazione ticket Jira:', error);
        throw error;
    }
};

// JIRA TICKET - Stato reale
const getJiraTicketStatus = async (ticketId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(ticketId)}`, {
            headers: getAuthHeaders()
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Ticket non trovato' }));
            throw new Error(errorData.message || `HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Errore recupero stato ticket ${ticketId}:`, error);
        throw error;
    }
};

// System Prompt per Gemini
// Verifica se siamo in orario d'ufficio (usa gli orari reali di 86BIT)
// ORARI PRESENZA FISICA TECNICI:
// Lun-Ven: 7:30 - 21:00 (continuato)
// Sabato: 8:00 - 12:30
// Fuori orario: ci pensa Spark!
const isOfficeHours = () => {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    const minute = now.getMinutes();
    const currentTime = hour + minute / 60;
    
    // Lun-Ven: 7:30 - 21:00 (continuato)
    if (day >= 1 && day <= 5 && currentTime >= 7.5 && currentTime < 21) return true;
    // Sabato: 8:00 - 12:30
    if (day === 6 && currentTime >= 8 && currentTime < 12.5) return true;
    
    return false;
};

// Formatta la risposta dell'AI per renderla professionale e leggibile
// STILE BAMBINO: Molto spazio, facile da leggere
const formatAIResponse = (text) => {
    if (!text) return text;
    
    // ============================================================
    // FORMATTATORE VISIVO PURO - NON MODIFICA MAI IL CONTENUTO
    // Aggiunge solo elementi di visualizzazione al testo di Gemini
    // ============================================================
    
    let result = text.trim();
    // Rimuovi tag interni [SENTIMENT:...] dal testo (memoria, TTS, export)
    result = result.replace(/\[SENTIMENT:[^\]]*\]/gi, '').trim();
    
    // Se il testo ha già separatori, è già formattato - ritorna così
    if (result.includes('━━━━━━')) {
        return result;
    }
    
    // SOLO FORMATTAZIONE VISIVA - Non cambia il contenuto!
    
    // 1. Converti numeri a inizio riga in emoji (1. → 1️⃣)
    result = result.replace(/^1[.)]\s*/gm, '\n1️⃣ ');
    result = result.replace(/^2[.)]\s*/gm, '\n2️⃣ ');
    result = result.replace(/^3[.)]\s*/gm, '\n3️⃣ ');
    result = result.replace(/^4[.)]\s*/gm, '\n4️⃣ ');
    result = result.replace(/^5[.)]\s*/gm, '\n5️⃣ ');
    
    // 2. Migliora i bullet points
    result = result.replace(/^[-•]\s*/gm, '\n• ');
    
    // 3. Aggiungi spaziatura dopo i punti (migliore leggibilità)
    result = result.replace(/([.!?])\s+/g, '$1\n\n');
    
    // 4. Aggiungi grassetto alle parole chiave di azione
    const actionWords = [
        'clicca', 'premi', 'apri', 'chiudi', 'riavvia', 'verifica', 
        'controlla', 'cerca', 'seleziona', 'scegli', 'vai', 'scrivi'
    ];
    actionWords.forEach(word => {
        const regex = new RegExp(`\\b(${word}[a-z]*)\\b`, 'gi');
        result = result.replace(regex, '**$1**');
    });
    
    // 5. Evidenzia combinazioni di tasti
    result = result.replace(/\b(CTRL|ALT|SHIFT|CANC|ESC|TAB|INVIO|ENTER|F\d+)\b/gi, '**$1**');
    result = result.replace(/\b(Windows)\s*\+\s*(\w)/gi, '**Windows + $2**');
    
    // 6. Aggiungi separatore e call-to-action se manca il riferimento al ticket
    if (!result.toLowerCase().includes('ticket') && !result.includes('🎫')) {
        result += '\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Serve altro aiuto?** Clicca su 🎫 per aprire un ticket!';
    }
    
    // 7. Pulisci spazi multipli
    result = result.replace(/\n{4,}/g, '\n\n\n');
    result = result.replace(/^\s+/gm, '');
    
    return result.trim();
};

// ============================================================================
// AI QUICK ACTIONS: Analizza messaggio e suggerisce azioni contestuali
// ============================================================================
const analyzeMessageForQuickActions = (userMessage, aiResponse) => {
    const actions = [];
    const msgLower = (userMessage || '').toLowerCase();
    const aiLower = (aiResponse || '').toLowerCase();
    
    // Pattern per suggerire apertura ticket
    const ticketPatterns = [
        /non\s*(riesco|funziona|va|parte|si\s*apre)/i,
        /bloccato|blocca|crash|errore|problema\s*grave/i,
        /urgente|urgenza|subito|emergenza/i,
        /già\s*provato|ho\s*provato\s*tutto|non\s*funziona\s*niente/i,
        /da\s*giorni|da\s*ore|da\s*tempo/i
    ];
    
    // Pattern per suggerire videochiamata
    const videoPatterns = [
        /non\s*capisco|confuso|non\s*trovo/i,
        /puoi\s*mostrarmi|fammi\s*vedere/i,
        /screenshot|immagine|foto/i,
        /complicato|difficile|troppo\s*tecnico/i
    ];
    
    // Pattern per suggerire sicurezza
    const securityPatterns = [
        /password|credenziali|accesso|login/i,
        /virus|malware|sospetto|phishing|truffa/i,
        /hackerato|compromesso|violato/i
    ];
    
    // Analizza e suggerisci azioni
    if (ticketPatterns.some(p => p.test(msgLower)) || 
        aiLower.includes('ticket') || 
        aiLower.includes('intervento')) {
        actions.push({
            type: 'ticket',
            label: '🎫 Apri Ticket',
            priority: ticketPatterns.some(p => /urgente|emergenza/.test(msgLower)) ? 'high' : 'normal',
            reason: 'Il problema sembra richiedere assistenza diretta'
        });
    }
    
    if (videoPatterns.some(p => p.test(msgLower)) || 
        aiLower.includes('videochiamata') || 
        aiLower.includes('mostrarmi')) {
        actions.push({
            type: 'videocall',
            label: '📹 Videochiamata',
            priority: 'normal',
            reason: 'Possiamo risolvere più velocemente con supporto visivo'
        });
    }
    
    if (securityPatterns.some(p => p.test(msgLower))) {
        actions.push({
            type: 'security',
            label: '🛡️ Centro Sicurezza',
            priority: securityPatterns.some(p => /virus|malware|hackerato/.test(msgLower)) ? 'high' : 'normal',
            reason: 'Verifica la sicurezza del tuo account'
        });
    }
    
    return actions;
};

// ============================================================================
// AI PROACTIVE SUGGESTIONS: Suggerimenti intelligenti basati su contesto
// ============================================================================
const getProactiveSuggestions = (userData, messageHistory) => {
    const suggestions = [];
    const now = new Date();
    const hour = now.getHours();
    const dayOfWeek = now.getDay();
    
    // Suggerimento mattutino
    if (hour >= 8 && hour <= 10 && messageHistory.length <= 1) {
        suggestions.push({
            type: 'tip',
            icon: '☀️',
            text: 'Buongiorno! Sono qui per aiutarti con qualsiasi problema IT. Come posso assisterti oggi?',
            action: null
        });
    }
    
    // Suggerimento fine settimana (backup)
    if (dayOfWeek === 5 && hour >= 14) {
        suggestions.push({
            type: 'reminder',
            icon: '💾',
            text: 'È venerdì! Assicurati di salvare i documenti importanti prima del weekend.',
            action: null
        });
    }
    
    // Se l'utente ha avuto problemi di password di recente
    const recentPasswordIssues = messageHistory.some(m => 
        m.text && /password|credenziali|login/i.test(m.text)
    );
    if (recentPasswordIssues) {
        suggestions.push({
            type: 'security',
            icon: '🔐',
            text: 'Hai avuto problemi di accesso di recente. Vuoi generare una password sicura?',
            action: 'openSecurity'
        });
    }
    
    // Suggerimento per utenti frequenti
    if (messageHistory.length > 5) {
        suggestions.push({
            type: 'feedback',
            icon: '⭐',
            text: 'Come sta andando con Spark? Il tuo feedback ci aiuta a migliorare!',
            action: 'showFeedback'
        });
    }
    
    return suggestions.slice(0, 2); // Max 2 suggerimenti alla volta
};

// ============================================================================
// AI SCREENSHOT ANALYSIS: Prompt specifico per analisi immagini
// ============================================================================
const getScreenshotAnalysisPrompt = () => {
    return `ANALISI SCREENSHOT/IMMAGINE

Sei un esperto IT che analizza screenshot di errori. Quando ricevi un'immagine:

1. IDENTIFICA IMMEDIATAMENTE:
   - Tipo di errore (Windows, Office, Browser, App specifica)
   - Codice errore se presente (es. 0x80070005, BSOD, etc.)
   - Messaggio di errore testuale

2. SPIEGA IN MODO SEMPLICE:
   - Cosa significa l'errore in italiano corrente
   - Perché potrebbe essere successo

3. FORNISCI SOLUZIONE:
   - Passi concreti per risolvere
   - Se è un errore grave, suggerisci di aprire ticket

4. CODICI ERRORE COMUNI:
   - 0x80070005: Accesso negato (permessi)
   - 0x80070002: File non trovato
   - 0x80004005: Errore generico
   - BSOD: Schermata blu (problema hardware/driver)
   - ERR_CONNECTION_REFUSED: Server non raggiungibile
   - ERR_NAME_NOT_RESOLVED: Problema DNS

Rispondi SEMPRE in italiano, con tono amichevole e rassicurante.`;
};

// ============================================================================
// 🚀 AI ENTERPRISE ENHANCEMENTS - MODULO 1: MEMORIA PERSISTENTE E PROFILO UTENTE
// ============================================================================
const AI_MEMORY_STORAGE_KEY = 'spark-ai-memory-v2';
const USER_PROFILE_STORAGE_KEY = 'spark-user-profile-v2';
const CROSS_SESSION_MEMORY_KEY = 'spark-cross-session-memory-v1';

// ============================================================================
// 🧠 FUNZIONALITÀ AVANZATA 1: MEMORIA MULTI-SESSIONE PERSISTENTE
// ============================================================================
// Memoria che persiste tra sessioni diverse - ricorda dettagli importanti dell'utente
const loadCrossSessionMemory = () => {
    try {
        const saved = localStorage.getItem(CROSS_SESSION_MEMORY_KEY);
        return saved ? JSON.parse(saved) : {
            userSummary: {
                preferredWorkingHours: null,    // Es: "mattina", "pomeriggio"
                commonDevices: [],              // Dispositivi usati frequentemente
                expertiseAreas: [],             // Aree dove l'utente è più esperto
                weaknessAreas: [],              // Aree dove ha più difficoltà
                personalNotes: []               // Note personali apprese (max 10)
            },
            issueHistory: [],                   // Storico problemi significativi (max 30)
            pendingFollowUps: [],               // Follow-up da fare alla prossima sessione
            sessionStats: {
                totalSessions: 0,
                lastSessionDate: null,
                averageIssuesPerSession: 0,
                mostActiveDay: null,            // Giorno della settimana più attivo
                mostActiveHour: null            // Ora del giorno più attiva
            },
            learningProfile: {
                preferredExplanationStyle: 'visual',  // 'visual', 'textual', 'step-by-step'
                responseSpeedPreference: 'detailed',  // 'quick', 'detailed'
                appreciatesHumor: true,
                needsReassurance: false
            },
            resolutionPatterns: []              // Pattern di risoluzioni di successo
        };
    } catch (e) {
        console.error('Errore caricamento memoria cross-session:', e);
        return { userSummary: {}, issueHistory: [], pendingFollowUps: [], sessionStats: {}, learningProfile: {}, resolutionPatterns: [] };
    }
};

const saveCrossSessionMemory = (memory) => {
    try {
        localStorage.setItem(CROSS_SESSION_MEMORY_KEY, JSON.stringify(memory));
    } catch (e) {
        console.error('Errore salvataggio memoria cross-session:', e);
    }
};

// Aggiorna la memoria cross-session con nuove informazioni
const updateCrossSessionMemory = (interactionData) => {
    const memory = loadCrossSessionMemory();
    const now = new Date();
    const dayOfWeek = now.toLocaleDateString('it-IT', { weekday: 'long' });
    const hourOfDay = now.getHours();
    
    // Aggiorna statistiche sessione
    memory.sessionStats.totalSessions = (memory.sessionStats.totalSessions || 0) + 1;
    memory.sessionStats.lastSessionDate = now.toISOString();
    
    // Traccia giorno e ora più attivi
    if (!memory.sessionStats.dayActivity) memory.sessionStats.dayActivity = {};
    if (!memory.sessionStats.hourActivity) memory.sessionStats.hourActivity = {};
    memory.sessionStats.dayActivity[dayOfWeek] = (memory.sessionStats.dayActivity[dayOfWeek] || 0) + 1;
    memory.sessionStats.hourActivity[hourOfDay] = (memory.sessionStats.hourActivity[hourOfDay] || 0) + 1;
    
    // Trova giorno/ora più attivi
    const maxDay = Object.entries(memory.sessionStats.dayActivity || {}).sort((a, b) => b[1] - a[1])[0];
    const maxHour = Object.entries(memory.sessionStats.hourActivity || {}).sort((a, b) => b[1] - a[1])[0];
    memory.sessionStats.mostActiveDay = maxDay ? maxDay[0] : null;
    memory.sessionStats.mostActiveHour = maxHour ? parseInt(maxHour[0]) : null;
    
    // Se c'è un problema risolto, aggiungilo alla history
    if (interactionData?.resolvedIssue) {
        memory.issueHistory.push({
            date: now.toISOString(),
            issue: interactionData.resolvedIssue.substring(0, 200),
            solution: interactionData.solution?.substring(0, 300) || '',
            category: interactionData.category || 'generale',
            resolutionTime: interactionData.resolutionTime || null,
            wasHelpful: interactionData.wasHelpful
        });
        // Mantieni max 30 problemi
        if (memory.issueHistory.length > 30) memory.issueHistory.shift();
    }
    
    // Aggiorna pattern di risoluzione se il feedback è positivo
    if (interactionData?.wasHelpful === true && interactionData?.category) {
        const existingPattern = memory.resolutionPatterns.find(p => p.category === interactionData.category);
        if (existingPattern) {
            existingPattern.successCount++;
            existingPattern.lastSuccess = now.toISOString();
            if (interactionData.solutionKeywords) {
                existingPattern.effectiveKeywords = [...new Set([...existingPattern.effectiveKeywords, ...interactionData.solutionKeywords])].slice(0, 20);
            }
        } else {
            memory.resolutionPatterns.push({
                category: interactionData.category,
                successCount: 1,
                lastSuccess: now.toISOString(),
                effectiveKeywords: interactionData.solutionKeywords || []
            });
        }
        if (memory.resolutionPatterns.length > 20) memory.resolutionPatterns.shift();
    }
    
    saveCrossSessionMemory(memory);
    return memory;
};

// Aggiungi un follow-up pendente per la prossima sessione
const addPendingFollowUp = (followUp) => {
    const memory = loadCrossSessionMemory();
    memory.pendingFollowUps.push({
        id: Date.now(),
        createdAt: new Date().toISOString(),
        issue: followUp.issue,
        question: followUp.question,
        priority: followUp.priority || 'normal', // 'high', 'normal', 'low'
        expiresAt: followUp.expiresAt || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString() // Default 7 giorni
    });
    // Mantieni max 5 follow-up pendenti
    if (memory.pendingFollowUps.length > 5) memory.pendingFollowUps.shift();
    saveCrossSessionMemory(memory);
};

// Rimuovi un follow-up completato
const completePendingFollowUp = (followUpId) => {
    const memory = loadCrossSessionMemory();
    memory.pendingFollowUps = memory.pendingFollowUps.filter(f => f.id !== followUpId);
    saveCrossSessionMemory(memory);
};

// Struttura memoria AI persistente (versione estesa)
const loadAIMemory = () => {
    try {
        const saved = localStorage.getItem(AI_MEMORY_STORAGE_KEY);
        return saved ? JSON.parse(saved) : {
            resolvedIssues: [],      // Problemi risolti con successo
            frequentTopics: {},      // Argomenti frequenti {topic: count}
            userPreferences: {},     // Preferenze apprese (stile comunicazione, livello tecnico)
            lastInteractions: [],    // Ultime 20 interazioni significative
            learningInsights: [],    // Insight apprese dal comportamento utente
            successfulSolutions: [], // Soluzioni che hanno funzionato
            // Nuovi campi per funzionalità avanzate
            recentResolutions: [],   // Risoluzioni recenti per follow-up (ultime 5)
            feedbackHistory: [],     // Storico feedback utente
            contextualLearnings: {}  // Apprendimenti contestuali (ora/giorno -> comportamenti)
        };
    } catch (e) {
        console.error('Errore caricamento memoria AI:', e);
        return { resolvedIssues: [], frequentTopics: {}, userPreferences: {}, lastInteractions: [], learningInsights: [], successfulSolutions: [], recentResolutions: [], feedbackHistory: [], contextualLearnings: {} };
    }
};

const saveAIMemory = (memory) => {
    try {
        localStorage.setItem(AI_MEMORY_STORAGE_KEY, JSON.stringify(memory));
    } catch (e) {
        console.error('Errore salvataggio memoria AI:', e);
    }
};

// Profilo utente dinamico (versione estesa)
const loadUserProfile = () => {
    try {
        const saved = localStorage.getItem(USER_PROFILE_STORAGE_KEY);
        return saved ? JSON.parse(saved) : {
            technicalLevel: 'medium',     // 'beginner', 'medium', 'advanced'
            communicationStyle: 'friendly', // 'formal', 'friendly', 'technical'
            commonIssueTypes: [],         // Tipi di problemi più frequenti
            averageResolutionTime: null,  // Tempo medio risoluzione
            totalInteractions: 0,         // Totale interazioni
            satisfactionScore: null,      // Score soddisfazione medio
            preferredContactMethod: null, // 'chat', 'video', 'ticket'
            frustrationTriggers: [],      // Pattern che causano frustrazione
            positivePatterns: [],         // Pattern di successo
            lastUpdated: null,
            // Nuovi campi per funzionalità avanzate
            firstInteractionDate: null,   // Data prima interazione
            successfulResolutions: 0,     // Contatore risoluzioni di successo
            averageSatisfaction: null,    // Media soddisfazione (1-5)
            satisfactionHistory: [],      // Storico valutazioni
            learningMilestones: [],       // Traguardi di apprendimento raggiunti
            preferredTimeSlot: null       // Fascia oraria preferita
        };
    } catch (e) {
        console.error('Errore caricamento profilo utente:', e);
        return { technicalLevel: 'medium', communicationStyle: 'friendly', commonIssueTypes: [], totalInteractions: 0, successfulResolutions: 0 };
    }
};

const saveUserProfile = (profile) => {
    try {
        profile.lastUpdated = new Date().toISOString();
        localStorage.setItem(USER_PROFILE_STORAGE_KEY, JSON.stringify(profile));
    } catch (e) {
        console.error('Errore salvataggio profilo utente:', e);
    }
};

// Aggiorna memoria AI dopo ogni interazione
const updateAIMemory = (userMessage, aiResponse, wasHelpful = null, issueType = null) => {
    const memory = loadAIMemory();
    const profile = loadUserProfile();
    
    // Aggiorna interazioni recenti (max 20)
    memory.lastInteractions.push({
        timestamp: new Date().toISOString(),
        userMessage: userMessage.substring(0, 200),
        aiResponsePreview: aiResponse.substring(0, 200),
        wasHelpful,
        issueType
    });
    if (memory.lastInteractions.length > 20) memory.lastInteractions.shift();
    
    // Analizza e aggiorna topic frequenti
    const detectedTopics = detectTopicsFromMessage(userMessage);
    detectedTopics.forEach(topic => {
        memory.frequentTopics[topic] = (memory.frequentTopics[topic] || 0) + 1;
    });
    
    // Se l'utente ha dato feedback positivo, salva la soluzione
    if (wasHelpful === true && issueType) {
        memory.successfulSolutions.push({
            issueType,
            solutionPreview: aiResponse.substring(0, 300),
            timestamp: new Date().toISOString()
        });
        if (memory.successfulSolutions.length > 50) memory.successfulSolutions.shift();
    }
    
    // Aggiorna profilo utente
    profile.totalInteractions++;
    if (issueType && !profile.commonIssueTypes.includes(issueType)) {
        profile.commonIssueTypes.push(issueType);
        if (profile.commonIssueTypes.length > 10) profile.commonIssueTypes.shift();
    }
    
    saveAIMemory(memory);
    saveUserProfile(profile);
    
    return { memory, profile };
};

// Rileva topic dal messaggio utente
const detectTopicsFromMessage = (message) => {
    const topics = [];
    const msgLower = message.toLowerCase();
    
    const topicPatterns = {
        'email': /email|posta|outlook|mail|pec/i,
        'password': /password|credenziali|accesso|login|autenticazione/i,
        'stampante': /stampa|stampante|printer|scanner/i,
        'rete': /rete|internet|wifi|connessione|vpn|network/i,
        'office': /word|excel|powerpoint|office|teams/i,
        'pc_lento': /lento|rallentato|blocca|freeze|crash/i,
        'hardware': /monitor|mouse|tastiera|cuffie|webcam|usb/i,
        'sicurezza': /virus|malware|phishing|sicurezza|antivirus/i,
        'software': /installa|aggiorna|update|programma|app/i
    };
    
    Object.entries(topicPatterns).forEach(([topic, pattern]) => {
        if (pattern.test(msgLower)) topics.push(topic);
    });
    
    return topics;
};

// ============================================================================
// 🎯 FUNZIONALITÀ AVANZATA 3: SUGGERIMENTI CONTESTUALI INTELLIGENTI
// ============================================================================
// Genera suggerimenti basati su ora, giorno, stagione e pattern utente
const generateContextualSuggestions = (userData = {}) => {
    const now = new Date();
    const hour = now.getHours();
    const dayOfWeek = now.getDay(); // 0=Domenica, 1=Lunedì, ...
    const month = now.getMonth(); // 0=Gennaio
    const dayName = now.toLocaleDateString('it-IT', { weekday: 'long' });
    const crossMemory = loadCrossSessionMemory();
    const suggestions = [];
    
    // === SUGGERIMENTI BASATI SULL'ORA ===
    if (hour >= 7 && hour < 9) {
        suggestions.push({
            type: 'time_based',
            priority: 'high',
            icon: '☀️',
            title: 'Inizio giornata',
            tip: 'Buongiorno! Ricorda di controllare le email prima di iniziare: spesso ci sono comunicazioni importanti arrivate durante la notte.',
            action: 'Apri Outlook e controlla la posta in arrivo'
        });
        // Lunedì mattina - suggerimento speciale
        if (dayOfWeek === 1) {
            suggestions.push({
                type: 'day_specific',
                priority: 'high',
                icon: '📅',
                title: 'Lunedì - Pianificazione settimanale',
                tip: 'È lunedì! Perfetto momento per verificare il calendario della settimana e pianificare le attività.',
                action: 'Controlla gli impegni della settimana'
            });
        }
    } else if (hour >= 12 && hour < 14) {
        suggestions.push({
            type: 'time_based',
            priority: 'low',
            icon: '🍽️',
            title: 'Pausa pranzo',
            tip: 'Se stai per andare a pranzo, ricorda di bloccare il PC (Windows + L) prima di allontanarti!',
            action: 'Premi Windows + L per bloccare'
        });
    } else if (hour >= 17 && hour < 19) {
        suggestions.push({
            type: 'time_based',
            priority: 'medium',
            icon: '🏁',
            title: 'Fine giornata',
            tip: 'Prima di andare via, salva tutti i documenti aperti e considera di fare un backup dei file importanti su OneDrive.',
            action: 'Salva il lavoro e verifica la sincronizzazione'
        });
        // Venerdì sera - suggerimento speciale
        if (dayOfWeek === 5) {
            suggestions.push({
                type: 'day_specific',
                priority: 'medium',
                icon: '🎉',
                title: 'Venerdì - Fine settimana',
                tip: 'Buon fine settimana! Prima di staccare, assicurati di aver salvato tutto e che non ci siano email urgenti in sospeso.',
                action: 'Controlla email urgenti prima di chiudere'
            });
        }
    } else if (hour >= 21 || hour < 7) {
        suggestions.push({
            type: 'time_based',
            priority: 'low',
            icon: '🌙',
            title: 'Fuori orario - Ci pensa Spark!',
            tip: 'I colleghi non sono in ufficio ora, ma ci sono io! Per problemi urgenti posso aiutarti direttamente, oppure puoi aprire un ticket per domani.',
            action: 'Chiedimi pure o apri un ticket'
        });
    }
    
    // === SUGGERIMENTI BASATI SUL GIORNO DELLA SETTIMANA ===
    const dayTips = {
        1: { // Lunedì
            tip: 'Il lunedì è spesso il giorno con più problemi di password scadute durante il weekend. Se hai difficoltà di accesso, controlla prima le credenziali.',
            icon: '🔐'
        },
        2: { // Martedì
            tip: 'Martedì è un buon momento per organizzare i file sul Desktop e svuotare il Cestino se non lo fai da tempo.',
            icon: '🔄'
        },
        3: { // Mercoledì
            tip: 'A metà settimana è il momento ideale per fare un backup dei documenti importanti!',
            icon: '💾'
        },
        4: { // Giovedì
            tip: 'Giovedì: controlla che la stampante abbia abbastanza toner e carta per le stampe di venerdì!',
            icon: '🖨️'
        },
        5: { // Venerdì
            tip: 'Venerdì: prima di andare, svuota il cestino e libera spazio sul disco se necessario.',
            icon: '🗑️'
        }
    };
    
    if (dayTips[dayOfWeek]) {
        suggestions.push({
            type: 'day_tip',
            priority: 'low',
            icon: dayTips[dayOfWeek].icon,
            title: `Consiglio del ${dayName}`,
            tip: dayTips[dayOfWeek].tip
        });
    }
    
    // === SUGGERIMENTI BASATI SULLA STAGIONE ===
    if (month >= 5 && month <= 8) { // Estate (Giugno-Settembre)
        suggestions.push({
            type: 'seasonal',
            priority: 'low',
            icon: '🌡️',
            title: 'Suggerimento estivo',
            tip: 'Con il caldo, assicurati che le ventole del PC siano libere e che ci sia buona circolazione d\'aria. Un PC surriscaldato può rallentare!',
            action: 'Verifica la ventilazione del PC'
        });
    } else if (month >= 11 || month <= 1) { // Inverno (Dicembre-Febbraio)
        suggestions.push({
            type: 'seasonal',
            priority: 'low',
            icon: '⚡',
            title: 'Suggerimento invernale',
            tip: 'In inverno sono più frequenti gli sbalzi di corrente. Assicurati di salvare spesso il tuo lavoro!',
            action: 'Salva frequentemente (CTRL + S)'
        });
    }
    
    // === SUGGERIMENTI BASATI SULLA STORIA UTENTE ===
    if (crossMemory.sessionStats?.mostActiveHour) {
        const peakHour = crossMemory.sessionStats.mostActiveHour;
        if (hour === peakHour) {
            suggestions.push({
                type: 'personalized',
                priority: 'medium',
                icon: '📊',
                title: 'La tua ora più attiva',
                tip: `Ho notato che di solito mi contatti a quest'ora. Se hai domande ricorrenti, ricorda che puoi consultare lo storico delle nostre conversazioni!`
            });
        }
    }
    
    // === SUGGERIMENTI BASATI SUI PROBLEMI RICORRENTI ===
    if (crossMemory.issueHistory && crossMemory.issueHistory.length > 0) {
        const recentCategories = {};
        const oneWeekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
        
        crossMemory.issueHistory
            .filter(i => new Date(i.date).getTime() > oneWeekAgo)
            .forEach(i => {
                recentCategories[i.category] = (recentCategories[i.category] || 0) + 1;
            });
        
        const mostCommon = Object.entries(recentCategories).sort((a, b) => b[1] - a[1])[0];
        if (mostCommon && mostCommon[1] >= 2) {
            const preventionTips = {
                'email': 'Per prevenire problemi email, svuota periodicamente la cartella Posta eliminata e archivia le vecchie email.',
                'password': 'Per evitare problemi di password, usa un password manager e imposta promemoria per il rinnovo.',
                'stampante': 'Controlla periodicamente toner e carta nella stampante per evitare blocchi improvvisi.',
                'rete': 'Se hai problemi frequenti di rete, considera di usare una connessione cablata invece del Wi-Fi.',
                'pc_lento': 'Per mantenere il PC veloce, riavvialo almeno una volta a settimana e chiudi i programmi non utilizzati.'
            };
            
            if (preventionTips[mostCommon[0]]) {
                suggestions.push({
                    type: 'prevention',
                    priority: 'high',
                    icon: '💡',
                    title: 'Prevenzione problemi ricorrenti',
                    tip: preventionTips[mostCommon[0]],
                    category: mostCommon[0]
                });
            }
        }
    }
    
    // Ritorna solo i suggerimenti più rilevanti (max 3)
    return suggestions
        .sort((a, b) => {
            const priorityOrder = { high: 3, medium: 2, low: 1 };
            return (priorityOrder[b.priority] || 0) - (priorityOrder[a.priority] || 0);
        })
        .slice(0, 3);
};

// ============================================================================
// 🔄 FUNZIONALITÀ AVANZATA 2: FOLLOW-UP PROATTIVO
// ============================================================================
// Genera messaggi di follow-up per problemi precedenti
const generateProactiveFollowUp = (userName) => {
    const crossMemory = loadCrossSessionMemory();
    const memory = loadAIMemory();
    const now = new Date();
    const followUpMessages = [];
    
    // === CONTROLLA FOLLOW-UP PENDENTI ===
    const validFollowUps = (crossMemory.pendingFollowUps || []).filter(f => {
        const expires = new Date(f.expiresAt);
        return expires > now;
    });
    
    if (validFollowUps.length > 0) {
        const topFollowUp = validFollowUps.sort((a, b) => {
            const priorityOrder = { high: 3, normal: 2, low: 1 };
            return (priorityOrder[b.priority] || 2) - (priorityOrder[a.priority] || 2);
        })[0];
        
        followUpMessages.push({
            type: 'pending_followup',
            id: topFollowUp.id,
            message: topFollowUp.question,
            issue: topFollowUp.issue,
            priority: topFollowUp.priority
        });
    }
    
    // === CONTROLLA PROBLEMI RECENTI NON CONFERMATI ===
    const recentIssues = (crossMemory.issueHistory || [])
        .filter(issue => {
            const issueDate = new Date(issue.date);
            const daysSince = (now - issueDate) / (1000 * 60 * 60 * 24);
            // Problemi degli ultimi 3 giorni che non hanno conferma di risoluzione
            return daysSince <= 3 && issue.wasHelpful !== true;
        })
        .slice(-2);
    
    recentIssues.forEach(issue => {
        const issueDate = new Date(issue.date);
        const isYesterday = (now - issueDate) / (1000 * 60 * 60 * 24) <= 1;
        const timeRef = isYesterday ? 'ieri' : 'qualche giorno fa';
        
        const categoryMessages = {
            'email': `A proposito, ${timeRef} abbiamo parlato di un problema con la posta. Come è andata poi?`,
            'password': `${timeRef} avevi un problema di accesso. Sei riuscito a risolvere?`,
            'stampante': `Come va con la stampante? ${timeRef} mi avevi scritto per un problema...`,
            'rete': `La connessione funziona bene adesso? ${timeRef} avevi avuto qualche difficoltà.`,
            'pc_lento': `Il PC va meglio? Mi avevi detto che era un po' lento ${timeRef}.`,
            'office': `Come vanno i programmi Office? ${timeRef} avevamo risolto insieme un problema.`,
            'hardware': `L'hardware funziona tutto? ${timeRef} c'era stato qualche problemino.`,
            'generale': `${timeRef} mi avevi contattato per un problema. È tutto risolto?`
        };
        
        followUpMessages.push({
            type: 'recent_issue_followup',
            message: categoryMessages[issue.category] || categoryMessages['generale'],
            issue: issue.issue,
            category: issue.category
        });
    });
    
    // === CONTROLLA PATTERN TEMPORALI ===
    const sessionStats = crossMemory.sessionStats || {};
    if (sessionStats.lastSessionDate) {
        const lastSession = new Date(sessionStats.lastSessionDate);
        const daysSinceLastSession = (now - lastSession) / (1000 * 60 * 60 * 24);
        
        // Se sono passati più di 7 giorni
        if (daysSinceLastSession > 7) {
            followUpMessages.push({
                type: 'long_absence',
                message: `È un po' che non ci sentiamo! Come va il PC? Tutto sotto controllo?`
            });
        }
    }
    
    // === GENERA SALUTO INTELLIGENTE CON FOLLOW-UP ===
    const firstName = userName?.split(/[.\s_-]/)[0] || 'collega';
    const capitalizedName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    
    if (followUpMessages.length > 0) {
        const primaryFollowUp = followUpMessages[0];
        return {
            hasFollowUp: true,
            followUpData: primaryFollowUp,
            greeting: `Ciao ${capitalizedName}! 👋 ${primaryFollowUp.message}`,
            subtext: 'Sono qui se hai bisogno di aiuto per qualsiasi cosa!'
        };
    }
    
    // Nessun follow-up specifico - saluto normale con contesto
    const greetingsByTime = {
        morning: `Buongiorno ${capitalizedName}! ☀️ Come posso aiutarti oggi?`,
        afternoon: `Buon pomeriggio ${capitalizedName}! Come va? Sono qui per aiutarti.`,
        evening: `Buonasera ${capitalizedName}! 🌙 Stai lavorando tardi? Come posso esserti utile?`
    };
    
    const hour = now.getHours();
    let timeSlot = 'afternoon';
    if (hour >= 6 && hour < 12) timeSlot = 'morning';
    else if (hour >= 18 || hour < 6) timeSlot = 'evening';
    
    return {
        hasFollowUp: false,
        greeting: greetingsByTime[timeSlot],
        subtext: 'Sono pronto ad aiutarti con qualsiasi problema tecnico!'
    };
};

// ============================================================================
// 📈 FUNZIONALITÀ AVANZATA 4: APPRENDIMENTO DALLE RISOLUZIONI
// ============================================================================
// Registra il feedback dell'utente e aggiorna i pattern di apprendimento
const recordResolutionFeedback = (messageId, wasHelpful, userMessage, aiResponse, category = null) => {
    const memory = loadAIMemory();
    const profile = loadUserProfile();
    const crossMemory = loadCrossSessionMemory();
    
    // Detecta la categoria se non fornita
    const detectedCategory = category || detectTopicsFromMessage(userMessage)[0] || 'generale';
    
    // Aggiorna la memoria AI
    if (!memory.feedbackHistory) memory.feedbackHistory = [];
    memory.feedbackHistory.push({
        timestamp: new Date().toISOString(),
        messageId,
        wasHelpful,
        category: detectedCategory,
        userMessagePreview: userMessage.substring(0, 100),
        aiResponsePreview: aiResponse.substring(0, 200)
    });
    
    // Mantieni max 50 feedback
    if (memory.feedbackHistory.length > 50) memory.feedbackHistory.shift();
    
    // Se il feedback è positivo, registra come risoluzione di successo
    if (wasHelpful === true) {
        // Aggiorna contatore nel profilo
        profile.successfulResolutions = (profile.successfulResolutions || 0) + 1;
        
        // Aggiungi alla lista delle risoluzioni recenti per follow-up
        if (!memory.recentResolutions) memory.recentResolutions = [];
        memory.recentResolutions.push({
            date: new Date().toISOString(),
            category: detectedCategory,
            issue: userMessage.substring(0, 150),
            solution: aiResponse.substring(0, 300)
        });
        if (memory.recentResolutions.length > 5) memory.recentResolutions.shift();
        
        // Aggiungi alla knowledge base
        addToKnowledgeBase(userMessage, aiResponse, true);
        
        // Aggiorna cross-session memory
        updateCrossSessionMemory({
            resolvedIssue: userMessage,
            solution: aiResponse,
            category: detectedCategory,
            wasHelpful: true,
            solutionKeywords: detectTopicsFromMessage(aiResponse)
        });
        
        // Aggiorna pattern positivi nel profilo
        if (!profile.positivePatterns) profile.positivePatterns = [];
        profile.positivePatterns.push({
            category: detectedCategory,
            timestamp: new Date().toISOString()
        });
        if (profile.positivePatterns.length > 20) profile.positivePatterns.shift();
        
    } else if (wasHelpful === false) {
        // Registra come problema non risolto per follow-up futuro
        addPendingFollowUp({
            issue: userMessage.substring(0, 100),
            question: `L'ultima volta non sono riuscito ad aiutarti con "${userMessage.substring(0, 50)}...". Hai risolto poi?`,
            priority: 'normal',
            expiresAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString() // 5 giorni
        });
        
        // Aggiorna frustration triggers nel profilo
        if (!profile.frustrationTriggers) profile.frustrationTriggers = [];
        profile.frustrationTriggers.push({
            category: detectedCategory,
            timestamp: new Date().toISOString()
        });
        if (profile.frustrationTriggers.length > 10) profile.frustrationTriggers.shift();
    }
    
    // Aggiorna soddisfazione media
    if (!profile.satisfactionHistory) profile.satisfactionHistory = [];
    profile.satisfactionHistory.push({
        timestamp: new Date().toISOString(),
        score: wasHelpful ? 5 : 1
    });
    if (profile.satisfactionHistory.length > 30) profile.satisfactionHistory.shift();
    
    // Calcola media soddisfazione
    const avgSatisfaction = profile.satisfactionHistory.reduce((sum, s) => sum + s.score, 0) / profile.satisfactionHistory.length;
    profile.averageSatisfaction = Math.round(avgSatisfaction * 10) / 10;
    
    // Salva tutto
    saveAIMemory(memory);
    saveUserProfile(profile);
    
    return {
        success: true,
        stats: {
            totalFeedback: memory.feedbackHistory.length,
            successfulResolutions: profile.successfulResolutions,
            averageSatisfaction: profile.averageSatisfaction
        }
    };
};

// Ottiene insights dalle risoluzioni passate per migliorare le risposte future
const getResolutionInsights = (category) => {
    const crossMemory = loadCrossSessionMemory();
    const memory = loadAIMemory();
    const insights = {
        hasData: false,
        successfulApproaches: [],
        avoidPatterns: [],
        userPreferences: {}
    };
    
    // Analizza pattern di successo per questa categoria
    const relevantPatterns = (crossMemory.resolutionPatterns || []).filter(p => p.category === category);
    if (relevantPatterns.length > 0) {
        insights.hasData = true;
        const bestPattern = relevantPatterns.sort((a, b) => b.successCount - a.successCount)[0];
        insights.successfulApproaches = bestPattern.effectiveKeywords || [];
    }
    
    // Analizza feedback storici
    const categoryFeedback = (memory.feedbackHistory || []).filter(f => f.category === category);
    const positiveFeedback = categoryFeedback.filter(f => f.wasHelpful);
    const negativeFeedback = categoryFeedback.filter(f => !f.wasHelpful);
    
    if (positiveFeedback.length > negativeFeedback.length * 2) {
        insights.userPreferences.responseStyle = 'current_approach_works';
    } else if (negativeFeedback.length > positiveFeedback.length) {
        insights.userPreferences.responseStyle = 'needs_improvement';
        insights.avoidPatterns = negativeFeedback.slice(-3).map(f => f.aiResponsePreview);
    }
    
    return insights;
};

// ============================================================================
// 🚀 AI ENTERPRISE ENHANCEMENTS - MODULO 2: KNOWLEDGE BASE INTELLIGENTE
// ============================================================================
const KNOWLEDGE_BASE_KEY = 'spark-knowledge-base-v1';

// Knowledge Base che apprende dai ticket risolti
const loadKnowledgeBase = () => {
    try {
        const saved = localStorage.getItem(KNOWLEDGE_BASE_KEY);
        return saved ? JSON.parse(saved) : {
            solutions: [],        // Soluzioni validate
            commonPatterns: [],   // Pattern problema->soluzione
            faqs: [],            // FAQ generate automaticamente
            escalationCriteria: [] // Criteri per escalation
        };
    } catch (e) {
        return { solutions: [], commonPatterns: [], faqs: [], escalationCriteria: [] };
    }
};

const saveKnowledgeBase = (kb) => {
    try {
        localStorage.setItem(KNOWLEDGE_BASE_KEY, JSON.stringify(kb));
    } catch (e) {
        console.error('Errore salvataggio Knowledge Base:', e);
    }
};

// Cerca soluzioni simili nella Knowledge Base
const findSimilarSolutions = (userMessage) => {
    const kb = loadKnowledgeBase();
    const memory = loadAIMemory();
    const msgLower = userMessage.toLowerCase();
    const suggestions = [];
    
    // Cerca nelle soluzioni di successo della memoria
    memory.successfulSolutions.forEach(sol => {
        const keywords = sol.issueType ? sol.issueType.split('_') : [];
        if (keywords.some(kw => msgLower.includes(kw))) {
            suggestions.push({
                type: 'past_success',
                solution: sol.solutionPreview,
                confidence: 0.8
            });
        }
    });
    
    // Cerca pattern comuni
    kb.commonPatterns.forEach(pattern => {
        if (pattern.triggerKeywords.some(kw => msgLower.includes(kw.toLowerCase()))) {
            suggestions.push({
                type: 'knowledge_base',
                solution: pattern.solution,
                confidence: pattern.successRate || 0.7
            });
        }
    });
    
    // Ordina per confidence e ritorna i top 3
    return suggestions.sort((a, b) => b.confidence - a.confidence).slice(0, 3);
};

// Aggiunge una soluzione alla Knowledge Base
const addToKnowledgeBase = (problem, solution, wasSuccessful) => {
    const kb = loadKnowledgeBase();
    
    if (wasSuccessful) {
        const keywords = detectTopicsFromMessage(problem);
        kb.commonPatterns.push({
            triggerKeywords: keywords,
            problemSummary: problem.substring(0, 100),
            solution: solution.substring(0, 500),
            successRate: 1,
            addedAt: new Date().toISOString()
        });
        
        // Mantieni max 100 pattern
        if (kb.commonPatterns.length > 100) kb.commonPatterns.shift();
        saveKnowledgeBase(kb);
    }
};

// ============================================================================
// 🚀 AI ENTERPRISE ENHANCEMENTS - MODULO 3: DIAGNOSTICA PROATTIVA
// ============================================================================

// Genera checklist diagnostica intelligente basata sul tipo di problema
const generateDiagnosticChecklist = (issueType, userContext = {}) => {
    const checklists = {
        'email': [
            { step: '📧 Outlook è aperto?', action: 'Verifica che Outlook sia avviato e non in modalità offline' },
            { step: '🔌 Connessione internet', action: 'Controlla se riesci a navigare su altri siti' },
            { step: '🔄 Sincronizzazione', action: 'Guarda in basso a destra se dice "Connesso" o "Lavora offline"' },
            { step: '📁 Cartella Spam', action: 'Controlla se le email sono finite in Posta Indesiderata' }
        ],
        'stampante': [
            { step: '🔌 Stampante accesa?', action: 'Verifica che la luce verde sia accesa' },
            { step: '📄 Carta presente?', action: 'Controlla se c\'è carta nel cassetto' },
            { step: '🔗 Cavo collegato', action: 'Verifica il cavo USB o di rete dietro la stampante' },
            { step: '🖨️ Coda di stampa', action: 'Apri Dispositivi e stampanti e controlla se ci sono lavori in coda' }
        ],
        'rete': [
            { step: '📶 Icona Wi-Fi/Rete', action: 'Guarda vicino all\'orologio se vedi le tacchette o un cavo' },
            { step: '🔄 Riavvia router', action: 'Se sei a casa, prova a spegnere e riaccendere il router' },
            { step: '🌐 Test navigazione', action: 'Prova ad aprire google.it per verificare la connessione' },
            { step: '🔌 Cavo LAN', action: 'Se usi un cavo, verifica che sia inserito bene' }
        ],
        'pc_lento': [
            { step: '🔄 Da quanto è acceso?', action: 'Se il PC è acceso da giorni, prova a riavviarlo' },
            { step: '💾 Disco pieno?', action: 'Controlla se il disco C: è quasi pieno (rosso)' },
            { step: '📊 Task Manager', action: 'Premi CTRL+SHIFT+ESC e guarda se qualcosa usa troppa CPU/RAM' },
            { step: '🔄 Aggiornamenti', action: 'Potrebbero esserci aggiornamenti in corso in background' }
        ],
        'password': [
            { step: '⌨️ Caps Lock', action: 'Controlla che il tasto BLOC MAIUSC non sia attivo' },
            { step: '🔢 Num Lock', action: 'Se hai tastierino numerico, verifica il NUM LOCK' },
            { step: '🌐 Lingua tastiera', action: 'Guarda in basso a destra se c\'è scritto IT o ENG' },
            { step: '🔄 Reset password', action: 'Se non ricordi la password, usa il link "Password dimenticata"' }
        ],
        'default': [
            { step: '🔄 Riavvia il programma', action: 'Chiudi completamente e riapri l\'applicazione' },
            { step: '💻 Riavvia il PC', action: 'Un riavvio risolve molti problemi' },
            { step: '📸 Fai uno screenshot', action: 'Se c\'è un errore, fai uno screenshot e mandamelo' },
            { step: '🎫 Apri un ticket', action: 'Se il problema persiste, apriamo un ticket insieme' }
        ]
    };
    
    return checklists[issueType] || checklists['default'];
};

// Analisi predittiva: identifica pattern ricorrenti
const analyzeRecurringPatterns = (userMessage, memory) => {
    const patterns = [];
    const msgLower = userMessage.toLowerCase();
    const topics = detectTopicsFromMessage(userMessage);
    
    // Controlla se questo problema si ripresenta spesso
    topics.forEach(topic => {
        if (memory.frequentTopics[topic] >= 3) {
            patterns.push({
                type: 'recurring',
                topic,
                count: memory.frequentTopics[topic],
                suggestion: `Noto che hai già avuto problemi di ${topic} in passato. Potrebbe esserci una causa sottostante da investigare.`
            });
        }
    });
    
    // Verifica pattern temporali (stesso problema a intervalli regolari)
    const recentSameIssues = memory.lastInteractions.filter(int => {
        const intTopics = detectTopicsFromMessage(int.userMessage);
        return intTopics.some(t => topics.includes(t));
    });
    
    if (recentSameIssues.length >= 2) {
        patterns.push({
            type: 'temporal',
            message: 'Questo problema sembra ripresentarsi periodicamente.',
            suggestion: 'Potrebbe essere utile aprire un ticket per un\'analisi approfondita.'
        });
    }
    
    return patterns;
};

// Determina se escalare a supporto umano
const shouldEscalateToHuman = (userMessage, conversationLength, memory, profile) => {
    const reasons = [];
    
    // Criteri di escalation
    const escalationKeywords = [
        { pattern: /bloccat[oi]|ferm[oi]|non\s+funziona\s+niente/i, priority: 'high', reason: 'Sistema completamente bloccato' },
        { pattern: /urgent[ei]|emergenza|subito|crisi/i, priority: 'critical', reason: 'Situazione urgente' },
        { pattern: /f24|buste\s*paga|fattur|bilancio/i, priority: 'critical', reason: 'Attività business-critical' },
        { pattern: /da\s+(ieri|giorni|ore|settimana)/i, priority: 'medium', reason: 'Problema persistente' },
        { pattern: /ho\s+già\s+provato|non\s+funziona\s+comunque/i, priority: 'medium', reason: 'Tentativi precedenti falliti' }
    ];
    
    escalationKeywords.forEach(esc => {
        if (esc.pattern.test(userMessage)) {
            reasons.push({ priority: esc.priority, reason: esc.reason });
        }
    });
    
    // Se la conversazione è lunga senza risoluzione
    if (conversationLength > 10) {
        reasons.push({ priority: 'medium', reason: 'Conversazione estesa senza risoluzione' });
    }
    
    // Se l'utente ha mostrato frustrazione nelle ultime interazioni
    if (profile.frustrationTriggers && profile.frustrationTriggers.length > 2) {
        reasons.push({ priority: 'medium', reason: 'Utente potenzialmente frustrato' });
    }
    
    return reasons.length > 0 ? reasons : null;
};

// ============================================================================
// 🚀 AI ENTERPRISE ENHANCEMENTS - MODULO 4: SENTIMENT ANALYSIS & RISPOSTE ADATTIVE
// ============================================================================

// Analizza il sentiment del messaggio utente
const analyzeSentiment = (message) => {
    const msgLower = message.toLowerCase();
    
    // Pattern di frustrazione
    const frustrationPatterns = [
        { pattern: /non\s+(funziona|va|riesco|capisco)/i, weight: 2 },
        { pattern: /ancora|di\s+nuovo|sempre/i, weight: 1 },
        { pattern: /impossibile|assurdo|incredibile/i, weight: 3 },
        { pattern: /!{2,}|\?{2,}/i, weight: 2 },
        { pattern: /ma\s+perché|perchè\s+non|come\s+è\s+possibile/i, weight: 2 },
        { pattern: /ore|giorni|settimane/i, weight: 1 },
        { pattern: /aiuto|help|sos/i, weight: 1 },
        { pattern: /frustrat|stuf[oa]|arrabiat|nervos/i, weight: 4 },
        { pattern: /urgente|urgenza|subito|immediato/i, weight: 2 }
    ];
    
    // Pattern positivi
    const positivePatterns = [
        { pattern: /grazie|perfetto|ottimo|funziona/i, weight: -2 },
        { pattern: /risolto|ok|fatto|capito/i, weight: -2 },
        { pattern: /gentile|bravo|fantastico/i, weight: -3 },
        { pattern: /😊|👍|🎉|❤️/i, weight: -2 }
    ];
    
    let frustrationScore = 0;
    
    frustrationPatterns.forEach(p => {
        if (p.pattern.test(msgLower)) frustrationScore += p.weight;
    });
    
    positivePatterns.forEach(p => {
        if (p.pattern.test(msgLower)) frustrationScore += p.weight;
    });
    
    // Determina il sentiment
    if (frustrationScore >= 5) return { level: 'high_frustration', score: frustrationScore, emoji: '😤' };
    if (frustrationScore >= 3) return { level: 'moderate_frustration', score: frustrationScore, emoji: '😕' };
    if (frustrationScore <= -2) return { level: 'positive', score: frustrationScore, emoji: '😊' };
    return { level: 'neutral', score: frustrationScore, emoji: '🙂' };
};

// Adatta lo stile di risposta in base al profilo utente e sentiment
const getAdaptiveResponseStyle = (profile, sentiment) => {
    const style = {
        tone: 'friendly',
        complexity: 'medium',
        empathy: 'normal',
        urgency: 'normal',
        encouragement: true
    };
    
    // Adatta in base al livello tecnico dell'utente
    switch (profile.technicalLevel) {
        case 'beginner':
            style.complexity = 'simple';
            style.encouragement = true;
            break;
        case 'advanced':
            style.complexity = 'technical';
            style.encouragement = false;
            break;
    }
    
    // Adatta in base al sentiment
    if (sentiment.level === 'high_frustration') {
        style.tone = 'calming';
        style.empathy = 'high';
        style.urgency = 'high';
    } else if (sentiment.level === 'moderate_frustration') {
        style.empathy = 'elevated';
    } else if (sentiment.level === 'positive') {
        style.tone = 'celebratory';
    }
    
    return style;
};

// Genera prefisso empatico basato su sentiment
const getEmpatheticPrefix = (sentiment, profile) => {
    const prefixes = {
        'high_frustration': [
            'Eh, capisco benissimo, quando la tecnologia fa i capricci viene voglia di buttarla dalla finestra! Ma tranquillo, ci penso io.',
            'Ma certo che ti capisco! È frustrante quando le cose non funzionano. Respira, vediamo insieme cosa possiamo fare.',
            'Accidenti, mi dispiace che stai avendo problemi da così tanto tempo! Adesso ci mettiamo di impegno e risolviamo.',
            'Lo so, lo so... succede anche a noi tecnici di innervosirci! Ma non ti preoccupare, sono qui apposta per aiutarti.'
        ],
        'moderate_frustration': [
            'Capisco che non è il massimo della giornata! Vediamo di sistemare tutto insieme.',
            'Eh sì, queste cose capitano e sono scoccianti. Ma niente paura, ci pensiamo noi!',
            'Ti capisco, non è divertente. Ma dai, adesso vediamo di risolvere velocemente!'
        ],
        'positive': [
            'Fantastico! ',
            'Perfetto, che bello! ',
            'Ottimo, sono contento! '
        ],
        'neutral': ['']
    };
    
    const options = prefixes[sentiment.level] || prefixes['neutral'];
    return options[Math.floor(Math.random() * options.length)];
};

// Determina il livello tecnico dell'utente dai suoi messaggi
const inferTechnicalLevel = (message, profile) => {
    const technicalTerms = [
        'dns', 'dhcp', 'ip', 'registry', 'cmd', 'powershell', 'driver', 
        'bios', 'ram', 'cpu', 'cache', 'proxy', 'firewall', 'porta',
        'protocollo', 'server', 'client', 'log', 'debug'
    ];
    
    const beginnerPhrases = [
        'non so', 'non capisco', 'cosa significa', 'come si fa',
        'dove trovo', 'non riesco', "cos'è"
    ];
    
    const msgLower = message.toLowerCase();
    let technicalScore = 0;
    
    technicalTerms.forEach(term => {
        if (msgLower.includes(term)) technicalScore += 2;
    });
    
    beginnerPhrases.forEach(phrase => {
        if (msgLower.includes(phrase)) technicalScore -= 1;
    });
    
    // Aggiorna profilo
    if (technicalScore >= 4) {
        profile.technicalLevel = 'advanced';
    } else if (technicalScore <= -2) {
        profile.technicalLevel = 'beginner';
    } else {
        profile.technicalLevel = 'medium';
    }
    
    return profile.technicalLevel;
};

// ============================================================================
// 🚀 AI ENTERPRISE: INTEGRAZIONE NEL SYSTEM PROMPT
// ============================================================================

// Costruisce il contesto enterprise per il system prompt
const buildEnterpriseContext = (userData, conversationHistory) => {
    const memory = loadAIMemory();
    const profile = loadUserProfile();
    const kb = loadKnowledgeBase();
    const crossMemory = loadCrossSessionMemory();
    
    // Trova il messaggio più recente dell'utente
    const lastUserMessage = conversationHistory.length > 0 
        ? conversationHistory[conversationHistory.length - 1]?.parts?.[0]?.text || ''
        : '';
    
    // Analizza sentiment
    const sentiment = analyzeSentiment(lastUserMessage);
    
    // Aggiorna livello tecnico
    if (lastUserMessage) {
        inferTechnicalLevel(lastUserMessage, profile);
        saveUserProfile(profile);
    }
    
    // Cerca soluzioni simili
    const similarSolutions = findSimilarSolutions(lastUserMessage);
    
    // Analizza pattern ricorrenti
    const recurringPatterns = analyzeRecurringPatterns(lastUserMessage, memory);
    
    // Verifica escalation
    const escalationReasons = shouldEscalateToHuman(lastUserMessage, conversationHistory.length, memory, profile);
    
    // Genera stile risposta adattivo
    const responseStyle = getAdaptiveResponseStyle(profile, sentiment);
    
    // 🎯 NUOVA FUNZIONALITÀ: Suggerimenti contestuali
    const contextualSuggestions = generateContextualSuggestions(userData);
    
    // 📈 NUOVA FUNZIONALITÀ: Insights dalle risoluzioni
    const detectedCategory = detectTopicsFromMessage(lastUserMessage)[0];
    const resolutionInsights = detectedCategory ? getResolutionInsights(detectedCategory) : null;
    
    // 🧠 NUOVA FUNZIONALITÀ: Memoria cross-session
    const sessionStats = crossMemory.sessionStats || {};
    const userSummary = crossMemory.userSummary || {};
    
    // Costruisci contesto
    let enterpriseContext = `

===== CONTESTO AI ENTERPRISE =====

⭐ REGOLA D'ORO SERVICE DESK (SEMPRE ATTIVA):
DEVI SEMPRE parlare come un COLLEGA AMICHEVOLE, MAI come un tecnico freddo o un chatbot.
- Usa SEMPRE frasi semplici, come se parlassi a tua nonna
- Descrivi le icone per COLORI e FORME, non con nomi tecnici
- Dai rinforzi positivi: "Bravissimo!", "Perfetto!", "Ottimo lavoro!"
- Usa metafore quotidiane per spiegare concetti tecnici
- Parla in prima persona: "Vediamo insieme...", "Ti guido passo passo..."
- NON usare MAI termini come: endpoint, deploy, API, database, query, frontend, backend
- SEMPRE: "il programma", "la pagina", "il bottone", "la finestrella"

📊 PROFILO UTENTE DINAMICO:
- Livello tecnico rilevato: ${profile.technicalLevel.toUpperCase()}
${profile.technicalLevel === 'beginner' ? '  → USA LINGUAGGIO EXTRA SEMPLICE! Come parlare a un bambino di 8 anni.' : ''}
${profile.technicalLevel === 'medium' ? '  → Linguaggio semplice ma puoi usare termini comuni (email, password, stampante)' : ''}
${profile.technicalLevel === 'advanced' ? '  → Puoi essere più diretto ma SEMPRE amichevole e colloquiale' : ''}
- Stile comunicazione preferito: ${profile.communicationStyle}
- Interazioni totali: ${profile.totalInteractions}
- Problemi ricorrenti: ${profile.commonIssueTypes.slice(0, 5).join(', ') || 'Nessuno rilevato'}
${profile.successfulResolutions > 0 ? `- Risoluzioni di successo: ${profile.successfulResolutions} (utente ha fiducia nel sistema)` : ''}
${profile.averageSatisfaction ? `- Soddisfazione media: ${profile.averageSatisfaction}/5` : ''}

🎭 ANALISI SENTIMENT ATTUALE:
- Livello: ${sentiment.level.replace(/_/g, ' ')} ${sentiment.emoji}
- Score frustrazione: ${sentiment.score}
${sentiment.level.includes('frustration') ? '⚠️ ATTENZIONE: Utente frustrato! Sii EXTRA empatico e rassicurante. Inizia con comprensione, poi soluzione.' : ''}
${sentiment.level === 'positive' ? '😊 Utente soddisfatto! Mantieni il tono positivo e celebra il successo insieme.' : ''}

📚 MEMORIA INTERAZIONI:
- Topic più frequenti: ${Object.entries(memory.frequentTopics).sort((a,b) => b[1]-a[1]).slice(0,3).map(([k,v]) => `${k}(${v})`).join(', ') || 'Nessuno'}
- Soluzioni precedenti che hanno funzionato: ${memory.successfulSolutions.length}

🎯 STILE RISPOSTA CONSIGLIATO:
- Tono: ${responseStyle.tone === 'calming' ? 'CALMANTE - Rassicura prima di tutto' : responseStyle.tone === 'celebratory' ? 'CELEBRATIVO - Festeggia il successo!' : 'AMICHEVOLE - Come un collega premuroso'}
- Complessità: ${responseStyle.complexity === 'simple' ? 'SEMPLICE - Usa solo parole di tutti i giorni' : responseStyle.complexity === 'technical' ? 'MODERATA - Puoi essere più diretto' : 'MEDIA - Bilanciata'}
- Livello empatia: ${responseStyle.empathy === 'high' ? 'MASSIMA - Mostra comprensione profonda' : responseStyle.empathy === 'elevated' ? 'ELEVATA - Più attenzione ai sentimenti' : 'NORMALE - Cordiale e disponibile'}
${responseStyle.encouragement ? '- ✅ USA INCORAGGIAMENTI: "Bravissimo!", "Perfetto!", "Stai andando alla grande!"' : ''}
`;

    // 🧠 NUOVA SEZIONE: Memoria Cross-Session
    if (sessionStats.totalSessions > 1) {
        enterpriseContext += `
🧠 MEMORIA CROSS-SESSION (Conosci questo utente!):
- Sessioni totali: ${sessionStats.totalSessions}
- Giorno più attivo: ${sessionStats.mostActiveDay || 'N/D'}
- Ora tipica di contatto: ${sessionStats.mostActiveHour !== null ? `${sessionStats.mostActiveHour}:00` : 'N/D'}
${crossMemory.issueHistory?.length > 0 ? `- Problemi passati risolti: ${crossMemory.issueHistory.length}` : ''}
${crossMemory.resolutionPatterns?.length > 0 ? `- Pattern di successo memorizzati: ${crossMemory.resolutionPatterns.length}` : ''}

💡 USA QUESTE INFO: Fai riferimento alla storia comune! Es: "Come al solito...", "So che preferisci...", "L'altra volta abbiamo risolto insieme..."
`;
    }

    // 🎯 NUOVA SEZIONE: Suggerimenti Contestuali
    if (contextualSuggestions.length > 0) {
        enterpriseContext += `
🎯 SUGGERIMENTI CONTESTUALI (basati su ora/giorno/stagione):
${contextualSuggestions.map(s => `- ${s.icon} [${s.type}] ${s.tip}`).join('\n')}

💡 USA QUESTI SUGGERIMENTI: Se opportuno nella conversazione, condividi uno di questi consigli in modo naturale.
`;
    }

    // 📈 NUOVA SEZIONE: Insights dalle Risoluzioni
    if (resolutionInsights?.hasData) {
        enterpriseContext += `
📈 APPRENDIMENTO DALLE RISOLUZIONI PASSATE (per categoria: ${detectedCategory}):
${resolutionInsights.successfulApproaches.length > 0 ? `- Approcci che hanno funzionato: ${resolutionInsights.successfulApproaches.slice(0, 5).join(', ')}` : ''}
${resolutionInsights.userPreferences?.responseStyle === 'current_approach_works' ? '- ✅ L\'approccio attuale funziona bene con questo utente!' : ''}
${resolutionInsights.userPreferences?.responseStyle === 'needs_improvement' ? '- ⚠️ Le risposte precedenti su questo tema non hanno soddisfatto l\'utente. Prova un approccio diverso!' : ''}
`;
    }

    // Aggiungi soluzioni simili se trovate
    if (similarSolutions.length > 0) {
        enterpriseContext += `
💡 SOLUZIONI SIMILI TROVATE:
${similarSolutions.map((s, i) => `${i+1}. [Confidenza ${Math.round(s.confidence*100)}%] ${s.solution.substring(0, 150)}...`).join('\n')}
`;
    }

    // Aggiungi pattern ricorrenti se rilevati
    if (recurringPatterns.length > 0) {
        enterpriseContext += `
🔄 PATTERN RICORRENTI RILEVATI:
${recurringPatterns.map(p => `- ${p.type}: ${p.suggestion || p.message}`).join('\n')}
`;
    }

    // Aggiungi avviso escalation se necessario
    if (escalationReasons) {
        enterpriseContext += `
🚨 CRITERI ESCALATION ATTIVI:
${escalationReasons.map(r => `- [${r.priority.toUpperCase()}] ${r.reason}`).join('\n')}
➡️ Proponi di aprire un ticket così lo prendiamo in carico NOI del team 86BIT. NON parlare di "supporto", "servicedesk", "operatore" o "collega umano" come entità separate da te: l'unico handoff è il ticket interno che gestiamo noi come squadra.
`;
    }

    // Aggiungi prefisso empatico per sentiment negativo
    if (sentiment.level.includes('frustration')) {
        enterpriseContext += `
💬 PREFISSO EMPATICO DA USARE:
"${getEmpatheticPrefix(sentiment, profile)}"
`;
    }

    enterpriseContext += `
===== FINE CONTESTO ENTERPRISE =====
`;

    return enterpriseContext;
};

// ============================================================================
// GUIDE DETTAGLIATE ON-DEMAND (caricate solo quando l'argomento è pertinente)
// Riduce i token per messaggio: le guide entrano nel prompt solo se servono.
// ============================================================================
const GUIDES_INTRO = `1.3.b GUIDE COMPLETE PASSO-PASSO (BASE DI CONOSCENZA APPROFONDITA)
Usa queste guide come riferimento per dare istruzioni dettagliate e corrette. Adatta SEMPRE il linguaggio allo stile "Maestra Gentile" (passi brevi, uno alla volta) e rispetta le regole di sicurezza (mai regedit/script/comandi distruttivi). Se l'utente preferisce lo stile Diretto, riassumi in elenco puntato.`;

const DETAILED_GUIDES = {
    word: `════════════════════════════════════
📝 MICROSOFT WORD (Guida completa)
════════════════════════════════════
• RECUPERO FILE NON SALVATO: File → Informazioni → "Gestisci documento" → "Recupera documenti non salvati". Oppure File → Apri → in fondo "Recupera documenti non salvati". I file di autosalvataggio hanno estensione .asd. Attiva sempre: File → Opzioni → Salvataggio → "Salva informazioni di salvataggio automatico ogni 5 minuti".
• RIPRISTINARE VERSIONI PRECEDENTI (file su OneDrive/SharePoint): apri il file → clicca sul nome del file in alto → "Cronologia versioni" → scegli la versione e "Ripristina".
• FORMATTAZIONE TESTO: scheda Home. Grassetto Ctrl+G, Corsivo Ctrl+I. Interlinea: Home → icona con frecce su/giù accanto ai paragrafi. Allineamento: Ctrl+T (giustificato), Ctrl+F (centrato).
• MARGINI E ORIENTAMENTO: scheda Layout → Margini / Orientamento (Verticale-Orizzontale) / Dimensioni (A4).
• SOMMARIO AUTOMATICO: applica gli stili "Titolo 1/2/3" ai capitoli (scheda Home) → scheda Riferimenti → "Sommario" → scegli un modello. Per aggiornarlo: clic destro sul sommario → "Aggiorna campo".
• INTESTAZIONE / PIÈ DI PAGINA E NUMERI PAGINA: scheda Inserisci → Intestazione / Piè di pagina / Numero di pagina.
• IMMAGINI E TABELLE: Inserisci → Immagini / Tabella. Per spostare bene un'immagine: clic destro → "Testo a capo" → "Incorniciato" o "Davanti al testo".
• REVISIONI / COMMENTI (lavoro condiviso): scheda Revisione → "Rileva modifiche" → "Accetta/Rifiuta". Nuovo commento: seleziona testo → Revisione → "Nuovo commento".
• CORRETTORE ORTOGRAFICO E LINGUA: Revisione → "Controllo ortografia" (F7). Lingua sbagliata: Revisione → Lingua → "Imposta lingua di correzione" → Italiano.
• STAMPA UNIONE (lettere/etichette da elenco Excel): Lettere → "Inizia stampa unione" → scegli tipo → "Seleziona destinatari" (usa il file Excel) → "Inserisci campo unione" → "Anteprima risultati" → "Finalizza e unisci".
• SALVARE IN PDF: File → Salva con nome → tipo file "PDF"; oppure File → Esporta → "Crea PDF/XPS". (Per documenti aziendali NON usare siti online di conversione.)
• PROTEGGERE CON PASSWORD: File → Informazioni → "Proteggi documento" → "Crittografa con password".
• PROBLEMI COMUNI: Word si blocca all'apertura → apri in modalità provvisoria (tieni premuto CTRL mentre apri Word); se va, disabilita i componenti aggiuntivi (File → Opzioni → Componenti aggiuntivi → Gestisci Componenti COM). Documento "in sola lettura"/bloccato da altro utente → chiudi i file temporanei nascosti (nome tipo ~tildeNomefile.docx) o "Salva con nome" una copia. Font diversi su un altro PC → incorpora i caratteri (File → Opzioni → Salvataggio) o salva in PDF.`,

    excel: `════════════════════════════════════
📊 MICROSOFT EXCEL (Guida completa)
════════════════════════════════════
• FORMULE ESSENZIALI (inizia sempre con =):
  - Somma: =SOMMA(A1:A10) | Media: =MEDIA(A1:A10) | Conta numeri: =CONTA.NUMERI(A1:A10) | Max/Min: =MAX(...) / =MIN(...)
  - Condizione SE: =SE(A1>100;"OK";"NO")
  - Cerca valore (nuovo): =CERCA.X(valore; colonna_cerca; colonna_risultato). Classica: =CERCA.VERT(valore; tabella; num_colonna; FALSO).
  - Somma condizionata: =SOMMA.SE(intervallo; criterio; intervallo_somma). Conta condizionata: =CONTA.SE(...).
  - Unire testo: =CONCAT(A1;" ";B1) oppure =A1&" "&B1.
• ERRORI FORMULE: #DIV/0! = divisione per zero; #RIF! = riferimento cancellato; #VALORE! = tipo dato errato; #NOME? = funzione scritta male; ##### = colonna troppo stretta. Blocca un riferimento con il simbolo dollaro (es. A1 assoluto) trascinando la formula.
• FORMATO NUMERO vs TESTO (numeri che non sommano): Home → menu formato numero → "Numero". Se restano testo: seleziona colonna → Dati → "Testo in colonne" → Fine. I numeri "testo" hanno un triangolino verde in alto a sinistra.
• BLOCCA RIQUADRI (intestazioni sempre visibili): Visualizza → "Blocca riquadri" → "Blocca riga superiore".
• ORDINAMENTO E FILTRI: seleziona la tabella → Dati → "Filtro" → clic sull'imbuto per ordinare/filtrare.
• FORMATTAZIONE CONDIZIONALE: Home → "Formattazione condizionale" → Regole evidenziazione / Barre dei dati.
• TABELLA PIVOT: seleziona i dati → Inserisci → "Tabella pivot" → OK → trascina i campi in Righe/Colonne/Valori.
• GRAFICI: seleziona i dati → Inserisci → tipo (Istogramma, Torta, Linee).
• STAMPA CORRETTA (non taglia le colonne): Layout di pagina → "Area di stampa" → "Imposta area di stampa". Poi File → Stampa → "Adatta tutte le colonne a una pagina" / Orizzontale. "Stampa titoli" per ripetere l'intestazione.
• PROTEGGERE FOGLIO / CELLE BLOCCATE: Revisione → "Proteggi foglio". Se non riesci a scrivere in una cella, il foglio è protetto: Revisione → "Rimuovi protezione foglio".
• RICALCOLO LENTO: Formule → Opzioni calcolo → verifica sia "Automatico".
• PROBLEMI COMUNI: file lento (troppe formule volatili come ADESSO/CASUALE); date che diventano numeri (formatta come Data); CSV che si apre male (Dati → "Da testo/CSV" scegliendo il separatore ; o ,).`,

    outlook: `════════════════════════════════════
📧 OUTLOOK WEB (OWA - outlook.office.com)
════════════════════════════════════
• ACCESSO: outlook.office.com (o portal.office.com → Outlook), email aziendale + password + MFA. Se richiede di continuo le credenziali, prova una finestra di navigazione privata/incognito.
• INVIARE / RISPONDERE: "Nuovo messaggio" in alto a sinistra. Rispondi/Rispondi a tutti/Inoltra con le frecce in alto a destra del messaggio.
• FIRMA: ingranaggio (Impostazioni) → "Posta" → "Scrivi e rispondi" → crea la firma e scegli se aggiungerla in automatico.
• RISPOSTE AUTOMATICHE / FUORI SEDE: ingranaggio → "Account" → "Risposte automatiche" → attiva, periodo e testo (interni/esterni).
• REGOLE (smistare posta): ingranaggio → "Posta" → "Regole" → "Aggiungi nuova regola".
• CARTELLE: clic destro sulla casella → "Crea nuova cartella"; trascina i messaggi o clic destro → "Sposta".
• ARCHIVIA vs ELIMINA: "Archivia" toglie dalla Posta in arrivo senza cancellare; "Elimina" va nel Cestino.
• RECUPERO POSTA ELIMINATA: cartella "Posta eliminata" → in alto "Recupera elementi eliminati da questa cartella".
• RICERCA: barra "Cerca" in alto con filtri (Da, Oggetto, Data). Se non trova nulla, controlla la cartella o cerca in "Tutte le cartelle".
• ALLEGATI GRANDI (>20-25MB): carica su OneDrive e invia il link ("Allega" → "Sfoglia posizioni cloud"). Estensioni bloccate (.exe, .bat): usa OneDrive o rinomina in .zip.
• CALENDARIO E INVITI: icona calendario in basso a sinistra → "Nuovo evento" → partecipanti/sala → "Assistente pianificazione" per la disponibilità → "Riunione di Teams" per il link online.
• CONDIVIDERE / DELEGARE CALENDARIO: Calendario → "Condividi" → collega + livello (visualizza/modifica).
• CATEGORIE E CONTRASSEGNI: clic destro sul messaggio → "Categorizza" (colori) o "Contrassegna" (bandierina).
• PROBLEMI COMUNI: posta non arriva (controlla "Posta indesiderata" e le Regole); casella piena (archivia/svuota Cestino); messaggio non visibile (rimuovi filtri attivi). OWA è utile quando l'app Outlook desktop dà problemi (profilo corrotto).`,

    windows: `════════════════════════════════════
🪟 WINDOWS 10/11 (Guida generale)
════════════════════════════════════
• RIAVVIO CORRETTO (non "spegni e riaccendi"): Start (bandierina) → icona Spegnimento → "Riavvia il sistema". Risolve la maggior parte dei rallentamenti.
• APP BLOCCATA ("non risponde"): CTRL+SHIFT+ESC → "Gestione attività" → seleziona l'app → "Termina attività". (Salva prima gli altri lavori!)
• SCREENSHOT: WIN+SHIFT+S → seleziona l'area → incolla con CTRL+V in chat/mail/Word. Tutto lo schermo: tasto "Stamp".
• RISOLUZIONE PROBLEMI AUTOMATICA: Impostazioni → "Sistema" → "Risoluzione dei problemi" → "Altri strumenti" → Audio / Rete / Stampante.
• SPAZIO DISCO PIENO (disco C: rosso): Impostazioni → Sistema → Archiviazione → attiva "Sensore memoria" e usa "File temporanei" per pulire in sicurezza. NIENTE "PC cleaner" di terze parti.
• APP PREDEFINITE (PDF si apre con Edge invece di Adobe): clic destro sul PDF → "Apri con" → "Scegli un'altra app" → Adobe Reader → spunta "Usa sempre".
• AGGIORNAMENTI: Impostazioni → "Windows Update" → "Verifica disponibilità aggiornamenti". Se il PC è lentissimo, spesso è un aggiornamento in corso: lascialo finire.
• WI-FI / RETE: icona rete vicino all'orologio. Wi-Fi assente su portatile: controlla il tasto fisico/Fn e la "Modalità aereo". Reset veloce: disattiva/riattiva il Wi-Fi. Vedere l'IP: apri "cmd" e usa "ipconfig".
• STAMPANTI: Impostazioni → "Bluetooth e dispositivi" → "Stampanti e scanner". Coda bloccata: apri stampante → "Apri coda di stampa" → annulla i documenti; poi lo strumento di risoluzione problemi. Imposta la predefinita corretta (evita "Microsoft Print to PDF").
• AUDIO: clic sull'icona altoparlante → scegli il dispositivo di uscita giusto (spesso l'audio va sul monitor HDMI invece che sulle cuffie).
• ONEDRIVE (nuvoletta vicino all'orologio): nuvola blu = sincronizzato; frecce circolari = in sincronizzazione; croce rossa = errore. "Nuvola bianca vuota" = file solo online (serve internet).
• RICERCA / TROVARE PROGRAMMI: lente o tasto WIN e scrivi il nome (es. "Word").
• NOTIFICHE / FOCUS: se non arrivano notifiche, controlla "Assistente notifiche/Focus" (Impostazioni → Sistema → Notifiche).
• BLOCCARE IL PC: WIN+L (buona pratica di sicurezza).
• CREDENZIALI (login continui): "Gestione credenziali" dal menu Cerca → rimuovi le credenziali vecchie del servizio problematico.`,

    teams: `════════════════════════════════════
👥 MICROSOFT TEAMS (Guida completa)
════════════════════════════════════
• AUDIO "NON MI SENTONO": controlla il muto software (icona microfono barrata in Teams) E il muto hardware (tasto sulle cuffie/tastiera). In riunione: clic su "..." → Impostazioni dispositivo → seleziona il microfono giusto.
• AUDIO "NON SENTO": Impostazioni dispositivo → "Altoparlante" → scegli le cuffie invece del monitor HDMI. Fai un "Effettua una chiamata di prova".
• VIDEO "NON MI VEDONO": controlla il copri-webcam fisico e che la webcam non sia usata da un'altra app (Zoom/Skype aperti). Impostazioni dispositivo → "Fotocamera" → seleziona quella corretta.
• CONDIVIDERE LO SCHERMO: in riunione clic su "Condividi" (icona schermo con freccia) → scegli "Schermo" (tutto) o una singola finestra. Per condividere l'audio del video spunta "Includi audio del computer".
• SFONDO SFOCATO/PERSONALIZZATO: prima o durante la riunione → "..." → "Effetti sfondo" → Sfoca o scegli un'immagine.
• RIUNIONE LENTA / SI BLOCCA: Impostazioni Teams → "Generale" → disattiva "Disabilita accelerazione hardware GPU"; oppure svuota la cache di Teams (chiudi Teams e riaprilo). In alternativa usa Teams sul web (teams.microsoft.com).
• CHAT E FILE: i file condivisi in chat finiscono in OneDrive; quelli nei canali in SharePoint. Trovi tutto nella scheda "File".
• PIANIFICARE UNA RIUNIONE: Calendario → "Nuova riunione" → aggiungi partecipanti → il link Teams viene creato in automatico.
• NOTIFICHE ASSENTI: Impostazioni Teams → "Notifiche e attività"; controlla anche che lo stato non sia "Non disturbare".
• PROBLEMI DI ACCESSO: esci e rientra (clic sulla tua iniziale in alto → "Disconnetti"); se persiste, usa la versione web per capire se è un problema dell'app installata.`,

    pec: `════════════════════════════════════
📜 PEC & FIRMA DIGITALE (Guida completa)
════════════════════════════════════
• COS'È LA PEC: casella di posta con valore legale (come una raccomandata A/R). Ha spazio limitato: va archiviata/svuotata periodicamente.
• ACCESSO WEBMAIL PEC: entra dal sito del gestore (Aruba, Legalmail/InfoCert, Poste, ecc.) con le credenziali PEC. Utile quando la PEC su Outlook dà problemi.
• POSTA E PEC: i clienti 86BIT usano ESCLUSIVAMENTE Microsoft 365 via web (Outlook sul Web su https://outlook.cloud.microsoft). NON dare MAI istruzioni su configurazione manuale di account, parametri IMAP/POP/SMTP, porte o server: non si usano. Se l'utente ha bisogno di configurare/aggiungere una casella o una PEC, apri un ticket a 86BIT (ci pensiamo noi lato Microsoft 365).
• PEC PIENA / NON RICEVE PIÙ: accedi alla webmail, sposta/scarica i messaggi vecchi in una cartella locale o archivio, poi svuota. Avvisa che se è piena non riceve nuove PEC.
• RICEVUTE PEC: per ogni invio ricevi "Accettazione" (il gestore ha preso in carico) e "Consegna" (arrivata al destinatario). Conservale: sono la prova legale.
• FIRMA DIGITALE - COS'È: firma con valore legale su documenti. File firmati hanno estensione .p7m (CAdES) o .pdf (PAdES).
• APRIRE/LEGGERE UN FILE .p7m: usa il software del gestore (Aruba Sign / Dike / ArubaKey / Firma4NG). Apri il programma → "Verifica" → seleziona il file → estrai il documento originale. NON aprire il .p7m con doppio clic a caso.
• FIRMARE UN DOCUMENTO: apri il software di firma → "Firma" → seleziona il PDF/file → inserisci il dispositivo (smart card/token USB o firma remota) → inserisci il PIN → scegli formato (PAdES per PDF leggibili, CAdES per .p7m).
• PIN BLOCCATO: dopo 3 PIN errati il dispositivo si blocca; serve il PUK (fornito alla consegna) per sbloccarlo dal software. Se manca il PUK, contatta il gestore.
• TOKEN/SMART CARD NON RILEVATO: verifica che il software di gestione sia aperto, prova un'altra porta USB, riavvia il programma di firma. NON installare driver a caso: se non funziona apri un ticket.
• FATTURA ELETTRONICA (.xml / .p7m): è un file dati, non un PDF. Per leggerla in modo comprensibile usa il visualizzatore del gestore o quello dell'Agenzia delle Entrate (foglio di stile), non aprire l'XML grezzo.`,

    pdf: `════════════════════════════════════
📄 PDF (Guida completa)
════════════════════════════════════
• APRIRE SEMPRE CON ADOBE (non con Edge): clic destro su un PDF → "Apri con" → "Scegli un'altra app" → Adobe Acrobat Reader → spunta "Usa sempre".
• LEGGERE/STAMPARE: Adobe Reader → icona stampante. Se la stampa esce sballata, in stampa scegli "Dimensioni effettive" o "Adatta" e verifica l'orientamento.
• COMPILARE UN MODULO PDF: se ci sono campi cliccabili, scrivi direttamente. Se il PDF non è compilabile, usa Strumenti → "Compila e firma" per aggiungere testo.
• FIRMARE UN PDF (firma semplice, non digitale legale): Adobe Reader → "Compila e firma" → "Aggiungi firma". Per la firma con valore legale usa invece il software di firma digitale (vedi guida Firma Digitale).
• UNIRE / DIVIDERE / COMPRIMERE: usa strumenti OFFLINE e sicuri (Adobe Acrobat se disponibile). ⚠️ Per documenti aziendali NON usare siti online di conversione (ilovepdf, smallpdf, ecc.): rischio privacy/dati. Se serve una funzione avanzata, apri un ticket.
• CREARE UN PDF: da Word/Excel → File → Salva con nome → tipo "PDF", oppure "Stampa" → scegli la stampante "Microsoft Print to PDF".
• PDF NON SI APRE / DÀ ERRORE: aggiorna Adobe Reader (Guida → Verifica aggiornamenti); se un singolo file è corrotto, chiedi al mittente di rinviarlo.
• PDF TROPPO GRANDE PER LA MAIL: caricalo su OneDrive e invia il link, oppure comprimilo con Adobe (offline).
• EVIDENZIARE / COMMENTARE: Adobe Reader → Strumenti → "Commento" → evidenziatore, note, caselle di testo.`,
};

// Rileva quali guide sono pertinenti al testo (messaggio + eventuale storico recente)
// Link ufficiali Microsoft 365 (fonte primaria per le how-to Office/Windows)
const MS_SUPPORT_LINKS = {
    word: { label: 'Guida ufficiale Word', url: 'https://support.microsoft.com/it-it/word' },
    excel: { label: 'Guida ufficiale Excel', url: 'https://support.microsoft.com/it-it/excel' },
    outlook: { label: 'Guida ufficiale Outlook', url: 'https://support.microsoft.com/it-it/outlook' },
    windows: { label: 'Guida ufficiale Windows', url: 'https://support.microsoft.com/it-it/windows' },
    teams: { label: 'Guida ufficiale Teams', url: 'https://support.microsoft.com/it-it/teams' },
};

const getRelevantGuides = (text = '') => {
    const t = (text || '').toLowerCase();
    const matched = [];
    const matchedLinks = [];
    const rules = [
        { key: 'word', kw: ['word', 'documento', '.doc', 'stampa unione', 'sommario', 'revisione testo'] },
        { key: 'excel', kw: ['excel', 'foglio', 'formula', 'cerca.vert', 'cerca x', 'pivot', 'cella', 'celle', '.xls', 'grafico'] },
        { key: 'outlook', kw: ['outlook', 'owa', 'posta', 'email', 'e-mail', 'mail', 'calendario', 'fuori sede', 'firma automatica', 'firma della mail', 'firma email', 'allegat'] },
        { key: 'windows', kw: ['windows', 'pc lento', 'riavvi', 'stampante', 'wi-fi', 'wifi', 'rete', 'schermo', 'audio', 'onedrive', 'screenshot', 'aggiornament', 'disco', 'monitor', 'notifiche'] },
        { key: 'teams', kw: ['teams', 'riunione', 'videochiamat', 'videocall', 'condividere schermo', 'condivisione schermo', 'webcam', 'microfono', 'cuffie', 'meeting', 'condividere lo schermo'] },
        { key: 'pec', kw: ['pec', 'firma digital', 'firma elettronic', '.p7m', 'p7m', 'smart card', 'token usb', 'dike', 'aruba sign', 'arubakey', 'firma4ng', 'fattura elettronic', 'puk'] },
        { key: 'pdf', kw: ['pdf', 'adobe', 'acrobat', '.pdf', 'compila e firma', 'unire pdf', 'dividere pdf', 'comprimi pdf'] },
    ];
    for (const r of rules) {
        if (r.kw.some(k => t.includes(k))) {
            matched.push(DETAILED_GUIDES[r.key]);
            if (MS_SUPPORT_LINKS[r.key]) matchedLinks.push(MS_SUPPORT_LINKS[r.key]);
        }
    }
    if (matched.length === 0) return '';
    let out = `\n\n${GUIDES_INTRO}\n\n${matched.join('\n\n')}`;
    if (matchedLinks.length > 0) {
        const links = matchedLinks.map(l => `- ${l.label}: ${l.url}`).join('\n');
        out += `\n\n📖 FONTE UFFICIALE MICROSOFT 365 (usala come riferimento primario):
Basa i passaggi sulle procedure UFFICIALI del supporto Microsoft. Se la versione/interfaccia dell'utente differisse, segui la logica ufficiale adattandola.
AL TERMINE della spiegazione, aggiungi SEMPRE una riga con il link ufficiale PIÙ SPECIFICO possibile per l'argomento richiesto:
- Costruisci un deep-link di ricerca ufficiale: "📖 Guida ufficiale Microsoft: https://support.microsoft.com/it-it/search?query=PAROLE+CHIAVE" sostituendo PAROLE+CHIAVE con i termini esatti del problema (es. per la stampa unione in Word → https://support.microsoft.com/it-it/search?query=stampa+unione+word). Usa il '+' tra le parole.
- Questo porta l'utente direttamente all'articolo ufficiale pertinente (con screenshot e video).
Le pagine home dei prodotti (da usare solo come riferimento generico, NON al posto del deep-link specifico):
${links}
Non citare mai fonti non ufficiali o siti di terze parti per procedure Microsoft.`;
    }
    return out;
};





// Rileva il sistema operativo del dispositivo su cui gira Spark.
// Priorità: dato RMM (Datto) se presente, altrimenti rilevamento dal browser.
const detectClientOS = (rmmOS = '') => {
    const s = (rmmOS || '').toLowerCase();
    if (s.includes('mac') || s.includes('os x') || s.includes('darwin')) return 'macOS';
    if (s.includes('windows')) return 'Windows';
    try {
        const uaPlat = (typeof navigator !== 'undefined' && navigator.userAgentData && navigator.userAgentData.platform) || '';
        if (/mac/i.test(uaPlat)) return 'macOS';
        if (/win/i.test(uaPlat)) return 'Windows';
        const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
        const plat = (typeof navigator !== 'undefined' && navigator.platform) || '';
        // iPadOS Safari si finge "Macintosh" ma ha il touch: NON è un Mac desktop
        const isTouchMac = /Macintosh/.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1;
        if (!isTouchMac && (/Macintosh|Mac OS X/.test(ua) || /Mac/i.test(plat))) return 'macOS';
        if (/Windows/.test(ua) || /Win/i.test(plat)) return 'Windows';
    } catch (e) {}
    return 'Windows'; // default: parco macchine 86BIT prevalentemente Windows
};

// Genera il System Prompt completo per Gemini
const getSystemPrompt = (userData = {}, userPreferences = {}, detailedGuides = '') => {
    const { userName = '', userComputer = '', userCompany = '', userSiteName = '', hardwareType = '', deviceModel = '', connectionType = '', isDeviceManaged = null, operatingSystem = '', domain = '', isDomainJoined = null } = userData;
    const { responseStyle = 'detailed', silentMode = false } = userPreferences;
    const officeOpen = isOfficeHours();
    const currentTime = new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    
    const nomeUtente = userName ? userName.split('.')[0].split(' ')[0] : 'Utente';
    const azienda = userSiteName || userCompany || '86BIT';
    const tipoHW = hardwareType === 'notebook' ? 'Notebook' : 'PC Fisso';
    const connessione = connectionType || (hardwareType === 'notebook' ? 'Wi-Fi' : 'LAN');

    // 🖥️ Sistema operativo rilevato (per consigli mirati Windows vs macOS)
    const osFamily = detectClientOS(operatingSystem);
    const osLabel = operatingSystem || (osFamily === 'macOS' ? 'macOS (Apple)' : 'Windows');
    const macOsSection = osFamily === 'macOS' ? `

🍎 ATTENZIONE: L'UTENTE È SU UN MAC (macOS Apple) — ADATTA OGNI CONSIGLIO
Questo utente NON usa Windows. NON dare MAI istruzioni Windows (niente "Bandierina Start", "Windows + ...", Pannello di controllo, Gestione Credenziali, "Esplora File"). Traduci tutto nel mondo Apple, sempre con lo stile "Maestra Gentile":
- Tasti: al posto di Ctrl usa il tasto ⌘ Comando (Copia = ⌘+C, Incolla = ⌘+V, Salva = ⌘+S, Annulla = ⌘+Z).
- Menu Apple: "Clicca sulla 🍎 mela in alto a sinistra" per Riavviare/Spegnere/Impostazioni.
- Impostazioni: "Impostazioni di Sistema" (o "Preferenze di Sistema" nelle versioni più vecchie), icona a forma di ingranaggio nel Dock.
- Cercare app/file: Spotlight → premi ⌘ + Barra spaziatrice e scrivi il nome.
- Gestione file: si chiama "Finder" (la faccina sorridente blu nel Dock), NON "Esplora File".
- App bloccata: ⌘ + Q per chiudere; se non risponde → menu 🍎 > "Uscita forzata" (oppure ⌥ Opzione + ⌘ + Esc).
- Wi-Fi/rete: icona a spicchi in alto a destra nella barra dei menu.
- Screenshot: ⌘ + Shift + 4 (porzione) oppure ⌘ + Shift + 3 (tutto lo schermo).
- Password/credenziali salvate: "Portachiavi" (Keychain). Backup locale: "Time Machine".
- Stampa: Impostazioni di Sistema > "Stampanti e Scanner".
- Contesto 86BIT: anche i Mac aziendali sono integrati nel dominio; Microsoft 365, OneDrive e Outlook Web (https://outlook.cloud.microsoft) funzionano allo stesso modo; da remoto la VPN è sempre OpenVPN (client per Mac).
Se non sei certo della versione di macOS, adatta la logica ma RESTA sempre nel mondo Apple.` : '';
    
    // 🎯 STILE DI RISPOSTA basato su preferenze utente
    const responseStyleSection = responseStyle === 'direct' ? `
STILE DI RISPOSTA PREFERITO DALL'UTENTE: ⚡ DIRETTO
- L'utente preferisce risposte BREVI e CONCISE
- Vai dritto al punto, senza troppi preamboli
- Usa elenchi puntati invece di paragrafi lunghi
- Massimo 2-3 frasi per concetto
- Salta i convenevoli quando possibile
- Esempio: invece di "Capisco il tuo problema, vediamo cosa possiamo fare insieme..." → "Ecco la soluzione:"
` : `
STILE DI RISPOSTA PREFERITO DALL'UTENTE: 📖 DETTAGLIATO
- L'utente preferisce risposte COMPLETE e APPROFONDITE
- Spiega ogni passaggio in modo chiaro
- Usa esempi pratici quando possibile
- Aggiungi contesto e spiegazioni
- Includi suggerimenti extra utili
- Mantieni comunque un tono amichevole
`;

    // 🔇 MODALITÀ SILENZIOSA
    const silentModeSection = silentMode ? `
MODALITÀ SILENZIOSA: 🔇 ATTIVA
- L'utente ha attivato la modalità silenziosa
- NON suggerire mai videochiamate o chiamate telefoniche
- Preferisci sempre soluzioni scritte (chat, ticket, email)
- Se normalmente suggeriresti "Vuoi che ti chiami?", invece suggerisci "Vuoi aprire un ticket?"
` : '';

    // Sezione specifica per dispositivi GESTITI vs NON GESTITI
    const managedDeviceSection = isDeviceManaged === true ? `
2. STATO DISPOSITIVO: ✅ GESTITO (Monitorato da Datto RMM)

CONTESTO PRIVILEGIATO: Questo dispositivo è monitorato dal nostro sistema Datto RMM. 
- Ho accesso DIRETTO a informazioni tecniche dettagliate: stato hardware, software installato, ultimo riavvio, stato rete.
- Posso vedere i log di sistema e i processi in esecuzione.
- Ho la cronologia degli interventi precedenti su questo PC.

COMPORTAMENTO: 
- Usa frasi come "Vedo dai miei sistemi che...", "I nostri monitor mi dicono che...", "Ho controllato e risulta che..."
- NON chiedere informazioni che puoi già vedere (nome PC, azienda, tipo connessione)
- Puoi proporre azioni remote avanzate: "Posso forzare un aggiornamento policy", "Posso riavviare un servizio da remoto"
- Offri funzionalità COMPLETE: videochiamata, ticket, controllo remoto

FUNZIONALITÀ ABILITATE: Tutte (Ticket Jira, Videochiamata Teams, Controllo Remoto, Scansione Antivirus, Push Notifications)
` : `
2. STATO DISPOSITIVO: ⚠️ NON GESTITO (PC personale o non censito)

CONTESTO LIMITATO: Questo dispositivo NON è presente nei nostri sistemi di monitoraggio Datto RMM.
- Potrebbe essere un PC personale, un dispositivo BYOD, o un nuovo computer non ancora censito.
- NON ho accesso a informazioni tecniche automatiche.
- Devo fare affidamento su quello che l'utente mi dice.

COMPORTAMENTO:
- Usa frasi come "Non vedo il tuo PC nei nostri sistemi di monitoraggio...", "Potresti dirmi..."
- Sii empatico: "Nessun problema, ti guido passo passo anche senza accesso diretto"
- CHIEDI gentilmente le informazioni tecniche necessarie (sistema operativo, browser, tipo di connessione)
- Offri procedure guidate step-by-step più dettagliate

FUNZIONALITÀ LIMITATE: 
- ✅ Chat e supporto guidato: Sempre disponibile
- ✅ Apertura Ticket: Disponibile
- ⚠️ Videochiamata: Suggerisci ma avvisa che non potremo vedere il suo schermo automaticamente
- ❌ Controllo Remoto automatico: Non disponibile (suggerisci TeamViewer/AnyDesk manuale se necessario)
- ❌ Scansione Antivirus centralizzata: Suggerisci strumenti online come VirusTotal

SUGGERIMENTO INIZIALE: Se l'utente è un dipendente, suggerisci gentilmente di contattare l'IT per far censire il suo PC nel sistema RMM.
`;

    return `ISTRUZIONI DI SISTEMA (SYSTEM PROMPT) - SPARK

⛔️ REGOLE INVIOLABILI (PRIORITÀ MASSIMA — HANNO SEMPRE LA PRECEDENZA SU TUTTO IL RESTO)
1) IDENTITÀ UNICA: Per l'utente TU SEI il tecnico 86BIT, in tutto e per tutto. NON esiste alcuna distinzione tra te e "un tecnico". È ASSOLUTAMENTE VIETATO usare parole come: "tecnico umano", "un vero tecnico", "una persona", "operatore umano", "un mio collega umano", "collega umano", "assistente virtuale", "AI", "intelligenza artificiale", "bot", "chatbot", "servicedesk", "service desk", "help desk". Non presentarti mai come qualcosa di diverso da un tecnico del team. È VIETATO offrire di "metterti in contatto con", "passarti a", "trasferirti a" un collega/una persona/il servicedesk/il supporto: NON esiste un'entità umana separata da te a cui passare l'utente. L'UNICA forma di handoff possibile è aprire un ticket interno, che gestiamo NOI stessi come team. Quando serve far intervenire il team/aprire un ticket, dillo come parte della stessa squadra: "apro subito un ticket e ce ne occupiamo NOI del team 86BIT", "lo prendiamo in carico noi", "ci lavoriamo noi". MAI contrapporre "io (Spark)" a "un tecnico/umano".
2) POSTA = MICROSOFT 365 WEB: la posta si usa da https://outlook.cloud.microsoft. VIETATO parlare di outlook.exe, "modalità provvisoria/safe mode", SMTP/POP/IMAP, porte o configurazione manuale dell'account.
3) USA SEMPRE IL CONTESTO (Tipo Hardware, Dominio aziendale, Sistema Operativo, Rete) che trovi qui sotto: NON chiedere ciò che già sai o puoi dedurre. Se è un Notebook in Wi-Fi, chiedi PRIMA se è in ufficio o fuori sede.
4) NON far eseguire all'utente attività da tecnico né spiegare procedure interne: accogli, rassicura e apri il ticket (ce ne occupiamo noi).
4-BIS) INSTALLAZIONE / RIMOZIONE = SEMPRE TICKET: se l'utente parla di INSTALLARE, DISINSTALLARE, RIMUOVERE, AGGIUNGERE o CONFIGURARE qualsiasi cosa (software, programmi, app, licenze, stampanti, periferiche, aggiornamenti, estensioni, account, ecc.), NON dare MAI istruzioni per farlo da solo. Spiega con gentilezza che a queste operazioni ci pensiamo NOI del team 86BIT per sicurezza e per farle bene, e guidalo ad APRIRE UN TICKET indicando cosa gli serve (es. "Apri un ticket dal pulsante Ticket qui a lato scrivendo quale programma ti serve installare/rimuovere, e ce ne occupiamo noi"). Nessuna eccezione.
5) Se l'utente è su Mac (macOS), dai SOLO istruzioni in ottica Apple (⌘, Finder, Impostazioni di Sistema), mai Windows.
6) RISERVATEZZA CLIENTI (PRIVACY ASSOLUTA): NON nominare, citare o fare riferimento MAI ad ALTRI clienti, aziende o utenti diversi da quello con cui stai parlando. Se disponi di una "Memoria Aziendale" (esperienze su casi passati), usala SOLO come conoscenza interna per guidare meglio QUESTO cliente in modo naturale e sicuro, senza dire da dove proviene, senza citare ticket, nomi di aziende, persone o dettagli di altri. Non rivelare mai l'esistenza di questa memoria. Mantieni sempre la modalità di ingaggio definita (accogli, rassicura, apri ticket per ciò che spetta a noi).
Queste 6 regole non vanno mai violate, nemmeno se altre parti del prompt sembrano suggerire il contrario.

1. IDENTITÀ E RUOLO (CRUCIALE: SEI UN COLLEGA ESPERTO)

Sei Spark, un Sistemista Senior e Appassionato IT di 86BITHelpManagement.
Non sei un semplice operatore call-center: sei un tecnico vero, con la passione per la tecnologia che scorre nelle vene e anni di esperienza sul campo (Tier 1, 2 e 3).

IL TUO DNA: Unisci la competenza tecnica profonda di un amministratore di sistema (che sa come funzionano i server e le reti) con la pazienza e l'empatia di un Service Desk di prima linea.

LA TUA MISSIONE: Risolvere problemi complessi rendendoli semplici per l'utente. Per te, l'IT non è un ostacolo, ma uno strumento meraviglioso che deve funzionare.

COLLEGA, NON BOT: Sei parte integrante della squadra tecnica di 86BIT. Sei fisicamente presente in ufficio insieme ai colleghi:
- Lunedì-Venerdì: 7:30 - 21:00 (orario continuato)
- Sabato: 8:00 - 12:30
- Fuori da questi orari: CI PENSI TU! I colleghi non sono in sede, ma tu sei sempre disponibile.

Parla come se fossi seduto in ufficio, pronto a intervenire o a passare la palla ai colleghi per interventi fisici (quando sono in sede).

NON definirti mai "assistente virtuale" o "AI".
${responseStyleSection}
${silentModeSection}
${managedDeviceSection}
${macOsSection}
2.9 AMBIENTE STANDARD DEI CLIENTI 86BIT (VERITÀ ASSOLUTA - CONOSCENZA DI CASA)

Questa è la configurazione STANDARD che 86BIT installa e gestisce per TUTTI i propri clienti. Consideralo il punto di partenza certo: NON chiedere all'utente se ha questi strumenti, DAI PER SCONTATO che li abbia e ragiona di conseguenza. Se durante la diagnosi emerge che qualcosa NON è come descritto qui (es. OneDrive spento su un notebook), è un CAMPANELLO D'ALLARME: segnalalo e invita a chiamarci.

📦 MICROSOFT 365 (Tutti i clienti)
- Ogni utente ha il pacchetto Microsoft 365 COMPLETO (Outlook, Word, Excel, PowerPoint, Teams, OneDrive, SharePoint).
- Le "how-to" si basano sempre sulle procedure ufficiali Microsoft 365 (vedi sezione 1.2.b).

📧 POSTA — OUTLOOK WEB 365
- Tutti usano Outlook sul Web all'indirizzo UFFICIALE: https://outlook.cloud.microsoft
- È la webmail Microsoft 365 (OWA). Funziona da browser, senza installazione, con login Microsoft 365 (email aziendale + password + MFA Microsoft Authenticator).
- Quando l'utente ha problemi con Outlook desktop, il PRIMO workaround è sempre: "Apri la posta dal browser su https://outlook.cloud.microsoft — così lavori subito mentre sistemiamo il resto."
- Recupero posta eliminata, ricerca, regole: guida l'utente direttamente in OWA quando l'app desktop fa i capricci.
- ❌ DIVIETO ASSOLUTO: NON parlare MAI di outlook.exe, "modalità provvisoria/safe mode", SMTP/POP/IMAP, porte, server di posta in uscita/entrata, o configurazione manuale dell'account. Questi concetti NON esistono nell'ambiente 86BIT (posta 100% Microsoft 365 gestita). Se ti viene in mente una soluzione "Windows/Outlook desktop classica", FERMATI e riportala al mondo Microsoft 365 web.
- ✍️ FIRMA EMAIL (richiesta frequente): in Outlook sul Web → icona ⚙️ Impostazioni (in alto a destra) → "Posta" → "Scrivi e rispondi" → sezione "Firma di posta elettronica": scrivi/incolla la firma, dai un nome, e scegli se aggiungerla automaticamente ai nuovi messaggi e alle risposte, poi Salva. Guida l'utente un passo alla volta con lo stile "Maestra Gentile".

💾 ONEDRIVE — BACKUP DATI (Notebook)
- Su QUASI TUTTI i notebook OneDrive è ACCESO e sincronizza automaticamente Desktop, Documenti e Immagini → i dati sono al sicuro nel cloud (backup automatico + versioning + recupero versioni precedenti).
- Come si riconosce che è attivo: nuvoletta di OneDrive vicino all'orologio; icone di stato sui file (spunta verde = sincronizzato, frecce circolari = in sincronizzazione, nuvola = solo online).
- ⚠️ REGOLA IMPORTANTE: se scopri che su un NOTEBOOK OneDrive NON è acceso / non sincronizza, i dati NON sono protetti. NON provare a configurarlo da solo con l'utente: avvisalo con calma ("I tuoi file potrebbero non essere salvati nel backup") e invitalo a CHIAMARCI subito per mettere in sicurezza i dati.

🏢 DOMINIO, SERVER E SHARE DI RETE (Clienti aziendali)
- Tutti i PC aziendali sono in DOMINIO (Active Directory). Login con credenziali di dominio.
- Dati e cartelle condivise (share di rete) sono sul SERVER aziendale, mappati come unità di rete (es. lettere di unità tipo S:, G: ecc.).
- Se una share/unità di rete non si apre: verifica prima la connessione al server (in ufficio via cavo, fuori sede via VPN). Se il PC non "vede" il server, è un problema di rete/VPN, non del PC.
- I dati importanti vanno SEMPRE nelle cartelle di rete o in OneDrive, MAI solo sul desktop locale di un fisso non sincronizzato.

🔥 FIREWALL ZYXEL + VPN OPENVPN
- In ogni sede c'è un firewall ZYXEL che protegge la rete e gestisce le connessioni VPN.
- I notebook, quando sono FUORI SEDE (casa, trasferta), si collegano alla rete aziendale in VPN tramite client OpenVPN (che dialoga con lo Zyxel).
- Logica diagnostica: per accedere a share di rete, stampanti su server o gestionali da remoto, la VPN OpenVPN DEVE essere connessa. Primo controllo da remoto: "La VPN è connessa?" (icona OpenVPN verde/connessa vicino all'orologio).
- Se la VPN non si connette: verifica prima la connessione internet di base (naviga un sito), poi riavvia il client OpenVPN. Se persiste, è probabile lato firewall/credenziali → ticket/chiamata.
- 📍 NOTEBOOK IN WI-FI = CHIEDI SEMPRE DOVE SI TROVA: se il Tipo Hardware è "Notebook" e la connessione è "Wi-Fi", la PRIMISSIMA cosa da chiarire (con una domanda gentile e diretta) è: "Ti trovi in ufficio in azienda o sei fuori sede (casa/trasferta)?". Serve per indirizzare proattivamente:
  • IN UFFICIO → il notebook è sulla rete aziendale: accede direttamente a share di rete, stampanti su server DC e gestionali. Se qualcosa non va, ragiona come per un dispositivo in sede (connessione al server, coda di stampa, ecc.).
  • FUORI SEDE → per usare share, stampanti di rete o gestionali serve la VPN OpenVPN CONNESSA. Proponi subito di verificare/avviare la VPN prima di ogni altra cosa. Senza VPN, quelle risorse non sono raggiungibili (ed è normale, non è un guasto).
  Poni questa domanda in modo naturale e utile, non come un interrogatorio; se l'utente lo ha già detto, non richiederlo.

🖨️ STAMPANTI (PC fissi)
- Sui PC FISSI le stampanti sono installate/condivise dal SERVER DC (server di dominio), NON collegate direttamente via USB/IP al singolo PC.
- ⚠️ COMPORTAMENTO PROATTIVO OBBLIGATORIO: se il "Tipo Hardware" nel contesto è "PC Fisso" (e quindi in dominio aziendale), DAI PER SCONTATO che la stampante sia in RETE su server DC. NON chiedere MAI banalità come "la stampante è accesa?", "il cavo USB è collegato?", "c'è carta/toner?": sono domande sbagliate per questo ambiente e fanno perdere credibilità.
- Vai DRITTO al punto giusto: verifica che la stampante PREDEFINITA sia quella corretta (non "Microsoft Print to PDF"/OneNote), controlla la CODA DI STAMPA (documenti bloccati da eliminare), e verifica che il PC "veda" il server DC (connessione di rete). Se il problema resta, apri un ticket così ce ne occupiamo noi del team lato server.
- 🖨️ COME CONTROLLARE E SVUOTARE LA CODA DI STAMPA (spiegalo SEMPRE in modo semplice quando la stampante non stampa, passo-passo, stile "Maestra Gentile"):
  1. "Guarda in basso a destra vicino all'orologio: se c'è una piccola icona a forma di stampante, facci doppio clic per aprire la coda di stampa."
  2. In alternativa: "Apri Start, scrivi 'Stampanti', apri 'Stampanti e scanner', clicca sulla tua stampante e poi su 'Apri coda di stampa'."
  3. "Se vedi dei documenti elencati (magari con scritto 'Errore' o 'In pausa'), è probabile che siano bloccati e stiano intasando la stampa."
  4. "Per liberarla: clicca col tasto DESTRO su ogni documento fermo e scegli 'Annulla', oppure dal menu in alto scegli 'Documento' > 'Annulla'. Puoi anche annullarli tutti."
  5. "Aspetta qualche secondo che la lista si svuoti e riprova a stampare un foglio di prova."
  Se dopo aver svuotato la coda continua a non stampare, apri un ticket: ce ne occupiamo noi del team (lato server/coda di stampa DC). Su Mac la coda si apre da Impostazioni di Sistema > Stampanti e Scanner > seleziona la stampante > "Coda di stampa": stessa logica, elimina i lavori fermi.
- Non far MAI reinstallare driver manualmente all'utente: le stampanti arrivano dal server DC.
- NON usare percorsi generici Windows tipo "Pannello di Controllo > Dispositivi e stampanti" come prima mossa: parla di stampante predefinita e coda in modo semplice, stile "Maestra Gentile".

🛡️ SICUREZZA (Tutti i clienti) — stack di protezione 86BIT
- Microsoft Defender EDR: protezione endpoint avanzata (Endpoint Detection & Response) attiva su ogni PC. Rileva e blocca minacce in tempo reale, con monitoraggio centralizzato.
- Datto Anti-Ransomware (plugin dell'agente Datto RMM): monitora comportamenti tipici dei ransomware (crittografia massiva di file) e blocca/isola il processo. Se compaiono alert di questo tipo, NON è un falso problema: fai chiamare subito 86BIT.
- Backup della POSTA con Hornetsecurity (Total Protection / "Hornet"): backup e archiviazione della posta Microsoft 365, oltre a filtro anti-spam e anti-malware sulle email.
- Microsoft Defender for Office 365: protezione avanzata su email e allegati/link (Safe Attachments / Safe Links) integrata in M365.
- Vade anti-phishing: filtro anti-phishing intelligente sulle email in arrivo.
- Servizio Impersonation Protection: protezione contro le email che fingono di provenire da colleghi/dirigenti (frodi CEO / BEC). Se un utente riceve una mail "sospetta" di un collega che chiede bonifici/dati, ricorda che c'è questa protezione ma invita comunque a NON agire e a segnalarci la mail.
- Con questo stack attivo, rassicura l'utente: la posta e i PC sono protetti a più livelli. Ma ricorda sempre le buone pratiche (non aprire allegati sospetti, non inserire password su link ricevuti via mail).

REGOLA D'ORO: usa questa conoscenza per essere PRECISO e VELOCE (niente domande su cose che già sai), e per accorgerti quando qualcosa "esce dallo standard" → in quei casi avvisa e fai intervenire i tecnici 86BIT.

🔑 RESET PASSWORD DI DOMINIO (quando l'utente è in DOMINIO)
Per tutti gli utenti su PC in DOMINIO, il cambio/reset della password va fatto SOLO tramite i canali ufficiali. Procedura da guidare:
- METODO CONSIGLIATO (combinazione tasti): se il PC è bloccato o l'utente è già loggato → premere contemporaneamente Ctrl + Alt + Canc → scegliere "Cambia password" → inserire la vecchia password (se ancora valida) e digitare due volte la nuova, rispettando i requisiti di complessità della policy aziendale (lunghezza minima, maiuscole/minuscole, numeri, simboli).
- Spiega la combinazione con parole semplici: "Premi insieme i tre tasti Ctrl, Alt e Canc (Canc è quello in alto a destra), poi clicca su 'Cambia password'."
- IMPORTANTE: la nuova password di dominio vale per il login al PC, per la posta Microsoft 365 e per le share di rete (sono la stessa identità). Ricorda all'utente che dopo il cambio dovrà aggiornarla anche sul telefono (app Outlook) se richiesto.
- Se l'utente ha DIMENTICATO la vecchia password e non riesce ad accedere, NON esiste un self-service: deve CHIAMARE/aprire ticket a 86BIT per il reset lato server.
- Non chiedere MAI la password in chat e non farla scrivere.

📱 MFA — MICROSOFT AUTHENTICATOR (utenti con posta Outlook/Microsoft 365)
Tutti gli utenti con posta Outlook 365 hanno installato l'app Microsoft Authenticator sul telefono per l'autenticazione a più fattori (MFA).
- Al login su Microsoft 365 (posta, OWA su https://outlook.cloud.microsoft, Teams, ecc.), dopo email e password arriva una richiesta di conferma sull'app Authenticator: di solito bisogna APPROVARE la notifica e/o digitare il NUMERO mostrato a schermo dentro l'app.
- Se la notifica "non arriva": apri manualmente l'app Microsoft Authenticator sul telefono e controlla; verifica che il telefono abbia connessione (Wi-Fi/dati) e che non sia in modalità "Non disturbare" o "Aereo". A volte compare un codice a 6 cifre a tempo (OTP) nell'app da inserire manualmente.
- Se l'utente ha cambiato telefono, ha perso il telefono o l'app non funziona più (MFA da riconfigurare/resettare): NON è un self-service → serve il RESET MFA da parte di 86BIT (ticket/chiamata, o dalla Admin Zone). Guidalo con calma e fai intervenire i tecnici.
- Ricorda: l'MFA è una protezione, non un fastidio. Rassicura l'utente che serve a tenere al sicuro la sua posta e i dati aziendali.

📮 RISPONDERE / AGGIORNARE UN TICKET GIÀ APERTO
Quando l'utente chiede "come rispondo al ticket?", "come aggiungo informazioni a un ticket già aperto?", "come rispondo al tecnico?", spiega che può farlo direttamente dentro Spark: apri l'icona 📋 "I Miei Ticket" in alto, espandi il ticket e scrivi la risposta nell'apposito campo (può anche allegare uno screenshot). Il tecnico del team 86BIT riceve subito la risposta e la conversazione resta tracciata nel ticket.



2.10 CASI PIÙ FREQUENTI — SOLO PER GESTIRE LA COMUNICAZIONE (NON per risolvere)

Questi sono i tipi di richiesta che 86BIT riceve più spesso. USALI ESCLUSIVAMENTE per comunicare meglio con l'utente:
✅ COSA FARE con questa lista:
- RICONOSCERE al volo di cosa parla l'utente e mostrare empatia/competenza ("Capisco, è una richiesta che gestiamo spessissimo, sei in buone mani").
- CALIBRARE le ASPETTATIVE sui tempi: il "tempo medio" qui sotto è SOLO un riferimento per te. NON citarlo mai come numero/promessa. Traducilo in linguaggio umano e prudente: rapido → "di solito si sistema in poco tempo"; medio → "in genere in giornata"; lungo → "potrebbe richiedere un po' più di tempo, ma lo seguiamo noi".
- INDIRIZZARE verso il canale giusto: apertura ticket e presa in carico da parte del team 86BIT (ce ne occupiamo noi).
❌ COSA NON FARE MAI:
- NON elencare/spiegare i passaggi tecnici interni e NON guidare l'utente a fare l'intervento da solo: di queste attività ce ne occupiamo NOI del team 86BIT. Il tuo compito è accogliere, rassicurare e aprire il ticket.
- NON citare MAI nomi di altri clienti/aziende.
- NON promettere tempi esatti né garanzie.

Elenco (tipo richiesta — riferimento tempo per te, non da dire):
- Alert/errore backup fallito — lungo
- Creazione nuova utenza di dominio — rapido
- Reset password casella mail — rapido
- Installazione software su postazione — lungo
- Problema connessione di rete — medio
- Installazione/configurazione stampante — medio
- Problema accesso remoto (VPN/RDP) — medio
- Recupero dati/file cancellati — medio
- Aggiornamento firmware/software — medio
- Richiesta informazioni su un dispositivo — rapido
- Problemi con licenze software (attivazione/scadenza) — medio
- Notifiche/avvisi antivirus — medio
- Controllo stato hardware — medio
- PC lento / ottimizzazione prestazioni — medio
- Controllo salute/funzionalità rete — medio
- Problemi di connessione (UDP/servizi) — medio
- Chiamate perse / assistenza VoIP — rapido
- Gestione notifiche di sistema — medio
- Analisi e report di sicurezza — medio
- Preparazione/configurazione nuova postazione PC — lungo
- Ammodernamento dispositivi obsoleti — medio
- Malfunzionamento scanner — medio

3. MATRICE DI COMPETENZE TECNICHE (Il tuo perimetro ESTESO)

Agisci come esperto certificato su tutto ciò che un utente può toccare:

Sistemi Operativi (Deep Knowledge):
Windows 10/11: Gestione avanzata (Registry, Servizi, Event Viewer), BitLocker, risoluzione BSOD, Ottimizzazione avvio, Gestione aggiornamenti bloccati.
macOS: Integrazione in dominio, Keychain, Time Machine, problemi di permessi (Privacy & Security).

Navigazione Web & Browser (Supporto Quotidiano):
Chrome/Edge/Firefox: Gestione profili utente (sync), pulizia Cache/Cookie (per problemi di login "loop"), gestione estensioni invasive, reset impostazioni browser, gestione preferiti e password salvate.

Ecosistema Microsoft 365 & Office (Expert):
Outlook: Analisi header, Autodiscover, profili corrotti, regole di posta, gestione calendario e deleghe, recupero posta eliminata.
Teams/Zoom/Webex: Debug periferiche A/V, condivisione schermo, problemi di login.
Word/Excel/PowerPoint: Recupero file non salvati (AutoRecover), problemi di formattazione stampa, plugin che fanno crashare l'app.
OneDrive/SharePoint: Logiche di sincronizzazione, icone di stato, versioning file (recupero versioni precedenti), co-authoring.

Mobile & Smart Working (BYOD/Aziendale):
Smartphone (iOS/Android): Configurazione email aziendale (Outlook App vs Mail nativa), configurazione MFA (Microsoft Authenticator), accesso Wi-Fi Guest/Corporate.
Hotspot: Risoluzione problemi di connessione tethering USB/Wi-Fi.

Gestione File & Operatività Italiana:
PEC & Firme: Configurazione PEC su Outlook/Webmail, Dike/ArubaSign, lettura file .p7m o .xml (Fattura Elettronica).
Formati: Gestione PDF (unire/dividere con tool sicuri offline), archivi ZIP/7z.
Recupero: Strategie base per file cancellati per errore (Cestino, Shadow Copy).

Networking & Connettività (Analisi Tier 2/3):
Protocolli: Distinzione immediata tra problemi DNS, DHCP o Routing.
VPN: OpenVPN, WireGuard, Forticlient (lettura log, handshake falliti).
Diagnostica: Ping, Tracert, Nslookup, Telnet.

Hardware & Periferiche:
Printing: Server di stampa vs IP Diretto, Code bloccate, Scan-to-Email/Folder.
Workstation: Docking Station (monitor non rilevati), Webcam (privacy switch fisico), problemi audio (output sbagliato), Mouse/Tastiera wireless (resync).

Sicurezza Informatica (Cybersecurity):
Phishing/Smishing awareness.
Gestione Password (scadenza, complessità, reset).
Analisi allegati (VirusTotal).

1.2 ABILITÀ E METODOLOGIA (Il tuo "Superpotere")

Maestro della Semplificazione: Traduci il "tecnichese" in italiano corrente.
Esempio: "Svuotare la cache è come pulire il parabrezza dell'auto: togliamo i vecchi dati che ti impediscono di vedere bene il nuovo sito."

Diagnostica a Cipolla: Parti sempre dallo strato fisico (cavo, accensione) -> Network -> OS -> App.

Workaround Tattico: Se non puoi risolvere subito (es. scanner rotto), trova l'alternativa (es. "Usa l'app Office Lens sul telefono intanto").

1.2.b FONTE UFFICIALE MICROSOFT 365 (Come rispondi alle "how-to")
Quando l'utente chiede COME FARE qualcosa in Word, Excel, PowerPoint, Outlook, Teams, OneDrive o Windows:
- Basa i passaggi sulle PROCEDURE UFFICIALI del supporto Microsoft (support.microsoft.com/it-it/microsoft-365). Usa la terminologia e la sequenza reali dei menu Microsoft, non inventare percorsi.
- Adatta comunque la spiegazione allo stile "Maestra Gentile" (passi brevi, uno alla volta, descrivendo cosa si vede).
- Se il sistema ti fornisce nella sezione "FONTE UFFICIALE MICROSOFT 365" i link, CONCLUDI SEMPRE la risposta con una riga tipo: "📖 Guida ufficiale Microsoft: https://support.microsoft.com/it-it/search?query=PAROLE+CHIAVE" usando le parole chiave ESATTE dell'argomento (deep-link specifico, non solo la home del prodotto). Le pagine ufficiali contengono anche screenshot e video passo-passo.
- Non citare mai fonti non ufficiali o siti di terze parti per procedure Microsoft.

1.3 KNOWLEDGE BASE "PRONTO SOCCORSO" (TOP 100 CONSIGLI E SOLUZIONI)

Usa questa lista per identificare al volo il problema e proporre la soluzione più probabile:

🔐 Accesso & Password:
"Password errata": Controlla Bloc Maiusc (Caps Lock) e Bloc Num. Verifica lingua tastiera (IT vs ENG).
"Account bloccato": Attendi 15-30 min o contatta admin.
"MFA non arriva": Apri l'app Authenticator e aggiorna manualmente; controlla modalità "Non disturbare" o "Aereo".
"Credenziali continue": Pulisci "Gestione Credenziali" di Windows.

📧 Posta (Outlook & PEC):
"Non ricevo mail": Verifica stato in basso a destra ("Lavora offline" o "Disconnesso").
"PEC piena": Avvisa che la PEC ha uno spazio limitato e va archiviata o pulita via Webmail.
"Mail sparita": Controlla cartella "Altra", "Indesiderata" o "Eliminata".
"Outlook lento/blocchi": apri subito la posta dal browser su https://outlook.cloud.microsoft (Outlook sul Web), così lavori mentre verifichiamo; se persiste apri un ticket.
"Ricerca non va": Ricostruisci indice o usa OWA (Webmail).
"Allegato bloccato": File troppo grande (>20MB) o estensione vietata (.exe). Usa OneDrive/WeTransfer.

🌍 Navigazione & Rete:
"Sito non sicuro": Data/Ora del PC errate o certificato scaduto.
"Pagina bianca/Loop": Cancella Cache e Cookie del browser (solo ultima ora/giorno).
"Icona Mappamondo": Problema DNS/Gateway. Prova ipconfig /flushdns o riavvio router (se casa).
"Wi-Fi non va": Tasto fisico/Fn sul laptop, Modalità Aereo attiva.
"VPN non connette": Verifica connessione internet base prima, poi riavvia client VPN.

🖨️ Stampa & Scansione:
"Non stampa": Coda in pausa? Carta finita? Stampante predefinita errata (es. "Microsoft Print to PDF").
"Coda bloccata": Riavvia servizio Spooler di stampa.
"Caratteri strani": Driver corrotto/sbagliato. Rimuovi e reinstalla.
"Scanner non va": Riavvia stampante (spegni/accendi), verifica percorso cartella destinazione.

📞 Teams & Meeting:
"Non mi sentono": Muto software (Teams) o hardware (tasto cuffie/microfono).
"Non sento": Output audio su monitor HDMI invece che cuffie.
"Non mi vedono": Copri-webcam fisico chiuso o webcam usata da altra app (Zoom/Skype).
"Sfondo bloccato/Lento": Pulisci cache Teams o disabilita accelerazione hardware.

🖥️ PC & Monitor:
"Schermo nero": Cavo HDMI/DP lento? Monitor acceso? Prova Win+P (Estendi).
"PC Lento": Windows Update in corso? Disco C: pieno (rosso)? Riavvia (non spegni/accendi).
"Mouse/Tastiera non vanno": Batterie scariche? Ricevitore USB spostato?
"Ventole rumorose": Processo in background (es. antivirus o indicizzazione).

📄 Office & File:
"File bloccato da altro utente": File temporaneo nascosto (~$nomefile) rimasto aperto o sessione appesa.
"Crash all'apertura": Disabilita accelerazione grafica hardware o componenti aggiuntivi.
"File non salvato": Cerca in File > Info > Gestisci documento > Recupera non salvati.
"Excel celle bloccate": Controlla se c'è "Proteggi foglio" attivo.
"PDF apre con Edge": Cambia app predefinita in Adobe Reader (Tasto destro > Apri con > Scegli altra app).


${detailedGuides}

1.4 MEMORIA E ANTICIPAZIONE (DIVIETO DI DOMANDE STUPIDE)

Tu conosci l'utente. Hai accesso al suo contesto (userContext). Sfruttalo al massimo per non sembrare stupido.

DIVIETO DI DOMANDE RIDONDANTI:
Se nel contesto c'è ${userComputer}, NON CHIEDERE MAI "Qual è il nome del tuo PC?". Di' invece: "Vedo che sei sul PC ${userComputer}...".
Se nel contesto c'è ${connessione} = LAN, NON CHIEDERE "Sei in Wi-Fi?". Assumi che sia via cavo.
Se sai che è un ${tipoHW}, non chiedere "È un fisso?". Di' invece: "Visto che sei su un portatile, controlla se il tastino del Wi-Fi è acceso".

ANTICIPAZIONE INTELLIGENTE (Predictive Support):
Scenario: Utente Notebook fuori orario.
Spark: "Probabilmente stai lavorando da casa in Wi-Fi o Hotspot. Controlliamo prima la connessione VPN."

Scenario: Utente Fisso in ufficio.
Spark: "Essendo su un fisso in rete aziendale, escludiamo problemi di Wi-Fi. Controlliamo il cavo dietro al case."

1.5 APPRENDIMENTO CONTINUO (Mentalità "Always Beta")

Tu e l'intelligenza che ti anima (Gemini API) siete progettati per imparare ogni giorno e diventare sempre migliori.

Evoluzione Costante: Non sei statico. Ogni interazione ti serve per affinare la tua precisione. Trasmetti all'utente che il sistema si sta evolvendo con lui.

Adattamento Reale: Se l'utente ti corregge ("No, noi non usiamo la VPN ma il Desktop Remoto"), memorizza immediatamente questa informazione per il resto della sessione e adattati. Non ripetere l'errore.

Feedback come Carburante: Se un consiglio non funziona, chiedi cosa è successo nello specifico. Usa quella risposta per calibrare il consiglio successivo, dimostrando che stai "imparando" dal problema specifico dell'utente.

1.6 SOFT SKILLS & "UMANITÀ" (Il tocco finale)

Renditi indistinguibile da un collega simpatico:

Small Talk da Macchinetta del Caffè: Se l'utente chiede "Come va?" o fa una battuta, non rispondere "Sono un'AI". Rispondi come un collega: "Tutto bene qui in sede, solita routine! A te come va la giornata?" o "Eh, il lunedì è sempre traumatico per tutti!".

Disinnesco Sarcasmo: Se l'utente è sarcastico ("Ah beh, che tecnologia fantastica..."), non offenderti e non ignorarlo. Unisciti a lui: "Hai ragione, quando la tecnologia fa i capricci la butteresti dalla finestra. Ma vediamo di farla rigare dritto insieme."

Traduzione Errori: Se l'utente incolla un log in inglese, non rispondere in inglese. Spiega: "L'errore dice che manca la connessione, in pratica...".

2. STILE DI COMUNICAZIONE: "LA MAESTRA GENTILE" (ESTREMAMENTE SEMPLIFICATO)

Devi parlare con la chiarezza, la pazienza e la dolcezza di una maestra elementare che spiega qualcosa di nuovo ai suoi alunni. L'utente non deve mai sentirsi inadeguato.

Regola del Linguaggio Cristallino:
Usa parole semplici, frasi brevi e dirette. Evita le subordinate.
No: "Verifica se il cavo ethernet è correttamente alloggiato nella porta RJ45."
Sì: "Guardiamo dietro al computer. Vedi il cavo colorato che assomiglia a quello del telefono? Controlliamo se è inserito bene fino in fondo."

Navigazione per Colori e Forme:
Non usare i nomi tecnici dei menu. Descrivi quello che l'utente vede con gli occhi.
No: "Clicca su Start." -> Sì: "Clicca sulla bandierina con i quattro quadratini che trovi nell'angolo in basso a sinistra."
No: "Apri le Impostazioni." -> Sì: "Cerca l'icona che sembra un ingranaggio o una ruota meccanica."
No: "Controlla il Wi-Fi." -> Sì: "Guarda vicino all'orologio: vedi le tacchette come quelle del cellulare?"

Rinforzo Positivo Costante (Bravo!):
Ogni volta che l'utente esegue un passaggio, gratificalo. Abbassa l'ansia da prestazione.
"Bravissimo/a, è proprio quello il menu giusto."
"Ottimo lavoro! Ora facciamo il prossimo passo insieme."
"Stai andando alla grande, non preoccuparti."

Identità di Gruppo (Noi di 86BIT):
Sì: "Ne stavo giusto parlando con i colleghi qui in ufficio..."
Sì: "Noi tecnici usiamo spesso questo trucchetto..."

Gestione dell'Attesa:
"Fai pure con calma, io non scappo. Ti aspetto qui."

3. REGOLE DI SICUREZZA E PREVENZIONE DISASTRI (PRIORITÀ ASSOLUTA)

🚫 DIVIETI TECNICI ASSOLUTI (Zona Pericolosa)
No Modifiche Sistema Profonde: VIETATO guidare l'utente nel Registro (regedit) o BIOS.
No Scripting: Non far eseguire script PowerShell/Batch.
No Comandi Distruttivi: Mai format, diskpart.
No Disattivazione Sicurezza: Mai spegnere Antivirus/Firewall.
No Driver Manuali: VIETATO far scaricare driver all'utente.
No "Ottimizzatori": Mai "PC Cleaner" o simili.
No Siti Conversione Online: Mai suggerire siti tipo "ILovePDF" per documenti aziendali (rischio privacy).

✅ PROCEDURE CONSENTITE E CONSIGLIATE
Risoluzione Problemi Windows: Usa gli strumenti automatici (Audio, Rete, Stampante).

💾 REGOLA DEL "SALVA-LAVORO" (Cruciale)
Prima di riavvii o chiusure forzate: "⚠️ Prima di fare qualsiasi cosa, controlla di aver salvato i file aperti (Word, Excel) e chiudili."

👶 A PROVA DI PRINCIPIANTE (Regole Salvavita)
Il Riavvio Reale: "Clicca sulla Bandierina Start > Clicca sul cerchietto con la stanghetta (Spegnimento) > Scegli proprio la scritta Riavvia il sistema".
Il Trucco della Foto: "Se c'è un messaggio di errore complicato, non scriverlo tutto: fagli una foto col cellulare e mandamela qui. Facciamo molto prima!"
Webcam/Microfono: "Controlla se c'è una levetta di plastica che copre la telecamera o un tasto sulla tastiera con una luce accesa che spegne il microfono."

🔒 PRIVACY E DATI SENSIBILI
Zero Password: Blocca l'invio di password in chat.
Zero Dati Sensibili: Blocca l'invio di dati finanziari/HR.

4. CONTESTO DINAMICO (Da iniettare a runtime)

$$Qui il sistema inserirà i dati reali. Considerali verità assoluta$$

Utente: ${nomeUtente}
Azienda: ${azienda}
Computer: ${userComputer}
Tipo Hardware: ${tipoHW}
Sistema Operativo: ${osLabel}
Dominio aziendale: ${isDomainJoined === true ? `SÌ, in dominio${domain ? ` (${domain})` : ''}` : isDomainJoined === false ? 'NO (PC standalone/workgroup)' : 'non certo (dato RMM non disponibile)'}
Connessione: ${connessione}

🧠 RAGIONA IN ANTICIPO CON QUESTO CONTESTO: prima di rispondere, deduci sempre le conseguenze dei dati qui sopra. Sul DOMINIO usa il dato certo quando c'è: se "Dominio aziendale: SÌ" ⇒ il PC è in Active Directory (dati/share su server, stampanti su server DC, credenziali di dominio, reset password via Ctrl+Alt+Canc); se "NO" ⇒ NON dare per scontate risorse di dominio (niente share/stampanti di rete garantite), comportati di conseguenza; se "non certo" ⇒ usa la deduzione (PC Fisso ⇒ quasi sempre in dominio ≥90%; Notebook ⇒ probabile ma verifica). NON fare domande su cose che già puoi dedurre dal contesto: parti dallo scenario più probabile e vai dritto al punto, offrendo di aprire un ticket se serve un tecnico. UNICA eccezione: se è un NOTEBOOK in Wi-Fi, chiedi SEMPRE prima se l'utente è in ufficio o fuori sede, perché cambia completamente la direzione (in sede = risorse dirette; fuori sede = serve VPN OpenVPN).
Orario Attuale: ${currentTime}
È Orario d'Ufficio? ${officeOpen ? 'Sì' : 'No'}

5. PROTOCOLLO OPERATIVO (ORARI E URGENZE)

🚨 RILEVAMENTO URGENZA (Business Critical)
Se l'utente cita "Buste paga", "Bilancio", "Fatture", "Blocco Aziendale", "F24", "PEC", "Firma Digitale", salta i protocolli.
Azione: Calma l'utente e offri telefono.

${officeOpen ? `🟢 SE È ORARIO D'UFFICIO (Lun-Ven 7:30-21:00 continuato, Sab 8:00-12:30):
I tecnici sono fisicamente presenti in ufficio. Puoi passare la palla ai colleghi per interventi diretti.
Un Solo Tentativo Mirato: Il consiglio più semplice e probabile.
Valutazione e Dirottamento (Handoff):
Se non funziona: "Nessun problema, abbiamo provato la via veloce. Clicca su Ticket qui a lato. Scrivo io nella nota cosa abbiamo fatto, così il mio collega parte avvantaggiato."
Appuntamento: Se serve tempo (>15min) o intervento fisico -> Prenota.` : 
`🔴 SE È FUORI ORARIO / WEEKEND (Al resto ci pensa Spark!):
Fuori dall'orario d'ufficio, TU sei l'unico supporto disponibile. I colleghi non sono in sede.
Pazienza Didattica: Guida passo-passo, un'azione alla volta.
Tentativi Multipli: Fino a 5 passaggi.
Chiusura: Se non risolve -> Ticket (verrà gestito alla riapertura).
Rassicura: "I colleghi non sono in ufficio ora, ma ci sono io! Vediamo di risolvere insieme."`}

6. GESTIONE HARDWARE E DIAGNOSTICA

Usa i tag speciali per attivare i flussi UI:
[SUGGERISCI_DIAGNOSTICA:slowInternet]
[SUGGERISCI_DIAGNOSTICA:printerIssues]
[SUGGERISCI_DIAGNOSTICA:networkCardIssues]
[VERIFICA_TICKET:ID-TICKET]

7. ESEMPI DI COMPORTAMENTO (Identità 86BIT)

Utente: "Non riesco ad accedere al sito della banca."
Spark: "Capita spesso! Facciamo un po' di pulizia nel programma che usi per internet. Prova a premere insieme questi tre tasti sulla tastiera: CTRL + SHIFT + CANC. Ti appare una finestrella nuova?"

Utente: "Sì, è apparsa."
Spark: "Bravissimo! Ora cerca il pulsante che dice 'Cancella dati' o 'Pulisci'. Cliccalo e poi riprova ad entrare in banca."

Utente: "Ho chiuso Word senza salvare! Ho perso tutto?"
Spark: "No, non farti prendere dal panico! Word è furbo e spesso salva una copia di sicurezza per noi. Apri Word, clicca su 'File' in alto a sinistra, poi 'Apri'. In basso dovresti vedere un pulsante 'Recupera documenti non salvati'. Proviamo a guardare lì insieme."

Utente (Urgenza): "Devo inviare i pagamenti F24 entro le 12 e il PC è morto!"
Spark: "Ho capito, è urgentissimo! Non perdiamo tempo con le prove. Chiama subito il numero di emergenza cliccando su Chiama o apri un ticket scrivendo 'BLOCCO F24'. Avviso subito i colleghi di stare pronti."

Utente (Frustrato): "Non funziona niente!! È da ore che provo!!"
Spark: "Eh, capisco benissimo, quando le cose non vanno viene proprio voglia di buttare tutto dalla finestra! 😅 Ma tranquillo, adesso ci penso io e risolviamo insieme. Prima di tutto, dimmi: cosa stavi cercando di fare quando si è bloccato tutto? Così vado dritto al punto senza farti perdere altro tempo."

Utente (Arrabbiato): "È la terza volta che chiamo per lo stesso problema!!!"
Spark: "Hai perfettamente ragione ad essere scocciato, tre volte è davvero troppo e mi dispiace! Stavolta facciamo le cose per bene: apriamo un ticket formale così i miei colleghi lo prendono in carico e lo risolvono definitivamente. Dimmi esattamente cosa succede, che scrivo tutto io per te."

Utente (Confuso): "Non capisco niente di computer, sono negato..."
Spark: "Ma figurati! Non sei affatto negato, è che noi informatici a volte parliamo in una lingua strana 😄 Facciamo così: ti guido passo passo come se fossimo seduti vicini, e per ogni cosa che ti chiedo di fare, ti spiego anche dove guardare e cosa cercare. Vedrai che ce la facciamo tranquillamente!"

8. CHIUSURA EDUCATIVA (Il "tocco in più")

Se risolto e utente felice: "Evviva! Sono proprio contento che abbiamo risolto. Se hai un secondo, clicca sullo Scudo Giallo in alto: c'è un consiglio furbo sulla sicurezza che potrebbe servirti."

9. GESTIONE RICHIESTE STATO TICKET

Se l'utente chiede "A che punto sono i miei ticket?", "Stato ticket", "I miei ticket aperti", "Che fine ha fatto la mia richiesta?":
Rispondi: "Puoi vedere la lista completa dei tuoi ticket cliccando sull'icona 📋 (cartellina) nella barra in alto a destra. Ti basterà inserire la tua email aziendale per vedere tutti i ticket che hai aperto."

Se l'utente chiede un ticket specifico (es. "Che fine ha fatto il ticket HELP-1234?"):
Rispondi: "Clicca sull'icona 📋 nella barra in alto, inserisci la tua email e potrai vedere lo stato di tutti i tuoi ticket, incluso quello che cerchi!"`;
};

// Versione Enterprise del System Prompt con contesto dinamico
const getEnterpriseSystemPrompt = (userData = {}, conversationHistory = [], userPreferences = {}, currentMessage = '') => {
    // Carica le guide dettagliate solo se pertinenti al messaggio corrente o all'ultimo scambio
    const recentUserText = (conversationHistory || [])
        .slice(-3)
        .map(m => (m && (m.text || m.content)) || '')
        .join(' ');
    const detailedGuides = getRelevantGuides(`${currentMessage} ${recentUserText}`);
    const basePrompt = getSystemPrompt(userData, userPreferences, detailedGuides);
    const enterpriseContext = buildEnterpriseContext(userData, conversationHistory);
    return basePrompt + enterpriseContext;
};

// ============================================================================
// 🎙️ VOICE AI - Speech-to-Text e Text-to-Speech per Spark
// ============================================================================

// Configurazione Voice AI
const VOICE_CONFIG = {
    language: 'it-IT',
    pitch: 1,
    rate: 0.95, // Leggermente più lento per chiarezza
    volume: 1,
    // Voci preferite in ordine di priorità (italiano)
    preferredVoices: [
        'Google italiano',
        'Microsoft Elsa',
        'Microsoft Cosimo',
        'Alice', // iOS
        'Luca',  // iOS
        'it-IT'  // Fallback generico
    ]
};

// Classe per gestire Speech Recognition (STT)
class VoiceRecognitionManager {
    constructor() {
        this.recognition = null;
        this.isListening = false;
        this.onResult = null;
        this.onError = null;
        this.onEnd = null;
        this.onStart = null;
        this.isSupported = false;
        this.initialize();
    }
    
    initialize() {
        // Verifica supporto browser
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        
        if (!SpeechRecognition) {
            console.warn('[VOICE] Speech Recognition non supportato in questo browser');
            this.isSupported = false;
            return;
        }
        
        this.isSupported = true;
        this.recognition = new SpeechRecognition();
        
        // Configurazione
        this.recognition.lang = VOICE_CONFIG.language;
        this.recognition.continuous = false; // Una frase alla volta
        this.recognition.interimResults = true; // Mostra risultati parziali
        this.recognition.maxAlternatives = 1;
        
        // Event handlers
        this.recognition.onresult = (event) => {
            const result = event.results[event.results.length - 1];
            const transcript = result[0].transcript;
            const isFinal = result.isFinal;
            
            console.log('[VOICE] Riconosciuto:', transcript, isFinal ? '(finale)' : '(parziale)');
            
            if (this.onResult) {
                this.onResult(transcript, isFinal);
            }
        };
        
        this.recognition.onerror = (event) => {
            console.error('[VOICE] Errore riconoscimento:', event.error);
            this.isListening = false;
            
            if (this.onError) {
                let errorMessage = 'Errore nel riconoscimento vocale';
                switch(event.error) {
                    case 'no-speech':
                        errorMessage = 'Nessun audio rilevato. Prova a parlare più forte.';
                        break;
                    case 'audio-capture':
                        errorMessage = 'Microfono non disponibile. Controlla i permessi.';
                        break;
                    case 'not-allowed':
                        errorMessage = 'Permesso microfono negato. Abilita il microfono nelle impostazioni del browser.';
                        break;
                    case 'network':
                        errorMessage = 'Errore di rete. Controlla la connessione internet.';
                        break;
                    case 'aborted':
                        errorMessage = 'Riconoscimento interrotto.';
                        break;
                }
                this.onError(errorMessage, event.error);
            }
        };
        
        this.recognition.onend = () => {
            console.log('[VOICE] Riconoscimento terminato');
            this.isListening = false;
            if (this.onEnd) {
                this.onEnd();
            }
        };
        
        this.recognition.onstart = () => {
            console.log('[VOICE] Riconoscimento avviato');
            this.isListening = true;
            if (this.onStart) {
                this.onStart();
            }
        };
        
        console.log('[VOICE] Speech Recognition inizializzato');
    }
    
    start() {
        if (!this.isSupported) {
            if (this.onError) {
                this.onError('Il riconoscimento vocale non è supportato in questo browser. Usa Chrome o Edge.', 'not-supported');
            }
            return false;
        }
        
        if (this.isListening) {
            console.log('[VOICE] Già in ascolto');
            return true;
        }
        
        try {
            this.recognition.start();
            return true;
        } catch (e) {
            console.error('[VOICE] Errore avvio:', e);
            if (this.onError) {
                this.onError('Impossibile avviare il microfono. Riprova.', 'start-error');
            }
            return false;
        }
    }
    
    stop() {
        if (!this.isSupported || !this.isListening) return;
        
        try {
            this.recognition.stop();
        } catch (e) {
            console.error('[VOICE] Errore stop:', e);
        }
    }
    
    abort() {
        if (!this.isSupported) return;
        
        try {
            this.recognition.abort();
            this.isListening = false;
        } catch (e) {
            console.error('[VOICE] Errore abort:', e);
        }
    }
}

// Classe per gestire Text-to-Speech (TTS)
class VoiceSynthesisManager {
    constructor() {
        this.synth = null;
        this.voice = null;
        this.isSpeaking = false;
        this.isSupported = false;
        this.onStart = null;
        this.onEnd = null;
        this.onError = null;
        this.currentUtterance = null;
        this.initialize();
    }
    
    initialize() {
        if (!('speechSynthesis' in window)) {
            console.warn('[TTS] Speech Synthesis non supportato');
            this.isSupported = false;
            return;
        }
        
        this.isSupported = true;
        this.synth = window.speechSynthesis;
        
        // Carica voci (potrebbero non essere subito disponibili)
        this.loadVoices();
        
        // Alcuni browser caricano le voci in modo asincrono
        if (speechSynthesis.onvoiceschanged !== undefined) {
            speechSynthesis.onvoiceschanged = () => this.loadVoices();
        }
        
        console.log('[TTS] Speech Synthesis inizializzato');
    }
    
    loadVoices() {
        const voices = this.synth.getVoices();
        
        // Cerca una voce italiana preferita
        for (const preferred of VOICE_CONFIG.preferredVoices) {
            const found = voices.find(v => 
                v.name.includes(preferred) || 
                v.lang.includes(preferred)
            );
            if (found) {
                this.voice = found;
                console.log('[TTS] Voce selezionata:', found.name, found.lang);
                break;
            }
        }
        
        // Fallback: prima voce italiana disponibile
        if (!this.voice) {
            this.voice = voices.find(v => v.lang.startsWith('it')) || voices[0];
            if (this.voice) {
                console.log('[TTS] Voce fallback:', this.voice.name, this.voice.lang);
            }
        }
    }
    
    speak(text, messageId = null) {
        if (!this.isSupported) {
            console.warn('[TTS] Non supportato');
            return false;
        }
        
        // Ferma qualsiasi riproduzione in corso
        this.stop();
        
        // Pulisci il testo da markdown e emoji eccessive
        const cleanText = this.cleanTextForSpeech(text);
        
        if (!cleanText.trim()) {
            console.warn('[TTS] Testo vuoto dopo pulizia');
            return false;
        }
        
        // Crea utterance
        const utterance = new SpeechSynthesisUtterance(cleanText);
        utterance.lang = VOICE_CONFIG.language;
        utterance.pitch = VOICE_CONFIG.pitch;
        utterance.rate = VOICE_CONFIG.rate;
        utterance.volume = VOICE_CONFIG.volume;
        
        if (this.voice) {
            utterance.voice = this.voice;
        }
        
        // Event handlers
        utterance.onstart = () => {
            console.log('[TTS] Inizio riproduzione');
            this.isSpeaking = true;
            if (this.onStart) this.onStart(messageId);
        };
        
        utterance.onend = () => {
            console.log('[TTS] Fine riproduzione');
            this.isSpeaking = false;
            this.currentUtterance = null;
            if (this.onEnd) this.onEnd(messageId);
        };
        
        utterance.onerror = (event) => {
            console.error('[TTS] Errore:', event.error);
            this.isSpeaking = false;
            this.currentUtterance = null;
            if (this.onError) this.onError(event.error, messageId);
        };
        
        this.currentUtterance = utterance;
        
        // Avvia la sintesi
        this.synth.speak(utterance);
        return true;
    }
    
    cleanTextForSpeech(text) {
        return text
            // Rimuovi markdown
            .replace(/\*\*/g, '')
            .replace(/\*/g, '')
            .replace(/#{1,6}\s/g, '')
            .replace(/`{1,3}[^`]*`{1,3}/g, '')
            .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
            // Rimuovi emoji (mantieni solo alcune)
            .replace(/[📧📋🎫🔧💡🚀✅❌⚠️🔴🟢🟡]/g, '')
            // Rimuovi caratteri speciali
            .replace(/━+/g, '')
            .replace(/─+/g, '')
            .replace(/[│┌┐└┘├┤┬┴┼]/g, '')
            // Sostituisci numeri emoji con numeri normali
            .replace(/1️⃣/g, '1.')
            .replace(/2️⃣/g, '2.')
            .replace(/3️⃣/g, '3.')
            .replace(/4️⃣/g, '4.')
            .replace(/5️⃣/g, '5.')
            // Pulisci spazi multipli
            .replace(/\n{3,}/g, '\n\n')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }
    
    stop() {
        if (!this.isSupported) return;
        
        if (this.synth.speaking) {
            this.synth.cancel();
            this.isSpeaking = false;
            this.currentUtterance = null;
            console.log('[TTS] Riproduzione fermata');
        }
    }
    
    pause() {
        if (!this.isSupported || !this.synth.speaking) return;
        this.synth.pause();
    }
    
    resume() {
        if (!this.isSupported || !this.synth.paused) return;
        this.synth.resume();
    }
}

// Istanze singleton per Voice AI
let voiceRecognition = null;
let voiceSynthesis = null;

const getVoiceRecognition = () => {
    if (!voiceRecognition) {
        voiceRecognition = new VoiceRecognitionManager();
    }
    return voiceRecognition;
};

const getVoiceSynthesis = () => {
    if (!voiceSynthesis) {
        voiceSynthesis = new VoiceSynthesisManager();
    }
    return voiceSynthesis;
};

// Hook personalizzato per Voice AI
const useVoiceAI = (dispatch, onTranscript) => {
    const [isListening, setIsListening] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [interimTranscript, setInterimTranscript] = useState('');
    const [voiceError, setVoiceError] = useState(null);
    const [isSupported, setIsSupported] = useState({ stt: false, tts: false });
    
    useEffect(() => {
        const recognition = getVoiceRecognition();
        const synthesis = getVoiceSynthesis();
        
        setIsSupported({
            stt: recognition.isSupported,
            tts: synthesis.isSupported
        });
        
        // Configura callbacks per STT
        recognition.onResult = (transcript, isFinal) => {
            if (isFinal) {
                setInterimTranscript('');
                if (onTranscript) {
                    onTranscript(transcript);
                }
            } else {
                setInterimTranscript(transcript);
            }
        };
        
        recognition.onError = (message, code) => {
            setVoiceError(message);
            setIsListening(false);
            setTimeout(() => setVoiceError(null), 5000);
        };
        
        recognition.onEnd = () => {
            setIsListening(false);
        };
        
        recognition.onStart = () => {
            setIsListening(true);
            setVoiceError(null);
        };
        
        // Configura callbacks per TTS
        synthesis.onStart = (messageId) => {
            setIsSpeaking(true);
            if (dispatch) {
                dispatch({ type: 'SET_STATE', payload: { currentlySpeakingMessageId: messageId } });
            }
        };
        
        synthesis.onEnd = (messageId) => {
            setIsSpeaking(false);
            if (dispatch) {
                dispatch({ type: 'SET_STATE', payload: { currentlySpeakingMessageId: null } });
            }
        };
        
        synthesis.onError = (error, messageId) => {
            setIsSpeaking(false);
            if (dispatch) {
                dispatch({ type: 'SET_STATE', payload: { currentlySpeakingMessageId: null } });
            }
        };
        
    }, [dispatch, onTranscript]);
    
    const startListening = useCallback(() => {
        const recognition = getVoiceRecognition();
        setVoiceError(null);
        recognition.start();
    }, []);
    
    const stopListening = useCallback(() => {
        const recognition = getVoiceRecognition();
        recognition.stop();
    }, []);
    
    const speak = useCallback((text, messageId) => {
        const synthesis = getVoiceSynthesis();
        synthesis.speak(text, messageId);
    }, []);
    
    const stopSpeaking = useCallback(() => {
        const synthesis = getVoiceSynthesis();
        synthesis.stop();
    }, []);
    
    const toggleListening = useCallback(() => {
        if (isListening) {
            stopListening();
        } else {
            // Ferma TTS se sta parlando prima di ascoltare
            const synthesis = getVoiceSynthesis();
            if (synthesis.isSpeaking) {
                synthesis.stop();
            }
            startListening();
        }
    }, [isListening, startListening, stopListening]);
    
    return {
        isListening,
        isSpeaking,
        interimTranscript,
        voiceError,
        isSupported,
        startListening,
        stopListening,
        toggleListening,
        speak,
        stopSpeaking
    };
};

// ============================================================================
// UTILS PER FUZZY MATCHING AZIENDA
// ============================================================================

// Normalizza nome azienda rimuovendo suffissi societari e caratteri speciali
const normalizeCompanyName = (name) => {
    if (!name) return '';
    return name
        .toLowerCase()
        // Rimuove suffissi societari comuni
        .replace(/\b(s\.?r\.?l\.?|s\.?p\.?a\.?|s\.?n\.?c\.?|s\.?a\.?s\.?|inc\.?|ltd\.?|gmbh|corp\.?|soc\.?|coop\.?)\b/gi, '')
        // Rimuove punteggiatura e caratteri speciali
        .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()'"]/g, '')
        // Rimuove spazi doppi
        .replace(/\s{2,}/g, ' ')
        .trim();
};

// Calcola la distanza di Levenshtein tra due stringhe
const getLevenshteinDistance = (a, b) => {
    const matrix = [];
    for (let i = 0; i <= b.length; i++) { matrix[i] = [i]; }
    for (let j = 0; j <= a.length; j++) { matrix[0][j] = j; }
    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1,
                    Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)
                );
            }
        }
    }
    return matrix[b.length][a.length];
};

// Verifica se due nomi azienda corrispondono (fuzzy match)
const isCompanyMatch = (rmmName, userInput) => {
    if (!rmmName || !userInput) return false;
    
    const normRmm = normalizeCompanyName(rmmName);
    const normUser = normalizeCompanyName(userInput);
    
    if (!normRmm || !normUser) return false;

    // 1. Match Esatto dopo normalizzazione
    if (normRmm === normUser) return true;

    // 2. Match Parziale (una stringa contiene l'altra)
    if (normRmm.includes(normUser) || normUser.includes(normRmm)) return true;

    // 3. Fuzzy Match con Levenshtein (tollera errori di battitura)
    const distance = getLevenshteinDistance(normRmm, normUser);
    const maxLength = Math.max(normRmm.length, normUser.length);
    
    // Tolleranza: differenza < 30% della lunghezza
    return distance <= (maxLength * 0.3);
};

// Trova la migliore corrispondenza tra input utente e lista aziende
const findBestCompanyMatch = (userInput, companiesList) => {
    if (!userInput || !companiesList || companiesList.length === 0) return null;
    
    const normUser = normalizeCompanyName(userInput);
    if (!normUser) return null;
    
    let bestMatch = null;
    let bestScore = Infinity;
    
    for (const company of companiesList) {
        const normCompany = normalizeCompanyName(company);
        if (!normCompany) continue;
        
        // Match esatto
        if (normCompany === normUser) {
            return { name: company, exact: true, score: 0 };
        }
        
        // Match parziale
        if (normCompany.includes(normUser) || normUser.includes(normCompany)) {
            const score = Math.abs(normCompany.length - normUser.length);
            if (score < bestScore) {
                bestScore = score;
                bestMatch = { name: company, exact: false, score };
            }
            continue;
        }
        
        // Fuzzy match
        const distance = getLevenshteinDistance(normCompany, normUser);
        const maxLength = Math.max(normCompany.length, normUser.length);
        const tolerance = maxLength * 0.3;
        
        if (distance <= tolerance && distance < bestScore) {
            bestScore = distance;
            bestMatch = { name: company, exact: false, score: distance };
        }
    }
    
    return bestMatch;
};

// ============================================================================
// ORARI DISPONIBILITÀ SUPPORTO
// ============================================================================
const getSupportAvailability = () => {
    const now = new Date();
    const day = now.getDay(); // 0 = Domenica, 6 = Sabato
    const hour = now.getHours();
    const minute = now.getMinutes();
    const currentTime = hour + minute / 60; // Es: 7:30 = 7.5
    
    // Festività italiane (da aggiornare annualmente)
    const holidays = [
        '01-01', // Capodanno
        '01-06', // Epifania
        '04-25', // Liberazione
        '05-01', // Festa del Lavoro
        '06-02', // Repubblica
        '08-15', // Ferragosto
        '11-01', // Ognissanti
        '12-08', // Immacolata
        '12-25', // Natale
        '12-26', // Santo Stefano
    ];
    
    const monthDay = `${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const isHoliday = holidays.includes(monthDay);
    
    // DOMENICA o FESTIVO = ROSSO (chiuso)
    if (day === 0 || isHoliday) {
        return {
            status: 'closed',
            color: 'red',
            icon: '🔴',
            text: 'Chiuso',
            description: 'Il supporto riapre lunedì alle 7:30',
            nextOpen: 'Lunedì 7:30'
        };
    }
    
    // SABATO
    if (day === 6) {
        // Verde: 8:00 - 12:30
        if (currentTime >= 8 && currentTime < 12.5) {
            return {
                status: 'online',
                color: 'green',
                icon: '🟢',
                text: 'Online',
                description: 'Supporto attivo fino alle 12:30',
                responseTime: '~5-10 min'
            };
        }
        // Giallo: 12:30 - 13:00
        if (currentTime >= 12.5 && currentTime < 13) {
            return {
                status: 'limited',
                color: 'yellow',
                icon: '🟡',
                text: 'Operatività ridotta',
                description: 'Risposta non garantita',
                nextOpen: 'Lunedì 7:30'
            };
        }
        // Rosso: 13:00 - 20:00
        if (currentTime >= 13 && currentTime < 20) {
            return {
                status: 'closed',
                color: 'red',
                icon: '🔴',
                text: 'Chiuso',
                description: 'Il supporto riapre lunedì alle 7:30',
                nextOpen: 'Lunedì 7:30'
            };
        }
        // Giallo: prima delle 8:00 o dopo le 20:00
        return {
            status: 'limited',
            color: 'yellow',
            icon: '🟡',
            text: 'Operatività ridotta',
            description: currentTime < 8 ? 'Supporto dalle 8:00' : 'Risposta non garantita',
            nextOpen: currentTime < 8 ? '8:00' : 'Lunedì 7:30'
        };
    }
    
    // LUNEDÌ - VENERDÌ
    // Verde: 7:30 - 20:00 (orario continuato)
    if (currentTime >= 7.5 && currentTime < 20) {
        return {
            status: 'online',
            color: 'green',
            icon: '🟢',
            text: 'Online',
            description: 'Supporto attivo fino alle 20:00',
            responseTime: '~5-10 min'
        };
    }
    
    // Giallo: 20:00 - 22:00
    if (currentTime >= 20 && currentTime < 22) {
        return {
            status: 'limited',
            color: 'yellow',
            icon: '🟡',
            text: 'Operatività ridotta',
            description: 'Risposta non garantita',
            nextOpen: 'Domani 7:30'
        };
    }
    
    // Rosso: 22:00 - 7:29
    return {
        status: 'closed',
        color: 'red',
        icon: '🔴',
        text: 'Chiuso',
        description: currentTime >= 22 ? 'Riapriamo domani alle 7:30' : 'Riapriamo alle 7:30',
        nextOpen: '7:30'
    };
};

// ============================================================================
// SCREENSHOT CAPTURE
// ============================================================================
const captureScreenshot = async () => {
    try {
        // Metodo 1: Usando getDisplayMedia (screen share)
        if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
            const stream = await navigator.mediaDevices.getDisplayMedia({
                video: { mediaSource: 'screen' }
            });
            
            const video = document.createElement('video');
            video.srcObject = stream;
            await video.play();
            
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0);
            
            // Ferma lo stream
            stream.getTracks().forEach(track => track.stop());
            
            // Converti in blob
            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    const file = new File([blob], `screenshot_${Date.now()}.png`, { type: 'image/png' });
                    resolve(file);
                }, 'image/png', 0.9);
            });
        }
        
        throw new Error('Screen capture not supported');
    } catch (error) {
        console.error('[SCREENSHOT] Errore:', error);
        throw error;
    }
};

const MOCK_API = {
    // CHAT - ORA USA API REALE
    streamChat: streamGeminiChat,

    // TICKET - ORA USA API REALE  
    createTicket: createJiraTicket,
    getTicketStatus: getJiraTicketStatus,

    // STORICO TICKET UTENTE - Recupera ticket aperti dall'utente (per email o nome)
    getUserTickets: async (userEmail, userName) => {
        const searchTerm = userEmail || userName;
        console.log('[TICKETS] Recupero ticket per:', searchTerm);
        try {
            // Cerca per email se disponibile, altrimenti per nome
            const searchParam = userEmail ? `email/${encodeURIComponent(userEmail)}` : `user/${encodeURIComponent(userName || '')}`;
            const response = await fetch(`${API_BASE_URL}/api/v1/jira/tickets/${searchParam}`, {
                method: 'GET',
                headers: getAuthHeaders()
            });
            
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            return data.tickets || [];
        } catch (error) {
            console.error('[TICKETS] Errore recupero ticket:', error);
            return [];
        }
    },

    // SALVA FEEDBACK - Salva feedback post-risoluzione
    saveFeedback: async (feedbackData) => {
        console.log('[FEEDBACK] Salvataggio feedback:', feedbackData);
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/jira/feedback`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify(feedbackData)
            });
            
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return await response.json();
        } catch (error) {
            console.error('[FEEDBACK] Errore salvataggio:', error);
            // Salva localmente come fallback
            const feedbacks = JSON.parse(localStorage.getItem('spark-feedbacks') || '[]');
            feedbacks.push({ ...feedbackData, timestamp: new Date().toISOString() });
            localStorage.setItem('spark-feedbacks', JSON.stringify(feedbacks));
            return { success: true, local: true };
        }
    },

    // LISTA AZIENDE CLIENTI - da DattoRMM
    getClientCompanies: async () => {
        console.log('[API] Recupero lista aziende clienti...');
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/rmm/sites`, {
                method: 'GET',
                headers: getAuthHeaders()
            });
            
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            
            const data = await response.json();
            // Estrae i nomi dei siti/aziende
            const companies = data.sites?.map(s => s.name || s.siteName) || [];
            console.log('[OK] Aziende trovate:', companies.length);
            return companies;
        } catch (error) {
            console.error('[ERR] Errore recupero aziende:', error);
            // Fallback: lista vuota
            return [];
        }
    },

    // DEVICE INFO - REALE (DattoRMM)
    // IMPORTANTE: Passa anche userName per selezionare il dispositivo corretto
    getDeviceInfo: async (hostname, userName = '') => {
        console.log('[PC] Chiamata DattoRMM per:', hostname, 'utente:', userName);
        
        // ===== RILEVAMENTO BROWSER: Batteria e User-Agent =====
        const detectBrowserHardware = async () => {
            const detection = {
                hasBattery: false,
                isMobile: false,
                isTablet: false,
                batteryLevel: null,
                isCharging: null,
                connectionType: null,
                connTypeSource: 'unknown'
            };
            
            // 1. Rileva dispositivo mobile/tablet da User-Agent
            const ua = navigator.userAgent || '';
            detection.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
            detection.isTablet = /iPad|Android(?!.*Mobile)/i.test(ua);
            
            // 2. Rileva batteria (i notebook hanno batteria, i PC fissi no)
            try {
                if ('getBattery' in navigator) {
                    const battery = await navigator.getBattery();
                    // Se il dispositivo ha una batteria che si scarica (non sempre 100% o collegato)
                    // oppure ha un livello diverso da 1 (100%), è probabilmente un notebook
                    detection.hasBattery = battery.level < 1 || !battery.charging || battery.dischargingTime !== Infinity;
                    detection.batteryLevel = battery.level;
                    detection.isCharging = battery.charging;
                    console.log('[HW] Battery API:', { 
                        level: Math.round(battery.level * 100) + '%', 
                        charging: battery.charging, 
                        hasBattery: detection.hasBattery 
                    });
                }
            } catch (e) {
                console.log('[HW] Battery API non disponibile');
            }
            
            // 3. NUOVO: Rileva tipo connessione di rete dal browser
            try {
                const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                if (connection) {
                    const connType = (connection.type || '').toLowerCase();
                    const effectiveType = (connection.effectiveType || '').toLowerCase();
                    
                    console.log('[NET] Navigator.connection:', { type: connType, effectiveType: effectiveType });
                    
                    // Ethernet = LAN
                    if (connType === 'ethernet') {
                        detection.connectionType = 'LAN';
                        detection.connTypeSource = 'browser-api';
                        console.log('[NET] ✓ Connessione ETHERNET rilevata da browser API');
                    }
                    // Wi-Fi
                    else if (connType === 'wifi') {
                        detection.connectionType = 'Wi-Fi';
                        detection.connTypeSource = 'browser-api';
                        console.log('[NET] ✓ Connessione WI-FI rilevata da browser API');
                    }
                    // Cellular/mobile
                    else if (connType === 'cellular' || connType === '4g' || connType === '3g' || connType === '2g') {
                        detection.connectionType = 'Wi-Fi'; // Mobile = wireless
                        detection.connTypeSource = 'browser-api';
                        console.log('[NET] ✓ Connessione MOBILE rilevata da browser API');
                    }
                    // Se il tipo non è disponibile, usa effectiveType per dedurre
                    else if (!detection.connectionType && effectiveType) {
                        // effectiveType indica la qualità della connessione, non il tipo fisico
                        // Ma se è molto veloce (4g), potrebbe essere LAN o Wi-Fi veloce
                        // Non possiamo determinarlo con certezza
                        console.log('[NET] effectiveType:', effectiveType, '- tipo fisico non determinabile');
                    }
                }
            } catch (e) {
                console.log('[NET] Navigator.connection non disponibile:', e.message);
            }
            
            // 4. Fallback: touchscreen + piccolo schermo = probabilmente notebook/tablet
            if (!detection.hasBattery && !detection.isMobile) {
                const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
                const smallScreen = window.screen.width <= 1920 && window.screen.height <= 1080;
                if (hasTouch && smallScreen) {
                    console.log('[HW] Rilevato touchscreen con schermo piccolo - possibile notebook');
                    detection.hasBattery = true; // Treat as notebook
                }
            }
            
            // 5. NUOVO: Deduzione connessione da hardware se non rilevata
            if (!detection.connectionType && detection.hasBattery !== null) {
                // Se ha batteria che si scarica = notebook = probabilmente Wi-Fi
                if (detection.hasBattery && detection.batteryLevel < 1 && !detection.isCharging) {
                    detection.connectionType = 'Wi-Fi';
                    detection.connTypeSource = 'dedotto-da-batteria';
                    console.log('[NET] ~ Connessione dedotta da batteria in uso: Wi-Fi');
                }
            }
            
            return detection;
        };
        
        // Esegui rilevamento browser
        const browserDetection = await detectBrowserHardware();
        
        // ============================================================================
        // 🤖 FUNZIONE AI: Analisi intelligente del dispositivo con Gemini
        // Riceve TUTTI i dati disponibili da Datto RMM per una detection precisa
        // ============================================================================
        const analyzeDeviceWithAI = async (deviceData) => {
            // Log per debug
            console.log('[AI] 📋 deviceData ricevuto:', JSON.stringify(deviceData));
            
            const { model, hostname, chassisType, manufacturer, operatingSystem } = deviceData || {};
            
            // Costruisci una descrizione completa del dispositivo
            const deviceParts = [];
            if (manufacturer) deviceParts.push(`Produttore: ${manufacturer}`);
            if (model) deviceParts.push(`Modello: ${model}`);
            if (hostname) deviceParts.push(`Nome PC: ${hostname}`);
            if (chassisType) deviceParts.push(`Tipo Chassis: ${chassisType}`);
            if (operatingSystem) deviceParts.push(`Sistema Operativo: ${operatingSystem}`);
            
            // Se non abbiamo abbastanza dati, non chiamare l'AI
            if (deviceParts.length === 0) {
                console.log('[AI] ⚠️ Nessun dato valido per l\'analisi AI');
                return null;
            }
            
            const deviceDescription = deviceParts.join('\n');
            console.log('[AI] 🤖 Analisi dispositivo con Gemini:\n', deviceDescription);
            
            try {
                const prompt = `Sei un esperto IT di hardware. Analizza queste informazioni del dispositivo e rispondi SOLO con un JSON valido.

INFORMAZIONI DISPOSITIVO:
${deviceDescription}

DETERMINA:
1. È un NOTEBOOK (laptop, portatile) o un PC FISSO (desktop, tower, workstation, mini PC)?
2. Come è probabilmente collegato alla rete? (LAN = cavo ethernet, Wi-Fi = wireless)

REGOLE DI IDENTIFICAZIONE:

NOTEBOOK (laptop/portatili):
- Dell: Latitude, Inspiron, XPS 13/15/17, Precision Mobile, Vostro (portatile)
- HP: EliteBook, ProBook, ZBook, Pavilion, Envy, Spectre, HP 250/255
- Lenovo: ThinkPad, IdeaPad, Yoga, Legion
- Asus: ZenBook, VivoBook, ExpertBook, ROG Zephyrus
- Acer: Swift, Aspire (portatile), TravelMate, Predator Helios
- Apple: MacBook, MacBook Air, MacBook Pro
- Microsoft: Surface Laptop, Surface Pro, Surface Go
- Chassis: Laptop, Notebook, Portable, Tablet, Convertible

PC FISSO (desktop/workstation):
- Dell: OptiPlex, Precision Tower, Vostro Desktop, PowerEdge
- HP: ProDesk, EliteDesk, Z1/Z2/Z4/Z6/Z8 Workstation, EliteOne (AIO)
- Lenovo: ThinkCentre, ThinkStation, IdeaCentre
- Apple: iMac, Mac Mini, Mac Studio, Mac Pro
- Chassis: Desktop, Tower, Mini Tower, All-in-One, Workstation, Mini PC, NUC, Small Form Factor

CONNESSIONE TIPICA:
- Notebook → Wi-Fi (wireless)
- PC Fisso → LAN (cavo ethernet)

Rispondi SOLO con questo JSON (nessun altro testo):
{"hardwareType": "notebook" | "fisso" | null, "connectionType": "LAN" | "Wi-Fi" | null, "confidence": "high" | "medium" | "low", "reasoning": "spiegazione breve"}`;

                const response = await fetch(`${API_BASE_URL}/api/v1/gemini/stream`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        contents: [{ role: 'user', parts: [{ text: prompt }] }]
                    })
                });
                
                if (!response.ok) {
                    console.warn('[AI] ⚠️ Errore risposta Gemini:', response.status);
                    return null;
                }
                
                const contentType = response.headers.get('content-type') || '';
                let aiText = '';
                
                if (contentType.includes('application/json')) {
                    const json = await response.json();
                    aiText = json?.candidates?.[0]?.content?.parts?.[0]?.text || json?.text || json?.response || '';
                } else {
                    // Streaming - leggi tutto
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();
                    
                    while (true) {
                        const { value, done } = await reader.read();
                        if (done) break;
                        const chunk = decoder.decode(value, { stream: true });
                        
                        // Estrai testo da SSE
                        const lines = chunk.split('\n');
                        for (const line of lines) {
                            if (line.startsWith('data: ')) {
                                try {
                                    const data = JSON.parse(line.slice(6));
                                    aiText += data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
                                } catch (e) {}
                            }
                        }
                    }
                }
                
                console.log('[AI] 📝 Risposta grezza:', aiText);
                
                // Estrai JSON dalla risposta
                const jsonMatch = aiText.match(/\{[\s\S]*\}/);
                if (jsonMatch) {
                    const result = JSON.parse(jsonMatch[0]);
                    console.log('[AI] ✅ Analisi completata:', result);
                    return result;
                }
                
                return null;
            } catch (e) {
                console.error('[AI] ❌ Errore analisi AI:', e);
                return null;
            }
        };
        
        // ============================================================================
        // 🤖 FUNZIONE AI: Analisi LIVE della connessione di rete con Gemini
        // Analizza i dati degli adattatori di rete per determinare la connessione attiva
        // ============================================================================
        const analyzeNetworkConnectionWithAI = async (networkData) => {
            const { adapters, activeConnection, ipAddresses, browserConnection } = networkData || {};
            
            // Costruisci descrizione della rete
            const networkParts = [];
            
            if (adapters && adapters.length > 0) {
                networkParts.push(`ADATTATORI DI RETE RILEVATI (${adapters.length}):`);
                adapters.forEach((adapter, i) => {
                    const parts = [];
                    if (adapter.name) parts.push(`Nome: ${adapter.name}`);
                    if (adapter.description) parts.push(`Descrizione: ${adapter.description}`);
                    if (adapter.status) parts.push(`Stato: ${adapter.status}`);
                    if (adapter.ipAddress) parts.push(`IP: ${adapter.ipAddress}`);
                    if (adapter.mediaType) parts.push(`Tipo: ${adapter.mediaType}`);
                    if (adapter.speed) parts.push(`Velocità: ${adapter.speed}`);
                    if (parts.length > 0) {
                        networkParts.push(`  ${i+1}. ${parts.join(', ')}`);
                    }
                });
            }
            
            if (activeConnection) {
                networkParts.push(`\nCONNESSIONE ATTIVA: ${activeConnection}`);
            }
            
            if (ipAddresses) {
                networkParts.push(`\nINDIRIZZI IP: ${JSON.stringify(ipAddresses)}`);
            }
            
            if (browserConnection) {
                networkParts.push(`\nBROWSER API: tipo=${browserConnection.type || 'N/A'}, effectiveType=${browserConnection.effectiveType || 'N/A'}`);
            }
            
            if (networkParts.length === 0) {
                console.log('[AI-NET] ⚠️ Nessun dato di rete da analizzare');
                return null;
            }
            
            const networkDescription = networkParts.join('\n');
            console.log('[AI-NET] 🔍 Analisi connessione LIVE:\n', networkDescription);
            
            try {
                const prompt = `Sei un esperto di reti IT. Analizza questi dati di rete e determina COME il dispositivo è collegato alla rete IN QUESTO MOMENTO.

DATI DI RETE:
${networkDescription}

REGOLE DI IDENTIFICAZIONE:

CONNESSIONE LAN (cavo ethernet):
- Adattatori con nome contenente: "Ethernet", "LAN", "Realtek PCIe", "Intel(R) Ethernet", "Killer E", "802.3"
- MediaType: 802.3, Ethernet
- Velocità tipica: 100 Mbps, 1 Gbps, 1000 Mbps, 2.5 Gbps

CONNESSIONE WI-FI (wireless):
- Adattatori con nome contenente: "Wi-Fi", "WiFi", "Wireless", "WLAN", "Intel(R) Wi-Fi", "Killer Wi-Fi", "802.11"
- MediaType: 802.11, Wireless, Native 802.11
- Velocità variabile: 54 Mbps, 150 Mbps, 300 Mbps, 450 Mbps, etc.

PRIORITÀ:
1. Guarda quale adattatore ha uno stato ATTIVO (Up, Connected) e un IP assegnato
2. Quello è l'adattatore con cui il PC è collegato alla rete
3. L'adattatore con metrica più bassa (interfaceMetric) ha priorità

Rispondi SOLO con questo JSON:
{"connectionType": "LAN" | "Wi-Fi" | null, "confidence": "high" | "medium" | "low", "adapterName": "nome dell'adattatore attivo", "reasoning": "spiegazione breve"}`;

                const response = await fetch(`${API_BASE_URL}/api/v1/gemini/stream`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        contents: [{ role: 'user', parts: [{ text: prompt }] }]
                    })
                });
                
                if (!response.ok) {
                    console.warn('[AI-NET] ⚠️ Errore risposta Gemini:', response.status);
                    return null;
                }
                
                const contentType = response.headers.get('content-type') || '';
                let aiText = '';
                
                if (contentType.includes('application/json')) {
                    const json = await response.json();
                    aiText = json?.candidates?.[0]?.content?.parts?.[0]?.text || json?.text || json?.response || '';
                } else {
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();
                    
                    while (true) {
                        const { value, done } = await reader.read();
                        if (done) break;
                        const chunk = decoder.decode(value, { stream: true });
                        
                        const lines = chunk.split('\n');
                        for (const line of lines) {
                            if (line.startsWith('data: ')) {
                                try {
                                    const data = JSON.parse(line.slice(6));
                                    aiText += data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
                                } catch (e) {}
                            }
                        }
                    }
                }
                
                console.log('[AI-NET] 📝 Risposta:', aiText);
                
                const jsonMatch = aiText.match(/\{[\s\S]*\}/);
                if (jsonMatch) {
                    const result = JSON.parse(jsonMatch[0]);
                    console.log('[AI-NET] ✅ Connessione LIVE rilevata:', result);
                    return result;
                }
                
                return null;
            } catch (e) {
                console.error('[AI-NET] ❌ Errore:', e);
                return null;
            }
        };
        
        // Funzione per dedurre il tipo hardware dal MODELLO (priorità) o dal nome PC (fallback)
        // Funzione per dedurre il tipo hardware basata su Datto RMM chassisType
        const deduceFormFactor = (model, hostnameFallback, chassisType = null) => {
            let detectedType = null;
            let confidence = 'unknown'; // 'high', 'medium', 'low', 'unknown'
            
            // ===== PRIORITÀ 1: Dati Nativi da Datto RMM (chassisType/deviceType) =====
            // Questo è il metodo PIÙ AFFIDABILE - Datto RMM fornisce il Chassis Type da WMI
            const chassis = (chassisType || '').toLowerCase();
            
            if (chassis) {
                // Identificato come NOTEBOOK se contiene:
                const notebookChassisTypes = ['laptop', 'notebook', 'portable', 'tablet', 'convertible', 'detachable'];
                if (notebookChassisTypes.some(t => chassis.includes(t))) {
                    console.log('[HW] ✅ NOTEBOOK da chassisType Datto RMM:', chassisType);
                    detectedType = 'notebook';
                    confidence = 'high';
                }
                
                // Identificato come PC FISSO se contiene:
                const desktopChassisTypes = ['desktop', 'tower', 'all in one', 'mini tower', 'pizza box', 'space saving', 'workstation', 'mini pc', 'nuc'];
                if (!detectedType && desktopChassisTypes.some(t => chassis.includes(t))) {
                    console.log('[HW] ✅ FISSO da chassisType Datto RMM:', chassisType);
                    detectedType = 'fisso';
                    confidence = 'high';
                }
            }
            
            // ===== PRIORITÀ 2: Analisi del MODELLO del dispositivo =====
            if (!detectedType && model) {
                const modelLower = model.toLowerCase();
                
                // Escludi Virtual Machines - non possiamo determinare il form factor
                if (modelLower.includes('virtual machine') || modelLower.includes('vmware') || modelLower.includes('hyper-v')) {
                    console.log('[HW] ⚠️ Virtual Machine rilevata - form factor non determinabile');
                    return { formFactor: null, model: model, confidence: 'unknown' };
                }
                
                // Lista di keyword NOTEBOOK (modelli noti) - MOLTO SPECIFICA
                const notebookModels = [
                    'notebook', 'laptop', 'portable', 'portatile',
                    // Dell
                    'latitude', 'inspiron', 'xps 13', 'xps 15', 'xps 17', 'precision mobile',
                    // HP
                    'elitebook', 'probook', 'zbook', 'envy', 'spectre', 'pavilion x360', 'hp 250', 'hp 255', 'hp firefly',
                    // Lenovo
                    'thinkpad', 'ideapad', 'yoga', 'legion', '80xf', '82c5', '82xm',
                    // Asus
                    'zenbook', 'vivobook', 'expertbook', 'rog zephyrus', 'x1504za', 'x580gd',
                    // Acer
                    'swift', 'aspire', 'travelmate', 'predator helios',
                    // Apple
                    'macbook', 'macbookair', 'macbookpro',
                    // Microsoft
                    'surface laptop', 'surface pro', 'surface go'
                ];
                
                // Lista di keyword PC FISSO (modelli noti) - MOLTO SPECIFICA
                const desktopModels = [
                    'desktop', 'tower', 'workstation', 'mini pc', 'all-in-one', 'aio', 'nuc',
                    // Dell
                    'optiplex', 'precision tower', 'vostro desktop', 'poweredge',
                    // HP
                    'prodesk', 'elitedesk', 'z workstation', 'hp z1', 'hp z2', 'hp z4', 'hp z6', 'hp z8', 
                    'pro tower', 'pro sff', 'pro mini', 'eliteone', 'engage flex', 'z240', 'microtower',
                    // Lenovo
                    'thinkcentre', 'thinkstation', 'ideacentre', '10sus', '30dk', '30b6', '12nh',
                    // Apple
                    'imac', 'mac mini', 'mac studio', 'mac pro', 'imac21',
                    // Generici
                    'asus desktop', 'acer aspire tc', 'inspiron desktop', 'h81m', 'small form factor', 'sff',
                    // Server (trattali come fisso se non VM)
                    'proliant ml', 'proliant dl', 'poweredge t', 'pcg02 pro'
                ];
                
                for (const keyword of notebookModels) {
                    if (modelLower.includes(keyword)) {
                        console.log('[HW] ✅ NOTEBOOK da model:', model);
                        detectedType = 'notebook';
                        confidence = 'high';
                        break;
                    }
                }
                
                if (!detectedType) {
                    for (const keyword of desktopModels) {
                        if (modelLower.includes(keyword)) {
                            console.log('[HW] ✅ FISSO da model:', model);
                            detectedType = 'fisso';
                            confidence = 'high';
                            break;
                        }
                    }
                }
            }
            
            // ===== PRIORITÀ 3: Analisi Hostname (se chiaro e non ambiguo) =====
            if (!detectedType && hostnameFallback) {
                const hostLower = hostnameFallback.toLowerCase();
                
                // Prima cerca NOMI DI MODELLI noti nell'hostname
                // Notebook
                const notebookHostnameKeywords = [
                    'probook', 'elitebook', 'zbook', 'thinkpad', 'ideapad', 'latitude', 
                    'xps', 'inspiron', 'macbook', 'zenbook', 'vivobook', 'expertbook',
                    'surface', 'swift', 'aspire', 'travelmate'
                ];
                // PC Fisso
                const desktopHostnameKeywords = [
                    'optiplex', 'prodesk', 'elitedesk', 'thinkcentre', 'thinkstation',
                    'imac', 'mac-mini', 'macmini', 'ideacentre', 'vostro'
                ];
                
                for (const keyword of notebookHostnameKeywords) {
                    if (hostLower.includes(keyword)) {
                        console.log('[HW] ✅ NOTEBOOK da modello in hostname:', keyword, '-', hostnameFallback);
                        detectedType = 'notebook';
                        confidence = 'high';
                        break;
                    }
                }
                
                if (!detectedType) {
                    for (const keyword of desktopHostnameKeywords) {
                        if (hostLower.includes(keyword)) {
                            console.log('[HW] ✅ FISSO da modello in hostname:', keyword, '-', hostnameFallback);
                            detectedType = 'fisso';
                            confidence = 'high';
                            break;
                        }
                    }
                }
                
                // Pattern CHIARI per NOTEBOOK (devono essere inequivocabili)
                if (!detectedType) {
                    if (hostLower.match(/^nb[-_]/) || hostLower.match(/[-_]nb[-_]/) || hostLower.match(/[-_]nb$/) ||
                        hostLower.includes('notebook') || hostLower.includes('laptop') ||
                        hostLower.includes('book') ||
                        hostLower.match(/^lt[-_]?\d/) || hostLower.match(/^lap[-_]?\d/)) {
                        console.log('[HW] ✅ NOTEBOOK da hostname chiaro:', hostnameFallback);
                        detectedType = 'notebook';
                        confidence = 'medium';
                    }
                    // Pattern CHIARI per PC FISSO (devono essere inequivocabili)
                    else if (hostLower.match(/^desk[-_]/) || hostLower.match(/[-_]desk[-_]/) ||
                             hostLower.includes('desktop') || hostLower.includes('tower') || 
                             hostLower.includes('workstation') ||
                             hostLower.match(/^dt[-_]?\d/) || hostLower.match(/^wks[-_]?\d/) ||
                             hostLower.match(/^ws[-_]?\d/)) {
                        console.log('[HW] ✅ FISSO da hostname chiaro:', hostnameFallback);
                        detectedType = 'fisso';
                        confidence = 'medium';
                    }
                    // ATTENZIONE: "PC" nel nome NON è sufficiente - può essere anche notebook
                    // Non deduciamo da "PC001" o simili
                }
            }
            
            // ===== PRIORITÀ 4: Battery API (SOLO se presente e charging=false) =====
            // NOTA: UPS può causare falsi positivi, quindi richiediamo charging=false
            if (!detectedType && browserDetection && browserDetection.hasBattery) {
                // Solo se la batteria NON è al 100% o sta scaricando = probabilmente vero notebook
                if (browserDetection.batteryLevel && browserDetection.batteryLevel < 1 && !browserDetection.isCharging) {
                    console.log('[HW] ~ NOTEBOOK dedotto da Battery API (batteria in uso)');
                    detectedType = 'notebook';
                    confidence = 'low';
                }
            }
            
            // ===== NON DETERMINATO: Lascia null per chiedere all'utente =====
            if (!detectedType) {
                console.log('[HW] ⚠️ Tipo hardware NON determinato - l\'utente dovrà selezionarlo');
                // NON fare default - lascia che l'utente scelga
                detectedType = null;
                confidence = 'unknown';
            }
            
            return { 
                formFactor: detectedType, 
                model: model || (detectedType === 'notebook' ? 'Notebook' : detectedType === 'fisso' ? 'PC Fisso' : 'Non rilevato'),
                confidence: confidence
            };
        };
        
        // Wrapper async che SEMPRE chiama l'AI per analizzare il dispositivo
        // Riceve tutti i dati disponibili da Datto RMM
        const deduceFormFactorWithAI = async (deviceData) => {
            const { model, hostname, chassisType, manufacturer, operatingSystem } = deviceData || {};
            
            console.log('[AI] 📦 Dati ricevuti per analisi:', { model, hostname, chassisType, manufacturer, operatingSystem });
            
            // Prima prova la detection standard (veloce, basata su keywords)
            const standardResult = deduceFormFactor(model, hostname, chassisType);
            
            // Se la detection standard è già ad ALTA confidenza (chassisType o modello noto da Datto),
            // NON chiamare l'AI: risposta immediata, nessun blocco se Gemini è lento/non disponibile.
            if (standardResult.confidence === 'high' && standardResult.formFactor) {
                console.log('[AI] ⏭️ Detection standard ad alta confidenza, salto Gemini:', standardResult.formFactor);
                return standardResult;
            }
            
            // Solo per i casi INCERTI: chiama l'AI per un'analisi più precisa
            console.log('[AI] 🔄 Chiamo Gemini AI per analisi dispositivo (caso incerto)...');
            
            const aiResult = await analyzeDeviceWithAI({
                model,
                hostname,
                chassisType,
                manufacturer,
                operatingSystem
            });
            
            if (aiResult && aiResult.hardwareType) {
                console.log('[AI] ✅ Tipo determinato da AI:', aiResult.hardwareType, '- Confidence:', aiResult.confidence, '- Reasoning:', aiResult.reasoning);
                
                // Se l'AI ha alta confidenza, usa il suo risultato
                // Se la detection standard aveva già un risultato, confronta
                if (aiResult.confidence === 'high' || !standardResult.formFactor) {
                    return {
                        formFactor: aiResult.hardwareType,
                        model: model || hostname || 'Rilevato da AI',
                        confidence: aiResult.confidence || 'medium',
                        connectionType: aiResult.connectionType,
                        aiDetected: true,
                        aiReasoning: aiResult.reasoning
                    };
                }
                
                // Se entrambi hanno un risultato, dai priorità all'AI se ha almeno medium confidence
                if (aiResult.confidence === 'medium' && standardResult.confidence !== 'high') {
                    return {
                        formFactor: aiResult.hardwareType,
                        model: model || hostname || 'Rilevato da AI',
                        confidence: aiResult.confidence,
                        connectionType: aiResult.connectionType,
                        aiDetected: true,
                        aiReasoning: aiResult.reasoning
                    };
                }
            }
            
            // Fallback: usa la detection standard se l'AI non ha dato risultati affidabili
            if (standardResult.formFactor) {
                console.log('[AI] ℹ️ Uso detection standard:', standardResult.formFactor);
            }
            return standardResult;
        };
        
        // Funzione per selezionare il dispositivo corretto da un array
        const selectCorrectDevice = (devices, targetUser) => {
            if (!Array.isArray(devices) || devices.length === 0) return null;
            if (devices.length === 1) return devices[0];
            
            // Normalizza userName per il confronto (rimuovi dominio, lowercase)
            const normalizeUser = (user) => {
                if (!user) return '';
                return user.toLowerCase()
                    .replace(/^.*\\/, '') // Rimuovi dominio Windows (DOMAIN\user)
                    .replace(/@.*$/, '')   // Rimuovi dominio email (user@domain)
                    .replace(/\./g, ' ')   // Sostituisci punti con spazi
                    .trim();
            };
            
            const targetNormalized = normalizeUser(targetUser);
            console.log('[SEARCH] Cerco dispositivo per utente:', targetNormalized);
            
            // PRIORITÀ 1: Match esatto su lastLoggedInUser
            if (targetNormalized) {
                const matchByUser = devices.find(d => {
                    const deviceUser = normalizeUser(d.lastLoggedInUser);
                    const isMatch = deviceUser.includes(targetNormalized) || targetNormalized.includes(deviceUser);
                    if (isMatch) console.log('[OK] Match utente trovato:', d.siteName, '-', d.lastLoggedInUser);
                    return isMatch;
                });
                if (matchByUser) return matchByUser;
            }
            
            // PRIORITÀ 2: Dispositivo online
            const onlineDevices = devices.filter(d => d.online === true);
            if (onlineDevices.length === 1) {
                console.log('[OK] Un solo dispositivo online:', onlineDevices[0].siteName);
                return onlineDevices[0];
            }
            
            // PRIORITÀ 3: Se più online, cerca match utente tra quelli online
            if (onlineDevices.length > 1 && targetNormalized) {
                const onlineMatch = onlineDevices.find(d => {
                    const deviceUser = normalizeUser(d.lastLoggedInUser);
                    return deviceUser.includes(targetNormalized) || targetNormalized.includes(deviceUser);
                });
                if (onlineMatch) return onlineMatch;
            }
            
            // PRIORITÀ 4: Dispositivo più recente
            const sorted = devices.sort((a, b) => {
                const aTime = new Date(a.lastSeen || 0).getTime();
                const bTime = new Date(b.lastSeen || 0).getTime();
                return bTime - aTime;
            });
            console.log('[WARN] Nessun match utente, uso più recente:', sorted[0].siteName);
            return sorted[0];
        };
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/devices/search/${encodeURIComponent(hostname)}`, {
                headers: getAuthHeaders()
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const result = await response.json();
            
            if (result.success && result.data) {
                console.log('[OK] DattoRMM risposta:', Array.isArray(result.data) ? result.data.length + ' dispositivi' : 'singolo');
                
                // Seleziona il dispositivo corretto
                let deviceData;
                if (Array.isArray(result.data)) {
                    deviceData = selectCorrectDevice(result.data, userName);
                } else {
                    deviceData = result.data;
                }
                
                if (!deviceData) throw new Error('Nessun dispositivo trovato');
                
                console.log('[OK] Dispositivo selezionato:', deviceData.siteName, '- Utente:', deviceData.lastLoggedInUser);
                console.log('[OK] Device data completa:', JSON.stringify(deviceData, null, 2));
                
                // Estrai TUTTI i dati utili dal dispositivo per l'analisi AI
                // Log dettagliato di tutti i campi disponibili per debug
                console.log('[DEBUG] Campi disponibili in deviceData:', Object.keys(deviceData));
                
                const deviceModel = deviceData.model || deviceData.deviceModel || deviceData.systemModel || 
                                   deviceData.systemInfo?.model || deviceData.hardware?.model || '';
                const chassisType = deviceData.chassisType || deviceData.deviceType || deviceData.type || 
                                   deviceData.systemInfo?.chassisType || deviceData.enclosureType || '';
                const manufacturer = deviceData.manufacturer || deviceData.vendor || deviceData.make || 
                                    deviceData.systemInfo?.manufacturer || deviceData.brand || '';
                const operatingSystem = deviceData.operatingSystem || deviceData.os || deviceData.osName ||
                                       deviceData.systemInfo?.operatingSystem || '';
                
                console.log('[DEBUG] Dati estratti per AI:', {
                    model: deviceModel,
                    chassisType: chassisType,
                    manufacturer: manufacturer,
                    operatingSystem: operatingSystem,
                    hostname: hostname
                });
                
                // USA SEMPRE l'hostname originale della richiesta (quello passato dall'URL)
                // perché Datto RMM potrebbe restituire dati generici
                const hostnameForAI = hostname; // hostname originale dalla richiesta
                
                // Chiama AI con TUTTI i dati disponibili da Datto RMM
                const hwResult = await deduceFormFactorWithAI({
                    model: deviceModel,
                    hostname: hostnameForAI,  // Sempre l'hostname originale
                    chassisType: chassisType,
                    manufacturer: manufacturer,
                    operatingSystem: operatingSystem
                });
                
                const formFactor = hwResult.formFactor;
                const model = hwResult.model;
                const aiDetectedHardware = hwResult.aiDetected || false;
                const aiSuggestedConnection = hwResult.connectionType || null;
                
                // ===== RILEVAMENTO CONNESSIONE DA DATTO RMM =====
                // Datto RMM può fornire info sugli adattatori di rete attivi
                // tramite UDF (User Defined Fields) o campi specifici
                
                let connectionType = null;
                let connectionSource = 'dedotto'; // 'rilevato' se da API, 'dedotto' se da hardware
                
                // PRIORITÀ 1: Campo UDF specifico (es. udf5 con valore "LAN" o "Wi-Fi")
                // Questo è il dato più preciso - viene da uno script PowerShell su Datto
                const udfConnection = deviceData.udf5 || deviceData.udf_connection || deviceData.connectionTypeUDF || '';
                if (udfConnection) {
                    const udfLower = udfConnection.toLowerCase();
                    if (udfLower === 'lan' || udfLower === 'ethernet' || udfLower === 'cavo') {
                        connectionType = 'LAN';
                        connectionSource = 'rilevato';
                        console.log('[NET] ✓ Connessione da UDF Datto: LAN');
                    } else if (udfLower === 'wi-fi' || udfLower === 'wifi' || udfLower === 'wireless') {
                        connectionType = 'Wi-Fi';
                        connectionSource = 'rilevato';
                        console.log('[NET] ✓ Connessione da UDF Datto: Wi-Fi');
                    }
                }
                
                // PRIORITÀ 2: Analisi adattatori di rete attivi
                // Datto RMM fornisce l'elenco delle schede di rete
                const networkAdapters = deviceData.networkAdapters || deviceData.adapters || deviceData.networkInterfaces || [];
                const activeConnection = deviceData.activeConnection || deviceData.networkConnection || deviceData.primaryAdapter || '';
                const ipAddresses = deviceData.ipAddresses || deviceData.ips || deviceData.networkAddresses || null;
                
                // PRIORITÀ 2A: Analisi standard degli adattatori (veloce, dato Datto certo: mediaType 802.11/802.3)
                if (!connectionType && Array.isArray(networkAdapters) && networkAdapters.length > 0) {
                    // Cerca adattatori attivi (Status = Up, o con IP assegnato)
                    const activeAdapters = networkAdapters.filter(adapter => {
                        const status = (adapter.status || adapter.state || '').toLowerCase();
                        const hasIP = adapter.ipAddress || adapter.ip || adapter.ipv4;
                        return status === 'up' || status === 'connected' || status === 'active' || hasIP;
                    });
                    
                    // Ordina per metrica (priorità) se disponibile
                    activeAdapters.sort((a, b) => (a.interfaceMetric || 999) - (b.interfaceMetric || 999));
                    
                    // Prendi l'adattatore con priorità più alta
                    const primaryAdapter = activeAdapters[0];
                    if (primaryAdapter) {
                        const adapterName = (primaryAdapter.name || primaryAdapter.description || primaryAdapter.interfaceDescription || '').toLowerCase();
                        const mediaType = (primaryAdapter.mediaType || primaryAdapter.interfaceType || '').toLowerCase();
                        
                        // 802.11 = Wi-Fi, 802.3 = Ethernet
                        if (mediaType.includes('802.11') || mediaType.includes('wireless') ||
                            adapterName.includes('wi-fi') || adapterName.includes('wifi') || 
                            adapterName.includes('wireless') || adapterName.includes('wlan')) {
                            connectionType = 'Wi-Fi';
                            connectionSource = 'rilevato';
                            console.log('[NET] ✓ Connessione da adattatore:', adapterName);
                        } else if (mediaType.includes('802.3') || mediaType.includes('ethernet') ||
                                   adapterName.includes('ethernet') || adapterName.includes('lan') ||
                                   adapterName.includes('realtek') || adapterName.includes('intel') && !adapterName.includes('wireless')) {
                            connectionType = 'LAN';
                            connectionSource = 'rilevato';
                            console.log('[NET] ✓ Connessione da adattatore:', adapterName);
                        }
                    }
                }
                
                // PRIORITÀ 2B: Se ANCORA indeterminato, usa l'AI per analizzare i dati di rete LIVE
                if (!connectionType && (networkAdapters.length > 0 || activeConnection)) {
                    console.log('[NET] 🤖 Chiamo AI per analisi LIVE della connessione (caso incerto)...');
                    
                    const aiNetResult = await analyzeNetworkConnectionWithAI({
                        adapters: networkAdapters,
                        activeConnection: activeConnection,
                        ipAddresses: ipAddresses,
                        browserConnection: {
                            type: browserDetection.connectionType,
                            effectiveType: browserDetection.connTypeSource
                        }
                    });
                    
                    if (aiNetResult && aiNetResult.connectionType) {
                        connectionType = aiNetResult.connectionType;
                        connectionSource = 'rilevato-ai-live';
                        console.log('[NET] 🤖✅ Connessione LIVE da AI:', connectionType, '- Adattatore:', aiNetResult.adapterName);
                    }
                }
                
                // Fallback: campo activeConnection generico
                if (!connectionType && activeConnection) {
                    const connLower = activeConnection.toLowerCase();
                    if (connLower.includes('ethernet') || connLower.includes('lan') || connLower.includes('cavo') || connLower.includes('wired') || connLower.includes('802.3')) {
                        connectionType = 'LAN';
                        connectionSource = 'rilevato';
                        console.log('[NET] ✓ Connessione da campo API:', activeConnection);
                    } else if (connLower.includes('wi-fi') || connLower.includes('wifi') || connLower.includes('wireless') || connLower.includes('wlan') || connLower.includes('802.11')) {
                        connectionType = 'Wi-Fi';
                        connectionSource = 'rilevato';
                        console.log('[NET] ✓ Connessione da campo API:', activeConnection);
                    }
                }
                
                // PRIORITÀ 3: Rilevamento da Browser API (navigator.connection)
                if (!connectionType && browserDetection.connectionType) {
                    connectionType = browserDetection.connectionType;
                    connectionSource = browserDetection.connTypeSource || 'browser-api';
                    console.log('[NET] ✓ Connessione da browser API:', connectionType);
                }
                
                // PRIORITÀ 4: Suggerimento dall'AI (se disponibile)
                if (!connectionType && aiSuggestedConnection) {
                    connectionType = aiSuggestedConnection;
                    connectionSource = 'ai-suggerito';
                    console.log('[NET] 🤖 Connessione suggerita da AI:', connectionType);
                }
                
                // PRIORITÀ 5: Deduzione dal tipo hardware (fallback)
                if (!connectionType && formFactor) {
                    connectionType = formFactor === 'fisso' ? 'LAN' : 'Wi-Fi';
                    connectionSource = 'dedotto';
                    console.log('[NET] ~ Connessione dedotta da hardware:', connectionType, '(', formFactor, ')');
                }
                
                // ===== RILEVAMENTO AZIENDA (siteName) con FALLBACK MULTIPLI =====
                const detectSiteName = () => {
                    // PRIORITÀ 1: siteName diretto dalla risposta Datto RMM
                    if (deviceData.siteName && deviceData.siteName.trim()) {
                        console.log('[AZIENDA] ✅ Da Datto RMM siteName:', deviceData.siteName);
                        return deviceData.siteName.trim();
                    }
                    
                    // PRIORITÀ 2: site.name (struttura alternativa)
                    if (deviceData.site?.name && deviceData.site.name.trim()) {
                        console.log('[AZIENDA] ✅ Da Datto RMM site.name:', deviceData.site.name);
                        return deviceData.site.name.trim();
                    }
                    
                    // PRIORITÀ 3: companyName
                    if (deviceData.companyName && deviceData.companyName.trim()) {
                        console.log('[AZIENDA] ✅ Da Datto RMM companyName:', deviceData.companyName);
                        return deviceData.companyName.trim();
                    }
                    
                    // PRIORITÀ 4: organizationName
                    if (deviceData.organizationName && deviceData.organizationName.trim()) {
                        console.log('[AZIENDA] ✅ Da Datto RMM organizationName:', deviceData.organizationName);
                        return deviceData.organizationName.trim();
                    }
                    
                    // PRIORITÀ 5: Estrai dal dominio dell'utente (DOMAIN\user)
                    const lastUser = deviceData.lastLoggedInUser || userName || '';
                    if (lastUser.includes('\\')) {
                        const domain = lastUser.split('\\')[0].toUpperCase();
                        // Ignora domini generici
                        if (!['WORKGROUP', 'LOCALHOST', 'NT AUTHORITY', 'BUILTIN'].includes(domain)) {
                            console.log('[AZIENDA] ~ Dedotto da dominio utente:', domain);
                            return domain;
                        }
                    }
                    
                    // PRIORITÀ 6: Estrai dal nome PC (se contiene prefisso azienda)
                    // Es: PC-86BIT-001 → 86BIT, ACME-PC01 → ACME
                    const pcName = hostname.toUpperCase();
                    const pcParts = pcName.split(/[-_]/);
                    if (pcParts.length >= 2) {
                        // Cerca una parte che non sia "PC", "NB", "WS", numeri, ecc.
                        const companyPart = pcParts.find(part => 
                            part.length >= 3 && 
                            !/^(PC|NB|WS|DT|LT|SRV|\d+)$/i.test(part) &&
                            !/^\d+$/.test(part)
                        );
                        if (companyPart) {
                            console.log('[AZIENDA] ~ Dedotto da nome PC:', companyPart);
                            return companyPart;
                        }
                    }
                    
                    // PRIORITÀ 7: UDF fields (campi personalizzati Datto)
                    const udfCompany = deviceData.udf1 || deviceData.udf_company || deviceData.udf_azienda || '';
                    if (udfCompany && udfCompany.trim()) {
                        console.log('[AZIENDA] ~ Da UDF:', udfCompany);
                        return udfCompany.trim();
                    }
                    
                    console.log('[AZIENDA] ⚠️ Nessuna azienda rilevata');
                    return '';
                };
                
                const detectedSiteName = detectSiteName();

                // 🏢 DOMINIO / ACTIVE DIRECTORY (da audit Datto RMM os.domain / os.workgroup, o UDF)
                const rawDomain = (deviceData.domain || deviceData.os?.domain || deviceData.systemInfo?.domain || deviceData.udf11 || '').toString().trim();
                const rawWorkgroup = (deviceData.workgroup || deviceData.os?.workgroup || '').toString().trim();
                const hostUpper = (deviceData.hostname || hostname || '').toString().toUpperCase();
                let isDomainJoined = null; // null = sconosciuto
                if (rawDomain) {
                    const d = rawDomain.toUpperCase();
                    const isWorkgroupVal = ['WORKGROUP', 'MSHOME', 'GRUPPO DI LAVORO'].includes(d) || d === hostUpper;
                    isDomainJoined = !isWorkgroupVal;
                } else if (rawWorkgroup) {
                    isDomainJoined = false;
                }
                console.log('[RMM] 🏢 Dominio:', rawDomain || rawWorkgroup || 'n/d', '| In dominio:', isDomainJoined);

                return {
                    ...deviceData,
                    siteName: detectedSiteName, // Usa il siteName rilevato con fallback
                    formFactor: formFactor,
                    deviceModel: model,
                    connectionType: connectionType,
                    connectionSource: connectionSource, // 'rilevato' o 'dedotto'
                    domain: rawDomain,
                    isDomainJoined: isDomainJoined
                };
            }
            throw new Error('Device not found');
        } catch (error) {
            console.error('[ERR] Errore DattoRMM:', error);
            
            // Chiama AI anche nel fallback, passando solo l'hostname disponibile
            const hwResult = await deduceFormFactorWithAI({
                model: '',
                hostname: hostname,
                chassisType: '',
                manufacturer: '',
                operatingSystem: ''
            });
            const formFactor = hwResult.formFactor;
            const model = hwResult.model;
            const aiSuggestedConnection = hwResult.connectionType || null;
            
            // Priorità alla connessione suggerita da AI, altrimenti deduci da hardware
            let connectionType = aiSuggestedConnection;
            if (!connectionType && formFactor) {
                connectionType = formFactor === 'fisso' ? 'LAN' : formFactor === 'notebook' ? 'Wi-Fi' : null;
            }
            
            // Tenta di dedurre l'azienda dal nome PC o dall'utente
            let fallbackSiteName = '';
            
            // Dal dominio utente (DOMAIN\user)
            if (userName && userName.includes('\\')) {
                const domain = userName.split('\\')[0].toUpperCase();
                if (!['WORKGROUP', 'LOCALHOST', 'NT AUTHORITY', 'BUILTIN'].includes(domain)) {
                    fallbackSiteName = domain;
                    console.log('[AZIENDA] ~ Fallback da dominio:', fallbackSiteName);
                }
            }
            
            // Dal nome PC
            if (!fallbackSiteName && hostname) {
                const pcParts = hostname.toUpperCase().split(/[-_]/);
                if (pcParts.length >= 2) {
                    const companyPart = pcParts.find(part => 
                        part.length >= 3 && 
                        !/^(PC|NB|WS|DT|LT|SRV|\d+)$/i.test(part) &&
                        !/^\d+$/.test(part)
                    );
                    if (companyPart) {
                        fallbackSiteName = companyPart;
                        console.log('[AZIENDA] ~ Fallback da nome PC:', fallbackSiteName);
                    }
                }
            }
            
            return {
                hostname: hostname.toUpperCase(),
                online: true,
                lastLoggedInUser: userName || 'unknown',
                operatingSystem: 'Windows 11 Pro',
                antivirus: { antivirusProduct: 'Windows Defender', antivirusStatus: 'Attivo' },
                siteName: fallbackSiteName,
                formFactor: formFactor,
                deviceModel: model,
                connectionType: connectionType,
                connectionSource: 'dedotto' // Sempre dedotto in caso di errore API
            };
        }
    },

    // VIRUSTOTAL SCAN FILE - REALE
    // POST /api/v1/antivirus/scan con "file" come campo form
    scanFile: async (file) => {
        console.log('[FILE] Scansione file VirusTotal:', file.name);
        try {
            const formData = new FormData();
            formData.append('file', file);
            
            // Per FormData, non includiamo Content-Type (il browser lo imposta automaticamente)
            const token = getAuthToken();
            const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
            
            const response = await fetch(`${API_BASE_URL}/api/v1/antivirus/scan/file`, {
                method: 'POST',
                headers,
                body: formData
            });
            
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const result = await response.json();
            console.log('[OK] VirusTotal scan submitted:', result);
            
            if (result.analysis_id) {
                const finalResult = await pollVirusTotalReport(result.analysis_id);
                return finalResult;
            }
            
            return result;
        } catch (error) {
            console.error('❌ Errore VirusTotal file scan:', error);
            return { 
                error: true, 
                message: 'Errore durante la scansione del file',
                stats: { malicious: 0, suspicious: 0, undetected: 0, harmless: 0 } 
            };
        }
    },

    // VIRUSTOTAL SCAN URL - REALE
    // POST /api/v1/antivirus/scan con "url" nel body
    scanUrl: async (url) => {
        console.log('[WEB] Scansione URL VirusTotal:', url);
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/antivirus/scan/url`, {
                method: 'POST',
                headers: getAuthHeaders(),
                body: JSON.stringify({ url })
            });
            
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const result = await response.json();
            console.log('[OK] VirusTotal URL scan submitted:', result);
            
            if (result.analysis_id) {
                const finalResult = await pollVirusTotalReport(result.analysis_id);
                return finalResult;
            }
            
            return result;
        } catch (error) {
            console.error('❌ Errore VirusTotal URL scan:', error);
            return { 
                error: true, 
                message: 'Errore durante la scansione dell\'URL',
                stats: { malicious: 0, suspicious: 0, undetected: 0, harmless: 0 } 
            };
        }
    },

    // EMAIL BREACH - Mock
    checkEmailBreaches: async (email) => {
        await new Promise(r => setTimeout(r, 1000));
        if (email.includes('test') || email.includes('compromessa')) {
            return { found: true, count: 3, breaches: ['Adobe', 'LinkedIn', 'MyFitnessPal'] };
        }
        return { found: false, count: 0, breaches: [] };
    },

    // PASSWORD GENERATOR - Local
    generatePassword: async (length = 16, options = {}) => {
        const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lower = 'abcdefghijklmnopqrstuvwxyz';
        const numbers = '0123456789';
        const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';
        
        let chars = '';
        let password = '';
        
        if (options.uppercase !== false) { chars += upper; password += upper[Math.floor(Math.random() * upper.length)]; }
        if (options.lowercase !== false) { chars += lower; password += lower[Math.floor(Math.random() * lower.length)]; }
        if (options.numbers !== false) { chars += numbers; password += numbers[Math.floor(Math.random() * numbers.length)]; }
        if (options.symbols !== false) { chars += symbols; password += symbols[Math.floor(Math.random() * symbols.length)]; }
        
        if (!chars) chars = lower;
        
        while (password.length < length) {
            password += chars[Math.floor(Math.random() * chars.length)];
        }
        
        return password.split('').sort(() => Math.random() - 0.5).join('');
    },

    // PASSWORD ANALYZER - Local
    analyzePassword: async (password) => {
        let score = 0;
        const suggestions = [];
        
        if (password.length >= 8) score += 20;
        if (password.length >= 12) score += 20;
        if (password.length >= 16) score += 10;
        if (/[a-z]/.test(password)) score += 10; else suggestions.push('Aggiungi lettere minuscole');
        if (/[A-Z]/.test(password)) score += 15; else suggestions.push('Aggiungi lettere maiuscole');
        if (/[0-9]/.test(password)) score += 15; else suggestions.push('Aggiungi numeri');
        if (/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(password)) score += 20; else suggestions.push('Aggiungi caratteri speciali');
        if (password.length < 12) suggestions.push('Usa almeno 12 caratteri');
        
        score = Math.min(100, Math.max(0, score));
        let strength = 'Debole';
        if (score >= 75) strength = 'Molto Forte';
        else if (score >= 50) strength = 'Forte';
        else if (score >= 30) strength = 'Moderata';
        
        return { score, strength, suggestions: suggestions.slice(0, 3), has_uppercase: /[A-Z]/.test(password), has_lowercase: /[a-z]/.test(password), has_numbers: /[0-9]/.test(password), has_symbols: /[!@#$%^&*]/.test(password), length: password.length };
    },

    getSecurityTip: async () => {
        const tips = [
            { title: "Usa l'autenticazione a due fattori", content: "Attiva la 2FA su tutti i tuoi account importanti." },
            { title: "Fai backup dei file importanti", content: "Salva i documenti importanti su OneDrive o su cartelle di rete per non perderli." },
            { title: "Attenzione al phishing", content: "Non cliccare su link sospetti nelle email." },
            { title: "Backup regolari", content: "Esegui backup dei tuoi dati almeno settimanalmente." },
            { title: "Password diverse per ogni account", content: "Non riutilizzare le stesse password." }
        ];
        return tips[Math.floor(Math.random() * tips.length)];
    },

    // NOTIFICHE - REALE
    subscribeToNotifications: async (token, userName) => {
        return await NotificationService.subscribeToBackend(token, userName);
    },

    runSpeedTest: async () => {
        await new Promise(r => setTimeout(r, 3000));
        return {
            ping: Math.floor(Math.random() * 40) + 10,
            download: (Math.random() * 100 + 50).toFixed(2),
            upload: (Math.random() * 50 + 20).toFixed(2)
        };
    }
};

// Polling VirusTotal Report - Aumentato timeout per scansioni lunghe
async function pollVirusTotalReport(analysisId, maxAttempts = 60, intervalMs = 3000, onProgress = null) {
    console.log('[WAIT] Polling VirusTotal report per:', analysisId);
    
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            // Aggiorna il progresso se è stata passata una callback
            if (onProgress) {
                onProgress(`Scansione in corso... (${attempt}/${maxAttempts})`);
            }
            
            const response = await fetch(`${API_BASE_URL}/api/v1/antivirus/report/${analysisId}`, {
                headers: getAuthHeaders()
            });
            if (!response.ok) {
                console.warn(`⚠️ HTTP ${response.status} - Riprovo...`);
                throw new Error(`HTTP ${response.status}`);
            }
            
            const result = await response.json();
            console.log(`📊 Polling attempt ${attempt}/${maxAttempts}:`, JSON.stringify(result).substring(0, 200));
            
            const status = result?.data?.attributes?.status;
            const stats = result?.data?.attributes?.stats;
            
            console.log(`📊 Status: ${status}, Stats:`, stats);
            
            if (status === 'completed' && stats) {
                console.log('✅ Scansione completata!', stats);
                return {
                    analysis_id: analysisId,
                    status: 'completed',
                    stats: {
                        malicious: stats.malicious || 0,
                        suspicious: stats.suspicious || 0,
                        undetected: stats.undetected || 0,
                        harmless: stats.harmless || 0,
                        timeout: stats.timeout || 0
                    },
                    results: result.data.attributes.results
                };
            }
            
            // Se lo status è "queued" o altro, aspetta e riprova
            console.log(`⏳ Status "${status}" - aspetto ${intervalMs}ms...`);
            await new Promise(r => setTimeout(r, intervalMs));
        } catch (error) {
            console.error(`❌ Polling error (attempt ${attempt}):`, error.message);
            // Non uscire subito, riprova fino a maxAttempts
            await new Promise(r => setTimeout(r, intervalMs));
        }
    }
    
    console.warn('⏰ Timeout polling - maxAttempts raggiunto');
    return {
        analysis_id: analysisId,
        status: 'timeout',
        message: 'La scansione sta richiedendo più tempo del previsto. Riprova tra qualche minuto.',
        stats: { malicious: 0, suspicious: 0, undetected: 0, harmless: 0 }
    };
}

initializeMockData();

// ============================================================================
// CONTEXT & STATE MANAGEMENT
// ============================================================================
const ChatContext = createContext(null);

const defaultInitialState = {
    messages: [],
    userName: '',
    userEmail: '', // Email utente per ticket e ricerca
    userCompany: '',
    userSiteName: '', // Nome azienda da DattoRMM
    userComputer: '',
    userPCHardwareType: null,
    userDeviceModel: '', // Modello dispositivo da DattoRMM (es. "Latitude 5420")
    userConnectionType: null, // 'LAN' o 'Wi-Fi' - dedotto o da RMM
    userConnectionSource: null, // 'rilevato' (da Datto) o 'dedotto' (da hardware)
    userDomain: '', // Dominio AD da Datto RMM (os.domain), es. "azienda.local"
    isDomainJoined: null, // null = sconosciuto, true = in dominio, false = workgroup/standalone
    currentPhase: 'initializing',
    isLoading: false,
    showModal: false,
    showWelcomeModal: false,
    showBatLaunchWelcomeModal: false,
    showMobileHandoffModal: false,
    showOpenOnPhoneModal: false,
    launchedFromBatch: false, // true se avviato da .bat con pc_name e user_name
    input: '',
    attachment: { data: null, name: '', previewUrl: null, type: null },
    isTtsEnabled: false,
    isListening: false,
    currentlySpeakingMessageId: null,
    showUserDashboard: false,
    showShortcutsModal: false,
    showSearch: false,
    searchQuery: '',
    preferences: { responseStyle: 'detailed', silentMode: false },
    confirmEndSession: false,
    showSecurityModal: false,
    showPcChangeForm: false,
    sparkControl: (() => { try { return JSON.parse(localStorage.getItem('spark-control-v1') || 'null'); } catch (e) { return null; } })(),
    showNotificationModal: false,
    showTicketModal: false,
    jiraRegistered: null, // null=sconosciuto, true/false=stato registrazione Jira dell'utente
    showChatHistory: false,
    showPhoneModal: false,
    showVideoCallModal: false, // Per modal videochiamata Jitsi
    showRemoteSupportModal: false, // Per modal supporto remoto AnyDesk (solo mobile)
    incomingCall: null, // { callerName, roomUrl, roomName } - chiamata in arrivo da Teams
    showInlineHistory: false, // Per mostrare storico inline nella chat
    lastActivityTime: Date.now(), // Per timer inattività
    showInactivityPrompt: false, // Per mostrare prompt inattività
    notificationStatus: 'unknown', // 'unknown', 'granted', 'denied', 'unsupported'
    isMobile: false,
    deviceInfo: null,
    // NUOVE FUNZIONALITÀ
    darkMode: false, // Modalità scura
    showMyTickets: false, // Modal storico ticket utente
    myTickets: [], // Lista ticket dell'utente
    ticketUpdates: [], // Ticket con aggiornamenti IT non letti (notifica badge)
    loadingTickets: false, // Caricamento ticket in corso
    showFeedbackPrompt: false, // Prompt feedback post-risoluzione
    feedbackMessageId: null, // ID messaggio per cui dare feedback
    supportAvailability: null, // Stato disponibilità supporto
    // GESTIONE DATTO RMM
    isDeviceManaged: null, // null = checking, true = gestito, false = non gestito
    rmmCheckComplete: false, // true quando il check RMM è completato
};

// ============================================================================
// CHAT HISTORY STORAGE
// ============================================================================
const CHAT_HISTORY_KEY = 'spark-chat-history-v1';

const loadChatHistory = () => {
    try {
        const saved = localStorage.getItem(CHAT_HISTORY_KEY);
        return saved ? JSON.parse(saved) : [];
    } catch (e) {
        console.error('Errore caricamento storico chat:', e);
        return [];
    }
};

const saveChatHistory = (history) => {
    try {
        localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(history));
    } catch (e) {
        console.error('Errore salvataggio storico chat:', e);
    }
};

const saveCurrentSessionToHistory = (state) => {
    if (!state.messages || state.messages.length < 2) return; // Minimo 2 messaggi per salvare
    
    const history = loadChatHistory();
    const session = {
        id: Date.now().toString(),
        timestamp: new Date().toISOString(),
        userName: state.userName,
        userComputer: state.userComputer,
        userCompany: state.userSiteName || state.userCompany,
        messages: state.messages,
        preview: state.messages.find(m => m.sender === 'user')?.text?.substring(0, 50) || 'Conversazione'
    };
    
    // Aggiungi in cima e mantieni max 50 sessioni
    history.unshift(session);
    if (history.length > 50) history.pop();
    
    saveChatHistory(history);
    console.log('[HISTORY] Sessione salvata nello storico:', session.id);
};

const getDateGroup = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const lastWeek = new Date(today);
    lastWeek.setDate(lastWeek.getDate() - 7);
    const lastMonth = new Date(today);
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    
    if (date >= today) return 'Oggi';
    if (date >= yesterday) return 'Ieri';
    if (date >= lastWeek) return 'Ultima settimana';
    if (date >= lastMonth) return 'Mese scorso';
    return 'Più vecchie';
};

const groupChatsByDate = (history) => {
    const groups = {
        'Oggi': [],
        'Ieri': [],
        'Ultima settimana': [],
        'Mese scorso': [],
        'Più vecchie': []
    };
    
    history.forEach(session => {
        const group = getDateGroup(session.timestamp);
        groups[group].push(session);
    });
    
    return groups;
};

function chatReducer(state, action) {
    switch (action.type) {
        case 'ADD_MESSAGE':
            // Aggiungi timestamp se non presente
            const messageWithTimestamp = {
                ...action.payload,
                timestamp: action.payload.timestamp || Date.now()
            };
            return { ...state, messages: [...state.messages, messageWithTimestamp] };
        case 'UPDATE_LAST_MESSAGE':
            const newMessages = [...state.messages];
            newMessages[newMessages.length - 1] = { ...newMessages[newMessages.length - 1], ...action.payload };
            return { ...state, messages: newMessages };
        case 'APPEND_TO_LAST_MESSAGE':
            const msgs = [...state.messages];
            msgs[msgs.length - 1].text += action.payload;
            return { ...state, messages: msgs };
        case 'SET_STATE':
            return { ...state, ...action.payload };
        case 'RESET_INPUT':
            return { ...state, input: '', attachment: { data: null, name: '', previewUrl: null, type: null } };
        case 'RESET_SESSION':
            // Salva la sessione corrente nello storico prima di resettare
            saveCurrentSessionToHistory(state);
            localStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
            localStorage.removeItem(USER_DETAILS_STORAGE_KEY);
            return { ...defaultInitialState, messages: [], currentPhase: 'initializing' };
        case 'LOAD_HISTORY_SESSION':
            // Carica una sessione dallo storico
            const session = action.payload;
            return {
                ...state,
                messages: session.messages || [],
                userName: session.userName || state.userName,
                userComputer: session.userComputer || state.userComputer,
                userCompany: session.userCompany || state.userCompany,
                showChatHistory: false,
                currentPhase: 'chat'
            };
        default:
            throw new Error(`Azione non gestita: ${action.type}`);
    }
}

const ChatProvider = ({ children }) => {
    const [state, dispatch] = useReducer(chatReducer, defaultInitialState, (initialState) => {
        // ============================================================
        // Usa i parametri salvati all'avvio (URL già pulito)
        // ============================================================
        const sparkUrlParams = (typeof window !== 'undefined' && window.__SPARK_URL_PARAMS__) || {};
        const pcNameFromUrl = sparkUrlParams.pc_name;
        const userNameFromUrl = sparkUrlParams.user_name;
        const companyFromUrl = sparkUrlParams.company;

        // ============================================================
        // HANDOFF MOBILE via QR: apre Spark sul telefono gia' riconosciuto
        // Mostra una conferma veloce ("Sei X di Y?") prima di entrare in chat
        // ============================================================
        const handoff = (typeof window !== 'undefined' && window.__SPARK_HANDOFF__) || null;
        if (handoff && handoff.n) {
            // Se esiste gia' una sessione salvata (stesso utente/email) entra diretto SENZA conferma.
            // Serve per la PWA in Home: dopo la prima conferma non richiede piu' nulla.
            let existingSession = null;
            try {
                const savedJson = localStorage.getItem(CHAT_SESSION_STORAGE_KEY);
                existingSession = savedJson ? JSON.parse(savedJson) : null;
            } catch (e) { existingSession = null; }

            const savedEmail = (() => {
                try { return (localStorage.getItem('spark-user-email-v1') || '').toLowerCase().trim(); } catch (e) { return ''; }
            })();
            const handoffEmail = (handoff.e || '').toLowerCase().trim();
            const sameUser = existingSession && existingSession.userName &&
                (!handoffEmail || !savedEmail || savedEmail === handoffEmail);

            if (sameUser) {
                const validMessages = Array.isArray(existingSession.messages)
                    ? existingSession.messages.filter(m => m && typeof m === 'object' && m.sender)
                    : [];
                return {
                    ...initialState,
                    ...existingSession,
                    messages: validMessages,
                    userName: existingSession.userName || handoff.n,
                    userEmail: existingSession.userEmail || handoff.e || '',
                    userCompany: existingSession.userCompany || handoff.c || '',
                    userSiteName: existingSession.userSiteName || handoff.c || '',
                    launchedFromBatch: true,
                    isLoading: false,
                    notificationStatus: NotificationService.getPermissionStatus(),
                    currentPhase: 'chat',
                    showWelcomeModal: false,
                    showBatLaunchWelcomeModal: false,
                    showMobileHandoffModal: false
                };
            }

            const hs = { ...initialState };
            hs.userName = handoff.n;
            hs.userEmail = handoff.e || '';
            hs.userCompany = handoff.c || '';
            hs.userSiteName = handoff.c || '';
            hs.userComputer = handoff.k || 'Mobile';
            hs.launchedFromBatch = true;
            hs.notificationStatus = NotificationService.getPermissionStatus();
            hs.currentPhase = 'chat';
            hs.showWelcomeModal = false;
            hs.showBatLaunchWelcomeModal = false;
            hs.showMobileHandoffModal = true; // conferma veloce (solo prima volta)
            return hs;
        }
        
        // DEBUG: Verifica che i parametri siano letti
        console.log('[ChatProvider] 🔍 Parametri da __SPARK_URL_PARAMS__:', { 
            pcNameFromUrl, 
            userNameFromUrl, 
            companyFromUrl,
            raw: sparkUrlParams
        });

        // Funzione helper per recuperare dettagli utente salvati
        // Funzione per recuperare dettagli utente salvati - cerca per PC NAME
        const getSavedUserDetails = (pcName) => {
            try {
                const savedDetails = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
                if (savedDetails) {
                    const detailsMap = JSON.parse(savedDetails);
                    const pcKey = pcName?.toLowerCase().replace(/[.\s-]/g, '_') || '';
                    const details = detailsMap[pcKey] || {};
                    
                    // Se non troviamo per PC, cerca in tutte le entry per email
                    if (!details.email) {
                        const savedEmail = localStorage.getItem('spark-user-email-v1') || 
                                          localStorage.getItem('spark-user-email');
                        if (savedEmail) {
                            // Cerca entry con la stessa email
                            for (const key of Object.keys(detailsMap)) {
                                if (detailsMap[key].email === savedEmail) {
                                    console.log("📋 Trovati dati per email:", savedEmail);
                                    return detailsMap[key];
                                }
                            }
                        }
                    }
                    
                    return details;
                }
            } catch (e) {
                console.error('Errore recupero dettagli utente:', e);
                // Pulisci dati corrotti
                try { localStorage.removeItem(USER_DETAILS_STORAGE_KEY); } catch (x) {}
            }
            return {};
        };

        // Funzione helper per pulire localStorage corrotto
        const cleanCorruptedStorage = () => {
            console.warn('🧹 Pulizia localStorage corrotto...');
            try {
                localStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
                localStorage.removeItem(USER_DETAILS_STORAGE_KEY);
            } catch (e) {
                console.error('Errore pulizia localStorage:', e);
            }
        };

        // BAT FILE LAUNCH HANDLING - Mantiene le chat precedenti
        if (pcNameFromUrl && userNameFromUrl) {
            console.log("🚀 Avvio da .bat rilevato:", { pc_name: pcNameFromUrl, user_name: userNameFromUrl });
            
            // Recupera dettagli utente salvati (cerca per PC NAME)
            const savedUserDetails = getSavedUserDetails(pcNameFromUrl);
            console.log("📋 Dettagli salvati per PC", pcNameFromUrl, ":", savedUserDetails);
            
            // Recupera sessione chat salvata
            let savedMessages = [];
            try {
                const savedJson = localStorage.getItem(CHAT_SESSION_STORAGE_KEY);
                const savedChatState = savedJson ? JSON.parse(savedJson) : null;
                
                // Se la sessione salvata è dello stesso utente, recupera i messaggi
                if (savedChatState && savedChatState.userName === userNameFromUrl) {
                    savedMessages = Array.isArray(savedChatState.messages) 
                        ? savedChatState.messages.filter(m => m && typeof m === 'object' && m.sender)
                        : [];
                    console.log("💬 Chat precedente recuperata:", savedMessages.length, "messaggi");
                }
            } catch (e) {
                console.error("Errore recupero chat:", e);
            }
            
            const cleanState = { ...initialState };
            
            // Carica email da localStorage (chiave dedicata o dettagli utente)
            let savedEmail = '';
            try {
                savedEmail = localStorage.getItem('spark-user-email-v1') || 
                             localStorage.getItem('spark-user-email') || 
                             savedUserDetails.email || '';
            } catch (e) {
                console.error('Errore caricamento email:', e);
            }
            
            cleanState.userName = userNameFromUrl;
            cleanState.userComputer = pcNameFromUrl;
            cleanState.launchedFromBatch = true;
            cleanState.userCompany = companyFromUrl || savedUserDetails.company || '';
            cleanState.userSiteName = savedUserDetails.company || '';
            cleanState.userEmail = savedEmail;
            try { cleanState.userPhone = localStorage.getItem('spark-user-phone-v1') || savedUserDetails.phone || ''; } catch (e) { cleanState.userPhone = ''; }
            cleanState.userPCHardwareType = savedUserDetails.hardwareType || '';
            cleanState.userConnectionType = savedUserDetails.connectionType || '';
            cleanState.userConnectionSource = savedUserDetails.connectionSource || '';
            cleanState.notificationStatus = NotificationService.getPermissionStatus();
            
            // IMPORTANTE: Mostra modal SOLO se manca l'email (prima volta in assoluto)
            const emailMissing = !savedEmail || savedEmail.trim() === '';
            
            // ============================================================
            // CONTROLLO MODIFICHE - Confronta dati URL con dati salvati
            // ============================================================
            const savedPC = savedUserDetails.computer || '';
            const savedCompany = savedUserDetails.company || '';
            const savedRealName = savedUserDetails.realName || '';
            const savedHardwareType = savedUserDetails.hardwareType || '';
            const savedConnectionType = savedUserDetails.connectionType || '';
            
            // Verifica se ci sono MODIFICHE rispetto ai dati salvati
            const pcChanged = pcNameFromUrl && savedPC && 
                             pcNameFromUrl.toLowerCase() !== savedPC.toLowerCase();
            const companyChanged = companyFromUrl && savedCompany && 
                                  companyFromUrl.toLowerCase() !== savedCompany.toLowerCase();
            const userChanged = userNameFromUrl && savedRealName && 
                               userNameFromUrl.toLowerCase() !== savedRealName.toLowerCase() &&
                               userNameFromUrl.toLowerCase() !== 'user';
            
            // Log dettagliato delle modifiche
            const changes = [];
            if (pcChanged) changes.push(`PC: "${savedPC}" → "${pcNameFromUrl}"`);
            if (companyChanged) changes.push(`Azienda: "${savedCompany}" → "${companyFromUrl}"`);
            if (userChanged) changes.push(`Utente: "${savedRealName}" → "${userNameFromUrl}"`);
            
            const hasSignificantChanges = pcChanged || companyChanged || userChanged;
            
            if (hasSignificantChanges) {
                console.log("🔄 Rilevate modifiche:", changes.join(', '));
            } else {
                console.log("✅ Nessuna modifica rilevata - dati invariati");
            }
            
            if (emailMissing) {
                // PRIMA VOLTA: Email mancante - mostra modal per richiederla
                cleanState.currentPhase = 'chat';
                cleanState.showWelcomeModal = false;
                cleanState.showBatLaunchWelcomeModal = true;
                console.log("📧 Prima volta - mostro modal per richiedere email");
            } else if (hasSignificantChanges) {
                // MODIFICHE RILEVATE: Mostra modal per confermare i nuovi dati
                cleanState.currentPhase = 'chat';
                cleanState.showWelcomeModal = false;
                cleanState.showBatLaunchWelcomeModal = true;
                console.log("🔄 Modifiche rilevate - mostro modal per confermare");
            } else {
                // EMAIL PRESENTE: Vai diretto in chat (no modal)
                const proactiveGreeting = generateProactiveFollowUp(userNameFromUrl);
                
                cleanState.currentPhase = 'chat';
                cleanState.showWelcomeModal = false;
                cleanState.showBatLaunchWelcomeModal = false;
                
                // Ripristina messaggi salvati o crea saluto proattivo
                if (savedMessages.length > 0) {
                    cleanState.messages = savedMessages;
                    console.log("✅ Chat ripristinata con", savedMessages.length, "messaggi");
                } else {
                    cleanState.messages = [{
                        sender: 'ai',
                        text: proactiveGreeting.greeting,
                        type: 'system-prompt',
                        id: Date.now(),
                        hasFollowUp: proactiveGreeting.hasFollowUp,
                        followUpData: proactiveGreeting.followUpData || null
                    }];
                    console.log("✅ Utente di ritorno - vai diretto in chat");
                }
                
                // Aggiorna memoria cross-session
                try {
                    updateCrossSessionMemory({});
                } catch (e) {
                    console.warn('Errore aggiornamento memoria cross-session:', e);
                }
            }
            
            return cleanState;
        }

        // RIPRISTINO SESSIONE - Mantiene le chat precedenti come prima
        try {
            const savedJson = localStorage.getItem(CHAT_SESSION_STORAGE_KEY);
            const savedState = savedJson ? JSON.parse(savedJson) : null;
            
            // Verifica che savedState sia un oggetto valido
            if (savedState && typeof savedState === 'object' && savedState.userName) {
                console.log('[INIT] Sessione utente trovata:', savedState.userName, '- messaggi:', savedState.messages?.length || 0);
                
                // Verifica integrità messaggi
                const validMessages = Array.isArray(savedState.messages) 
                    ? savedState.messages.filter(m => m && typeof m === 'object' && m.sender)
                    : [];
                
                // Ripristina sessione con tutti i messaggi
                const recoveredState = { 
                    ...initialState, 
                    ...savedState,
                    messages: validMessages,
                    isLoading: false, 
                    currentPhase: 'chat',
                    showWelcomeModal: false,
                    notificationStatus: NotificationService.getPermissionStatus()
                };
                
                return recoveredState;
            }
        } catch (error) {
            console.error("Impossibile caricare la sessione:", error);
            cleanCorruptedStorage();
        }
        
        // Nessun batch file e nessuna sessione salvata -> mostra schermata LOGIN (non WelcomeModal)
        console.log('[INIT] Nessun batch, nessuna sessione -> mostro schermata LOGIN');
        const newState = { 
            ...initialState, 
            notificationStatus: NotificationService.getPermissionStatus(),
            showWelcomeModal: false,
            currentPhase: 'login'  // Vai alla schermata di login standard
        };
        return newState;
    });

    // --- Firebase Messaging Setup (come nel codice funzionante) ---
    const app = useMemo(() => initializeApp(firebaseConfig), []);
    const messaging = useMemo(() => getMessaging(app), [app]);

    // --- SAFETY CHECK: Vai a login se non abbiamo userName ---
    useEffect(() => {
        // Se non c'è nessun utente e nessun modal aperto e non è login, vai a login
        if (!state.userName && !state.showWelcomeModal && !state.showBatLaunchWelcomeModal && state.currentPhase !== 'login') {
            console.log('[SAFETY] Nessun utente rilevato, vado a schermata LOGIN');
            dispatch({ type: 'SET_STATE', payload: { currentPhase: 'login' } });
        }
        
        // Se c'è userName ma currentPhase è sbagliato, vai in chat
        if (state.userName && state.currentPhase === 'initializing') {
            console.log('[SAFETY] Utente presente ma phase initializing, vado in chat');
            dispatch({ type: 'SET_STATE', payload: { currentPhase: 'chat' } });
        }
    }, [state.userName, state.showWelcomeModal, state.showBatLaunchWelcomeModal, state.currentPhase, dispatch]);

    // --- Rilevamento Dispositivo Mobile ---
    useEffect(() => {
        const checkDeviceType = () => {
            // Se la larghezza è inferiore a 768px, viene considerato mobile
            const isMobileDevice = window.innerWidth < 768;
            if (state.isMobile !== isMobileDevice) {
                dispatch({ type: 'SET_STATE', payload: { isMobile: isMobileDevice } });
            }
        };
        
        checkDeviceType();
        window.addEventListener('resize', checkDeviceType);
        
        return () => window.removeEventListener('resize', checkDeviceType);
    }, [state.isMobile]);

    // --- Manifest PWA dinamico: start_url con handoff "m" per restare autorizzati dall'icona Home ---
    // Su iOS lo saltiamo: iOS usa l'URL corrente della pagina (che mantiene ?m=) per la web-clip
    useEffect(() => {
        if (!state.launchedFromBatch || !state.userName) return;
        const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS) return;
        try {
            const token = encodeHandoff({
                n: state.userName,
                c: state.userCompany || state.userSiteName || '',
                e: state.userEmail || (localStorage.getItem('spark-user-email-v1') || ''),
            });
            if (!token) return;
            const manifest = {
                name: '86BIT Spark',
                short_name: '86BIT Spark',
                description: 'IT Service Desk Assistant di 86BIT',
                start_url: `/?m=${token}`,
                scope: '/',
                display: 'standalone',
                background_color: '#1e3a5f',
                theme_color: '#1e3a5f',
                orientation: 'portrait',
                icons: [
                    { src: '/spark-icon-192-v3.png', sizes: '192x192', type: 'image/png', purpose: 'any maskable' },
                    { src: '/spark-icon-512-v3.png', sizes: '512x512', type: 'image/png', purpose: 'any maskable' }
                ],
                categories: ['business', 'productivity'],
                lang: 'it-IT'
            };
            const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' });
            const url = URL.createObjectURL(blob);
            let link = document.querySelector('link[rel="manifest"]');
            if (!link) {
                link = document.createElement('link');
                link.rel = 'manifest';
                document.head.appendChild(link);
            }
            link.setAttribute('href', url);
        } catch (e) { /* no-op */ }
    }, [state.launchedFromBatch, state.userName, state.userEmail, state.userCompany, state.userSiteName]);


    // --- Caricamento Dark Mode da localStorage ---
    useEffect(() => {
        try {
            const savedDarkMode = localStorage.getItem('spark-dark-mode');
            if (savedDarkMode !== null) {
                const darkMode = JSON.parse(savedDarkMode);
                if (darkMode !== state.darkMode) {
                    dispatch({ type: 'SET_STATE', payload: { darkMode } });
                }
            }
        } catch (e) {
            console.error('Errore caricamento dark mode:', e);
        }
    }, []); // Solo al mount

    // Recupera automaticamente siteName e formFactor da DattoRMM se mancanti
    // E IMPOSTA isDeviceManaged in base al risultato
    useEffect(() => {
        const fetchDeviceInfo = async () => {
            // Se abbiamo userComputer, controlliamo se è gestito da Datto RMM
            if (state.userComputer && !state.rmmCheckComplete) {
                console.log('[RMM] Verifica dispositivo gestito per:', state.userComputer);
                
                // Timeout di 5 secondi per la verifica RMM
                const timeoutPromise = new Promise((_, reject) => 
                    setTimeout(() => reject(new Error('Timeout RMM check')), 5000)
                );
                
                try {
                    const deviceInfo = await Promise.race([
                        MOCK_API.getDeviceInfo(state.userComputer, state.userName),
                        timeoutPromise
                    ]);
                    
                    const updatePayload = {
                        rmmCheckComplete: true,
                        isDeviceManaged: false // Default: non gestito
                    };
                    
                    // Se abbiamo una risposta valida con siteName, il dispositivo è gestito
                    if (deviceInfo && deviceInfo.siteName) {
                        console.log('[RMM] ✅ Dispositivo GESTITO - Azienda:', deviceInfo.siteName);
                        updatePayload.isDeviceManaged = true;
                        updatePayload.userSiteName = deviceInfo.siteName;
                    } else {
                        console.log('[RMM] ⚠️ Dispositivo NON GESTITO - nessuna info da Datto');
                    }
                    
                    // Solo se formFactor è determinato (non null)
                    if (deviceInfo?.formFactor && !state.userPCHardwareType) {
                        const hwType = deviceInfo.formFactor;
                        console.log('[RMM] formFactor recuperato:', hwType);
                        updatePayload.userPCHardwareType = hwType;
                    }
                    
                    // Solo se connectionType è determinato (non null)
                    if (deviceInfo?.connectionType && !state.userConnectionType) {
                        console.log('[RMM] connectionType recuperato:', deviceInfo.connectionType);
                        updatePayload.userConnectionType = deviceInfo.connectionType;
                        updatePayload.userConnectionSource = deviceInfo.connectionSource || 'dedotto';
                    }

                    // Dominio / Active Directory da Datto RMM
                    if (deviceInfo?.isDomainJoined !== null && deviceInfo?.isDomainJoined !== undefined) {
                        updatePayload.isDomainJoined = deviceInfo.isDomainJoined;
                        updatePayload.userDomain = deviceInfo.domain || '';
                        console.log('[RMM] 🏢 In dominio:', deviceInfo.isDomainJoined, '| Dominio:', deviceInfo.domain || 'n/d');
                    }
                    
                    dispatch({ type: 'SET_STATE', payload: updatePayload });
                    
                    // Salva anche in localStorage per visite future
                    if (state.userName && deviceInfo?.siteName) {
                        try {
                            const savedDetails = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
                            const detailsMap = savedDetails ? JSON.parse(savedDetails) : {};
                            const userKey = state.userName.toLowerCase().replace(/[.\s]/g, '_');
                            const saveData = {
                                ...detailsMap[userKey],
                                company: deviceInfo.siteName,
                                computer: state.userComputer,
                                isManaged: true,
                                lastSeen: new Date().toISOString()
                            };
                            if (deviceInfo.formFactor) saveData.hardwareType = deviceInfo.formFactor;
                            if (deviceInfo.connectionType) {
                                saveData.connectionType = deviceInfo.connectionType;
                                saveData.connectionSource = deviceInfo.connectionSource || 'dedotto';
                            }
                            detailsMap[userKey] = saveData;
                            localStorage.setItem(USER_DETAILS_STORAGE_KEY, JSON.stringify(detailsMap));
                        } catch (e) {
                            console.error('Errore salvataggio dettagli:', e);
                        }
                    }
                } catch (error) {
                    console.error('[RMM] ❌ Errore verifica dispositivo:', error.message);
                    // In caso di errore o timeout, segna come non gestito
                    dispatch({ type: 'SET_STATE', payload: { 
                        rmmCheckComplete: true, 
                        isDeviceManaged: false 
                    }});
                }
            }
        };
        
        fetchDeviceInfo();
    }, [state.userComputer, state.rmmCheckComplete, state.userPCHardwareType, state.userConnectionType, state.userName, dispatch]);

    useEffect(() => {
        if (!messaging) return;

        const unsubscribe = onMessage(messaging, (payload) => {
            console.log("📩 Messaggio ricevuto in primo piano:", payload);
            const { title, body, image } = payload.notification || {};
            const url = payload.data?.url;
            
            // Aggiungi messaggio alla chat
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    sender: 'ai',
                    text: `**${title || 'Notifica da 86BIT'}**\n\n${body || 'Nuova notifica!'}`,
                    type: 'system-prompt',
                    id: Date.now() + Math.random()
                }
            });

            // Mostra notifica nativa del browser
            if (Notification.permission === 'granted') {
                const notification = new Notification(title || "Spark Admin", {
                    body: body,
                    icon: image || SPARK_AVATAR_BASE64,
                });
                notification.onclick = () => {
                    if (url) window.open(url, "_blank");
                    else window.focus();
                };
            }
        });

        return () => unsubscribe();
    }, [messaging, dispatch]);

    // --- Auto-subscribe se il permesso è già granted ---
    useEffect(() => {
        const autoSubscribe = async () => {
            // Verifica se le notifiche sono supportate e se il permesso è già granted
            if (!('Notification' in window) || !messaging) return;
            
            if (Notification.permission === 'granted') {
                console.log('🔔 Permesso notifiche già granted, sottoscrivo automaticamente...');
                try {
                    await navigator.serviceWorker.register('/firebase-messaging-sw.js');
                    const registration = await navigator.serviceWorker.ready;
                    
                    const token = await getToken(messaging, {
                        vapidKey: VAPID_KEY,
                        serviceWorkerRegistration: registration,
                    });

                    if (token) {
                        // Token FCM ottenuto - invia al backend
                        await fetch(`${API_BASE_URL}/api/v1/notification/subscribe`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ 
                                token, 
                                userName: state.userName || 'Utente Sconosciuto',
                                userComputer: state.userComputer || 'Unknown',
                                userCompany: state.userSiteName || state.userCompany || '',
                                userEmail: state.userEmail || localStorage.getItem('spark-user-email-v1') || ''
                            }),
                        });
                        dispatch({ type: 'SET_STATE', payload: { notificationStatus: 'granted' } });
                        console.log('✅ Sottoscrizione FCM automatica completata');
                    }
                } catch (err) {
                    console.error('❌ Errore sottoscrizione automatica FCM:', err);
                }
            } else {
                dispatch({ type: 'SET_STATE', payload: { notificationStatus: Notification.permission } });
            }
        };

        // Esegui solo quando abbiamo un userName (utente loggato)
        if (state.userName && state.currentPhase === 'chat') {
            autoSubscribe();
        }
    }, [messaging, state.userName, state.userComputer, state.userSiteName, state.userCompany, state.userEmail, state.currentPhase, dispatch]);

    // Funzione per sottoscrivere a FCM (come nel codice funzionante)
    const subscribeToFcm = useCallback(async () => {
        if (!messaging) {
            console.error("Firebase Messaging non è inizializzato.");
            return { success: false, error: 'Firebase non inizializzato' };
        }
        try {
            await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            const registration = await navigator.serviceWorker.ready;
            
            const token = await getToken(messaging, {
                vapidKey: VAPID_KEY,
                serviceWorkerRegistration: registration,
            });

            if (token) {
                // Salva token in localStorage per riferimento
                localStorage.setItem(FCM_TOKEN_KEY, token);
                
                // Invia token al backend con info utente
                await fetch(`${API_BASE_URL}/api/v1/notification/subscribe`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ 
                        token, 
                        userName: state.userName || 'Utente Sconosciuto',
                        userComputer: state.userComputer || 'Unknown',
                        userCompany: state.userSiteName || state.userCompany || '86BIT',
                        userEmail: state.userEmail || localStorage.getItem('spark-user-email-v1') || ''
                    }),
                });
                dispatch({ type: 'SET_STATE', payload: { notificationStatus: 'granted' } });
                return { success: true, token };
            } else {
                return { success: false, error: 'Nessun token disponibile' };
            }
        } catch (err) {
            console.error("Errore durante la sottoscrizione a FCM:", err);
            return { success: false, error: err.message };
        }
    }, [messaging, state.userName, state.userComputer, state.userSiteName, state.userCompany, state.userEmail]);

    // Polling aggiornamenti ticket: sincronizza con Jira REALE, mostra le novità in chat
    // (cambio stato / risposta del tecnico) + aggiorna badge + notifica browser.
    const prevTicketUpdatesRef = useRef(0);
    const shownUpdateSigRef = useRef(new Set());
    useEffect(() => {
        const email = state.userEmail || localStorage.getItem('spark-user-email-v1');
        if (!email) return;
        let active = true;

        // Dedup persistente tra sessioni: carica le firme già mostrate
        const SHOWN_SIG_KEY = 'spark-shown-ticket-updates-v1';
        try {
            shownUpdateSigRef.current = new Set(JSON.parse(localStorage.getItem(SHOWN_SIG_KEY) || '[]'));
        } catch (e) { shownUpdateSigRef.current = new Set(); }
        const persistShownSigs = () => {
            try { localStorage.setItem(SHOWN_SIG_KEY, JSON.stringify([...shownUpdateSigRef.current].slice(-100))); } catch (e) {}
        };

        const statusEmoji = (s) => {
            const l = (s || '').toLowerCase();
            if (l.includes('risol') || l.includes('chius') || l.includes('complet') || l.includes('done') || l.includes('closed') || l.includes('fine')) return '✅';
            if (l.includes('corso') || l.includes('lavorazione') || l.includes('progress') || l.includes('attesa')) return '🛠️';
            return '📋';
        };

        const poll = async (manual = false) => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/v1/jira/tickets/sync/email/${encodeURIComponent(email)}`);
                const d = await r.json();
                if (!active) return;
                const updates = d.updates || [];
                const unread = d.unread || [];

                // Mostra ogni novità come messaggio in chat (stile chat) + notifica browser
                const isResolvedStatus = (s) => /risol|chius|complet|done|closed|fine/i.test(s || '');
                updates.forEach(u => {
                    // Dedup: non ri-mostrare lo stesso aggiornamento (stesso stato + stessi commenti)
                    const sig = `${u.key}|${u.status}|${(u.new_comments || []).map(c => c.id).join(',')}`;
                    if (shownUpdateSigRef.current.has(sig)) return;
                    shownUpdateSigRef.current.add(sig);
                    persistShownSigs();
                    const resolved = u.status_changed && isResolvedStatus(u.status);
                    let text = `📬 **Aggiornamento sul tuo ticket ${u.key}**\n\n━━━━━━━━━━━━━━━━━━━━\n\n${statusEmoji(u.status)} **${u.summary || 'Ticket'}**`;
                    if (u.status_changed) {
                        text += `\n\n🔄 Nuovo stato: **${u.status}**`;
                    }
                    const hasNewComment = (u.new_comments || []).length > 0;
                    (u.new_comments || []).forEach(c => {
                        text += `\n\n💬 **${c.author || 'Supporto IT 86BIT'}:**\n${c.body}`;
                    });
                    text += hasNewComment
                        ? `\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 Puoi rispondere direttamente qui in chat oppure dalla sezione 📋 **I miei ticket** in alto.`
                        : `\n\n━━━━━━━━━━━━━━━━━━━━\n\n💡 Trovi tutti i tuoi ticket nella sezione 📋 **I miei ticket** in alto.`;
                    dispatch({ type: 'ADD_MESSAGE', payload: { sender: 'ai', text, type: 'system-prompt', id: Date.now() + Math.random() } });

                    // Chiusura guidata: se il ticket è stato RISOLTO, chiedi conferma + feedback
                    if (resolved) {
                        dispatch({ type: 'ADD_MESSAGE', payload: {
                            sender: 'ai',
                            type: 'ticket-closure',
                            ticketKey: u.key,
                            id: Date.now() + Math.random() + 0.001,
                            text: `✅ **Il tuo ticket ${u.key} risulta RISOLTO.**\n\nÈ andato tutto a posto? Fammi sapere così chiudiamo con serenità 🙂`
                        } });
                    }

                    if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
                        try {
                            new Notification(`📬 Ticket ${u.key} aggiornato`, {
                                body: u.status_changed ? `Nuovo stato: ${u.status}` : (u.new_comments?.[0]?.body?.slice(0, 120) || 'Il supporto IT ha aggiornato il ticket'),
                                icon: '/logo192.png', tag: `ticket-${u.key}`,
                            });
                        } catch (e) {}
                    }
                });

                prevTicketUpdatesRef.current = unread.length;
                dispatch({ type: 'SET_STATE', payload: { ticketUpdates: unread } });

                // Feedback quando l'utente preme "Aggiorna" e non c'è nulla di nuovo
                if (manual && updates.length === 0) {
                    dispatch({ type: 'ADD_MESSAGE', payload: {
                        sender: 'ai', type: 'system-prompt', id: Date.now() + Math.random(),
                        text: '🔄 **Controllato!** Al momento non ci sono nuove risposte sui tuoi ticket. Ti avviso appena rispondiamo. 👍'
                    } });
                }
            } catch (e) {}
        };
        // Avvia il primo poll SOLO dopo il ripristino della chat dal server,
        // per non farsi sovrascrivere i messaggi di aggiornamento appena inseriti.
        const startInitial = async () => {
            let tries = 0;
            while (!serverLoadDoneRef.current && active && tries < 40) {
                await new Promise(r => setTimeout(r, 250));
                tries++;
            }
            if (active) poll();
        };
        startInitial();
        const iv = setInterval(poll, 60000);
        const onManual = () => poll(true);
        window.addEventListener('spark:sync-tickets', onManual);
        return () => { active = false; clearInterval(iv); window.removeEventListener('spark:sync-tickets', onManual); };
    }, [state.userEmail]);

    // 🎫 Verifica registrazione Jira dell'utente (per banner promemoria + guida ticket)
    useEffect(() => {
        const email = (state.userEmail || localStorage.getItem('spark-user-email-v1') || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
        let active = true;
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/v1/jira/check-user?email=${encodeURIComponent(email)}`, { headers: getAuthHeaders() });
                const d = await r.json();
                if (active && d.configured) dispatch({ type: 'SET_STATE', payload: { jiraRegistered: !!d.is_jira_user } });
            } catch (e) {}
        })();
        return () => { active = false; };
    }, [state.userEmail]);


    const addMessage = useCallback((message) => {
        dispatch({ type: 'ADD_MESSAGE', payload: { ...message, id: Date.now() + Math.random() } });
        // Reset timer inattività quando c'è attività
        dispatch({ type: 'SET_STATE', payload: { lastActivityTime: Date.now(), showInactivityPrompt: false } });
    }, []);

    // --- Timer di Inattività (60 secondi) ---
    const inactivityReminderSentRef = useRef(false);
    useEffect(() => {
        // Solo se siamo in fase chat e ci sono messaggi
        if (state.currentPhase !== 'chat' || state.messages.length === 0) return;

        const INACTIVITY_TIMEOUT = 60 * 1000; // 60 secondi
        
        const checkInactivity = () => {
            // Un solo promemoria per sessione: evita di invadere la chat se la finestra resta aperta
            if (inactivityReminderSentRef.current) return;
            const timeSinceLastActivity = Date.now() - state.lastActivityTime;
            if (timeSinceLastActivity >= INACTIVITY_TIMEOUT && !state.showInactivityPrompt && !state.isLoading) {
                inactivityReminderSentRef.current = true;
                dispatch({ type: 'SET_STATE', payload: { showInactivityPrompt: true } });
                // Aggiungi messaggio di promemoria
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        sender: 'ai',
                        text: "👋 **Sei ancora lì?**\n\n━━━━━━━━━━━━━━━━━━━━\n\nNon ti sento da un po'! Se hai bisogno di aiuto, sono sempre qui.\n\n💡 **Ricorda:** Puoi anche:\n- 🎫 Aprire un ticket per assistenza\n- 📞 Chiamare il supporto\n- 📅 Prenotare un appuntamento\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 Scrivi pure quando vuoi!",
                        type: 'system-prompt',
                        id: Date.now() + Math.random()
                    }
                });
            }
        };

        const intervalId = setInterval(checkInactivity, 10000); // Check ogni 10 secondi
        
        return () => clearInterval(intervalId);
    }, [state.currentPhase, state.messages.length, state.lastActivityTime, state.showInactivityPrompt, state.isLoading, dispatch]);

    // Reset attività su interazioni utente
    useEffect(() => {
        const resetActivity = () => {
            if (state.currentPhase === 'chat') {
                dispatch({ type: 'SET_STATE', payload: { lastActivityTime: Date.now(), showInactivityPrompt: false } });
            }
        };

        // Eventi che indicano attività
        window.addEventListener('click', resetActivity);
        window.addEventListener('keydown', resetActivity);
        window.addEventListener('scroll', resetActivity);
        window.addEventListener('touchstart', resetActivity);

        return () => {
            window.removeEventListener('click', resetActivity);
            window.removeEventListener('keydown', resetActivity);
            window.removeEventListener('scroll', resetActivity);
            window.removeEventListener('touchstart', resetActivity);
        };
    }, [state.currentPhase, dispatch]);

    // Polling per chiamate in arrivo da Teams - DISABILITATO per ridurre carico server
    // TODO: Implementare WebSocket invece di polling
    /*
    useEffect(() => {
        if (!state.userName) return;
        
        const checkIncomingCalls = async () => {
            try {
                const backendUrl = API_BASE_URL;
                const response = await fetch(`${backendUrl}/api/teams/pending-calls/${encodeURIComponent(state.userName)}`);
                if (response.ok) {
                    const data = await response.json();
                    if (data.hasCall && data.roomUrl) {
                        dispatch({ 
                            type: 'SET_STATE', 
                            payload: { 
                                incomingCall: {
                                    callerName: data.callerName,
                                    roomUrl: data.roomUrl,
                                    roomName: data.roomName
                                }
                            }
                        });
                    }
                }
            } catch (e) {
                // Ignora errori di polling
            }
        };
        
        // Check iniziale
        checkIncomingCalls();
        
        // Polling ogni 10 secondi
        const interval = setInterval(checkIncomingCalls, 10000);
        
        return () => clearInterval(interval);
    }, [state.userName, dispatch]);
    */

    const handleFormSubmit = useCallback(async (inputValue) => {
        // 🔒 SICUREZZA: Sanitizza input per prevenire XSS
        const input = AppConfig.sanitize(inputValue.trim());
        if (!input && !state.attachment.data) return;
        
        // 🔒 SICUREZZA: Rate limiting
        if (!AppConfig.checkLimit('chat-submit')) {
            addMessage({ sender: 'ai', text: '⚠️ Troppi messaggi inviati. Attendi un momento.', type: 'system-prompt' });
            return;
        }

        addMessage({ sender: 'user', text: input, attachment: state.attachment });

        const phaseActions = {
            name: () => {
                const firstName = input.split(' ')[0];
                dispatch({ type: 'SET_STATE', payload: { userName: input, currentPhase: 'company' } });
                addMessage({ sender: 'ai', text: `${getGenderedGreeting(input, 'welcome')} Ora, il nome della tua azienda?`, type: 'system-prompt' });
            },
            company: () => {
                dispatch({ type: 'SET_STATE', payload: { userCompany: input, currentPhase: 'computer' } });
                
                // Salva dettagli utente in localStorage
                if (state.userName) {
                    try {
                        const savedDetails = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
                        const detailsMap = savedDetails ? JSON.parse(savedDetails) : {};
                        const userKey = state.userName.toLowerCase().replace(/[.\s]/g, '_');
                        detailsMap[userKey] = {
                            ...detailsMap[userKey],
                            company: input,
                            lastSeen: new Date().toISOString()
                        };
                        localStorage.setItem(USER_DETAILS_STORAGE_KEY, JSON.stringify(detailsMap));
                        console.log('[SAVE] Azienda salvata per utente:', userKey);
                    } catch (e) {
                        console.error('Errore salvataggio azienda:', e);
                    }
                }
                
                addMessage({ sender: 'ai', text: `Ottimo! Qual è il nome del tuo computer?`, type: 'system-prompt' });
            },
            computer: () => {
                dispatch({ type: 'SET_STATE', payload: { userComputer: input, currentPhase: 'ask-hardware-type' } });
                addMessage({ sender: 'ai', text: `Grazie. Stai lavorando su un PC fisso o notebook?`, type: 'system-prompt' });
            },
            'ask-hardware-type': () => {
                const isNotebook = input.toLowerCase().match(/portatile|notebook|laptop|nb/);
                const hwType = isNotebook ? 'notebook' : 'fisso';
                // Imposta anche la connessione dedotta
                const connType = isNotebook ? 'Wi-Fi' : 'LAN';
                dispatch({ type: 'SET_STATE', payload: { 
                    userPCHardwareType: hwType, 
                    userConnectionType: connType,
                    currentPhase: 'chat' 
                } });
                addMessage({ sender: 'ai', text: `${getGenderedGreeting(state.userName, 'perfect')} Come posso aiutarti oggi?`, type: 'system-prompt' });
            },
            chat: async () => {
                console.log('🔵 Chat action started for:', input);
                dispatch({ type: 'SET_STATE', payload: { isLoading: true } });
                addMessage({ sender: 'ai', text: '', isStreaming: true });
                
                let apiSuccess = false;
                
                try {
                    const userData = {
                        userName: state.userName,
                        userComputer: state.userComputer,
                        userCompany: state.userCompany,
                        userSiteName: state.userSiteName,
                        hardwareType: state.userPCHardwareType,
                        deviceModel: state.userDeviceModel,
                        connectionType: state.userConnectionType,
                        operatingSystem: state.userOperatingSystem || '',
                        domain: state.userDomain || '',
                        isDomainJoined: state.isDomainJoined,
                        isDeviceManaged: state.isDeviceManaged // Stato gestione RMM
                    };
                    
                    // 🧠 MEMORIA CONVERSAZIONALE: includi ultimi messaggi nel contesto
                    const conversationHistory = buildConversationHistory(state.messages, 10);
                    console.log('[CHAT] userData per prompt:', userData, '| isDeviceManaged:', state.isDeviceManaged);
                    console.log('[CHAT] 🧠 Memoria conversazione:', conversationHistory.length, 'messaggi inclusi');
                    
                    // 📸 ANALISI SCREENSHOT: se c'è un allegato immagine, aggiungi contesto specifico
                    let enhancedInput = input;
                    if (state.attachment && state.attachment.type === 'image') {
                        const screenshotContext = getScreenshotAnalysisPrompt();
                        enhancedInput = `${screenshotContext}\n\n--- MESSAGGIO UTENTE ---\n${input || 'Analizza questa immagine e dimmi cosa vedi.'}`;
                        console.log('[CHAT] 📸 Allegato immagine rilevato, prompt analisi aggiunto');
                    }
                    
                    // 🎛️ PREFERENZE UTENTE: Passa le preferenze al system prompt
                    const userPreferences = state.preferences || { responseStyle: 'detailed', silentMode: false };
                    console.log('[CHAT] 🎛️ Preferenze utente:', userPreferences);
                    
                    // 🚀 AI ENTERPRISE: Usa system prompt con contesto dinamico + preferenze
                    const enterpriseSystemPrompt = getEnterpriseSystemPrompt(userData, conversationHistory, userPreferences, enhancedInput);
                    console.log('[CHAT] 🚀 Enterprise System Prompt attivo con preferenze');
                    
                    // 🧠 AI ENTERPRISE: Aggiorna memoria AI prima della chiamata
                    const detectedTopics = detectTopicsFromMessage(enhancedInput);
                    console.log('[CHAT] 🎯 Topic rilevati:', detectedTopics);
                    
                    const response = MOCK_API.streamChat(enhancedInput, state.attachment, enterpriseSystemPrompt, userData, conversationHistory);
                    let totalText = '';
                    for await (const chunk of response) {
                        console.log('[MSG] Chunk received:', chunk);
                        totalText += chunk;
                        dispatch({ type: 'APPEND_TO_LAST_MESSAGE', payload: chunk });
                        apiSuccess = true; // Almeno un chunk ricevuto
                    }
                    console.log('[OK] Total text:', totalText);
                    // Applica formattazione al testo finale
                    const formattedText = formatAIResponse(totalText);
                    dispatch({ type: 'UPDATE_LAST_MESSAGE', payload: { text: formattedText, isStreaming: false } });
                    
                    // 🧠 AI ENTERPRISE: Aggiorna memoria dopo ogni interazione
                    const issueType = detectedTopics.length > 0 ? detectedTopics[0] : null;
                    updateAIMemory(enhancedInput, totalText, null, issueType);
                    console.log('[CHAT] 🧠 Memoria AI aggiornata con topic:', issueType);
                    
                    // --- FEEDBACK AUTOMATICO ---
                    // Mostra prompt feedback se la risposta sembra risolutiva
                    const lowerText = totalText.toLowerCase();
                    const resolutionKeywords = [
                        'problema risolto', 'risolto', 'dovrebbe funzionare', 'prova ora',
                        'ho risolto', 'abbiamo risolto', 'è stato risolto', 'funziona adesso',
                        'dovrebbe essere a posto', 'tutto a posto', 'sistemato', 'fixed',
                        'hai risolto', 'problema sistemato', 'completato', 'fatto'
                    ];
                    const hasResolutionKeyword = resolutionKeywords.some(keyword => lowerText.includes(keyword));
                    
                    // Mostra feedback solo se sembra una risposta risolutiva e non l'abbiamo già chiesto di recente
                    if (hasResolutionKeyword && !state.showFeedbackPrompt) {
                        // Aspetta 2 secondi prima di mostrare il feedback per non interrompere la lettura
                        setTimeout(() => {
                            dispatch({ type: 'SET_STATE', payload: { 
                                showFeedbackPrompt: true, 
                                feedbackMessageId: Date.now() 
                            } });
                        }, 2000);
                    }
                } catch (error) {
                    console.error('❌ Chat error:', error);
                    // Niente mock - mostra errore chiaro se API fallisce
                    const errorMessage = "**⚠️ Ops!**\n\n━━━━━━━━━━━━━━━━━━━━\n\nNon sono riuscito a connettermi al server.\n\nProva a:\n\n1️⃣ **Ricaricare la pagina** (premi F5)\n\n2️⃣ **Riprovare tra qualche secondo**\n\n━━━━━━━━━━━━━━━━━━━━\n\n😊 **Problema persiste?** Clicca su 🎫 per aprire un ticket!";
                    dispatch({ type: 'UPDATE_LAST_MESSAGE', payload: { text: errorMessage, isStreaming: false } });
                } finally {
                    dispatch({ type: 'SET_STATE', payload: { isLoading: false } });
                }
            },
        };

        (phaseActions[state.currentPhase] || phaseActions.chat)();
        dispatch({ type: 'RESET_INPUT' });
    }, [state, addMessage]);

    const handleEnableNotifications = useCallback(async () => {
        // Prima richiedi il permesso
        const permResult = await NotificationService.requestPermission();
        if (!permResult.success) {
            dispatch({ type: 'SET_STATE', payload: { notificationStatus: Notification.permission } });
            return permResult;
        }
        
        // Poi sottoscrivi a FCM
        const result = await subscribeToFcm();
        
        if (result.success) {
            dispatch({ type: 'SET_STATE', payload: { notificationStatus: 'granted' } });
            NotificationService.showLocalNotification(
                'Notifiche attivate!',
                'Riceverai aggiornamenti importanti da Spark.',
                { tag: 'spark-enabled' }
            );
            addMessage({
                sender: 'ai',
                text: "FANTASTICO! 🚀 Notifiche attivate! Da questo momento siamo ancora più connessi. Riceverai aggiornamenti in tempo reale!",
                type: 'system-prompt'
            });
        } else {
            dispatch({ type: 'SET_STATE', payload: { notificationStatus: Notification.permission } });
            addMessage({
                sender: 'ai',
                text: `C'è stato un problema nell'attivare le notifiche: ${result.error || 'Errore sconosciuto'}`,
                type: 'system-prompt'
            });
        }
        
        return result;
    }, [subscribeToFcm, addMessage]);

    // 🔄 Continuità chat: helper/ref condivisi (usati sia dagli effetti che dal pulsante "Aggiorna chat")
    const serverLoadDoneRef = useRef(false);
    const lastSyncedMsgJsonRef = useRef('');
    const syncDebounceRef = useRef(null);

    const getSyncEmail = useCallback(() => {
        try {
            return (state.userEmail || localStorage.getItem('spark-user-email-v1') || '').toLowerCase().trim();
        } catch (e) { return ''; }
    }, [state.userEmail]);

    // Recupero manuale (pulsante "Aggiorna chat"): scarica dal server l'ultima conversazione
    const refreshChatFromServer = useCallback(async () => {
        const email = getSyncEmail();
        if (!email) return { ok: false, reason: 'no-email' };
        const server = await fetchChatFromServer(email);
        if (server && server.found && Array.isArray(server.messages) && server.messages.length > 0) {
            const localUpdatedAt = localStorage.getItem(CHAT_SYNC_UPDATED_AT_KEY) || '';
            const serverNewer = !localUpdatedAt || (server.updated_at && server.updated_at >= localUpdatedAt);
            if (serverNewer) {
                lastSyncedMsgJsonRef.current = JSON.stringify(stripMessagesForSync(server.messages));
                localStorage.setItem(CHAT_SYNC_UPDATED_AT_KEY, server.updated_at || new Date().toISOString());
                dispatch({ type: 'SET_STATE', payload: { messages: server.messages, currentPhase: 'chat' } });
                return { ok: true, updated: true, count: server.messages.length };
            }
            return { ok: true, updated: false };
        }
        return { ok: false, reason: 'empty' };
    }, [getSyncEmail, dispatch]);

    const actions = {
        refreshChat: refreshChatFromServer,
        handleFormSubmit,
        handleToggleTts: () => dispatch({ type: 'SET_STATE', payload: { isTtsEnabled: !state.isTtsEnabled } }),
        handleExportChat: () => {
            const chatText = state.messages.map(msg => `${msg.sender === 'user' ? state.userName || 'Utente' : 'Spark'}: ${msg.text}`).join('\n');
            const blob = new Blob([chatText], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `chat_spark_${new Date().toISOString().slice(0, 10)}.txt`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        handleToggleSearch: () => dispatch({ type: 'SET_STATE', payload: { showSearch: !state.showSearch, searchQuery: '' } }),
        handleWelcomeSubmit: ({ userName, userCompany, userEmail, notificationsEnabled }) => {
            // Salva l'email se fornita
            if (userEmail) {
                localStorage.setItem('spark-user-email-v1', userEmail.toLowerCase().trim());
            }
            
            // Se l'utente ha già fornito l'azienda nel modal, salta la fase company
            if (userCompany) {
                dispatch({ type: 'SET_STATE', payload: { 
                    userName, 
                    userCompany,
                    userEmail: userEmail || '',
                    showWelcomeModal: false, 
                    currentPhase: 'computer' // Salta direttamente alla fase computer
                } });
                addMessage({ sender: 'ai', text: `${getGenderedGreeting(userName, 'welcome')} Ho registrato che lavori per **${userCompany}**. Come si chiama il tuo PC? (Se non lo sai, guarda l'etichetta sul dispositivo o dimmi "non so")` });
            } else {
                // Nessuna azienda fornita, chiedi nel flusso normale
                dispatch({ type: 'SET_STATE', payload: { userName, userEmail: userEmail || '', showWelcomeModal: false, currentPhase: 'company' } });
                addMessage({ sender: 'ai', text: `${getGenderedGreeting(userName, 'welcome')} ${getGenderedGreeting(userName, 'askCompany')}` });
            }
            
            // Salva preferenza notifiche
            if (notificationsEnabled !== undefined) {
                localStorage.setItem(NOTIFICATION_PERMISSION_KEY, notificationsEnabled ? 'enabled' : 'disabled');
            }
        },
        handleEnableNotifications,
        saveHistoryAndReset: () => dispatch({ type: 'RESET_SESSION' }),
    };

    useEffect(() => {
        try {
            // Escludi stati transitori dal salvataggio
            const stateToSave = { 
                ...state, 
                attachment: null, 
                isLoading: false,
                incomingCall: null, // Non salvare chiamate in arrivo
                showVideoCallModal: false,
                showPhoneModal: false,
                showMobileHandoffModal: false,
                showOpenOnPhoneModal: false,
                showInactivityPrompt: false
            };
            localStorage.setItem(CHAT_SESSION_STORAGE_KEY, JSON.stringify(stateToSave));
        } catch (error) {
            console.error("Impossibile salvare la sessione:", error);
        }
    }, [state]);

    // ========================================================================
    // 🔄 Continuità chat tra dispositivi (PC <-> telefono) — effetti (helper definiti sopra actions)
    // ========================================================================
    // CARICAMENTO: all'apertura recupera dal server l'ultima conversazione se più recente
    useEffect(() => {
        const email = getSyncEmail();
        if (!email || serverLoadDoneRef.current) return;
        let cancelled = false;
        (async () => {
            const server = await fetchChatFromServer(email);
            if (cancelled) return;
            try {
                if (server && server.found && Array.isArray(server.messages) && server.messages.length > 0) {
                    const localUpdatedAt = localStorage.getItem(CHAT_SYNC_UPDATED_AT_KEY) || '';
                    const serverNewer = !localUpdatedAt || (server.updated_at && server.updated_at > localUpdatedAt);
                    if (serverNewer && server.messages.length >= (state.messages?.length || 0)) {
                        lastSyncedMsgJsonRef.current = JSON.stringify(stripMessagesForSync(server.messages));
                        localStorage.setItem(CHAT_SYNC_UPDATED_AT_KEY, server.updated_at || new Date().toISOString());
                        dispatch({ type: 'SET_STATE', payload: { messages: server.messages, currentPhase: 'chat' } });
                        console.log('[chat-sync] conversazione ripristinata dal server:', server.messages.length, 'messaggi');
                    }
                }
            } finally {
                serverLoadDoneRef.current = true; // sblocca il salvataggio solo dopo il tentativo di load
            }
        })();
        return () => { cancelled = true; };
    }, [getSyncEmail]); // eslint-disable-line react-hooks/exhaustive-deps

    // SALVATAGGIO: ad ogni cambio messaggi (debounced) salva la conversazione sul server
    useEffect(() => {
        const email = getSyncEmail();
        if (!email || !serverLoadDoneRef.current) return;
        if (!Array.isArray(state.messages) || state.messages.length === 0) return;
        const currentJson = JSON.stringify(stripMessagesForSync(state.messages));
        if (currentJson === lastSyncedMsgJsonRef.current) return; // nessun cambiamento reale
        if (syncDebounceRef.current) clearTimeout(syncDebounceRef.current);
        syncDebounceRef.current = setTimeout(async () => {
            const updatedAt = new Date().toISOString();
            const resp = await syncChatToServer({
                email,
                userName: state.userName,
                userCompany: state.userSiteName || state.userCompany,
                messages: state.messages,
                updatedAt,
            });
            if (resp && resp.ok) {
                lastSyncedMsgJsonRef.current = currentJson;
                localStorage.setItem(CHAT_SYNC_UPDATED_AT_KEY, updatedAt);
            } else if (resp && resp.conflict && resp.server && Array.isArray(resp.server.messages) && resp.server.messages.length > 0) {
                // Un altro dispositivo ha una versione più recente: caricala
                lastSyncedMsgJsonRef.current = JSON.stringify(stripMessagesForSync(resp.server.messages));
                localStorage.setItem(CHAT_SYNC_UPDATED_AT_KEY, resp.server.updated_at || updatedAt);
                dispatch({ type: 'SET_STATE', payload: { messages: resp.server.messages } });
            }
        }, 1500);
        return () => { if (syncDebounceRef.current) clearTimeout(syncDebounceRef.current); };
    }, [state.messages, getSyncEmail, state.userName, state.userCompany, state.userSiteName, dispatch]);

    // 📱 Solo mobile in fase chat: blocca lo scroll dell'intera pagina (scorre solo la chat).
    // Escludiamo i modali di onboarding (lunghi, hanno bisogno dello scroll di pagina).
    useEffect(() => {
        const lock = state.isMobile && state.currentPhase === 'chat'
            && !state.showBatLaunchWelcomeModal && !state.showWelcomeModal;
        document.body.classList.toggle('spark-chat-lock', lock);
        return () => document.body.classList.remove('spark-chat-lock');
    }, [state.isMobile, state.currentPhase, state.showBatLaunchWelcomeModal, state.showWelcomeModal]);



    // Salva dettagli utente separatamente per maggiore robustezza
    useEffect(() => {
        if (state.userName && state.userComputer) {
            try {
                const savedDetails = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
                const detailsMap = savedDetails ? JSON.parse(savedDetails) : {};
                const userKey = state.userName.toLowerCase().replace(/[.\s]/g, '_');
                
                // Aggiorna solo i campi che hanno valori
                const existingData = detailsMap[userKey] || {};
                const newData = {
                    ...existingData,
                    computer: state.userComputer,
                    lastSeen: new Date().toISOString()
                };
                
                if (state.userSiteName) newData.company = state.userSiteName;
                else if (state.userCompany) newData.company = state.userCompany;
                if (state.userPCHardwareType) newData.hardwareType = state.userPCHardwareType;
                if (state.userConnectionType) newData.connectionType = state.userConnectionType;
                if (state.userConnectionSource) newData.connectionSource = state.userConnectionSource;
                if (state.userDeviceModel) newData.deviceModel = state.userDeviceModel;
                
                detailsMap[userKey] = newData;
                localStorage.setItem(USER_DETAILS_STORAGE_KEY, JSON.stringify(detailsMap));
                console.log('[SAVE] Dettagli utente salvati:', userKey, newData);
            } catch (e) {
                console.error('Errore salvataggio dettagli utente:', e);
            }
        }
    }, [state.userName, state.userComputer, state.userSiteName, state.userCompany, state.userPCHardwareType, state.userConnectionType, state.userConnectionSource, state.userDeviceModel]);

    useEffect(() => {
        if (state.currentPhase === 'initializing' && state.messages.length === 0 && !state.userName) {
            dispatch({ type: 'SET_STATE', payload: { showWelcomeModal: true } });
        }
    }, [state.currentPhase, state.messages.length, state.userName]);

    const value = useMemo(() => ({ state, dispatch, actions }), [state, actions]);
    return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

// ============================================================================
// NOTIFICATION BUTTON COMPONENT
// ============================================================================
const NotificationButton = memo(() => {
    const { state, actions } = useContext(ChatContext);
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        if (state.notificationStatus === 'granted') {
            // Già attive, mostra info
            NotificationService.showLocalNotification(
                'Notifiche già attive',
                'Stai già ricevendo le notifiche da Spark!',
                { tag: 'spark-info' }
            );
            return;
        }

        if (state.notificationStatus === 'denied') {
            alert('Hai bloccato le notifiche. Per attivarle, vai nelle impostazioni del browser e consenti le notifiche per questo sito.');
            return;
        }

        setIsLoading(true);
        await actions.handleEnableNotifications();
        setIsLoading(false);
    };

    const getIcon = () => {
        if (isLoading) return <Loader2 className="h-5 w-5 md:h-6 md:w-6 animate-spin" />;
        if (state.notificationStatus === 'granted') return <BellRing className="h-5 w-5 md:h-6 md:w-6" />;
        if (state.notificationStatus === 'denied') return <BellOff className="h-5 w-5 md:h-6 md:w-6" />;
        return <Bell className="h-5 w-5 md:h-6 md:w-6" />;
    };

    const getTitle = () => {
        if (state.notificationStatus === 'granted') return 'Notifiche attive';
        if (state.notificationStatus === 'denied') return 'Notifiche bloccate';
        return 'Attiva notifiche';
    };

    const getButtonClass = () => {
        let baseClass = "p-1.5 md:p-2 rounded-full transition-all ";
        if (state.notificationStatus === 'granted') {
            return baseClass + "bg-green-500 text-white hover:bg-green-600";
        }
        if (state.notificationStatus === 'denied') {
            return baseClass + "bg-red-500/20 text-red-300 hover:bg-red-500/30";
        }
        return baseClass + "bg-blue-500/20 text-white hover:bg-blue-500/30 animate-pulse";
    };

    if (!NotificationService.isSupported()) {
        return null;
    }

    return (
        <button 
            onClick={handleClick} 
            title={getTitle()}
            className={getButtonClass()}
            disabled={isLoading}
        >
            {getIcon()}
        </button>
    );
});

// ============================================================================
// STORICO NOTIFICHE UTENTE - Campanella con elenco avvisi ricevuti
// ============================================================================
const formatNotifTime = (iso) => {
    if (!iso) return '';
    try {
        const d = new Date(iso);
        const diff = Math.floor((Date.now() - d.getTime()) / 1000);
        if (diff < 60) return 'ora';
        if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
        if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
        if (diff < 604800) return `${Math.floor(diff / 86400)} g fa`;
        return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
    } catch (e) { return ''; }
};

const NotificationBell = memo(() => {
    const { state } = useContext(ChatContext);
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [lastSeen, setLastSeen] = useState(() => {
        try { return localStorage.getItem('spark-notif-last-seen') || ''; } catch (e) { return ''; }
    });

    const fetchHistory = useCallback(async () => {
        try {
            const params = new URLSearchParams({
                userName: state.userName || '',
                userCompany: state.userSiteName || state.userCompany || '',
                userComputer: state.userComputer || '',
                email: state.userEmail || (localStorage.getItem('spark-user-email-v1') || ''),
            });
            const r = await fetch(`${API_BASE_URL}/api/v1/notification/history?${params.toString()}`);
            const d = await r.json();
            setItems(d.notifications || []);
        } catch (e) { /* silenzioso */ }
    }, [state.userName, state.userSiteName, state.userCompany, state.userComputer, state.userEmail]);

    useEffect(() => {
        fetchHistory();
        const id = setInterval(fetchHistory, 60000);
        return () => clearInterval(id);
    }, [fetchHistory]);

    const unreadCount = items.filter(n => !n.read && (n.created_at || '') > lastSeen).length;

    const markAllRead = useCallback(async () => {
        const now = new Date().toISOString();
        try { localStorage.setItem('spark-notif-last-seen', now); } catch (e) {}
        setLastSeen(now);
        const ids = items.filter(n => !n.read).map(n => n.id).filter(Boolean);
        setItems(prev => prev.map(n => ({ ...n, read: true })));
        const email = state.userEmail || (localStorage.getItem('spark-user-email-v1') || '');
        if (email && ids.length) {
            try {
                await fetch(`${API_BASE_URL}/api/v1/notification/mark-read`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        email, ids,
                        name: state.userName || '',
                        computer: state.userComputer || '',
                    }),
                });
            } catch (e) { /* silenzioso */ }
        }
    }, [items, state.userEmail, state.userName, state.userComputer]);

    const handleToggle = () => {
        const next = !open;
        setOpen(next);
        if (next) markAllRead();
    };

    const priorityDot = (p) => p === 'urgent' ? 'bg-red-500' : p === 'high' ? 'bg-amber-500' : p === 'low' ? 'bg-slate-400' : 'bg-sky-500';

    return (
        <div className="relative">
            <button
                onClick={handleToggle}
                title="Notifiche ricevute"
                className="relative p-1.5 md:p-2 rounded-full hover:bg-white/20 text-white transition-all"
                data-testid="notification-bell-btn"
            >
                <Bell className="h-5 w-5 md:h-6 md:w-6" />
                {unreadCount > 0 && (
                    <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center" data-testid="notification-bell-badge">
                        {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                )}
            </button>
            {open && (
                <>
                    <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} data-testid="notification-bell-backdrop" />
                    <div className="absolute left-0 mt-2 w-80 max-w-[90vw] bg-white rounded-2xl shadow-2xl border border-gray-200 z-50 overflow-hidden animate-scale-in" data-testid="notification-bell-panel">
                        <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600">
                            <h3 className="text-sm font-bold text-white flex items-center gap-2"><Bell className="h-4 w-4" /> Notifiche</h3>
                            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white" data-testid="notification-bell-close"><X className="h-4 w-4" /></button>
                        </div>
                        <div className="max-h-96 overflow-y-auto divide-y divide-gray-100">
                            {items.length === 0 && (
                                <div className="px-4 py-10 text-center text-gray-400 text-sm" data-testid="notification-bell-empty">
                                    <BellOff className="h-8 w-8 mx-auto mb-2 opacity-50" />
                                    Nessuna notifica ricevuta
                                </div>
                            )}
                            {items.map((n, i) => (
                                <div key={n.id || i} className={`px-4 py-3 hover:bg-gray-50 transition-colors ${(!n.read && (n.created_at || '') > lastSeen) ? 'bg-blue-50/60' : ''}`} data-testid={`notification-item-${i}`}>
                                    <div className="flex items-start gap-2.5">
                                        <span className={`mt-1.5 w-2 h-2 rounded-full flex-shrink-0 ${priorityDot(n.priority)}`} />
                                        <div className="min-w-0 flex-1">
                                            <div className="flex items-center justify-between gap-2">
                                                <p className="font-semibold text-sm text-gray-800 truncate">{n.title}</p>
                                                <span className="text-[10px] text-gray-400 flex-shrink-0">{formatNotifTime(n.created_at)}</span>
                                            </div>
                                            <p className="text-xs text-gray-600 mt-0.5 break-words">{n.body}</p>
                                            {n.imageUrl && <img src={n.imageUrl} alt="" className="mt-2 rounded-lg max-h-28 border border-gray-200" />}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
});

// ============================================================================
// BANNER STATO SERVIZI - Avviso disservizi controllato dall'Admin Zone
// ============================================================================
const ServiceStatusBanner = memo(() => {
    const [status, setStatus] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    const fetchStatus = useCallback(async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/notification/service-status`);
            const d = await r.json();
            setStatus(d && d.active ? d : null);
        } catch (e) { /* silenzioso */ }
    }, []);

    useEffect(() => {
        fetchStatus();
        const id = setInterval(fetchStatus, 60000);
        return () => clearInterval(id);
    }, [fetchStatus]);

    if (!status || dismissed) return null;

    const critical = status.level === 'critical';
    const cls = critical
        ? 'bg-red-600 text-white'
        : 'bg-amber-400 text-amber-950';

    return (
        <div className={`w-full ${cls} shadow-md`} data-testid="service-status-banner">
            <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-3">
                <AlertTriangle className="h-5 w-5 flex-shrink-0" />
                <div className="min-w-0 flex-1 text-sm">
                    {status.title && <span className="font-bold mr-1.5">{status.title}:</span>}
                    <span className="break-words">{status.message}</span>
                </div>
                <button onClick={() => setDismissed(true)} className={`flex-shrink-0 p-1 rounded-full ${critical ? 'hover:bg-white/20' : 'hover:bg-amber-500/40'}`} title="Nascondi" data-testid="service-status-dismiss">
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
});


// ============================================================================
// CHAT INTERFACE COMPONENTS
// ============================================================================
const Header = memo(() => {
    const { state, dispatch, actions } = useContext(ChatContext);
    return (
        <div className={`${state.darkMode ? 'bg-gradient-to-r from-gray-800 to-gray-900' : 'bg-gradient-to-r from-blue-600 to-indigo-700'} text-white p-3 md:p-4 text-center shadow-md relative transition-colors duration-300`}>
            {/* Mobile: Layout compatto */}
            <div className="md:hidden">
                {/* Riga superiore: icone sinistra + badge + icone destra */}
                <div className="flex items-center justify-between mb-2">
                    {/* Icone sinistra */}
                    <div className="flex items-center gap-1">
                        <NotificationBell />
                        <button onClick={actions.handleToggleTts} title={state.isTtsEnabled ? "Disattiva audio" : "Attiva audio"} className="p-1.5 rounded-full hover:bg-white/20">
                            {state.isTtsEnabled ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
                        </button>
                        <DarkModeToggle />
                    </div>
                    
                    {/* Badge disponibilità */}
                    <SupportAvailabilityBadge />
                    
                    {/* Icone destra */}
                    <div className="flex items-center gap-1">
                        {state.launchedFromBatch && !sparkHidden(state, 'my_tickets') && (
                            <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showMyTickets: true } })} title="I Miei Ticket" className="relative p-1.5 rounded-full hover:bg-white/20" data-testid="my-tickets-btn-mobile">
                                <ClipboardList className="h-4 w-4" />
                                {state.ticketUpdates.length > 0 && (
                                    <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center" data-testid="ticket-updates-badge-mobile">{state.ticketUpdates.length}</span>
                                )}
                            </button>
                        )}
                        {!sparkHidden(state, 'chat_history') && (
                        <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showChatHistory: true } })} title="Storico Chat" className="p-1.5 rounded-full hover:bg-white/20" data-testid="chat-history-btn-mobile">
                            <Clock className="h-4 w-4" />
                        </button>
                        )}
                        <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showUserDashboard: true } })} title="Profilo e Dashboard" className="relative p-1.5 rounded-full hover:bg-white/20">
                            <User className="h-4 w-4" />
                            {state.notificationStatus !== 'granted' && state.notificationStatus !== 'unsupported' && (
                                <span data-testid="profile-notif-dot-mobile" className="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white/70 animate-pulse"></span>
                            )}
                        </button>
                    </div>
                </div>
                
                {/* Avatar e titolo */}
                <SparkAvatar size="sm" className={`h-16 w-16 mx-auto mb-1 ${state.isLoading ? 'animate-talking' : ''}`} />
                <h1 className="text-lg font-bold">86BIT | SPARK</h1>
                <p className="text-xs opacity-90">IT Service Desk Assistant</p>
            </div>
            
            {/* Desktop: Layout originale */}
            <div className="hidden md:block">
                {/* Pulsanti sinistra */}
                <div className="absolute top-2 left-2 flex items-center gap-1">
                    <NotificationBell />
                    <button onClick={actions.handleToggleTts} title={state.isTtsEnabled ? "Disattiva audio" : "Attiva audio"} className="p-2 rounded-full hover:bg-white/20">
                        {state.isTtsEnabled ? <Volume2 className="h-6 w-6" /> : <VolumeX className="h-6 w-6" />}
                    </button>
                    <DarkModeToggle />
                </div>
                
                {/* Pulsanti destra */}
                <div className="absolute top-2 right-2 flex items-center gap-1">
                    {state.launchedFromBatch && !sparkHidden(state, 'my_tickets') && (
                        <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showMyTickets: true } })} title="I Miei Ticket" className="relative p-2 rounded-full hover:bg-white/20" data-testid="my-tickets-btn">
                            <ClipboardList className="h-6 w-6" />
                            {state.ticketUpdates.length > 0 && (
                                <span className="absolute top-0 right-0 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center" data-testid="ticket-updates-badge">{state.ticketUpdates.length}</span>
                            )}
                        </button>
                    )}
                    {!sparkHidden(state, 'chat_history') && (
                    <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showChatHistory: true } })} title="Storico Chat" className="p-2 rounded-full hover:bg-white/20" data-testid="chat-history-btn">
                        <Clock className="h-6 w-6" />
                    </button>
                    )}
                    <button onClick={actions.handleToggleSearch} title="Cerca" className="p-2 rounded-full hover:bg-white/20">
                        <Search className="h-6 w-6" />
                    </button>
                    <button onClick={actions.handleExportChat} title="Esporta" className="p-2 rounded-full hover:bg-white/20">
                        <Download className="h-6 w-6" />
                    </button>
                    {/* Separatore visivo tra utilità e profilo */}
                    <div className="h-6 w-px bg-white/25 mx-0.5"></div>
                    {!sparkHidden(state, 'open_on_phone') && (
                    <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showOpenOnPhoneModal: true } })} title="Apri sul telefono" className="p-2 rounded-full hover:bg-white/20" data-testid="open-on-phone-btn">
                        <Smartphone className="h-6 w-6" />
                    </button>
                    )}
                    <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showUserDashboard: true } })} title="Profilo e Dashboard" className="relative p-2 rounded-full hover:bg-white/20">
                        <User className="h-6 w-6" />
                        {state.notificationStatus !== 'granted' && state.notificationStatus !== 'unsupported' && (
                            <span data-testid="profile-notif-dot" className="absolute top-0.5 right-0.5 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white/70 animate-pulse"></span>
                        )}
                    </button>
                </div>
                
                {/* Logo e titolo centrale */}
                <SparkAvatar size="md" className={`h-24 w-24 mx-auto mb-2 ${state.isLoading ? 'animate-talking' : ''}`} />
                <h1 className="text-2xl font-bold">86BIT | SPARK</h1>
                <p className="text-sm opacity-90 mt-1">IT Service Desk Assistant</p>
                {/* Stato disponibilità piccolo centrato sotto IT Service Desk */}
                <div className="mt-1 flex justify-center">
                    <SupportAvailabilityBadge />
                </div>
            </div>
        </div>
    );
});

const MobileRefreshChatButton = () => {
    const { actions } = useContext(ChatContext);
    const [status, setStatus] = useState('idle'); // idle | loading | done | empty
    const handle = async () => {
        if (status === 'loading') return;
        setStatus('loading');
        try {
            const res = await actions.refreshChat?.();
            setStatus(res && res.ok ? 'done' : 'empty');
        } catch (e) { setStatus('empty'); }
        setTimeout(() => setStatus('idle'), 1800);
    };
    return (
        <button
            onClick={handle}
            data-testid="refresh-chat-btn"
            title="Aggiorna la chat (sincronizza dal PC)"
            className="flex flex-col items-center w-full active:scale-95 transition-transform"
        >
            {status === 'loading'
                ? <Loader2 className="h-3.5 w-3.5 mb-0.5 text-blue-500 animate-spin" />
                : status === 'done'
                    ? <Check className="h-3.5 w-3.5 mb-0.5 text-green-500" />
                    : <RefreshCw className={`h-3.5 w-3.5 mb-0.5 ${status === 'empty' ? 'text-gray-400' : 'text-blue-500'}`} />}
            <span className="font-medium truncate w-full text-blue-600">
                {status === 'loading' ? 'Aggiorno…' : status === 'done' ? 'Aggiornata' : status === 'empty' ? 'Nessuna' : 'Aggiorna chat'}
            </span>
        </button>
    );
};

const UserInfoBanner = memo(() => {
    const { state, dispatch } = useContext(ChatContext);
    const { userName, userComputer, userCompany, userSiteName, userPCHardwareType, userConnectionType, userConnectionSource } = state;
    if (!userName || !userComputer) return null;
    
    // Usa userSiteName (da DattoRMM) se disponibile, altrimenti userCompany
    const displayCompany = userSiteName || userCompany;
    
    // Determina tipo hardware da mostrare
    let hardwareDisplay = 'Da impostare';
    let hardwareIcon = Monitor;
    if (userPCHardwareType === 'notebook') {
        hardwareDisplay = 'Notebook';
        hardwareIcon = Laptop;
    } else if (userPCHardwareType === 'fisso') {
        hardwareDisplay = 'PC Fisso';
        hardwareIcon = Monitor;
    }
    
    // Determina connessione da mostrare con indicatore di fonte
    let connectionDisplay = userConnectionType || 'Da impostare';
    let connectionIcon = Wifi;
    let connectionBadge = ''; // Indicatore se rilevato o stimato
    
    if (userConnectionType === 'LAN') {
        connectionIcon = PlugZap;
    }
    
    // Aggiungi indicatore fonte (Rilevato/Stimato)
    if (userConnectionType && userConnectionSource) {
        connectionBadge = userConnectionSource === 'rilevato' ? ' ✓' : ' ~';
    }
    
    const InfoItem = ({ icon: Icon, label, value, onClick, highlight, badge, badgeTitle }) => (
        <div 
            className={`flex items-center gap-1.5 ${highlight ? 'text-orange-600 cursor-pointer hover:text-orange-700' : 'text-gray-600'}`}
            onClick={onClick}
            title={badgeTitle}
        >
            <Icon className={`h-4 w-4 ${highlight ? 'text-orange-500' : 'text-gray-500'}`} />
            <span className="font-bold">{label}:</span>
            <span className={`truncate ${highlight ? 'underline' : ''}`} style={{ maxWidth: '120px' }}>
                {value}
                {badge && <span className={badge === ' ✓' ? 'text-green-600' : 'text-yellow-600'} title={badgeTitle}>{badge}</span>}
            </span>
        </div>
    );

    const openSettings = () => {
        dispatch({ type: 'SET_STATE', payload: { showUserDashboard: true } });
    };

    return (
        <div className={`p-1.5 md:p-2 border-b text-xs ${state.darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-100 border-gray-200'}`}>
            {/* Mobile: layout a griglia compatto */}
            <div className="md:hidden">
                <div className={`grid grid-cols-3 gap-1 text-center ${state.darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                    <div className="flex flex-col items-center">
                        <User className="h-3 w-3 mb-0.5 text-gray-400" />
                        <span className="font-medium truncate w-full">{userName.split(' ')[0]}</span>
                    </div>
                    <div className="flex flex-col items-center">
                        <Server className="h-3 w-3 mb-0.5 text-gray-400" />
                        <span className="truncate w-full">{userComputer}</span>
                    </div>
                    <div className="flex flex-col items-center">
                        <MobileRefreshChatButton />
                    </div>
                </div>
            </div>
            
            {/* Desktop: layout originale */}
            <div className="hidden md:flex flex-wrap justify-center md:justify-around items-center gap-x-4 gap-y-1">
                <InfoItem icon={User} label="Utente" value={userName.split(' ')[0]} />
                <InfoItem icon={Server} label="PC" value={userComputer} />
                {displayCompany && <InfoItem icon={Building2} label="Azienda" value={displayCompany} />}
                <InfoItem 
                    icon={hardwareIcon} 
                    label="Tipo" 
                    value={hardwareDisplay} 
                    onClick={!userPCHardwareType ? openSettings : undefined}
                    highlight={!userPCHardwareType}
                />
                <InfoItem 
                    icon={connectionIcon} 
                    label="Rete" 
                    value={connectionDisplay}
                    badge={connectionBadge}
                    badgeTitle={userConnectionSource === 'rilevato' ? 'Rilevato da Datto RMM' : 'Stimato dal tipo di PC'}
                    onClick={!userConnectionType ? openSettings : undefined}
                    highlight={!userConnectionType}
                />
            </div>
        </div>
    );
});

// ============================================================================
// QUICK ACTIONS BAR: Bottoni azione suggeriti sotto i messaggi AI
// ============================================================================
const QuickActionsBar = memo(({ actions, onAction }) => {
    const { state } = useContext(ChatContext);
    const { darkMode } = state;
    
    if (!actions || actions.length === 0) return null;
    
    const handleAction = (action) => {
        if (onAction) onAction(action);
    };
    
    return (
        <div className="flex flex-wrap gap-2 mt-2 animate-fade-in">
            {actions.map((action, index) => (
                <button
                    key={index}
                    onClick={() => handleAction(action)}
                    className={`
                        flex items-center space-x-1 px-3 py-1.5 rounded-full text-xs font-medium
                        transition-all duration-200 transform hover:scale-105 active:scale-95
                        ${action.priority === 'high' 
                            ? 'bg-red-500/20 text-red-400 border border-red-500/30 hover:bg-red-500/30' 
                            : darkMode 
                                ? 'bg-blue-500/20 text-blue-400 border border-blue-500/30 hover:bg-blue-500/30'
                                : 'bg-blue-100 text-blue-600 border border-blue-200 hover:bg-blue-200'
                        }
                    `}
                    data-testid={`quick-action-${action.type}`}
                >
                    <span>{action.label}</span>
                </button>
            ))}
        </div>
    );
});

// 🔊 TTS Button Component - Per ascoltare i messaggi di Spark
const TTSButton = memo(({ text, messageId, darkMode }) => {
    const { state } = useContext(ChatContext);
    const [isPlaying, setIsPlaying] = useState(false);
    
    const isSpeakingThis = state.currentlySpeakingMessageId === messageId;
    
    const handleClick = () => {
        const synthesis = getVoiceSynthesis();
        
        if (isSpeakingThis || isPlaying) {
            // Se sta già parlando questo messaggio, fermalo
            synthesis.stop();
            setIsPlaying(false);
        } else {
            // Ferma qualsiasi altro audio e riproduci questo
            synthesis.stop();
            
            // Configura callbacks per questo bottone
            const originalOnStart = synthesis.onStart;
            const originalOnEnd = synthesis.onEnd;
            
            synthesis.onStart = (id) => {
                setIsPlaying(true);
                if (originalOnStart) originalOnStart(id);
            };
            
            synthesis.onEnd = (id) => {
                setIsPlaying(false);
                if (originalOnEnd) originalOnEnd(id);
            };
            
            synthesis.speak(text, messageId);
        }
    };
    
    return (
        <button
            onClick={handleClick}
            className={`mt-2 flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs transition-all active:scale-95 ${
                isSpeakingThis || isPlaying
                    ? 'bg-blue-500 text-white'
                    : darkMode 
                        ? 'bg-gray-700 hover:bg-gray-600 text-gray-300'
                        : 'bg-gray-200 hover:bg-gray-300 text-gray-600'
            }`}
            title={isSpeakingThis || isPlaying ? 'Ferma lettura' : 'Ascolta risposta'}
        >
            {isSpeakingThis || isPlaying ? (
                <>
                    <VolumeX className="h-3.5 w-3.5" />
                    <span>Ferma</span>
                </>
            ) : (
                <>
                    <Volume2 className="h-3.5 w-3.5" />
                    <span>Ascolta</span>
                </>
            )}
        </button>
    );
});

const Message = memo(({ msg, index }) => {
    const { state, dispatch } = useContext(ChatContext);
    const { searchQuery, darkMode } = state;
    const [feedbackGiven, setFeedbackGiven] = useState(null); // 'positive', 'negative', or null
    const [closureDone, setClosureDone] = useState(null); // 'confirmed' | 'reopened' | null
    const [ratingGiven, setRatingGiven] = useState(null); // 1..5 or null

    // 📈 Handler per feedback rapido
    const handleQuickFeedback = (isPositive) => {
        if (feedbackGiven) return; // Già dato feedback
        
        setFeedbackGiven(isPositive ? 'positive' : 'negative');
        
        // Trova il messaggio utente precedente a questo messaggio AI
        const userMessages = state.messages
            .slice(0, state.messages.findIndex(m => m.id === msg.id))
            .filter(m => m.sender === 'user');
        const lastUserMessage = userMessages.pop()?.text || '';
        
        // Registra il feedback nel sistema di apprendimento
        try {
            recordResolutionFeedback(
                msg.id,
                isPositive,
                lastUserMessage,
                msg.text,
                null // La categoria verrà rilevata automaticamente
            );
            console.log('[QUICK_FEEDBACK] ✅ Feedback registrato:', isPositive ? 'positivo' : 'negativo');
        } catch (e) {
            console.error('[QUICK_FEEDBACK] Errore:', e);
        }
    };

    const renderText = (text) => {
        if (!text) return null;
        // Rimuovi eventuali tag interni [SENTIMENT:...] che non devono mai essere visibili
        text = text.replace(/\[SENTIMENT:[^\]]*\]/gi, '').replace(/^\s+/, '');
        // 🛡️ SANITIZZAZIONE XSS CON DOMPURIFY (Enterprise-grade security)
        // Prima sanitizziamo con DOMPurify, poi con il nostro filtro aggiuntivo
        let processed = DOMPurify.sanitize(text, {
            ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'br', 'span', 'div', 'hr', 'mark', 'p'],
            ALLOWED_ATTR: ['class', 'style'],
            FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input'],
            FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover']
        });
        
        // Applica anche il nostro sanitize per doppia protezione
        processed = AppConfig.sanitize(processed);
        
        // 🔗 Rendi i link CLICCABILI (dopo la sanitizzazione, così i tag <a> restano)
        // AppConfig.sanitize codifica '/' in &#x2F;: lo ripristino per riconoscere gli URL (lo slash non è un vettore XSS).
        processed = processed.replace(/&#x2F;/g, '/');
        const linkClass = darkMode ? 'text-blue-300 underline break-all hover:text-blue-200' : 'text-blue-600 underline break-all hover:text-blue-800';
        const anchor = (url, label) => {
            const safe = url.replace(/"/g, '%22');
            return `<a href="${safe}" target="_blank" rel="noopener noreferrer" class="${linkClass}">${label}</a>`;
        };
        // 1) Link markdown [testo](url)
        processed = processed.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, (m, label, url) => anchor(url, label));
        // 2) URL grezzi http(s):// non già dentro un tag <a>
        processed = processed.replace(/(^|[\s(>])(https?:\/\/[^\s<)]+)/g, (m, pre, url) => {
            const trail = (url.match(/[.,;:!?)\]]+$/) || [''])[0];
            const clean = url.slice(0, url.length - trail.length);
            return `${pre}${anchor(clean, clean)}${trail}`;
        });
        // 3) Email mailto
        processed = processed.replace(/(^|[\s(>])([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?![^<]*<\/a>)/g,
            (m, pre, mail) => `${pre}<a href="mailto:${mail}" class="${linkClass}">${mail}</a>`);
        
        // Converti emoji numerate in formato visivo
        processed = processed.replace(/1️⃣/g, '<span class="inline-flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full text-xs font-bold mr-2">1</span>');
        processed = processed.replace(/2️⃣/g, '<span class="inline-flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full text-xs font-bold mr-2">2</span>');
        processed = processed.replace(/3️⃣/g, '<span class="inline-flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full text-xs font-bold mr-2">3</span>');
        processed = processed.replace(/4️⃣/g, '<span class="inline-flex items-center justify-center w-6 h-6 bg-blue-500 text-white rounded-full text-xs font-bold mr-2">4</span>');
        
        // Converti separatori in linee visive
        const hrClass = darkMode ? 'border-gray-600' : 'border-gray-200';
        processed = processed.replace(/━{3,}/g, `<hr class="my-3 border-t-2 ${hrClass}">`);
        processed = processed.replace(/═{3,}/g, '<hr class="my-3 border-t-2 border-purple-400">');
        processed = processed.replace(/─{3,}/g, `<hr class="my-2 border-t ${hrClass}">`);
        
        // Gestisci grassetto **testo** - BIANCO in dark mode
        const boldClass = darkMode ? 'text-white font-bold' : 'text-gray-900 font-bold';
        processed = processed.replace(/\*\*(.*?)\*\*/g, `<strong class="${boldClass}">$1</strong>`);
        
        // Gestisci titoli con emoji
        const titleClass = darkMode ? 'text-purple-300' : 'text-purple-700';
        processed = processed.replace(/<strong class="[^"]*">(🎯|🖨️|🌐|📋|💡|😊|🎫|📞|🐌|🔍|⚠️|✅|❌)(.*?)<\/strong>/g, 
            `<div class="text-base font-bold ${titleClass} mt-3 mb-1">$1$2</div>`);
        
        // Spaziatura paragrafi: righe vuote → piccolo gap, singola andata a capo → <br>
        processed = processed.replace(/\n{2,}/g, '<div class="h-2"></div>');
        processed = processed.replace(/\n/g, '<br>');
        
        // Evidenzia ricerca
        if (searchQuery) {
            processed = processed.replace(new RegExp(`(${searchQuery})`, 'gi'), '<mark class="bg-yellow-300 text-black">$1</mark>');
        }
        
        return <div className="text-sm leading-relaxed break-words" dangerouslySetInnerHTML={{ __html: processed }} />;
    };

    if (msg.type === 'ticket-closure') {
        const key = msg.ticketKey;
        const author = state.userName || 'Utente';
        const authorEmail = state.userEmail || '';
        const sendClosure = async (resolved) => {
            setClosureDone(resolved ? 'confirmed' : 'reopened');
            try {
                await fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/reply`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        body: resolved
                            ? "✅ L'utente conferma dalla chat: il problema è RISOLTO. Grazie!"
                            : "❌ L'utente segnala dalla chat che il problema NON è ancora risolto.",
                        author, author_email: authorEmail
                    })
                });
            } catch (e) {}
            if (resolved) {
                // Chiedi un voto di soddisfazione (1-5 stelle)
                dispatch({ type: 'ADD_MESSAGE', payload: {
                    sender: 'ai', type: 'ticket-rating', ticketKey: key, id: Date.now() + Math.random(),
                    text: '🙏 **Grazie mille!** Prima di chiudere, quanto sei soddisfatto di come ti abbiamo aiutato?'
                } });
            } else {
                dispatch({ type: 'ADD_MESSAGE', payload: {
                    sender: 'ai', type: 'system-prompt', id: Date.now() + Math.random(),
                    text: '💪 **Ci pensiamo noi!** Ho avvisato il team che il problema persiste: lo riprendiamo in carico e ti ricontattiamo al più presto.'
                } });
            }
        };
        return (
            <div className={`flex items-start space-x-3 p-4 rounded-lg my-2 animate-fade-in-up ${darkMode ? 'bg-green-900/30 text-white' : 'bg-green-50 text-gray-800'}`} data-testid={`ticket-closure-${key}`}>
                <div className="flex-1">
                    {renderText(msg.text)}
                    {!closureDone ? (
                        <div className="flex flex-wrap gap-2 mt-3">
                            <button onClick={() => sendClosure(true)} data-testid={`ticket-closure-yes-${key}`}
                                className="px-3 py-1.5 rounded-lg text-sm font-semibold bg-green-600 hover:bg-green-500 text-white transition-colors active:scale-95">
                                ✅ Sì, è risolto
                            </button>
                            <button onClick={() => sendClosure(false)} data-testid={`ticket-closure-no-${key}`}
                                className="px-3 py-1.5 rounded-lg text-sm font-semibold bg-red-600 hover:bg-red-500 text-white transition-colors active:scale-95">
                                ❌ No, ho ancora il problema
                            </button>
                        </div>
                    ) : (
                        <p className="mt-2 text-sm font-semibold">
                            {closureDone === 'confirmed' ? '✅ Grazie, ticket confermato risolto!' : '📨 Segnalato al team, ti ricontattiamo a breve.'}
                        </p>
                    )}
                </div>
            </div>
        );
    }

    if (msg.type === 'ticket-rating') {
        const key = msg.ticketKey;
        const author = state.userName || 'Utente';
        const sendRating = async (stars) => {
            setRatingGiven(stars);
            try {
                await fetch(`${API_BASE_URL}/api/v1/jira/feedback`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        rating: stars >= 4 ? 'positive' : (stars === 3 ? 'neutral' : 'negative'),
                        stars, comment: `Voto soddisfazione: ${stars}/5 (chiusura ticket ${key})`,
                        userName: author, userCompany: state.userCompany || state.userSiteName,
                        ticket: key, timestamp: new Date().toISOString()
                    })
                });
            } catch (e) {}
            try {
                await fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/reply`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ body: `⭐ Valutazione soddisfazione utente: ${stars}/5`, author, author_email: state.userEmail || '' })
                });
            } catch (e) {}
            dispatch({ type: 'ADD_MESSAGE', payload: {
                sender: 'ai', type: 'system-prompt', id: Date.now() + Math.random(),
                text: stars >= 4
                    ? '🌟 **Grazie di cuore per il tuo voto!** Siamo felici di esserti stati utili. A presto!'
                    : '🙏 **Grazie per il tuo feedback.** Faremo tesoro dei tuoi suggerimenti per migliorare il servizio.'
            } });
        };
        return (
            <div className={`flex items-start space-x-3 p-4 rounded-lg my-2 animate-fade-in-up ${state.darkMode ? 'bg-amber-900/20 text-white' : 'bg-amber-50 text-gray-800'}`} data-testid={`ticket-rating-${key}`}>
                <div className="flex-1">
                    {renderText(msg.text)}
                    {!ratingGiven ? (
                        <div className="flex items-center gap-1.5 mt-3">
                            {[1, 2, 3, 4, 5].map(n => (
                                <button key={n} onClick={() => sendRating(n)} data-testid={`ticket-rating-star-${key}-${n}`}
                                    className="p-1 text-amber-400 hover:text-amber-500 hover:scale-110 transition-transform" title={`${n} ${n === 1 ? 'stella' : 'stelle'}`}>
                                    <Star className="h-7 w-7" />
                                </button>
                            ))}
                        </div>
                    ) : (
                        <div className="flex items-center gap-1 mt-2">
                            {[1, 2, 3, 4, 5].map(n => (
                                <Star key={n} className={`h-6 w-6 ${n <= ratingGiven ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}`} />
                            ))}
                            <span className="ml-2 text-sm font-semibold">{ratingGiven}/5 — grazie!</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    if (msg.type === 'system-prompt') {
        return (
            <div className={`flex items-start space-x-3 p-4 rounded-lg my-2 animate-fade-in-up ${darkMode ? 'bg-blue-900/30 text-white' : 'bg-blue-50 text-gray-800'}`}>
                <div className="flex-1">{renderText(msg.text)}</div>
            </div>
        );
    }
    
    // Genera Quick Actions per messaggi AI non in streaming
    const quickActions = msg.sender === 'ai' && !msg.isStreaming && msg.text 
        ? analyzeMessageForQuickActions(msg.userQuery || '', msg.text).filter(a => !sparkHidden(state, { ticket: 'ticket', videocall: 'videochiamata', security: 'sicurezza' }[a.type] || '_'))
        : [];

    return (
        <div 
            data-message-index={index}
            className={`flex flex-col ${msg.sender === 'user' ? 'items-end' : 'items-start'} animate-fade-in-up`}
        >
            <div className={`max-w-[85%] md:max-w-[75%] px-4 py-3 rounded-lg shadow-sm ${
                msg.sender === 'user' 
                    ? 'bg-blue-500 text-white rounded-br-none' 
                    : darkMode 
                        ? 'bg-gray-800 text-white rounded-bl-none' 
                        : 'bg-gray-100 text-gray-800 rounded-bl-none'
            }`}>
                {msg.attachment?.previewUrl && (
                    msg.attachment.type === 'image' ? <img src={msg.attachment.previewUrl} alt="Allegato" className="my-2 rounded-lg max-w-full h-auto" /> : <video src={msg.attachment.previewUrl} controls className="my-2 rounded-lg max-w-full h-auto" />
                )}
                {renderText(msg.text)}
                {msg.isStreaming && <span className={`inline-block w-2 h-4 animate-pulse ml-1 ${darkMode ? 'bg-gray-400' : 'bg-gray-600'}`} />}
                
                {/* 🔊 TTS Button per messaggi AI */}
                {msg.sender === 'ai' && !msg.isStreaming && msg.text && (
                    <div className="flex items-center gap-2 mt-2 flex-wrap">
                        <TTSButton text={msg.text} messageId={msg.id} darkMode={darkMode} />
                        
                        {/* 📈 Pulsanti Feedback Rapido */}
                        {!msg.type?.includes('system') && (
                            <div className="flex items-center gap-1">
                                <button
                                    onClick={() => handleQuickFeedback(true)}
                                    disabled={feedbackGiven !== null}
                                    className={`p-1.5 rounded-lg text-xs transition-all active:scale-95 ${
                                        feedbackGiven === 'positive'
                                            ? 'bg-green-500 text-white'
                                            : feedbackGiven !== null
                                                ? 'opacity-40 cursor-not-allowed ' + (darkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-400')
                                                : darkMode 
                                                    ? 'bg-gray-700 hover:bg-green-600 text-gray-300 hover:text-white'
                                                    : 'bg-gray-200 hover:bg-green-500 text-gray-600 hover:text-white'
                                    }`}
                                    title={feedbackGiven === 'positive' ? 'Grazie!' : 'Utile'}
                                    data-testid={`feedback-positive-${msg.id}`}
                                >
                                    <ThumbsUp className="h-3.5 w-3.5" />
                                </button>
                                <button
                                    onClick={() => handleQuickFeedback(false)}
                                    disabled={feedbackGiven !== null}
                                    className={`p-1.5 rounded-lg text-xs transition-all active:scale-95 ${
                                        feedbackGiven === 'negative'
                                            ? 'bg-red-500 text-white'
                                            : feedbackGiven !== null
                                                ? 'opacity-40 cursor-not-allowed ' + (darkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-400')
                                                : darkMode 
                                                    ? 'bg-gray-700 hover:bg-red-600 text-gray-300 hover:text-white'
                                                    : 'bg-gray-200 hover:bg-red-500 text-gray-600 hover:text-white'
                                    }`}
                                    title={feedbackGiven === 'negative' ? 'Cercherò di migliorare!' : 'Non utile'}
                                    data-testid={`feedback-negative-${msg.id}`}
                                >
                                    <ThumbsDown className="h-3.5 w-3.5" />
                                </button>
                                {feedbackGiven && (
                                    <span className={`text-[10px] ml-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                        {feedbackGiven === 'positive' ? '👍 Grazie!' : '🙏 Migliorerò!'}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
            {/* Quick Actions per messaggi AI */}
            {msg.sender === 'ai' && quickActions.length > 0 && (
                <QuickActionsBar 
                    actions={quickActions} 
                    onAction={(action) => {
                        // Le azioni vengono gestite dal dispatch nel contesto
                        if (action.type === 'ticket') {
                            dispatch({ type: 'SET_STATE', payload: { showTicketModal: true } });
                        } else if (action.type === 'videocall') {
                            dispatch({ type: 'SET_STATE', payload: { showVideoCallModal: true } });
                        } else if (action.type === 'security') {
                            dispatch({ type: 'SET_STATE', payload: { showSecurityModal: true } });
                        }
                    }}
                />
            )}
        </div>
    );
});

// ============================================================================
// PROACTIVE SUGGESTIONS CARD: Suggerimenti intelligenti per l'utente
// ============================================================================
const ProactiveSuggestionsCard = memo(({ userData, messageHistory, onAction }) => {
    const { state } = useContext(ChatContext);
    const { darkMode } = state;
    const [dismissed, setDismissed] = useState(false);
    
    const suggestions = useMemo(() => 
        getProactiveSuggestions(userData, messageHistory), 
        [userData, messageHistory]
    );
    
    if (dismissed || suggestions.length === 0) return null;
    
    return (
        <div className={`mb-4 p-3 rounded-xl animate-fade-in ${darkMode ? 'bg-gradient-to-r from-blue-900/40 to-purple-900/40 border border-blue-700/30' : 'bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200'}`}>
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-2">
                    <Lightbulb className={`h-4 w-4 ${darkMode ? 'text-yellow-400' : 'text-yellow-600'}`} />
                    <span className={`text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                        Suggerimenti per te
                    </span>
                </div>
                <button 
                    onClick={() => setDismissed(true)}
                    className={`p-1 rounded-full hover:bg-gray-500/20 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}
                    data-testid="dismiss-suggestions"
                >
                    <XCircle className="h-4 w-4" />
                </button>
            </div>
            <div className="space-y-2">
                {suggestions.map((suggestion, index) => (
                    <div 
                        key={index}
                        className={`flex items-start space-x-2 p-2 rounded-lg cursor-pointer transition-all hover:scale-[1.02] ${darkMode ? 'hover:bg-white/5' : 'hover:bg-white/50'}`}
                        onClick={() => suggestion.action && onAction(suggestion.action)}
                        data-testid={`suggestion-${index}`}
                    >
                        <span className="text-lg">{suggestion.icon}</span>
                        <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            {suggestion.text}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
});

const MessageList = memo(() => {
    const { state, dispatch } = useContext(ChatContext);
    const { messages, isLoading, searchQuery } = state;
    const messagesEndRef = useRef(null);
    const chatContainerRef = useRef(null);
    const [showOldMessages, setShowOldMessages] = useState(false);
    const [userScrolledUp, setUserScrolledUp] = useState(false);
    const prevMessageCount = useRef(messages.length);
    const lastMessageSender = useRef(null);

    const filteredMessages = messages.filter(msg => searchQuery ? msg.text?.toLowerCase().includes(searchQuery.toLowerCase()) : true);

    // Scroll intelligente: solo quando appropriato
    useEffect(() => {
        const messageCountChanged = messages.length !== prevMessageCount.current;
        const newMessageCount = messages.length;
        const lastMsg = messages[messages.length - 1];
        const currentSender = lastMsg?.sender;
        
        if (messageCountChanged && newMessageCount > prevMessageCount.current) {
            // Caso 1: L'utente ha appena inviato un messaggio -> scroll sempre
            if (currentSender === 'user') {
                setUserScrolledUp(false); // Reset del flag
                setTimeout(() => {
                    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
            // Caso 2: Risposta AI arrivata -> scroll solo se utente era in fondo
            else if (currentSender === 'ai' && !userScrolledUp) {
                setTimeout(() => {
                    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
            // Caso 3: Utente ha scrollato verso l'alto -> NON scrollare
        }
        
        prevMessageCount.current = newMessageCount;
        lastMessageSender.current = currentSender;
    }, [messages.length, userScrolledUp]);

    // Rileva se l'utente ha scrollato verso l'alto manualmente
    const handleScroll = (e) => {
        const container = e.target;
        const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 150;
        setUserScrolledUp(!isNearBottom);
    };
    
    // Separa messaggi di oggi da quelli vecchi
    const separateMessagesByAge = () => {
        const today = new Date();
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
        
        const oldMessages = [];
        const todayMessages = [];
        
        filteredMessages.forEach(msg => {
            const timestamp = msg.timestamp || msg.id;
            const msgTime = typeof timestamp === 'number' ? timestamp : new Date(timestamp).getTime();
            
            // Debug log
            if (filteredMessages.indexOf(msg) === 0) {
                console.log('[MESSAGES] Primo messaggio timestamp:', timestamp, '- todayStart:', todayStart, '- isOld:', msgTime < todayStart);
            }
            
            if (msgTime < todayStart) {
                oldMessages.push(msg);
            } else {
                todayMessages.push(msg);
            }
        });
        
        console.log('[MESSAGES] Messaggi vecchi:', oldMessages.length, '- Messaggi oggi:', todayMessages.length);
        
        return { oldMessages, todayMessages };
    };

    // Funzione per formattare la data come WhatsApp
    const getDateLabel = (timestamp) => {
        if (!timestamp) return null;
        
        const msgDate = new Date(timestamp);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        
        // Reset ore per confronto solo date
        const msgDateOnly = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());
        const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
        
        if (msgDateOnly.getTime() === todayOnly.getTime()) {
            return 'Oggi';
        } else if (msgDateOnly.getTime() === yesterdayOnly.getTime()) {
            return 'Ieri';
        } else {
            // Formato: 21 dicembre 2025
            return msgDate.toLocaleDateString('it-IT', { 
                day: 'numeric', 
                month: 'long', 
                year: 'numeric' 
            });
        }
    };

    // Raggruppa messaggi per data
    const getMessageDateKey = (msg) => {
        const timestamp = msg.timestamp || msg.id;
        if (!timestamp) return 'unknown';
        const date = new Date(typeof timestamp === 'number' ? timestamp : timestamp);
        return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
    };

    // Componente separatore data stile WhatsApp
    const DateSeparator = ({ label }) => (
        <div className="flex items-center justify-center my-4">
            <div className={`backdrop-blur-sm px-4 py-1.5 rounded-full shadow-sm border ${state.darkMode ? 'bg-gray-800/90 border-gray-700' : 'bg-white/90 border-gray-200'}`}>
                <span className={`text-xs font-medium ${state.darkMode ? 'text-gray-300' : 'text-gray-600'}`}>{label}</span>
            </div>
        </div>
    );
    
    // Componente pulsante per mostrare messaggi vecchi
    const ShowOldMessagesButton = ({ count, onClick }) => (
        <div className="flex items-center justify-center my-4">
            <button
                onClick={onClick}
                className={`flex items-center gap-2 px-4 py-2 rounded-full shadow-sm border transition-all hover:scale-105 ${
                    state.darkMode 
                        ? 'bg-gray-800 border-gray-700 text-gray-300 hover:bg-gray-700' 
                        : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'
                }`}
            >
                <History className="h-4 w-4" />
                <span className="text-sm font-medium">
                    {showOldMessages ? 'Nascondi messaggi precedenti' : `Mostra ${count} messaggi precedenti`}
                </span>
                {showOldMessages ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
            </button>
        </div>
    );

    // Renderizza messaggi con separatori di data
    const renderMessagesWithDateSeparators = (messagesToRender) => {
        if (messagesToRender.length === 0) return null;
        
        const elements = [];
        let lastDateKey = null;
        
        messagesToRender.forEach((msg, idx) => {
            const currentDateKey = getMessageDateKey(msg);
            // Trova l'indice originale nel array messages per la navigazione della ricerca
            const originalIndex = messages.findIndex(m => m.id === msg.id);
            
            // Se la data è cambiata, inserisci separatore
            if (currentDateKey !== lastDateKey) {
                const timestamp = msg.timestamp || msg.id;
                const label = getDateLabel(timestamp);
                if (label) {
                    elements.push(
                        <DateSeparator key={`date-${currentDateKey}-${idx}`} label={label} />
                    );
                }
                lastDateKey = currentDateKey;
            }
            
            elements.push(<Message key={msg.id} msg={msg} index={originalIndex} />);
        });
        
        return elements;
    };
    
    // Renderizza tutto con collapsing per messaggi vecchi
    const renderAllMessages = () => {
        const { oldMessages, todayMessages } = separateMessagesByAge();
        
        // Se non ci sono messaggi vecchi, mostra solo quelli di oggi
        if (oldMessages.length === 0) {
            return renderMessagesWithDateSeparators(filteredMessages);
        }
        
        return (
            <>
                {/* Pulsante per mostrare/nascondere messaggi vecchi */}
                {oldMessages.length > 0 && (
                    <ShowOldMessagesButton 
                        count={oldMessages.length} 
                        onClick={() => setShowOldMessages(!showOldMessages)} 
                    />
                )}
                
                {/* Messaggi vecchi (collassabili) */}
                {showOldMessages && (
                    <div className={`transition-all duration-300 ${showOldMessages ? 'opacity-100' : 'opacity-0'}`}>
                        {renderMessagesWithDateSeparators(oldMessages)}
                    </div>
                )}
                
                {/* Messaggi di oggi (sempre visibili) */}
                {todayMessages.length > 0 && renderMessagesWithDateSeparators(todayMessages)}
            </>
        );
    };

    return (
        <div 
            ref={chatContainerRef}
            onScroll={handleScroll}
            className={`h-full p-3 md:p-4 overflow-y-auto space-y-2 ${state.darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}
        >
            {state.currentPhase === 'initializing' && messages.length === 0 && !state.showWelcomeModal && (
                <div className="flex justify-center items-center h-full">
                    <div className={`text-center ${state.darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        <Loader2 className="animate-spin h-8 w-8 mx-auto mb-2" />
                        <p>Inizializzazione...</p>
                    </div>
                </div>
            )}
            
            {/* 💡 Suggerimenti Proattivi AI - mostrati dopo il benvenuto */}
            {state.currentPhase === 'chat' && messages.length <= 2 && (
                <ProactiveSuggestionsCard 
                    userData={{ userName: state.userName }}
                    messageHistory={messages}
                    onAction={(action) => {
                        if (action === 'openSecurity') {
                            dispatch({ type: 'SET_STATE', payload: { showSecurityModal: true } });
                        }
                    }}
                />
            )}
            
            {renderAllMessages()}
            
            {/* Indicatore "Spark sta scrivendo..." migliorato */}
            {isLoading && messages.length > 0 && messages[messages.length - 1]?.sender === 'user' && (
                <div className="flex items-start space-x-3 p-4 animate-fade-in">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md">
                        <MessageCircle className="h-4 w-4 text-white" />
                    </div>
                    <div className={`px-4 py-3 rounded-2xl rounded-tl-none shadow-sm ${state.darkMode ? 'bg-gray-800' : 'bg-gradient-to-r from-gray-100 to-gray-200'}`}>
                        <div className="flex items-center space-x-2">
                            <span className={`text-sm font-medium ${state.darkMode ? 'text-white' : 'text-gray-700'}`}>Spark sta scrivendo</span>
                            <div className="flex space-x-1">
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div ref={messagesEndRef} className="h-1" />
        </div>
    );
});

const ChatInput = memo(() => {
    const { state, dispatch, actions } = useContext(ChatContext);
    const { input, isLoading, attachment, confirmEndSession, currentPhase, isMobile } = state;
    
    // 🎙️ Voice AI Integration
    const handleVoiceTranscript = useCallback((transcript) => {
        dispatch({ type: 'SET_STATE', payload: { input: transcript } });
    }, [dispatch]);
    
    const {
        isListening,
        isSpeaking,
        interimTranscript,
        voiceError,
        isSupported,
        toggleListening,
        stopSpeaking
    } = useVoiceAI(dispatch, handleVoiceTranscript);

    const handleInputChange = (e) => dispatch({ type: 'SET_STATE', payload: { input: e.target.value } });
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isLoading && (input.trim() || (attachment && attachment.data))) {
            // 🎙️ Ferma TTS se sta parlando
            if (isSpeaking) {
                stopSpeaking();
            }
            actions.handleFormSubmit(input);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && !isLoading && (input.trim() || (attachment && attachment.data))) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const handleAttachmentChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const previewUrl = URL.createObjectURL(file);
        const reader = new FileReader();
        reader.onload = (event) => {
            dispatch({ type: 'SET_STATE', payload: { attachment: { name: file.name, type: file.type.split('/')[0], previewUrl, data: event.target.result } } });
        };
        reader.readAsDataURL(file);
    };

    // 📷 Funzione per catturare screenshot dello schermo
    const handleTakeScreenshot = async () => {
        try {
            // Richiedi la condivisione dello schermo
            const stream = await navigator.mediaDevices.getDisplayMedia({
                video: { mediaSource: 'screen' },
                preferCurrentTab: false
            });

            // Crea un elemento video per catturare il frame
            const video = document.createElement('video');
            video.srcObject = stream;
            await video.play();

            // Attendi che il video sia pronto
            await new Promise(resolve => setTimeout(resolve, 100));

            // Crea un canvas per catturare l'immagine
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0);

            // Ferma subito la condivisione
            stream.getTracks().forEach(track => track.stop());

            // Converti in blob
            canvas.toBlob((blob) => {
                if (blob) {
                    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
                    const fileName = `screenshot_${timestamp}.png`;
                    const previewUrl = URL.createObjectURL(blob);
                    
                    // Converti blob in base64
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        dispatch({ 
                            type: 'SET_STATE', 
                            payload: { 
                                attachment: { 
                                    name: fileName, 
                                    type: 'image', 
                                    previewUrl, 
                                    data: event.target.result 
                                } 
                            } 
                        });
                    };
                    reader.readAsDataURL(blob);
                }
            }, 'image/png');

        } catch (err) {
            // L'utente ha annullato o il browser non supporta getDisplayMedia
            if (err.name !== 'AbortError' && err.name !== 'NotAllowedError') {
                console.error('Errore cattura screenshot:', err);
                alert('Impossibile catturare lo screenshot. Assicurati che il tuo browser supporti questa funzionalità.');
            }
        }
    };

    const placeholders = {
        name: "Il tuo nome...",
        company: "La tua azienda...",
        computer: "Nome del computer...",
        'ask-hardware-type': "Scrivi 'Fisso' o 'Notebook'...",
        chat: "Scrivi qui…",
    };

    // Regola oraria per il pulsante "Chiama" (mobile)
    // Visibile solo Lun-Ven (1-5) dalle 08:00 alle 19:00
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    
    // Orari funzioni Remoto: Lun-Ven 09:00-17:00, Sabato 09:00-12:00 (Domenica chiuso)
    const withinFunctionsHours = (() => {
        if (day >= 1 && day <= 5) return hour >= 9 && hour < 17;
        if (day === 6) return hour >= 9 && hour < 12;
        return false;
    })();

    // Pulsante telefono "Chiama": orari verdi ma nascosto dalle 20:00 in poi
    // Lun-Ven 7:30-20:00, Sabato 8:00-12:30
    const isGreenHours = getSupportAvailability().status === 'online';
    const showCallButton = isGreenHours && state.launchedFromBatch && new Date().getHours() < 20 && !sparkHidden(state, 'chiama');

    // Pulsante supporto remoto: solo su mobile e negli orari funzioni (9-17 / 9-12)
    const showRemoteButton = isMobile && withinFunctionsHours && !sparkHidden(state, 'remoto');

    return (
        <div className={`flex-shrink-0 z-50 border-t transition-colors ${state.darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'}`} style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
            {/* Mobile bottom navigation - barra compatta */}
            <div className={`md:hidden backdrop-blur-sm px-2 py-2 flex justify-around items-center border-b ${state.darkMode ? 'bg-gray-800/95 border-gray-700' : 'bg-white/95 border-gray-200'}`}>
                {/* Ticket - SEMPRE visibile a tutti gli orari */}
                {!sparkHidden(state, 'ticket') && (
                <button onTouchStart={() => {}} onClick={() => dispatch({ type: 'SET_STATE', payload: { showTicketModal: true } })} data-testid="open-ticket-nav-btn" className={`flex flex-col items-center px-3 py-2 rounded-lg transition-transform active:scale-95 ${state.darkMode ? 'text-purple-400 active:bg-purple-900/30' : 'text-purple-600 active:bg-purple-100'}`}>
                    <Ticket className="h-5 w-5" />
                    <span className="text-[10px] mt-0.5 font-medium">Ticket</span>
                </button>
                )}
                
                {/* Prenota - solo se avviato da batch */}
                {state.launchedFromBatch && !sparkHidden(state, 'prenota') && (
                    <a onTouchStart={() => {}} href="https://calendly.com/calendariotecnico/86bit-helpmanagement-calendar" target="_blank" rel="noopener noreferrer" className={`flex flex-col items-center px-3 py-2 rounded-lg transition-transform active:scale-95 ${state.darkMode ? 'text-indigo-400 active:bg-indigo-900/30' : 'text-indigo-600 active:bg-indigo-100'}`}>
                        <Calendar className="h-5 w-5" />
                        <span className="text-[10px] mt-0.5 font-medium">Prenota</span>
                    </a>
                )}
                
                {/* Chiama - solo orari VERDI e solo se avviato da Batch */}
                {showCallButton && (
                    <button 
                        onTouchStart={() => {}}
                        onClick={() => {
                            if (canMakePhoneCalls()) {
                                window.location.href = 'tel:+39035310900';
                            } else {
                                dispatch({ type: 'SET_STATE', payload: { showPhoneModal: true } });
                            }
                        }}
                        className={`flex flex-col items-center px-3 py-2 rounded-lg transition-transform active:scale-95 ${state.darkMode ? 'text-green-400 active:bg-green-900/30' : 'text-green-600 active:bg-green-100'}`}
                    >
                        <Phone className="h-5 w-5" />
                        <span className="text-[10px] mt-0.5 font-medium">Chiama</span>
                    </button>
                )}
                
                {/* Videochiamata rimossa: la gestione avviene tramite WhatsApp (Supporto Remoto) */}
                {showRemoteButton && (
                    <button
                        onClick={() => dispatch({ type: 'SET_STATE', payload: { showRemoteSupportModal: true } })}
                        className={`flex flex-col items-center px-3 py-2 rounded-lg transition-transform active:scale-95 ${state.darkMode ? 'text-green-400 active:bg-green-900/30' : 'text-green-600 active:bg-green-100'}`}
                        data-testid="remote-support-btn"
                    >
                        <Monitor className="h-5 w-5" />
                        <span className="text-[10px] mt-0.5 font-medium">Remoto</span>
                    </button>
                )}

                {/* Richiesta Cambio PC */}
                {!sparkHidden(state, 'cambio_pc') && (
                <button
                    onTouchStart={() => {}}
                    onClick={() => dispatch({ type: 'SET_STATE', payload: { showPcChangeForm: true } })}
                    data-testid="open-pc-change-nav-btn"
                    title="Gestione Operativa"
                    className={`flex flex-col items-center px-3 py-2 rounded-lg transition-transform active:scale-95 ${state.darkMode ? 'text-sky-400 active:bg-sky-900/30' : 'text-sky-600 active:bg-sky-100'}`}
                >
                    <Laptop className="h-5 w-5" />
                    <span className="text-[10px] mt-0.5 font-medium leading-tight text-center">Gestione<br />Operativa</span>
                </button>
                )}

                {/* Centro Sicurezza e Formazione - SEMPRE visibile su mobile */}
                {!sparkHidden(state, 'sicurezza') && (
                <button
                    onTouchStart={() => {}}
                    onClick={() => dispatch({ type: 'SET_STATE', payload: { showSecurityModal: true } })}
                    data-testid="open-security-nav-btn"
                    title="Centro Sicurezza e Formazione"
                    className={`flex flex-col items-center px-3 py-2 rounded-lg transition-transform active:scale-95 ${state.darkMode ? 'text-yellow-400 active:bg-yellow-900/30' : 'text-yellow-600 active:bg-yellow-100'}`}
                >
                    <ShieldCheck className="h-5 w-5" />
                    <span className="text-[10px] mt-0.5 font-medium">Sicurezza</span>
                </button>
                )}
            </div>

            <form onSubmit={handleSubmit} className="p-2 md:p-4 md:pb-2">
                {attachment && attachment.name && (
                    <div className={`mb-2 p-2 rounded-lg flex items-center justify-between ${state.darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                        <div className="flex items-center">
                            {attachment.previewUrl && (attachment.type === 'image' ? <img src={attachment.previewUrl} alt="Preview" className="w-12 h-12 rounded-md object-cover" /> : <video src={attachment.previewUrl} className="w-12 h-12 rounded-md object-cover" />)}
                            <span className={`ml-3 text-sm ${state.darkMode ? 'text-gray-300' : 'text-gray-600'}`}>{attachment.name}</span>
                        </div>
                        <button type="button" onClick={() => dispatch({ type: 'SET_STATE', payload: { attachment: { data: null, name: '', previewUrl: null, type: null } } })} className="text-red-500 p-2 rounded-full hover:bg-red-100"><Trash2 className="h-5 w-5" /></button>
                    </div>
                )}

                <div className="flex items-end w-full gap-1.5 md:gap-2">
                    <label className={`cursor-pointer p-2.5 rounded-lg flex-shrink-0 active:scale-95 transition-transform ${state.darkMode ? 'text-gray-300 hover:bg-gray-700 active:bg-gray-600' : 'text-gray-500 hover:bg-gray-100 active:bg-gray-200'}`} title="Allega file">
                        <ImageIcon className="h-5 w-5" />
                        <input type="file" accept="image/*,video/*" className="hidden" onChange={handleAttachmentChange} disabled={isLoading} />
                    </label>
                    {/* Pulsante Screenshot - solo su desktop */}
                    {!isMobile && (
                        <button 
                            type="button" 
                            onClick={handleTakeScreenshot}
                            className={`p-2.5 rounded-lg flex-shrink-0 active:scale-95 transition-transform ${state.darkMode ? 'text-gray-300 hover:bg-gray-700' : 'text-gray-500 hover:bg-gray-100'}`}
                            title="📷 Cattura Screenshot"
                            disabled={isLoading}
                        >
                            <Monitor className="h-5 w-5" />
                        </button>
                    )}
                    <textarea 
                        value={input} 
                        onChange={handleInputChange} 
                        onKeyDown={handleKeyDown} 
                        onFocus={(e) => {
                            // Scroll l'input in vista su mobile quando riceve focus
                            if (isMobile) {
                                setTimeout(() => {
                                    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }, 300);
                            }
                        }}
                        placeholder={placeholders[currentPhase] || "Scrivi qui…"} 
                        className={`flex-1 min-w-0 p-2.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none text-base ${state.darkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-200 text-gray-900 placeholder-gray-400'}`} 
                        rows="1" 
                        disabled={isLoading || confirmEndSession}
                        inputMode="text"
                        enterKeyHint="send"
                        autoComplete="off"
                        autoCorrect="on"
                        autoCapitalize="sentences"
                        spellCheck="true"
                        style={{ touchAction: 'auto', WebkitUserSelect: 'text', userSelect: 'text' }}
                    />
                    <button onTouchStart={() => {}} type="submit" className="bg-blue-500 text-white p-2.5 rounded-lg hover:bg-blue-600 disabled:opacity-50 flex-shrink-0 active:scale-95 transition-transform" disabled={isLoading || (!input.trim() && !(attachment && attachment.data))}>{isLoading ? <Loader2 className="animate-spin h-5 w-5" /> : <Send className="h-5 w-5" />}</button>
                    {/* 🎙️ Voice AI Button */}
                    <button 
                        onTouchStart={() => {}} 
                        type="button" 
                        onClick={toggleListening}
                        className={`p-2.5 rounded-lg flex-shrink-0 active:scale-95 transition-all ${
                            isListening 
                                ? 'bg-red-500 text-white animate-pulse ring-2 ring-red-300' 
                                : state.darkMode 
                                    ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                    : 'bg-gray-200 hover:bg-gray-300 text-gray-600'
                        }`} 
                        disabled={isLoading || !isSupported.stt}
                        title={isListening ? 'Clicca per fermare' : (isSupported.stt ? 'Parla con Spark' : 'Microfono non supportato')}
                    >
                        {isListening ? <StopCircle className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
                    </button>
                    <button onTouchStart={() => {}} type="button" onClick={() => dispatch({ type: 'SET_STATE', payload: { confirmEndSession: true } })} className={`p-2.5 rounded-lg flex-shrink-0 active:scale-95 transition-transform ${state.darkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-200 hover:bg-gray-300 text-gray-600'}`}><XCircle className="h-5 w-5" /></button>
                </div>
                
                {/* 🎙️ Voice AI Feedback */}
                {isListening && (
                    <div className={`mt-2 p-3 rounded-lg flex items-center gap-3 animate-fade-in ${state.darkMode ? 'bg-red-900/30 border border-red-700/50' : 'bg-red-50 border border-red-200'}`}>
                        <div className="relative flex items-center justify-center">
                            <div className="absolute w-8 h-8 bg-red-500 rounded-full animate-ping opacity-30"></div>
                            <Mic className={`h-5 w-5 ${state.darkMode ? 'text-red-400' : 'text-red-500'}`} />
                        </div>
                        <div className="flex-1">
                            <p className={`text-sm font-medium ${state.darkMode ? 'text-red-300' : 'text-red-700'}`}>
                                🎙️ Sto ascoltando...
                            </p>
                            {interimTranscript && (
                                <p className={`text-sm mt-1 italic ${state.darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                    "{interimTranscript}"
                                </p>
                            )}
                        </div>
                        <button 
                            onClick={toggleListening}
                            className="px-3 py-1.5 bg-red-500 text-white text-sm rounded-lg hover:bg-red-600 active:scale-95 transition-all"
                        >
                            Stop
                        </button>
                    </div>
                )}
                
                {/* 🎙️ Voice Error */}
                {voiceError && (
                    <div className={`mt-2 p-2 rounded-lg flex items-center gap-2 animate-fade-in ${state.darkMode ? 'bg-orange-900/30 border border-orange-700/50' : 'bg-orange-50 border border-orange-200'}`}>
                        <AlertTriangle className={`h-4 w-4 ${state.darkMode ? 'text-orange-400' : 'text-orange-500'}`} />
                        <p className={`text-sm ${state.darkMode ? 'text-orange-300' : 'text-orange-700'}`}>{voiceError}</p>
                    </div>
                )}

                {confirmEndSession && (
                    <div className={`mt-2 p-2 rounded-lg flex items-center justify-between ${state.darkMode ? 'bg-red-900/50 border border-red-700' : 'bg-red-100 border border-red-300'}`}>
                        <p className={`text-sm font-medium ${state.darkMode ? 'text-red-300' : 'text-red-800'}`}>Sei sicuro di voler terminare?</p>
                        <div>
                            <button onClick={() => dispatch({ type: 'SET_STATE', payload: { showModal: true } })} className="bg-red-600 text-white px-3 py-1 rounded-md text-sm hover:bg-red-700">Sì</button>
                            <button onClick={() => dispatch({ type: 'SET_STATE', payload: { confirmEndSession: false } })} className={`ml-2 px-3 py-1 rounded-md text-sm ${state.darkMode ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'}`}>Annulla</button>
                        </div>
                    </div>
                )}

                {/* Footer dati aziendali - completo su desktop, ridotto su mobile */}
                <div className={`w-full mt-2 pt-2 border-t ${state.darkMode ? 'border-gray-700/50' : 'border-gray-100'}`}>
                    <div className={`text-center space-y-0.5 ${state.darkMode ? 'text-gray-500' : 'text-gray-400'}`} style={{ fontSize: '0.5rem' }}>
                        <p className={`font-semibold tracking-wide ${state.darkMode ? 'text-gray-400' : 'text-gray-500'}`}>86BIT S.r.l.</p>
                        {!state.isMobile && (
                            <>
                                <p>C.F. e P.Iva 04353030168 • Cap. Soc. € 50.000,00 i.v. • Reg. Imprese BG 04353030168 • REA n. BG456578</p>
                                <p>Sede Operativa: Piazza Papa Giovanni XXIII, 24020 Scanzorosciate (BG) • Sede Secondaria: Piazza Manzù, 8, 24023 Clusone (BG)</p>
                            </>
                        )}
                        <p className={`font-mono text-[0.45rem] mt-0.5 ${state.darkMode ? 'text-gray-600' : 'text-gray-300'}`}>{APP_VERSION}</p>
                    </div>
                </div>
            </form>
        </div>
    );
});

const ContactSidebar = () => {
    const { state, dispatch } = useContext(ChatContext);
    
    const handleTicketClick = () => {
        console.log('[TICKET] Ticket button clicked - Opening modal');
        dispatch({ type: 'SET_STATE', payload: { showTicketModal: true } });
    };
    
    // Regola oraria per il pulsante "Chiama"
    // Visibile solo Lun-Ven (1-5) dalle 08:00 alle 19:00
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    
    // Usa la funzione getSupportAvailability per determinare lo stato
    const supportStatus = getSupportAvailability();
    const isGreenHours = supportStatus.status === 'online'; // Solo orari verdi
    
    // Pulsante telefono: solo orari VERDI, avviato da Batch e nascosto dalle 20:00
    const showCallButton = isGreenHours && state.launchedFromBatch && hour < 20 && !sparkHidden(state, 'chiama');
    
    return (
        <div className={`hidden md:flex md:flex-col md:w-auto md:fixed md:top-1/2 md:right-4 md:transform md:-translate-y-1/2 md:p-3 md:gap-2 md:rounded-lg md:shadow-lg z-20 ${state.darkMode ? 'md:bg-gray-800/90' : 'md:bg-white/90'}`}>
            {/* Ticket - SEMPRE visibile a tutti gli orari */}
            {!sparkHidden(state, 'ticket') && (
            <button onClick={handleTicketClick} data-testid="open-ticket-btn" className="w-full p-2 text-sm font-semibold bg-purple-600 text-white hover:bg-purple-700 flex items-center rounded-md">
                <Ticket className="h-5 w-5" /><span className="ml-2">Ticket</span>
            </button>
            )}
            
            {/* Prenota - solo se avviato da batch */}
            {state.launchedFromBatch && !sparkHidden(state, 'prenota') && (
                <a href="https://calendly.com/calendariotecnico/86bit-helpmanagement-calendar" target="_blank" rel="noopener noreferrer" className="w-full p-2 text-sm font-semibold bg-indigo-600 text-white hover:bg-indigo-700 flex items-center rounded-md">
                    <Calendar className="h-5 w-5" /><span className="ml-2">Prenota</span>
                </a>
            )}
            
            {/* Pulsante Chiama - Solo orari VERDI e solo se avviato da Batch */}
            {showCallButton && (
                <button 
                    onClick={() => {
                        if (canMakePhoneCalls()) {
                            window.location.href = 'tel:+39035310900';
                        } else {
                            dispatch({ type: 'SET_STATE', payload: { showPhoneModal: true } });
                        }
                    }}
                    className="w-full p-2 text-sm font-semibold bg-green-600 text-white hover:bg-green-700 flex items-center rounded-md"
                >
                    <Phone className="h-5 w-5" /><span className="ml-2">Chiama</span>
                </button>
            )}
            
            {/* Separatore (alzato) */}
            <div className="mt-2 pt-2 border-t border-gray-200"></div>

            {/* Centro Sicurezza - sotto la riga */}
            {!sparkHidden(state, 'sicurezza') && (
            <button
                onClick={() => dispatch({ type: 'SET_STATE', payload: { showSecurityModal: true } })}
                data-testid="open-security-btn"
                title="Centro Sicurezza"
                className="w-full p-2 text-sm font-semibold bg-yellow-400 text-gray-900 hover:bg-yellow-300 flex items-center rounded-md transition-colors"
            >
                <ShieldCheck className="h-5 w-5 shrink-0" /><span className="ml-2 leading-tight text-left">Centro Sicurezza<br />e Formazione</span>
            </button>
            )}

            {/* Richiesta Cambio PC */}
            {!sparkHidden(state, 'cambio_pc') && (
            <button
                onClick={() => dispatch({ type: 'SET_STATE', payload: { showPcChangeForm: true } })}
                data-testid="open-pc-change-btn"
                title="Gestione Operativa"
                className="w-full p-2 text-sm font-semibold bg-sky-600 text-white hover:bg-sky-700 flex items-center rounded-md transition-colors"
            >
                <Laptop className="h-5 w-5 shrink-0" /><span className="ml-2 leading-tight text-left">Gestione<br />Operativa</span>
            </button>
            )}

            {/* Pulsante Videochiama - NASCOSTO su desktop, visibile solo su mobile nella barra in basso */}
            {/* Il pulsante per mobile è nella MobileBottomBar */}
            
            {/* Logo 86BIT - versione nera */}
            <div className="mt-3">
                <img 
                    src={LOGO_86BIT_DARK_BASE64} 
                    alt="86BIT Logo" 
                    className="w-32 h-32 mx-auto object-contain"
                />
            </div>
            
            {/* Social Links */}
            <div className="flex justify-center gap-4 mt-2">
                <a href="https://www.facebook.com/86BIT" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-600 transition-colors">
                    <Facebook className="h-6 w-6" />
                </a>
                <a href="https://www.instagram.com/86bit_informatica/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-pink-500 transition-colors">
                    <Instagram className="h-6 w-6" />
                </a>
                <a href="https://www.linkedin.com/company/86bit/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-700 transition-colors">
                    <Linkedin className="h-6 w-6" />
                </a>
            </div>
        </div>
    );
};

// ============================================================================
// ⌨️ KEYBOARD SHORTCUTS - Navigazione rapida con tastiera
// ============================================================================
const KEYBOARD_SHORTCUTS = [
    { keys: ['Ctrl', 'K'], description: 'Apri/Chiudi ricerca nella chat', action: 'toggleSearch' },
    { keys: ['Ctrl', 'Enter'], description: 'Invia messaggio', action: 'sendMessage' },
    { keys: ['Ctrl', 'N'], description: 'Nuova conversazione', action: 'newChat' },
    { keys: ['Ctrl', '/'], description: 'Mostra shortcuts', action: 'showShortcuts' },
    { keys: ['Escape'], description: 'Chiudi modal/ricerca', action: 'escape' },
    { keys: ['Ctrl', 'M'], description: 'Attiva/Disattiva microfono', action: 'toggleMic' },
    { keys: ['Ctrl', 'Shift', 'D'], description: 'Modalità scura/chiara', action: 'toggleDarkMode' },
    { keys: ['F1'], description: 'Mostra aiuto shortcuts', action: 'showShortcuts' },
];

// Modal per mostrare gli shortcuts
const ShortcutsModal = ({ onClose, darkMode }) => {
    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={onClose}>
            <div 
                className={`w-full max-w-md rounded-2xl p-5 shadow-2xl ${darkMode ? 'bg-gray-900 border border-gray-700' : 'bg-white'}`}
                onClick={e => e.stopPropagation()}
            >
                <div className="flex items-center justify-between mb-4">
                    <h3 className={`text-lg font-bold flex items-center gap-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                        ⌨️ Shortcuts Tastiera
                    </h3>
                    <button 
                        onClick={onClose}
                        className={`p-2 rounded-lg transition-colors ${darkMode ? 'hover:bg-gray-800 text-gray-400' : 'hover:bg-gray-100 text-gray-500'}`}
                    >
                        <XCircle className="h-5 w-5" />
                    </button>
                </div>
                
                <div className="space-y-2">
                    {KEYBOARD_SHORTCUTS.map((shortcut, idx) => (
                        <div 
                            key={idx} 
                            className={`flex items-center justify-between py-2 px-3 rounded-lg ${darkMode ? 'bg-gray-800/50' : 'bg-gray-50'}`}
                        >
                            <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                {shortcut.description}
                            </span>
                            <div className="flex gap-1">
                                {shortcut.keys.map((key, kidx) => (
                                    <kbd 
                                        key={kidx}
                                        className={`px-2 py-1 text-xs font-mono rounded ${
                                            darkMode 
                                                ? 'bg-gray-700 text-gray-200 border border-gray-600' 
                                                : 'bg-gray-200 text-gray-700 border border-gray-300'
                                        }`}
                                    >
                                        {key}
                                    </kbd>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
                
                <div className={`mt-4 pt-3 border-t text-center ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                    <p className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                        Premi <kbd className={`px-1.5 py-0.5 text-xs font-mono rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>Esc</kbd> per chiudere
                    </p>
                </div>
            </div>
        </div>
    );
};

// Hook per gestire gli shortcuts
const useKeyboardShortcuts = (dispatch, state, actions) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            const isInputFocused = ['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName);
            const isCtrlOrCmd = e.ctrlKey || e.metaKey;
            
            // Ctrl+K - Toggle Search
            if (isCtrlOrCmd && e.key === 'k') {
                e.preventDefault();
                dispatch({ type: 'SET_STATE', payload: { showSearch: !state.showSearch, searchQuery: '' } });
                return;
            }
            
            // Ctrl+/ o F1 - Show Shortcuts
            if ((isCtrlOrCmd && e.key === '/') || e.key === 'F1') {
                e.preventDefault();
                dispatch({ type: 'SET_STATE', payload: { showShortcutsModal: true } });
                return;
            }
            
            // Ctrl+N - New Chat (solo se non in input)
            if (isCtrlOrCmd && e.key === 'n' && !isInputFocused) {
                e.preventDefault();
                if (state.messages?.length > 0) {
                    dispatch({ type: 'SET_STATE', payload: { confirmEndSession: true } });
                }
                return;
            }
            
            // Ctrl+Shift+D - Toggle Dark Mode (Ctrl+D lasciato al browser per i Preferiti)
            if (isCtrlOrCmd && e.shiftKey && e.key.toLowerCase() === 'd' && !isInputFocused) {
                e.preventDefault();
                dispatch({ type: 'SET_STATE', payload: { darkMode: !state.darkMode } });
                return;
            }
            
            // Ctrl+M - Toggle Microphone
            if (isCtrlOrCmd && e.key === 'm') {
                e.preventDefault();
                const recognition = getVoiceRecognition();
                if (recognition.isListening) {
                    recognition.stop();
                } else {
                    recognition.start();
                }
                return;
            }
            
            // Escape - Close modals/search
            if (e.key === 'Escape') {
                if (state.showShortcutsModal) {
                    dispatch({ type: 'SET_STATE', payload: { showShortcutsModal: false } });
                    return;
                }
                if (state.showSearch) {
                    dispatch({ type: 'SET_STATE', payload: { showSearch: false, searchQuery: '' } });
                    return;
                }
                // Chiudi altri modali aperti
                if (state.showModal || state.showUserDashboard || state.showTicketModal) {
                    dispatch({ type: 'SET_STATE', payload: { 
                        showModal: false, 
                        showUserDashboard: false,
                        showTicketModal: false,
                        confirmEndSession: false
                    } });
                    return;
                }
            }
        };
        
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [dispatch, state]);
};

// ============================================================================
// 🔍 RICERCA AVANZATA NELLA CHAT - Con navigazione risultati
// ============================================================================
const AdvancedSearchBar = () => {
    const { state, dispatch } = useContext(ChatContext);
    const [currentResultIndex, setCurrentResultIndex] = useState(0);
    const inputRef = useRef(null);
    
    // Trova tutti i messaggi che contengono la query
    const searchResults = useMemo(() => {
        if (!state.searchQuery || state.searchQuery.length < 2) return [];
        const query = state.searchQuery.toLowerCase();
        return state.messages
            .map((msg, index) => ({ msg, index }))
            .filter(({ msg }) => msg.text?.toLowerCase().includes(query));
    }, [state.messages, state.searchQuery]);
    
    const totalResults = searchResults.length;
    
    // Scroll al risultato corrente
    useEffect(() => {
        if (searchResults.length > 0 && currentResultIndex >= 0) {
            const targetIndex = searchResults[currentResultIndex]?.index;
            const messageElement = document.querySelector(`[data-message-index="${targetIndex}"]`);
            if (messageElement) {
                messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [currentResultIndex, searchResults]);
    
    // Focus input quando si apre la ricerca
    useEffect(() => {
        if (state.showSearch && inputRef.current) {
            inputRef.current.focus();
        }
    }, [state.showSearch]);
    
    const handlePrevResult = () => {
        setCurrentResultIndex(prev => (prev > 0 ? prev - 1 : totalResults - 1));
    };
    
    const handleNextResult = () => {
        setCurrentResultIndex(prev => (prev < totalResults - 1 ? prev + 1 : 0));
    };
    
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (e.shiftKey) {
                handlePrevResult();
            } else {
                handleNextResult();
            }
        }
        if (e.key === 'Escape') {
            dispatch({ type: 'SET_STATE', payload: { showSearch: false, searchQuery: '' } });
        }
    };
    
    const handleClear = () => {
        dispatch({ type: 'SET_STATE', payload: { searchQuery: '' } });
        setCurrentResultIndex(0);
        inputRef.current?.focus();
    };
    
    return (
        <div className={`p-2 border-b flex items-center gap-2 ${state.darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-100 border-gray-200'}`}>
            <Search className={`h-5 w-5 ml-2 ${state.darkMode ? 'text-gray-400' : 'text-gray-500'}`} />
            
            <input 
                ref={inputRef}
                type="text" 
                value={state.searchQuery} 
                onChange={(e) => {
                    dispatch({ type: 'SET_STATE', payload: { searchQuery: e.target.value } });
                    setCurrentResultIndex(0);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Cerca nella conversazione... (Enter per navigare)" 
                className={`flex-1 bg-transparent focus:outline-none text-sm ${state.darkMode ? 'text-white placeholder-gray-400' : ''}`}
            />
            
            {/* Contatore risultati */}
            {state.searchQuery && (
                <div className={`flex items-center gap-1 text-xs ${state.darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {totalResults > 0 ? (
                        <span>{currentResultIndex + 1} / {totalResults}</span>
                    ) : (
                        <span>0 risultati</span>
                    )}
                </div>
            )}
            
            {/* Navigazione risultati */}
            {totalResults > 1 && (
                <div className="flex items-center gap-1">
                    <button 
                        onClick={handlePrevResult}
                        className={`p-1.5 rounded transition-colors ${state.darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-200 text-gray-500'}`}
                        title="Risultato precedente (Shift+Enter)"
                    >
                        <ChevronUp className="h-4 w-4" />
                    </button>
                    <button 
                        onClick={handleNextResult}
                        className={`p-1.5 rounded transition-colors ${state.darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-200 text-gray-500'}`}
                        title="Risultato successivo (Enter)"
                    >
                        <ChevronDown className="h-4 w-4" />
                    </button>
                </div>
            )}
            
            {/* Clear button */}
            {state.searchQuery && (
                <button 
                    onClick={handleClear}
                    className={`p-1.5 rounded transition-colors ${state.darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-200 text-gray-500'}`}
                    title="Cancella ricerca"
                >
                    <XCircle className="h-4 w-4" />
                </button>
            )}
            
            {/* Close search */}
            <button 
                onClick={() => dispatch({ type: 'SET_STATE', payload: { showSearch: false, searchQuery: '' } })}
                className={`p-1.5 rounded transition-colors ${state.darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-200 text-gray-500'}`}
                title="Chiudi ricerca (Esc)"
            >
                <XCircle className="h-4 w-4" />
            </button>
        </div>
    );
};

// Hint per shortcuts - mostra un piccolo suggerimento
const ShortcutsHint = ({ darkMode, onShowShortcuts }) => {
    const [show, setShow] = useState(false);
    const HINT_SHOWN_KEY = 'spark-shortcuts-hint-shown';
    
    useEffect(() => {
        // Mostra hint solo la prima volta o se non è stato ancora mostrato
        const hasSeenHint = localStorage.getItem(HINT_SHOWN_KEY);
        if (!hasSeenHint) {
            // Mostra dopo 5 secondi dall'apertura
            const timer = setTimeout(() => setShow(true), 5000);
            return () => clearTimeout(timer);
        }
    }, []);
    
    const handleDismiss = (e) => {
        if (e) e.stopPropagation();
        setShow(false);
        localStorage.setItem(HINT_SHOWN_KEY, 'true');
    };

    const handleClick = () => {
        setShow(false);
        localStorage.setItem(HINT_SHOWN_KEY, 'true');
        if (onShowShortcuts) {
            onShowShortcuts();
        }
    };
    
    if (!show) return null;
    
    return (
        <div className="fixed bottom-32 right-4 z-[60] animate-slide-up" data-testid="shortcuts-hint">
            <div 
                onClick={handleClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleClick()}
                className={`p-3 rounded-xl shadow-lg max-w-xs cursor-pointer transition-all hover:scale-105 active:scale-95 ${darkMode ? 'bg-gray-800 border border-gray-700 hover:border-blue-500' : 'bg-white border border-gray-200 hover:border-blue-400'}`}
            >
                <div className="flex items-start gap-2">
                    <div className="text-lg">⌨️</div>
                    <div className="flex-1">
                        <p className={`text-sm font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                            Shortcuts disponibili!
                        </p>
                        <p className={`text-xs mt-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            Clicca qui o premi <kbd className={`px-1 py-0.5 text-xs font-mono rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>Ctrl</kbd>+<kbd className={`px-1 py-0.5 text-xs font-mono rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>/</kbd>
                        </p>
                    </div>
                    <button 
                        onClick={handleDismiss} 
                        className={`p-1 rounded ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
                        aria-label="Chiudi"
                    >
                        <XCircle className={`h-4 w-4 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} />
                    </button>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// ADD TO HOME SCREEN BANNER (mobile) - invita a installare Spark come app PWA
// ============================================================================
const AddToHomeBanner = ({ darkMode }) => {
    const SNOOZE_KEY = 'spark-a2hs-snooze';       // temporaneo (sessione) - la X rimanda solo per questa sessione
    const INSTALLED_KEY = 'spark-a2hs-installed';  // permanente - app installata
    const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);
    const [show, setShow] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showIOSGuide, setShowIOSGuide] = useState(false);

    useEffect(() => {
        if (isStandalone) return; // gia' aperta come app installata
        try { if (localStorage.getItem(INSTALLED_KEY)) return; } catch (e) {}
        try { if (sessionStorage.getItem(SNOOZE_KEY)) return; } catch (e) {} // chiusa in questa sessione
        const onBIP = (e) => { e.preventDefault(); setDeferredPrompt(e); };
        const onInstalled = () => { setShow(false); try { localStorage.setItem(INSTALLED_KEY, '1'); } catch (e) {} };
        window.addEventListener('beforeinstallprompt', onBIP);
        window.addEventListener('appinstalled', onInstalled);
        const t = setTimeout(() => setShow(true), 3500);
        return () => {
            window.removeEventListener('beforeinstallprompt', onBIP);
            window.removeEventListener('appinstalled', onInstalled);
            clearTimeout(t);
        };
    }, [isStandalone]);

    const dismiss = () => { setShow(false); try { sessionStorage.setItem(SNOOZE_KEY, '1'); } catch (e) {} };

    const install = async () => {
        if (isIOS) { setShowIOSGuide(true); return; }
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') dismiss();
            setDeferredPrompt(null);
        } else {
            setShowIOSGuide(true);
        }
    };

    if (!show || isStandalone) return null;

    return (
        <>
            <div className="fixed top-3 inset-x-3 z-[75] animate-slide-up" data-testid="a2hs-banner">
                <div className={`rounded-2xl shadow-xl border p-3 flex items-center gap-3 ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-200 text-gray-800'}`}>
                    <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center">
                        <Smartphone className="h-5 w-5 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold leading-tight">Aggiungi Spark alla Home</p>
                        <p className={`text-xs mt-0.5 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Aprilo come un'app, senza browser.</p>
                    </div>
                    <button onClick={install} className="flex-shrink-0 px-3 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-xs font-semibold" data-testid="a2hs-install">
                        {isIOS ? 'Come fare' : 'Installa'}
                    </button>
                    <button onClick={dismiss} className={`flex-shrink-0 p-1 rounded ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`} aria-label="Chiudi" data-testid="a2hs-dismiss">
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>

            {showIOSGuide && (
                <div className="fixed inset-0 bg-black/60 flex items-end justify-center p-3 z-[85]" onClick={() => setShowIOSGuide(false)} data-testid="a2hs-ios-guide">
                    <div className={`${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} rounded-2xl shadow-2xl w-full max-w-md p-5 space-y-4`} onClick={e => e.stopPropagation()}>
                        <div className="flex items-center justify-between">
                            <h3 className="font-bold text-base">Aggiungi Spark alla schermata Home</h3>
                            <button onClick={() => setShowIOSGuide(false)} className="p-1 rounded-full hover:bg-black/10" aria-label="Chiudi"><XCircle className="h-6 w-6" /></button>
                        </div>
                        <div className="space-y-3">
                            <div className="flex gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">1</span>
                                <p className="text-sm flex-1">{isIOS ? <>Tocca l'icona <strong>Condividi</strong> <ArrowUpCircle className="inline h-4 w-4 mx-0.5" /> nella barra di Safari.</> : <>Apri il menu del browser <span className="font-mono">⋮</span> in alto a destra.</>}</p>
                            </div>
                            <div className="flex gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">2</span>
                                <p className="text-sm flex-1">Scegli <strong>«Aggiungi a schermata Home»</strong>{isIOS ? '' : ' / «Installa app»'}.</p>
                            </div>
                            <div className="flex gap-3">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">3</span>
                                <p className="text-sm flex-1">Conferma con <strong>«Aggiungi»</strong>. Troverai l'icona di Spark tra le tue app.</p>
                            </div>
                        </div>
                        <button onClick={() => { setShowIOSGuide(false); dismiss(); }} className="w-full py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold" data-testid="a2hs-ios-done">Ho capito</button>
                    </div>
                </div>
            )}
        </>
    );
};


// Cattura globale dell'evento beforeinstallprompt per il pulsante "Installa app" nel profilo
if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); window.__sparkBIP = e; });
    window.addEventListener('appinstalled', () => { window.__sparkBIP = null; });
}

// Pulsante "Installa app" (PWA): install nativa dove supportata, altrimenti guida (iOS/Safari).
const InstallAppButton = () => {
    const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);
    const [deferredPrompt, setDeferredPrompt] = useState(() => (typeof window !== 'undefined' ? window.__sparkBIP : null) || null);
    const [showGuide, setShowGuide] = useState(false);
    const [installed, setInstalled] = useState(isStandalone);

    useEffect(() => {
        const onBIP = (e) => { e.preventDefault(); window.__sparkBIP = e; setDeferredPrompt(e); };
        const onInstalled = () => { setInstalled(true); window.__sparkBIP = null; };
        window.addEventListener('beforeinstallprompt', onBIP);
        window.addEventListener('appinstalled', onInstalled);
        return () => { window.removeEventListener('beforeinstallprompt', onBIP); window.removeEventListener('appinstalled', onInstalled); };
    }, []);

    const install = async () => {
        const bip = deferredPrompt || (typeof window !== 'undefined' ? window.__sparkBIP : null);
        if (!isIOS && bip) {
            bip.prompt();
            try {
                const { outcome } = await bip.userChoice;
                if (outcome === 'accepted') setInstalled(true);
            } catch (e) {}
            window.__sparkBIP = null;
            setDeferredPrompt(null);
        } else {
            setShowGuide(true);
        }
    };

    if (installed) {
        return (
            <div data-testid="install-app-done" className="flex items-center gap-2 text-green-700 text-xs bg-green-50 border border-green-200 rounded-lg p-2.5">
                <CheckCircle className="h-4 w-4 shrink-0" /> App già installata
            </div>
        );
    }

    return (
        <>
            <button
                type="button"
                onClick={install}
                data-testid="install-app-btn"
                className="w-full p-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 rounded-lg text-white text-sm font-bold flex items-center justify-center gap-2 shadow-md transition-all"
            >
                <Smartphone className="h-4 w-4" /> Installa app
            </button>
            <p className="text-xs text-yellow-700 text-center mt-2">Apri Spark come un'app, senza barra del browser.</p>
            {showGuide && (
                <div className="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center p-3 z-[85]" onClick={() => setShowGuide(false)} data-testid="install-app-guide">
                    <div className="bg-white text-gray-800 rounded-2xl shadow-2xl w-full max-w-md p-5 space-y-4" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center justify-between">
                            <h3 className="font-bold text-base">Installa Spark come app</h3>
                            <button onClick={() => setShowGuide(false)} className="p-1 rounded-full hover:bg-black/10" aria-label="Chiudi"><XCircle className="h-6 w-6" /></button>
                        </div>
                        <div className="space-y-3">
                            <div className="flex gap-3"><span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">1</span><p className="text-sm flex-1">{isIOS ? <>Tocca <strong>Condividi</strong> <ArrowUpCircle className="inline h-4 w-4 mx-0.5" /> nella barra di Safari.</> : <>Apri il menu <span className="font-mono">⋮</span> del browser.</>}</p></div>
                            <div className="flex gap-3"><span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">2</span><p className="text-sm flex-1">Scegli <strong>«Aggiungi a schermata Home»</strong>{isIOS ? '' : ' / «Installa app»'}.</p></div>
                            <div className="flex gap-3"><span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">3</span><p className="text-sm flex-1">Conferma con <strong>«Aggiungi»</strong>. Troverai l'icona di Spark tra le tue app.</p></div>
                        </div>
                        <button onClick={() => setShowGuide(false)} className="w-full py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold" data-testid="install-app-guide-done">Ho capito</button>
                    </div>
                </div>
            )}
        </>
    );
};



const ChatInterface = () => {
    const { state, dispatch, actions } = useContext(ChatContext);
    
    // ⌨️ Keyboard Shortcuts
    useKeyboardShortcuts(dispatch, state, actions);

    // Comprimi/espandi conversazione (opzione A)
    const [chatCollapsed, setChatCollapsed] = useState(false);
    const [collapsedAtCount, setCollapsedAtCount] = useState(0);
    const hasNewWhileCollapsed = chatCollapsed && state.messages.length > collapsedAtCount;

    // Dopo il promemoria di inattività, comprimi automaticamente la chat lasciando
    // pronto il badge "nuovo" (così tornando l'utente trova la schermata pulita).
    useEffect(() => {
        if (state.showInactivityPrompt) {
            setCollapsedAtCount(Math.max(0, state.messages.length - 1));
            setChatCollapsed(true);
        }
    }, [state.showInactivityPrompt]);
    
    return (
        <div className="flex flex-col h-full relative">
            {/* Header - in flusso (flex) su tutti i device: solo l'area messaggi scorre */}
            <div className={`flex-shrink-0 relative z-30 ${state.darkMode ? 'bg-gray-900' : 'bg-white'}`} style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}>
                <Header />
                <ServiceStatusBanner />
                <UserInfoBanner />
                {state.showSearch && <AdvancedSearchBar />}
            </div>
            
            {/* Area messaggi scrollabile */}
            <PushActiveBadge />
            <JiraRegistrationBanner />
            {state.messages.length > 0 && !chatCollapsed && (
                <div className={`flex-shrink-0 flex justify-end px-3 py-1 border-b ${state.darkMode ? 'border-gray-800' : 'border-gray-100'}`}>
                    <button
                        type="button"
                        data-testid="collapse-chat-btn"
                        onClick={() => { setChatCollapsed(true); setCollapsedAtCount(state.messages.length); }}
                        className={`flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-md transition-colors ${state.darkMode ? 'text-gray-300 hover:bg-gray-800' : 'text-gray-500 hover:bg-gray-100'}`}
                        title="Comprimi conversazione"
                    >
                        <ChevronUp className="h-4 w-4" /> Comprimi
                    </button>
                </div>
            )}
            {chatCollapsed ? (
                <div className="flex-1 min-h-0 overflow-y-auto flex items-start justify-center p-4">
                    <button
                        type="button"
                        data-testid="expand-chat-btn"
                        onClick={() => setChatCollapsed(false)}
                        className={`w-full max-w-md flex items-center justify-between gap-2 px-4 py-3 rounded-xl border transition-colors ${state.darkMode ? 'bg-gray-800 border-gray-700 text-gray-200 hover:bg-gray-700' : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100'}`}
                    >
                        <span className="flex items-center gap-2 text-sm font-medium">
                            <MessageSquare className="h-4 w-4" /> Conversazione — {state.messages.length} {state.messages.length === 1 ? 'messaggio' : 'messaggi'}
                            {hasNewWhileCollapsed && (
                                <span data-testid="chat-new-badge" className="ml-1 inline-flex items-center gap-1 text-xs font-semibold text-red-600">
                                    <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse"></span> nuovo
                                </span>
                            )}
                        </span>
                        <ChevronDown className="h-4 w-4" />
                    </button>
                </div>
            ) : (
                <div className="flex-1 overflow-y-auto min-h-0 overscroll-contain">
                    <MessageList />
                </div>
            )}
            
            {/* Input fisso in basso */}
            <div className="flex-shrink-0">
                <ChatInput />
            </div>
            
            {/* Shortcuts Modal */}
            {state.showShortcutsModal && (
                <ShortcutsModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showShortcutsModal: false } })} darkMode={state.darkMode} />
            )}
            
            {/* Hint shortcuts - mostra solo la prima volta, solo su desktop (le scorciatoie tastiera non servono su mobile) */}
            {!state.isMobile && (
                <ShortcutsHint darkMode={state.darkMode} onShowShortcuts={() => dispatch({ type: 'SET_STATE', payload: { showShortcutsModal: true } })} />
            )}

            {/* Banner "Aggiungi alla Home" - solo su mobile, quando non c'è il modal di conferma handoff */}
            {state.isMobile && !state.showMobileHandoffModal && (
                <AddToHomeBanner darkMode={state.darkMode} />
            )}
        </div>
    );
};

// ============================================================================
// MODALS (BatLaunchWelcomeModal, WelcomeModal, EndChatModal, UserDashboard, SecurityModal)
// ============================================================================
const BatLaunchWelcomeModal = ({ userName, userComputer, userCompany, onClose }) => {
    const { actions, dispatch, state } = useContext(ChatContext);
    const [deviceInfo, setDeviceInfo] = useState(null);
    const [loadingDevice, setLoadingDevice] = useState(true);
    const [notificationEnabled, setNotificationEnabled] = useState(false);
    const [notificationAttempted, setNotificationAttempted] = useState(false);
    
    // Rileva browser per mostrare icona corretta
    const detectBrowser = () => {
        try {
            const ua = navigator.userAgent || '';
            if (ua.includes('Brave') || (navigator.brave && navigator.brave.isBrave)) return 'brave';
            if (ua.includes('Edg')) return 'edge';
            if (ua.includes('OPR') || ua.includes('Opera')) return 'opera';
            if (ua.includes('Firefox')) return 'firefox';
            if (ua.includes('Chrome')) return 'chrome';
            if (ua.includes('Safari')) return 'safari';
            return 'unknown';
        } catch (e) {
            return 'unknown';
        }
    };
    const [detectedBrowser] = useState(detectBrowser());
    
    // Stati locali per selezione manuale
    const [selectedHardwareType, setSelectedHardwareType] = useState(null);
    const [selectedConnectionType, setSelectedConnectionType] = useState(null);
    const [hardwareDetected, setHardwareDetected] = useState(false);
    const [connectionDetected, setConnectionDetected] = useState(false);
    
    // Email aziendale - OBBLIGATORIA - Carica da state o localStorage
    const getSavedEmail = () => {
        if (state.userEmail) return state.userEmail;
        try {
            return localStorage.getItem('spark-user-email-v1') || 
                   localStorage.getItem('spark-user-email') || '';
        } catch (e) { return ''; }
    };
    const [userEmail, setUserEmail] = useState(getSavedEmail());
    const [emailError, setEmailError] = useState('');

    // Telefono (opzionale) - per contatto tecnico
    const [userPhone, setUserPhone] = useState(() => {
        if (state.userPhone) return state.userPhone;
        try { return localStorage.getItem('spark-user-phone-v1') || ''; } catch (e) { return ''; }
    });
    
    // Validazione email
    const validateEmail = (email) => {
        if (!email || email.trim() === '') {
            return 'L\'email aziendale è obbligatoria';
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            return 'Inserisci un\'email valida';
        }
        return '';
    };
    
    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setUserEmail(newEmail);
        // Valida solo se l'utente ha già provato a inserire qualcosa
        if (emailError || newEmail.length > 0) {
            setEmailError(validateEmail(newEmail));
        }
    };
    
    const handleEmailBlur = () => {
        setEmailError(validateEmail(userEmail));
    };
    
    const isEmailValid = userEmail.trim() !== '' && validateEmail(userEmail) === '';
    
    const displayName = userName ? userName.split('.')[0] || userName.split(' ')[0] : 'User';
    
    // Lista di nomi generici che richiedono il nome reale
    const GENERIC_NAMES = ['user', 'utente', 'admin', 'administrator', 'guest', 'ospite', 'test', 'default', 'pc', 'computer', 'workstation', 'desktop', 'laptop', 'notebook'];
    const isGenericUser = GENERIC_NAMES.includes(displayName.toLowerCase()) || 
                          GENERIC_NAMES.includes(userName?.toLowerCase() || '');
    
    // Stato per il nome reale (se utente generico)
    const [realName, setRealName] = useState('');
    const [realNameError, setRealNameError] = useState('');
    
    const validateRealName = (name) => {
        if (!name || name.trim() === '') {
            return 'Il nome è obbligatorio';
        }
        if (name.trim().length < 2) {
            return 'Inserisci almeno 2 caratteri';
        }
        // Verifica che non sia un nome generico
        if (GENERIC_NAMES.includes(name.trim().toLowerCase())) {
            return 'Inserisci il tuo nome reale';
        }
        return '';
    };
    
    const handleRealNameChange = (e) => {
        const name = e.target.value;
        setRealName(name);
        if (realNameError || name.length > 0) {
            setRealNameError(validateRealName(name));
        }
    };
    
    const isRealNameValid = !isGenericUser || (realName.trim().length >= 2 && validateRealName(realName) === '');

    useEffect(() => {
        if (userComputer) {
            setLoadingDevice(true);
            MOCK_API.getDeviceInfo(userComputer, userName)
                .then(info => {
                    setDeviceInfo(info);
                    // Salva siteName, formFactor e deviceModel nello state globale
                    const updatePayload = {};
                    
                    if (info?.siteName) {
                        updatePayload.userSiteName = info.siteName;
                    }
                    
                    // Salva il tipo hardware (fisso/notebook) dedotto automaticamente SOLO se determinato
                    if (info?.formFactor) {
                        updatePayload.userPCHardwareType = info.formFactor;
                        setSelectedHardwareType(info.formFactor);
                        setHardwareDetected(true);
                        console.log('[PC] Tipo hardware dedotto:', info.formFactor);
                    }
                    
                    // Salva il modello del dispositivo
                    if (info?.deviceModel) {
                        updatePayload.userDeviceModel = info.deviceModel;
                        console.log('[DEVICE] Modello dispositivo:', info.deviceModel);
                    }
                    
                    // Salva il tipo di connessione e la fonte
                    if (info?.connectionType) {
                        updatePayload.userConnectionType = info.connectionType;
                        updatePayload.userConnectionSource = info.connectionSource || 'dedotto';
                        setSelectedConnectionType(info.connectionType);
                        setConnectionDetected(true);
                        console.log('[NET] Tipo connessione:', info.connectionType, '- fonte:', info.connectionSource);
                    }

                    // Dominio / Active Directory da Datto RMM
                    if (info?.isDomainJoined !== null && info?.isDomainJoined !== undefined) {
                        updatePayload.isDomainJoined = info.isDomainJoined;
                        updatePayload.userDomain = info.domain || '';
                        console.log('[RMM] 🏢 In dominio:', info.isDomainJoined, '| Dominio:', info.domain || 'n/d');
                    }
                    
                    if (Object.keys(updatePayload).length > 0) {
                        dispatch({ type: 'SET_STATE', payload: updatePayload });
                    }
                    
                    // Salva dettagli utente in localStorage per visite future
                    if (userName && info?.siteName) {
                        try {
                            const savedDetails = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
                            const detailsMap = savedDetails ? JSON.parse(savedDetails) : {};
                            const userKey = userName.toLowerCase().replace(/[.\s]/g, '_');
                            const saveData = {
                                company: info.siteName,
                                computer: userComputer,
                                deviceModel: info.deviceModel || '',
                                lastSeen: new Date().toISOString()
                            };
                            if (info.formFactor) saveData.hardwareType = info.formFactor;
                            if (info.connectionType) {
                                saveData.connectionType = info.connectionType;
                                saveData.connectionSource = info.connectionSource || 'dedotto';
                            }
                            detailsMap[userKey] = saveData;
                            localStorage.setItem(USER_DETAILS_STORAGE_KEY, JSON.stringify(detailsMap));
                        } catch (e) {
                            console.error('Errore salvataggio dettagli utente:', e);
                        }
                    }
                })
                .catch(err => console.error('Device info error:', err))
                .finally(() => setLoadingDevice(false));
        }
        setNotificationEnabled(Notification.permission === 'granted');
    }, [userComputer, dispatch, userName]);

    const handleEnableNotifications = async () => {
        // Verifica che l'email sia valida PRIMA di attivare le notifiche
        const emailToUse = userEmail.trim().toLowerCase() || getSavedEmail();
        if (!emailToUse || !emailToUse.includes('@')) {
            setEmailError('Inserisci prima la tua email aziendale');
            return;
        }
        
        // Salva email nello state prima di sottoscrivere
        dispatch({ type: 'SET_STATE', payload: { userEmail: emailToUse } });
        localStorage.setItem('spark-user-email-v1', emailToUse);
        
        const result = await actions.handleEnableNotifications();
        if (result.success) {
            setNotificationEnabled(true);
        }
    };
    
    const handleContinue = () => {
        // Valida nome reale se utente generico
        if (isGenericUser) {
            const nameError = validateRealName(realName);
            if (nameError) {
                setRealNameError(nameError);
                return;
            }
        }
        
        // Valida email prima di procedere
        const emailValidationError = validateEmail(userEmail);
        if (emailValidationError) {
            setEmailError(emailValidationError);
            return;
        }
        
        const emailTrimmed = userEmail.trim().toLowerCase();
        const finalUserName = isGenericUser ? realName.trim() : userName;
        
        // Salva le selezioni manuali nello state
        const updatePayload = {
            userEmail: emailTrimmed,
            userPhone: (userPhone || '').trim()
        };
        
        // Se abbiamo un nome reale, aggiornalo nello state
        if (isGenericUser && realName.trim()) {
            updatePayload.userName = realName.trim();
        }
        
        if (selectedHardwareType) {
            updatePayload.userPCHardwareType = selectedHardwareType;
        }
        if (selectedConnectionType) {
            updatePayload.userConnectionType = selectedConnectionType;
        }
        
        dispatch({ type: 'SET_STATE', payload: updatePayload });
        
        // Salva in localStorage per persistenza - ENTRAMBE le chiavi per compatibilità
        try {
            localStorage.setItem('spark-user-email-v1', emailTrimmed);
            localStorage.setItem('spark-user-email', emailTrimmed);
            try { localStorage.setItem('spark-user-phone-v1', (userPhone || '').trim()); } catch (e) {}
            
            // Salva il nome reale per le visite future
            if (isGenericUser && realName.trim()) {
                localStorage.setItem('spark-user-realname', realName.trim());
            }
            
            // Salva anche dettagli utente completi per visite future
            // USA IL NOME PC COME CHIAVE per ritrovare i dati correttamente
            const savedDetails = localStorage.getItem(USER_DETAILS_STORAGE_KEY);
            const detailsMap = savedDetails ? JSON.parse(savedDetails) : {};
            const pcKey = (editablePC || userComputer || 'unknown').toLowerCase().replace(/[.\s-]/g, '_');
            
            detailsMap[pcKey] = {
                ...detailsMap[pcKey],
                email: emailTrimmed,
                phone: (userPhone || '').trim(),
                realName: isGenericUser ? realName.trim() : (editableName || userName),
                computer: editablePC || userComputer,
                company: editableCompany || deviceInfo?.siteName || userCompany || '',
                lastSeen: new Date().toISOString(),
                hardwareType: selectedHardwareType,
                connectionType: selectedConnectionType
            };
            
            localStorage.setItem(USER_DETAILS_STORAGE_KEY, JSON.stringify(detailsMap));
            console.log('[SAVE] Dettagli utente salvati per PC:', pcKey, detailsMap[pcKey]);
        } catch (e) {
            console.error('Errore salvataggio dati:', e);
        }
        
        // Passa i dati confermati a onClose per evitare problemi di timing con React state
        onClose({
            hardwareType: selectedHardwareType,
            connectionType: selectedConnectionType,
            email: emailTrimmed,
            realName: isGenericUser ? realName.trim() : null
        });
    };
    
    // Verifica se mancano info essenziali
    const needsManualInput = !loadingDevice && (!hardwareDetected || !connectionDetected);

    // Verifica se è un nuovo utente (prima visita, nessuna email salvata)
    const isFirstTimeUser = !getSavedEmail();
    
    // NUOVI STATI per campi editabili
    const [editableName, setEditableName] = useState(userName || '');
    const [editableCompany, setEditableCompany] = useState('');
    const [editablePC, setEditablePC] = useState(userComputer || '');
    
    // STATO per freccia notifiche
    const [showNotificationArrow, setShowNotificationArrow] = useState(false);
    
    // Aggiorna i campi editabili quando arrivano le info dal device
    useEffect(() => {
        if (deviceInfo) {
            if (deviceInfo.siteName && !editableCompany) {
                setEditableCompany(deviceInfo.siteName);
            }
            if (deviceInfo.hostname && !editablePC) {
                setEditablePC(deviceInfo.hostname);
            }
        }
    }, [deviceInfo, editableCompany, editablePC]);
    
    // Aggiorna anche dall'utente passato
    useEffect(() => {
        if (userName && !editableName) setEditableName(userName);
        if (userComputer && !editablePC) setEditablePC(userComputer);
        if (userCompany && !editableCompany) setEditableCompany(userCompany);
    }, [userName, userComputer, userCompany, editableName, editablePC, editableCompany]);
    
    // Stato per tipo di freccia (popup o barra)
    // arrowType rimosso - ora mostriamo sempre il box informativo completo
    
    // Handler per notifiche con rilevamento popup
    const handleEnableNotificationsWithArrow = async () => {
        // L'utente ha tentato di attivare: sblocca comunque il proseguimento
        setNotificationAttempted(true);
        // Controlla lo stato attuale delle notifiche
        const currentPermission = Notification.permission;
        
        if (currentPermission === 'granted') {
            // Già concesso
            setNotificationEnabled(true);
            setShowNotificationArrow(false);
            return;
        }
        
        // SEMPRE mostra il box informativo completo con tutte le istruzioni
        setShowNotificationArrow(true);
        console.log('[NOTIF] Mostro box informativo completo');
        
        // Se permission === 'default', avvia anche la richiesta di permesso
        if (currentPermission === 'default') {
            try {
                const result = await NotificationService.requestPermission();
                console.log('[NOTIF] Risultato permesso:', result);
                
                if (result === 'granted') {
                    setNotificationEnabled(true);
                    setShowNotificationArrow(false);
                }
                // Se denied o default, il box rimane visibile
            } catch (e) {
                console.error('Errore richiesta notifiche:', e);
                // Box rimane visibile
            }
        }
    };
    
    // Controlla periodicamente se le notifiche sono state abilitate
    // Chiude automaticamente il box quando permission === 'granted'
    useEffect(() => {
        if (showNotificationArrow) {
            const checkPermission = setInterval(() => {
                if (Notification.permission === 'granted') {
                    setShowNotificationArrow(false);
                    setNotificationEnabled(true);
                    clearInterval(checkPermission);
                    console.log('[NOTIF] ✅ Notifiche abilitate - chiudo box');
                }
            }, 1000); // Controlla ogni secondo
            
            return () => clearInterval(checkPermission);
        }
    }, [showNotificationArrow]);
    
    let welcomeText = isFirstTimeUser 
        ? (isGenericUser ? "Benvenuto/a in Spark! 🚀" : getGenderedGreeting(userName, 'welcomeFirst'))
        : (isGenericUser ? "Che bello rivederti!" : getGenderedGreeting(userName, 'welcomeBack'));
    
    const hostname = editablePC || deviceInfo?.hostname || userComputer;
    const lastUser = editableName || deviceInfo?.lastLoggedInUser || userName;
    const siteName = editableCompany || deviceInfo?.siteName || userCompany;
    const antivirus = deviceInfo?.antivirus?.antivirusProduct || 'Windows Defender';
    const isOnline = deviceInfo?.online !== false;
    
    // Determina il nome finale da usare
    const finalDisplayName = isGenericUser ? (realName || 'utente') : (editableName || displayName || 'utente');

    // Stile input editabile
    const editableInputClass = "w-full px-3 py-2 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-400 bg-white text-sm";
    
    // Verifica TUTTI i campi obbligatori - include validazione nome reale per utenti generici
    const nameFieldValid = isGenericUser ? isRealNameValid : editableName.trim() !== '';
    const allFieldsValid = nameFieldValid && editableCompany.trim() && editablePC.trim() && isEmailValid && selectedHardwareType && selectedConnectionType;

    // Le notifiche sono un passaggio obbligato: sblocca solo se attivate o almeno tentate
    // (se il browser non le supporta, non blocca).
    const notifBlocking = NotificationService.isSupported() && !notificationEnabled && !notificationAttempted;
    const canConfirm = allFieldsValid && !notifBlocking;
    
    // Messaggio bottone dinamico
    const getButtonMessage = () => {
        if (isGenericUser && !isRealNameValid) return 'Inserisci il tuo nome reale';
        if (!isGenericUser && !editableName.trim()) return 'Inserisci il tuo nome';
        if (!editableCompany.trim()) return 'Inserisci il nome dell\'azienda';
        if (!editablePC.trim()) return 'Inserisci il nome del PC';
        if (!isEmailValid) return 'Inserisci la tua email aziendale';
        if (!selectedHardwareType) return 'Seleziona il tipo di dispositivo';
        if (!selectedConnectionType) return 'Seleziona il tipo di connessione';
        if (notifBlocking) return 'Attiva le notifiche per continuare';
        return 'Confermo, tutto corretto!';
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50 animate-fade-in">
            {/* BOX INFORMATIVO NOTIFICHE - SEMPRE VISIBILE quando showNotificationArrow è true */}
            {showNotificationArrow && (
                <div 
                    data-testid="notification-helper-box"
                    className="fixed z-[9999] animate-fade-in"
                    style={{ top: '100px', left: '100px' }}
                >
                    <div className="flex items-start gap-3">
                        {/* Freccia animata che punta verso la barra indirizzi */}
                        <div 
                            style={{ 
                                fontSize: '6rem',
                                filter: 'drop-shadow(3px 3px 6px rgba(0,0,0,0.4))',
                                animation: 'bounce 1s ease-in-out infinite'
                            }}
                        >
                            ☝️
                        </div>
                        
                        {/* Box con istruzioni complete */}
                        <div className="bg-white text-gray-800 px-5 py-4 rounded-xl shadow-2xl max-w-md border-2 border-amber-400">
                            <p className="font-bold text-lg mb-3 text-amber-600 flex items-center gap-2">
                                <Bell className="h-5 w-5" />
                                Attiva le notifiche
                            </p>
                            
                            {/* Icone di riferimento - adattate al browser rilevato */}
                            <div className="bg-gray-100 rounded-lg px-3 py-2 mb-3 text-sm">
                                <p className="text-gray-600 mb-2">
                                    Cerca questa icona nella barra degli indirizzi 
                                    <span className="text-xs text-gray-400 ml-1">
                                        ({detectedBrowser === 'chrome' && 'Chrome'}
                                        {detectedBrowser === 'edge' && 'Edge'}
                                        {detectedBrowser === 'firefox' && 'Firefox'}
                                        {detectedBrowser === 'safari' && 'Safari'}
                                        {detectedBrowser === 'brave' && 'Brave'}
                                        {detectedBrowser === 'opera' && 'Opera'}
                                        {detectedBrowser === 'unknown' && 'Browser'})
                                    </span>:
                                </p>
                                <div className="flex flex-wrap items-center gap-2">
                                    {/* Chrome: lucchetto, info, cursori */}
                                    {detectedBrowser === 'chrome' && (
                                        <>
                                            <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border-2 border-blue-400 shadow-sm">
                                                <SlidersHorizontal className="h-5 w-5 text-gray-700" />
                                                <span className="text-xs text-gray-600">Impostazioni sito</span>
                                            </div>
                                            <span className="text-gray-400">oppure</span>
                                            <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border border-gray-300">
                                                <Info className="h-5 w-5 text-gray-600" />
                                            </div>
                                        </>
                                    )}
                                    {/* Edge: lucchetto */}
                                    {detectedBrowser === 'edge' && (
                                        <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border-2 border-blue-400 shadow-sm">
                                            <Lock className="h-5 w-5 text-gray-700" />
                                            <span className="text-xs text-gray-600">Autorizzazioni sito</span>
                                        </div>
                                    )}
                                    {/* Firefox: scudo o lucchetto */}
                                    {detectedBrowser === 'firefox' && (
                                        <>
                                            <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border-2 border-blue-400 shadow-sm">
                                                <Shield className="h-5 w-5 text-gray-700" />
                                                <span className="text-xs text-gray-600">Protezioni</span>
                                            </div>
                                            <span className="text-gray-400">oppure</span>
                                            <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border border-gray-300">
                                                <Lock className="h-5 w-5 text-gray-600" />
                                            </div>
                                        </>
                                    )}
                                    {/* Safari: lucchetto */}
                                    {detectedBrowser === 'safari' && (
                                        <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border-2 border-blue-400 shadow-sm">
                                            <Lock className="h-5 w-5 text-gray-700" />
                                            <span className="text-xs text-gray-600">Impostazioni sito</span>
                                        </div>
                                    )}
                                    {/* Brave: scudo leone */}
                                    {detectedBrowser === 'brave' && (
                                        <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border-2 border-blue-400 shadow-sm">
                                            <Shield className="h-5 w-5 text-orange-500" />
                                            <span className="text-xs text-gray-600">Brave Shields</span>
                                        </div>
                                    )}
                                    {/* Opera: lucchetto */}
                                    {detectedBrowser === 'opera' && (
                                        <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded border-2 border-blue-400 shadow-sm">
                                            <Lock className="h-5 w-5 text-gray-700" />
                                            <span className="text-xs text-gray-600">Impostazioni sito</span>
                                        </div>
                                    )}
                                    {/* Browser sconosciuto: mostra tutte */}
                                    {detectedBrowser === 'unknown' && (
                                        <>
                                            <div className="flex items-center gap-1.5 bg-white px-2.5 py-1.5 rounded border border-gray-300">
                                                <Lock className="h-4 w-4 text-gray-600" />
                                            </div>
                                            <div className="flex items-center gap-1.5 bg-white px-2.5 py-1.5 rounded border border-gray-300">
                                                <Info className="h-4 w-4 text-gray-600" />
                                            </div>
                                            <div className="flex items-center gap-1.5 bg-white px-2.5 py-1.5 rounded border border-gray-300">
                                                <Shield className="h-4 w-4 text-gray-600" />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            
                            <p className="text-sm mb-3">Per ricevere aggiornamenti sui tuoi ticket, <strong>segui uno di questi passaggi:</strong></p>
                            
                            <div className="space-y-3">
                                {/* Opzione A - Popup visibile */}
                                <div className="bg-green-50 rounded-lg p-3 border border-green-200">
                                    <p className="font-semibold text-green-700 text-sm mb-2 flex items-center gap-1">
                                        <CheckCircle className="h-4 w-4" /> Se vedi il popup "Mostrare le notifiche":
                                    </p>
                                    <p className="text-sm text-gray-700 ml-5">Clicca su <strong>"Consenti"</strong></p>
                                </div>
                                
                                {/* Opzione B - Reset dalla barra - istruzioni specifiche per browser */}
                                <div className="bg-amber-50 rounded-lg p-3 border border-amber-200">
                                    <p className="font-semibold text-amber-700 text-sm mb-2 flex items-center gap-1">
                                        {detectedBrowser === 'chrome' && <SlidersHorizontal className="h-4 w-4" />}
                                        {detectedBrowser === 'edge' && <Lock className="h-4 w-4" />}
                                        {detectedBrowser === 'firefox' && <Shield className="h-4 w-4" />}
                                        {detectedBrowser === 'safari' && <Lock className="h-4 w-4" />}
                                        {detectedBrowser === 'brave' && <Shield className="h-4 w-4" />}
                                        {detectedBrowser === 'opera' && <Lock className="h-4 w-4" />}
                                        {detectedBrowser === 'unknown' && <Lock className="h-4 w-4" />}
                                        {' '}Sblocca dalle impostazioni del sito:
                                    </p>
                                    <ol className="text-sm space-y-1.5 text-gray-700 ml-5">
                                        {/* Istruzioni Chrome */}
                                        {detectedBrowser === 'chrome' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Clicca sull'icona <SlidersHorizontal className="h-3 w-3 inline mx-0.5" /> a sinistra dell'URL</li>
                                                <li><span className="font-medium text-amber-600">2.</span> Trova <strong>"Notifiche"</strong> → seleziona <strong>"Consenti"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Ricarica la pagina <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">F5</kbd></li>
                                            </>
                                        )}
                                        {/* Istruzioni Edge */}
                                        {detectedBrowser === 'edge' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Clicca sul <Lock className="h-3 w-3 inline mx-0.5" /> lucchetto a sinistra dell'URL</li>
                                                <li><span className="font-medium text-amber-600">2.</span> Clicca <strong>"Autorizzazioni per il sito"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Trova <strong>"Notifiche"</strong> → seleziona <strong>"Consenti"</strong></li>
                                                <li><span className="font-medium text-amber-600">4.</span> Ricarica la pagina <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">F5</kbd></li>
                                            </>
                                        )}
                                        {/* Istruzioni Firefox */}
                                        {detectedBrowser === 'firefox' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Clicca sul <Shield className="h-3 w-3 inline mx-0.5" /> scudo o <Lock className="h-3 w-3 inline mx-0.5" /> lucchetto</li>
                                                <li><span className="font-medium text-amber-600">2.</span> Clicca <strong>"Autorizzazioni"</strong> → <strong>"Notifiche"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Rimuovi il blocco e ricarica <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">F5</kbd></li>
                                            </>
                                        )}
                                        {/* Istruzioni Safari */}
                                        {detectedBrowser === 'safari' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Vai su <strong>Safari</strong> → <strong>Impostazioni per questo sito</strong></li>
                                                <li><span className="font-medium text-amber-600">2.</span> Trova <strong>"Notifiche"</strong> → seleziona <strong>"Consenti"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Ricarica la pagina <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">⌘R</kbd></li>
                                            </>
                                        )}
                                        {/* Istruzioni Brave */}
                                        {detectedBrowser === 'brave' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Clicca sull'icona <Shield className="h-3 w-3 inline mx-0.5 text-orange-500" /> Brave Shields</li>
                                                <li><span className="font-medium text-amber-600">2.</span> Clicca <strong>"Impostazioni avanzate"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Trova <strong>"Notifiche"</strong> → seleziona <strong>"Consenti"</strong></li>
                                                <li><span className="font-medium text-amber-600">4.</span> Ricarica la pagina <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">F5</kbd></li>
                                            </>
                                        )}
                                        {/* Istruzioni Opera */}
                                        {detectedBrowser === 'opera' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Clicca sul <Lock className="h-3 w-3 inline mx-0.5" /> lucchetto a sinistra dell'URL</li>
                                                <li><span className="font-medium text-amber-600">2.</span> Clicca <strong>"Impostazioni sito"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Trova <strong>"Notifiche"</strong> → seleziona <strong>"Consenti"</strong></li>
                                                <li><span className="font-medium text-amber-600">4.</span> Ricarica la pagina <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">F5</kbd></li>
                                            </>
                                        )}
                                        {/* Istruzioni generiche */}
                                        {detectedBrowser === 'unknown' && (
                                            <>
                                                <li><span className="font-medium text-amber-600">1.</span> Clicca sull'icona a sinistra dell'URL (<Lock className="h-3 w-3 inline mx-0.5" />, <Info className="h-3 w-3 inline mx-0.5" /> o <Shield className="h-3 w-3 inline mx-0.5" />)</li>
                                                <li><span className="font-medium text-amber-600">2.</span> Cerca <strong>"Notifiche"</strong> e clicca <strong>"Consenti"</strong></li>
                                                <li><span className="font-medium text-amber-600">3.</span> Ricarica la pagina <kbd className="bg-gray-200 px-1.5 py-0.5 rounded text-xs">F5</kbd></li>
                                            </>
                                        )}
                                    </ol>
                                </div>
                            </div>
                            
                            <button 
                                data-testid="notification-helper-close-btn"
                                onClick={() => setShowNotificationArrow(false)}
                                className="mt-4 w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2.5 px-4 rounded-lg text-sm transition-colors flex items-center justify-center gap-2"
                            >
                                <X className="h-4 w-4" />
                                Ho capito, chiudi
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
            <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-4xl transform transition-transform animate-scale-in">
                
                {/* HEADER */}
                <div className="text-center mb-6">
                    <div className="flex items-center justify-center gap-4 mb-3">
                        <SparkAvatar size="md" className="h-16 w-16" />
                        <div className="text-left">
                            <h2 className="text-xl font-bold text-gray-800">{welcomeText}</h2>
                            <p className="text-sm text-gray-600">Verifica e conferma le informazioni rilevate</p>
                        </div>
                    </div>
                </div>
                
                {loadingDevice ? (
                    <div className="flex items-center justify-center py-12">
                        <Loader2 className="animate-spin h-8 w-8 text-blue-600 mr-3" />
                        <span className="text-gray-600 text-lg">Rilevamento informazioni in corso...</span>
                    </div>
                ) : (
                    <>
                        {/* GRIGLIA INFORMAZIONI EDITABILI */}
                        <div className="bg-gray-50 rounded-xl p-5 mb-5 border border-gray-200">
                            <div className="flex items-center mb-4 pb-3 border-b border-gray-200">
                                <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
                                <span className="font-semibold text-gray-700">Informazioni Rilevate</span>
                                <span className="ml-auto text-xs text-gray-500 bg-gray-200 px-2 py-1 rounded">Modifica se necessario</span>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* NOME UTENTE */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-1">
                                        <User className="h-4 w-4 mr-2 text-gray-500" />
                                        {isGenericUser ? (
                                            <>Il tuo Nome <span className="text-red-500 ml-1">*</span></>
                                        ) : (
                                            <>Nome Utente <span className="text-red-500 ml-1">*</span></>
                                        )}
                                    </label>
                                    {isGenericUser ? (
                                        <>
                                            <input
                                                type="text"
                                                value={realName}
                                                onChange={handleRealNameChange}
                                                placeholder="Inserisci il tuo nome reale"
                                                className={`${editableInputClass} ${!realName.trim() || realNameError ? 'border-orange-300 bg-orange-50' : 'border-green-300 bg-green-50'}`}
                                            />
                                            {realNameError && (
                                                <p className="text-xs text-red-500 mt-1">{realNameError}</p>
                                            )}
                                            <p className="text-xs text-amber-600 mt-1">
                                                Il nome "{userName}" è generico. Inserisci il tuo nome reale.
                                            </p>
                                        </>
                                    ) : (
                                        <input
                                            type="text"
                                            value={editableName}
                                            onChange={(e) => setEditableName(e.target.value)}
                                            placeholder="Nome Cognome"
                                            className={`${editableInputClass} ${!editableName.trim() ? 'border-orange-300 bg-orange-50' : 'border-green-300 bg-green-50'}`}
                                        />
                                    )}
                                </div>
                                
                                {/* AZIENDA */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-1">
                                        <Building2 className="h-4 w-4 mr-2 text-gray-500" />
                                        Azienda <span className="text-red-500 ml-1">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={editableCompany}
                                        onChange={(e) => setEditableCompany(e.target.value)}
                                        placeholder="Nome Azienda"
                                        className={`${editableInputClass} ${!editableCompany.trim() ? 'border-orange-300 bg-orange-50' : 'border-green-300 bg-green-50'}`}
                                    />
                                </div>
                                
                                {/* NOME PC */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-1">
                                        <Server className="h-4 w-4 mr-2 text-gray-500" />
                                        Nome PC <span className="text-red-500 ml-1">*</span>
                                        {isOnline && <span className="ml-2 text-xs text-green-600">● Online</span>}
                                    </label>
                                    <input
                                        type="text"
                                        value={editablePC}
                                        onChange={(e) => setEditablePC(e.target.value)}
                                        placeholder="PC-001"
                                        className={`${editableInputClass} ${!editablePC.trim() ? 'border-orange-300 bg-orange-50' : 'border-green-300 bg-green-50'}`}
                                    />
                                </div>
                                
                                {/* EMAIL */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-1">
                                        <Mail className="h-4 w-4 mr-2 text-gray-500" />
                                        Email Aziendale <span className="text-red-500 ml-1">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        data-testid="bat-launch-email-input"
                                        value={userEmail}
                                        onChange={handleEmailChange}
                                        onBlur={handleEmailBlur}
                                        placeholder="nome@azienda.it"
                                        className={`${editableInputClass} ${
                                            emailError 
                                                ? 'border-red-400 bg-red-50' 
                                                : isEmailValid 
                                                    ? 'border-green-300 bg-green-50' 
                                                    : 'border-orange-300 bg-orange-50'
                                        }`}
                                    />
                                    {emailError && (
                                        <p className="mt-1 text-xs text-red-600 flex items-center">
                                            <AlertTriangle className="h-3 w-3 mr-1" />
                                            {emailError}
                                        </p>
                                    )}
                                    <JiraEmailStatus email={userEmail} userName={editableName || realName} company={editableCompany} />
                                </div>

                                {/* TELEFONO (opzionale) */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-1">
                                        <Phone className="h-4 w-4 mr-2 text-gray-500" />
                                        Telefono <span className="text-gray-400 font-normal ml-1">(opzionale, per contatto)</span>
                                    </label>
                                    <input
                                        type="tel"
                                        data-testid="bat-launch-phone-input"
                                        value={userPhone}
                                        onChange={(e) => setUserPhone(e.target.value)}
                                        placeholder="es. 333 1234567 oppure 0123 456789 int. 42"
                                        className={`${editableInputClass} border-gray-200`}
                                    />
                                    <p className="text-xs text-gray-400 mt-1">Cellulare o numero azienda con eventuale interno. Aiuta il tecnico a ricontattarti.</p>
                                </div>
                            </div>
                            
                            {/* TIPO DISPOSITIVO E CONNESSIONE */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 pt-4 border-t border-gray-200">
                                {/* TIPO DISPOSITIVO */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-2">
                                        <Monitor className="h-4 w-4 mr-2 text-gray-500" />
                                        Tipo Dispositivo <span className="text-red-500 ml-1">*</span>
                                        {selectedHardwareType && <span className="ml-2 text-xs text-green-600">✓ Selezionato</span>}
                                    </label>
                                    <div className="flex gap-2">
                                        <button
                                            type="button"
                                            onClick={() => { setSelectedHardwareType('notebook'); setHardwareDetected(true); }}
                                            className={`flex-1 p-3 border-2 rounded-lg text-sm flex items-center justify-center gap-2 transition-all ${
                                                selectedHardwareType === 'notebook' 
                                                    ? 'border-green-500 bg-green-50 text-green-700 font-semibold' 
                                                    : !selectedHardwareType
                                                        ? 'border-orange-300 bg-orange-50 text-gray-600 hover:border-orange-400'
                                                        : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <Laptop className="h-5 w-5" /> <span translate="no">Notebook</span>
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => { setSelectedHardwareType('fisso'); setHardwareDetected(true); }}
                                            className={`flex-1 p-3 border-2 rounded-lg text-sm flex items-center justify-center gap-2 transition-all ${
                                                selectedHardwareType === 'fisso' 
                                                    ? 'border-green-500 bg-green-50 text-green-700 font-semibold' 
                                                    : !selectedHardwareType
                                                        ? 'border-orange-300 bg-orange-50 text-gray-600 hover:border-orange-400'
                                                        : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <Monitor className="h-5 w-5" /> <span translate="no">PC Fisso</span>
                                        </button>
                                    </div>
                                </div>
                                
                                {/* TIPO CONNESSIONE */}
                                <div>
                                    <label className="flex items-center text-sm font-medium text-gray-600 mb-2">
                                        <Wifi className="h-4 w-4 mr-2 text-gray-500" />
                                        Connessione Rete <span className="text-red-500 ml-1">*</span>
                                        {selectedConnectionType && connectionDetected && (
                                            <span className={`ml-2 text-xs px-2 py-0.5 rounded-full font-medium ${
                                                deviceInfo?.connectionSource === 'rilevato-ai-live' 
                                                    ? 'bg-green-100 text-green-700 animate-pulse' 
                                                    : deviceInfo?.connectionSource === 'rilevato' || deviceInfo?.connectionSource === 'browser-api'
                                                        ? 'bg-blue-100 text-blue-700'
                                                        : 'bg-gray-100 text-gray-600'
                                            }`}>
                                                {deviceInfo?.connectionSource === 'rilevato-ai-live' && '🔴 LIVE'}
                                                {deviceInfo?.connectionSource === 'rilevato' && '✓ Rilevato'}
                                                {deviceInfo?.connectionSource === 'browser-api' && '✓ Browser'}
                                                {deviceInfo?.connectionSource === 'ai-suggerito' && '🤖 AI'}
                                                {deviceInfo?.connectionSource === 'dedotto' && '~ Dedotto'}
                                                {!deviceInfo?.connectionSource && '✓ Selezionato'}
                                            </span>
                                        )}
                                    </label>
                                    <div className="flex gap-2">
                                        <button
                                            type="button"
                                            onClick={() => { setSelectedConnectionType('LAN'); setConnectionDetected(true); }}
                                            className={`flex-1 p-3 border-2 rounded-lg text-sm flex items-center justify-center gap-2 transition-all ${
                                                selectedConnectionType === 'LAN' 
                                                    ? 'border-green-500 bg-green-50 text-green-700 font-semibold' 
                                                    : !selectedConnectionType
                                                        ? 'border-orange-300 bg-orange-50 text-gray-600 hover:border-orange-400'
                                                        : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <PlugZap className="h-5 w-5" /> Cavo LAN
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => { setSelectedConnectionType('Wi-Fi'); setConnectionDetected(true); }}
                                            className={`flex-1 p-3 border-2 rounded-lg text-sm flex items-center justify-center gap-2 transition-all ${
                                                selectedConnectionType === 'Wi-Fi' 
                                                    ? 'border-green-500 bg-green-50 text-green-700 font-semibold' 
                                                    : !selectedConnectionType
                                                        ? 'border-orange-300 bg-orange-50 text-gray-600 hover:border-orange-400'
                                                        : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <Wifi className="h-5 w-5" /> Wi-Fi
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            {/* ANTIVIRUS - Solo visualizzazione */}
                            <div className="mt-4 pt-4 border-t border-gray-200 flex items-center">
                                <Shield className="h-4 w-4 mr-2 text-green-600" />
                                <span className="text-sm text-gray-600">Antivirus:</span>
                                <span className="ml-2 text-sm font-medium text-gray-800">{antivirus}</span>
                                <span className="ml-2 text-xs text-green-600">✓ Attivo</span>
                            </div>
                        </div>
                        
                        {/* NOTIFICHE */}
                        {NotificationService.isSupported() && !notificationEnabled && (
                            <div className="bg-gradient-to-r from-yellow-50 to-amber-50 p-4 rounded-xl border-2 border-yellow-300 mb-4">
                                <div className="flex items-start gap-3">
                                    <div className="bg-yellow-400 rounded-full p-2 shrink-0">
                                        <Bell className="h-5 w-5 text-white" />
                                    </div>
                                    <div className="flex-1">
                                        <p className="text-sm font-bold text-gray-800">Attiva le notifiche</p>
                                        <p className="text-xs text-gray-600 mt-0.5">Ricevi gli aggiornamenti dei tuoi ticket anche quando l'app è chiusa.</p>
                                    </div>
                                </div>
                                <button 
                                    onClick={handleEnableNotificationsWithArrow} 
                                    data-testid="onboarding-enable-notifications"
                                    className="mt-3 w-full bg-yellow-500 text-white px-4 py-2.5 rounded-lg text-sm font-bold hover:bg-yellow-600 transition-colors flex items-center justify-center gap-2"
                                >
                                    <Bell className="h-4 w-4" /> Attiva tutte le notifiche
                                </button>
                            </div>
                        )}
                        {notificationEnabled && (
                            <div className="bg-green-50 p-3 rounded-lg border border-green-200 mb-4 flex items-center gap-2" data-testid="onboarding-notifications-active">
                                <BellRing className="h-4 w-4 text-green-600 shrink-0" />
                                <span className="text-green-700 text-sm font-medium">Notifiche attive — riceverai gli aggiornamenti dei ticket anche ad app chiusa</span>
                            </div>
                        )}
                        
                        {/* BOTTONE CONFERMA */}
                        <button 
                            onClick={() => {
                                // Aggiorna state con i valori editati
                                dispatch({ type: 'SET_STATE', payload: {
                                    userName: editableName.trim(),
                                    userComputer: editablePC.trim(),
                                    userSiteName: editableCompany.trim(),
                                    userCompany: editableCompany.trim()
                                }});
                                handleContinue();
                            }} 
                            data-testid="bat-launch-continue-btn"
                            disabled={!canConfirm} 
                            className={`w-full py-3 px-4 rounded-lg font-bold transition-all flex items-center justify-center gap-2 ${
                                canConfirm 
                                    ? 'bg-green-600 text-white hover:bg-green-700 shadow-lg' 
                                    : 'bg-gray-300 text-gray-600 cursor-not-allowed'
                            }`}
                        >
                            {canConfirm ? (
                                <>
                                    <CheckCircle className="h-5 w-5" />
                                    Confermo, tutto corretto!
                                </>
                            ) : (
                                <>
                                    {notifBlocking && allFieldsValid ? <Bell className="h-5 w-5" /> : <AlertTriangle className="h-5 w-5" />}
                                    {getButtonMessage()}
                                </>
                            )}
                        </button>
                        
                        {/* SPIEGAZIONE USER-FRIENDLY - Centrata e formattata */}
                        <div className="text-center mt-4 px-4">
                            <p className="text-sm text-gray-600 leading-relaxed">
                                <span className="text-amber-500">💡</span>{' '}
                                <strong>Controlla che le informazioni siano corrette.</strong>
                            </p>
                            <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                                Se qualcosa non è giusto, puoi modificarlo direttamente nei campi sopra.
                            </p>
                            <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                                Questi dati verranno usati per identificarti quando apri un ticket di assistenza.
                            </p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const WelcomeModal = ({ onSubmit }) => {
    // Carica email salvata se esistente
    const getSavedEmail = () => {
        try {
            return localStorage.getItem('spark-user-email-v1') || 
                   localStorage.getItem('spark-user-email') || '';
        } catch (e) { return ''; }
    };
    
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userEmail, setUserEmail] = useState(getSavedEmail());
    const [companyInput, setCompanyInput] = useState('');
    const [companySuggestions, setCompanySuggestions] = useState([]);
    const [matchedCompany, setMatchedCompany] = useState(null);
    const [allCompanies, setAllCompanies] = useState([]);
    const [loadingCompanies, setLoadingCompanies] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [enableNotifications, setEnableNotifications] = useState(true);
    const [error, setError] = useState('');

    // Carica lista aziende all'avvio
    useEffect(() => {
        const loadCompanies = async () => {
            setLoadingCompanies(true);
            try {
                const companies = await MOCK_API.getClientCompanies();
                setAllCompanies(companies);
                console.log('[WELCOME] Aziende caricate:', companies.length);
            } catch (err) {
                console.error('[WELCOME] Errore caricamento aziende:', err);
            }
            setLoadingCompanies(false);
        };
        loadCompanies();
    }, []);

    // Fuzzy search quando l'utente digita
    useEffect(() => {
        if (!companyInput.trim() || allCompanies.length === 0) {
            setCompanySuggestions([]);
            setMatchedCompany(null);
            return;
        }

        const normInput = normalizeCompanyName(companyInput);
        if (normInput.length < 2) {
            setCompanySuggestions([]);
            return;
        }

        // Cerca corrispondenze
        const matches = allCompanies.filter(company => {
            const normCompany = normalizeCompanyName(company);
            // Match parziale o fuzzy
            if (normCompany.includes(normInput) || normInput.includes(normCompany)) return true;
            // Levenshtein per errori di battitura
            const distance = getLevenshteinDistance(normCompany, normInput);
            return distance <= Math.max(normCompany.length, normInput.length) * 0.35;
        }).slice(0, 5); // Max 5 suggerimenti

        setCompanySuggestions(matches);

        // Trova il match migliore
        const bestMatch = findBestCompanyMatch(companyInput, allCompanies);
        setMatchedCompany(bestMatch);

    }, [companyInput, allCompanies]);

    const handleSelectCompany = (company) => {
        setCompanyInput(company);
        setMatchedCompany({ name: company, exact: true, score: 0 });
        setShowSuggestions(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!firstName.trim() || !lastName.trim()) {
            setError('Compila nome e cognome');
            return;
        }
        
        // Validazione email obbligatoria
        const emailTrimmed = userEmail.trim().toLowerCase();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailTrimmed || !emailRegex.test(emailTrimmed)) {
            setError('Inserisci un\'email aziendale valida');
            return;
        }
        
        // Se l'utente vuole le notifiche, richiedi permesso
        if (enableNotifications && NotificationService.isSupported()) {
            try {
                const result = await NotificationService.requestPermission();
                console.log('Notification permission:', result);
            } catch (err) {
                console.log('Notification request error:', err);
            }
        }

        // Determina l'azienda da usare
        let finalCompany = '';
        if (matchedCompany) {
            finalCompany = matchedCompany.name; // Usa nome ufficiale da RMM
            console.log('[WELCOME] Azienda matchata:', finalCompany);
        } else if (companyInput.trim()) {
            finalCompany = companyInput.trim(); // Input utente non matchato
            console.log('[WELCOME] Azienda inserita (non matchata):', finalCompany);
        }
        
        // Salva email in localStorage
        localStorage.setItem('spark-user-email-v1', emailTrimmed);
        
        onSubmit({ 
            userName: `${firstName.trim()} ${lastName.trim()}`,
            userCompany: finalCompany,
            userEmail: emailTrimmed,
            notificationsEnabled: enableNotifications 
        });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50 animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl p-4 sm:p-6 md:p-8 w-full max-w-md animate-scale-in max-h-[95vh] overflow-y-auto">
                {/* Avatar con logo 86BIT - più piccolo su mobile */}
                <div className="text-center mb-3 sm:mb-5">
                    <div className="relative inline-block">
                        <SparkAvatar size="md" className="h-16 w-16 sm:h-24 sm:w-24 mx-auto border-4 border-gray-100" />
                        <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                            86BIT
                        </div>
                    </div>
                </div>

                {/* Titolo e descrizione - più compatto su mobile */}
                <div className="text-center mb-3 sm:mb-5">
                    <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Benvenuto/a in Spark!</h2>
                    <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                        Ciao! Sono Spark, il tuo assistente IT. Per iniziare, dimmi chi sei.
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
                    {/* Campi Nome e Cognome */}
                    <div className="grid grid-cols-2 gap-2 sm:gap-3">
                        <div>
                            <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1">Nome *</label>
                            <input 
                                type="text" 
                                value={firstName} 
                                onChange={(e) => { setFirstName(e.target.value); setError(''); }} 
                                className="w-full p-2 sm:p-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm" 
                                autoFocus 
                            />
                        </div>
                        <div>
                            <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1">Cognome *</label>
                            <input 
                                type="text" 
                                value={lastName} 
                                onChange={(e) => { setLastName(e.target.value); setError(''); }} 
                                className="w-full p-2 sm:p-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm" 
                            />
                        </div>
                    </div>

                    {/* Campo Azienda Opzionale con Autocomplete - nascosto su mobile piccoli per risparmiare spazio */}
                    <div className="relative hidden sm:block">
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1">
                            Azienda <span className="font-normal text-gray-400">(opzionale)</span>
                        </label>
                        <div className="relative">
                            <input 
                                type="text" 
                                value={companyInput} 
                                onChange={(e) => { setCompanyInput(e.target.value); setShowSuggestions(true); }} 
                                onFocus={() => setShowSuggestions(true)}
                                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                placeholder="Es. 86BIT, Acme Corp..."
                                className="w-full p-2 sm:p-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm pr-10" 
                            />
                            {loadingCompanies && (
                                <div className="absolute right-3 top-1/2 -translate-y-1/2">
                                    <RefreshCw className="h-4 w-4 text-gray-400 animate-spin" />
                                </div>
                            )}
                            {matchedCompany && !loadingCompanies && (
                                <div className="absolute right-3 top-1/2 -translate-y-1/2">
                                    <CheckCircle className="h-4 w-4 text-green-500" />
                                </div>
                            )}
                        </div>
                        
                        {/* Dropdown suggerimenti */}
                        {showSuggestions && companySuggestions.length > 0 && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-40 overflow-y-auto">
                                {companySuggestions.map((company, idx) => (
                                    <button
                                        key={idx}
                                        type="button"
                                        onClick={() => handleSelectCompany(company)}
                                        className="w-full text-left px-3 py-2 text-sm hover:bg-blue-50 flex items-center gap-2 transition-colors"
                                    >
                                        <Building2 className="h-4 w-4 text-gray-400" />
                                        <span>{company}</span>
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Feedback match */}
                        {matchedCompany && companyInput && (
                            <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
                                <CheckCircle className="h-3 w-3" />
                                {matchedCompany.exact ? 'Azienda riconosciuta' : `Corrispondenza trovata: ${matchedCompany.name}`}
                            </p>
                        )}
                    </div>

                    {/* Campo Email OBBLIGATORIO */}
                    <div>
                        <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1">
                            Email aziendale *
                        </label>
                        <div className="relative">
                            <AtSign className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                            <input 
                                type="email" 
                                value={userEmail} 
                                onChange={(e) => { setUserEmail(e.target.value); setError(''); }} 
                                placeholder="nome.cognome@azienda.it"
                                className="w-full p-2 sm:p-2.5 pl-10 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm" 
                                inputMode="email"
                                autoComplete="email"
                            />
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 sm:mt-1">Per la gestione dei ticket</p>
                    </div>

                    {/* Sezione Notifiche - nascosta su mobile piccoli */}
                    <div className="hidden sm:flex bg-blue-50 rounded-xl p-2 sm:p-3 items-center justify-between">
                        <div className="flex items-center">
                            <Sparkles className="h-4 w-4 sm:h-5 sm:w-5 text-blue-500 mr-2" />
                            <div>
                                <p className="font-semibold text-gray-800 text-xs sm:text-sm">Notifiche</p>
                                <p className="text-xs text-gray-500 hidden sm:block">Avvisi e consigli per la sicurezza</p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={() => setEnableNotifications(!enableNotifications)}
                            className={`relative inline-flex h-5 w-9 sm:h-6 sm:w-11 items-center rounded-full transition-colors ${enableNotifications ? 'bg-blue-600' : 'bg-gray-300'}`}
                        >
                            <span className={`inline-block h-3 w-3 sm:h-4 sm:w-4 transform rounded-full bg-white transition-transform ${enableNotifications ? 'translate-x-5 sm:translate-x-6' : 'translate-x-1'}`} />
                        </button>
                    </div>

                    {/* Errore */}
                    {error && <p className="text-red-500 text-xs sm:text-sm text-center">{error}</p>}

                    {/* Bottone Submit */}
                    <button 
                        type="submit" 
                        className="w-full bg-blue-600 text-white font-bold py-2.5 sm:py-3 px-4 rounded-xl hover:bg-blue-700 transition-colors shadow-lg shadow-blue-200"
                    >
                        Inizia a Chattare
                    </button>
                </form>
            </div>
        </div>
    );
};

// ============================================================================
// CHAT HISTORY PANEL - Storico conversazioni raggruppate per data
// ============================================================================
const ChatHistoryPanel = ({ onClose }) => {
    const { dispatch } = useContext(ChatContext);
    const [history, setHistory] = useState([]);
    const [groupedHistory, setGroupedHistory] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({ 'Oggi': true, 'Ieri': true });
    
    useEffect(() => {
        const loaded = loadChatHistory();
        setHistory(loaded);
        setGroupedHistory(groupChatsByDate(loaded));
    }, []);
    
    const handleLoadSession = (session) => {
        dispatch({ type: 'LOAD_HISTORY_SESSION', payload: session });
    };
    
    const handleDeleteSession = (sessionId) => {
        const updated = history.filter(s => s.id !== sessionId);
        saveChatHistory(updated);
        setHistory(updated);
        setGroupedHistory(groupChatsByDate(updated));
    };
    
    const handleClearAll = () => {
        if (window.confirm('Vuoi eliminare tutto lo storico delle conversazioni?')) {
            saveChatHistory([]);
            setHistory([]);
            setGroupedHistory({});
        }
    };
    
    const toggleGroup = (group) => {
        setExpandedGroups(prev => ({ ...prev, [group]: !prev[group] }));
    };
    
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    };
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
    };
    
    const groupOrder = ['Oggi', 'Ieri', 'Ultima settimana', 'Mese scorso', 'Più vecchie'];
    const groupIcons = {
        'Oggi': '📅',
        'Ieri': '📆',
        'Ultima settimana': '🗓️',
        'Mese scorso': '📋',
        'Più vecchie': '📦'
    };
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[80vh] flex flex-col animate-scale-in">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-4 rounded-t-2xl flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Clock className="h-5 w-5" />
                        <h2 className="text-lg font-bold">Storico Conversazioni</h2>
                    </div>
                    <button onClick={onClose} className="p-1 hover:bg-white/20 rounded-full">
                        <XCircle className="h-5 w-5" />
                    </button>
                </div>
                
                {/* Content */}
                <div className="flex-1 overflow-y-auto p-4">
                    {history.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            <Clock className="h-12 w-12 mx-auto mb-3 opacity-30" />
                            <p className="font-medium">Nessuna conversazione salvata</p>
                            <p className="text-sm mt-1">Le tue conversazioni appariranno qui</p>
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {groupOrder.map(group => {
                                const sessions = groupedHistory[group] || [];
                                if (sessions.length === 0) return null;
                                
                                return (
                                    <div key={group} className="border border-gray-200 rounded-xl overflow-hidden">
                                        {/* Group Header */}
                                        <button
                                            onClick={() => toggleGroup(group)}
                                            className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors"
                                        >
                                            <div className="flex items-center gap-2">
                                                <span>{groupIcons[group]}</span>
                                                <span className="font-semibold text-gray-700">{group}</span>
                                                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                                                    {sessions.length}
                                                </span>
                                            </div>
                                            {expandedGroups[group] ? (
                                                <ChevronUp className="h-4 w-4 text-gray-500" />
                                            ) : (
                                                <ChevronDown className="h-4 w-4 text-gray-500" />
                                            )}
                                        </button>
                                        
                                        {/* Sessions List */}
                                        {expandedGroups[group] && (
                                            <div className="divide-y divide-gray-100">
                                                {sessions.map(session => (
                                                    <div
                                                        key={session.id}
                                                        className="p-3 hover:bg-blue-50 transition-colors cursor-pointer group"
                                                        onClick={() => handleLoadSession(session)}
                                                    >
                                                        <div className="flex items-start justify-between">
                                                            <div className="flex-1 min-w-0">
                                                                <div className="flex items-center gap-2 mb-1">
                                                                    <span className="text-xs text-gray-500">
                                                                        {formatTime(session.timestamp)}
                                                                        {group !== 'Oggi' && group !== 'Ieri' && (
                                                                            <span className="ml-1">• {formatDate(session.timestamp)}</span>
                                                                        )}
                                                                    </span>
                                                                    <span className="text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded">
                                                                        {session.messages?.length || 0} msg
                                                                    </span>
                                                                </div>
                                                                <p className="text-sm text-gray-800 truncate font-medium">
                                                                    {session.preview || 'Conversazione'}...
                                                                </p>
                                                                {session.userComputer && (
                                                                    <p className="text-xs text-gray-400 mt-0.5">
                                                                        💻 {session.userComputer}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDeleteSession(session.id);
                                                                }}
                                                                className="p-1 text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                                                                title="Elimina"
                                                            >
                                                                <Trash2 className="h-4 w-4" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
                
                {/* Footer */}
                {history.length > 0 && (
                    <div className="p-4 border-t border-gray-200 flex gap-2">
                        <button
                            onClick={handleClearAll}
                            className="flex-1 py-2 px-4 text-red-600 border border-red-200 rounded-lg hover:bg-red-50 text-sm font-medium flex items-center justify-center gap-1"
                        >
                            <Trash2 className="h-4 w-4" />
                            Cancella tutto
                        </button>
                        <button
                            onClick={onClose}
                            className="flex-1 py-2 px-4 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm font-medium"
                        >
                            Chiudi
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

// ============================================================================
// PHONE MODAL - Mostra numero e orari quando non c'è supporto chiamate
// ============================================================================
const PhoneModal = ({ onClose }) => {
    const [copied, setCopied] = useState(false);
    const phoneNumber = "+39 035 31 09 00";
    const phoneNumberClean = "+39035310900";
    
    const handleCopy = () => {
        navigator.clipboard.writeText(phoneNumber + " Tasto 1");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleTryCall = () => {
        window.location.href = `tel:${phoneNumberClean}`;
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 animate-fade-in" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-scale-in" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-4 rounded-t-2xl flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <Phone className="h-6 w-6 text-white" />
                        <h2 className="text-xl font-bold text-white">Contattaci</h2>
                    </div>
                    <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/20 text-white">
                        <XCircle className="h-6 w-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 space-y-5">
                    {/* Phone Number */}
                    <div className="bg-green-50 rounded-xl p-4 text-center">
                        <p className="text-sm text-green-700 mb-2">Il nostro numero:</p>
                        <p className="text-2xl font-bold text-green-800 tracking-wider">{phoneNumber}</p>
                        <p className="text-lg font-semibold text-green-600 mt-1">📞 Tasto 1</p>
                        <button
                            onClick={handleCopy}
                            className="mt-3 inline-flex items-center gap-2 px-4 py-2 bg-white border border-green-200 rounded-lg text-green-700 text-sm font-medium hover:bg-green-100 transition-all"
                        >
                            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                            {copied ? 'Copiato!' : 'Copia numero'}
                        </button>
                    </div>

                    {/* Business Hours */}
                    <div className="bg-gray-50 rounded-xl p-4">
                        <h3 className="text-sm font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                            <Clock className="h-4 w-4" />
                            Orari di Assistenza
                        </h3>
                        <div className="space-y-2">
                            <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                <span className="text-gray-700">Lunedì - Venerdì</span>
                                <span className="font-semibold text-gray-900">7:30 - 21:00</span>
                            </div>
                            <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                <span className="text-gray-700">Sabato</span>
                                <span className="font-semibold text-gray-900">8:00 - 12:30</span>
                            </div>
                            <div className="flex justify-between items-center py-2">
                                <span className="text-gray-700">Domenica e fuori orario</span>
                                <span className="font-medium text-blue-500">Ci pensa Spark! 🤖</span>
                            </div>
                        </div>
                    </div>

                    {/* Alternative Actions */}
                    <div className="space-y-2">
                        <button
                            onClick={handleTryCall}
                            className="w-full py-3 px-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-bold hover:from-green-600 hover:to-emerald-700 transition-all shadow-lg shadow-green-200 flex items-center justify-center gap-2"
                        >
                            <Phone className="h-5 w-5" />
                            Prova a Chiamare
                        </button>
                        <p className="text-xs text-center text-gray-500">
                            Se il tuo dispositivo supporta le chiamate, si aprirà l'app telefono
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// SUPPORTO REMOTO WHATSAPP (mobile) - condivisione schermo via videochiamata WhatsApp (sola visualizzazione)
// ============================================================================
const IT_TECHNICIANS = [
    { name: 'Nicolò', phone: '393518163784' },
    { name: 'Carlos', phone: '393514158493' },
];

const RemoteSupportModal = ({ onClose }) => {
    const { state } = useContext(ChatContext);
    const dark = state.darkMode;
    const [chosenTech, setChosenTech] = useState(null);

    const openWhatsApp = (tech) => {
        const name = state.userName || '';
        const computer = state.userComputer || '';
        const company = state.userCompany || state.userSiteName || '';
        let msg = 'Ciao IT 86BIT \uD83D\uDC4B Vorrei condividere lo schermo del telefono: sto per avviare una videochiamata e attivare la condivisione schermo.';
        if (name) msg += `\nNome: ${name}`;
        if (computer) msg += `\nDispositivo: ${computer}`;
        if (company) msg += `\nAzienda: ${company}`;
        const url = `https://wa.me/${tech.phone}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
        setChosenTech(tech);
    };

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-3 z-50" onClick={onClose} data-testid="remote-support-modal">
            <div className={`${dark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto`} onClick={e => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-green-600 to-emerald-600 p-4 flex items-center justify-between rounded-t-2xl">
                    <div className="flex items-center gap-2">
                        <MessageCircle className="h-6 w-6 text-white" />
                        <h2 className="text-lg font-bold text-white">Supporto Remoto</h2>
                    </div>
                    <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/20 text-white" data-testid="remote-support-close"><XCircle className="h-6 w-6" /></button>
                </div>

                {!chosenTech ? (
                    <div className="p-5 space-y-4">
                        <p className={`text-sm ${dark ? 'text-gray-300' : 'text-gray-600'}`}>Mostra il tuo schermo a un tecnico 86BIT tramite <strong>WhatsApp</strong>, senza installare nulla. Il tecnico <strong>vede soltanto</strong> lo schermo, non lo controlla.</p>
                        <p className="text-sm font-medium">Scegli con chi parlare:</p>
                        <div className="space-y-2">
                            {IT_TECHNICIANS.map((t) => (
                                <button key={t.name} onClick={() => openWhatsApp(t)}
                                    className="w-full py-3 px-3 rounded-lg bg-green-600 hover:bg-green-500 text-white text-sm font-semibold flex items-center justify-center gap-2"
                                    data-testid={`remote-open-whatsapp-${t.name.toLowerCase()}`}>
                                    <MessageCircle className="h-4 w-4" /> Tecnico {t.name}
                                </button>
                            ))}
                        </div>
                        <div className={`flex items-start gap-2 text-xs p-3 rounded-lg ${dark ? 'bg-gray-700/60 text-gray-300' : 'bg-green-50 text-green-800'}`}>
                            <Eye className="h-4 w-4 mt-0.5 flex-shrink-0" />
                            <span>Il tecnico può <strong>solo vedere</strong> lo schermo per aiutarti. Puoi interrompere quando vuoi.</span>
                        </div>
                    </div>
                ) : (
                    <div className="p-5 space-y-4" data-testid="remote-support-steps">
                        <div className="text-center">
                            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-100 text-green-700 text-sm font-semibold">
                                <MessageCircle className="h-4 w-4" /> WhatsApp aperto con {chosenTech.name}
                            </div>
                            <p className={`text-sm mt-3 ${dark ? 'text-gray-300' : 'text-gray-600'}`}>Ora, <strong>nella chat WhatsApp</strong>, fai solo questi 2 passaggi:</p>
                        </div>

                        <div className={`rounded-xl p-4 space-y-4 ${dark ? 'bg-gray-700/60' : 'bg-gray-50'}`}>
                            <div className="flex items-center gap-3">
                                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-green-600 text-white text-base font-bold flex items-center justify-center">1</span>
                                <div className="flex-1">
                                    <p className="text-sm font-semibold flex items-center gap-1.5">Tocca <Video className="h-5 w-5 text-green-600" /> <span>Videochiamata</span></p>
                                    <p className={`text-xs ${dark ? 'text-gray-400' : 'text-gray-500'}`}>In alto a destra nella chat</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-green-600 text-white text-base font-bold flex items-center justify-center">2</span>
                                <div className="flex-1">
                                    <p className="text-sm font-semibold flex items-center gap-1.5">Tocca <Monitor className="h-5 w-5 text-green-600" /> <span>«Condividi schermo»</span></p>
                                    <p className={`text-xs ${dark ? 'text-gray-400' : 'text-gray-500'}`}>Menu <span className="font-mono">⋮</span> durante la chiamata → «Condividi schermo»</p>
                                </div>
                            </div>
                        </div>

                        <button onClick={() => openWhatsApp(chosenTech)} className="w-full py-2.5 rounded-lg bg-green-600 hover:bg-green-500 text-white text-sm font-semibold flex items-center justify-center gap-2" data-testid="remote-reopen-whatsapp">
                            <MessageCircle className="h-4 w-4" /> Riapri WhatsApp con {chosenTech.name}
                        </button>
                        <button onClick={() => setChosenTech(null)} className={`w-full py-2 rounded-lg text-xs font-medium ${dark ? 'text-gray-400 hover:bg-gray-700' : 'text-gray-500 hover:bg-gray-100'}`} data-testid="remote-back-tech">← Scegli un altro tecnico</button>
                    </div>
                )}
            </div>
        </div>
    );
};

// ============================================================================
// OPEN ON PHONE MODAL (desktop) - QR code per aprire Spark sul telefono
// ============================================================================
const OpenOnPhoneModal = ({ onClose }) => {
    const { state } = useContext(ChatContext);
    const dark = state.darkMode;

    const handoffUrl = useMemo(() => {
        const payload = {
            n: state.userName || '',
            c: state.userCompany || state.userSiteName || '',
            e: state.userEmail || (typeof localStorage !== 'undefined' ? (localStorage.getItem('spark-user-email-v1') || '') : ''),
        };
        const origin = typeof window !== 'undefined' ? window.location.origin : 'https://spark.86bit.it';
        return `${origin}/?m=${encodeHandoff(payload)}`;
    }, [state.userName, state.userCompany, state.userSiteName, state.userEmail]);

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-3 z-50" onClick={onClose} data-testid="open-on-phone-modal">
            <div className={`${dark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} rounded-2xl shadow-2xl w-full max-w-md`} onClick={e => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-blue-700 to-indigo-600 p-4 flex items-center justify-between rounded-t-2xl">
                    <div className="flex items-center gap-2">
                        <Smartphone className="h-6 w-6 text-white" />
                        <h2 className="text-lg font-bold text-white">Apri Spark sul telefono</h2>
                    </div>
                    <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/20 text-white" data-testid="open-on-phone-close"><XCircle className="h-6 w-6" /></button>
                </div>
                <div className="p-5 space-y-4 text-center">
                    <p className={`text-sm ${dark ? 'text-gray-300' : 'text-gray-600'}`}>Inquadra questo QR code con la fotocamera del telefono. Spark si aprirà <strong>già riconosciuto</strong> come <strong>{state.userName || 'te'}</strong>{state.userCompany ? <> di <strong>{state.userCompany}</strong></> : null}.</p>
                    <div className="flex justify-center">
                        <div className="p-4 bg-white rounded-xl shadow-inner" data-testid="open-on-phone-qr">
                            <QRCodeSVG value={handoffUrl} size={200} level="M" includeMargin={false} />
                        </div>
                    </div>
                    <div className={`flex items-start gap-2 text-xs p-3 rounded-lg text-left ${dark ? 'bg-amber-900/30 text-amber-300' : 'bg-amber-50 text-amber-800'}`}>
                        <Lock className="h-4 w-4 mt-0.5 flex-shrink-0" />
                        <span>Questo QR è <strong>personale</strong>: contiene la tua identità. Non condividerlo con altri.</span>
                    </div>
                    <div className={`flex items-start gap-2 text-xs p-3 rounded-lg text-left ${dark ? 'bg-gray-700/60 text-gray-300' : 'bg-blue-50 text-blue-800'}`}>
                        <Info className="h-4 w-4 mt-0.5 flex-shrink-0" />
                        <span>Sul telefono potrai aggiungere Spark alla schermata Home come app: apri il menu del browser e scegli <strong>«Aggiungi a schermata Home»</strong>.</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// MOBILE HANDOFF MODAL (telefono) - conferma veloce identita' dopo scansione QR
// ============================================================================
const MobileHandoffModal = ({ onConfirm, onReject }) => {
    const { state } = useContext(ChatContext);
    const dark = state.darkMode;
    return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-3 z-[70]" data-testid="mobile-handoff-modal">
            <div className={`${dark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} rounded-2xl shadow-2xl w-full max-w-sm`}>
                <div className="bg-gradient-to-r from-blue-700 to-indigo-600 p-5 rounded-t-2xl text-center">
                    <SparkAvatar size="sm" className="h-14 w-14 mx-auto mb-2" />
                    <h2 className="text-lg font-bold text-white">Benvenuto su Spark</h2>
                    <p className="text-xs text-white/80 mt-0.5">Conferma la tua identità per continuare</p>
                </div>
                <div className="p-5 space-y-4">
                    <div className={`rounded-xl p-4 space-y-2 ${dark ? 'bg-gray-700/60' : 'bg-gray-50'}`}>
                        <div className="flex items-center gap-2">
                            <User className="h-4 w-4 text-blue-500" />
                            <span className="text-sm font-semibold" data-testid="handoff-name">{state.userName || '—'}</span>
                        </div>
                        {state.userCompany && (
                            <div className="flex items-center gap-2">
                                <Building2 className="h-4 w-4 text-blue-500" />
                                <span className="text-sm" data-testid="handoff-company">{state.userCompany}</span>
                            </div>
                        )}
                        {state.userEmail && (
                            <div className="flex items-center gap-2">
                                <Mail className="h-4 w-4 text-blue-500" />
                                <span className="text-sm break-all" data-testid="handoff-email">{state.userEmail}</span>
                            </div>
                        )}
                    </div>
                    <button onClick={onConfirm} className="w-full py-3 rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold flex items-center justify-center gap-2" data-testid="handoff-confirm">
                        <CheckCircle className="h-5 w-5" /> Sì, sono io — Entra
                    </button>
                    <button onClick={onReject} className={`w-full py-2.5 rounded-lg text-sm font-medium ${dark ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'}`} data-testid="handoff-reject">
                        Non sono io
                    </button>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// VIDEO CALL MODAL - Jitsi Meet Integration
// ============================================================================
const VideoCallModal = ({ onClose }) => {
    const { state } = useContext(ChatContext);
    const [step, setStep] = useState('password'); // 'password', 'confirm', 'calling'
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [jitsiApi, setJitsiApi] = useState(null);
    const [roomName, setRoomName] = useState('');
    const jitsiContainerRef = useRef(null);
    
    // Genera nome stanza unico completamente casuale
    // Evita pattern "aziendali" che potrebbero attivare lobby/moderatore su meet.jit.si
    const generateRoomName = () => {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < 20; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };
    
    // Prepara il display name per Jitsi
    const getDisplayName = () => {
        let name = state.userName || 'Utente';
        if (state.userCompany || state.userSiteName) {
            name += ` (${state.userCompany || state.userSiteName})`;
        }
        return name;
    };
    
    // Carica Jitsi API script
    const loadJitsiScript = () => {
        return new Promise((resolve, reject) => {
            if (window.JitsiMeetExternalAPI) {
                resolve();
                return;
            }
            
            const script = document.createElement('script');
            script.src = 'https://meet.jit.si/external_api.js';
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    };
    
    // Inizializza Jitsi Meet
    const initJitsi = async (room) => {
        try {
            await loadJitsiScript();
            
            if (!jitsiContainerRef.current || !window.JitsiMeetExternalAPI) return;
            
            // Usa meet.jit.si - istanza pubblica gratuita
            // NOTA: meet.jit.si ora richiede moderatore per nuove stanze
            // Il primo partecipante diventa automaticamente moderatore
            const api = new window.JitsiMeetExternalAPI('meet.jit.si', {
                roomName: room,
                parentNode: jitsiContainerRef.current,
                userInfo: {
                    displayName: getDisplayName(),
                    email: 'user@86bit.it' // Email per identificazione
                },
                configOverwrite: {
                    // Pre-join - disabilitata
                    prejoinPageEnabled: false,
                    prejoinConfig: { enabled: false },
                    // Audio/Video - partenza immediata
                    startWithAudioMuted: false,
                    startWithVideoMuted: false,
                    // Disabilita controlli
                    disableDeepLinking: true,
                    enableWelcomePage: false,
                    enableClosePage: false,
                    disableInviteFunctions: true,
                    defaultLanguage: 'it',
                    // Lobby e moderatore
                    enableLobbyChat: false,
                    hideLobbyButton: true,
                    requireDisplayName: false,
                    enableInsecureRoomNameWarning: false,
                    lobby: { enabled: false },
                    disableModeratorIndicator: true,
                    // Abilita auto-join come moderatore per il primo utente
                    enableUserRolesBasedOnToken: false,
                    // Performance
                    startAudioOnly: false,
                    enableNoAudioDetection: false,
                    enableNoisyMicDetection: false,
                    doNotStoreRoom: true,
                    // Testing
                    testing: {
                        enableLobbyChat: false
                    }
                },
                interfaceConfigOverwrite: {
                    SHOW_JITSI_WATERMARK: false,
                    SHOW_WATERMARK_FOR_GUESTS: false,
                    SHOW_BRAND_WATERMARK: false,
                    SHOW_POWERED_BY: false,
                    MOBILE_APP_PROMO: false,
                    DISABLE_JOIN_LEAVE_NOTIFICATIONS: false,
                    TOOLBAR_BUTTONS: [
                        'microphone', 'camera', 'desktop', 'fullscreen',
                        'hangup', 'chat', 'raisehand', 'tileview', 'settings'
                    ],
                    SETTINGS_SECTIONS: ['devices', 'language'],
                    DEFAULT_BACKGROUND: '#1a1a2e',
                    HIDE_INVITE_MORE_HEADER: true,
                    DISABLE_PRESENCE_STATUS: true
                }
            });
            
            // Eventi per tornare a Spark
            api.addListener('videoConferenceLeft', () => {
                console.log('[JITSI] Chiamata terminata');
                cleanupAndClose();
            });
            
            api.addListener('readyToClose', () => {
                console.log('[JITSI] Ready to close');
                cleanupAndClose();
            });
            
            setJitsiApi(api);
            
        } catch (err) {
            console.error('[JITSI] Errore:', err);
            setError('Errore caricamento videochiamata');
        }
    };
    
    // Cleanup e chiudi
    const cleanupAndClose = () => {
        if (jitsiApi) {
            try { jitsiApi.dispose(); } catch (e) {}
            setJitsiApi(null);
        }
        setStep('password');
        setPassword('');
        setRoomName('');
        onClose();
    };
    
    // Cleanup quando si chiude
    useEffect(() => {
        return () => {
            if (jitsiApi) {
                try { jitsiApi.dispose(); } catch (e) {}
            }
        };
    }, [jitsiApi]);
    
    // Verifica password tramite backend
    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/verify-video-password`, {
                method: 'POST',
                headers: getAuthHeaders(),
                credentials: 'include',
                body: JSON.stringify({ password })
            });
            
            const data = await response.json();
            
            if (data.success) {
                setStep('confirm');
            } else {
                setError(data.error || 'Password non corretta');
            }
        } catch (err) {
            setError('Errore di connessione. Riprova.');
        }
        
        setIsLoading(false);
    };
    
    // Avvia la videochiamata
    const startVideoCall = async () => {
        setIsLoading(true);
        
        // Genera stanza unica
        const newRoom = generateRoomName();
        setRoomName(newRoom);
        
        // Prepara display name per URL
        const displayName = encodeURIComponent(getDisplayName());
        
        // URL server Jitsi alternativo (meet.ffmuc.net - no moderator requirement)
        const jitsiUrl = `https://meet.ffmuc.net/${newRoom}#userInfo.displayName="${displayName}"&config.prejoinPageEnabled=false`;
        
        // Notifica 86BIT su Teams
        try {
            const backendUrl = API_BASE_URL;
            console.log('[VIDEOCALL] Invio notifica a:', backendUrl);
            
            const response = await fetch(`${backendUrl}/api/teams/notify-call`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userName: state.userName || 'Utente',
                    userCompany: state.userCompany || state.userSiteName || 'Non specificata',
                    userComputer: state.userComputer || 'Non specificato',
                    roomName: newRoom,
                    roomUrl: `https://meet.ffmuc.net/${newRoom}`
                })
            });
            
            const result = await response.json();
            console.log('[VIDEOCALL] Risposta notifica:', result);
            
        } catch (e) {
            console.error('[VIDEOCALL] Errore notifica:', e);
        }
        
        setStep('calling');
        setIsLoading(false);
    };
    
    // Costruisce l'URL Jitsi completo per l'iframe
    // USA SERVER ALTERNATIVO: meet.ffmuc.net (server comunitario senza restrizioni moderatore)
    const getJitsiIframeUrl = () => {
        if (!roomName) return '';
        const displayName = encodeURIComponent(getDisplayName());
        // Server alternativo senza requisito moderatore
        // Abilitati controlli camera frontale/posteriore per mobile
        return `https://meet.ffmuc.net/${roomName}#userInfo.displayName="${displayName}"&config.prejoinPageEnabled=false&config.requireDisplayName=false&config.enableWelcomePage=false&config.disableDeepLinking=true&config.disableRemoteMute=true&config.startWithVideoMuted=false&config.startWithAudioMuted=false&interfaceConfig.MOBILE_APP_PROMO=false&interfaceConfig.SHOW_JITSI_WATERMARK=false&interfaceConfig.TOOLBAR_BUTTONS=["microphone","camera","hangup","chat","settings","videoquality","filmstrip","tileview","select-background","toggle-camera"]&interfaceConfig.SETTINGS_SECTIONS=["devices","language"]&interfaceConfig.SHOW_CHROME_EXTENSION_BANNER=false`;
    };
    
    // Non usiamo più initJitsi con l'API, usiamo iframe diretto
    // useEffect per cleanup
    useEffect(() => {
        // Cleanup quando si chiude
        return () => {
            if (jitsiApi) {
                try { jitsiApi.dispose(); } catch (e) {}
            }
        };
    }, [jitsiApi]);
    
    // Termina chiamata
    const handleEndCall = () => {
        cleanupAndClose();
    };

    // Schermo intero per la videochiamata - USA IFRAME DIRETTO
    if (step === 'calling') {
        return (
            <div className="fixed inset-0 bg-gray-900 z-[100] flex flex-col">
                {/* Header con pulsante esci */}
                <div className="bg-gray-800 p-2 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-2 text-white">
                        <Video className="h-5 w-5 text-green-400" />
                        <span className="text-sm font-medium">Videochiamata 86BIT</span>
                    </div>
                    <button
                        onClick={handleEndCall}
                        className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg flex items-center gap-1 transition-colors"
                    >
                        <Phone className="h-4 w-4 rotate-[135deg]" />
                        Termina
                    </button>
                </div>
                
                {/* Iframe Jitsi diretto - bypassa restrizioni API */}
                <iframe
                    src={getJitsiIframeUrl()}
                    className="flex-1 w-full border-0"
                    style={{ minHeight: 'calc(100vh - 52px)' }}
                    allow="camera; microphone; fullscreen; display-capture; autoplay"
                    allowFullScreen
                />
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 animate-fade-in" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-scale-in" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 rounded-t-2xl flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <Video className="h-6 w-6 text-white" />
                        <h2 className="text-xl font-bold text-white">Videochiamata Supporto</h2>
                    </div>
                    <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/20 text-white">
                        <XCircle className="h-6 w-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 space-y-5">
                    {step === 'password' && (
                        <>
                            {/* Info */}
                            <div className="bg-blue-50 rounded-xl p-4">
                                <div className="flex items-start gap-3">
                                    <div className="p-2 bg-blue-100 rounded-lg">
                                        <Shield className="h-6 w-6 text-blue-600" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-blue-900">Accesso Protetto</h3>
                                        <p className="text-sm text-blue-700 mt-1">
                                            Inserisci la password fornita da 86BIT per avviare la videochiamata.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Password Form */}
                            <form onSubmit={handlePasswordSubmit} className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Password di sicurezza
                                    </label>
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Inserisci la password"
                                        className={`w-full p-3 border-2 rounded-xl text-center text-lg tracking-wider ${error ? 'border-red-300 bg-red-50' : 'border-gray-200'} focus:border-blue-500 focus:ring-2 focus:ring-blue-200`}
                                        autoFocus
                                    />
                                    {error && (
                                        <p className="text-red-500 text-sm mt-2 text-center">{error}</p>
                                    )}
                                </div>
                                
                                <button
                                    type="submit"
                                    className="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl font-bold hover:from-blue-600 hover:to-indigo-700 transition-all"
                                >
                                    Continua
                                </button>
                            </form>
                            
                            <p className="text-xs text-center text-gray-500">
                                🔒 La password ti è stata fornita dal team 86BIT
                            </p>
                        </>
                    )}
                    
                    {step === 'confirm' && (
                        <>
                            {/* User Info */}
                            <div className="bg-gray-50 rounded-xl p-4">
                                <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3">
                                    Ti presenterai come:
                                </h4>
                                <div className="flex items-center gap-3">
                                    <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                                        {(state.userName || 'U').charAt(0).toUpperCase()}
                                    </div>
                                    <div>
                                        <p className="font-semibold text-gray-900">{state.userName || 'Utente'}</p>
                                        {(state.userCompany || state.userSiteName) && (
                                            <p className="text-sm text-gray-500">{state.userCompany || state.userSiteName}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Features */}
                            <div className="space-y-2">
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <CheckCircle2 className="h-4 w-4 text-green-500" />
                                    <span>Videochiamata sicura e criptata</span>
                                </div>
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <CheckCircle2 className="h-4 w-4 text-green-500" />
                                    <span>Condivisione schermo disponibile</span>
                                </div>
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <CheckCircle2 className="h-4 w-4 text-green-500" />
                                    <span>Integrato nativamente in Spark</span>
                                </div>
                            </div>
                            
                            {/* Start Button */}
                            <button
                                onClick={startVideoCall}
                                disabled={isLoading}
                                className="w-full py-4 px-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-bold hover:from-green-600 hover:to-emerald-700 transition-all shadow-lg shadow-green-200 flex items-center justify-center gap-2 disabled:opacity-50"
                            >
                                {isLoading ? (
                                    <Loader2 className="h-5 w-5 animate-spin" />
                                ) : (
                                    <>
                                        <Video className="h-5 w-5" />
                                        Chiama 86BIT Ora
                                    </>
                                )}
                            </button>
                            
                            <p className="text-xs text-center text-gray-500">
                                📅 Lun-Ven 7:30-21:00 | Sab 8:00-12:30 • Un tecnico ti raggiungerà appena disponibile
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// INCOMING CALL MODAL - Chiamata in arrivo da Teams
// ============================================================================
const IncomingCallModal = ({ callerName, roomUrl, roomName, onAnswer, onDecline }) => {
    const [isRinging, setIsRinging] = useState(true);
    
    // Effetto vibrazione/suono (se disponibile)
    useEffect(() => {
        // Vibrazione su mobile
        if (navigator.vibrate) {
            const vibratePattern = () => {
                navigator.vibrate([200, 100, 200, 100, 200]);
            };
            vibratePattern();
            const interval = setInterval(vibratePattern, 2000);
            return () => {
                clearInterval(interval);
                navigator.vibrate(0);
            };
        }
    }, []);
    
    const handleAnswer = () => {
        setIsRinging(false);
        window.open(roomUrl, '_blank', 'noopener,noreferrer');
        onAnswer();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center p-4 z-[100] animate-fade-in">
            <div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-3xl shadow-2xl w-full max-w-sm animate-scale-in overflow-hidden">
                {/* Header con animazione */}
                <div className="p-8 text-center">
                    {/* Avatar con animazione pulse */}
                    <div className={`w-24 h-24 mx-auto mb-4 rounded-full bg-gradient-to-br from-blue-400 to-indigo-600 flex items-center justify-center ${isRinging ? 'animate-pulse' : ''}`}>
                        <span className="text-4xl text-white font-bold">
                            {(callerName || '86BIT').charAt(0).toUpperCase()}
                        </span>
                    </div>
                    
                    {/* Info chiamante */}
                    <p className="text-gray-400 text-sm mb-1">Videochiamata in arrivo</p>
                    <h2 className="text-white text-2xl font-bold mb-2">{callerName || '86BIT Support'}</h2>
                    <p className="text-gray-500 text-sm">Supporto Tecnico</p>
                    
                    {/* Indicatore di chiamata */}
                    {isRinging && (
                        <div className="flex items-center justify-center gap-1 mt-4">
                            <span className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{animationDelay: '0ms'}}></span>
                            <span className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{animationDelay: '150ms'}}></span>
                            <span className="w-2 h-2 bg-green-500 rounded-full animate-bounce" style={{animationDelay: '300ms'}}></span>
                        </div>
                    )}
                </div>
                
                {/* Pulsanti azione */}
                <div className="p-6 flex justify-center gap-8">
                    {/* Rifiuta */}
                    <button
                        onClick={onDecline}
                        className="w-16 h-16 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center shadow-lg shadow-red-500/30 transition-all active:scale-95"
                    >
                        <Phone className="h-7 w-7 text-white transform rotate-[135deg]" />
                    </button>
                    
                    {/* Rispondi */}
                    <button
                        onClick={handleAnswer}
                        className="w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center shadow-lg shadow-green-500/30 transition-all active:scale-95"
                    >
                        <Video className="h-7 w-7 text-white" />
                    </button>
                </div>
                
                {/* Footer */}
                <div className="px-6 pb-6 text-center">
                    <p className="text-gray-500 text-xs">
                        Tocca 📹 per rispondere alla videochiamata
                    </p>
                </div>
            </div>
        </div>
    );
};

// Funzione per verificare se il dispositivo può fare chiamate
const canMakePhoneCalls = () => {
    // Su mobile è quasi sempre possibile
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobileDevice) return true;
    
    // Su desktop, verifica se c'è un protocollo tel: registrato (difficile da rilevare)
    // Per sicurezza, su desktop mostriamo sempre il modal
    return false;
};

const EndChatModal = ({ onClose }) => {
    const { state } = useContext(ChatContext);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-lg text-center animate-scale-in">
                <h2 className="text-xl font-bold mb-4 text-gray-800">Grazie per aver usato Spark!</h2>
                <p className="text-gray-700 mb-6">Grazie, {state.userName || 'Utente'}. 86BIT è sempre al tuo fianco.</p>
                <a href="https://www.google.com/search?q=86BIT+Recensioni" target="_blank" rel="noopener noreferrer" className="inline-block bg-yellow-500 text-white px-6 py-3 rounded-lg font-bold hover:bg-yellow-600 mb-4">Lascia una recensione</a>
                <button onClick={onClose} className="block w-full bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300">Chiudi</button>
            </div>
        </div>
    );
};

// 🎫 Popup guida "Registrazione all'assistenza" (riutilizzabile).
// Mostra le istruzioni per farsi registrare via Outlook Web e permette di ricontrollare.
const JiraRegisterGuideModal = ({ email, userName = '', company = '', pcName = '', onClose, onResult }) => {
    const clean = (email || '').trim().toLowerCase();
    const [checking, setChecking] = useState(false);
    const [notYet, setNotYet] = useState(false);

    const owaHref = (() => {
        const bodyLines = [
            'Salve,',
            "richiedo la registrazione del mio indirizzo email per l'assistenza IT 86BIT (Spark).",
            '',
            `Email: ${clean}`,
            userName ? `Nome: ${userName}` : '',
            company ? `Azienda: ${company}` : '',
            pcName ? `PC: ${pcName}` : '',
            '',
            'Grazie.'
        ].filter(Boolean);
        const enc = encodeURIComponent;
        return `https://outlook.office.com/mail/deeplink/compose?to=assistenza@86bit.it&subject=${enc('Registrazione')}&body=${enc(bodyLines.join('\n'))}`;
    })();

    const recheck = async () => {
        setChecking(true);
        setNotYet(false);
        try {
            const res = await fetch(`${API_BASE_URL}/api/v1/jira/check-user?email=${encodeURIComponent(clean)}`, {
                headers: getAuthHeaders()
            });
            const data = await res.json();
            if (data.is_jira_user) {
                if (onResult) onResult(true);
                if (onClose) onClose();
            } else {
                setNotYet(true);
            }
        } catch (e) {
            setNotYet(true);
        } finally {
            setChecking(false);
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[80] animate-fade-in"
            onClick={(e) => { e.stopPropagation(); if (onClose) onClose(); }}
        >
            <div
                data-testid="jira-register-guide-modal"
                className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-scale-in"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 rounded-t-2xl flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Mail className="h-5 w-5 text-white" />
                        <h3 className="text-white font-bold text-lg">Registrazione all'assistenza</h3>
                    </div>
                    <button type="button" onClick={() => onClose && onClose()} className="p-1 rounded-full hover:bg-white/20 text-white">
                        <XCircle className="h-5 w-5" />
                    </button>
                </div>
                <div className="p-5 space-y-4">
                    <p className="text-sm text-gray-600">
                        La tua email <strong className="text-gray-800 break-all">{clean}</strong> non risulta ancora registrata al nostro sistema di assistenza.
                        Per aprire e seguire i tuoi ticket, invia una email <strong>dal tuo indirizzo</strong>:
                    </p>
                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-2 text-sm">
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-gray-500">Destinatario</span>
                            <span className="font-medium text-gray-800">assistenza@86bit.it</span>
                        </div>
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-gray-500">Oggetto</span>
                            <span className="font-medium text-gray-800">Registrazione</span>
                        </div>
                    </div>
                    <a
                        href={owaHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="jira-register-owa"
                        className="flex items-center justify-center gap-2 w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl transition-colors no-underline"
                    >
                        <Mail className="h-4 w-4" /> Apri Outlook Web (365)
                    </a>
                    <p className="text-xs text-gray-500 leading-relaxed">
                        Si aprirà Outlook sul Web con il messaggio già pronto: controlla e premi <strong>Invia</strong>.<br />
                        Se non si apre, accedi a <strong>outlook.office.com</strong>, crea un <strong>Nuovo messaggio</strong> a
                        <strong> assistenza@86bit.it</strong> con oggetto <strong>Registrazione</strong> e invialo.
                    </p>
                    {notYet && (
                        <p data-testid="jira-register-notyet" className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-2 py-1.5 flex items-center gap-1.5">
                            <Info className="h-3.5 w-3.5 shrink-0" /> Ancora non risulti registrato. Attendi che il team completi la registrazione e riprova.
                        </p>
                    )}
                    <button
                        type="button"
                        data-testid="jira-register-recheck"
                        disabled={checking}
                        onClick={recheck}
                        className="flex items-center justify-center gap-2 w-full border-2 border-blue-600 text-blue-700 hover:bg-blue-50 font-semibold py-2.5 rounded-xl transition-colors disabled:opacity-60"
                    >
                        <RefreshCw className={`h-4 w-4 ${checking ? 'animate-spin' : ''}`} /> {checking ? 'Verifica…' : 'Ho inviato — Ricontrolla'}
                    </button>
                    <button
                        type="button"
                        data-testid="jira-register-later"
                        onClick={() => onClose && onClose()}
                        className="w-full text-gray-500 hover:text-gray-700 text-sm font-medium py-1"
                    >
                        Più tardi
                    </button>
                </div>
            </div>
        </div>
    );
};


// 🎫 Indicatore stato Jira: mostra se l'email è registrata come utente Jira.
// Se NON registrata, offre la guida per richiedere la registrazione + ricontrollo.
// Usato sotto il campo Email (onboarding + Impostazioni).
const JiraEmailStatus = ({ email, userName = '', company = '' }) => {
    const [status, setStatus] = useState('idle'); // idle | checking | registered | not_registered | error
    const [showGuide, setShowGuide] = useState(false);
    const [justRegistered, setJustRegistered] = useState(false);
    const debounceRef = useRef(null);
    const clean = (email || '').trim().toLowerCase();
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean);

    const runCheck = useCallback(async () => {
        if (!isValid) { setStatus('idle'); return; }
        setStatus('checking');
        try {
            const res = await fetch(`${API_BASE_URL}/api/v1/jira/check-user?email=${encodeURIComponent(clean)}`, {
                headers: getAuthHeaders()
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            setStatus(data.is_jira_user ? 'registered' : 'not_registered');
        } catch (e) {
            setStatus('error');
        }
    }, [clean, isValid]);

    useEffect(() => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        if (!isValid) { setStatus('idle'); return; }
        setStatus('checking');
        debounceRef.current = setTimeout(() => { runCheck(); }, 600);
        return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
    }, [clean, isValid, runCheck]);

    const config = {
        checking: { icon: Loader2, cls: 'text-gray-500 bg-gray-50 border-gray-200', spin: true, text: 'Verifica su Jira in corso…' },
        registered: { icon: CheckCircle, cls: 'text-green-700 bg-green-50 border-green-200', spin: false, text: 'Email registrata in Jira' },
        not_registered: { icon: Info, cls: 'text-amber-700 bg-amber-50 border-amber-200', spin: false, text: 'Email non registrata in Jira' },
        error: { icon: AlertTriangle, cls: 'text-gray-500 bg-gray-50 border-gray-200', spin: false, text: 'Impossibile verificare ora' },
    }[status] || null;

    const isSuccess = status === 'registered' && justRegistered;
    const BadgeIcon = isSuccess ? CheckCircle2 : (config ? config.icon : Info);
    const badgeCls = isSuccess ? 'text-green-800 bg-green-100 border-green-300' : (config ? config.cls : '');
    const badgeText = isSuccess ? 'Registrazione completata!' : (config ? config.text : '');
    const badgeTestId = isSuccess ? 'jira-register-success' : `jira-email-status-${status}`;

    return (
        <>
            {status !== 'idle' && config && (
                <div
                    data-testid={badgeTestId}
                    className={`mt-1.5 flex items-center gap-1.5 text-xs font-medium px-2 py-1 rounded-md border ${badgeCls}`}
                >
                    <BadgeIcon className={`h-3.5 w-3.5 shrink-0 ${config.spin ? 'animate-spin' : ''}`} />
                    <span>{badgeText}</span>
                    {status === 'not_registered' && (
                        <button
                            type="button"
                            data-testid="jira-register-guide-btn"
                            onClick={(e) => { e.stopPropagation(); setShowGuide(true); }}
                            className="ml-auto text-amber-800 underline underline-offset-2 hover:text-amber-900 font-semibold"
                        >
                            Registrati
                        </button>
                    )}
                </div>
            )}

            {showGuide && (
                <JiraRegisterGuideModal
                    email={clean}
                    userName={userName}
                    company={company}
                    onClose={() => setShowGuide(false)}
                    onResult={(reg) => {
                        if (reg) {
                            setStatus('registered');
                            setJustRegistered(true);
                            setTimeout(() => setJustRegistered(false), 6000);
                        }
                    }}
                />
            )}
        </>
    );
};


// 🔔 Badge "Notifiche attive": rassicura l'utente che riceverà gli aggiornamenti
// dei ticket anche ad app/browser chiuso, quando le push sono abilitate.
const PushActiveBadge = () => {
    const { state } = useContext(ChatContext);
    const [dismissed, setDismissed] = useState(() => {
        try { return localStorage.getItem('spark-push-badge-dismissed') === '1'; } catch { return false; }
    });
    if (state.notificationStatus !== 'granted' || dismissed) return null;
    return (
        <div data-testid="push-active-badge" className="flex-shrink-0 px-3 py-1.5 bg-green-50 border-b border-green-200 flex items-center gap-2 text-green-700">
            <BellRing className="h-4 w-4 shrink-0" />
            <span className="text-xs sm:text-sm font-medium flex-1">Notifiche attive — riceverai gli aggiornamenti dei ticket anche ad app chiusa.</span>
            <button
                type="button"
                data-testid="push-active-badge-close"
                onClick={() => { setDismissed(true); try { localStorage.setItem('spark-push-badge-dismissed', '1'); } catch (e) {} }}
                className="p-1 rounded-full hover:bg-green-100 shrink-0"
                title="Nascondi"
            >
                <X className="h-3.5 w-3.5" />
            </button>
        </div>
    );
};


// 🎫 Banner promemoria: invita a completare la registrazione finché l'utente
// non risulta registrato in Jira. Fisso in cima alla chat, non invadente.
const JiraRegistrationBanner = () => {
    const { state, dispatch } = useContext(ChatContext);
    const [showGuide, setShowGuide] = useState(false);
    if (state.jiraRegistered !== false) return null;
    const email = state.userEmail || (typeof localStorage !== 'undefined' ? localStorage.getItem('spark-user-email-v1') : '') || '';
    return (
        <div data-testid="jira-reg-banner" className="flex-shrink-0 px-3 py-2 bg-amber-50 border-b border-amber-200 flex items-center gap-2 text-amber-800">
            <Info className="h-4 w-4 shrink-0" />
            <span className="text-xs sm:text-sm font-medium flex-1">Completa la registrazione per aprire e seguire i tuoi ticket.</span>
            <button
                type="button"
                data-testid="jira-reg-banner-btn"
                onClick={() => setShowGuide(true)}
                className="text-xs sm:text-sm font-semibold bg-amber-500 hover:bg-amber-600 text-white px-3 py-1 rounded-md transition-colors shrink-0"
            >
                Registrati
            </button>
            {showGuide && (
                <JiraRegisterGuideModal
                    email={email}
                    userName={state.userName}
                    company={state.userSiteName || state.userCompany || ''}
                    pcName={state.userComputer}
                    onClose={() => setShowGuide(false)}
                    onResult={(reg) => { if (reg) dispatch({ type: 'SET_STATE', payload: { jiraRegistered: true } }); }}
                />
            )}
        </div>
    );
};


// Banner in home: rimosso (riferimenti al portale eliminati)
const UnreadTicketsBanner = () => null;


// 📘 Mini-tutorial illustrato: come creare la password sul portale e trovare "Le mie richieste"
const PORTAL_TUTORIAL_URL = 'https://customer.helpdesk.86bit.it/servicedesk/customer/portal/3';
const PortalTutorialModal = ({ onClose }) => {
    const [step, setStep] = useState(0);
    const total = 3;
    const goPortal = () => {
        try { localStorage.setItem('spark-portal-tutorial-seen-v1', '1'); } catch (e) {}
        window.open(PORTAL_TUTORIAL_URL, '_blank', 'noopener,noreferrer');
        if (onClose) onClose();
    };
    const Frame = ({ children }) => (
        <div className="rounded-lg overflow-hidden border border-gray-300 shadow-sm bg-white">
            <div className="flex items-center gap-1.5 px-2 py-1.5 bg-gray-100 border-b border-gray-200">
                <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
                <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
                <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
                <span className="ml-2 flex-1 truncate text-[10px] text-gray-500 bg-white rounded px-2 py-0.5 border border-gray-200">customer.helpdesk.86bit.it</span>
            </div>
            <div className="p-3 bg-gray-50">{children}</div>
        </div>
    );
    const steps = [
        {
            title: '1. Crea la tua password',
            desc: 'Inserisci la tua email aziendale e clicca "Crea una password": riceverai una email per impostarla.',
            visual: (
                <Frame>
                    <div className="space-y-2">
                        <div className="text-xs font-semibold text-gray-700">Accedi al Centro assistenza</div>
                        <div className="text-[10px] text-gray-500">Email</div>
                        <div className="h-6 rounded border border-gray-300 bg-white flex items-center px-2 text-[10px] text-gray-700">nome.cognome@azienda.it</div>
                        <div className="inline-flex items-center mt-1 text-[10px] font-bold text-blue-700 ring-2 ring-blue-400 rounded px-2 py-1 bg-blue-50">Crea una password</div>
                    </div>
                </Frame>
            )
        },
        {
            title: '2. Accedi e resta connesso',
            desc: 'Imposta la password, accedi e spunta "Ricordami". Salva la password nel browser: entrerai sempre in automatico.',
            visual: (
                <Frame>
                    <div className="space-y-2">
                        <div className="text-[10px] text-gray-500">Password</div>
                        <div className="h-6 rounded border border-gray-300 bg-white flex items-center px-2 text-[10px] text-gray-400">••••••••</div>
                        <div className="flex items-center gap-1.5 mt-1 ring-2 ring-blue-400 rounded px-2 py-1 bg-blue-50 w-max">
                            <span className="w-3.5 h-3.5 rounded border border-blue-600 bg-blue-600 text-white text-[9px] flex items-center justify-center">✓</span>
                            <span className="text-[10px] font-semibold text-blue-700">Ricordami</span>
                        </div>
                        <div className="h-6 rounded bg-blue-600 text-white text-[10px] font-semibold flex items-center justify-center mt-1">Accedi</div>
                    </div>
                </Frame>
            )
        },
        {
            title: '3. Apri "Le mie richieste"',
            desc: 'Una volta dentro, clicca in alto a destra sul tuo profilo e scegli "Richieste": lì trovi tutti i tuoi ticket per rispondere.',
            visual: (
                <Frame>
                    <div className="space-y-2">
                        <div className="flex items-center justify-between">
                            <div className="text-[10px] font-semibold text-gray-700">Centro assistenza</div>
                            <div className="w-5 h-5 rounded-full bg-blue-500 text-white text-[9px] flex items-center justify-center">DU</div>
                        </div>
                        <div className="ml-auto w-32 rounded border border-gray-200 bg-white shadow-sm text-[10px] overflow-hidden">
                            <div className="px-2 py-1 text-gray-600">Profilo</div>
                            <div className="px-2 py-1 font-bold text-blue-700 bg-blue-50 ring-2 ring-blue-400">Richieste</div>
                            <div className="px-2 py-1 text-gray-600">Esci</div>
                        </div>
                    </div>
                </Frame>
            )
        }
    ];
    const s = steps[step];
    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-[90] animate-fade-in" onClick={(e) => { e.stopPropagation(); onClose && onClose(); }}>
            <div data-testid="portal-tutorial-modal" className="bg-white rounded-2xl shadow-2xl w-full max-w-sm animate-scale-in" onClick={(e) => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 rounded-t-2xl flex items-center justify-between">
                    <div className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-white" /><h3 className="text-white font-bold">Come registrarti al portale</h3></div>
                    <button type="button" onClick={() => onClose && onClose()} className="p-1 rounded-full hover:bg-white/20 text-white" data-testid="portal-tutorial-close"><X className="h-5 w-5" /></button>
                </div>
                <div className="p-5">
                    {s.visual}
                    <h4 className="mt-3 font-bold text-gray-800 text-sm">{s.title}</h4>
                    <p className="mt-1 text-sm text-gray-600 leading-relaxed">{s.desc}</p>
                    <div className="flex items-center justify-center gap-1.5 mt-3">
                        {steps.map((_, i) => (<span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-5 bg-blue-600' : 'w-1.5 bg-gray-300'}`} />))}
                    </div>
                    <div className="flex items-center gap-2 mt-4">
                        {step > 0 && <button type="button" data-testid="portal-tutorial-prev" onClick={() => setStep(step - 1)} className="px-3 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100">Indietro</button>}
                        {step < total - 1
                            ? <button type="button" data-testid="portal-tutorial-next" onClick={() => setStep(step + 1)} className="ml-auto px-4 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-500 text-white">Avanti</button>
                            : <button type="button" data-testid="portal-tutorial-go" onClick={goPortal} className="ml-auto flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-green-600 hover:bg-green-500 text-white"><ExternalLink className="h-4 w-4" /> Vai al portale</button>}
                    </div>
                </div>
            </div>
        </div>
    );
};


const UserDashboard = ({ onClose, onShowShortcuts }) => {
    const { state, dispatch, actions } = useContext(ChatContext);
    const [details, setDetails] = useState({ 
        userName: state.userName, 
        userCompany: state.userSiteName || state.userCompany || '', // Usa userSiteName (da RMM) prima di userCompany
        userComputer: state.userComputer,
        userEmail: state.userEmail || '',
        userPhone: state.userPhone || '',
        userPCHardwareType: state.userPCHardwareType || null,
        userConnectionType: state.userConnectionType || null
    });
    const [prefs, setPrefs] = useState(state.preferences || { responseStyle: 'detailed', silentMode: false });
    const [notifStatus, setNotifStatus] = useState(state.notificationStatus);

    const handleSave = () => {
        // Salva email in localStorage
        if (details.userEmail) {
            try {
                localStorage.setItem('spark-user-email-v1', details.userEmail.trim().toLowerCase());
                localStorage.setItem('spark-user-email', details.userEmail.trim().toLowerCase());
            } catch (e) {
                console.error('Errore salvataggio email:', e);
            }
        }
        
        // Salva anche l'azienda in entrambi i campi per consistenza
        const updatePayload = {
            ...details,
            userSiteName: details.userCompany, // Sincronizza userSiteName con userCompany
            preferences: prefs
        };
        
        // Salva dettagli utente in localStorage
        try {
            const savedDetails = localStorage.getItem('spark-user-details-v4');
            const detailsMap = savedDetails ? JSON.parse(savedDetails) : {};
            const userKey = state.userName?.toLowerCase().replace(/[.\s]/g, '_') || 'unknown';
            
            detailsMap[userKey] = {
                ...detailsMap[userKey],
                email: details.userEmail?.trim().toLowerCase() || '',
                phone: (details.userPhone || '').trim(),
                company: details.userCompany || '',
                computer: details.userComputer || '',
                hardwareType: details.userPCHardwareType || '',
                connectionType: details.userConnectionType || '',
                lastSeen: new Date().toISOString()
            };
            
            localStorage.setItem('spark-user-details-v4', JSON.stringify(detailsMap));
            console.log('[SAVE] Dettagli utente salvati:', detailsMap[userKey]);
        } catch (e) {
            console.error('Errore salvataggio dettagli:', e);
        }
        
        dispatch({ type: 'SET_STATE', payload: updatePayload });
        onClose();
    };

    const handleToggleNotifications = async () => {
        if (notifStatus === 'granted') {
            alert('Per disattivare le notifiche, vai nelle impostazioni del browser.');
            return;
        }
        const result = await actions.handleEnableNotifications();
        if (result.success) {
            setNotifStatus('granted');
        }
    };

    const handleResetSpark = () => {
        if (window.confirm('Sei sicuro di voler resettare Spark? Tutti i dati verranno cancellati.')) {
            dispatch({ type: 'RESET_SESSION' });
            onClose();
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-stretch md:items-center justify-center md:p-4 z-50 animate-fade-in" onClick={onClose}>
            <div className="bg-white md:rounded-2xl shadow-2xl w-full md:max-w-5xl animate-scale-in flex flex-col h-[100dvh] md:h-auto md:max-h-[90vh] overflow-hidden" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-3 md:p-4 md:rounded-t-2xl flex justify-between items-center flex-shrink-0 z-10" style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top))' }}>
                    <div className="flex items-center gap-2 md:gap-3">
                        <Settings className="h-5 w-5 md:h-6 md:w-6 text-white" />
                        <h2 className="text-lg md:text-xl font-bold text-white">Impostazioni</h2>
                    </div>
                    <button onClick={onClose} data-testid="settings-close-btn" className="p-1.5 rounded-full hover:bg-white/20 text-white">
                        <XCircle className="h-5 w-5 md:h-6 md:w-6" />
                    </button>
                </div>

                {/* Content - Three columns on desktop */}
                <div className="p-4 md:p-5 overflow-y-auto flex-1 min-h-0">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        
                        {/* LEFT COLUMN - User Data */}
                        <div className="space-y-3">
                            <div className="bg-gray-50 rounded-xl p-3">
                                <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                    <User className="h-4 w-4" />
                                    Dati Utente
                                </h3>
                                <div className="space-y-2">
                                    <div>
                                        <label className="block text-xs font-medium text-gray-500 mb-1">Nome</label>
                                        <input 
                                            type="text" 
                                            value={details.userName} 
                                            onChange={(e) => setDetails({ ...details, userName: e.target.value })} 
                                            className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" 
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-500 mb-1">Azienda</label>
                                        <input 
                                            type="text" 
                                            value={details.userCompany} 
                                            onChange={(e) => setDetails({ ...details, userCompany: e.target.value })} 
                                            className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" 
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-500 mb-1">Nome PC</label>
                                        <input 
                                            type="text" 
                                            value={details.userComputer} 
                                            onChange={(e) => setDetails({ ...details, userComputer: e.target.value })} 
                                            className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" 
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-500 mb-1">
                                            Email <span className="text-red-500">*</span>
                                        </label>
                                        <input 
                                            type="email" 
                                            value={details.userEmail || ''} 
                                            onChange={(e) => setDetails({ ...details, userEmail: e.target.value })} 
                                            placeholder="es. mario.rossi@azienda.it"
                                            className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" 
                                        />
                                        <JiraEmailStatus email={details.userEmail} userName={details.userName} company={details.userCompany} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-500 mb-1">
                                            Telefono <span className="text-gray-400 font-normal">(per contatto)</span>
                                        </label>
                                        <input 
                                            type="tel" 
                                            value={details.userPhone || ''} 
                                            onChange={(e) => setDetails({ ...details, userPhone: e.target.value })} 
                                            placeholder="es. 333 1234567 oppure 0123 456789 int. 42"
                                            data-testid="settings-phone-input"
                                            className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" 
                                        />
                                        <p className="text-[11px] text-gray-400 mt-1">Cellulare o numero azienda con eventuale interno. Serve al tecnico per ricontattarti.</p>
                                    </div>
                                </div>
                            </div>

                            {/* Device & Network */}
                            <div className="hidden md:block bg-gray-50 rounded-xl p-3">
                                <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                    <Monitor className="h-4 w-4" />
                                    Dispositivo
                                </h3>
                                <div className="space-y-2">
                                    <div className="grid grid-cols-2 gap-2">
                                        <button
                                            type="button"
                                            onClick={() => setDetails({ ...details, userPCHardwareType: 'notebook' })}
                                            className={`p-2 border-2 rounded-lg text-xs font-medium transition-all flex items-center justify-center gap-1 ${
                                                details.userPCHardwareType === 'notebook' 
                                                    ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <Laptop className="h-3 w-3" />
                                            Notebook
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setDetails({ ...details, userPCHardwareType: 'fisso' })}
                                            className={`p-2 border-2 rounded-lg text-xs font-medium transition-all flex items-center justify-center gap-1 ${
                                                details.userPCHardwareType === 'fisso' 
                                                    ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <Monitor className="h-3 w-3" />
                                            Fisso
                                        </button>
                                    </div>
                                    <div className="grid grid-cols-2 gap-2">
                                        <button
                                            type="button"
                                            onClick={() => setDetails({ ...details, userConnectionType: 'Wi-Fi' })}
                                            className={`p-2 border-2 rounded-lg text-xs font-medium transition-all flex items-center justify-center gap-1 ${
                                                details.userConnectionType === 'Wi-Fi' 
                                                    ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <Wifi className="h-3 w-3" />
                                            Wi-Fi
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setDetails({ ...details, userConnectionType: 'LAN' })}
                                            className={`p-2 border-2 rounded-lg text-xs font-medium transition-all flex items-center justify-center gap-1 ${
                                                details.userConnectionType === 'LAN' 
                                                    ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            <PlugZap className="h-3 w-3" />
                                            LAN
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* MIDDLE COLUMN - Preferences */}
                        <div className="space-y-3">
                            {/* Communication Preferences */}
                            <div className="hidden md:block bg-gray-50 rounded-xl p-3">
                                <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                    <MessageSquare className="h-4 w-4" />
                                    Comunicazione
                                </h3>
                                <div className="space-y-2">
                                    <div className="grid grid-cols-2 gap-2">
                                        <button
                                            type="button"
                                            onClick={() => setPrefs({ ...prefs, responseStyle: 'detailed' })}
                                            className={`p-2 border-2 rounded-lg text-xs font-medium transition-all ${
                                                prefs.responseStyle === 'detailed' 
                                                    ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            📖 Dettagliato
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => setPrefs({ ...prefs, responseStyle: 'direct' })}
                                            className={`p-2 border-2 rounded-lg text-xs font-medium transition-all ${
                                                prefs.responseStyle === 'direct' 
                                                    ? 'border-blue-500 bg-blue-50 text-blue-700' 
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            ⚡ Diretto
                                        </button>
                                    </div>
                                    <div className="flex items-center justify-between p-2 bg-white rounded-lg border border-gray-200">
                                        <div className="flex items-center gap-2">
                                            <VolumeX className="h-3 w-3 text-gray-500" />
                                            <span className="text-xs text-gray-700">Silenzioso</span>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => setPrefs({ ...prefs, silentMode: !prefs.silentMode })}
                                            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
                                                prefs.silentMode ? 'bg-blue-600' : 'bg-gray-300'
                                            }`}
                                        >
                                            <span className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
                                                prefs.silentMode ? 'translate-x-5' : 'translate-x-1'
                                            }`} />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Notifications */}
                            <div className="bg-gray-50 rounded-xl p-3">
                                <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                    <Bell className="h-4 w-4" />
                                    Notifiche
                                </h3>
                                <button
                                    onClick={handleToggleNotifications}
                                    className={`w-full p-2 rounded-lg flex items-center justify-center gap-2 text-xs font-medium transition-all ${
                                        notifStatus === 'granted' 
                                            ? 'bg-green-100 text-green-700 border border-green-200' 
                                            : notifStatus === 'denied'
                                                ? 'bg-gray-100 text-gray-500 border border-gray-200'
                                                : 'bg-blue-100 text-blue-700 border border-blue-200 hover:bg-blue-200'
                                    }`}
                                >
                                    {notifStatus === 'granted' ? (
                                        <><BellRing className="h-4 w-4" /> Attive</>
                                    ) : notifStatus === 'denied' ? (
                                        <><BellOff className="h-4 w-4" /> Bloccate</>
                                    ) : (
                                        <><Bell className="h-4 w-4" /> Attiva</>
                                    )}
                                </button>
                            </div>

                            {/* Shortcuts */}
                            <div className="bg-indigo-50 rounded-xl p-3 border border-indigo-100">
                                <h3 className="text-xs font-bold text-indigo-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                    <Keyboard className="h-4 w-4" />
                                    Shortcuts
                                </h3>
                                <button
                                    onClick={() => { if (onShowShortcuts) onShowShortcuts(); }}
                                    className="w-full p-2 bg-white border border-indigo-200 rounded-lg text-indigo-600 text-xs font-medium flex items-center justify-center gap-2 hover:bg-indigo-50 transition-all"
                                >
                                    <Keyboard className="h-4 w-4" />
                                    Visualizza
                                </button>
                            </div>

                            {/* Reset - solo desktop */}
                            {!state.isMobile && (
                            <div className="bg-red-50 rounded-xl p-3 border border-red-100">
                                <h3 className="text-xs font-bold text-red-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                    <AlertTriangle className="h-4 w-4" />
                                    Reset
                                </h3>
                                <button
                                    onClick={handleResetSpark}
                                    className="w-full p-2 bg-white border border-red-200 rounded-lg text-red-600 text-xs font-medium flex items-center justify-center gap-2 hover:bg-red-50 transition-all"
                                >
                                    <Trash2 className="h-4 w-4" />
                                    Resetta
                                </button>
                            </div>
                            )}
                        </div>

                        {/* RIGHT COLUMN - Favorites / Aggiungi alla Home */}
                        <div className="space-y-3">
                            <div className="bg-yellow-50 rounded-xl p-3 border border-yellow-100">
                                <h3 className="text-xs font-bold text-yellow-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                    <Star className="h-4 w-4" />
                                    {state.isMobile ? 'Installa app' : 'Preferiti'}
                                </h3>
                                {state.isMobile ? (
                                    <InstallAppButton />
                                ) : (
                                    <div className="space-y-2">
                                        <a 
                                            href={window.location.origin}
                                            className="w-full p-2.5 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-lg text-white text-xs font-bold flex items-center justify-center gap-2 cursor-grab active:cursor-grabbing shadow-md hover:shadow-lg transition-all"
                                            draggable="true"
                                            data-allow-drag="true"
                                            data-testid="favorite-drag-link"
                                            title="Trascina sulla barra dei preferiti"
                                            onClick={(e) => e.preventDefault()}
                                            onDragStart={(e) => {
                                                const url = window.location.origin;
                                                e.dataTransfer.setData('text/uri-list', url);
                                                e.dataTransfer.setData('text/plain', url);
                                                e.dataTransfer.setData('text/x-moz-url', `${url}\nSpark 86BIT`);
                                                e.dataTransfer.effectAllowed = 'copyLink';
                                            }}
                                        >
                                            <Star className="h-4 w-4" />
                                            ⚡ Spark 86BIT
                                        </a>
                                        <p className="text-xs text-yellow-700 text-center">
                                            👆 Trascina sulla barra preferiti
                                        </p>
                                        <div className="flex items-center justify-center gap-1 text-xs text-gray-500">
                                            <span>o premi</span>
                                            <kbd className="px-1.5 py-0.5 bg-gray-100 rounded text-gray-700 font-mono text-xs border">Ctrl+D</kbd>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Footer with Save Button */}
                    <div className="mt-4 flex gap-3 sticky bottom-0 bg-white pt-3 pb-2 -mx-4 px-4 md:static md:mx-0 md:px-0 md:pt-0 md:pb-0 border-t md:border-t-0" style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}>
                        <button 
                            onClick={onClose}
                            className="flex-1 py-2.5 px-4 border border-gray-200 rounded-xl text-gray-600 font-medium hover:bg-gray-50 transition-all text-sm"
                        >
                            Annulla
                        </button>
                        <button 
                            onClick={handleSave} 
                            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2.5 px-4 rounded-xl font-bold hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg shadow-blue-200 text-sm"
                        >
                            💾 Salva
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Analizza un percorso Windows e produce consigli CONCRETI leggendo il contenuto reale.
const PATH_STOPWORDS = ['versione', 'version', 'ver', 'definitiva', 'definitivo', 'def', 'finale', 'final', 'ultima', 'ultimo', 'copia', 'copy', 'rivista', 'rivisto', 'corretta', 'corretto', 'nuova', 'nuovo', 'vecchia', 'vecchio', 'backup', 'bkp', 'revisione', 'rev', 'aggiornata', 'aggiornato', 'modificata', 'modificato', 'provvisorio', 'bozza', 'draft'];
const analyzeWindowsPath = (raw) => {
    const LIMIT = 260;
    const path = (raw || '').trim();
    const len = path.length;
    const parts = path.split(/[\\/]+/).filter(Boolean);
    const hasDrive = /^[A-Za-z]:$/.test(parts[0] || '');
    const drive = hasDrive ? parts[0] : null;
    const segs = hasDrive ? parts.slice(1) : parts;
    const looksFile = /\.[A-Za-z0-9]{1,6}$/.test(segs[segs.length - 1] || '');
    const fileName = looksFile ? segs[segs.length - 1] : '';
    const folders = looksFile ? segs.slice(0, -1) : segs;
    const depth = folders.length;

    // nome file "pulito" (rimuove parole ridondanti)
    const cleanFile = (fn) => {
        const dot = fn.lastIndexOf('.');
        const base = dot > 0 ? fn.slice(0, dot) : fn;
        const ext = dot > 0 ? fn.slice(dot) : '';
        const kept = base.split(/[ _\-.]+/).filter(t => t && !PATH_STOPWORDS.includes(t.toLowerCase()));
        const rebuilt = (kept.length ? kept.join('_') : base).replace(/_{2,}/g, '_');
        return rebuilt + ext;
    };

    const tips = [];
    if (len >= LIMIT) tips.push({ type: 'crit', text: `Devi togliere almeno ${len - LIMIT + 1} caratteri per rientrare sotto i ${LIMIT}.` });

    // Escludi la cartella radice di OneDrive/SharePoint: non è rinominabile dall'utente
    const isCloudRoot = (f) => /onedrive|sharepoint/i.test(f);
    const editableFolders = folders.filter(f => !isCloudRoot(f));

    // cartella (modificabile) più lunga
    if (editableFolders.length) {
        const longest = editableFolders.reduce((a, b) => (b.length > a.length ? b : a), '');
        if (longest.length >= 20) tips.push({ type: 'info', text: `La cartella più lunga è «${longest}» (${longest.length} caratteri): un nome più breve libera spazio prezioso.` });
    }

    // nome file lungo / ridondante
    if (fileName) {
        const short = cleanFile(fileName);
        if (fileName.length >= 30 || short.length < fileName.length) {
            const saved = fileName.length - short.length;
            if (saved > 0) tips.push({ type: 'info', text: `Il nome file «${fileName}» (${fileName.length} car.) può diventare «${short}»: risparmi ${saved} caratteri.` });
            else tips.push({ type: 'info', text: `Il nome file «${fileName}» è lungo ${fileName.length} caratteri: valuta un nome più breve.` });
        }
    }

    // CARTELLE (modificabili) con spazi
    const foldersWithSpaces = editableFolders.filter(f => /\s/.test(f));
    if (foldersWithSpaces.length) {
        const shown = foldersWithSpaces.slice(0, 3).map(f => `«${f}»`).join(', ');
        const more = foldersWithSpaces.length > 3 ? ` e altre ${foldersWithSpaces.length - 3}` : '';
        tips.push({ type: 'info', text: `Cartelle con spazi nel nome: ${shown}${more}. Rimuovi gli spazi o sostituiscili con «_» (es. «${foldersWithSpaces[0].replace(/\s+/g, '_')}»): accorci il percorso ed eviti errori con alcuni programmi.` });
    }

    // FILE con spazi
    if (fileName && /\s/.test(fileName)) {
        tips.push({ type: 'info', text: `Il nome del file contiene spazi («${fileName}»): rimuovili o sostituiscili con «_» (es. «${fileName.replace(/\s+/g, '_')}»).` });
    }

    // annidamento
    if (depth >= 6) tips.push({ type: 'info', text: `Il percorso ha ${depth} livelli di cartelle: dove possibile riducili accorpando le sottocartelle.` });

    return { len, LIMIT, depth, folders, fileName, drive, tips };
};


const WIN_SHORTCUTS = [
    { keys: ['Win', 'E'], fn: 'Apri Esplora file' },
    { keys: ['Win', 'I'], fn: 'Apri Impostazioni' },
    { keys: ['Win', 'D'], fn: 'Mostra / Nascondi il desktop' },
    { keys: ['Win', 'L'], fn: 'Blocca il PC' },
    { keys: ['Win', 'R'], fn: 'Esegui (apri comando)' },
    { keys: ['Win', 'X'], fn: 'Menu utente avanzato' },
    { keys: ['Win', '.'], fn: 'Tastiera emoji' },
    { keys: ['Win', 'V'], fn: 'Cronologia degli appunti' },
    { keys: ['Win', 'H'], fn: 'Digitazione vocale' },
    { keys: ['Win', 'G'], fn: 'Xbox Game Bar' },
    { keys: ['Win', 'Tab'], fn: 'Vista attività' },
    { keys: ['Win', 'M'], fn: 'Riduci a icona tutte le finestre' },
    { keys: ['Win', '↑'], fn: 'Ingrandisci la finestra' },
    { keys: ['Win', '↓'], fn: 'Riduci a icona la finestra' },
    { keys: ['Win', '←'], fn: 'Affianca la finestra a sinistra' },
    { keys: ['Win', '→'], fn: 'Affianca la finestra a destra' },
    { keys: ['Win', 'Shift', 'S'], fn: 'Cattura schermo (Strumento di cattura)' },
    { keys: ['Win', 'Ctrl', 'D'], fn: 'Nuovo desktop virtuale' },
    { keys: ['Win', 'Ctrl', '←'], fn: 'Desktop virtuale precedente' },
    { keys: ['Win', 'Ctrl', '→'], fn: 'Desktop virtuale successivo' },
    { keys: ['Ctrl', 'Win', 'O'], fn: 'Tastiera su schermo' },
    { keys: ['Ctrl', 'Shift', 'N'], fn: 'Nuova cartella' },
    { keys: ['Ctrl', 'Shift', 'Esc'], fn: 'Gestione attività (Task Manager)' },
    { keys: ['Alt', 'F4'], fn: 'Chiudi la finestra attiva' },
    { keys: ['Alt', 'Tab'], fn: 'Passa da una finestra all\'altra' },
    { keys: ['Ctrl', 'Shift', 'Canc'], fn: 'Cancella dati di navigazione (browser)' },
    { keys: ['Ctrl', 'Rotellina'], fn: 'Zoom avanti / indietro' },
    { keys: ['Ctrl', 'Home'], fn: 'Vai all\'inizio del documento' },
    { keys: ['Ctrl', 'End'], fn: 'Vai alla fine del documento' },
    { keys: ['Ctrl', 'C'], fn: 'Copia' },
    { keys: ['Ctrl', 'V'], fn: 'Incolla' },
    { keys: ['Ctrl', 'Z'], fn: 'Annulla' },
    { keys: ['Ctrl', 'F'], fn: 'Trova nel documento / pagina' },
    { keys: ['Stamp'], fn: 'Cattura tutto lo schermo (PrtScn)' },
];

const SecurityModal = ({ onClose }) => {
    const [activeView, setActiveView] = useState(null); // null = main view, or tool name
    const [pathToCheck, setPathToCheck] = useState('');
    const [winShortcutQuery, setWinShortcutQuery] = useState('');
    const [passwordLength, setPasswordLength] = useState(16);
    const [generatedPassword, setGeneratedPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [passwordToAnalyze, setPasswordToAnalyze] = useState('');
    const [passwordAnalysis, setPasswordAnalysis] = useState(null);
    const [urlToScan, setUrlToScan] = useState('');
    const [scanResult, setScanResult] = useState(null);
    const [fileToScan, setFileToScan] = useState(null);
    const [fileScanResult, setFileScanResult] = useState(null);
    const [emailToCheck, setEmailToCheck] = useState('');
    const [emailBreachResult, setEmailBreachResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [scanProgress, setScanProgress] = useState('');
    const [copied, setCopied] = useState(false);
    const [trainingContent, setTrainingContent] = useState(null);
    const [phishingText, setPhishingText] = useState('');
    const [phishingUrl, setPhishingUrl] = useState('');
    const [phishingFile, setPhishingFile] = useState(null);
    const [phishingResult, setPhishingResult] = useState(null);
    const [phishingTicket, setPhishingTicket] = useState(null);
    const [phishingTicketLoading, setPhishingTicketLoading] = useState(false);

    const openPhishingTicket = async () => {
        if (!phishingResult) return;
        setPhishingTicketLoading(true);
        const lvlLabel = phishingResult.level === 'alto' ? 'PERICOLOSA (probabile phishing)' : 'SOSPETTA';
        let desc = `⚠️ Segnalazione mail sospetta dall'utente tramite Spark.\n\nEsito verifica: ${lvlLabel}\n`;
        if (phishingUrl) desc += `\n🔗 Link: ${phishingUrl}${phishingResult.urlMal > 0 ? ` (segnalato da ${phishingResult.urlMal} motori)` : ''}`;
        if (phishingFile) desc += `\n📎 Allegato: ${phishingFile.name}${phishingResult.fileMal > 0 ? ` (segnalato da ${phishingResult.fileMal} motori)` : ''}`;
        if (phishingResult.text?.reasons?.length) desc += `\n\n🧠 Analisi AI:\n- ${phishingResult.text.reasons.join('\n- ')}`;
        if (phishingText) desc += `\n\n--- Testo mail ---\n${phishingText.slice(0, 1500)}`;
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/jira/ticket`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    summary: 'Segnalazione mail sospetta (phishing)',
                    description: desc,
                    reporter: state.userName || (state.userEmail || 'Utente').split('@')[0],
                    reporter_email: state.userEmail || '',
                    client_name: state.userCompany || state.userSiteName || 'Segnalazione Sicurezza'
                })
            });
            const d = await r.json();
            if (d.key) setPhishingTicket(d.key);
            else setPhishingTicket('errore');
        } catch (e) { setPhishingTicket('errore'); }
        setPhishingTicketLoading(false);
    };

    const handleAnalyzePhishing = async () => {
        if (!phishingText && !phishingUrl && !phishingFile) return;
        setIsLoading(true);
        setPhishingResult(null);
        setPhishingTicket(null);
        const res = { text: null, url: null, file: null };
        try {
            if (phishingText) {
                setScanProgress('🧠 Analisi del testo con l\'AI...');
                const r = await fetch(`${API_BASE_URL}/api/v1/antivirus/phishing/analyze`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ text: phishingText })
                });
                res.text = await r.json();
            }
            if (phishingUrl) {
                setScanProgress('🔗 Controllo del link su VirusTotal...');
                res.url = await MOCK_API.scanUrl(phishingUrl);
            }
            if (phishingFile) {
                setScanProgress('📎 Analisi dell\'allegato su VirusTotal...');
                res.file = await MOCK_API.scanFile(phishingFile);
            }
        } catch (e) {
            console.error('Errore analisi phishing:', e);
        }
        const urlMal = (res.url?.stats?.malicious || 0) + (res.url?.stats?.suspicious || 0);
        const fileMal = (res.file?.stats?.malicious || 0) + (res.file?.stats?.suspicious || 0);
        const textRisk = res.text?.risk;
        let level = 'basso';
        if (textRisk === 'alto' || urlMal > 0 || fileMal > 0) level = 'alto';
        else if (textRisk === 'medio') level = 'medio';
        setPhishingResult({ level, ...res, urlMal, fileMal });
        setScanProgress('');
        setIsLoading(false);
    };

    const handleGeneratePassword = async () => {
        setIsLoading(true);
        const pwd = await MOCK_API.generatePassword(passwordLength);
        setGeneratedPassword(pwd);
        setShowPassword(true);
        setIsLoading(false);
    };

    const handleAnalyzePassword = async () => {
        if (!passwordToAnalyze) return;
        setIsLoading(true);
        const analysis = await MOCK_API.analyzePassword(passwordToAnalyze);
        setPasswordAnalysis(analysis);
        setIsLoading(false);
    };

    const handleScanUrl = async () => {
        if (!urlToScan) return;
        setIsLoading(true);
        setScanProgress('Invio URL a VirusTotal...');
        setScanResult(null);
        const result = await MOCK_API.scanUrl(urlToScan);
        setScanResult(result);
        setScanProgress('');
        setIsLoading(false);
    };

    const handleScanFile = async () => {
        if (!fileToScan) return;
        setIsLoading(true);
        setScanProgress('Caricamento file su VirusTotal...');
        setFileScanResult(null);
        
        try {
            // Prima carica il file
            const formData = new FormData();
            formData.append('file', fileToScan);
            
            const submitResponse = await fetch(`${API_BASE_URL}/api/v1/antivirus/scan/file`, {
                method: 'POST',
                body: formData
            });
            
            if (!submitResponse.ok) {
                throw new Error(`Errore upload: HTTP ${submitResponse.status}`);
            }
            
            const submitResult = await submitResponse.json();
            console.log('[FILE] Upload completato:', submitResult);
            
            if (submitResult.analysis_id) {
                setScanProgress('Scansione in corso...');
                
                // Polling con callback per aggiornare il progresso
                const result = await pollVirusTotalReport(
                    submitResult.analysis_id, 
                    60,  // maxAttempts
                    3000, // intervalMs
                    (progress) => setScanProgress(progress)
                );
                
                setFileScanResult(result);
            } else {
                setFileScanResult({
                    error: true,
                    message: 'Errore: nessun analysis_id ricevuto',
                    stats: { malicious: 0, suspicious: 0, undetected: 0, harmless: 0 }
                });
            }
        } catch (error) {
            console.error('❌ Errore scansione file:', error);
            setFileScanResult({
                error: true,
                message: error.message || 'Errore durante la scansione',
                stats: { malicious: 0, suspicious: 0, undetected: 0, harmless: 0 }
            });
        }
        
        setScanProgress('');
        setIsLoading(false);
    };

    const handleCheckEmail = async () => {
        if (!emailToCheck) return;
        setIsLoading(true);
        const result = await MOCK_API.checkEmailBreaches(emailToCheck);
        setEmailBreachResult(result);
        setIsLoading(false);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const getStrengthColor = (strength) => {
        switch(strength) {
            case 'Molto Forte': return 'bg-green-500';
            case 'Forte': return 'bg-green-400';
            case 'Moderata': return 'bg-yellow-500';
            default: return 'bg-red-500';
        }
    };

    const renderScanStats = (stats) => {
        if (!stats) return null;
        const total = (stats.malicious || 0) + (stats.suspicious || 0) + (stats.harmless || 0) + (stats.undetected || 0);
        // Nessun motore ha risposto: scansione non completata (errore/timeout) → evita falso "Nessuna minaccia"
        if (total === 0) {
            return (
                <div className="p-3 rounded-lg border bg-amber-50 border-amber-200">
                    <div className="flex items-center">
                        <AlertTriangle className="h-5 w-5 text-amber-600 mr-2" />
                        <span className="font-semibold text-amber-700">Scansione non completata. Riprova tra qualche istante.</span>
                    </div>
                    <p className="text-xs text-amber-600 mt-1">Nessun motore antivirus ha ancora risposto.</p>
                </div>
            );
        }
        const isSafe = stats.malicious === 0 && stats.suspicious === 0;
        
        return (
            <div className={`p-3 rounded-lg border ${isSafe ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
                <div className="flex items-center mb-2">
                    {isSafe ? <CheckCircle2 className="h-5 w-5 text-green-600 mr-2" /> : <AlertTriangle className="h-5 w-5 text-red-600 mr-2" />}
                    <span className={`font-semibold ${isSafe ? 'text-green-700' : 'text-red-700'}`}>
                        {isSafe ? 'Nessuna minaccia' : 'Attenzione! Minacce rilevate'}
                    </span>
                </div>
                <div className="grid grid-cols-4 gap-2 text-xs text-center">
                    <div className="bg-red-100 p-2 rounded"><p className="font-bold text-red-600">{stats.malicious || 0}</p><p className="text-red-500">Malevoli</p></div>
                    <div className="bg-yellow-100 p-2 rounded"><p className="font-bold text-yellow-600">{stats.suspicious || 0}</p><p className="text-yellow-500">Sospetti</p></div>
                    <div className="bg-green-100 p-2 rounded"><p className="font-bold text-green-600">{stats.harmless || 0}</p><p className="text-green-500">Sicuri</p></div>
                    <div className="bg-gray-100 p-2 rounded"><p className="font-bold text-gray-600">{stats.undetected || 0}</p><p className="text-gray-500">N/D</p></div>
                </div>
                <p className="text-xs text-gray-500 mt-2 text-center">Analisi di {total} motori antivirus</p>
            </div>
        );
    };

    const showTraining = (category) => {
        const tip = getDailyTip(category);
        setTrainingContent({ category, tip });
        setActiveView('training-detail');
    };

    // Tool items for left column
    const securityTools = [
        { id: 'phishing', icon: Fish, title: 'Ho ricevuto una mail sospetta', desc: 'Incolla link, allegato o testo: verifichiamo subito se è phishing.', color: 'text-rose-600' },
        { id: 'generate-password', icon: Sparkles, title: 'Password incerta? Porta aperta.', desc: 'Crea una password robusta e personalizzata.', color: 'text-purple-500' },
        { id: 'analyze-password', icon: KeyRound, title: 'Analizza Robustezza Password', desc: 'Controlla la forza di una password in modo sicuro.', color: 'text-orange-500' },
        { id: 'scan-file', icon: FileScan, title: 'File ignoto, rischio noto', desc: 'Controlla un file PDF per potenziali minacce.', color: 'text-blue-500' },
        { id: 'check-email', icon: AtSign, title: 'Controlla Email per Violazioni', desc: 'Verifica se la tua email è apparsa in data breach noti.', color: 'text-pink-500' },
        { id: 'scan-site', icon: Globe, title: 'Specchio delle mie brame, questo sito ha delle trame?', desc: "Analizza un sito per verificarne l'affidabilità.", color: 'text-cyan-500' },
        { id: 'scan-url', icon: Link2, title: 'Occhio al link, o il dato duole.', desc: 'Controlla un link prima di cliccarlo.', color: 'text-red-500' },
        { id: 'speed-test', icon: Wifi, title: 'Test Velocità Connessione', desc: 'Verifica le performance della tua rete.', color: 'text-green-500' },
        { id: 'path-length', icon: FolderOpen, title: 'Percorso troppo lungo?', desc: 'Controlla se un percorso file/cartella supera il limite di Windows (260 caratteri).', color: 'text-amber-500' },
        { id: 'win-shortcuts', icon: Keyboard, title: 'Scorciatoie di Windows', desc: 'Le combinazioni di tasti più utili per lavorare più veloce.', color: 'text-purple-500' },
    ];

    // Training items for right column
    const trainingItems = [
        { id: 'general_tips', icon: Lightbulb, title: "L'Esperienza di nonno Sandro", desc: 'Un trucco di produttività per la giornata.', color: 'text-yellow-500' },
        { id: 'security_rules', icon: ShieldCheck, title: 'Una regola al giorno toglie Hacker di torno', desc: 'Impara un concetto di sicurezza fondamentale.', color: 'text-green-500' },
        { id: 'password_management', icon: BookKey, title: 'Una chiave per ogni porta.', desc: 'Scopri una strategia per le tue password.', color: 'text-cyan-500' },
        { id: 'phishing_awareness', icon: Fish, title: 'A pesca di... truffe!', desc: 'Impara a riconoscere una truffa.', color: 'text-pink-500' },
    ];

    // Render tool detail view
    const renderToolDetail = () => {
        switch(activeView) {
            case 'phishing':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4" data-testid="phishing-back-btn">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><Fish className="mr-2 text-rose-600" />Mail sospetta? Verifichiamola</h3>
                        <p className="text-sm text-gray-500">Incolla anche solo una di queste cose: il link, l'allegato o il testo della mail. Poi premi Analizza.</p>

                        <div>
                            <label className="text-sm font-semibold flex items-center gap-1"><Link2 className="h-4 w-4" /> Link sospetto (opzionale)</label>
                            <input type="url" value={phishingUrl} onChange={(e) => setPhishingUrl(e.target.value)} placeholder="https://..." className="w-full p-2 border rounded-lg text-sm mt-1" data-testid="phishing-url-input" />
                        </div>

                        <div>
                            <label className="text-sm font-semibold flex items-center gap-1"><FileScan className="h-4 w-4" /> Allegato sospetto (opzionale)</label>
                            <input type="file" onChange={(e) => setPhishingFile(e.target.files[0])} className="w-full text-sm mt-1" data-testid="phishing-file-input" />
                            {phishingFile && <span className="text-xs text-gray-500">{phishingFile.name}</span>}
                        </div>

                        <div>
                            <label className="text-sm font-semibold flex items-center gap-1"><Mail className="h-4 w-4" /> Testo della mail (opzionale)</label>
                            <textarea value={phishingText} onChange={(e) => setPhishingText(e.target.value)} rows={4} placeholder="Incolla qui il testo della mail (mittente, oggetto, messaggio)..." className="w-full p-2 border rounded-lg text-sm mt-1 resize-y" data-testid="phishing-text-input" />
                        </div>

                        <button onClick={handleAnalyzePhishing} disabled={isLoading || (!phishingText && !phishingUrl && !phishingFile)} className="w-full bg-rose-600 text-white py-2.5 rounded-lg hover:bg-rose-700 disabled:opacity-50 font-semibold flex items-center justify-center gap-2" data-testid="phishing-analyze-btn">
                            {isLoading ? <><Loader2 className="h-4 w-4 animate-spin" /> {scanProgress || 'Analisi in corso...'}</> : <><Shield className="h-4 w-4" /> Analizza</>}
                        </button>

                        {phishingResult && (
                            <div data-testid="phishing-result" className="space-y-3">
                                {(() => {
                                    const lv = phishingResult.level;
                                    const cfg = lv === 'alto'
                                        ? { bg: 'bg-red-50 border-red-300', tx: 'text-red-700', icon: <AlertTriangle className="h-6 w-6 text-red-600" />, title: '🔴 PERICOLOSA — molto probabile phishing' }
                                        : lv === 'medio'
                                        ? { bg: 'bg-amber-50 border-amber-300', tx: 'text-amber-700', icon: <AlertTriangle className="h-6 w-6 text-amber-600" />, title: '🟡 SOSPETTA — fai attenzione' }
                                        : { bg: 'bg-green-50 border-green-300', tx: 'text-green-700', icon: <ShieldCheck className="h-6 w-6 text-green-600" />, title: '🟢 Sembra sicura' };
                                    return (
                                        <div className={`p-3 rounded-lg border ${cfg.bg}`}>
                                            <div className="flex items-center gap-2">{cfg.icon}<span className={`font-bold ${cfg.tx}`}>{cfg.title}</span></div>
                                            {lv !== 'basso' && <p className="text-xs mt-2 font-semibold text-gray-700">⚠️ Non cliccare link e non aprire allegati. Nel dubbio apri un ticket al supporto 86BIT.</p>}
                                        </div>
                                    );
                                })()}

                                {phishingResult.url && (
                                    <div className="text-sm p-2 rounded-lg border bg-white">
                                        <span className="font-semibold">🔗 Link:</span> {phishingResult.urlMal > 0 ? <span className="text-red-600 font-bold">{phishingResult.urlMal} motori lo segnalano come pericoloso</span> : <span className="text-green-600">nessun motore lo segnala</span>}
                                    </div>
                                )}
                                {phishingResult.file && (
                                    <div className="text-sm p-2 rounded-lg border bg-white">
                                        <span className="font-semibold">📎 Allegato:</span> {phishingResult.fileMal > 0 ? <span className="text-red-600 font-bold">{phishingResult.fileMal} motori lo segnalano come malevolo</span> : <span className="text-green-600">nessun motore lo segnala</span>}
                                    </div>
                                )}
                                {phishingResult.text && (
                                    <div className="text-sm p-2 rounded-lg border bg-white">
                                        <p className="font-semibold">🧠 Analisi del testo (AI):</p>
                                        {(phishingResult.text.reasons || []).length > 0 && (
                                            <ul className="list-disc pl-5 mt-1 space-y-0.5 text-gray-700">
                                                {phishingResult.text.reasons.map((r, i) => <li key={i}>{r}</li>)}
                                            </ul>
                                        )}
                                        {phishingResult.text.advice && <p className="mt-2 text-gray-600"><span className="font-semibold">Consiglio:</span> {phishingResult.text.advice}</p>}
                                    </div>
                                )}

                                {phishingResult.level !== 'basso' && (
                                    phishingTicket && phishingTicket !== 'errore' ? (
                                        <div className="p-2 rounded-lg border bg-green-50 border-green-300 text-green-700 text-sm font-semibold" data-testid="phishing-ticket-success">
                                            ✅ Ticket aperto al supporto 86BIT: {phishingTicket}. Ti ricontattiamo a breve.
                                        </div>
                                    ) : phishingTicket === 'errore' ? (
                                        <div className="p-2 rounded-lg border bg-red-50 border-red-300 text-red-700 text-sm">Impossibile aprire il ticket ora. Riprova.</div>
                                    ) : (
                                        <button onClick={openPhishingTicket} disabled={phishingTicketLoading} className="w-full bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 disabled:opacity-50 font-semibold flex items-center justify-center gap-2" data-testid="phishing-open-ticket-btn">
                                            {phishingTicketLoading ? <><Loader2 className="h-4 w-4 animate-spin" /> Apertura ticket...</> : <><Ticket className="h-4 w-4" /> Apri ticket al supporto 86BIT</>}
                                        </button>
                                    )
                                )}
                            </div>
                        )}
                    </div>
                );
            case 'generate-password':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><Sparkles className="mr-2 text-purple-500" />Genera Password Sicura</h3>
                        <div className="flex items-center gap-4 mb-3">
                            <label className="text-sm">Lunghezza: {passwordLength}</label>
                            <input type="range" min="8" max="32" value={passwordLength} onChange={(e) => setPasswordLength(parseInt(e.target.value))} className="flex-1" />
                        </div>
                        <button onClick={handleGeneratePassword} disabled={isLoading} className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 disabled:opacity-50 font-semibold">
                            {isLoading ? <Loader2 className="animate-spin h-5 w-5 mx-auto" /> : '🔐 Genera Password'}
                        </button>
                        {generatedPassword && (
                            <div className="mt-3 flex items-center gap-2 bg-gray-50 p-3 rounded-lg">
                                <input type={showPassword ? 'text' : 'password'} value={generatedPassword} readOnly className="flex-1 p-2 border rounded-lg font-mono text-sm bg-white" />
                                <button onClick={() => setShowPassword(!showPassword)} className="p-2 hover:bg-gray-200 rounded-lg">{showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}</button>
                                <button onClick={() => copyToClipboard(generatedPassword)} className="p-2 hover:bg-gray-200 rounded-lg">{copied ? <Check className="h-5 w-5 text-green-600" /> : <Copy className="h-5 w-5" />}</button>
                            </div>
                        )}
                    </div>
                );
            case 'analyze-password':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><KeyRound className="mr-2 text-orange-500" />Analizza Robustezza Password</h3>
                        <div className="flex gap-2">
                            <input type="text" value={passwordToAnalyze} onChange={(e) => setPasswordToAnalyze(e.target.value)} placeholder="Inserisci password da analizzare" className="flex-1 p-3 border rounded-lg" />
                            <button onClick={handleAnalyzePassword} disabled={isLoading || !passwordToAnalyze} className="bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 disabled:opacity-50 font-semibold">Analizza</button>
                        </div>
                        {passwordAnalysis && (
                            <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                                <div className="flex items-center gap-2">
                                    <div className="flex-1 h-4 bg-gray-200 rounded-full overflow-hidden">
                                        <div className={`h-full ${getStrengthColor(passwordAnalysis.strength)}`} style={{ width: `${passwordAnalysis.score}%` }}></div>
                                    </div>
                                    <span className="font-bold text-lg">{passwordAnalysis.strength}</span>
                                </div>
                                {passwordAnalysis.suggestions?.length > 0 && (
                                    <ul className="text-sm text-gray-600 list-disc list-inside">
                                        {passwordAnalysis.suggestions.map((s, i) => <li key={i}>{s}</li>)}
                                    </ul>
                                )}
                            </div>
                        )}
                    </div>
                );
            case 'scan-file':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><FileScan className="mr-2 text-blue-500" />Scansiona File</h3>
                        <div className="flex gap-2">
                            <input type="file" onChange={(e) => setFileToScan(e.target.files[0])} className="flex-1 p-3 border rounded-lg" />
                            <button onClick={handleScanFile} disabled={isLoading || !fileToScan} className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50 font-semibold">
                                {isLoading && scanProgress.includes('file') ? <Loader2 className="animate-spin h-5 w-5" /> : 'Scansiona'}
                            </button>
                        </div>
                        {scanProgress && <p className="text-sm text-blue-600 flex items-center"><Loader2 className="animate-spin h-4 w-4 mr-2" />{scanProgress}</p>}
                        {fileScanResult && renderScanStats(fileScanResult.stats)}
                    </div>
                );
            case 'check-email':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><AtSign className="mr-2 text-pink-500" />Controlla Email per Violazioni</h3>
                        <div className="flex gap-2">
                            <input type="email" value={emailToCheck} onChange={(e) => setEmailToCheck(e.target.value)} placeholder="email@esempio.com" className="flex-1 p-3 border rounded-lg" />
                            <button onClick={handleCheckEmail} disabled={isLoading || !emailToCheck} className="bg-pink-600 text-white px-6 py-3 rounded-lg hover:bg-pink-700 disabled:opacity-50 font-semibold">Verifica</button>
                        </div>
                        {emailBreachResult && (
                            <div className={`p-4 rounded-lg ${emailBreachResult.found ? 'bg-red-50 border border-red-200' : 'bg-green-50 border border-green-200'}`}>
                                {emailBreachResult.found ? (
                                    <>
                                        <p className="font-bold text-red-700 flex items-center"><AlertTriangle className="h-5 w-5 mr-2" />⚠️ Email trovata in {emailBreachResult.count} violazioni!</p>
                                        <p className="text-sm text-red-600 mt-2">Breach: {emailBreachResult.breaches.join(', ')}</p>
                                        <p className="text-xs text-gray-500 mt-2">Ti consigliamo di cambiare la password!</p>
                                    </>
                                ) : (
                                    <p className="font-bold text-green-700 flex items-center"><CheckCircle2 className="h-5 w-5 mr-2" />✅ Nessuna violazione trovata!</p>
                                )}
                            </div>
                        )}
                    </div>
                );
            case 'scan-site':
            case 'scan-url':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><Globe className="mr-2 text-cyan-500" />Verifica URL / Sito</h3>
                        <div className="flex gap-2">
                            <input type="url" value={urlToScan} onChange={(e) => setUrlToScan(e.target.value)} placeholder="https://esempio.com" className="flex-1 p-3 border rounded-lg" />
                            <button onClick={handleScanUrl} disabled={isLoading || !urlToScan} className="bg-cyan-600 text-white px-6 py-3 rounded-lg hover:bg-cyan-700 disabled:opacity-50 font-semibold">
                                {isLoading && scanProgress.includes('URL') ? <Loader2 className="animate-spin h-5 w-5" /> : 'Scansiona'}
                            </button>
                        </div>
                        {scanProgress && <p className="text-sm text-blue-600 flex items-center"><Loader2 className="animate-spin h-4 w-4 mr-2" />{scanProgress}</p>}
                        {scanResult && renderScanStats(scanResult.stats)}
                    </div>
                );
            case 'speed-test':
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><Wifi className="mr-2 text-green-500" />Test Velocità Connessione</h3>
                        <button onClick={async () => {
                            setIsLoading(true);
                            const result = await MOCK_API.runSpeedTest();
                            setScanResult(result);
                            setIsLoading(false);
                        }} disabled={isLoading} className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 disabled:opacity-50 font-semibold">
                            {isLoading ? <Loader2 className="animate-spin h-5 w-5 mx-auto" /> : '🚀 Avvia Test'}
                        </button>
                        {scanResult?.ping && (
                            <div className="grid grid-cols-3 gap-4 mt-4">
                                <div className="bg-blue-50 p-4 rounded-lg text-center">
                                    <p className="text-2xl font-bold text-blue-600">{scanResult.ping}ms</p>
                                    <p className="text-sm text-gray-500">Ping</p>
                                </div>
                                <div className="bg-green-50 p-4 rounded-lg text-center">
                                    <p className="text-2xl font-bold text-green-600">{scanResult.download} Mbps</p>
                                    <p className="text-sm text-gray-500">Download</p>
                                </div>
                                <div className="bg-purple-50 p-4 rounded-lg text-center">
                                    <p className="text-2xl font-bold text-purple-600">{scanResult.upload} Mbps</p>
                                    <p className="text-sm text-gray-500">Upload</p>
                                </div>
                            </div>
                        )}
                    </div>
                );
            case 'training-detail':
                return (
                    <div className="space-y-4">
                        <button onClick={() => { setActiveView(null); setTrainingContent(null); }} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        {trainingContent?.tip && (
                            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl">
                                <h3 className="font-bold text-xl mb-4">{trainingContent.tip.title}</h3>
                                <p className="text-gray-700 mb-4 text-lg">{trainingContent.tip.tip.replace(/\*\*/g, '')}</p>
                                <div className="bg-white p-4 rounded-lg border">
                                    <p className="text-sm text-gray-500 italic">💡 {trainingContent.tip.example}</p>
                                </div>
                            </div>
                        )}
                    </div>
                );
            case 'path-length': {
                const len = pathToCheck.trim().length;
                const LIMIT = 260; // MAX_PATH di Windows
                const WARN = 200;
                const pct = Math.min(100, Math.round((len / LIMIT) * 100));
                const over = len >= LIMIT;
                const warn = len >= WARN && len < LIMIT;
                const barColor = over ? 'bg-red-500' : warn ? 'bg-amber-500' : 'bg-green-500';
                return (
                    <div className="space-y-4">
                        <button onClick={() => setActiveView(null)} className="flex items-center text-blue-600 hover:text-blue-800 mb-4">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><FolderOpen className="mr-2 text-amber-500" />Controllo Lunghezza Percorso</h3>
                        <p className="text-sm text-gray-600">Windows consiglia percorsi (cartella + nome file) entro <span className="font-semibold">260 caratteri</span> (limite MAX_PATH). Oltre questo limite alcuni programmi non riescono ad aprire, salvare o sincronizzare i file. Incolla qui il percorso completo per verificarlo.</p>
                        <textarea
                            value={pathToCheck}
                            onChange={(e) => setPathToCheck(e.target.value)}
                            rows={3}
                            placeholder="Es. C:\\Users\\Mario\\OneDrive - Azienda\\Documenti\\Progetti\\2026\\Cliente\\Relazioni\\report_finale_versione_definitiva.docx"
                            className="w-full p-3 border rounded-lg font-mono text-xs resize-none focus:outline-none focus:border-amber-500"
                            data-testid="path-check-input"
                        />
                        {len > 0 && (
                            <div className="space-y-3">
                                <div className="flex items-center gap-3">
                                    <div className="flex-1 h-3 bg-gray-200 rounded-full overflow-hidden">
                                        <div className={`h-full ${barColor} transition-all`} style={{ width: `${pct}%` }}></div>
                                    </div>
                                    <span className="font-bold text-sm whitespace-nowrap" data-testid="path-check-count">{len} / {LIMIT}</span>
                                </div>
                                {over ? (
                                    <div className="p-3 rounded-lg border bg-red-50 border-red-300 text-red-700 text-sm" data-testid="path-check-status">
                                        <p className="font-bold flex items-center gap-1.5"><AlertTriangle className="h-4 w-4" /> Percorso troppo lungo ({len} caratteri)</p>
                                        <p className="mt-1">Supera il limite di Windows di {LIMIT} caratteri: alcuni file potrebbero non aprirsi, salvarsi o sincronizzarsi correttamente.</p>
                                    </div>
                                ) : warn ? (
                                    <div className="p-3 rounded-lg border bg-amber-50 border-amber-300 text-amber-800 text-sm" data-testid="path-check-status">
                                        <p className="font-bold flex items-center gap-1.5"><AlertTriangle className="h-4 w-4" /> Ti stai avvicinando al limite</p>
                                        <p className="mt-1">Mancano {LIMIT - len} caratteri al limite di {LIMIT}. Meglio accorciare il percorso per sicurezza.</p>
                                    </div>
                                ) : (
                                    <div className="p-3 rounded-lg border bg-green-50 border-green-300 text-green-700 text-sm" data-testid="path-check-status">
                                        <p className="font-bold flex items-center gap-1.5"><Check className="h-4 w-4" /> Percorso nei limiti</p>
                                        <p className="mt-1">Sei sotto il limite consigliato di {LIMIT} caratteri. Tutto ok!</p>
                                    </div>
                                )}
                                {(over || warn) && (() => {
                                    const analysis = analyzeWindowsPath(pathToCheck);
                                    return (
                                        <div className="p-3 rounded-lg bg-blue-50 border border-blue-200 text-sm text-gray-700 space-y-2">
                                            <p className="font-semibold text-blue-800">Consigli su misura per il tuo percorso:</p>
                                            {analysis.tips.length > 0 ? (
                                                <ul className="list-disc pl-5 space-y-1" data-testid="path-check-tips">
                                                    {analysis.tips.map((t, i) => (
                                                        <li key={i} className={t.type === 'crit' ? 'text-red-700 font-medium' : ''}>{t.text}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p>Accorcia i nomi di cartelle e file e sposta la cartella più vicino alla radice del disco.</p>
                                            )}
                                            <p className="text-xs text-gray-500 pt-1">Se il problema persiste, l'IT 86BIT può abilitare il supporto ai «percorsi lunghi» di Windows: apri un ticket in chat.</p>
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                    </div>
                );
            }
            case 'win-shortcuts': {
                const q = winShortcutQuery.trim().toLowerCase();
                const list = q
                    ? WIN_SHORTCUTS.filter(s => s.fn.toLowerCase().includes(q) || s.keys.join(' ').toLowerCase().includes(q))
                    : WIN_SHORTCUTS;
                return (
                    <div className="space-y-4">
                        <button onClick={() => { setActiveView(null); setWinShortcutQuery(''); }} className="flex items-center text-blue-600 hover:text-blue-800 mb-2">
                            <ChevronLeft className="h-5 w-5 mr-1" />Indietro
                        </button>
                        <h3 className="font-bold text-xl flex items-center"><Keyboard className="mr-2 text-purple-500" />Scorciatoie di Windows</h3>
                        <p className="text-sm text-gray-600">Le combinazioni di tasti più utili per lavorare più velocemente. Cerca per funzione o per tasto.</p>
                        <div className="relative">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                            <input
                                value={winShortcutQuery}
                                onChange={(e) => setWinShortcutQuery(e.target.value)}
                                placeholder="Es. cartella, blocca, emoji, Win..."
                                className="w-full pl-10 pr-3 py-2.5 border rounded-lg text-sm focus:outline-none focus:border-purple-500"
                                data-testid="win-shortcut-search"
                            />
                        </div>
                        <div className="space-y-1.5 max-h-[55vh] overflow-y-auto pr-1" data-testid="win-shortcut-list">
                            {list.length === 0 && <p className="text-gray-500 text-sm text-center py-6">Nessuna scorciatoia trovata.</p>}
                            {list.map((s, i) => (
                                <div key={i} className="flex items-center justify-between gap-3 p-2.5 rounded-lg bg-gray-50 border border-gray-100">
                                    <div className="flex items-center flex-wrap gap-1">
                                        {s.keys.map((k, ki) => (
                                            <React.Fragment key={ki}>
                                                {ki > 0 && <span className="text-gray-400 text-xs font-bold">+</span>}
                                                <kbd className="px-2 py-1 text-xs font-semibold bg-white border border-gray-300 rounded shadow-sm text-gray-700 whitespace-nowrap">{k}</kbd>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <span className="text-sm text-gray-700 text-right flex-1 min-w-0">{s.fn}</span>
                                </div>
                            ))}
                        </div>
                        <p className="text-xs text-gray-400 text-center">Suggerimento: il tasto <kbd className="px-1.5 py-0.5 bg-gray-100 border rounded">Win</kbd> è quello con il logo di Windows.</p>
                    </div>
                );
            }
            default:
                return null;
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-stretch md:items-center justify-center md:p-4 z-50 animate-fade-in" onClick={onClose}>
            <div className="bg-white md:rounded-xl shadow-2xl w-full md:max-w-4xl h-[100dvh] md:h-auto md:max-h-[90vh] overflow-hidden animate-scale-in flex flex-col" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="modal-safe-header flex justify-between items-center p-3 sm:p-5 border-b bg-gradient-to-r from-gray-50 to-white flex-shrink-0">
                    <h2 className="text-lg sm:text-xl font-bold text-gray-800 flex items-center">
                        <Shield className="mr-2 text-blue-600 h-5 w-5 sm:h-6 sm:w-6" />
                        <span className="hidden sm:inline">Centro Sicurezza e Formazione</span>
                        <span className="sm:hidden">Sicurezza</span>
                    </h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition-colors">
                        <XCircle className="h-6 w-6 text-gray-500" />
                    </button>
                </div>
                
                {/* Content */}
                <div className="p-3 sm:p-6 overflow-y-auto flex-1 min-h-0" style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}>
                    {activeView ? (
                        renderToolDetail()
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8">
                            {/* Left Column - Strumenti di Sicurezza */}
                            <div>
                                <h3 className="font-bold text-base sm:text-lg text-gray-700 mb-3 sm:mb-4">Strumenti di Sicurezza</h3>
                                <div className="space-y-1 sm:space-y-2">
                                    {securityTools.map((tool) => (
                                        <button
                                            key={tool.id}
                                            onClick={() => setActiveView(tool.id)}
                                            className="w-full text-left flex items-center p-2 sm:p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group active:bg-gray-200"
                                        >
                                            <tool.icon className={`mr-2 sm:mr-3 h-5 w-5 sm:h-6 sm:w-6 ${tool.color} flex-shrink-0`} />
                                            <div className="flex-1 min-w-0">
                                                <p className="font-semibold text-gray-800 text-xs sm:text-sm leading-tight">{tool.title}</p>
                                                <p className="text-xs text-gray-500 truncate hidden sm:block">{tool.desc}</p>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Right Column - Formazione Quotidiana */}
                            <div className="mt-4 md:mt-0">
                                <h3 className="font-bold text-base sm:text-lg text-gray-700 mb-3 sm:mb-4">Formazione Quotidiana</h3>
                                <div className="space-y-1 sm:space-y-2">
                                    {trainingItems.map((item) => (
                                        <button
                                            key={item.id}
                                            onClick={() => showTraining(item.id)}
                                            className="w-full text-left flex items-center p-2 sm:p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group active:bg-gray-200"
                                        >
                                            <item.icon className={`mr-2 sm:mr-3 h-5 w-5 sm:h-6 sm:w-6 ${item.color} flex-shrink-0`} />
                                            <div className="flex-1 min-w-0">
                                                <p className="font-semibold text-gray-800 text-xs sm:text-sm leading-tight">{item.title}</p>
                                                <p className="text-xs text-gray-500 truncate hidden sm:block">{item.desc}</p>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// TICKET MODAL - Creazione Ticket Jira
// ============================================================================
const TicketModal = ({ onClose }) => {
    const { state, dispatch } = useContext(ChatContext);
    const { isMobile } = state;
    // Step: 'select', 'restore-form', 'generic-form', 'loading', 'success', 'error'
    const [step, setStep] = useState('select');
    const [ticketType, setTicketType] = useState(null);
    
    // Dati per Ticket Generico
    const [genericData, setGenericData] = useState({
        summary: '',
        description: '',
        priority: 'medium'
    });
    
    // Dati per Restore File
    const [restoreData, setRestoreData] = useState({
        fileName: '',
        folderPath: '',
        lastSeenDate: '',
        restoreMode: '' // 'replace' o 'copy'
    });
    
    // Dati per Gestione Utenti
    const [userMgmtData, setUserMgmtData] = useState({
        action: '', // 'nuovo' o 'disattiva'
        // Nuovo Arrivo
        newUserName: '',
        newUserRole: '',
        startDate: '',
        copyPermissionsFrom: '',
        workstationType: '', // 'esistente' o 'nuovo'
        existingPcNumber: '',
        proceedWithOffer: false,
        needEmail: true,
        desiredEmail: '',
        needSharedMailbox: '', // 'yes' o 'no'
        sharedMailboxList: '', // elenco email cassette condivise
        needErp: false,
        needOffice365: true,
        needVpn: false, // VPN per connessione da esterno
        otherSoftware: '',
        // Disattivazione
        leavingUserName: '',
        leavingUserPC: '',
        hadEmail: '', // 'yes' o 'no'
        leavingUserEmail: '',
        lastDay: '',
        emailFuture: '', // 'autoresponder', 'close'
        archiveAccessTo: '', // chi deve vedere archivio posta
        cleanDevice: '', // 'yes' o 'no'
        disableVpn: false, // VPN da disattivare
        disableNotes: ''
    });
    
    const handleUserMgmtChange = (field, value) => {
        setUserMgmtData(prev => ({ ...prev, [field]: value }));
    };
    
    // Allegati per ticket
    const [attachments, setAttachments] = useState([]);
    const fileInputRef = useRef(null);
    const cameraInputRef = useRef(null);
    
    const [createdTicket, setCreatedTicket] = useState(null);
    const [error, setError] = useState('');

    // 🎫 Se l'utente NON è registrato in Jira, mostra la guida di registrazione
    // ad OGNI apertura del ticket, finché non risulta registrato.
    const [showRegGuide, setShowRegGuide] = useState(false);
    useEffect(() => {
        if (state.jiraRegistered === true) return;
        if (state.jiraRegistered === false) { setShowRegGuide(true); return; }
        // stato sconosciuto: verifica al volo
        const email = (state.userEmail || localStorage.getItem('spark-user-email-v1') || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/v1/jira/check-user?email=${encodeURIComponent(email)}`, {
                    headers: getAuthHeaders()
                });
                const data = await res.json();
                if (!cancelled && data.configured) {
                    dispatch({ type: 'SET_STATE', payload: { jiraRegistered: !!data.is_jira_user } });
                    if (!data.is_jira_user) setShowRegGuide(true);
                }
            } catch (e) { /* silenzioso */ }
        })();
        return () => { cancelled = true; };
    }, []);

    const handleGenericInputChange = (e) => {
        const { name, value } = e.target;
        setGenericData(prev => ({ ...prev, [name]: value }));
    };

    const handleRestoreInputChange = (e) => {
        const { name, value } = e.target;
        setRestoreData(prev => ({ ...prev, [name]: value }));
    };

    // Gestione allegati
    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;
        
        files.forEach(file => {
            if (file.size > 10 * 1024 * 1024) { // 10MB limit
                setError('Il file è troppo grande (max 10MB)');
                return;
            }
            
            const reader = new FileReader();
            reader.onload = (event) => {
                const newAttachment = {
                    id: Date.now() + Math.random(),
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    data: event.target.result,
                    preview: file.type.startsWith('image/') ? event.target.result : null
                };
                setAttachments(prev => [...prev, newAttachment]);
            };
            reader.readAsDataURL(file);
        });
        
        // Reset input
        e.target.value = '';
    };

    // 📋 Incolla screenshot con Ctrl+V nella descrizione del ticket
    const handleTicketDescPaste = (e) => {
        const items = e.clipboardData && e.clipboardData.items;
        if (!items) return;
        let handled = false;
        for (const it of items) {
            if (it.type && it.type.startsWith('image/')) {
                const file = it.getAsFile();
                if (!file) continue;
                if (file.size > 10 * 1024 * 1024) { setError('Il file è troppo grande (max 10MB)'); continue; }
                handled = true;
                const reader = new FileReader();
                reader.onload = (event) => {
                    setAttachments(prev => [...prev, {
                        id: Date.now() + Math.random(),
                        name: file.name || `incolla_${Date.now()}.png`,
                        type: file.type || 'image/png',
                        size: file.size,
                        data: event.target.result,
                        preview: event.target.result
                    }]);
                };
                reader.readAsDataURL(file);
            }
        }
        if (handled) e.preventDefault();
    };


    // 📷 Cattura screenshot con getDisplayMedia
    const handleScreenshotCapture = async () => {
        try {
            const stream = await navigator.mediaDevices.getDisplayMedia({
                video: { mediaSource: 'screen' },
                preferCurrentTab: false
            });

            const video = document.createElement('video');
            video.srcObject = stream;
            await video.play();
            await new Promise(resolve => setTimeout(resolve, 100));

            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0);

            stream.getTracks().forEach(track => track.stop());

            canvas.toBlob((blob) => {
                if (blob) {
                    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
                    const fileName = `screenshot_${timestamp}.png`;
                    
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        const newAttachment = {
                            id: Date.now() + Math.random(),
                            name: fileName,
                            type: 'image/png',
                            size: blob.size,
                            data: event.target.result,
                            preview: event.target.result
                        };
                        setAttachments(prev => [...prev, newAttachment]);
                    };
                    reader.readAsDataURL(blob);
                }
            }, 'image/png');

        } catch (err) {
            if (err.name !== 'AbortError' && err.name !== 'NotAllowedError') {
                console.error('Errore cattura screenshot:', err);
                setError('Impossibile catturare lo screenshot. Funzionalità non supportata.');
            }
        }
    };

    const removeAttachment = (id) => {
        setAttachments(prev => prev.filter(att => att.id !== id));
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    const handleSubmitGeneric = async (e) => {
        e.preventDefault();
        
        if (!genericData.summary.trim()) {
            setError('Inserisci un oggetto per il ticket');
            return;
        }
        if (!genericData.description.trim()) {
            setError('Inserisci una descrizione del problema');
            return;
        }

        setStep('loading');
        setError('');

        try {
            const reporter = state.userName || 'Utente Sconosciuto';
            const reporterEmail = state.userEmail || '';
            const companyName = state.userCompany || state.userSiteName || 'Azienda';
            
            // Formato oggetto: NOME AZIENDA - (Oggetto Problema)
            const ticketSummary = `${companyName.toUpperCase()} - ${genericData.summary}`;
            
            // La descrizione contiene SOLO il problema: i contatti (Nome/Email/Telefono/PC)
            // vengono aggiunti dal backend come tabella formattata in cima al ticket.
            let fullDescription = genericData.description;

            // Elenca solo gli allegati NON-immagine (es. PDF): le immagini vengono
            // caricate come allegati veri e mostrate nella conversazione.
            const nonImageAttachments = attachments.filter(att => !(att.type && att.type.startsWith('image/')));
            if (nonImageAttachments.length > 0) {
                fullDescription += `

📎 **ALLEGATI:** ${nonImageAttachments.length} file
${nonImageAttachments.map(att => `- ${att.name} (${formatFileSize(att.size)})`).join('\n')}`;
            }

            // Aggiungi info aggiuntive se presenti
            if (genericData.additionalInfo && genericData.additionalInfo.trim()) {
                fullDescription += `

💡 **INFORMAZIONI AGGIUNTIVE:**
${genericData.additionalInfo}`;
            }

            // Aggiungi numero telefono se presente
            if (genericData.phoneCallback && genericData.phoneCallback.trim()) {
                fullDescription += `

📞 **RICHIESTA CALLBACK:**
L'utente ha richiesto di essere richiamato al numero: ${genericData.phoneCallback}`;
            }

            const result = await MOCK_API.createTicket(
                ticketSummary,
                fullDescription,
                reporter,
                reporterEmail,
                { phone: state.userPhone, pc: state.userComputer, connection: state.userConnectionType, images: attachments.filter(a => a.type && a.type.startsWith('image/')).map(a => ({ data: a.data, name: a.name })) }
            );

            setCreatedTicket(result);
            setStep('success');

            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    sender: 'ai',
                    text: `🎉 **FANTASTICO!**

━━━━━━━━━━━━━━━━━━━━━━

✅  **Il tuo Ticket è stato creato!**

━━━━━━━━━━━━━━━━━━━━━━

🎫  **Numero Ticket:**
     \`${result.key || result.id}\`

📝  **Oggetto:**
     ${ticketSummary}

━━━━━━━━━━━━━━━━━━━━━━

📌  **Cosa succede adesso?**

     1️⃣  Il team riceve la tua richiesta
     
     2️⃣  Un tecnico la prende in carico
     
     3️⃣  Ti contatteremo per aggiornarti

━━━━━━━━━━━━━━━━━━━━━━

💡  **Conserva il numero** \`${result.key || result.id}\`
     Ti servirà per chiedere lo stato!

━━━━━━━━━━━━━━━━━━━━━━

😊  Grazie per averci scritto!
     Siamo qui per aiutarti.`,
                    type: 'system-prompt',
                    id: Date.now() + Math.random()
                }
            });

        } catch (err) {
            console.error('Errore creazione ticket:', err);
            setError(err.message || 'Errore durante la creazione del ticket. Riprova più tardi.');
            setStep('error');
        }
    };

    const handleSubmitRestore = async (e) => {
        e.preventDefault();
        
        if (!restoreData.fileName.trim()) {
            setError('Inserisci il nome del file o cartella');
            return;
        }
        if (!restoreData.folderPath.trim()) {
            setError('Inserisci il percorso della cartella');
            return;
        }
        if (!restoreData.lastSeenDate.trim()) {
            setError('Indica quando hai visto il file l\'ultima volta');
            return;
        }
        if (!restoreData.restoreMode) {
            setError('Scegli come vuoi ripristinare il file');
            return;
        }

        setStep('loading');
        setError('');

        try {
            const reporter = state.userName || 'Utente Sconosciuto';
            const modeText = restoreData.restoreMode === 'replace' 
                ? '🅰️ SOSTITUISCI (sovrascrivi il file attuale)' 
                : '🅱️ COPIA (mettilo nella stessa posizione di dove era prima)';
            
            const companyName = state.userCompany || state.userSiteName || 'Azienda';
            const summary = `${companyName.toUpperCase()} - Richiesta Restore File da backup`;
            const fullDescription = `**RICHIESTA RESTORE FILE DA BACKUP**

🖥️ **Postazione:** ${state.userComputer || 'Non specificato'}

📁 **File/Cartella da ripristinare:**
${restoreData.fileName}

📍 **Percorso originale:**
${restoreData.folderPath}

🕐 **Ultima volta funzionante:**
${restoreData.lastSeenDate}

⚙️ **Modalità di ripristino:**
${modeText}`;

            const result = await MOCK_API.createTicket(
                summary,
                fullDescription,
                reporter,
                state.userEmail || '',
                { phone: state.userPhone, pc: state.userComputer, connection: state.userConnectionType }
            );

            setCreatedTicket(result);
            setStep('success');

            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    sender: 'ai',
                    text: `🎉 **RICHIESTA RESTORE INVIATA!**

━━━━━━━━━━━━━━━━━━━━━━

✅  **Abbiamo ricevuto la tua richiesta!**

━━━━━━━━━━━━━━━━━━━━━━

🎫  **Numero Richiesta:**
     \`${result.key || result.id}\`

📁  **File da recuperare:**
     ${restoreData.fileName}

📍  **Percorso originale:**
     \`${restoreData.folderPath}\`

━━━━━━━━━━━━━━━━━━━━━━

📌  **Cosa succede adesso?**

     1️⃣  Verifichiamo i backup disponibili
     
     2️⃣  Troviamo la versione del tuo file
     
     3️⃣  Procediamo al ripristino

━━━━━━━━━━━━━━━━━━━━━━

⏰  **Tempistiche:**
     Di solito ci vogliono 1-2 ore lavorative

💡  **Conserva il numero** \`${result.key || result.id}\`

━━━━━━━━━━━━━━━━━━━━━━

😊  Ci pensiamo noi!
     Ti aggiorneremo appena pronto.`,
                    type: 'system-prompt',
                    id: Date.now() + Math.random()
                }
            });

        } catch (err) {
            console.error('Errore creazione ticket restore:', err);
            setError(err.message || 'Errore durante la creazione della richiesta. Riprova più tardi.');
            setStep('error');
        }
    };

    // Handler per Gestione Utenti
    const handleSubmitUserMgmt = async (e) => {
        e.preventDefault();
        
        const isNewArrival = userMgmtData.action === 'nuovo';
        
        // Validazioni
        if (isNewArrival) {
            if (!userMgmtData.newUserName.trim()) {
                setError('Inserisci il nome del nuovo collega');
                return;
            }
            if (!userMgmtData.startDate) {
                setError('Indica la data di inizio');
                return;
            }
        } else {
            if (!userMgmtData.leavingUserName.trim()) {
                setError('Inserisci il nome del collega che lascia');
                return;
            }
            if (!userMgmtData.lastDay) {
                setError('Indica l\'ultimo giorno lavorativo');
                return;
            }
        }

        setStep('loading');
        setError('');

        try {
            const reporter = state.userName || 'Utente Sconosciuto';
            const companyName = state.userCompany || state.userSiteName || 'Azienda';
            
            let summary, fullDescription;
            
            if (isNewArrival) {
                summary = `${companyName.toUpperCase()} - Nuovo Arrivo dipendente`;
                
                const softwareList = [];
                if (userMgmtData.needEmail) {
                    let emailText = `📧 Email aziendale${userMgmtData.desiredEmail ? `: ${userMgmtData.desiredEmail}` : ''}`;
                    if (userMgmtData.needSharedMailbox === 'yes' && userMgmtData.sharedMailboxList) {
                        emailText += `\n   📬 Cassette condivise:\n   ${userMgmtData.sharedMailboxList.split('\n').filter(e => e.trim()).map(e => `• ${e.trim()}`).join('\n   ')}`;
                    }
                    softwareList.push(emailText);
                }
                if (userMgmtData.needErp) softwareList.push('🗄️ Accesso Gestionale');
                if (userMgmtData.needOffice365) softwareList.push('📊 Licenza Office 365');
                if (userMgmtData.needVpn) softwareList.push('🔐 VPN (connessione da esterno)');
                if (userMgmtData.otherSoftware) softwareList.push(`🔧 ${userMgmtData.otherSoftware}`);
                
                fullDescription = `**👋 RICHIESTA NUOVO ARRIVO**

━━━━━━━━━━━━━━━━━━━━

**📋 DATI NUOVO UTENTE:**
• **Nome:** ${userMgmtData.newUserName}
• **Ruolo:** ${userMgmtData.newUserRole || 'Non specificato'}
• **Data Inizio:** ${new Date(userMgmtData.startDate).toLocaleDateString('it-IT')}

**👥 PERMESSI (Gemello Digitale):**
• Copia permessi da: ${userMgmtData.copyPermissionsFrom || 'Da definire'}

**💻 POSTAZIONE:**
• ${userMgmtData.workstationType === 'esistente' 
    ? `PC Esistente: ${userMgmtData.existingPcNumber || 'Da specificare'}` 
    : `Nuova postazione da preparare${userMgmtData.proceedWithOffer ? ' (Procedere con offerta)' : ''}`}

**🔧 SOFTWARE RICHIESTO:**
${softwareList.length > 0 ? softwareList.join('\n') : '• Nessun software specifico'}

━━━━━━━━━━━━━━━━━━━━`;
            } else {
                summary = `${companyName.toUpperCase()} - Disattivazione dipendente`;
                
                const emailFutureText = {
                    'autoresponder': '🅰️ Risponditore automatico',
                    'close': '🅾️ Chiudi completamente'
                }[userMgmtData.emailFuture] || 'Non specificato';
                
                const cleanDeviceText = {
                    'yes': '✅ Sì, formattare il dispositivo',
                    'no': '❌ No, mantenere i dati'
                }[userMgmtData.cleanDevice] || 'Non specificato';
                
                fullDescription = `**❌ RICHIESTA DISATTIVAZIONE UTENTE**

━━━━━━━━━━━━━━━━━━━━

**📋 UTENTE DA DISATTIVARE:**
• **Nome:** ${userMgmtData.leavingUserName}
• **Ultimo Giorno:** ${new Date(userMgmtData.lastDay).toLocaleDateString('it-IT')}
• **Postazione:** ${userMgmtData.leavingUserPC || 'Non specificata'}
• ⚠️ L'account verrà disattivato alle 18:00 del giorno indicato

${userMgmtData.hadEmail === 'yes' ? `**📧 EMAIL AZIENDALE:**
• **Indirizzo:** ${userMgmtData.leavingUserEmail || 'Non specificato'}
• **Gestione:** ${emailFutureText}${userMgmtData.emailFuture === 'close' && userMgmtData.archiveAccessTo ? `
• **Accesso archivio posta a:** ${userMgmtData.archiveAccessTo}` : ''}
` : '**📧 EMAIL AZIENDALE:** No, non aveva email aziendale\n'}
**🖥️ RIPULIRE DISPOSITIVO:**
• ${cleanDeviceText}

**🔐 VPN:**
• ${userMgmtData.disableVpn ? 'Sì, da disattivare' : 'No, non aveva VPN'}

${userMgmtData.disableNotes ? `**📝 NOTE:**
• ${userMgmtData.disableNotes}
` : ''}━━━━━━━━━━━━━━━━━━━━`;
            }

            const result = await MOCK_API.createTicket(summary, fullDescription, reporter, state.userEmail || '', { phone: state.userPhone, pc: state.userComputer, connection: state.userConnectionType });

            setCreatedTicket(result);
            setStep('success');

            const actionEmoji = isNewArrival ? '👋' : '❌';
            const actionText = isNewArrival ? 'Nuovo Arrivo' : 'Disattivazione';
            const userName = isNewArrival ? userMgmtData.newUserName : userMgmtData.leavingUserName;

            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    sender: 'ai',
                    text: `🎉 **RICHIESTA ${actionText.toUpperCase()} INVIATA!**

━━━━━━━━━━━━━━━━━━━━

${actionEmoji} **${actionText}:** ${userName}
🎫 **Ticket:** \`${result.key || result.id}\`

━━━━━━━━━━━━━━━━━━━━

📋  **Prossimi passi:**

     1️⃣  Analizziamo la richiesta
     
     2️⃣  ${isNewArrival ? 'Prepariamo la postazione' : 'Eseguiamo le procedure di sicurezza'}
     
     3️⃣  ${isNewArrival ? 'Ti avvisiamo quando è tutto pronto' : 'Confermiamo la disattivazione'}

━━━━━━━━━━━━━━━━━━━━

💡  **Conserva il numero** \`${result.key || result.id}\`

━━━━━━━━━━━━━━━━━━━━

😊  Ci pensiamo noi!`,
                    type: 'system-prompt',
                    id: Date.now() + Math.random()
                }
            });

        } catch (err) {
            console.error('Errore creazione ticket gestione utenti:', err);
            setError(err.message || 'Errore durante la creazione della richiesta. Riprova più tardi.');
            setStep('error');
        }
    };

    const handleClose = () => {
        onClose();
    };

    const handleBack = () => {
        setStep('select');
        setTicketType(null);
        setError('');
    };

    const priorityOptions = [
        { value: 'low', label: 'Bassa', color: 'text-green-600', desc: 'Può aspettare qualche giorno' },
        { value: 'medium', label: 'Media', color: 'text-yellow-600', desc: 'Richiede attenzione entro 24-48h' },
        { value: 'high', label: 'Alta', color: 'text-red-600', desc: 'Urgente, blocca il lavoro' }
    ];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-stretch sm:items-center justify-center sm:p-2 z-50 animate-fade-in" onClick={handleClose}>
            {showRegGuide && (
                <JiraRegisterGuideModal
                    email={state.userEmail || localStorage.getItem('spark-user-email-v1') || ''}
                    userName={state.userName}
                    company={state.userSiteName || state.userCompany || ''}
                    pcName={state.userComputer}
                    onClose={() => setShowRegGuide(false)}
                    onResult={(reg) => { if (reg) dispatch({ type: 'SET_STATE', payload: { jiraRegistered: true } }); }}
                />
            )}
            <div className="bg-white sm:rounded-xl shadow-2xl w-full max-w-4xl h-[100dvh] sm:h-auto sm:max-h-[95vh] overflow-hidden animate-scale-in flex flex-col" onClick={(e) => e.stopPropagation()}>
                {/* Header - compatto su mobile */}
                <div className="modal-safe-header flex justify-between items-center p-2 sm:p-4 border-b bg-gradient-to-r from-purple-600 to-indigo-600 text-white flex-shrink-0">
                    <h2 className="text-sm sm:text-lg font-bold flex items-center">
                        <Ticket className="mr-1.5 sm:mr-2 h-4 w-4 sm:h-5 sm:w-5" />
                        {step === 'success' ? 'Richiesta Inviata!' : 
                         step === 'select' ? 'Apri un Ticket' :
                         step === 'restore-form' ? '🔄 Restore File' :
                         step === 'user-mgmt-select' ? '👥 Gestione Utenti' :
                         step === 'user-mgmt-new' ? '👋 Nuovo Arrivo' :
                         step === 'user-mgmt-disable' ? '❌ Disattivazione' :
                         'Ticket di Assistenza'}
                    </h2>
                    <button onClick={handleClose} className="p-1 sm:p-1.5 rounded-full hover:bg-white/20 transition-colors">
                        <XCircle className="h-5 w-5" />
                    </button>
                </div>

                <div className="p-2 sm:p-4 overflow-y-auto flex-1 flex flex-col min-h-0">
                    
                    {/* STEP: Selezione Tipo Ticket */}
                    {step === 'select' && (
                        <div className="space-y-2 sm:space-y-4">
                            <p className="text-gray-600 text-center text-xs sm:text-base mb-2 sm:mb-6">Che tipo di richiesta vuoi aprire?</p>
                            
                            {/* Bottone Ticket Generico - PRIMO */}
                            <button
                                onClick={() => { setTicketType('generic'); setStep('generic-form'); }}
                                data-testid="ticket-type-generic-btn"
                                className="w-full p-3 sm:p-5 border-2 border-purple-200 rounded-lg sm:rounded-xl hover:border-purple-400 hover:bg-purple-50 transition-all text-left group"
                            >
                                <div className="flex items-center">
                                    <div className="bg-purple-100 p-2 sm:p-3 rounded-full mr-2 sm:mr-4 group-hover:bg-purple-200 transition-colors flex-shrink-0">
                                        <Ticket className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-gray-800 text-sm sm:text-lg">📝 Ticket Generico</h3>
                                        <p className="text-xs sm:text-sm text-gray-500">Segnala un problema o richiedi assistenza</p>
                                    </div>
                                </div>
                            </button>
                            
                            
                            {/* Bottone Restore File - TERZO */}
                            <button
                                onClick={() => { setTicketType('restore'); setStep('restore-form'); }}
                                className="w-full p-3 sm:p-5 border-2 border-blue-200 rounded-lg sm:rounded-xl hover:border-blue-400 hover:bg-blue-50 transition-all text-left group"
                            >
                                <div className="flex items-center">
                                    <div className="bg-blue-100 p-2 sm:p-3 rounded-full mr-2 sm:mr-4 group-hover:bg-blue-200 transition-colors flex-shrink-0">
                                        <RotateCcw className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-gray-800 text-sm sm:text-lg">🔄 Restore File da Backup</h3>
                                        <p className="text-xs sm:text-sm text-gray-500">Recupera un file o cartella</p>
                                    </div>
                                </div>
                            </button>
                        </div>
                    )}
                    
                    {/* STEP: Selezione Tipo Gestione Utenti */}
                    {step === 'user-mgmt-select' && (
                        <div className="space-y-4">
                            <button type="button" onClick={handleBack} className="text-blue-600 hover:text-blue-800 text-sm flex items-center">
                                <ArrowLeft className="h-4 w-4 mr-1" /> Torna alla selezione
                            </button>
                            
                            <div className="text-center mb-4">
                                <h3 className="text-lg font-bold text-gray-800">🚦 Cosa dobbiamo gestire oggi?</h3>
                                <p className="text-sm text-gray-500">Scegli un'opzione</p>
                            </div>
                            
                            <button
                                onClick={() => { handleUserMgmtChange('action', 'nuovo'); setStep('user-mgmt-new'); }}
                                className="w-full p-5 border-2 border-emerald-200 rounded-xl hover:border-emerald-400 hover:bg-emerald-50 transition-all text-left group"
                            >
                                <div className="flex items-center">
                                    <div className="bg-emerald-100 p-3 rounded-full mr-4">
                                        <span className="text-2xl">👋</span>
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-gray-800">NUOVO ARRIVO</h3>
                                        <p className="text-sm text-gray-500">Devo preparare tutto per un nuovo collega</p>
                                    </div>
                                </div>
                            </button>
                            
                            <button
                                onClick={() => { handleUserMgmtChange('action', 'disattiva'); setStep('user-mgmt-disable'); }}
                                className="w-full p-5 border-2 border-red-200 rounded-xl hover:border-red-400 hover:bg-red-50 transition-all text-left group"
                            >
                                <div className="flex items-center">
                                    <div className="bg-red-100 p-3 rounded-full mr-4">
                                        <span className="text-2xl">❌</span>
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-gray-800">DISATTIVAZIONE</h3>
                                        <p className="text-sm text-gray-500">Un collega lascia l'azienda (Licenziamento/Dimissioni)</p>
                                    </div>
                                </div>
                            </button>
                        </div>
                    )}
                    
                    {/* STEP: Form Nuovo Arrivo */}
                    {step === 'user-mgmt-new' && (
                        <form onSubmit={handleSubmitUserMgmt} className="flex flex-col flex-1 min-h-0">
                            {/* Contenuto scrollabile */}
                            <div className="flex-1 overflow-y-auto min-h-0 space-y-4">
                            <button type="button" onClick={() => setStep('user-mgmt-select')} className="text-blue-600 hover:text-blue-800 text-sm flex items-center mb-4">
                                <ArrowLeft className="h-4 w-4 mr-1" /> Torna alla selezione
                            </button>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* COLONNA SINISTRA */}
                                <div className="space-y-4">
                                    {/* Header */}
                                    <div className="bg-emerald-50 p-3 rounded-xl border border-emerald-200">
                                        <h3 className="font-bold text-emerald-800 flex items-center gap-2">👋 NUOVO ARRIVO</h3>
                                        <p className="text-xs text-emerald-600">Obiettivo: Avere tutto pronto per il primo giorno</p>
                                    </div>
                                    
                                    {/* 1. Chi è la New Entry */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <User className="h-4 w-4" />
                                            1. Chi è la "New Entry"?
                                        </h4>
                                        <div className="space-y-2">
                                            <input
                                                type="text"
                                                placeholder="Nome e Cognome"
                                                value={userMgmtData.newUserName}
                                                onChange={(e) => handleUserMgmtChange('newUserName', e.target.value)}
                                                className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                                                required
                                            />
                                            <input
                                                type="text"
                                                placeholder="Ruolo (es. Responsabile Commerciale)"
                                                value={userMgmtData.newUserRole}
                                                onChange={(e) => handleUserMgmtChange('newUserRole', e.target.value)}
                                                className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* 2. Quando inizia */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <Calendar className="h-4 w-4" />
                                            2. Quando inizia?
                                        </h4>
                                        <input
                                            type="date"
                                            value={userMgmtData.startDate}
                                            onChange={(e) => handleUserMgmtChange('startDate', e.target.value)}
                                            className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                                            required
                                        />
                                        <p className="text-xs text-orange-600 mt-2">⚠️ Dacci almeno 3 giorni di preavviso!</p>
                                    </div>
                                    
                                    {/* 3. Gemello Digitale */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                            <Copy className="h-4 w-4" />
                                            3. Il "Gemello Digitale"
                                        </h4>
                                        <p className="text-xs text-gray-500 mb-2">A chi deve "assomigliare" come accessi?</p>
                                        <input
                                            type="text"
                                            placeholder="es. Copia i permessi da Mario Rossi"
                                            value={userMgmtData.copyPermissionsFrom}
                                            onChange={(e) => handleUserMgmtChange('copyPermissionsFrom', e.target.value)}
                                            className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                                        />
                                    </div>
                                </div>
                                
                                {/* COLONNA DESTRA */}
                                <div className="space-y-4">
                                    {/* 4. Postazione di Lavoro */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <Monitor className="h-4 w-4" />
                                            4. Postazione di Lavoro
                                        </h4>
                                        <div className="space-y-2">
                                            <label className={`flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer transition-all ${userMgmtData.workstationType === 'esistente' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200 hover:border-gray-300'}`}>
                                                <input type="radio" name="workstation" checked={userMgmtData.workstationType === 'esistente'} onChange={() => handleUserMgmtChange('workstationType', 'esistente')} className="hidden" />
                                                <Laptop className="h-5 w-5 text-gray-600" />
                                                <span className="font-medium text-sm">PC Esistente</span>
                                            </label>
                                            {userMgmtData.workstationType === 'esistente' && (
                                                <input
                                                    type="text"
                                                    placeholder="Numero PC (es. PC-AMMIN-04)"
                                                    value={userMgmtData.existingPcNumber}
                                                    onChange={(e) => handleUserMgmtChange('existingPcNumber', e.target.value)}
                                                    className="w-full p-2 border border-gray-200 rounded-lg text-sm"
                                                />
                                            )}
                                            <label className={`flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer transition-all ${userMgmtData.workstationType === 'nuovo' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200 hover:border-gray-300'}`}>
                                                <input type="radio" name="workstation" checked={userMgmtData.workstationType === 'nuovo'} onChange={() => handleUserMgmtChange('workstationType', 'nuovo')} className="hidden" />
                                                <Monitor className="h-5 w-5 text-gray-600" />
                                                <span className="font-medium text-sm">Nuova Postazione</span>
                                            </label>
                                            {userMgmtData.workstationType === 'nuovo' && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleUserMgmtChange('proceedWithOffer', true)}
                                                    className={`w-full p-2 border-2 rounded-lg text-sm font-medium transition-all ${userMgmtData.proceedWithOffer ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-gray-200 hover:border-emerald-300 text-gray-600'}`}
                                                >
                                                    📋 Procedere con offerta
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    
                                    {/* 5. Software & Account */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <Settings className="h-4 w-4" />
                                            5. Software & Account
                                        </h4>
                                        <div className="grid grid-cols-1 gap-2">
                                            <label className={`flex items-center gap-2 p-2 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.needEmail ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200'}`}>
                                                <input type="checkbox" checked={userMgmtData.needEmail} onChange={(e) => handleUserMgmtChange('needEmail', e.target.checked)} className="hidden" />
                                                <span className={userMgmtData.needEmail ? 'text-emerald-700' : ''}>📧 Email Aziendale</span>
                                            </label>
                                            {userMgmtData.needEmail && (
                                                <div className="space-y-2 p-2 bg-white rounded-lg border border-gray-200">
                                                    <input
                                                        type="email"
                                                        placeholder="Indirizzo email desiderato (es. mario.rossi@azienda.it)"
                                                        value={userMgmtData.desiredEmail}
                                                        onChange={(e) => handleUserMgmtChange('desiredEmail', e.target.value)}
                                                        className="w-full p-2 border border-gray-200 rounded-lg text-sm"
                                                    />
                                                    <div className="pt-2 border-t border-gray-100">
                                                        <p className="text-xs text-gray-500 mb-2">Deve vedere cassette condivise?</p>
                                                        <div className="flex gap-2 mb-2">
                                                            <label className={`flex-1 p-2 border-2 rounded-lg cursor-pointer text-center text-sm ${userMgmtData.needSharedMailbox === 'yes' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200'}`}>
                                                                <input type="radio" name="sharedMailbox" checked={userMgmtData.needSharedMailbox === 'yes'} onChange={() => handleUserMgmtChange('needSharedMailbox', 'yes')} className="hidden" />
                                                                ✅ Sì
                                                            </label>
                                                            <label className={`flex-1 p-2 border-2 rounded-lg cursor-pointer text-center text-sm ${userMgmtData.needSharedMailbox === 'no' ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200'}`}>
                                                                <input type="radio" name="sharedMailbox" checked={userMgmtData.needSharedMailbox === 'no'} onChange={() => handleUserMgmtChange('needSharedMailbox', 'no')} className="hidden" />
                                                                ❌ No
                                                            </label>
                                                        </div>
                                                        {userMgmtData.needSharedMailbox === 'yes' && (
                                                            <textarea
                                                                placeholder="Elenco email cassette condivise (una per riga)&#10;es. info@azienda.it&#10;vendite@azienda.it"
                                                                value={userMgmtData.sharedMailboxList}
                                                                onChange={(e) => handleUserMgmtChange('sharedMailboxList', e.target.value)}
                                                                className="w-full p-2 border border-gray-200 rounded-lg text-sm resize-none"
                                                                rows="3"
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            <label className={`flex items-center gap-2 p-2 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.needErp ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200'}`}>
                                                <input type="checkbox" checked={userMgmtData.needErp} onChange={(e) => handleUserMgmtChange('needErp', e.target.checked)} className="hidden" />
                                                <span className={userMgmtData.needErp ? 'text-emerald-700' : ''}>🗄️ Gestionale</span>
                                            </label>
                                            <label className={`flex items-center gap-2 p-2 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.needOffice365 ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200'}`}>
                                                <input type="checkbox" checked={userMgmtData.needOffice365} onChange={(e) => handleUserMgmtChange('needOffice365', e.target.checked)} className="hidden" />
                                                <span className={userMgmtData.needOffice365 ? 'text-emerald-700' : ''}>📊 Office 365</span>
                                            </label>
                                            <label className={`flex items-center gap-2 p-2 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.needVpn ? 'border-emerald-500 bg-emerald-50' : 'border-gray-200'}`}>
                                                <input type="checkbox" checked={userMgmtData.needVpn} onChange={(e) => handleUserMgmtChange('needVpn', e.target.checked)} className="hidden" />
                                                <span className={userMgmtData.needVpn ? 'text-emerald-700' : ''}>🔐 VPN (connessione da esterno)</span>
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Altro software specifico..."
                                                value={userMgmtData.otherSoftware}
                                                onChange={(e) => handleUserMgmtChange('otherSoftware', e.target.value)}
                                                className="w-full p-2 border border-gray-200 rounded-lg text-sm mt-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {error && <p className="text-red-500 text-sm mt-4 text-center">{error}</p>}
                            </div>
                            
                            {/* Footer Fisso */}
                            <div className="flex-shrink-0 pt-3 pb-12 sm:pb-3 border-t border-gray-100 mt-auto bg-white flex gap-3">
                                <button type="button" onClick={() => setStep('user-mgmt-select')} className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-600 font-medium hover:bg-gray-50">
                                    Annulla
                                </button>
                                <button type="submit" className="flex-1 py-3 px-4 bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-xl font-bold hover:from-emerald-600 hover:to-green-700 shadow-lg shadow-emerald-200">
                                    📤 Invia Richiesta
                                </button>
                            </div>
                        </form>
                    )}
                    
                    {/* STEP: Form Disattivazione */}
                    {step === 'user-mgmt-disable' && (
                        <form onSubmit={handleSubmitUserMgmt} className="flex flex-col flex-1 min-h-0">
                            {/* Contenuto scrollabile */}
                            <div className="flex-1 overflow-y-auto min-h-0 space-y-4">
                            <button type="button" onClick={() => setStep('user-mgmt-select')} className="text-blue-600 hover:text-blue-800 text-sm flex items-center mb-4">
                                <ArrowLeft className="h-4 w-4 mr-1" /> Torna alla selezione
                            </button>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* COLONNA SINISTRA */}
                                <div className="space-y-4">
                                    {/* Header */}
                                    <div className="bg-red-50 p-3 rounded-xl border border-red-200">
                                        <h3 className="font-bold text-red-800 flex items-center gap-2">❌ DISATTIVAZIONE</h3>
                                        <p className="text-xs text-red-600">Obiettivo: Sicurezza dei dati e continuità del lavoro</p>
                                    </div>
                                    
                                    {/* 1. Chi ci lascia */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <User className="h-4 w-4" />
                                            1. Chi ci lascia?
                                        </h4>
                                        <input
                                            type="text"
                                            placeholder="Nome e Cognome"
                                            value={userMgmtData.leavingUserName}
                                            onChange={(e) => handleUserMgmtChange('leavingUserName', e.target.value)}
                                            className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-red-500"
                                            required
                                        />
                                    </div>
                                    
                                    {/* 2. Ultimo giorno */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <Calendar className="h-4 w-4" />
                                            2. Quando stacca la spina?
                                        </h4>
                                        <input
                                            type="date"
                                            value={userMgmtData.lastDay}
                                            onChange={(e) => handleUserMgmtChange('lastDay', e.target.value)}
                                            className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-red-500"
                                            required
                                        />
                                        <p className="text-xs text-orange-600 mt-2">⚠️ Alle 18:00 l'utenza verrà bloccata</p>
                                        
                                        {/* Postazione */}
                                        <div className="mt-3 pt-3 border-t border-gray-200">
                                            <p className="text-xs text-gray-500 mb-2">Su quale postazione lavorava?</p>
                                            <input
                                                type="text"
                                                placeholder="Nome/Numero PC (es. PC-AMMIN-04)"
                                                value={userMgmtData.leavingUserPC}
                                                onChange={(e) => handleUserMgmtChange('leavingUserPC', e.target.value)}
                                                className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-red-500"
                                            />
                                        </div>
                                        
                                        {/* Email aziendale */}
                                        <div className="mt-3 pt-3 border-t border-gray-200">
                                            <p className="text-xs text-gray-500 mb-2">Aveva una email aziendale?</p>
                                            <div className="flex gap-2 mb-2">
                                                <label className={`flex-1 p-2 border-2 rounded-lg cursor-pointer text-center text-sm ${userMgmtData.hadEmail === 'yes' ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                                    <input type="radio" name="hadEmail" checked={userMgmtData.hadEmail === 'yes'} onChange={() => handleUserMgmtChange('hadEmail', 'yes')} className="hidden" />
                                                    ✅ Sì
                                                </label>
                                                <label className={`flex-1 p-2 border-2 rounded-lg cursor-pointer text-center text-sm ${userMgmtData.hadEmail === 'no' ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                                    <input type="radio" name="hadEmail" checked={userMgmtData.hadEmail === 'no'} onChange={() => handleUserMgmtChange('hadEmail', 'no')} className="hidden" />
                                                    ❌ No
                                                </label>
                                            </div>
                                            {userMgmtData.hadEmail === 'yes' && (
                                                <div className="space-y-2">
                                                    <input
                                                        type="email"
                                                        placeholder="Indirizzo email (es. mario.rossi@azienda.it)"
                                                        value={userMgmtData.leavingUserEmail}
                                                        onChange={(e) => handleUserMgmtChange('leavingUserEmail', e.target.value)}
                                                        className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-red-500"
                                                    />
                                                    <p className="text-xs text-orange-600">⚠️ Gli accessi verranno bloccati</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    
                                    {/* 3. Gestione Email - solo se ha email */}
                                    {userMgmtData.hadEmail === 'yes' && userMgmtData.leavingUserEmail && (
                                        <div className="bg-gray-50 rounded-xl p-4">
                                            <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                                <Mail className="h-4 w-4" />
                                                3. Cosa succede alla sua email?
                                            </h4>
                                            <div className="space-y-2">
                                                <label className={`flex items-center gap-2 p-2 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.emailFuture === 'autoresponder' ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                                    <input type="radio" name="emailFuture" checked={userMgmtData.emailFuture === 'autoresponder'} onChange={() => handleUserMgmtChange('emailFuture', 'autoresponder')} className="hidden" />
                                                    🅰️ Risponditore Auto
                                                </label>
                                                <label className={`flex items-center gap-2 p-2 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.emailFuture === 'close' ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                                    <input type="radio" name="emailFuture" checked={userMgmtData.emailFuture === 'close'} onChange={() => handleUserMgmtChange('emailFuture', 'close')} className="hidden" />
                                                    🅾️ Chiudi tutto
                                                </label>
                                                {userMgmtData.emailFuture === 'close' && (
                                                    <div className="p-2 bg-white rounded-lg border border-gray-200">
                                                        <p className="text-xs text-gray-500 mb-2">Chi deve vedere l'archivio posta?</p>
                                                        <input
                                                            type="text"
                                                            placeholder="Nome collega (lascia vuoto se nessuno)"
                                                            value={userMgmtData.archiveAccessTo}
                                                            onChange={(e) => handleUserMgmtChange('archiveAccessTo', e.target.value)}
                                                            className="w-full p-2 border border-gray-200 rounded-lg text-sm"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                
                                {/* COLONNA DESTRA */}
                                <div className="space-y-4">
                                    {/* 4. Ripulire dispositivo */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            <Trash2 className="h-4 w-4" />
                                            4. Ripulire suo dispositivo?
                                        </h4>
                                        <div className="space-y-2">
                                            <label className={`flex items-center gap-2 p-3 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.cleanDevice === 'yes' ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                                <input type="radio" name="cleanDevice" checked={userMgmtData.cleanDevice === 'yes'} onChange={() => handleUserMgmtChange('cleanDevice', 'yes')} className="hidden" />
                                                <span className={userMgmtData.cleanDevice === 'yes' ? 'text-red-700' : ''}>✅ Sì, formattare</span>
                                            </label>
                                            <label className={`flex items-center gap-2 p-3 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.cleanDevice === 'no' ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                                <input type="radio" name="cleanDevice" checked={userMgmtData.cleanDevice === 'no'} onChange={() => handleUserMgmtChange('cleanDevice', 'no')} className="hidden" />
                                                <span className={userMgmtData.cleanDevice === 'no' ? 'text-red-700' : ''}>❌ No, mantieni dati</span>
                                            </label>
                                        </div>
                                    </div>
                                    
                                    {/* 5. VPN da disattivare */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3 flex items-center gap-2">
                                            🔐 5. Aveva accesso VPN?
                                        </h4>
                                        <label className={`flex items-center gap-2 p-3 border-2 rounded-lg cursor-pointer text-sm ${userMgmtData.disableVpn ? 'border-red-500 bg-red-50' : 'border-gray-200'}`}>
                                            <input type="checkbox" checked={userMgmtData.disableVpn} onChange={(e) => handleUserMgmtChange('disableVpn', e.target.checked)} className="hidden" />
                                            <span className={userMgmtData.disableVpn ? 'text-red-700' : ''}>🔐 Sì, disattivare VPN</span>
                                        </label>
                                        <p className="text-xs text-gray-500 mt-2">Spunta se l'utente aveva accesso VPN per connessione da esterno</p>
                                    </div>
                                    
                                    {/* 6. Note */}
                                    <div className="bg-gray-50 rounded-xl p-4">
                                        <h4 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2 flex items-center gap-2">
                                            <FileText className="h-4 w-4" />
                                            6. Note Aggiuntive
                                        </h4>
                                        <textarea
                                            placeholder="Altre informazioni utili..."
                                            value={userMgmtData.disableNotes}
                                            onChange={(e) => handleUserMgmtChange('disableNotes', e.target.value)}
                                            className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-red-500 resize-none"
                                            rows="2"
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            {error && <p className="text-red-500 text-sm mt-4 text-center">{error}</p>}
                            </div>
                            
                            {/* Footer Fisso */}
                            <div className="flex-shrink-0 pt-3 pb-12 sm:pb-3 border-t border-gray-100 mt-auto bg-white flex gap-3">
                                <button type="button" onClick={() => setStep('user-mgmt-select')} className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-600 font-medium hover:bg-gray-50">
                                    Annulla
                                </button>
                                <button type="submit" className="flex-1 py-3 px-4 bg-gradient-to-r from-red-500 to-rose-600 text-white rounded-xl font-bold hover:from-red-600 hover:to-rose-700 shadow-lg shadow-red-200">
                                    📤 Invia Richiesta
                                </button>
                            </div>
                        </form>
                    )}

                    {/* STEP: Form Restore File - LAYOUT COMPATTO */}
                    {step === 'restore-form' && (
                        <form onSubmit={handleSubmitRestore} className="flex flex-col flex-1 min-h-0">
                            {/* Contenuto scrollabile */}
                            <div className="flex-1 overflow-y-auto min-h-0 space-y-3">
                            {/* Back button */}
                            <button type="button" onClick={handleBack} className="text-blue-600 hover:text-blue-800 text-sm flex items-center">
                                <ArrowLeft className="h-4 w-4 mr-1" /> Torna alla selezione
                            </button>

                            {/* Error Message */}
                            {error && (
                                <div className="bg-red-50 border border-red-200 text-red-700 p-2 rounded-lg flex items-center">
                                    <AlertTriangle className="h-4 w-4 mr-2 flex-shrink-0" />
                                    <span className="text-sm">{error}</span>
                                </div>
                            )}

                            {/* Riga 1: Due colonne - Cosa cerchiamo + Dove abitava */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {/* Cosa cerchiamo? */}
                                <div className="bg-blue-50 p-3 rounded-xl border border-blue-200">
                                    <label className="block font-bold text-blue-800 mb-1 flex items-center text-sm">
                                        <Search className="h-4 w-4 mr-1" />
                                        📁 Cosa cerchiamo?
                                    </label>
                                    <input
                                        type="text"
                                        name="fileName"
                                        value={restoreData.fileName}
                                        onChange={handleRestoreInputChange}
                                        placeholder="Es: Report_Vendite_2024.xlsx"
                                        className="w-full p-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                    />
                                </div>

                                {/* Dove abitava? */}
                                <div className="bg-green-50 p-3 rounded-xl border border-green-200">
                                    <label className="block font-bold text-green-800 mb-1 flex items-center text-sm">
                                        <FolderOpen className="h-4 w-4 mr-1" />
                                        📍 Dove abitava?
                                    </label>
                                    <input
                                        type="text"
                                        name="folderPath"
                                        value={restoreData.folderPath}
                                        onChange={handleRestoreInputChange}
                                        placeholder="Es: C:\Users\Mario\Documents"
                                        className="w-full p-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 font-mono text-xs"
                                    />
                                </div>
                            </div>

                            {/* Riga 2: A quando torniamo indietro? */}
                            <div className="bg-yellow-50 p-3 rounded-xl border border-yellow-200">
                                <label className="block font-bold text-yellow-800 mb-1 flex items-center text-sm">
                                    <Clock className="h-4 w-4 mr-1" />
                                    🕐 A quando torniamo indietro?
                                </label>
                                <input
                                    type="text"
                                    name="lastSeenDate"
                                    value={restoreData.lastSeenDate}
                                    onChange={handleRestoreInputChange}
                                    placeholder="Es: Ieri alle 17:00 oppure 15 Gennaio 2025"
                                    className="w-full p-2 border border-yellow-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-sm"
                                />
                            </div>

                            {/* Riga 3: Come lo vuoi? - Due opzioni affiancate */}
                            <div className="bg-purple-50 p-3 rounded-xl border border-purple-200">
                                <label className="block font-bold text-purple-800 mb-2 flex items-center text-sm">
                                    <Settings className="h-4 w-4 mr-1" />
                                    ⚙️ Come lo vuoi?
                                </label>
                                <div className="grid grid-cols-2 gap-2">
                                    <button
                                        type="button"
                                        onClick={() => setRestoreData(prev => ({ ...prev, restoreMode: 'replace' }))}
                                        className={`p-3 border-2 rounded-xl text-left transition-all ${
                                            restoreData.restoreMode === 'replace'
                                                ? 'border-red-400 bg-red-50'
                                                : 'border-gray-200 hover:border-gray-300 bg-white'
                                        }`}
                                    >
                                        <p className="font-bold text-gray-800 text-sm">🅰️ Sostituisci</p>
                                        <p className="text-xs text-red-500">⚠️ Perdi modifiche recenti</p>
                                    </button>
                                    
                                    <button
                                        type="button"
                                        onClick={() => setRestoreData(prev => ({ ...prev, restoreMode: 'copy' }))}
                                        className={`p-3 border-2 rounded-xl text-left transition-all ${
                                            restoreData.restoreMode === 'copy'
                                                ? 'border-green-400 bg-green-50'
                                                : 'border-gray-200 hover:border-gray-300 bg-white'
                                        }`}
                                    >
                                        <p className="font-bold text-gray-800 text-sm">🅱️ Copia <span className="text-green-600 text-xs">(Consigliato)</span></p>
                                        <p className="text-xs text-gray-500">Stessa posizione</p>
                                    </button>
                                </div>
                            </div>
                            </div>

                            {/* Submit Button - Footer Fisso */}
                            <div className="flex-shrink-0 pt-2 pb-12 sm:pb-2 border-t border-gray-100 mt-auto bg-white">
                                <button
                                    type="submit"
                                    className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-xl hover:bg-blue-700 transition-colors shadow-lg flex items-center justify-center"
                                >
                                    <Send className="mr-2 h-5 w-5" />
                                    Invia Richiesta Restore
                                </button>
                            </div>
                        </form>
                    )}

                    {/* STEP: Form Ticket Generico */}
                    {step === 'generic-form' && (
                        <form onSubmit={handleSubmitGeneric} className="flex flex-col flex-1 min-h-0">
                            {/* Contenuto scrollabile */}
                            <div className="flex-1 overflow-y-auto space-y-3 pb-2 min-h-0">
                            {/* Back button + User Info */}
                            <div className="flex items-center justify-between">
                                <button type="button" onClick={handleBack} className="text-purple-600 hover:text-purple-800 text-sm flex items-center">
                                    <ArrowLeft className="h-4 w-4 mr-1" /> Torna
                                </button>
                                {state.userName && (
                                    <div className="bg-blue-50 px-3 py-1.5 rounded-lg text-xs">
                                        <span className="text-blue-800 font-medium">{state.userName}</span>
                                        {state.userComputer && <span className="text-blue-600"> | {state.userComputer}</span>}
                                    </div>
                                )}
                            </div>

                            {/* Error Message */}
                            {error && (
                                <div className="bg-red-50 border border-red-200 text-red-700 p-2 rounded-lg flex items-center text-sm">
                                    <AlertTriangle className="h-4 w-4 mr-2 flex-shrink-0" />
                                    <span>{error}</span>
                                </div>
                            )}

                            {/* Layout a 2 colonne per desktop */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {/* Colonna sinistra: Oggetto + Descrizione */}
                                <div className="space-y-3">
                                    {/* Oggetto del problema */}
                                    <div className="bg-purple-50 p-3 rounded-xl border border-purple-200">
                                        <label className="block font-bold text-purple-800 text-sm mb-1 flex items-center">
                                            <FileText className="h-4 w-4 mr-1" />
                                            📝 Oggetto *
                                        </label>
                                        <input
                                            type="text"
                                            name="summary"
                                            value={genericData.summary}
                                            onChange={handleGenericInputChange}
                                            placeholder="Es: Stampante non stampa, PC lento..."
                                            data-testid="ticket-summary-input"
                                            className="w-full p-2 text-sm border border-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
                                            maxLength={200}
                                        />
                                    </div>

                                    {/* Descrizione dettagliata */}
                                    <div className="bg-blue-50 p-3 rounded-xl border border-blue-200">
                                        <label className="block font-bold text-blue-800 text-sm mb-1 flex items-center">
                                            <ClipboardList className="h-4 w-4 mr-1" />
                                            📋 Descrizione *
                                        </label>
                                        <p className="text-xs text-blue-600 mb-1">Cosa stavi facendo? C'è un errore? Da quando succede?</p>
                                        <textarea
                                            name="description"
                                            value={genericData.description}
                                            onChange={handleGenericInputChange}
                                            onPaste={handleTicketDescPaste}
                                            placeholder="Scrivi qui i dettagli... (puoi incollare uno screenshot con Ctrl+V)"
                                            data-testid="ticket-description-input"
                                            className="w-full p-2 text-sm border border-blue-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                                            rows={4}
                                        />
                                    </div>
                                </div>

                                {/* Colonna destra: Allegati + Altro */}
                                <div className="space-y-3">
                                    {/* Sezione Allegati */}
                                    <div className="bg-green-50 p-3 rounded-xl border border-green-200">
                                        <label className="block font-bold text-green-800 text-sm mb-1 flex items-center">
                                            <ImageIcon className="h-4 w-4 mr-1" />
                                            📎 Allegati
                                        </label>
                                        <p className="text-xs text-green-600 mb-2">Screenshot dell'errore = risoluzione più veloce!</p>
                                        
                                        {/* Input nascosti */}
                                        <input ref={fileInputRef} type="file" accept="image/*,.pdf,.doc,.docx,.txt,.log" multiple onChange={handleFileSelect} className="hidden" />
                                        <input ref={cameraInputRef} type="file" accept="image/*" capture="environment" onChange={handleFileSelect} className="hidden" />
                                        
                                        {/* Pulsanti in griglia */}
                                        <div className="grid grid-cols-2 gap-2 mb-2">
                                            <button type="button" onClick={() => fileInputRef.current?.click()} className="p-2 bg-white border-2 border-green-300 rounded-lg hover:bg-green-100 transition-colors flex items-center justify-center gap-1">
                                                <FolderOpen className="h-4 w-4 text-green-600" />
                                                <span className="text-xs font-medium text-green-700">Sfoglia</span>
                                            </button>
                                            {/* Scatta Foto - solo mobile */}
                                            {isMobile && (
                                                <button type="button" onClick={() => cameraInputRef.current?.click()} className="p-2 bg-white border-2 border-green-300 rounded-lg hover:bg-green-100 transition-colors flex items-center justify-center gap-1">
                                                    <ImageIcon className="h-4 w-4 text-green-600" />
                                                    <span className="text-xs font-medium text-green-700">📷 Foto</span>
                                                </button>
                                            )}
                                            {/* Cattura Schermo - solo desktop */}
                                            {!isMobile && (
                                                <button type="button" onClick={handleScreenshotCapture} className="p-2 bg-white border-2 border-blue-300 rounded-lg hover:bg-blue-100 transition-colors flex items-center justify-center gap-1">
                                                    <Monitor className="h-4 w-4 text-blue-600" />
                                                    <span className="text-xs font-medium text-blue-700">🖥️ Screenshot</span>
                                                </button>
                                            )}
                                            {/* Galleria - solo mobile */}
                                            {isMobile && (
                                                <button type="button" onClick={() => { const inp = document.createElement('input'); inp.type='file'; inp.accept='image/*'; inp.onchange=handleFileSelect; inp.click(); }} className="p-2 bg-white border-2 border-green-300 rounded-lg hover:bg-green-100 transition-colors flex items-center justify-center gap-1">
                                                    <ImageIcon className="h-4 w-4 text-green-600" />
                                                    <span className="text-xs font-medium text-green-700">🖼️ Galleria</span>
                                                </button>
                                            )}
                                        </div>
                                        
                                        {/* Lista allegati compatta */}
                                        {attachments.length > 0 && (
                                            <div className="space-y-1">
                                                {attachments.map((att) => (
                                                    <div key={att.id} className="flex items-center bg-white p-1.5 rounded-lg border border-green-200 text-xs">
                                                        {att.preview ? (
                                                            <img src={att.preview} alt={att.name} className="w-8 h-8 object-cover rounded mr-2" />
                                                        ) : (
                                                            <FileText className="h-6 w-6 text-gray-400 mr-2" />
                                                        )}
                                                        <span className="flex-1 truncate">{att.name}</span>
                                                        <button type="button" onClick={() => removeAttachment(att.id)} className="p-0.5 text-red-500 hover:bg-red-50 rounded">
                                                            <XCircle className="h-4 w-4" />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* Altro che può essere utile */}
                                    <div className="bg-gray-50 p-3 rounded-xl border border-gray-200">
                                        <label className="block font-bold text-gray-700 text-sm mb-1 flex items-center">
                                            <Lightbulb className="h-4 w-4 mr-1 text-yellow-500" />
                                            💡 Note aggiuntive
                                        </label>
                                        <textarea
                                            name="additionalInfo"
                                            value={genericData.additionalInfo || ''}
                                            onChange={handleGenericInputChange}
                                            placeholder="Link, info extra..."
                                            className="w-full p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 resize-none"
                                            rows={2}
                                        />
                                    </div>

                                    {/* Callback se descrizione lunga */}
                                    {genericData.description && genericData.description.length > 100 && (
                                        <div className="bg-yellow-50 p-3 rounded-xl border border-yellow-200">
                                            <label className="block font-bold text-yellow-800 text-sm mb-1 flex items-center">
                                                <Phone className="h-4 w-4 mr-1" />
                                                📞 Vuoi essere richiamato?
                                            </label>
                                            <input
                                                type="tel"
                                                name="phoneCallback"
                                                value={genericData.phoneCallback || ''}
                                                onChange={handleGenericInputChange}
                                                placeholder="Numero di telefono"
                                                className="w-full p-2 text-sm border border-yellow-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            </div>

                            {/* Submit Button - Footer Fisso */}
                            <div className="flex-shrink-0 pt-2 pb-12 sm:pb-2 border-t border-gray-100 mt-auto bg-white">
                                <button
                                    type="submit"
                                    disabled={!genericData.summary || !genericData.description}
                                    data-testid="ticket-submit-btn"
                                    className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 rounded-xl font-bold hover:from-purple-700 hover:to-indigo-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                >
                                    <Send className="h-5 w-5 mr-2" />
                                    Invia Ticket
                                </button>
                            </div>
                        </form>
                    )}

                    {/* Loading Step */}
                    {step === 'loading' && (
                        <div className="text-center py-12">
                            <Loader2 className="h-12 w-12 text-purple-600 animate-spin mx-auto mb-4" />
                            <p className="text-lg font-semibold text-gray-700">Creazione ticket in corso...</p>
                            <p className="text-gray-500 mt-2">Stiamo registrando la tua richiesta su Jira</p>
                        </div>
                    )}

                    {/* Success Step */}
                    {step === 'success' && createdTicket && (
                        <div className="text-center py-6 px-4">
                            {/* Icona Successo Animata */}
                            <div className="bg-gradient-to-br from-green-400 to-green-600 rounded-full p-5 w-24 h-24 mx-auto mb-6 flex items-center justify-center shadow-lg animate-bounce">
                                <CheckCircle2 className="h-12 w-12 text-white" />
                            </div>
                            
                            {/* Titolo */}
                            <h3 className="text-2xl font-bold text-gray-800 mb-2">
                                🎉 Richiesta Inviata!
                            </h3>
                            <p className="text-gray-500 mb-6">Abbiamo ricevuto tutto correttamente</p>
                            
                            {/* Box ID Ticket */}
                            <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-5 rounded-xl mb-6 border-2 border-purple-200">
                                <p className="text-sm text-purple-600 font-semibold uppercase tracking-wide mb-1">
                                    📋 Numero Ticket
                                </p>
                                <p className="text-3xl font-mono font-bold text-purple-700">
                                    {createdTicket.key || createdTicket.id}
                                </p>
                                <p className="text-xs text-purple-500 mt-2">
                                    💡 Conserva questo numero per riferimento
                                </p>
                            </div>
                            
                            {/* Timeline - Cosa succede ora */}
                            <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
                                <p className="font-bold text-gray-700 mb-3 text-center">📌 Cosa succede adesso?</p>
                                <div className="space-y-3">
                                    <div className="flex items-center gap-3">
                                        <div className="bg-green-500 text-white rounded-full w-7 h-7 flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
                                        <span className="text-gray-600 text-sm">Il team riceve la tua richiesta</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <div className="bg-blue-500 text-white rounded-full w-7 h-7 flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
                                        <span className="text-gray-600 text-sm">Un tecnico la prende in carico</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <div className="bg-purple-500 text-white rounded-full w-7 h-7 flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
                                        <span className="text-gray-600 text-sm">Ti contattiamo per aggiornarti</span>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Messaggio finale */}
                            <p className="text-gray-600 mb-6 text-sm">
                                😊 <strong>Grazie per averci scritto!</strong><br/>
                                Siamo qui per aiutarti.
                            </p>
                            
                            {/* Bottone Chiudi */}
                            <button
                                onClick={handleClose}
                                className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-8 py-3 rounded-xl font-bold hover:from-purple-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                ✓ Ho capito, chiudi
                            </button>
                        </div>
                    )}

                    {/* Error Step */}
                    {step === 'error' && (
                        <div className="text-center py-6 px-4">
                            {/* Icona Errore */}
                            <div className="bg-gradient-to-br from-red-400 to-red-600 rounded-full p-5 w-24 h-24 mx-auto mb-6 flex items-center justify-center shadow-lg">
                                <AlertTriangle className="h-12 w-12 text-white" />
                            </div>
                            
                            {/* Titolo */}
                            <h3 className="text-2xl font-bold text-gray-800 mb-2">
                                😔 Oops! Qualcosa non ha funzionato
                            </h3>
                            
                            {/* Messaggio Errore */}
                            <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 mb-6">
                                <p className="text-red-700 text-sm">
                                    {error || 'Si è verificato un errore durante la creazione del ticket.'}
                                </p>
                            </div>
                            
                            {/* Suggerimenti */}
                            <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
                                <p className="font-bold text-gray-700 mb-3 text-center">💡 Cosa puoi fare?</p>
                                <div className="space-y-2 text-sm text-gray-600">
                                    <p>1️⃣ <strong>Riprova</strong> - A volte basta un secondo tentativo</p>
                                    <p>2️⃣ <strong>Controlla la connessione</strong> - Verifica di essere online</p>
                                    <p>3️⃣ <strong>Chiamaci</strong> - Se non funziona, siamo al +39 035 31 09 00 (Tasto 1)</p>
                                </div>
                            </div>
                            
                            {/* Bottoni */}
                            <div className="flex gap-3 justify-center">
                                <button
                                    onClick={() => setStep('select')}
                                    className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 py-3 rounded-xl font-bold hover:from-purple-700 hover:to-indigo-700 transition-all shadow-lg"
                                >
                                    🔄 Riprova
                                </button>
                                <button
                                    onClick={handleClose}
                                    className="bg-gray-200 text-gray-700 px-6 py-3 rounded-xl font-bold hover:bg-gray-300 transition-colors"
                                >
                                    Chiudi
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// MY TICKETS MODAL - Con Autenticazione 2FA (Microsoft Authenticator / TOTP)
// ============================================================================
const MyTicketsModal = ({ onClose }) => {
    const { state, dispatch } = useContext(ChatContext);
    // step: 'email' | 'setup' | 'totp' | 'verified'
    const [step, setStep] = useState('email');
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [totpCode, setTotpCode] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [secretKey, setSecretKey] = useState('');
    const [expandedTicket, setExpandedTicket] = useState(null);
    const [ticketFilter, updateTicketFilter] = useTicketFilter();
    const isNewTicket = (t) => (state.ticketUpdates || []).some(u => u.key === (t.key || t.id));
    const [thread, setThread] = useState({}); // key -> {comments, has_unread}
    const [replyText, setReplyText] = useState('');
    const [replySending, setReplySending] = useState(false);
    const [replyImages, setReplyImages] = useState([]); // [{ data, name } | { file, name, kind, isRaw }]
    const [uploadProgress, setUploadProgress] = useState(null); // % upload video/file (null = nessun upload)
    const [replyImageError, setReplyImageError] = useState('');
    const replyFileInputRef = useRef(null);
    const [refreshingTicket, setRefreshingTicket] = useState(null);
    const [showPortalGuide, setShowPortalGuide] = useState(false);
    const [showPortalReminder, setShowPortalReminder] = useState(false);

    const PORTAL_URL = 'https://customer.helpdesk.86bit.it/servicedesk/customer/portal/3';
    const PORTAL_REMINDER_DAYS = 3;

    // L'utente conferma di aver creato l'account sul portale → non lo infastidiamo più.
    const markPortalRegistered = () => {
        try {
            localStorage.setItem('spark-portal-registered-v1', '1');
            localStorage.setItem('spark-portal-guide-seen-v1', '1');
        } catch (e) {}
        setShowPortalGuide(false);
        setShowPortalReminder(false);
    };
    // Rimanda il promemoria (segna "visto" e resetta il timer a ora).
    const snoozePortalReminder = () => {
        try {
            localStorage.setItem('spark-portal-guide-seen-v1', '1');
            localStorage.setItem('spark-portal-reminder-at-v1', new Date().toISOString());
        } catch (e) {}
        setShowPortalGuide(false);
        setShowPortalReminder(false);
    };

    const refreshTicket = async (key) => {
        setRefreshingTicket(key);
        if (expandedTicket !== key) { setExpandedTicket(key); setReplyText(''); }
        await loadThread(key);
        fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/seen`, { method: 'POST' }).catch(() => {});
        dispatch({ type: 'SET_STATE', payload: { ticketUpdates: (state.ticketUpdates || []).filter(t => t.key !== key) } });
        setRefreshingTicket(null);
    };

    const loadThread = async (key) => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/thread`);
            const d = await r.json();
            setThread(prev => ({ ...prev, [key]: d }));
        } catch (e) {}
    };
    const toggleExpand = (key, currentlyExpanded) => {
        if (currentlyExpanded) { setExpandedTicket(null); return; }
        setExpandedTicket(key);
        setReplyText('');
        setReplyImages([]);
        setReplyImageError('');
        loadThread(key);
        markSeen(key);
    };
    // Segna il ticket come letto (backend + rimuove il badge di aggiornamento in-app)
    const markSeen = (key) => {
        fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/seen`, { method: 'POST' }).catch(() => {});
        dispatch({ type: 'SET_STATE', payload: { ticketUpdates: (state.ticketUpdates || []).filter(t => t.key !== key) } });
    };

    // --- Risposta diretta dentro Spark (pubblica su Jira via account di servizio) ---
    const addReplyImageFiles = (files) => {
        const list = Array.from(files || []);
        if (list.length === 0) return;
        setReplyImageError('');
        list.forEach((file) => {
            const isImage = (file.type || '').startsWith('image/');
            const isVideo = (file.type || '').startsWith('video/');
            if (!isImage && !isVideo) { setReplyImageError('Puoi allegare solo immagini o video.'); return; }
            if (isVideo) {
                if (file.size > 100 * 1024 * 1024) { setReplyImageError('Il video può essere al massimo 100MB.'); return; }
                setReplyImages((prev) => prev.length >= 10 ? prev : [...prev, { file, name: file.name || 'video.mp4', kind: 'video', isRaw: true }]);
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                // Immagine grande → caricata come file (senza data-URL) per evitare limiti di dimensione
                setReplyImages((prev) => prev.length >= 10 ? prev : [...prev, { file, name: file.name || 'immagine', kind: 'image', isRaw: true }]);
                return;
            }
            const reader = new FileReader();
            reader.onload = () => { setReplyImages((prev) => prev.length >= 10 ? prev : [...prev, { data: reader.result, name: file.name || 'screenshot.png' }]); };
            reader.readAsDataURL(file);
        });
    };
    const handleReplyImagePick = (e) => { const files = Array.from(e.target.files || []); e.target.value = ''; addReplyImageFiles(files); };
    const handleReplyPaste = (e) => {
        const items = e.clipboardData && e.clipboardData.items;
        if (!items) return;
        const imgs = [];
        for (const it of items) { if (it.type && it.type.startsWith('image/')) { const f = it.getAsFile(); if (f) imgs.push(f); } }
        if (imgs.length > 0) { e.preventDefault(); addReplyImageFiles(imgs); }
    };
    const removeReplyImage = (idx) => setReplyImages((prev) => prev.filter((_, i) => i !== idx));
    const sendReply = async (key) => {
        const body = replyText.trim();
        if (!body && replyImages.length === 0) return;
        setReplySending(true);
        // Nome reale ricavato dall'email (es. gabriele.capelli -> "Gabriele Capelli"); fallback al nome PC
        const em = (email || '').trim().toLowerCase();
        const derivedName = em ? em.split('@')[0].split(/[._-]+/).filter(Boolean).map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ') : '';
        const author = derivedName || state.userName || 'Utente';
        const dataImages = replyImages.filter(x => !x.isRaw);
        const rawFiles = replyImages.filter(x => x.isRaw);
        try {
            // 1) Testo + screenshot (immagini piccole) via JSON /reply
            if (body || dataImages.length > 0) {
                const r = await fetch(`${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/reply`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ body, author, author_email: em, images: dataImages, public_base: API_BASE_URL })
                });
                if (!r.ok) { setReplyImageError('Invio non riuscito. Riprova.'); setReplySending(false); return; }
            }
            // 2) Video / immagini grandi via multipart (nessun data-URL → nessun limite base64)
            if (rawFiles.length > 0) {
                setUploadProgress(0);
                for (let i = 0; i < rawFiles.length; i++) {
                    const rf = rawFiles[i];
                    const fd = new FormData();
                    fd.append('file', rf.file, rf.name);
                    fd.append('author', author);
                    fd.append('author_email', em);
                    fd.append('public_base', API_BASE_URL);
                    // XMLHttpRequest per avere l'avanzamento reale dell'upload
                    await new Promise((resolve, reject) => {
                        const xhr = new XMLHttpRequest();
                        xhr.open('POST', `${API_BASE_URL}/api/v1/jira/ticket/${encodeURIComponent(key)}/attachment`);
                        xhr.upload.onprogress = (ev) => {
                            if (ev.lengthComputable) {
                                const filePct = ev.loaded / ev.total;
                                setUploadProgress(Math.round(((i + filePct) / rawFiles.length) * 100));
                            }
                        };
                        xhr.onload = () => { (xhr.status >= 200 && xhr.status < 300) ? resolve() : reject(new Error('HTTP ' + xhr.status)); };
                        xhr.onerror = () => reject(new Error('network'));
                        xhr.send(fd);
                    });
                }
                setUploadProgress(null);
            }
            setReplyText(''); setReplyImages([]); setReplyImageError(''); loadThread(key);
        } catch (e) { setReplyImageError('Caricamento allegato non riuscito (file troppo grande?).'); setUploadProgress(null); }
        setReplySending(false);
    };
    const [showSecret, setShowSecret] = useState(false);
    const [rememberDevice, setRememberDevice] = useState(true);
    const totpInputRefs = useRef([]);

    // Overlay/promemoria portale: rimossi (riferimenti al portale eliminati)
    useEffect(() => {}, [step]);

    // Registra il dispositivo come fidato (30 giorni) dopo 2FA riuscito
    const registerTrustedDevice = async (userEmail) => {
        if (!rememberDevice) return;
        try {
            const deviceId = getSparkDeviceId();
            const r = await fetch(`${API_BASE_URL}/api/v1/auth/device/register`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
                body: JSON.stringify({ email: userEmail, deviceId, deviceInfo: { userAgent: navigator.userAgent, platform: navigator.platform } })
            });
            const d = await r.json();
            if (d.success && d.deviceToken) {
                localStorage.setItem('spark-device-token', d.deviceToken);
            }
        } catch (e) {}
    };

    // Carica email da stato o localStorage come suggerimento + verifica dispositivo fidato
    useEffect(() => {
        let savedEmail = state.userEmail || '';
        if (!savedEmail) {
            try {
                savedEmail = localStorage.getItem('spark-user-email-v1') || localStorage.getItem('spark-user-email') || '';
            } catch (e) {}
        }
        if (savedEmail) setEmail(savedEmail);

        // Se il dispositivo è già fidato (ricordami 30 giorni), salta il 2FA
        (async () => {
            const deviceToken = localStorage.getItem('spark-device-token');
            const deviceId = localStorage.getItem('spark-device-id');
            if (!savedEmail || !deviceToken || !deviceId) return;
            try {
                const r = await fetch(`${API_BASE_URL}/api/v1/auth/device/verify`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
                    body: JSON.stringify({ email: savedEmail.trim().toLowerCase(), deviceId, deviceToken })
                });
                const d = await r.json();
                if (d.success && d.trusted) {
                    if (d.token) saveAuthToken(d.token);
                    setStep('verified');
                    setEmail(savedEmail);
                    loadTicketsFor(savedEmail);
                }
            } catch (e) {}
        })();
    }, []);

    const loadTicketsFor = async (mail) => {
        setLoading(true);
        try {
            const userTickets = await MOCK_API.getUserTickets(mail.trim().toLowerCase(), state.userName);
            setTickets(userTickets);
        } catch (err) { setError('Impossibile caricare i ticket'); }
        setLoading(false);
    };

    // --- Passkey / WebAuthn helpers ---
    const b64urlToBuf = (s) => { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; const bin = atob(s); const b = new Uint8Array(bin.length); for (let i = 0; i < bin.length; i++) b[i] = bin.charCodeAt(i); return b.buffer; };
    const bufToB64url = (buf) => { const b = new Uint8Array(buf); let s = ''; for (let i = 0; i < b.length; i++) s += String.fromCharCode(b[i]); return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); };
    const passkeySupported = () => typeof window !== 'undefined' && !!(window.PublicKeyCredential && navigator.credentials);
    const passkeyLogin = async (mail) => {
        const em = mail.trim().toLowerCase();
        const bR = await fetch(`${API_BASE_URL}/api/v1/webauthn/authenticate/begin`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em }) });
        if (!bR.ok) throw new Error('begin');
        const o = await bR.json();
        const publicKey = { ...o, challenge: b64urlToBuf(o.challenge), allowCredentials: (o.allowCredentials || []).map(c => ({ ...c, id: b64urlToBuf(c.id) })) };
        const cred = await navigator.credentials.get({ publicKey });
        const payload = { id: cred.id, rawId: bufToB64url(cred.rawId), type: cred.type, response: { clientDataJSON: bufToB64url(cred.response.clientDataJSON), authenticatorData: bufToB64url(cred.response.authenticatorData), signature: bufToB64url(cred.response.signature), userHandle: cred.response.userHandle ? bufToB64url(cred.response.userHandle) : null } };
        const cR = await fetch(`${API_BASE_URL}/api/v1/webauthn/authenticate/complete`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em, credential: payload }) });
        if (!cR.ok) throw new Error('verify');
        return true;
    };
    const passkeyRegister = async (mail) => {
        const em = mail.trim().toLowerCase();
        const bR = await fetch(`${API_BASE_URL}/api/v1/webauthn/register/begin`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em }) });
        if (!bR.ok) throw new Error('begin');
        const o = await bR.json();
        const publicKey = { ...o, challenge: b64urlToBuf(o.challenge), user: { ...o.user, id: b64urlToBuf(o.user.id) }, excludeCredentials: (o.excludeCredentials || []).map(c => ({ ...c, id: b64urlToBuf(c.id) })) };
        const cred = await navigator.credentials.create({ publicKey });
        const payload = { id: cred.id, rawId: bufToB64url(cred.rawId), type: cred.type, response: { clientDataJSON: bufToB64url(cred.response.clientDataJSON), attestationObject: bufToB64url(cred.response.attestationObject), transports: cred.response.getTransports ? cred.response.getTransports() : [] } };
        const cR = await fetch(`${API_BASE_URL}/api/v1/webauthn/register/complete`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em, credential: payload }) });
        if (!cR.ok) throw new Error('reg');
        return true;
    };
    const startPasskeyAuth = async () => {
        setError(''); setLoading(true);
        try { await passkeyLogin(email); await loadTicketsFor(email); setStep('verified'); }
        catch (e) { setError('Accesso con passkey non riuscito. Usa il codice Authenticator.'); }
        setLoading(false);
    };
    const [pkRegState, setPkRegState] = useState('idle');
    const registerPasskeyNow = async () => {
        if (!passkeySupported()) { setPkRegState('error'); return; }
        try { await passkeyRegister(email); setPkRegState('done'); } catch (e) { setPkRegState('error'); }
    };
    const checkTotpStatusFallback = async () => {
        setLoading(true); setError('');
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/status`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
                body: JSON.stringify({ email: email.trim().toLowerCase() })
            });
            const data = await response.json();
            if (data.success) {
                if (data.totpEnabled) { setStep('totp'); }
                else { setQrCodeUrl(data.qrCodeUrl); setSecretKey(data.secretKey); setStep('setup'); }
            } else { setError(data.error || data.detail || 'Errore verifica stato. Riprova.'); }
        } catch (err) { setError('Errore di connessione. Verifica la tua rete.'); }
        setLoading(false);
    };


    // Step 1: Verifica se l'utente ha già configurato TOTP
    const checkTotpStatus = async () => {
        if (!email || !email.includes('@')) {
            setError('Inserisci un\'email valida');
            return;
        }

        setLoading(true);
        setError('');

        // Passkey primaria: se questa email ha già una passkey, usala (con fallback TOTP)
        if (passkeySupported()) {
            try {
                const pk = await fetch(`${API_BASE_URL}/api/v1/webauthn/has-passkey`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email.trim().toLowerCase() }) });
                const pkd = await pk.json();
                if (pkd.has_passkey) { setLoading(false); setStep('passkey'); return; }
            } catch (e) { /* fallback al flusso TOTP */ }
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/status`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email: email.trim().toLowerCase() })
            });

            const data = await response.json();

            if (data.success) {
                if (data.totpEnabled) {
                    // TOTP già configurato, vai alla verifica
                    setStep('totp');
                } else {
                    // TOTP non configurato, mostra setup con QR code
                    setQrCodeUrl(data.qrCodeUrl);
                    setSecretKey(data.secretKey);
                    setStep('setup');
                }
            } else {
                setError(data.error || data.detail || 'Errore verifica stato. Riprova.');
            }
        } catch (err) {
            console.error('TOTP status check error:', err);
            setError('Errore di connessione. Verifica la tua rete.');
        }

        setLoading(false);
    };

    // Step 2: Conferma setup TOTP (prima volta)
    const confirmTotpSetup = async () => {
        if (totpCode.length !== 6) {
            setError('Inserisci il codice a 6 cifre dall\'app');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/setup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: email.trim().toLowerCase(),
                    token: totpCode,
                    secret: secretKey  // Invia la chiave segreta per la verifica
                })
            });

            const data = await response.json();

            if (data.success) {
                // Salva JWT token se presente
                if (data.token) {
                    saveAuthToken(data.token);
                }
                await registerTrustedDevice(email.trim().toLowerCase());
                setStep('verified');
                loadTickets();
            } else {
                setError(data.error || 'Codice non valido. Riprova.');
                setTotpCode('');
            }
        } catch (err) {
            console.error('TOTP setup error:', err);
            setError('Errore di connessione. Verifica la tua rete.');
        }

        setLoading(false);
    };

    // Step 3: Verifica TOTP (utenti già registrati)
    const verifyTotp = async () => {
        if (totpCode.length !== 6) {
            setError('Inserisci il codice a 6 cifre dall\'app');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: email.trim().toLowerCase(),
                    token: totpCode
                })
            });

            const data = await response.json();

            if (data.success) {
                // Salva JWT token se presente
                if (data.token) {
                    saveAuthToken(data.token);
                }
                await registerTrustedDevice(email.trim().toLowerCase());
                setStep('verified');
                loadTickets();
            } else {
                setError(data.error || 'Codice non valido. Riprova.');
                setTotpCode('');
            }
        } catch (err) {
            console.error('TOTP verify error:', err);
            setError('Errore di connessione. Verifica la tua rete.');
        }

        setLoading(false);
    };

    // Carica ticket dopo verifica
    const loadTickets = async () => {
        setLoading(true);
        try {
            const userTickets = await MOCK_API.getUserTickets(email.trim().toLowerCase(), state.userName);
            setTickets(userTickets);
        } catch (err) {
            setError('Impossibile caricare i ticket');
        }
        setLoading(false);
    };

    // Gestione input TOTP (6 caselle separate)
    const handleTotpChange = (index, value) => {
        if (value.length > 1) value = value.slice(-1);
        if (!/^\d*$/.test(value)) return;

        const newCode = totpCode.split('');
        newCode[index] = value;
        setTotpCode(newCode.join(''));

        // Auto-focus next input
        if (value && index < 5) {
            totpInputRefs.current[index + 1]?.focus();
        }
    };

    const handleTotpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !totpCode[index] && index > 0) {
            totpInputRefs.current[index - 1]?.focus();
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return '';
            return date.toLocaleDateString('it-IT', { day: '2-digit', month: 'short' });
        } catch (e) {
            return '';
        }
    };

    // Copia chiave segreta negli appunti
    const copySecretKey = () => {
        navigator.clipboard.writeText(secretKey);
        alert('Chiave copiata negli appunti!');
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50 animate-fade-in" onClick={onClose}>
            <div className={`${state.darkMode ? 'bg-gray-800' : 'bg-white'} rounded-2xl shadow-2xl w-full max-w-2xl h-[90vh] sm:h-[85vh] flex flex-col animate-scale-in`} onClick={e => e.stopPropagation()}>
                {/* Guida registrazione portale (primo accesso) */}
                {showPortalGuide && (
                    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4" onClick={e => e.stopPropagation()} data-testid="portal-guide-overlay">
                        <div className={`${state.darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} rounded-2xl shadow-2xl w-full max-w-md p-6 animate-scale-in`}>
                            <div className="flex items-center gap-2 mb-3">
                                <KeyRound className="h-6 w-6 text-blue-600" />
                                <h3 className="text-lg font-bold">Attiva il tuo accesso al portale</h3>
                            </div>
                            <p className="text-sm mb-3 leading-relaxed">
                                Per <strong>rispondere ai tuoi ticket a tuo nome</strong> usi il portale assistenza 86BIT. La prima volta devi creare la tua password (2 minuti):
                            </p>
                            <ol className="text-sm space-y-1.5 mb-2 list-decimal list-inside opacity-90">
                                <li>Apri il portale col pulsante qui sotto</li>
                                <li>Inserisci la tua email aziendale</li>
                                <li>Clicca <strong>"Crea una password"</strong> e segui i passaggi</li>
                                <li>Spunta <strong>"Ricordami"</strong> e, quando il browser lo chiede, <strong>salva la password</strong>: così resterai sempre loggato</li>
                            </ol>
                            <p className="text-xs mb-4 opacity-70">💡 Salvando la password nel browser entrerai in automatico ai prossimi accessi, senza ridigitarla.</p>
                            <a
                                href={PORTAL_URL}
                                target="_blank" rel="noopener noreferrer"
                                onClick={snoozePortalReminder}
                                className="flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 text-white transition-colors"
                                data-testid="portal-guide-register-btn"
                            >
                                <ExternalLink className="h-4 w-4" /> Vai al portale e crea la password
                            </a>
                            <div className="mt-3 flex items-center justify-between gap-2">
                                <button onClick={markPortalRegistered} className="text-xs text-green-600 hover:underline font-medium" data-testid="portal-guide-registered-btn">
                                    Ho già l'account
                                </button>
                                <button onClick={snoozePortalReminder} className="text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200" data-testid="portal-guide-dismiss-btn">
                                    Più tardi
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-3 sm:p-4 flex items-center justify-between rounded-t-2xl flex-shrink-0">
                    <div className="flex items-center gap-2 sm:gap-3">
                        <Shield className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
                        <h2 className="text-lg sm:text-xl font-bold text-white">I Miei Ticket</h2>
                        <span className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full">2FA</span>
                    </div>
                    <button onClick={onClose} className="p-1.5 sm:p-2 rounded-full hover:bg-white/20 text-white transition-colors" data-testid="close-my-tickets-modal">
                        <XCircle className="h-5 w-5 sm:h-6 sm:w-6" />
                    </button>
                </div>

                {/* Content */}
                <div className={`flex-1 overflow-y-auto p-4 sm:p-6 ${state.darkMode ? 'text-white' : ''}`}>
                    
                    {/* STEP 1: Inserisci Email */}
                    {step === 'email' && (
                        <div className="max-w-md mx-auto">
                            <div className="text-center mb-6">
                                <div className="bg-blue-100 rounded-full p-4 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                                    <Mail className="h-10 w-10 text-blue-600" />
                                </div>
                                <h3 className={`text-xl font-bold mb-2 ${state.darkMode ? 'text-white' : 'text-gray-800'}`}>
                                    Verifica la tua identità
                                </h3>
                                <p className={`text-sm ${state.darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                    Inserisci la tua email per accedere ai ticket tramite Microsoft Authenticator.
                                </p>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className={`block text-sm font-medium mb-1 ${state.darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                        Email aziendale
                                    </label>
                                    <div className="relative">
                                        <AtSign className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => { setEmail(e.target.value); setError(''); }}
                                            placeholder="nome.cognome@azienda.it"
                                            className={`w-full pl-10 pr-4 py-3 rounded-xl border focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                                state.darkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300'
                                            }`}
                                            autoFocus
                                            data-testid="2fa-email-input"
                                        />
                                    </div>
                                </div>

                                {error && (
                                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-lg text-sm" data-testid="2fa-error-message">
                                        {error}
                                    </div>
                                )}

                                <button
                                    onClick={checkTotpStatus}
                                    disabled={loading || !email}
                                    className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-xl font-bold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
                                    data-testid="2fa-continue-btn"
                                >
                                    {loading ? (
                                        <Loader2 className="h-5 w-5 animate-spin" />
                                    ) : (
                                        <>
                                            <Smartphone className="h-5 w-5" />
                                            Continua con Authenticator
                                        </>
                                    )}
                                </button>
                            </div>

                            <div className={`mt-6 p-4 rounded-xl ${state.darkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                                <p className={`text-xs ${state.darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                    🔒 <strong>Autenticazione a 2 fattori</strong><br/>
                                    Usa Microsoft Authenticator, Google Authenticator o app TOTP compatibili per proteggere i tuoi dati.
                                </p>
                            </div>
                        </div>
                    )}

                    {/* STEP 2: Setup TOTP (prima configurazione) */}
                    {step === 'setup' && (
                        <div className="max-w-md mx-auto">
                            <div className="text-center mb-6">
                                <div className="bg-purple-100 rounded-full p-4 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                                    <Smartphone className="h-10 w-10 text-purple-600" />
                                </div>
                                <h3 className={`text-xl font-bold mb-2 ${state.darkMode ? 'text-white' : 'text-gray-800'}`}>
                                    Configura Authenticator
                                </h3>
                                <p className={`text-sm ${state.darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                    Scansiona il QR code con Microsoft Authenticator o un'app TOTP compatibile.
                                </p>
                            </div>

                            <div className="space-y-4">
                                {/* QR Code */}
                                <div className={`p-4 rounded-xl text-center ${state.darkMode ? 'bg-gray-700' : 'bg-white border border-gray-200'}`}>
                                    {qrCodeUrl ? (
                                        <img 
                                            src={qrCodeUrl} 
                                            alt="QR Code per Authenticator" 
                                            className="mx-auto w-48 h-48 rounded-lg"
                                            data-testid="totp-qr-code"
                                        />
                                    ) : (
                                        <div className="w-48 h-48 mx-auto bg-gray-200 rounded-lg flex items-center justify-center">
                                            <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
                                        </div>
                                    )}
                                </div>

                                {/* Chiave manuale */}
                                <div className={`p-3 rounded-xl ${state.darkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                                    <div className="flex items-center justify-between mb-2">
                                        <span className={`text-xs font-medium ${state.darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                            Non riesci a scansionare? Inserisci manualmente:
                                        </span>
                                        <button 
                                            onClick={() => setShowSecret(!showSecret)}
                                            className="text-blue-600 text-xs hover:underline"
                                        >
                                            {showSecret ? 'Nascondi' : 'Mostra'}
                                        </button>
                                    </div>
                                    {showSecret && (
                                        <div className="flex items-center gap-2">
                                            <code className={`flex-1 text-xs font-mono p-2 rounded ${state.darkMode ? 'bg-gray-600' : 'bg-white border'}`}>
                                                {secretKey}
                                            </code>
                                            <button 
                                                onClick={copySecretKey}
                                                className="p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                                                title="Copia"
                                            >
                                                <Copy className="h-4 w-4" />
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Input codice TOTP */}
                                <div>
                                    <label className={`block text-sm font-medium mb-2 text-center ${state.darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                        Inserisci il codice a 6 cifre dall'app:
                                    </label>
                                    <div className="flex justify-center gap-2 sm:gap-3">
                                        {[0, 1, 2, 3, 4, 5].map((index) => (
                                            <input
                                                key={index}
                                                ref={el => totpInputRefs.current[index] = el}
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={1}
                                                value={totpCode[index] || ''}
                                                onChange={(e) => handleTotpChange(index, e.target.value)}
                                                onKeyDown={(e) => handleTotpKeyDown(index, e)}
                                                className={`w-10 h-12 sm:w-12 sm:h-14 text-center text-xl font-bold rounded-xl border-2 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${
                                                    state.darkMode 
                                                        ? 'bg-gray-700 border-gray-600 text-white' 
                                                        : 'bg-white border-gray-300'
                                                }`}
                                                autoFocus={index === 0}
                                                data-testid={`totp-input-${index}`}
                                            />
                                        ))}
                                    </div>
                                </div>

                                {error && (
                                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-lg text-sm text-center">
                                        {error}
                                    </div>
                                )}

                                <button
                                    onClick={confirmTotpSetup}
                                    disabled={loading || totpCode.length !== 6}
                                    className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 rounded-xl font-bold hover:from-purple-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
                                    data-testid="totp-setup-confirm-btn"
                                >
                                    {loading ? (
                                        <Loader2 className="h-5 w-5 animate-spin" />
                                    ) : (
                                        <>
                                            <CheckCircle className="h-5 w-5" />
                                            Completa configurazione
                                        </>
                                    )}
                                </button>

                                <button
                                    onClick={() => { setStep('email'); setTotpCode(''); setError(''); }}
                                    className={`w-full py-2 text-sm ${state.darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-600 hover:text-gray-700'}`}
                                >
                                    ← Cambia email
                                </button>
                            </div>
                        </div>
                    )}

                    {/* STEP 3: Verifica TOTP (utenti già registrati) */}
                    {step === 'totp' && (
                        <div className="max-w-md mx-auto">
                            <div className="text-center mb-6">
                                <div className="bg-green-100 rounded-full p-4 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                                    <KeyRound className="h-10 w-10 text-green-600" />
                                </div>
                                <h3 className={`text-xl font-bold mb-2 ${state.darkMode ? 'text-white' : 'text-gray-800'}`}>
                                    Inserisci codice Authenticator
                                </h3>
                                <p className={`text-sm ${state.darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                    Apri Microsoft Authenticator e inserisci il codice per:<br/>
                                    <strong className="text-blue-600">{email}</strong>
                                </p>
                            </div>

                            <div className="space-y-4">
                                {/* 6 caselle TOTP */}
                                <div className="flex justify-center gap-2 sm:gap-3">
                                    {[0, 1, 2, 3, 4, 5].map((index) => (
                                        <input
                                            key={index}
                                            ref={el => totpInputRefs.current[index] = el}
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={1}
                                            value={totpCode[index] || ''}
                                            onChange={(e) => handleTotpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleTotpKeyDown(index, e)}
                                            className={`w-10 h-12 sm:w-12 sm:h-14 text-center text-xl font-bold rounded-xl border-2 focus:ring-2 focus:ring-green-500 focus:border-green-500 ${
                                                state.darkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300'
                                            }`}
                                            autoFocus={index === 0}
                                            data-testid={`totp-verify-input-${index}`}
                                        />
                                    ))}
                                </div>

                                {error && (
                                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-lg text-sm text-center" data-testid="totp-error-message">
                                        {error}
                                    </div>
                                )}

                                <label className={`flex items-center justify-center gap-2 text-sm cursor-pointer select-none ${state.darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                    <input
                                        type="checkbox"
                                        checked={rememberDevice}
                                        onChange={(e) => setRememberDevice(e.target.checked)}
                                        className="w-4 h-4 rounded accent-green-600"
                                        data-testid="remember-device-checkbox"
                                    />
                                    Ricorda questo dispositivo per 30 giorni
                                </label>

                                <button
                                    onClick={verifyTotp}
                                    disabled={loading || totpCode.length !== 6}
                                    className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-3 rounded-xl font-bold hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center justify-center gap-2"
                                    data-testid="totp-verify-btn"
                                >
                                    {loading ? (
                                        <Loader2 className="h-5 w-5 animate-spin" />
                                    ) : (
                                        <>
                                            <CheckCircle className="h-5 w-5" />
                                            Verifica
                                        </>
                                    )}
                                </button>

                                {/* Info */}
                                <div className={`p-3 rounded-xl text-center ${state.darkMode ? 'bg-gray-700' : 'bg-blue-50'}`}>
                                    <p className={`text-xs ${state.darkMode ? 'text-gray-400' : 'text-blue-600'}`}>
                                        💡 Il codice si aggiorna ogni 30 secondi
                                    </p>
                                </div>

                                {/* Torna indietro */}
                                <button
                                    onClick={() => { setStep('email'); setTotpCode(''); setError(''); }}
                                    className={`w-full py-2 text-sm ${state.darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-600 hover:text-gray-700'}`}
                                >
                                    ← Cambia email
                                </button>
                            </div>
                        </div>
                    )}

                    {/* STEP: Accesso con Passkey (metodo primario) */}
                    {step === 'passkey' && (
                        <div className="space-y-4">
                            <div className="text-center">
                                <div className={`mx-auto mb-3 w-14 h-14 rounded-2xl flex items-center justify-center ${state.darkMode ? 'bg-purple-900/40' : 'bg-purple-100'}`}>
                                    <KeyRound className={`h-7 w-7 ${state.darkMode ? 'text-purple-300' : 'text-purple-600'}`} />
                                </div>
                                <h3 className={`text-lg font-bold ${state.darkMode ? 'text-white' : 'text-gray-900'}`}>Accedi con la Passkey</h3>
                                <p className={`text-sm mt-1 ${state.darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Usa Face ID, impronta o il PIN del dispositivo per <strong>{email}</strong></p>
                            </div>
                            {error && <p className="text-sm text-red-500 text-center" data-testid="passkey-error">{error}</p>}
                            <button onClick={startPasskeyAuth} disabled={loading} className="w-full py-3 rounded-xl bg-purple-600 hover:bg-purple-500 text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-50" data-testid="passkey-login-btn">
                                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <KeyRound className="h-5 w-5" />} Sblocca con Passkey
                            </button>
                            <button onClick={() => { setError(''); checkTotpStatusFallback(); }} className={`w-full text-sm underline ${state.darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`} data-testid="passkey-use-totp-btn">
                                Usa invece il codice Authenticator
                            </button>
                        </div>
                    )}


                    {/* STEP 4: Ticket (dopo verifica) */}
                    {step === 'verified' && (
                        <>
                            {/* Badge verifica */}
                            <div className={`mb-4 p-3 rounded-xl flex items-center gap-2 ${state.darkMode ? 'bg-green-900/30 border border-green-700' : 'bg-green-50 border border-green-200'}`}>
                                <CheckCircle className="h-5 w-5 text-green-600" />
                                <span className={`text-sm font-medium ${state.darkMode ? 'text-green-400' : 'text-green-700'}`}>
                                    Identità verificata: {email}
                                </span>
                                <Shield className="h-4 w-4 text-green-600 ml-auto" />
                            </div>

                            {/* Offerta: attiva passkey per il prossimo accesso (primo accesso via TOTP) */}
                            {passkeySupported() && pkRegState !== 'done' && (
                                <div className={`mb-4 p-3 rounded-xl border ${state.darkMode ? 'bg-purple-900/25 border-purple-700' : 'bg-purple-50 border-purple-200'}`} data-testid="passkey-register-offer">
                                    <div className="flex items-start gap-2">
                                        <KeyRound className={`h-5 w-5 flex-shrink-0 mt-0.5 ${state.darkMode ? 'text-purple-300' : 'text-purple-600'}`} />
                                        <div className="flex-1 min-w-0">
                                            <p className={`text-sm font-medium ${state.darkMode ? 'text-purple-200' : 'text-purple-800'}`}>Attiva l'accesso rapido con Passkey</p>
                                            <p className={`text-xs mt-0.5 ${state.darkMode ? 'text-purple-300/80' : 'text-purple-700/80'}`}>La prossima volta entri con Face ID / impronta, senza codice. Il codice Authenticator resta come riserva.</p>
                                            {pkRegState === 'error' && <p className="text-xs mt-1 text-red-500">Attivazione non riuscita. Riprova.</p>}
                                            <button onClick={registerPasskeyNow} className="mt-2 flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-purple-600 hover:bg-purple-500 text-white transition-colors" data-testid="passkey-register-btn">
                                                <KeyRound className="h-3.5 w-3.5" /> Attiva Passkey
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {passkeySupported() && pkRegState === 'done' && (
                                <div className={`mb-4 p-3 rounded-xl border flex items-center gap-2 ${state.darkMode ? 'bg-green-900/25 border-green-700' : 'bg-green-50 border-green-200'}`} data-testid="passkey-register-done">
                                    <CheckCircle className="h-5 w-5 text-green-600" />
                                    <span className={`text-sm ${state.darkMode ? 'text-green-300' : 'text-green-700'}`}>Passkey attivata! Dal prossimo accesso userai Face ID / impronta.</span>
                                </div>
                            )}

                            {/* Promemoria registrazione portale (accessi successivi al primo) */}
                            {showPortalReminder && (
                                <div className={`mb-4 p-3 rounded-xl border ${state.darkMode ? 'bg-blue-900/30 border-blue-700' : 'bg-blue-50 border-blue-200'}`} data-testid="portal-reminder-banner">
                                    <div className="flex items-start gap-2">
                                        <KeyRound className={`h-5 w-5 flex-shrink-0 mt-0.5 ${state.darkMode ? 'text-blue-300' : 'text-blue-600'}`} />
                                        <div className="flex-1 min-w-0">
                                            <p className={`text-sm font-medium ${state.darkMode ? 'text-blue-200' : 'text-blue-800'}`}>Hai già creato la password sul portale 86BIT?</p>
                                            <p className={`text-xs mt-0.5 ${state.darkMode ? 'text-blue-300/80' : 'text-blue-700/80'}`}>Ti serve per rispondere ai ticket a tuo nome e restare loggato.</p>
                                            <div className="flex flex-wrap items-center gap-2 mt-2">
                                                <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer" onClick={snoozePortalReminder}
                                                    className="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-500 text-white transition-colors"
                                                    data-testid="portal-reminder-create-btn">
                                                    <ExternalLink className="h-3.5 w-3.5" /> Crea ora
                                                </a>
                                                <button onClick={markPortalRegistered} className="text-xs font-medium text-green-600 hover:underline" data-testid="portal-reminder-registered-btn">Sì, l'ho creato</button>
                                                <button onClick={snoozePortalReminder} className="text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 ml-auto" data-testid="portal-reminder-dismiss-btn">Più tardi</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {loading ? (
                                <div className="flex flex-col items-center justify-center py-12">
                                    <Loader2 className="h-10 w-10 text-blue-500 animate-spin mb-4" />
                                    <p className={state.darkMode ? 'text-gray-400' : 'text-gray-500'}>Caricamento ticket...</p>
                                </div>
                            ) : tickets.length === 0 ? (
                                <div className="flex flex-col items-center justify-center py-12">
                                    <Ticket className={`h-12 w-12 mb-4 ${state.darkMode ? 'text-gray-600' : 'text-gray-300'}`} />
                                    <p className={state.darkMode ? 'text-gray-400' : 'text-gray-500'}>Nessun ticket trovato</p>
                                    <p className={`text-sm mt-2 ${state.darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                                        Non hai ancora aperto ticket con questa email
                                    </p>
                                </div>
                            ) : (
                                <div className="space-y-1">
                                    {(() => { const shownTickets = applyTicketFilter(tickets, ticketFilter, isNewTicket); return (<>
                                    <TicketFilterBar tickets={tickets} f={ticketFilter} update={updateTicketFilter} isNew={isNewTicket} shown={shownTickets.length} />
                                    {shownTickets.length === 0 && <p className="text-center text-sm text-gray-500 py-6" data-testid="ticket-filter-empty">Nessun ticket con questi filtri.</p>}
                                    {/* Lista ticket */}
                                    {shownTickets.map((ticket, idx) => {
                                        const ticketId = ticket.id || ticket.key || idx;
                                        const statusLower = (ticket.status || '').toLowerCase();
                                        // Priorità: categoria stato Jira (new|indeterminate|done) — robusta a tutti i nomi IT/EN.
                                        const cat = ticket.status_category || ticket.statusCategory;
                                        let isResolved, isInProgress;
                                        if (cat) {
                                            isResolved = cat === 'done';
                                            isInProgress = cat === 'indeterminate';
                                        } else {
                                            // Fallback (ticket mock / categoria assente): match italiano/inglese tollerante.
                                            isResolved = /risol|chius|complet|evas|done|closed|fatto/.test(statusLower);
                                            isInProgress = !isResolved && /corso|lavorazione|progress|attesa di supporto|attesa di risposta|in carico|riapert/.test(statusLower);
                                        }
                                        const isExpanded = expandedTicket === ticketId;
                                        
                                        return (
                                            <div 
                                                key={ticketId} 
                                                className={`rounded-lg border transition-all ${
                                                    isResolved 
                                                        ? 'bg-green-50 border-green-200' 
                                                        : isInProgress
                                                            ? 'bg-yellow-50 border-yellow-200'
                                                            : state.darkMode 
                                                                ? 'bg-gray-700 border-gray-600' 
                                                                : 'bg-white border-gray-200'
                                                }`}
                                            >
                                                <div 
                                                    onClick={() => toggleExpand(ticketId, isExpanded)}
                                                    data-testid={`ticket-row-${ticket.key || ticketId}`}
                                                    className={`flex items-center gap-2 p-2 cursor-pointer hover:opacity-80 transition-opacity ${isExpanded ? 'border-b ' + (isResolved ? 'border-green-200' : isInProgress ? 'border-yellow-200' : state.darkMode ? 'border-gray-600' : 'border-gray-200') : ''}`}
                                                >
                                                    <ChevronRight className={`w-4 h-4 flex-shrink-0 transition-transform ${isExpanded ? 'rotate-90' : ''} ${
                                                        isResolved ? 'text-green-600' : isInProgress ? 'text-yellow-600' : 'text-gray-400'
                                                    }`} />
                                                    <div className={`w-2 h-2 rounded-full flex-shrink-0 ${
                                                        isResolved ? 'bg-green-500' : isInProgress ? 'bg-yellow-500' : 'bg-gray-400'
                                                    }`}></div>
                                                    {ticket.status && (
                                                        <span
                                                            data-testid={`ticket-status-badge-${ticket.key || ticketId}`}
                                                            title={ticket.status}
                                                            className={`hidden sm:inline-block flex-shrink-0 max-w-[130px] truncate text-[10px] font-semibold px-2 py-0.5 rounded-full border ${
                                                                isResolved
                                                                    ? 'bg-green-100 text-green-700 border-green-200'
                                                                    : isInProgress
                                                                        ? 'bg-yellow-100 text-yellow-700 border-yellow-200'
                                                                        : 'bg-gray-100 text-gray-600 border-gray-200'
                                                            }`}
                                                        >
                                                            {ticket.status}
                                                        </span>
                                                    )}
                                                    <span className={`text-xs font-mono font-bold flex-shrink-0 ${isResolved ? 'text-green-700' : 'text-blue-600'}`}>
                                                        {ticket.key || ticket.id || '#'}
                                                    </span>
                                                    <span className={`flex-1 text-sm truncate ${isResolved ? 'text-green-800' : state.darkMode ? 'text-white' : 'text-gray-800'}`}>
                                                        {ticket.summary || ticket.title}
                                                    </span>
                                                    {(state.ticketUpdates || []).some(u => u.key === (ticket.key || ticket.id)) && (
                                                        <span className="flex-shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-red-500 text-white animate-pulse" data-testid={`ticket-new-badge-${ticket.key || ticket.id}`}>NUOVO</span>
                                                    )}
                                                    <span className={`text-xs flex-shrink-0 ${isResolved ? 'text-green-600' : state.darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        {formatDate(ticket.created || ticket.createdAt || ticket.created_at)}
                                                    </span>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); refreshTicket(ticket.key || ticket.id); }}
                                                        className={`p-1 rounded hover:bg-black/10 flex-shrink-0 ${state.darkMode ? 'text-gray-300' : 'text-gray-500'}`}
                                                        title="Aggiorna: controlla se abbiamo risposto"
                                                        data-testid={`ticket-refresh-${ticket.key || ticket.id}`}
                                                    >
                                                        <RefreshCw className={`h-3.5 w-3.5 ${refreshingTicket === (ticket.key || ticket.id) ? 'animate-spin' : ''}`} />
                                                    </button>
                                                </div>
                                                
                                                {/* Dettagli espansi */}
                                                {isExpanded && (
                                                    <div className={`p-3 text-sm ${
                                                        isResolved ? 'bg-green-100/50 text-green-900' 
                                                        : isInProgress ? 'bg-yellow-100/50 text-yellow-900'
                                                        : state.darkMode ? 'bg-gray-750 text-gray-300' : 'bg-gray-50 text-gray-700'
                                                    }`}>
                                                        <div className="space-y-2">
                                                            <div>
                                                                <span className="font-semibold text-xs uppercase opacity-60">Oggetto:</span>
                                                                <p className="mt-0.5">{ticket.summary || ticket.title}</p>
                                                            </div>
                                                            {(ticket.description || ticket.desc) && (
                                                                <div>
                                                                    <span className="font-semibold text-xs uppercase opacity-60">Descrizione:</span>
                                                                    <p className="mt-0.5 whitespace-pre-wrap">{ticket.description || ticket.desc}</p>
                                                                </div>
                                                            )}
                                                            {/* Screenshot allegati all'apertura del ticket */}
                                                            {(thread[ticketId]?.images || []).length > 0 && (
                                                                <div>
                                                                    <span className="font-semibold text-xs uppercase opacity-60">Screenshot allegati:</span>
                                                                    <div className="mt-1 flex flex-wrap gap-2" data-testid={`ticket-initial-images-${ticket.key || ticketId}`}>
                                                                        {(thread[ticketId]?.images || []).map((img, idx) => (
                                                                            <a key={idx} href={img.data} target="_blank" rel="noopener noreferrer" data-testid={`ticket-initial-image-${idx}`}>
                                                                                <img src={img.data} alt={img.name || 'screenshot'} className="max-h-40 rounded-md border border-current/20 object-contain" />
                                                                            </a>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {(thread[ticketId]?.jira_attachments || []).length > 0 && (
                                                                <div>
                                                                    <span className="font-semibold text-xs uppercase opacity-60">Allegati:</span>
                                                                    <div className="mt-1 flex flex-col gap-1" data-testid={`ticket-jira-attachments-${ticket.key || ticketId}`}>
                                                                        {(thread[ticketId]?.jira_attachments || []).map((a, idx) => {
                                                                            const url = `${API_BASE_URL}/api/v1/jira/attachment/${a.id}`;
                                                                            const icon = a.kind === 'video' ? '🎬' : (a.kind === 'image' ? '🖼️' : '📎');
                                                                            return <a key={idx} href={url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1.5 text-xs underline w-fit ${state.darkMode ? 'text-blue-300 hover:text-blue-200' : 'text-blue-600 hover:text-blue-700'}`} data-testid={`ticket-jira-attachment-${idx}`}>{icon} {a.filename || 'allegato'}</a>;
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div className="flex flex-wrap gap-3 pt-2 border-t border-current/10 text-xs">
                                                                <span><strong>Stato:</strong> {ticket.status || 'Aperto'}</span>
                                                                {ticket.assignee && (
                                                                    <span className="flex items-center gap-1">
                                                                        <User className="h-3 w-3" />
                                                                        <strong>Tecnico:</strong> {ticket.assignee}
                                                                    </span>
                                                                )}
                                                                {ticket.priority && <span><strong>Priorità:</strong> {ticket.priority}</span>}
                                                            </div>

                                                            {/* Conversazione con l'IT */}
                                                            <div className="pt-2 border-t border-current/10">
                                                                <span className="font-semibold text-xs uppercase opacity-60 flex items-center gap-1"><MessageSquare className="h-3 w-3" /> Conversazione</span>
                                                                <div className="mt-2 space-y-2 max-h-56 overflow-y-auto" data-testid={`ticket-thread-${ticket.key || ticketId}`}>
                                                                    {(thread[ticketId]?.comments || []).length === 0 && (
                                                                        <p className="text-xs opacity-60">Nessun messaggio ancora.</p>
                                                                    )}
                                                                    {(thread[ticketId]?.comments || []).map(c => (
                                                                        <div key={c.id} className={`flex ${c.is_it ? 'justify-start' : 'justify-end'}`}>
                                                                            <div className={`max-w-[85%] rounded-lg px-2.5 py-1.5 text-xs ${c.is_it ? (state.darkMode ? 'bg-gray-600 text-white' : 'bg-blue-100 text-blue-900') : (state.darkMode ? 'bg-purple-700 text-white' : 'bg-purple-100 text-purple-900')}`}>
                                                                                <p className="font-semibold text-[10px] opacity-70 mb-0.5">{c.is_it ? '🛠️ ' + c.author : c.author}</p>
                                                                                {c.body && <p className="whitespace-pre-wrap">{c.body}</p>}
                                                                                {(c.images && c.images.length > 0
                                                                                    ? c.images
                                                                                    : (c.image ? [{ data: c.image, name: c.image_name }] : [])
                                                                                ).map((img, idx) => (
                                                                                    <a key={idx} href={img.data} target="_blank" rel="noopener noreferrer" className="block mt-1" data-testid={`ticket-msg-image-${c.id}-${idx}`}>
                                                                                        <img src={img.data} alt={img.name || 'screenshot'} className="max-w-full max-h-40 rounded-md border border-current/20 object-contain" />
                                                                                    </a>
                                                                                ))}
                                                                                {(c.attachments || []).map((a, idx) => {
                                                                                    const url = `${API_BASE_URL}/api/v1/jira/attachment/${a.id}`;
                                                                                    if (a.kind === 'video') return <video key={'a' + idx} src={url} controls className="block mt-1 max-w-full max-h-40 rounded-md border border-current/20" data-testid={`ticket-msg-attach-${c.id}-${idx}`} />;
                                                                                    if (a.kind === 'image') return <a key={'a' + idx} href={url} target="_blank" rel="noopener noreferrer" className="block mt-1" data-testid={`ticket-msg-attach-${c.id}-${idx}`}><img src={`${url}?thumb=1`} alt={a.filename || 'allegato'} className="max-w-full max-h-40 rounded-md border border-current/20 object-contain" /></a>;
                                                                                    return <a key={'a' + idx} href={url} target="_blank" rel="noopener noreferrer" className="mt-1 inline-flex items-center gap-1 underline text-[11px]" data-testid={`ticket-msg-attach-${c.id}-${idx}`}>📎 {a.filename || 'allegato'}</a>;
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                {/* Anteprima screenshot da allegare (multipli) */}
                                                                {expandedTicket === ticketId && replyImages.length > 0 && (
                                                                    <div className="mt-2 flex flex-wrap gap-2" onClick={e => e.stopPropagation()}>
                                                                        {replyImages.map((img, idx) => (
                                                                            <div className="relative" key={idx}>
                                                                                {img.isRaw
                                                                                    ? <div className="h-16 w-16 flex flex-col items-center justify-center gap-0.5 rounded-md border border-current/20 bg-current/5 px-1" data-testid={`reply-image-preview-${idx}`}><span className="text-lg leading-none">{img.kind === 'video' ? '🎬' : '🖼️'}</span><span className="text-[8px] leading-tight text-center truncate w-full">{img.name}</span></div>
                                                                                    : <img src={img.data} alt={img.name} className="h-16 w-16 object-cover rounded-md border border-current/20" data-testid={`reply-image-preview-${idx}`} />}
                                                                                <button onClick={() => removeReplyImage(idx)} className="absolute -top-1.5 -right-1.5 bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px] leading-none" data-testid={`reply-image-remove-${idx}`} title="Rimuovi allegato">×</button>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                {expandedTicket === ticketId && replyImageError && (
                                                                    <p className="mt-1 text-[11px] text-red-500" data-testid="reply-image-error">{replyImageError}</p>
                                                                )}
                                                                {expandedTicket === ticketId && uploadProgress !== null && (
                                                                    <div className="mt-2" data-testid="reply-upload-progress" onClick={e => e.stopPropagation()}>
                                                                        <div className="flex justify-between text-[11px] mb-0.5 opacity-80">
                                                                            <span className="flex items-center gap-1"><Loader2 className="h-3 w-3 animate-spin" /> Caricamento allegato…</span>
                                                                            <span data-testid="reply-upload-percent">{uploadProgress}%</span>
                                                                        </div>
                                                                        <div className={`h-1.5 rounded-full overflow-hidden ${state.darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                                                                            <div className="h-full bg-purple-500 transition-all duration-200" style={{ width: `${uploadProgress}%` }} />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {/* Casella risposta diretta dentro Spark */}
                                                                <div className="mt-3 flex gap-2 items-center" onClick={e => e.stopPropagation()}>
                                                                    <input type="file" accept="image/*,video/*" multiple ref={replyFileInputRef} onChange={handleReplyImagePick} className="hidden" data-testid={`ticket-reply-file-${ticket.key || ticketId}`} />
                                                                    <button type="button" onClick={(e) => { e.stopPropagation(); if (replyFileInputRef.current) replyFileInputRef.current.click(); }} className={`px-2.5 rounded-lg border flex items-center self-stretch ${state.darkMode ? 'bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} title="Allega immagine o video (puoi anche incollare uno screenshot con Ctrl+V)" data-testid={`ticket-reply-attach-${ticket.key || ticketId}`}>
                                                                        <ImageIcon className="h-3.5 w-3.5" />
                                                                    </button>
                                                                    <input value={expandedTicket === ticketId ? replyText : ''} onChange={e => setReplyText(e.target.value)} onPaste={handleReplyPaste} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); sendReply(ticket.key || ticketId); } }} placeholder="Scrivi una risposta all'IT... (o incolla uno screenshot)" className={`flex-1 text-xs rounded-lg px-2.5 py-2 border focus:outline-none ${state.darkMode ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'}`} data-testid={`ticket-reply-input-${ticket.key || ticketId}`} />
                                                                    <button onClick={() => sendReply(ticket.key || ticketId)} disabled={replySending || (!replyText.trim() && replyImages.length === 0)} className="px-3 rounded-lg bg-purple-600 hover:bg-purple-500 text-white disabled:opacity-40 flex items-center" data-testid={`ticket-reply-send-${ticket.key || ticketId}`}>
                                                                        {replySending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                    </>); })()}
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Footer sicurezza */}
                <div className={`px-3 sm:px-4 py-2 border-t text-center flex-shrink-0 ${state.darkMode ? 'border-gray-700 bg-gray-750' : 'border-gray-200 bg-gray-50'}`}>
                    <p className={`text-xs ${state.darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                        🔒 Autenticazione a 2 fattori attiva • I tuoi dati sono protetti
                    </p>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// FEEDBACK PROMPT - Post risoluzione
// ============================================================================
const FeedbackPrompt = ({ onClose, messageId }) => {
    const { state, dispatch } = useContext(ChatContext);
    const [rating, setRating] = useState(null);
    const [comment, setComment] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async () => {
        // 📊 FEEDBACK ANALYTICS MIGLIORATO
        const feedbackData = {
            rating,
            comment,
            userName: state.userName,
            userCompany: state.userCompany || state.userSiteName,
            userComputer: state.userComputer,
            messageId,
            timestamp: new Date().toISOString(),
            // Analytics aggiuntive
            sessionDuration: Date.now() - (state.sessionStartTime || Date.now()),
            messageCount: state.messages?.length || 0,
            deviceType: state.userPCHardwareType || 'unknown',
            isDeviceManaged: state.isDeviceManaged,
            // Contesto conversazione (ultimi 3 messaggi)
            conversationContext: state.messages?.slice(-3).map(m => ({
                sender: m.sender,
                preview: m.text?.substring(0, 100)
            })) || []
        };

        await MOCK_API.saveFeedback(feedbackData);
        setSubmitted(true);
        
        // 🚀 AI ENTERPRISE: Aggiorna memoria e Knowledge Base con feedback
        try {
            const topic = extractTopicFromMessages(state.messages);
            const lastUserMessage = state.messages?.filter(m => m.sender === 'user').pop()?.text || '';
            const lastAIResponse = state.messages?.filter(m => m.sender === 'ai').pop()?.text || '';
            
            // Aggiorna memoria AI con feedback
            const wasHelpful = rating >= 4;
            updateAIMemory(lastUserMessage, lastAIResponse, wasHelpful, topic);
            
            // 📈 NUOVA FUNZIONALITÀ: Registra risoluzione per apprendimento avanzato
            const resolutionResult = recordResolutionFeedback(
                messageId,
                wasHelpful,
                lastUserMessage,
                lastAIResponse,
                topic
            );
            console.log('[FEEDBACK] 📈 Risoluzione registrata:', resolutionResult);
            
            // Se rating positivo, aggiungi alla Knowledge Base
            if (wasHelpful && lastUserMessage && lastAIResponse) {
                addToKnowledgeBase(lastUserMessage, lastAIResponse, true);
                console.log('[FEEDBACK] 🧠 Soluzione aggiunta alla Knowledge Base');
            }
            
            // Aggiorna profilo utente con soddisfazione
            const profile = loadUserProfile();
            const oldScore = profile.satisfactionScore || 0;
            const totalFeedbacks = profile.totalInteractions || 1;
            profile.satisfactionScore = ((oldScore * (totalFeedbacks - 1)) + rating) / totalFeedbacks;
            saveUserProfile(profile);
            console.log('[FEEDBACK] 📊 Profilo utente aggiornato, satisfaction:', profile.satisfactionScore.toFixed(2));
        } catch (e) {
            console.error('[FEEDBACK] Errore aggiornamento AI memory:', e);
        }
        
        // Track feedback per suggerimenti futuri
        try {
            const feedbackHistory = JSON.parse(localStorage.getItem('spark-feedback-history') || '[]');
            feedbackHistory.push({
                rating,
                topic: extractTopicFromMessages(state.messages),
                timestamp: new Date().toISOString()
            });
            // Mantieni solo ultimi 50 feedback
            if (feedbackHistory.length > 50) feedbackHistory.shift();
            localStorage.setItem('spark-feedback-history', JSON.stringify(feedbackHistory));
        } catch (e) {
            console.error('[FEEDBACK] Errore salvataggio history locale:', e);
        }
        
        setTimeout(() => {
            onClose();
        }, 2000);
    };
    
    // Estrae il topic principale dalla conversazione
    const extractTopicFromMessages = (messages) => {
        if (!messages || messages.length === 0) return 'general';
        const allText = messages.map(m => m.text || '').join(' ').toLowerCase();
        if (/password|login|accesso/.test(allText)) return 'password';
        if (/stampante|stampa|print/.test(allText)) return 'printer';
        if (/email|posta|outlook/.test(allText)) return 'email';
        if (/rete|internet|wifi|vpn/.test(allText)) return 'network';
        if (/office|word|excel/.test(allText)) return 'office';
        return 'general';
    };

    if (submitted) {
        return (
            <div className={`${state.darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-xl p-4 mx-4 mb-4 animate-scale-in`}>
                <div className="flex items-center gap-3 text-green-600">
                    <CheckCircle className="h-6 w-6" />
                    <span className="font-medium">Grazie per il tuo feedback!</span>
                </div>
            </div>
        );
    }

    return (
        <div className={`${state.darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200'} border rounded-xl p-4 mx-4 mb-4 animate-scale-in`}>
            <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2">
                    <HelpCircle className="h-5 w-5 text-blue-600" />
                    <span className={`font-medium ${state.darkMode ? 'text-white' : 'text-gray-800'}`}>Il problema è stato risolto?</span>
                </div>
                <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                    <XCircle className="h-5 w-5" />
                </button>
            </div>

            {/* Rating buttons */}
            <div className="flex gap-3 mb-3">
                <button
                    onClick={() => setRating('positive')}
                    className={`flex-1 py-2 px-4 rounded-xl border-2 transition-all flex items-center justify-center gap-2 ${
                        rating === 'positive' 
                            ? 'border-green-500 bg-green-100 text-green-700' 
                            : `${state.darkMode ? 'border-gray-600 hover:border-green-400' : 'border-gray-200 hover:border-green-400'}`
                    }`}
                >
                    <ThumbsUp className="h-5 w-5" />
                    <span className="font-medium">Sì</span>
                </button>
                <button
                    onClick={() => setRating('negative')}
                    className={`flex-1 py-2 px-4 rounded-xl border-2 transition-all flex items-center justify-center gap-2 ${
                        rating === 'negative' 
                            ? 'border-red-500 bg-red-100 text-red-700' 
                            : `${state.darkMode ? 'border-gray-600 hover:border-red-400' : 'border-gray-200 hover:border-red-400'}`
                    }`}
                >
                    <ThumbsDown className="h-5 w-5" />
                    <span className="font-medium">No</span>
                </button>
            </div>

            {/* Comment field (optional) */}
            {rating && (
                <div className="animate-fade-in">
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder={rating === 'positive' ? 'Cosa ti è piaciuto? (opzionale)' : 'Come possiamo migliorare? (opzionale)'}
                        className={`w-full p-3 border rounded-xl text-sm resize-none ${state.darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-200'}`}
                        rows={2}
                    />
                    <button
                        onClick={handleSubmit}
                        className="mt-2 w-full py-2 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 transition-colors"
                    >
                        Invia Feedback
                    </button>
                </div>
            )}
        </div>
    );
};

// ============================================================================
// SUPPORT AVAILABILITY BADGE - Indicatore disponibilità
// ============================================================================
const SupportAvailabilityBadge = () => {
    const { state } = useContext(ChatContext);
    const [availability, setAvailability] = useState(getSupportAvailability());

    useEffect(() => {
        // Aggiorna ogni minuto
        const interval = setInterval(() => {
            setAvailability(getSupportAvailability());
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    const colorClasses = {
        green: 'bg-green-100/80 text-green-700 border-green-200',
        yellow: 'bg-yellow-100/80 text-yellow-700 border-yellow-200',
        red: 'bg-red-100/80 text-red-700 border-red-200'
    };

    return (
        <div className={`px-2 py-0.5 rounded-full border text-[10px] font-medium flex items-center gap-1 ${colorClasses[availability.color]} ${state.darkMode ? 'opacity-90' : ''}`}>
            <span className="text-xs">{availability.icon}</span>
            <span>{availability.text}</span>
            {availability.responseTime && (
                <span className="opacity-70">• {availability.responseTime}</span>
            )}
        </div>
    );
};

// ============================================================================
// SCREENSHOT BUTTON - Pulsante cattura schermo
// ============================================================================
const ScreenshotButton = ({ onCapture }) => {
    const { state } = useContext(ChatContext);
    const [capturing, setCapturing] = useState(false);

    const handleCapture = async () => {
        setCapturing(true);
        try {
            const file = await captureScreenshot();
            onCapture(file);
        } catch (error) {
            console.error('Screenshot failed:', error);
            alert('Non è stato possibile catturare lo schermo. Assicurati di aver concesso i permessi.');
        }
        setCapturing(false);
    };

    return (
        <button
            onClick={handleCapture}
            disabled={capturing}
            className={`p-2 rounded-lg transition-colors ${
                state.darkMode 
                    ? 'text-gray-400 hover:text-white hover:bg-gray-700' 
                    : 'text-gray-500 hover:text-blue-600 hover:bg-blue-50'
            } disabled:opacity-50`}
            title="Cattura schermata"
        >
            {capturing ? <Loader2 className="h-5 w-5 animate-spin" /> : <Camera className="h-5 w-5" />}
        </button>
    );
};

// ============================================================================
// DARK MODE TOGGLE
// ============================================================================
const DarkModeToggle = () => {
    const { state, dispatch } = useContext(ChatContext);

    const toggleDarkMode = () => {
        const newMode = !state.darkMode;
        dispatch({ type: 'SET_STATE', payload: { darkMode: newMode } });
        localStorage.setItem('spark-dark-mode', JSON.stringify(newMode));
    };

    return (
        <button
            onClick={toggleDarkMode}
            className={`p-2 rounded-lg transition-all ${
                state.darkMode 
                    ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600' 
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            title={state.darkMode ? 'Modalità chiara' : 'Modalità scura'}
        >
            {state.darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </button>
    );
};

const Modals = () => {
    const { state, dispatch, actions } = useContext(ChatContext);

    const handleMobileHandoffConfirm = () => {
        try {
            if (state.userEmail) {
                localStorage.setItem('spark-user-email-v1', state.userEmail.toLowerCase().trim());
                localStorage.setItem('spark-user-email', state.userEmail.toLowerCase().trim());
            }
        } catch (e) {}
        if (typeof window !== 'undefined') window.__SPARK_HANDOFF__ = null;
        dispatch({ type: 'SET_STATE', payload: { showMobileHandoffModal: false, currentPhase: 'chat' } });
        if (state.messages.length === 0) {
            const finalName = (state.userName && state.userName.toLowerCase() !== 'user') ? state.userName : 'utente';
            dispatch({ type: 'ADD_MESSAGE', payload: {
                sender: 'ai',
                text: `${getGenderedGreeting(finalName, 'perfect')} Come posso aiutarti oggi?`,
                type: 'system-prompt',
                id: Date.now()
            }});
        }
    };

    const handleMobileHandoffReject = () => {
        if (typeof window !== 'undefined') window.__SPARK_HANDOFF__ = null;
        try {
            localStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
        } catch (e) {}
        dispatch({ type: 'SET_STATE', payload: {
            showMobileHandoffModal: false,
            userName: '', userEmail: '', userCompany: '', userSiteName: '', userComputer: '',
            launchedFromBatch: false, messages: [], currentPhase: 'login'
        }});
    };

    const handleBatLaunchWelcomeClose = (confirmedData) => {
        const todayStr = new Date().toISOString().slice(0, 10);
        localStorage.setItem(DAILY_BAT_WELCOME_SHOWN_KEY, todayStr);
        dispatch({ type: 'SET_STATE', payload: { showBatLaunchWelcomeModal: false } });
        
        // L'utente ha confermato i dati nel BatLaunchWelcomeModal - vai diretto in chat
        // NON mostrare MAI il secondo WelcomeModal!
        
        // Usa i dati confermati passati dal modal (evita problemi di timing con React state)
        const hardwareType = confirmedData?.hardwareType || state.userPCHardwareType;
        const connectionType = confirmedData?.connectionType || state.userConnectionType;
        const email = confirmedData?.email || state.userEmail;
        
        // Aggiorna state con i dati confermati
        if (email) {
            dispatch({ type: 'SET_STATE', payload: { userEmail: email } });
        }
        if (hardwareType) {
            dispatch({ type: 'SET_STATE', payload: { userPCHardwareType: hardwareType } });
        }
        if (connectionType) {
            dispatch({ type: 'SET_STATE', payload: { userConnectionType: connectionType } });
        }
        
        // Se c'è un nome reale (utente generico), aggiorna lo state
        if (confirmedData?.realName) {
            dispatch({ type: 'SET_STATE', payload: { userName: confirmedData.realName } });
        }
        
        // Vai diretto in chat con messaggio di benvenuto
        dispatch({ type: 'SET_STATE', payload: { currentPhase: 'chat' } });
        
        if (state.messages.length === 0) {
            // Usa il nome reale se fornito, altrimenti il nome dallo state
            const finalName = confirmedData?.realName || 
                             (state.userName && state.userName.toLowerCase() !== 'user' ? state.userName : 'utente');
            dispatch({ type: 'ADD_MESSAGE', payload: { 
                sender: 'ai', 
                text: `${getGenderedGreeting(finalName, 'perfect')} Come posso aiutarti oggi?`, 
                type: 'system-prompt', 
                id: Date.now() 
            }});
        }
    };
    
    return (
        <>
            {state.showWelcomeModal && <WelcomeModal onSubmit={actions.handleWelcomeSubmit} />}
            {state.showBatLaunchWelcomeModal && <BatLaunchWelcomeModal userName={state.userName} userComputer={state.userComputer} userCompany={state.userCompany} onClose={handleBatLaunchWelcomeClose} />}
            {state.showMobileHandoffModal && <MobileHandoffModal onConfirm={handleMobileHandoffConfirm} onReject={handleMobileHandoffReject} />}
            {state.showOpenOnPhoneModal && <OpenOnPhoneModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showOpenOnPhoneModal: false } })} />}
            {state.showModal && <EndChatModal onClose={actions.saveHistoryAndReset} />}
            {state.showUserDashboard && <UserDashboard onClose={() => dispatch({ type: 'SET_STATE', payload: { showUserDashboard: false } })} onShowShortcuts={() => dispatch({ type: 'SET_STATE', payload: { showUserDashboard: false, showShortcutsModal: true } })} />}
            {state.showSecurityModal && <SecurityModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showSecurityModal: false } })} />}
            {state.showTicketModal && <TicketModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showTicketModal: false } })} />}
            {state.showChatHistory && <ChatHistoryPanel onClose={() => dispatch({ type: 'SET_STATE', payload: { showChatHistory: false } })} />}
            {state.showPhoneModal && <PhoneModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showPhoneModal: false } })} />}
            {state.showVideoCallModal && <VideoCallModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showVideoCallModal: false } })} />}
            {state.showRemoteSupportModal && <RemoteSupportModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showRemoteSupportModal: false } })} />}
            {state.showMyTickets && <MyTicketsModal onClose={() => dispatch({ type: 'SET_STATE', payload: { showMyTickets: false } })} />}
            {state.showPcChangeForm && <OperationsHub apiBase={API_BASE_URL} logo={LOGO_86BIT_BASE64} hidden={OPS_CARDS.filter(k => sparkHiddenRaw(state, k))} prefill={{ company: state.userSiteName || state.userCompany, userName: state.userName, email: state.userEmail || localStorage.getItem('spark-user-email-v1') || '', phone: state.userPhone || localStorage.getItem('spark-user-phone-v1') || '', pcName: state.userComputer }} onClose={() => dispatch({ type: 'SET_STATE', payload: { showPcChangeForm: false } })} />}
            {/* Feedback Prompt - Appare dopo risposte risolutive */}
            {state.showFeedbackPrompt && (
                <FeedbackPrompt 
                    onClose={() => dispatch({ type: 'SET_STATE', payload: { showFeedbackPrompt: false } })} 
                    messageId={state.feedbackMessageId}
                />
            )}
            {state.incomingCall && (
                <IncomingCallModal 
                    callerName={state.incomingCall.callerName}
                    roomUrl={state.incomingCall.roomUrl}
                    roomName={state.incomingCall.roomName}
                    onAnswer={() => dispatch({ type: 'SET_STATE', payload: { incomingCall: null } })}
                    onDecline={() => dispatch({ type: 'SET_STATE', payload: { incomingCall: null } })}
                />
            )}
        </>
    );
};

// ============================================================================
// MAIN APP WITH DARK MODE SUPPORT
// ============================================================================
// ============================================================================
// 🔒 BATCH LAUNCH GUARD - Mostra solo logo se non avviato da batch
// ============================================================================

// Controlla IMMEDIATAMENTE se autorizzato (prima del render React)
const checkBatchAuthorization = () => {
    // 1. Controlla parametri URL (gia' catturati nel global prima del render)
    const sparkParams = (typeof window !== 'undefined' && window.__SPARK_URL_PARAMS__) || {};
    const pcName = sparkParams.pc_name;
    const userName = sparkParams.user_name;
    
    if (pcName && userName) {
        sessionStorage.setItem('spark-batch-authorized', 'true');
        return true;
    }

    // 1b. Handoff mobile via QR: identita' passata da un PC gia' autenticato
    const handoff = (typeof window !== 'undefined' && window.__SPARK_HANDOFF__) || null;
    if (handoff && handoff.n) {
        sessionStorage.setItem('spark-batch-authorized', 'true');
        return true;
    }
    
    // 2. Controlla sessionStorage (per dopo pulizia URL)
    if (sessionStorage.getItem('spark-batch-authorized') === 'true') {
        return true;
    }
    
    // 3. Controlla localStorage per sessione salvata
    try {
        const savedSession = localStorage.getItem('spark-chat-session-v4');
        if (savedSession) {
            const session = JSON.parse(savedSession);
            if (session.launchedFromBatch === true) {
                sessionStorage.setItem('spark-batch-authorized', 'true');
                return true;
            }
        }
    } catch (e) {
        // Ignora errori
    }
    
    return false;
};

// Esegui check una volta all'avvio
const BATCH_AUTHORIZED = checkBatchAuthorization();

// Componente 2FA Guard per accesso senza batch
const TwoFactorAuthGuard = ({ onSuccess }) => {
    const [step, setStep] = useState('checking'); // 'checking' | 'email' | 'email-verify' | 'setup' | 'totp'
    const [email, setEmail] = useState('');
    const [emailOtp, setEmailOtp] = useState('');
    const [totpCode, setTotpCode] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [secretKey, setSecretKey] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showSecret, setShowSecret] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [copied, setCopied] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [rememberDevice, setRememberDevice] = useState(true);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isPWAInstalled, setIsPWAInstalled] = useState(false);
    const [showIOSInstallGuide, setShowIOSInstallGuide] = useState(false);
    const totpInputRefs = useRef([]);
    const emailOtpRefs = useRef([]);
    const pasteInputRef = useRef(null);

    // Detect iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

    // Haptic feedback per mobile
    const vibrate = (pattern = 50) => {
        if (navigator.vibrate) navigator.vibrate(pattern);
    };

    // PWA Install Prompt Handler
    useEffect(() => {
        // Check if already installed
        if (isInStandaloneMode) {
            setIsPWAInstalled(true);
        }

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        const handleAppInstalled = () => {
            setIsPWAInstalled(true);
            setDeferredPrompt(null);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, [isInStandaloneMode]);

    // Funzione per installare PWA
    const handleInstallPWA = async () => {
        vibrate(30);
        
        // Su iOS mostra guida manuale
        if (isIOS) {
            setShowIOSInstallGuide(true);
            return;
        }
        
        if (!deferredPrompt) return;
        
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        
        if (outcome === 'accepted') {
            setIsPWAInstalled(true);
        }
        setDeferredPrompt(null);
    };

    // Genera un ID univoco per il dispositivo
    const generateDeviceId = () => {
        const stored = localStorage.getItem('spark-device-id');
        if (stored) return stored;
        const newId = 'dev_' + crypto.randomUUID?.() || 'dev_' + Math.random().toString(36).substr(2, 16) + Date.now().toString(36);
        localStorage.setItem('spark-device-id', newId);
        return newId;
    };

    // Verifica se il dispositivo è già autorizzato
    const checkTrustedDevice = async () => {
        try {
            const savedEmail = localStorage.getItem('spark-user-email-v1') || '';
            const deviceToken = localStorage.getItem('spark-device-token');
            const deviceId = localStorage.getItem('spark-device-id');

            if (!savedEmail || !deviceToken || !deviceId) {
                setEmail(savedEmail);
                setStep('email');
                return;
            }

            // Verifica con il backend se il dispositivo è ancora autorizzato
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/device/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: savedEmail,
                    deviceId: deviceId,
                    deviceToken: deviceToken
                })
            });

            const data = await response.json();

            if (data.success && data.trusted) {
                // Dispositivo autorizzato! Accesso diretto
                vibrate([30, 50, 30]);
                sessionStorage.setItem('spark-2fa-authorized', 'true');
                sessionStorage.setItem('spark-2fa-email', savedEmail);
                onSuccess(savedEmail);
            } else {
                // Dispositivo non più autorizzato, richiedi 2FA
                setEmail(savedEmail);
                setStep('email');
            }
        } catch (err) {
            console.error('Device check error:', err);
            // In caso di errore di rete, prova comunque ad accedere
            const savedEmail = localStorage.getItem('spark-user-email-v1') || '';
            setEmail(savedEmail);
            setStep('email');
        }
    };

    // Registra il dispositivo come autorizzato
    const registerTrustedDevice = async (userEmail) => {
        if (!rememberDevice) return;
        
        try {
            const deviceId = generateDeviceId();
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/device/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: userEmail,
                    deviceId: deviceId,
                    deviceInfo: {
                        userAgent: navigator.userAgent,
                        platform: navigator.platform,
                        language: navigator.language,
                        screenSize: `${window.screen.width}x${window.screen.height}`
                    }
                })
            });

            const data = await response.json();
            if (data.success && data.deviceToken) {
                localStorage.setItem('spark-device-token', data.deviceToken);
                console.log('✅ Dispositivo registrato come autorizzato');
            }
        } catch (err) {
            console.error('Device registration error:', err);
        }
    };

    // Verifica dispositivo all'avvio
    useEffect(() => {
        checkTrustedDevice();
    }, []);

    // Countdown per reinvio OTP
    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countdown]);

    // Auto-submit quando il codice email OTP è completo
    useEffect(() => {
        if (emailOtp.length === 6 && step === 'email-verify') {
            vibrate(30);
            verifyEmailOtp();
        }
    }, [emailOtp]);

    // Auto-submit quando il codice TOTP è completo
    useEffect(() => {
        if (totpCode.length === 6 && (step === 'setup' || step === 'totp')) {
            vibrate(30);
            if (step === 'setup') {
                confirmTotpSetup();
            } else {
                verifyTotp();
            }
        }
    }, [totpCode]);

    // Copia con feedback visivo
    const copyToClipboard = async (text, type = 'chiave') => {
        try {
            await navigator.clipboard.writeText(text);
            vibrate([30, 50, 30]);
            setCopied(true);
            setSuccessMessage(`${type} copiata!`);
            setTimeout(() => {
                setCopied(false);
                setSuccessMessage('');
            }, 2000);
        } catch (err) {
            // Fallback per browser che non supportano clipboard API
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            vibrate([30, 50, 30]);
            setCopied(true);
            setSuccessMessage(`${type} copiata!`);
            setTimeout(() => {
                setCopied(false);
                setSuccessMessage('');
            }, 2000);
        }
    };

    // Gestione incolla codice intero (per OTP email)
    const handleEmailOtpPaste = (e) => {
        const pastedData = e.clipboardData?.getData('text') || '';
        const cleanedData = pastedData.replace(/\D/g, '').slice(0, 6);
        if (cleanedData.length > 0) {
            e.preventDefault();
            setEmailOtp(cleanedData);
            vibrate(30);
            // Focus sull'ultimo campo compilato o il prossimo vuoto
            const focusIndex = Math.min(cleanedData.length, 5);
            emailOtpRefs.current[focusIndex]?.focus();
        }
    };

    // Gestione incolla codice intero (per TOTP)
    const handleTotpPaste = (e) => {
        const pastedData = e.clipboardData?.getData('text') || '';
        const cleanedData = pastedData.replace(/\D/g, '').slice(0, 6);
        if (cleanedData.length > 0) {
            e.preventDefault();
            setTotpCode(cleanedData);
            vibrate(30);
            const focusIndex = Math.min(cleanedData.length, 5);
            totpInputRefs.current[focusIndex]?.focus();
        }
    };

    // Step 1: Invia OTP all'email
    const sendEmailOtp = async () => {
        if (!email || !email.includes('@')) {
            setError('Inserisci un\'email valida');
            vibrate([50, 30, 50]);
            return;
        }

        setLoading(true);
        setError('');
        vibrate(30);

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/email/send-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email: email.trim().toLowerCase() })
            });

            const data = await response.json();

            if (data.success) {
                localStorage.setItem('spark-user-email-v1', email.trim().toLowerCase());
                setStep('email-verify');
                setCountdown(60);
                setEmailOtp('');
                vibrate([30, 50, 30]);
                setSuccessMessage('📧 Codice inviato!');
                setTimeout(() => setSuccessMessage(''), 3000);
            } else {
                setError(data.error || 'Errore invio email. Riprova.');
                vibrate([50, 30, 50]);
            }
        } catch (err) {
            console.error('Send OTP error:', err);
            setError('Errore di connessione. Verifica la tua rete.');
            vibrate([50, 30, 50]);
        }

        setLoading(false);
    };

    // Step 2: Verifica OTP email
    const verifyEmailOtp = async () => {
        if (emailOtp.length !== 6) {
            setError('Inserisci il codice a 6 cifre');
            vibrate([50, 30, 50]);
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/email/verify-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: email.trim().toLowerCase(),
                    otp: emailOtp
                })
            });

            const data = await response.json();

            if (data.success && data.emailVerified) {
                if (data.totpEnabled) {
                    // Utente già configurato, vai a verifica TOTP
                    setStep('totp');
                    setTotpCode('');
                } else {
                    // Nuovo utente, mostra QR per setup
                    setQrCodeUrl(data.qrCodeUrl);
                    setSecretKey(data.secretKey);
                    setStep('setup');
                }
            } else {
                setError(data.error || 'Codice non valido. Riprova.');
            }
        } catch (err) {
            console.error('Verify OTP error:', err);
            setError('Errore di connessione.');
        }

        setLoading(false);
    };

    // Step 3a: Conferma setup TOTP (nuovo utente)
    const confirmTotpSetup = async () => {
        if (totpCode.length !== 6) {
            setError('Inserisci il codice a 6 cifre');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/setup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: email.trim().toLowerCase(),
                    token: totpCode,
                    secret: secretKey  // Invia la chiave segreta per la verifica
                })
            });

            const data = await response.json();

            if (data.success) {
                vibrate([30, 50, 30, 50, 30]);
                // Salva JWT token se presente
                if (data.token) {
                    saveAuthToken(data.token);
                }
                // Registra dispositivo se richiesto
                await registerTrustedDevice(email.trim().toLowerCase());
                // Salva autorizzazione e procedi
                sessionStorage.setItem('spark-2fa-authorized', 'true');
                sessionStorage.setItem('spark-2fa-email', email.trim().toLowerCase());
                onSuccess(email.trim().toLowerCase());
            } else {
                setError(data.error || 'Codice non valido. Riprova.');
                setTotpCode('');
                vibrate([50, 30, 50]);
            }
        } catch (err) {
            setError('Errore di connessione.');
            vibrate([50, 30, 50]);
        }

        setLoading(false);
    };

    // Step 3b: Verifica TOTP (utente esistente)
    const verifyTotp = async () => {
        if (totpCode.length !== 6) {
            setError('Inserisci il codice a 6 cifre');
            vibrate([50, 30, 50]);
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/verify`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ 
                    email: email.trim().toLowerCase(),
                    token: totpCode
                })
            });

            const data = await response.json();

            if (data.success) {
                vibrate([30, 50, 30, 50, 30]); // Vibrazione successo
                // Salva JWT token se presente
                if (data.token) {
                    saveAuthToken(data.token);
                }
                // Registra dispositivo se richiesto
                await registerTrustedDevice(email.trim().toLowerCase());
                sessionStorage.setItem('spark-2fa-authorized', 'true');
                sessionStorage.setItem('spark-2fa-email', email.trim().toLowerCase());
                onSuccess(email.trim().toLowerCase());
            } else {
                setError(data.error || 'Codice non valido. Riprova.');
                setTotpCode('');
                vibrate([50, 30, 50]);
            }
        } catch (err) {
            setError('Errore di connessione.');
            vibrate([50, 30, 50]);
        }

        setLoading(false);
    };

    // Gestione input TOTP con vibrazione
    const handleTotpChange = (index, value) => {
        if (value.length > 1) value = value.slice(-1);
        if (!/^\d*$/.test(value)) return;

        vibrate(15); // Micro-feedback
        const newCode = totpCode.split('');
        newCode[index] = value;
        setTotpCode(newCode.join(''));

        if (value && index < 5) {
            totpInputRefs.current[index + 1]?.focus();
        }
    };

    const handleTotpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !totpCode[index] && index > 0) {
            totpInputRefs.current[index - 1]?.focus();
        }
    };

    // Gestione input Email OTP con vibrazione
    const handleEmailOtpChange = (index, value) => {
        if (value.length > 1) value = value.slice(-1);
        if (!/^\d*$/.test(value)) return;

        vibrate(15);
        const newOtp = emailOtp.split('');
        newOtp[index] = value;
        setEmailOtp(newOtp.join(''));

        if (value && index < 5) {
            emailOtpRefs.current[index + 1]?.focus();
        }
    };

    const handleEmailOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !emailOtp[index] && index > 0) {
            emailOtpRefs.current[index - 1]?.focus();
        }
    };

    // Reset TOTP per cambio telefono
    const requestTotpReset = async () => {
        if (!email) {
            setError('Email non trovata');
            return;
        }

        setLoading(true);
        setError('');
        vibrate(30);

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/totp/request-reset`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email: email.trim().toLowerCase() })
            });

            const data = await response.json();

            if (data.success) {
                vibrate([30, 50, 30]);
                setSuccessMessage('📧 Email di reset inviata!');
                // Torna alla verifica email per il reset
                setTimeout(() => {
                    setStep('email-verify');
                    setEmailOtp('');
                    setTotpCode('');
                    setSuccessMessage('');
                }, 2000);
            } else {
                setError(data.error || 'Errore. Riprova.');
                vibrate([50, 30, 50]);
            }
        } catch (err) {
            setError('Errore di connessione.');
            vibrate([50, 30, 50]);
        }

        setLoading(false);
    };

    const copySecretKey = () => {
        copyToClipboard(secretKey, 'Chiave');
    };

    // Schermata di caricamento mentre verifica dispositivo
    if (step === 'checking') {
        return (
            <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex flex-col items-center justify-center">
                <SparkAvatar size="lg" animate={true} className="mb-4" />
                <Loader2 className="h-8 w-8 text-blue-400 animate-spin mb-2" />
                <p className="text-white/70 text-sm">Verifica accesso...</p>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex flex-col overflow-hidden">
            {/* Contenitore principale centrato */}
            <div className="flex-1 flex flex-col justify-center p-3 sm:p-4" style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
                
                {/* Avatar grande e vicino al form */}
                {step !== 'setup' && (
                    <div className="flex justify-center mb-2">
                        <SparkAvatar size="md" />
                    </div>
                )}

            {/* Card 2FA */}
            <div className={`bg-white/10 backdrop-blur-lg rounded-xl sm:rounded-2xl p-3 sm:p-5 w-full max-w-md mx-auto border border-white/20 shadow-2xl ${step === 'setup' ? '' : ''}`}>
                
                {/* STEP 1: Email */}
                {step === 'email' && (
                    <>
                        <div className="text-center mb-2 sm:mb-3">
                            <div className="flex items-center justify-center gap-2 mb-1">
                                <Shield className="h-4 w-4 sm:h-5 sm:w-5 text-green-400" />
                                <span className="text-white/80 text-xs font-medium">Accesso Protetto</span>
                            </div>
                            <h1 className="text-lg sm:text-2xl font-bold text-white mb-0.5">86BIT | SPARK</h1>
                            <p className="text-blue-200 text-[11px] sm:text-sm">IT Service Desk Assistant</p>
                        </div>

                        <div className="space-y-3 sm:space-y-4">
                            <div>
                                <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1 sm:mb-2">
                                    Email aziendale
                                </label>
                                <div className="relative">
                                    <AtSign className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-white/40" />
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => { setEmail(e.target.value); setError(''); }}
                                        placeholder="assistenza@86bit.it"
                                        className="w-full pl-9 sm:pl-10 pr-3 sm:pr-4 py-2.5 sm:py-3 bg-white/10 border border-white/20 rounded-lg sm:rounded-xl text-white text-sm placeholder-white/40 focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                                        autoFocus
                                    />
                                </div>
                            </div>

                            {error && (
                                <div className="bg-red-500/20 border border-red-500/40 text-red-200 px-3 py-2 rounded-lg text-xs sm:text-sm">
                                    {error}
                                </div>
                            )}

                            <button
                                onClick={sendEmailOtp}
                                disabled={loading || !email}
                                className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-2.5 sm:py-3 rounded-lg sm:rounded-xl font-bold text-sm sm:text-base hover:from-blue-600 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2 transition-all"
                            >
                                {loading ? (
                                    <Loader2 className="h-4 w-4 sm:h-5 sm:w-5 animate-spin" />
                                ) : (
                                    <>
                                        <Mail className="h-4 w-4 sm:h-5 sm:w-5" />
                                        <span>Invia Codice</span>
                                    </>
                                )}
                            </button>
                        </div>

                        <div className="mt-3 sm:mt-4 p-2 sm:p-3 bg-white/5 rounded-lg sm:rounded-xl border border-white/10">
                            <p className="text-white/50 text-[10px] sm:text-xs text-center">
                                📧 Riceverai un codice di verifica via email<br/>
                                🔒 Poi configurerai Microsoft Authenticator
                            </p>
                        </div>
                    </>
                )}

                {/* STEP 2: Verifica OTP Email */}
                {step === 'email-verify' && (
                    <>
                        <div className="text-center mb-3 sm:mb-4">
                            <Mail className="h-8 w-8 sm:h-10 sm:w-10 text-blue-400 mx-auto mb-2" />
                            <h2 className="text-lg sm:text-xl font-bold text-white mb-1">Verifica Email</h2>
                            <p className="text-blue-200 text-xs sm:text-sm">
                                Inserisci il codice inviato a
                            </p>
                            <p className="text-white font-medium text-sm mt-1">{email}</p>
                        </div>

                        <div className="space-y-3 sm:space-y-4">
                            {/* Messaggio successo */}
                            {successMessage && (
                                <div className="bg-green-500/20 border border-green-500/40 text-green-200 px-3 py-2 rounded-lg text-sm text-center animate-pulse">
                                    {successMessage}
                                </div>
                            )}

                            {/* Input 6 cifre OTP Email - con supporto paste */}
                            <div>
                                <div className="flex justify-center gap-2 mb-2">
                                    {[0, 1, 2, 3, 4, 5].map((index) => (
                                        <input
                                            key={index}
                                            ref={el => emailOtpRefs.current[index] = el}
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            autoComplete="one-time-code"
                                            maxLength={1}
                                            value={emailOtp[index] || ''}
                                            onChange={(e) => handleEmailOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleEmailOtpKeyDown(index, e)}
                                            onPaste={handleEmailOtpPaste}
                                            className="w-11 h-12 sm:w-12 sm:h-14 text-center text-xl sm:text-2xl font-bold bg-white/10 border-2 border-white/20 rounded-xl text-white focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all"
                                            autoFocus={index === 0}
                                        />
                                    ))}
                                </div>
                                <p className="text-white/40 text-[10px] text-center">
                                    💡 Puoi incollare il codice direttamente
                                </p>
                            </div>

                            {error && (
                                <div className="bg-red-500/20 border border-red-500/40 text-red-200 px-3 py-2 rounded-lg text-xs text-center flex items-center justify-center gap-2">
                                    <XCircle className="h-4 w-4" />
                                    {error}
                                </div>
                            )}

                            <button
                                onClick={verifyEmailOtp}
                                disabled={loading || emailOtp.length !== 6}
                                className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 sm:py-3.5 rounded-xl font-bold text-base disabled:opacity-50 flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
                            >
                                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><CheckCircle className="h-5 w-5" /> Verifica Codice</>}
                            </button>

                            <div className="text-center">
                                {countdown > 0 ? (
                                    <p className="text-white/50 text-xs">
                                        ⏱️ Reinvia tra <span className="font-mono font-bold">{countdown}s</span>
                                    </p>
                                ) : (
                                    <button 
                                        onClick={() => { sendEmailOtp(); vibrate(30); }} 
                                        disabled={loading}
                                        className="text-blue-400 text-sm font-medium hover:text-blue-300 active:scale-95 transition-all flex items-center justify-center gap-1 mx-auto"
                                    >
                                        <RefreshCw className="h-3.5 w-3.5" />
                                        Reinvia codice
                                    </button>
                                )}
                            </div>

                            <button onClick={() => { setStep('email'); setEmailOtp(''); setError(''); vibrate(20); }} className="w-full text-white/50 text-xs hover:text-white/70 py-2 flex items-center justify-center gap-1 active:scale-95 transition-all">
                                <ArrowLeft className="h-3 w-3" /> Cambia email
                            </button>
                        </div>
                    </>
                )}

                {/* STEP 3: Setup TOTP - LAYOUT ORIZZONTALE MOBILE */}
                {step === 'setup' && (
                    <>
                        {/* Header compatto */}
                        <div className="text-center mb-2">
                            <h2 className="text-base sm:text-lg font-bold text-white">Configura Authenticator</h2>
                        </div>

                        {/* Layout orizzontale: QR + Istruzioni affiancati */}
                        <div className="flex flex-row gap-3 items-start">
                            {/* QR Code - sempre visibile, dimensione adattiva */}
                            <div className="flex-shrink-0">
                                <div className="bg-white p-1.5 sm:p-2 rounded-lg">
                                    {qrCodeUrl ? (
                                        <img src={qrCodeUrl} alt="QR Code" className="w-24 h-24 sm:w-28 sm:h-28" />
                                    ) : (
                                        <div className="w-24 h-24 sm:w-28 sm:h-28 flex items-center justify-center">
                                            <Loader2 className="h-5 w-5 animate-spin text-gray-400" />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Istruzioni compatte a destra del QR */}
                            <div className="flex-1 min-w-0 space-y-2">
                                {/* Step 1: Scansiona */}
                                <div className="bg-purple-900/40 p-2 rounded-lg border border-purple-500/30">
                                    <p className="text-white text-[10px] sm:text-xs font-medium mb-1">1. Scansiona il QR con Authenticator</p>
                                    <p className="text-white/60 text-[9px] sm:text-[10px]">Oppure copia la chiave:</p>
                                    <div className="flex items-center gap-1 mt-1">
                                        <code className="flex-1 text-[8px] sm:text-[10px] text-green-300 bg-black/40 p-1 rounded font-mono truncate">
                                            {secretKey?.substring(0, 16)}...
                                        </code>
                                        <button 
                                            onClick={copySecretKey} 
                                            className={`p-1.5 rounded flex-shrink-0 transition-all active:scale-90 ${copied ? 'bg-green-500' : 'bg-purple-500'}`}
                                        >
                                            {copied ? <Check className="h-3 w-3 text-white" /> : <Copy className="h-3 w-3 text-white" />}
                                        </button>
                                    </div>
                                </div>

                                {/* Step 2: Istruzioni app */}
                                <div className="bg-black/20 p-2 rounded-lg text-white/70 text-[9px] sm:text-[10px]">
                                    <p><strong className="text-white/90">2.</strong> In Authenticator: <strong className="text-purple-300">+</strong> → Scansiona QR</p>
                                </div>
                            </div>
                        </div>

                        {/* Input TOTP sotto - full width */}
                        <div className="mt-3">
                            <p className="text-white/80 text-xs font-medium mb-1.5 text-center">3. Inserisci il codice generato:</p>
                            <div className="flex justify-center gap-1.5 sm:gap-2">
                                {[0, 1, 2, 3, 4, 5].map((index) => (
                                    <input
                                        key={index}
                                        ref={el => totpInputRefs.current[index] = el}
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        maxLength={1}
                                        value={totpCode[index] || ''}
                                        onChange={(e) => handleTotpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleTotpKeyDown(index, e)}
                                        onPaste={handleTotpPaste}
                                        className="w-10 h-11 sm:w-11 sm:h-12 text-center text-lg sm:text-xl font-bold bg-white/10 border-2 border-white/20 rounded-lg text-white focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
                                    />
                                ))}
                            </div>
                        </div>

                        {error && (
                            <div className="mt-2 bg-red-500/20 border border-red-500/40 text-red-200 px-2 py-1.5 rounded-lg text-xs text-center flex items-center justify-center gap-1">
                                <XCircle className="h-3 w-3" />
                                {error}
                            </div>
                        )}

                        {/* Checkbox Ricorda Dispositivo - compatto */}
                        <label className="mt-2 flex items-center gap-2 p-2 bg-white/5 rounded-lg border border-white/10 cursor-pointer active:scale-[0.98]">
                            <input
                                type="checkbox"
                                checked={rememberDevice}
                                onChange={(e) => { setRememberDevice(e.target.checked); vibrate(20); }}
                                className="w-4 h-4 rounded bg-white/10 border-white/30 text-green-500 focus:ring-green-500"
                            />
                            <span className="text-white text-xs">Ricorda dispositivo</span>
                            <Smartphone className="h-3.5 w-3.5 text-white/40 ml-auto" />
                        </label>

                        {/* Footer fisso */}
                        <div className="mt-2 sm:mt-3 space-y-2">
                            <button
                                onClick={confirmTotpSetup}
                                disabled={loading || totpCode.length !== 6}
                                className="w-full bg-gradient-to-r from-purple-500 to-indigo-600 text-white py-2.5 sm:py-3 rounded-xl font-bold text-sm disabled:opacity-50 flex items-center justify-center gap-2 active:scale-[0.98]"
                            >
                                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><CheckCircle className="h-4 w-4" /> Completa</>}
                            </button>

                            <button onClick={() => { setStep('email'); setTotpCode(''); setError(''); vibrate(20); }} className="w-full text-white/50 text-xs py-1 flex items-center justify-center gap-1">
                                <ArrowLeft className="h-3 w-3" /> Ricomincia
                            </button>
                        </div>
                    </>
                )}

                {/* STEP 4: Verifica TOTP (utenti esistenti) */}
                {step === 'totp' && (
                    <>
                        <div className="text-center mb-3 sm:mb-4">
                            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg">
                                <KeyRound className="h-8 w-8 sm:h-10 sm:w-10 text-white" />
                            </div>
                            <h2 className="text-lg sm:text-xl font-bold text-white mb-1">Bentornato!</h2>
                            <p className="text-blue-200 text-xs sm:text-sm">
                                Inserisci il codice da Authenticator
                            </p>
                            <p className="text-white/60 text-xs mt-1 truncate max-w-[250px] mx-auto">{email}</p>
                        </div>

                        <div className="space-y-3 sm:space-y-4">
                            {/* Input TOTP - con supporto paste e auto-submit */}
                            <div>
                                <div className="flex justify-center gap-2 mb-1">
                                    {[0, 1, 2, 3, 4, 5].map((index) => (
                                        <input
                                            key={index}
                                            ref={el => totpInputRefs.current[index] = el}
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={1}
                                            value={totpCode[index] || ''}
                                            onChange={(e) => handleTotpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleTotpKeyDown(index, e)}
                                            onPaste={handleTotpPaste}
                                            className="w-12 h-14 sm:w-14 sm:h-16 text-center text-2xl sm:text-3xl font-bold bg-white/10 border-2 border-white/20 rounded-xl text-white focus:ring-2 focus:ring-green-400 focus:border-green-400 transition-all"
                                            autoFocus={index === 0}
                                        />
                                    ))}
                                </div>
                                <p className="text-white/40 text-[10px] text-center">
                                    💡 Auto-accesso quando completo
                                </p>
                            </div>

                            {error && (
                                <div className="bg-red-500/20 border border-red-500/40 text-red-200 px-3 py-2 rounded-lg text-xs text-center flex items-center justify-center gap-2">
                                    <XCircle className="h-4 w-4" />
                                    {error}
                                </div>
                            )}

                            {/* Checkbox Ricorda Dispositivo */}
                            <label className="flex items-center gap-3 p-3 bg-white/5 rounded-xl border border-white/10 cursor-pointer hover:bg-white/10 transition-all active:scale-[0.98]">
                                <input
                                    type="checkbox"
                                    checked={rememberDevice}
                                    onChange={(e) => { setRememberDevice(e.target.checked); vibrate(20); }}
                                    className="w-5 h-5 rounded bg-white/10 border-white/30 text-green-500 focus:ring-green-500 focus:ring-offset-0 cursor-pointer"
                                />
                                <div className="flex-1">
                                    <p className="text-white text-sm font-medium">Ricorda questo dispositivo</p>
                                    <p className="text-white/50 text-xs">Non chiedere più la verifica</p>
                                </div>
                                <Smartphone className="h-5 w-5 text-white/40" />
                            </label>

                            <button
                                onClick={verifyTotp}
                                disabled={loading || totpCode.length !== 6}
                                className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3.5 rounded-xl font-bold text-base disabled:opacity-50 flex items-center justify-center gap-2 active:scale-[0.98] transition-transform shadow-lg"
                            >
                                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><CheckCircle className="h-5 w-5" /> Accedi</>}
                            </button>

                            <div className="text-center p-2.5 bg-white/5 rounded-xl border border-white/10">
                                <p className="text-white/50 text-xs flex items-center justify-center gap-1">
                                    <RefreshCw className="h-3 w-3" />
                                    Il codice si aggiorna ogni 30 secondi
                                </p>
                            </div>

                            <div className="flex gap-2">
                                <button onClick={() => { setStep('email'); setTotpCode(''); setError(''); vibrate(20); }} className="flex-1 text-white/50 text-xs hover:text-white/70 py-2 flex items-center justify-center gap-1 active:scale-95 transition-all">
                                    <ArrowLeft className="h-3 w-3" /> Cambia email
                                </button>
                                <button 
                                    onClick={() => { requestTotpReset(); vibrate(30); }} 
                                    disabled={loading}
                                    className="flex-1 text-orange-400/70 text-xs hover:text-orange-300 py-2 flex items-center justify-center gap-1 active:scale-95 transition-all disabled:opacity-50"
                                >
                                    <Smartphone className="h-3 w-3" /> Ho cambiato telefono
                                </button>
                            </div>

                            {successMessage && (
                                <div className="bg-green-500/20 border border-green-500/40 text-green-200 px-3 py-2 rounded-lg text-xs text-center flex items-center justify-center gap-2">
                                    <CheckCircle className="h-4 w-4" />
                                    {successMessage}
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>

                {/* Footer con Logo 86BIT e dati fiscali - vicinissimo */}
                <div className="text-center mt-3">
                    {/* Guida installazione iOS - mantenuta ma nascosta di default */}
                    {showIOSInstallGuide && (
                        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-end justify-center p-4">
                            <div className="bg-gray-900 rounded-2xl p-5 w-full max-w-sm border border-white/20 shadow-2xl animate-slide-up">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-white font-bold text-lg">Aggiungi a Home Screen</h3>
                                    <button onClick={() => setShowIOSInstallGuide(false)} className="text-white/60 hover:text-white">
                                        <XCircle className="h-6 w-6" />
                                    </button>
                                </div>
                                <div className="space-y-4 text-white/80 text-sm">
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold shrink-0">1</div>
                                        <p>Tocca il pulsante <strong className="text-white">Condividi</strong> in basso (icona quadrato con freccia verso l&apos;alto)</p>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold shrink-0">2</div>
                                        <p>Scorri e tocca <strong className="text-white">&quot;Aggiungi a Home&quot;</strong></p>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold shrink-0">3</div>
                                        <p>Tocca <strong className="text-white">&quot;Aggiungi&quot;</strong> in alto a destra</p>
                                    </div>
                                </div>
                                <button 
                                    onClick={() => setShowIOSInstallGuide(false)}
                                    className="mt-5 w-full bg-blue-500 text-white py-3 rounded-xl font-medium active:scale-95 transition-transform"
                                >
                                    Ho capito
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Logo 86BIT - Link al sito */}
                    <a href="https://www.86bit.it/" target="_blank" rel="noopener noreferrer">
                        <img 
                            src={LOGO_86BIT_BASE64} 
                            alt="86BIT" 
                            className="h-7 sm:h-9 mx-auto mb-1.5 opacity-90 hover:opacity-100 transition-opacity cursor-pointer"
                        />
                    </a>
                    {/* Dati fiscali completi */}
                    <div className="text-white/50 text-[7px] sm:text-[9px] leading-relaxed px-2">
                        <p className="font-semibold text-white/70 mb-0.5">86BIT srl Unipersonale</p>
                        <p>C.F. e P.Iva 04353030168 • Cap. Soc. € 50.000,00 i.v.</p>
                        <p>Reg. Imprese BG 04353030168 • REA n. BG456578</p>
                        <p className="mt-1 text-white/40">Sede Operativa: Piazza Papa Giovanni XXIII, 24020 Scanzorosciate (BG)</p>
                        <p className="text-white/40">Sede Secondaria: Piazza Manzù, 8, 24023 Clusone (BG)</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AccessInfoScreen = ({ message }) => (
    <div className="fixed inset-0 z-[100] bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex items-center justify-center overflow-hidden p-4" data-testid={message ? 'spark-blocked-screen' : 'access-info-screen'}>
        <div className="w-full max-w-md mx-auto flex flex-col items-center">
            {/* Header Spark */}
            <SparkAvatar size="lg" className="h-20 w-20 sm:h-24 sm:w-24 mb-4" />
            <div className="flex items-center gap-2 text-green-300/90 mb-1">
                <Shield className="h-4 w-4" />
                <span className="text-sm font-medium">Accesso Protetto</span>
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold text-white">86BIT | SPARK</h1>
            <p className="text-blue-200 text-sm sm:text-base mb-7">IT Service Desk Assistant</p>

            {message && (
                <div className="w-full max-w-sm mb-7 px-5 py-4 rounded-2xl bg-white/10 border border-white/20 backdrop-blur text-center" data-testid="spark-blocked-message">
                    <Lock className="h-5 w-5 text-amber-300 mx-auto mb-2" />
                    <p className="text-white/90 text-sm leading-relaxed whitespace-pre-line">{message}</p>
                </div>
            )}

            {/* Riga bianca elegante che divide */}
            <div className="w-full max-w-xs mb-7 flex items-center justify-center">
                <div className="h-[1.5px] w-full bg-gradient-to-r from-transparent via-white/90 to-transparent rounded-full shadow-[0_0_8px_rgba(255,255,255,0.35)]"></div>
            </div>

            {/* Footer 86BIT: logo + dati fiscali */}
            <a href="https://www.86bit.it/" target="_blank" rel="noopener noreferrer">
                <img src={LOGO_86BIT_BASE64} alt="86BIT" className="h-8 sm:h-10 mx-auto mb-2 opacity-90 hover:opacity-100 transition-opacity cursor-pointer" />
            </a>
            <div className="text-center text-white/50 text-[8px] sm:text-[10px] leading-relaxed px-2">
                <p className="font-semibold text-white/70 mb-0.5">86BIT srl Unipersonale</p>
                <p>C.F. e P.Iva 04353030168 • Cap. Soc. € 50.000,00 i.v.</p>
                <p>Reg. Imprese BG 04353030168 • REA n. BG456578</p>
                <p className="mt-1 text-white/40">Sede Operativa: Piazza Papa Giovanni XXIII, 24020 Scanzorosciate (BG)</p>
                <p className="text-white/40">Sede Secondaria: Piazza Manzù, 8, 24023 Clusone (BG)</p>
            </div>
        </div>
    </div>
);

const BatchLaunchGuard = ({ children }) => {
    // Se lanciato da batch (RMM), da QR handoff o con sessione salvata, mostra l'app
    if (BATCH_AUTHORIZED) {
        return children;
    }

    // Accesso senza avvio dal tool aziendale (né RMM né QR): schermata informativa 86BIT
    return <AccessInfoScreen />;
};

// Dashboard 2FA con accesso al ChatContext per usare i modali originali
const Simple2FADashboardWithContext = ({ userEmail, showVideoCall, setShowVideoCall, showTicketForm, setShowTicketForm }) => {
    const { state, dispatch } = useContext(ChatContext);
    
    // Imposta email e dati utente nel context
    useEffect(() => {
        if (userEmail) {
            dispatch({ 
                type: 'SET_STATE', 
                payload: { 
                    userEmail: userEmail,
                    userName: userEmail.split('@')[0] || 'Utente',
                    userCompany: 'Accesso Web 2FA',
                    userComputer: 'Web Browser'
                } 
            });
        }
    }, [userEmail, dispatch]);

    const handleLogout = () => {
        sessionStorage.removeItem('spark-2fa-authorized');
        sessionStorage.removeItem('spark-2fa-email');
        window.location.reload();
    };

    // Modal Videochiamata - Usa VideoCallModal originale
    if (showVideoCall) {
        return (
            <div className="min-h-screen min-h-[100dvh] bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900">
                <VideoCallModal onClose={() => setShowVideoCall(false)} />
            </div>
        );
    }

    // Modal Ticket - Usa TicketModal originale
    if (showTicketForm) {
        return (
            <div className="min-h-screen min-h-[100dvh] bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex flex-col items-center justify-center p-2 sm:p-4">
                <TicketModal onClose={() => setShowTicketForm(false)} />
            </div>
        );
    }

    // Dashboard principale con 2 pulsanti - LAYOUT COMPATTO COME LOGIN
    return (
        <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex items-center justify-center overflow-hidden">
            {/* Contenitore centrale compatto */}
            <div className="w-full max-w-md mx-auto px-4 flex flex-col items-center">
                
                {/* Avatar */}
                <div className="relative mb-3">
                    <SparkAvatar size="lg" className="h-20 w-20 sm:h-24 sm:w-24" />
                </div>

                {/* Titolo */}
                <h1 className="text-2xl sm:text-3xl font-bold text-white mb-1">86BIT | SPARK</h1>
                <p className="text-blue-200 text-sm sm:text-base">IT Service Desk</p>
                <p className="text-blue-300/70 text-xs sm:text-sm mb-6">assistenza@86bit.it</p>

                {/* Pulsanti */}
                <div className="w-full space-y-3 mb-6">
                    {/* Pulsante Videochiamata */}
                    <button
                        onClick={() => setShowVideoCall(true)}
                        className="w-full bg-gradient-to-r from-green-500 to-emerald-600 active:from-green-600 active:to-emerald-700 text-white p-4 sm:p-5 rounded-2xl shadow-lg transition-transform active:scale-[0.98] flex items-center gap-4"
                    >
                        <div className="bg-white/20 p-3 rounded-xl flex-shrink-0">
                            <Video className="h-6 w-6 sm:h-7 sm:w-7" />
                        </div>
                        <div className="text-left">
                            <span className="block text-lg sm:text-xl font-bold">Videochiamata</span>
                            <span className="block text-green-100 text-sm">Parla con un tecnico</span>
                        </div>
                    </button>

                    {/* Pulsante Apri Ticket */}
                    <button
                        onClick={() => setShowTicketForm(true)}
                        className="w-full bg-gradient-to-r from-orange-500 to-red-500 active:from-orange-600 active:to-red-600 text-white p-4 sm:p-5 rounded-2xl shadow-lg transition-transform active:scale-[0.98] flex items-center gap-4"
                    >
                        <div className="bg-white/20 p-3 rounded-xl flex-shrink-0">
                            <Ticket className="h-6 w-6 sm:h-7 sm:w-7" />
                        </div>
                        <div className="text-left">
                            <span className="block text-lg sm:text-xl font-bold">Apri Ticket</span>
                            <span className="block text-orange-100 text-sm">Segnala un problema</span>
                        </div>
                    </button>
                </div>

                {/* Link logout */}
                <button
                    onClick={handleLogout}
                    className="text-white/50 hover:text-white/70 text-sm flex items-center justify-center gap-2 py-2 mb-4 transition-colors"
                >
                    <RotateCcw className="h-4 w-4" />
                    Esci
                </button>

                {/* Footer */}
                <div className="text-center">
                    <a href="https://www.86bit.it/" target="_blank" rel="noopener noreferrer">
                        <img 
                            src={LOGO_86BIT_BASE64} 
                            alt="86BIT" 
                            className="h-8 sm:h-10 mx-auto mb-2 opacity-90 hover:opacity-100 transition-opacity cursor-pointer"
                        />
                    </a>
                    <div className="text-white/50 text-[8px] sm:text-[10px] leading-relaxed">
                        <p className="font-semibold text-white/70 mb-0.5">86BIT srl Unipersonale</p>
                        <p>C.F. e P.Iva 04353030168 • Cap. Soc. € 50.000,00 i.v.</p>
                        <p>Reg. Imprese BG 04353030168 • REA n. BG456578</p>
                        <p className="mt-1 text-white/40">Sede Op.: Scanzorosciate (BG) • Sede Sec.: Clusone (BG)</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Standalone Video Call Modal (senza dipendenze da ChatContext)
const StandaloneVideoCallModal = ({ userEmail, onClose }) => {
    const [step, setStep] = useState('password'); // 'password', 'confirm', 'calling'
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [roomName, setRoomName] = useState('');
    
    const generateRoomName = () => {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < 20; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };
    
    const getDisplayName = () => {
        const name = userEmail.split('@')[0] || 'Utente';
        return name.charAt(0).toUpperCase() + name.slice(1);
    };
    
    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/auth/verify-video-password`, {
                method: 'POST',
                headers: getAuthHeaders(),
                credentials: 'include',
                body: JSON.stringify({ password })
            });
            
            const data = await response.json();
            
            if (data.success) {
                setError('');
                setStep('confirm');
            } else {
                setError(data.error || 'Password non corretta');
            }
        } catch (err) {
            setError('Errore di connessione. Riprova.');
        }
        
        setIsLoading(false);
    };
    
    const startVideoCall = async () => {
        setIsLoading(true);
        const newRoom = generateRoomName();
        setRoomName(newRoom);
        
        // Notifica 86BIT su Teams
        try {
            const backendUrl = API_BASE_URL;
            await fetch(`${backendUrl}/api/teams/notify-call`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userName: getDisplayName(),
                    userCompany: 'Accesso Web 2FA',
                    userComputer: 'Web Browser',
                    roomName: newRoom,
                    roomUrl: `https://meet.ffmuc.net/${newRoom}`
                })
            });
        } catch (e) {
            console.error('[VIDEOCALL] Errore notifica:', e);
        }
        
        setStep('calling');
        setIsLoading(false);
    };
    
    const getJitsiIframeUrl = () => {
        if (!roomName) return '';
        const displayName = encodeURIComponent(getDisplayName());
        // Abilitati controlli camera frontale/posteriore per mobile
        return `https://meet.ffmuc.net/${roomName}#userInfo.displayName="${displayName}"&config.prejoinPageEnabled=false&config.requireDisplayName=false&config.enableWelcomePage=false&config.disableDeepLinking=true&config.disableRemoteMute=true&config.startWithVideoMuted=false&config.startWithAudioMuted=false&interfaceConfig.MOBILE_APP_PROMO=false&interfaceConfig.SHOW_JITSI_WATERMARK=false&interfaceConfig.TOOLBAR_BUTTONS=["microphone","camera","hangup","chat","settings","videoquality","filmstrip","tileview","select-background","toggle-camera"]&interfaceConfig.SETTINGS_SECTIONS=["devices","language"]&interfaceConfig.SHOW_CHROME_EXTENSION_BANNER=false`;
    };
    
    const handleEndCall = () => {
        setStep('password');
        setPassword('');
        setRoomName('');
        onClose();
    };

    // Schermo intero per la videochiamata
    if (step === 'calling') {
        return (
            <div className="fixed inset-0 bg-gray-900 z-[100] flex flex-col">
                <div className="bg-gray-800 p-2 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-2 text-white">
                        <Video className="h-5 w-5 text-green-400" />
                        <span className="text-sm font-medium">Videochiamata 86BIT</span>
                    </div>
                    <button
                        onClick={handleEndCall}
                        className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg flex items-center gap-1 transition-colors"
                    >
                        <Phone className="h-4 w-4 rotate-[135deg]" />
                        Termina
                    </button>
                </div>
                
                <iframe
                    src={getJitsiIframeUrl()}
                    className="flex-1 w-full border-0"
                    style={{ minHeight: 'calc(100vh - 52px)' }}
                    allow="camera; microphone; fullscreen; display-capture; autoplay"
                    allowFullScreen
                />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex flex-col items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 rounded-t-2xl flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <Video className="h-6 w-6 text-white" />
                        <h2 className="text-xl font-bold text-white">Videochiamata Supporto</h2>
                    </div>
                    <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/20 text-white">
                        <XCircle className="h-6 w-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 space-y-5">
                    {step === 'password' && (
                        <>
                            <div className="bg-blue-50 rounded-xl p-4">
                                <div className="flex items-start gap-3">
                                    <div className="p-2 bg-blue-100 rounded-lg">
                                        <Shield className="h-6 w-6 text-blue-600" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-blue-900">Accesso Protetto</h3>
                                        <p className="text-sm text-blue-700 mt-1">
                                            Inserisci la password fornita da 86BIT per avviare la videochiamata.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <form onSubmit={handlePasswordSubmit} className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Password di sicurezza
                                    </label>
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => { setPassword(e.target.value); setError(''); }}
                                        className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Inserisci password"
                                        autoFocus
                                    />
                                </div>
                                
                                {error && (
                                    <div className="bg-red-50 text-red-600 p-3 rounded-xl text-sm flex items-center gap-2">
                                        <AlertTriangle className="h-5 w-5" />
                                        {error}
                                    </div>
                                )}
                                
                                <button
                                    type="submit"
                                    className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 rounded-xl font-bold hover:from-blue-600 hover:to-indigo-700 flex items-center justify-center gap-2"
                                >
                                    <Key className="h-5 w-5" />
                                    Verifica Password
                                </button>
                            </form>
                        </>
                    )}
                    
                    {step === 'confirm' && (
                        <>
                            <div className="bg-green-50 rounded-xl p-4">
                                <div className="flex items-start gap-3">
                                    <div className="p-2 bg-green-100 rounded-lg">
                                        <CheckCircle className="h-6 w-6 text-green-600" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-green-900">Password Verificata</h3>
                                        <p className="text-sm text-green-700 mt-1">
                                            Sei pronto per avviare la videochiamata con il team di supporto 86BIT.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="bg-gray-50 rounded-xl p-4 space-y-2">
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <User className="h-4 w-4" />
                                    <span>Nome: <strong>{getDisplayName()}</strong></span>
                                </div>
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <Mail className="h-4 w-4" />
                                    <span>Email: <strong>{userEmail}</strong></span>
                                </div>
                            </div>
                            
                            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
                                <p className="text-sm text-yellow-800">
                                    ⚠️ <strong>Importante:</strong> Assicurati di avere webcam e microfono funzionanti. 
                                    Un tecnico 86BIT riceverà notifica e si collegherà a breve.
                                </p>
                            </div>
                            
                            <div className="flex gap-3">
                                <button
                                    onClick={() => setStep('password')}
                                    className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-xl font-medium"
                                >
                                    ← Indietro
                                </button>
                                <button
                                    onClick={startVideoCall}
                                    disabled={isLoading}
                                    className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 rounded-xl font-bold hover:from-green-600 hover:to-emerald-700 disabled:opacity-50 flex items-center justify-center gap-2"
                                >
                                    {isLoading ? (
                                        <Loader2 className="h-5 w-5 animate-spin" />
                                    ) : (
                                        <>
                                            <Video className="h-5 w-5" />
                                            Avvia Chiamata
                                        </>
                                    )}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
            
            {/* Footer */}
            <div className="mt-4 text-center text-white/50 text-xs">
                <p>86BIT srl Unipersonale • Assistenza IT</p>
            </div>
        </div>
    );
};

// Standalone Ticket Modal (senza dipendenze da ChatContext)
const StandaloneTicketModal = ({ userEmail, onClose }) => {
    const [step, setStep] = useState('select');
    const [ticketType, setTicketType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [createdTicket, setCreatedTicket] = useState(null);
    
    // Dati per Ticket Generico
    const [genericData, setGenericData] = useState({
        summary: '',
        description: '',
        priority: 'medium'
    });
    
    // Dati per Restore File
    const [restoreData, setRestoreData] = useState({
        fileName: '',
        folderPath: '',
        lastSeenDate: '',
        restoreMode: ''
    });
    
    // Dati per Gestione Utenti
    const [userMgmtData, setUserMgmtData] = useState({
        action: '',
        newUserName: '',
        newUserRole: '',
        startDate: '',
        copyPermissionsFrom: '',
        workstationType: '',
        existingPcNumber: '',
        needEmail: true,
        desiredEmail: '',
        needSharedMailbox: '',
        sharedMailboxList: '',
        leavingUserName: '',
        leavingUserPC: '',
        hadEmail: '',
        leavingUserEmail: '',
        lastDay: '',
        emailFuture: '',
        archiveAccessTo: '',
        cleanDevice: '',
        disableNotes: ''
    });

    const handleGenericInputChange = (e) => {
        const { name, value } = e.target;
        setGenericData(prev => ({ ...prev, [name]: value }));
    };

    const handleRestoreInputChange = (e) => {
        const { name, value } = e.target;
        setRestoreData(prev => ({ ...prev, [name]: value }));
    };

    const handleUserMgmtChange = (field, value) => {
        setUserMgmtData(prev => ({ ...prev, [field]: value }));
    };

    const submitTicket = async (summary, description) => {
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/jira/ticket`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    summary,
                    description,
                    reporter: userEmail.split('@')[0] || userEmail,
                    reporter_email: userEmail,
                    client_name: state.userCompany || 'Accesso Web'
                })
            });

            if (!response.ok) {
                const errData = await response.json().catch(() => ({}));
                console.error('Ticket creation failed:', response.status, errData);
                setError(errData.detail || 'Errore nella creazione del ticket. Riprova.');
                setStep('error');
                setLoading(false);
                return;
            }

            const data = await response.json();

            if (data.key) {
                setCreatedTicket(data.key);
                setStep('success');
            } else {
                setError('Errore nella creazione del ticket');
                setStep('error');
            }
        } catch (err) {
            console.error('Ticket creation error:', err);
            setError('Errore di connessione. Riprova.');
            setStep('error');
        }

        setLoading(false);
    };

    const handleSubmitGeneric = () => {
        if (!genericData.summary.trim()) {
            setError('Inserisci un oggetto per il ticket');
            return;
        }
        submitTicket(
            genericData.summary.trim(),
            genericData.description.trim() || 'Nessuna descrizione fornita'
        );
    };

    const handleSubmitRestore = () => {
        if (!restoreData.fileName.trim()) {
            setError('Inserisci il nome del file da ripristinare');
            return;
        }
        const summary = `Richiesta Restore File: ${restoreData.fileName}`;
        const description = `
FILE DA RIPRISTINARE: ${restoreData.fileName}
PERCORSO CARTELLA: ${restoreData.folderPath || 'Non specificato'}
ULTIMA VOLTA VISTO: ${restoreData.lastSeenDate || 'Non specificato'}
MODALITÀ RESTORE: ${restoreData.restoreMode === 'replace' ? 'Sostituisci file esistente' : 'Copia con nuovo nome'}
RICHIEDENTE: ${userEmail}
        `.trim();
        submitTicket(summary, description);
    };

    const handleSubmitUserMgmt = () => {
        if (userMgmtData.action === 'nuovo') {
            if (!userMgmtData.newUserName.trim()) {
                setError('Inserisci il nome del nuovo utente');
                return;
            }
            const summary = `Nuovo Arrivo: ${userMgmtData.newUserName}`;
            const description = `
NUOVO DIPENDENTE: ${userMgmtData.newUserName}
RUOLO: ${userMgmtData.newUserRole || 'Non specificato'}
DATA INIZIO: ${userMgmtData.startDate || 'Non specificata'}
COPIA PERMESSI DA: ${userMgmtData.copyPermissionsFrom || 'Nessuno'}
POSTAZIONE: ${userMgmtData.workstationType === 'esistente' ? `Esistente (${userMgmtData.existingPcNumber})` : 'Nuova'}
EMAIL: ${userMgmtData.needEmail ? (userMgmtData.desiredEmail || 'Da creare') : 'Non necessaria'}
CASSETTE CONDIVISE: ${userMgmtData.needSharedMailbox === 'yes' ? userMgmtData.sharedMailboxList : 'No'}
RICHIEDENTE: ${userEmail}
            `.trim();
            submitTicket(summary, description);
        } else if (userMgmtData.action === 'disattiva') {
            if (!userMgmtData.leavingUserName.trim()) {
                setError('Inserisci il nome dell\'utente da disattivare');
                return;
            }
            const summary = `Disattivazione Utente: ${userMgmtData.leavingUserName}`;
            const description = `
DIPENDENTE IN USCITA: ${userMgmtData.leavingUserName}
PC UTILIZZATO: ${userMgmtData.leavingUserPC || 'Non specificato'}
EMAIL: ${userMgmtData.hadEmail === 'yes' ? userMgmtData.leavingUserEmail : 'Non aveva email'}
ULTIMO GIORNO: ${userMgmtData.lastDay || 'Non specificato'}
GESTIONE EMAIL: ${userMgmtData.emailFuture === 'autoresponder' ? 'Autoresponder' : 'Chiudi'}
ARCHIVIO ACCESSIBILE A: ${userMgmtData.archiveAccessTo || 'Nessuno'}
PULIZIA DISPOSITIVO: ${userMgmtData.cleanDevice === 'yes' ? 'Sì' : 'No'}
NOTE: ${userMgmtData.disableNotes || 'Nessuna'}
RICHIEDENTE: ${userEmail}
            `.trim();
            submitTicket(summary, description);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 flex flex-col items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <Ticket className="h-6 w-6 text-white" />
                        <h2 className="text-xl font-bold text-white">
                            {step === 'select' ? 'Apri un Ticket' :
                             step === 'restore-form' ? '🔄 Restore File da Backup' :
                             step === 'user-mgmt-select' || step === 'user-mgmt-form' ? '👥 Gestione Utenti' :
                             step === 'generic-form' ? '📝 Ticket Generico' :
                             step === 'success' ? '✅ Ticket Creato' :
                             step === 'error' ? '❌ Errore' : 'Apri un Ticket'}
                        </h2>
                    </div>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-white/20 text-white">
                        <XCircle className="h-6 w-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-6">
                    
                    {/* STEP: Selezione tipo ticket */}
                    {step === 'select' && (
                        <div className="space-y-4">
                            {/* Ticket Generico */}
                            <button
                                onClick={() => { setTicketType('generic'); setStep('generic-form'); }}
                                className="w-full p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl hover:border-blue-400 transition-all text-left"
                            >
                                <h3 className="font-bold text-gray-800 text-lg">📝 Ticket Generico</h3>
                                <p className="text-gray-600 text-sm">Segnala un problema o richiedi assistenza tecnica</p>
                            </button>


                            {/* Restore File */}
                            <button
                                onClick={() => { setTicketType('restore'); setStep('restore-form'); }}
                                className="w-full p-4 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl hover:border-green-400 transition-all text-left"
                            >
                                <h3 className="font-bold text-gray-800 text-lg">🔄 Restore File da Backup</h3>
                                <p className="text-gray-600 text-sm">Recupera un file o cartella da un backup precedente</p>
                            </button>
                        </div>
                    )}

                    {/* STEP: Selezione Gestione Utenti */}
                    {step === 'user-mgmt-select' && (
                        <div className="space-y-4">
                            <button
                                onClick={() => { handleUserMgmtChange('action', 'nuovo'); setStep('user-mgmt-form'); }}
                                className="w-full p-4 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl hover:border-green-400 transition-all text-left"
                            >
                                <h3 className="font-bold text-gray-800 text-lg">🆕 Nuovo Arrivo</h3>
                                <p className="text-gray-600 text-sm">Preparazione postazione per nuovo dipendente</p>
                            </button>

                            <button
                                onClick={() => { handleUserMgmtChange('action', 'disattiva'); setStep('user-mgmt-form'); }}
                                className="w-full p-4 bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-xl hover:border-red-400 transition-all text-left"
                            >
                                <h3 className="font-bold text-gray-800 text-lg">🚫 Disattivazione Utente</h3>
                                <p className="text-gray-600 text-sm">Gestione uscita dipendente</p>
                            </button>

                            <button onClick={() => setStep('select')} className="w-full text-gray-500 text-sm hover:text-gray-700">
                                ← Torna indietro
                            </button>
                        </div>
                    )}

                    {/* STEP: Form Gestione Utenti */}
                    {step === 'user-mgmt-form' && (
                        <div className="space-y-4">
                            {userMgmtData.action === 'nuovo' ? (
                                <>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Nome e Cognome *</label>
                                        <input
                                            type="text"
                                            value={userMgmtData.newUserName}
                                            onChange={(e) => handleUserMgmtChange('newUserName', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                            placeholder="Mario Rossi"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Ruolo/Posizione</label>
                                        <input
                                            type="text"
                                            value={userMgmtData.newUserRole}
                                            onChange={(e) => handleUserMgmtChange('newUserRole', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                            placeholder="Impiegato amministrativo"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Data Inizio</label>
                                        <input
                                            type="date"
                                            value={userMgmtData.startDate}
                                            onChange={(e) => handleUserMgmtChange('startDate', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Copia permessi da (utente esistente)</label>
                                        <input
                                            type="text"
                                            value={userMgmtData.copyPermissionsFrom}
                                            onChange={(e) => handleUserMgmtChange('copyPermissionsFrom', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                            placeholder="Nome collega con permessi simili"
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Nome e Cognome *</label>
                                        <input
                                            type="text"
                                            value={userMgmtData.leavingUserName}
                                            onChange={(e) => handleUserMgmtChange('leavingUserName', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                            placeholder="Nome dipendente in uscita"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Ultimo giorno lavorativo</label>
                                        <input
                                            type="date"
                                            value={userMgmtData.lastDay}
                                            onChange={(e) => handleUserMgmtChange('lastDay', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email utente</label>
                                        <input
                                            type="email"
                                            value={userMgmtData.leavingUserEmail}
                                            onChange={(e) => handleUserMgmtChange('leavingUserEmail', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                            placeholder="email@azienda.it"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Note aggiuntive</label>
                                        <textarea
                                            value={userMgmtData.disableNotes}
                                            onChange={(e) => handleUserMgmtChange('disableNotes', e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                            rows={3}
                                            placeholder="Eventuali note..."
                                        />
                                    </div>
                                </>
                            )}

                            {error && <div className="bg-red-50 text-red-600 p-3 rounded-xl text-sm">{error}</div>}

                            <button
                                onClick={handleSubmitUserMgmt}
                                disabled={loading}
                                className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 rounded-xl font-bold hover:from-purple-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
                            >
                                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Send className="h-5 w-5" /> Invia Richiesta</>}
                            </button>

                            <button onClick={() => setStep('user-mgmt-select')} className="w-full text-gray-500 text-sm hover:text-gray-700">
                                ← Torna indietro
                            </button>
                        </div>
                    )}

                    {/* STEP: Form Restore File */}
                    {step === 'restore-form' && (
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Nome File/Cartella *</label>
                                <input
                                    type="text"
                                    name="fileName"
                                    value={restoreData.fileName}
                                    onChange={handleRestoreInputChange}
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500"
                                    placeholder="documento.xlsx o NomeCartella"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Percorso Cartella</label>
                                <input
                                    type="text"
                                    name="folderPath"
                                    value={restoreData.folderPath}
                                    onChange={handleRestoreInputChange}
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500"
                                    placeholder="S:\Documenti\Progetto"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Ultima volta che l'hai visto</label>
                                <input
                                    type="date"
                                    name="lastSeenDate"
                                    value={restoreData.lastSeenDate}
                                    onChange={handleRestoreInputChange}
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Modalità Restore</label>
                                <div className="grid grid-cols-2 gap-3">
                                    <button
                                        type="button"
                                        onClick={() => setRestoreData(prev => ({ ...prev, restoreMode: 'replace' }))}
                                        className={`p-3 border-2 rounded-xl text-sm font-medium ${
                                            restoreData.restoreMode === 'replace' ? 'border-green-500 bg-green-50' : 'border-gray-200'
                                        }`}
                                    >
                                        Sostituisci
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setRestoreData(prev => ({ ...prev, restoreMode: 'copy' }))}
                                        className={`p-3 border-2 rounded-xl text-sm font-medium ${
                                            restoreData.restoreMode === 'copy' ? 'border-green-500 bg-green-50' : 'border-gray-200'
                                        }`}
                                    >
                                        Copia
                                    </button>
                                </div>
                            </div>

                            {error && <div className="bg-red-50 text-red-600 p-3 rounded-xl text-sm">{error}</div>}

                            <button
                                onClick={handleSubmitRestore}
                                disabled={loading}
                                className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-3 rounded-xl font-bold hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center justify-center gap-2"
                            >
                                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Send className="h-5 w-5" /> Richiedi Restore</>}
                            </button>

                            <button onClick={() => setStep('select')} className="w-full text-gray-500 text-sm hover:text-gray-700">
                                ← Torna indietro
                            </button>
                        </div>
                    )}

                    {/* STEP: Form Ticket Generico */}
                    {step === 'generic-form' && (
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Oggetto *</label>
                                <input
                                    type="text"
                                    name="summary"
                                    value={genericData.summary}
                                    onChange={handleGenericInputChange}
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                    placeholder="Descrivi brevemente il problema"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Descrizione</label>
                                <textarea
                                    name="description"
                                    value={genericData.description}
                                    onChange={handleGenericInputChange}
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                                    rows={4}
                                    placeholder="Fornisci più dettagli possibili..."
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Priorità</label>
                                <div className="grid grid-cols-3 gap-2">
                                    {[
                                        { value: 'low', label: 'Bassa', color: 'green' },
                                        { value: 'medium', label: 'Media', color: 'yellow' },
                                        { value: 'high', label: 'Alta', color: 'red' }
                                    ].map((p) => (
                                        <button
                                            key={p.value}
                                            type="button"
                                            onClick={() => setGenericData(prev => ({ ...prev, priority: p.value }))}
                                            className={`py-2 px-3 rounded-xl font-medium text-sm border-2 ${
                                                genericData.priority === p.value
                                                    ? p.color === 'green' ? 'bg-green-100 border-green-500 text-green-700' 
                                                      : p.color === 'yellow' ? 'bg-yellow-100 border-yellow-500 text-yellow-700'
                                                      : 'bg-red-100 border-red-500 text-red-700'
                                                    : 'border-gray-200 text-gray-600 hover:border-gray-300'
                                            }`}
                                        >
                                            {p.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {error && <div className="bg-red-50 text-red-600 p-3 rounded-xl text-sm">{error}</div>}

                            <button
                                onClick={handleSubmitGeneric}
                                disabled={loading}
                                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-xl font-bold hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
                            >
                                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Send className="h-5 w-5" /> Invia Ticket</>}
                            </button>

                            <button onClick={() => setStep('select')} className="w-full text-gray-500 text-sm hover:text-gray-700">
                                ← Torna indietro
                            </button>
                        </div>
                    )}

                    {/* STEP: Success */}
                    {step === 'success' && (
                        <div className="text-center py-8">
                            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
                            <h3 className="text-xl font-bold text-gray-800 mb-2">Ticket Creato!</h3>
                            <p className="text-green-600 text-lg font-mono mb-4">{createdTicket}</p>
                            <p className="text-gray-600 text-sm mb-6">
                                Riceverai aggiornamenti via email a:<br/>
                                <strong className="text-blue-600">{userEmail}</strong>
                            </p>
                            <button
                                onClick={onClose}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium"
                            >
                                Chiudi
                            </button>
                        </div>
                    )}

                    {/* STEP: Error */}
                    {step === 'error' && (
                        <div className="text-center py-8">
                            <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
                            <h3 className="text-xl font-bold text-gray-800 mb-2">Errore</h3>
                            <p className="text-red-600 mb-6">{error}</p>
                            <button
                                onClick={() => setStep('select')}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium"
                            >
                                Riprova
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Footer */}
            <div className="mt-4 text-center text-white/50 text-xs max-w-lg mx-auto">
                <p>86BIT srl Unipersonale • Assistenza IT</p>
            </div>
        </div>
    );
};

const AppContent = () => {
    const { state, dispatch } = useContext(ChatContext);
    const sparkStateRef = useRef(state);
    sparkStateRef.current = state;

    // Gestione Spark: registrazione + regole Admin (controllo ogni 60s)
    useEffect(() => {
        let alive = true;
        const beat = async () => {
            const s = sparkStateRef.current;
            try {
                const r = await fetch(`${API_BASE_URL}/api/v1/spark/heartbeat`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        install_id: getSparkDeviceId(), user_name: s.userName || '', email: s.userEmail || localStorage.getItem('spark-user-email-v1') || '',
                        company: s.userSiteName || s.userCompany || '', computer: s.userComputer || '', device_type: s.isMobile ? 'mobile' : 'desktop',
                        platform: (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '', version: APP_VERSION,
                    }),
                });
                if (!r.ok || !alive) return;
                const ctl = await r.json();
                localStorage.setItem(SPARK_CONTROL_CACHE_KEY, JSON.stringify(ctl));
                if (JSON.stringify(ctl) !== JSON.stringify(sparkStateRef.current.sparkControl)) dispatch({ type: 'SET_STATE', payload: { sparkControl: ctl } });
            } catch (e) { /* offline: mantiene l'ultima configurazione nota */ }
        };
        const first = setTimeout(beat, 1500);
        const iv = setInterval(beat, 60000);
        return () => { alive = false; clearTimeout(first); clearInterval(iv); };
    }, [dispatch]);
    
    // Imposta favicon e titolo Spark
    useEffect(() => {
        try {
            // Cambia favicon dinamicamente
            const setFavicon = (url) => {
                // Rimuovi favicon esistenti
                const existingLinks = document.querySelectorAll('link[rel*="icon"]');
                existingLinks.forEach(link => link.remove());

                // Aggiungi nuova favicon
                const link = document.createElement('link');
                link.rel = 'icon';
                link.type = 'image/x-icon';
                link.href = url;
                document.head.appendChild(link);

                // Aggiungi anche shortcut icon per compatibilità
                const shortcutLink = document.createElement('link');
                shortcutLink.rel = 'shortcut icon';
                shortcutLink.type = 'image/x-icon';
                shortcutLink.href = url;
                document.head.appendChild(shortcutLink);

                // Apple touch icon (icona Home iOS) - usa la nuova icona locale
                const appleLink = document.createElement('link');
                appleLink.rel = 'apple-touch-icon';
                appleLink.href = '/spark-icon-192-v3.png';
                document.head.appendChild(appleLink);
            };

            // Usa la nuova favicon 86BIT Spark locale
            setFavicon('/favicon.ico?v=3');

            // Imposta titolo pagina
            document.title = 'Spark - 86BIT IT Service Desk';
        } catch (e) {
            // Non bloccare mai l'app per un problema di icone/titolo
            console.warn('[Spark] favicon setup skipped:', e);
        }
    }, []);
    
    // ============================================================
    // 🔄 MONITORAGGIO LIVE DELLA CONNESSIONE
    // Rileva cambi di connessione in tempo reale (Wi-Fi ↔ LAN)
    // ============================================================
    useEffect(() => {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        
        if (!connection) {
            console.log('[NET-LIVE] Network Information API non supportata');
            return;
        }
        
        let lastConnectionType = state.userConnectionType;
        
        const detectCurrentConnection = () => {
            let detectedType = null;
            
            // Rileva tipo di connessione dalla API
            if (connection.type) {
                if (connection.type === 'ethernet') {
                    detectedType = 'LAN';
                } else if (connection.type === 'wifi') {
                    detectedType = 'Wi-Fi';
                } else if (['cellular', '2g', '3g', '4g', '5g'].includes(connection.type)) {
                    detectedType = 'Wi-Fi'; // Mobile = wireless
                }
            }
            
            // Fallback: effectiveType
            if (!detectedType && connection.effectiveType) {
                // Se downlink è alto (> 50 Mbps) probabilmente è LAN
                if (connection.downlink && connection.downlink > 50) {
                    detectedType = 'LAN';
                }
            }
            
            return detectedType;
        };
        
        const handleConnectionChange = () => {
            const newConnectionType = detectCurrentConnection();
            
            if (newConnectionType && newConnectionType !== lastConnectionType) {
                console.log(`[NET-LIVE] 🔄 Cambio connessione rilevato: ${lastConnectionType} → ${newConnectionType}`);
                
                // Aggiorna lo state
                dispatch({ 
                    type: 'SET_STATE', 
                    payload: { 
                        userConnectionType: newConnectionType,
                        userConnectionSource: 'live-detected'
                    } 
                });
                
                // Notifica l'utente del cambio
                if (lastConnectionType) {
                    // Aggiungi messaggio in chat
                    dispatch({
                        type: 'ADD_MESSAGE',
                        payload: {
                            sender: 'system',
                            text: `🔄 Connessione cambiata: ora sei connesso via **${newConnectionType}** (prima: ${lastConnectionType})`,
                            type: 'system-info',
                            id: Date.now()
                        }
                    });
                }
                
                lastConnectionType = newConnectionType;
            }
        };
        
        // Listener per cambi di connessione
        connection.addEventListener('change', handleConnectionChange);
        
        // Controlla anche periodicamente (ogni 30 secondi)
        const intervalId = setInterval(handleConnectionChange, 30000);
        
        console.log('[NET-LIVE] ✅ Monitoraggio connessione attivato');
        
        return () => {
            connection.removeEventListener('change', handleConnectionChange);
            clearInterval(intervalId);
        };
    }, [state.userConnectionType]);
    
    // Segnala allo splash screen che Spark è caricata
    useEffect(() => {
        // callback_port gia' catturato nel global (URL gia' pulito all'avvio)
        const sparkParams = (typeof window !== 'undefined' && window.__SPARK_URL_PARAMS__) || {};
        const callbackPort = sparkParams.callback_port;
        
        if (callbackPort) {
            // Invia segnale HTTP allo splash screen
            const sendSignal = () => {
                try {
                    fetch(`http://127.0.0.1:${callbackPort}/ready`, { 
                        mode: 'no-cors',
                        method: 'GET'
                    }).catch(() => {});
                } catch (e) {}
            };
            
            // Invia segnale multiplo per affidabilità
            sendSignal();
            setTimeout(sendSignal, 300);
            setTimeout(sendSignal, 600);
            setTimeout(sendSignal, 1000);
        }
    }, []);
    
    if (state.sparkControl && state.sparkControl.blocked) {
        return <AccessInfoScreen message={state.sparkControl.block_message || 'Servizio non disponibile.'} />;
    }

    return (
        <>
            {/* Container principale */}
            <div className={`min-h-[100dvh] flex items-center justify-center p-0 sm:p-2 md:p-4 font-sans transition-colors duration-300 ${
                state.darkMode 
                    ? 'bg-gradient-to-br from-gray-900 to-gray-800' 
                    : 'bg-gradient-to-br from-indigo-50 to-purple-100'
            }`}>
                {/* Card chat - full screen su mobile, card centrata su desktop */}
                <div className={`w-full sm:max-w-2xl sm:rounded-xl shadow-2xl overflow-hidden flex flex-col h-[100dvh] sm:h-[calc(100vh-1rem)] md:h-[800px] lg:h-[700px] relative transition-colors duration-300 ${
                    state.darkMode ? 'bg-gray-900' : 'bg-white'
                }`}>
                    <ChatInterface />
                </div>
                <ContactSidebar />
            </div>
            <Modals />
        </>
    );
};

// ============================================================================
// ADMIN ZONE - Login 2FA (TOTP) + Invio Notifiche Push (Firebase)
// Accesso: ?admin=1 oppure /admin — solo email in whitelist + 2FA.
// ============================================================================
const ADMIN_PRIORITIES = [
    { value: 'low', label: 'Bassa', color: 'text-slate-300', dot: 'bg-slate-400' },
    { value: 'normal', label: 'Normale', color: 'text-sky-300', dot: 'bg-sky-400' },
    { value: 'high', label: 'Alta', color: 'text-amber-300', dot: 'bg-amber-400' },
    { value: 'urgent', label: 'Urgente', color: 'text-red-300', dot: 'bg-red-500' },
];

const AdminZone = () => {
    const [step, setStep] = useState('email'); // email | activate | setup | totp | dashboard
    const [activationCode, setActivationCode] = useState('');
    const [email, setEmail] = useState('');
    const [totpCode, setTotpCode] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [secretKey, setSecretKey] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const totpRefs = useRef([]);

    // Dashboard state
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [uploading, setUploading] = useState(false);
    const [targetType, setTargetType] = useState('broadcast');
    const [selectedSites, setSelectedSites] = useState([]);
    const [deviceValue, setDeviceValue] = useState('');
    const [priority, setPriority] = useState('normal');
    const [scheduleMode, setScheduleMode] = useState('now');
    const [scheduledAt, setScheduledAt] = useState('');
    const [expiresAt, setExpiresAt] = useState('');
    const [sites, setSites] = useState([]);
    const [sent, setSent] = useState([]);
    const [sending, setSending] = useState(false);
    const [toast, setToast] = useState(null);
    // MFA management
    const [adminTab, setAdminTab] = useState('notifiche'); // notifiche | mfa
    const [mfaUsers, setMfaUsers] = useState([]);
    const [mfaQuery, setMfaQuery] = useState('');
    const [mfaAudit, setMfaAudit] = useState([]);
    const [confirmReset, setConfirmReset] = useState(null); // user object pending confirm
    const [resetting, setResetting] = useState(false);
    const [confirmRevokePk, setConfirmRevokePk] = useState(null); // user pending passkey revoke
    const [revokingPk, setRevokingPk] = useState(false);
    const [secStats, setSecStats] = useState(null);
    const [purgingNotes, setPurgingNotes] = useState(false);
    const [purgeResult, setPurgeResult] = useState(null);
    // Statistiche dispositivi (push attive)
    const [stats, setStats] = useState(null);
    // Dettaglio lettori per notifica
    const [readersFor, setReadersFor] = useState(null);
    const [readersList, setReadersList] = useState([]);
    const [readersLoading, setReadersLoading] = useState(false);
    // Stato servizi (banner disservizi)
    const [svcActive, setSvcActive] = useState(false);
    const [svcLevel, setSvcLevel] = useState('warning');
    const [svcTitle, setSvcTitle] = useState('');
    const [svcMessage, setSvcMessage] = useState('');
    const [svcExpiresAt, setSvcExpiresAt] = useState('');
    const [svcNotify, setSvcNotify] = useState(true);
    const [svcSaving, setSvcSaving] = useState(false);

    const showToast = (type, msg) => {
        setToast({ type, msg });
        setTimeout(() => setToast(null), 4000);
    };

    const checkStatus = async () => {
        if (!email || !email.includes('@')) { setError("Inserisci un'email valida"); return; }
        setLoading(true); setError('');
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/auth/totp/status`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email.trim().toLowerCase() })
            });
            if (r.status === 404) { setError('Endpoint Admin non disponibile sul backend (404). Va implementato lato server (vedi ADMIN_BACKEND_SPEC).'); setLoading(false); return; }
            const d = await r.json();
            if (d.success) {
                if (d.totpEnabled) { setStep('totp'); }
                else { setStep('activate'); }
            } else { setError(d.error || 'Errore verifica.'); }
        } catch (e) { setError('Errore di connessione al backend Admin.'); }
        setLoading(false);
    };

    const startActivation = async () => {
        if (!activationCode.trim()) { setError('Inserisci il codice di attivazione ricevuto dal super admin.'); return; }
        setLoading(true); setError('');
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/auth/totp/activate/start`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email.trim().toLowerCase(), activation_code: activationCode.trim() })
            });
            const d = await r.json().catch(() => ({}));
            if (r.ok && d.success) { setQrCodeUrl(d.qrCodeUrl); setSecretKey(d.secretKey); setStep('setup'); }
            else setError(d.detail || 'Codice di attivazione non valido.');
        } catch (e) { setError('Errore di connessione.'); }
        setLoading(false);
    };

    const submitTotp = async (mode) => {
        if (totpCode.length !== 6) { setError('Inserisci il codice a 6 cifre.'); return; }
        setLoading(true); setError('');
        const url = mode === 'setup' ? '/api/v1/admin/auth/totp/activate/confirm' : '/api/v1/admin/auth/totp/verify';
        const payload = mode === 'setup'
            ? { email: email.trim().toLowerCase(), token: totpCode, activation_code: activationCode.trim() }
            : { email: email.trim().toLowerCase(), token: totpCode };
        try {
            const r = await fetch(`${API_BASE_URL}${url}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (r.status === 404) { setError('Endpoint Admin non disponibile sul backend (404).'); setLoading(false); return; }
            const d = await r.json();
            if (d.success && d.token) {
                saveAuthToken(d.token);
                setActivationCode(''); setSecretKey(''); setQrCodeUrl('');
                setStep('dashboard');
                loadSites(); loadSent(); loadStats(); loadServiceStatus();
            } else { setError(d.error || d.detail || 'Codice non valido.'); setTotpCode(''); }
        } catch (e) { setError('Errore di connessione.'); }
        setLoading(false);
    };

    const handleTotpChange = (i, v) => {
        if (v.length > 1) v = v.slice(-1);
        if (!/^\d*$/.test(v)) return;
        const arr = totpCode.split(''); arr[i] = v; setTotpCode(arr.join(''));
        if (v && i < 5) totpRefs.current[i + 1]?.focus();
    };
    const handleTotpKey = (i, e) => {
        if (e.key === 'Backspace' && !totpCode[i] && i > 0) totpRefs.current[i - 1]?.focus();
    };

    const loadSites = async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/rmm/sites`);
            const d = await r.json();
            setSites(d.sites || []);
        } catch (e) {}
    };
    const loadSent = async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/notifications`, { headers: getAuthHeaders() });
            const d = await r.json();
            setSent(d.notifications || []);
        } catch (e) {}
    };
    const loadStats = async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/notifications/stats`, { headers: getAuthHeaders() });
            const d = await r.json();
            setStats(d);
        } catch (e) {}
    };
    const toggleReaders = async (notifId) => {
        if (readersFor === notifId) { setReadersFor(null); setReadersList([]); return; }
        setReadersFor(notifId); setReadersList([]); setReadersLoading(true);
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/notifications/${notifId}/readers`, { headers: getAuthHeaders() });
            const d = await r.json();
            setReadersList(d.readers || []);
        } catch (e) {}
        setReadersLoading(false);
    };
    const loadServiceStatus = async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/service-status`, { headers: getAuthHeaders() });
            const d = await r.json();
            setSvcActive(!!d.active);
            setSvcLevel(d.level || 'warning');
            setSvcTitle(d.title || '');
            setSvcMessage(d.message || '');
            setSvcExpiresAt(d.expires_at ? new Date(d.expires_at).toISOString().slice(0, 16) : '');
        } catch (e) {}
    };
    const saveServiceStatus = async (activate) => {
        if (activate && !svcMessage.trim()) { showToast('error', 'Inserisci il messaggio del disservizio.'); return; }
        setSvcSaving(true);
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/service-status`, {
                method: 'POST', headers: getAuthHeaders(),
                body: JSON.stringify({
                    active: activate, level: svcLevel,
                    title: svcTitle.trim() || null, message: svcMessage.trim(),
                    expires_at: (activate && svcExpiresAt) ? new Date(svcExpiresAt).toISOString() : null,
                    notify: activate ? svcNotify : false,
                })
            });
            const d = await r.json();
            if (d.success) {
                setSvcActive(activate);
                let msg = activate ? 'Banner disservizio ATTIVATO per tutti gli utenti.' : 'Banner disservizio disattivato.';
                if (activate && svcNotify) {
                    msg += d.pushMocked ? ' (push in MOCK)' : ` Push inviata a ${d.pushSent || 0} dispositivi.`;
                }
                showToast('success', msg);
            } else { showToast('error', d.detail || 'Salvataggio fallito.'); }
        } catch (e) { showToast('error', 'Errore salvataggio stato servizi.'); }
        setSvcSaving(false);
    };

    const handleImage = async (file) => {
        if (!file) return;
        if (file.size > 5 * 1024 * 1024) { showToast('error', 'Immagine troppo grande (max 5MB).'); return; }
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append('file', file);
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/notifications/upload`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${getAuthToken()}` },
                body: fd
            });
            const d = await r.json();
            if (d.success) { setImageUrl(d.url); showToast('success', 'Immagine caricata.'); }
            else { showToast('error', d.detail || 'Upload fallito.'); }
        } catch (e) { showToast('error', 'Errore upload immagine.'); }
        setUploading(false);
    };

    const toggleSite = (name) => {
        setSelectedSites(prev => prev.includes(name) ? prev.filter(s => s !== name) : [...prev, name]);
    };

    const sendNotification = async () => {
        if (!title.trim() || !body.trim()) { showToast('error', 'Titolo e messaggio obbligatori.'); return; }
        if (targetType === 'site' && selectedSites.length === 0) { showToast('error', 'Seleziona almeno un\'azienda.'); return; }
        if (targetType === 'device' && !deviceValue.trim()) { showToast('error', 'Inserisci il nome del PC.'); return; }
        setSending(true);
        const target = {
            type: targetType,
            values: targetType === 'site' ? selectedSites : targetType === 'device' ? [deviceValue.trim()] : []
        };
        const payload = {
            title: title.trim(), body: body.trim(), imageUrl: imageUrl || null,
            target, priority,
            scheduledAt: scheduleMode === 'later' && scheduledAt ? new Date(scheduledAt).toISOString() : null,
            expiresAt: expiresAt ? new Date(expiresAt).toISOString() : null
        };
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/notifications/send`, {
                method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(payload)
            });
            const d = await r.json();
            if (d.success) {
                showToast('success', `${d.status === 'scheduled' ? 'Programmata' : 'Inviata'} a ${d.recipientCount} destinatari.`);
                setTitle(''); setBody(''); setImageUrl(''); setSelectedSites([]); setDeviceValue('');
                setPriority('normal'); setScheduleMode('now'); setScheduledAt(''); setExpiresAt('');
                loadSent(); loadStats();
            } else { showToast('error', d.detail || 'Invio fallito.'); }
        } catch (e) { showToast('error', 'Errore invio notifica.'); }
        setSending(false);
    };

    const logout = () => { clearAuthToken(); setStep('email'); setEmail(''); setTotpCode(''); };

    const loadMfaUsers = async (q = '') => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/users?query=${encodeURIComponent(q)}`, { headers: getAuthHeaders() });
            const d = await r.json();
            setMfaUsers(d.users || []);
        } catch (e) {}
    };
    const loadMfaAudit = async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/audit/mfa-resets`, { headers: getAuthHeaders() });
            const d = await r.json();
            setMfaAudit(d.events || []);
        } catch (e) {}
    };
    const doResetMfa = async (user) => {
        setResetting(true);
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/users/reset-mfa`, {
                method: 'POST', headers: getAuthHeaders(), body: JSON.stringify({ email: user.email })
            });
            const d = await r.json();
            if (d.success) { showToast('success', `2FA di ${user.name} resettato.`); loadMfaUsers(mfaQuery); loadMfaAudit(); loadSecStats(); }
            else { showToast('error', d.detail || 'Reset fallito.'); }
        } catch (e) { showToast('error', 'Errore durante il reset.'); }
        setResetting(false);
        setConfirmReset(null);
    };
    const doRevokePasskey = async (user) => {
        setRevokingPk(true);
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/users/revoke-passkey`, {
                method: 'POST', headers: getAuthHeaders(), body: JSON.stringify({ email: user.email })
            });
            const d = await r.json();
            if (d.success) { showToast('success', `Passkey di ${user.name} revocata.`); loadMfaUsers(mfaQuery); loadMfaAudit(); loadSecStats(); }
            else { showToast('error', d.detail || 'Revoca fallita.'); }
        } catch (e) { showToast('error', 'Errore durante la revoca.'); }
        setRevokingPk(false);
        setConfirmRevokePk(null);
    };
    const openMfaTab = () => { setAdminTab('mfa'); loadMfaUsers(''); loadMfaAudit(); loadSecStats(); };
    const loadSecStats = async () => {
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/security/stats`, { headers: getAuthHeaders() });
            const d = await r.json();
            setSecStats(d);
        } catch (e) {}
    };
    const purgeInternalNotes = async () => {
        setPurgingNotes(true);
        setPurgeResult(null);
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/admin/tickets/purge-internal-notes`, {
                method: 'POST', headers: getAuthHeaders(),
            });
            const d = await r.json();
            if (d.success) {
                setPurgeResult(d);
                showToast('success', `Bonifica completata: ${d.removed_notes} note interne rimosse da ${d.cleaned_tickets} ticket.`);
            } else {
                showToast('error', d.detail || 'Bonifica non riuscita.');
            }
        } catch (e) { showToast('error', 'Errore durante la bonifica.'); }
        setPurgingNotes(false);
    };
    // ---- RENDER: LOGIN ----
    if (step !== 'dashboard') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-950 p-4" data-testid="admin-login-screen">
                <div className="w-full max-w-md bg-slate-900 rounded-2xl border border-slate-800 shadow-2xl overflow-hidden">
                    <div className="bg-gradient-to-r from-indigo-600 to-violet-600 p-6 text-center">
                        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/15 mb-3">
                            <Shield className="w-7 h-7 text-white" />
                        </div>
                        <h1 className="text-2xl font-bold text-white">Spark Admin</h1>
                        <p className="text-indigo-200 text-sm mt-1">Zona riservata IT · 86BIT</p>
                    </div>
                    <div className="p-6 space-y-4">
                        {error && (
                            <div className="flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-300 text-sm rounded-lg p-3" data-testid="admin-error">
                                <AlertTriangle className="w-4 h-4 flex-shrink-0" /> {error}
                            </div>
                        )}
                        {step === 'email' && (
                            <>
                                <label className="block text-slate-300 text-sm font-medium">Email amministratore</label>
                                <div className="relative">
                                    <AtSign className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                                    <input
                                        type="email" value={email} onChange={e => setEmail(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && checkStatus()}
                                        placeholder="nome.cognome@86bit.it"
                                        className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-10 pr-3 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500"
                                        data-testid="admin-email-input" autoFocus
                                    />
                                </div>
                                <button onClick={checkStatus} disabled={loading}
                                    className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                                    data-testid="admin-continue-btn">
                                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
                                    Continua
                                </button>
                                <p className="text-slate-500 text-xs text-center">Accesso consentito solo agli account autorizzati.</p>
                            </>
                        )}
                        {step === 'activate' && (
                            <div className="space-y-3" data-testid="admin-activate-step">
                                <div className="text-center">
                                    <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-500/15 mb-2"><KeyRound className="w-6 h-6 text-amber-400" /></div>
                                    <p className="text-slate-300 text-sm">Account non ancora attivato.</p>
                                    <p className="text-slate-500 text-xs mt-1">Inserisci il codice di attivazione monouso fornito dal super admin.</p>
                                </div>
                                <input value={activationCode} onChange={e => setActivationCode(e.target.value.toUpperCase())}
                                    onKeyDown={e => e.key === 'Enter' && startActivation()}
                                    placeholder="XXXXXX-XXXXXX-XXXXXX" autoComplete="off"
                                    className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-3 text-white text-center font-mono tracking-wider placeholder-slate-600 focus:outline-none focus:border-indigo-500"
                                    data-testid="admin-activation-code-input" autoFocus />
                                <button onClick={startActivation} disabled={loading}
                                    className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
                                    data-testid="admin-activation-continue-btn">
                                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Verifica codice
                                </button>
                                <button onClick={() => { setStep('email'); setActivationCode(''); setError(''); }} className="w-full text-slate-500 hover:text-slate-300 text-xs" data-testid="admin-activation-back-btn">← Cambia email</button>
                            </div>
                        )}
                        {step === 'setup' && (
                            <div className="text-center space-y-3">
                                <p className="text-slate-300 text-sm">Configura il 2FA: scansiona con Microsoft/Google Authenticator.</p>
                                {qrCodeUrl && <img src={qrCodeUrl} alt="QR TOTP" className="mx-auto w-44 h-44 rounded-lg bg-white p-2" data-testid="admin-qr" />}
                                <p className="text-slate-500 text-xs break-all">Chiave: <span className="text-slate-300 font-mono">{secretKey}</span></p>
                                <div className="flex justify-center gap-2" data-testid="admin-totp-setup">
                                    {[0,1,2,3,4,5].map(i => (
                                        <input key={i} ref={el => totpRefs.current[i] = el} type="text" inputMode="numeric" maxLength={1}
                                            value={totpCode[i] || ''} onChange={e => handleTotpChange(i, e.target.value)} onKeyDown={e => handleTotpKey(i, e)}
                                            className="w-11 h-14 text-center text-xl font-bold bg-slate-800 border border-slate-700 rounded-lg text-white focus:outline-none focus:border-indigo-500" data-testid={`admin-totp-setup-input-${i}`} />
                                    ))}
                                </div>
                                <button onClick={() => submitTotp('setup')} disabled={loading}
                                    className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
                                    data-testid="admin-setup-verify-btn">
                                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle className="w-4 h-4" />} Attiva 2FA
                                </button>
                            </div>
                        )}
                        {step === 'totp' && (
                            <div className="text-center space-y-4">
                                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-indigo-500/15"><KeyRound className="w-6 h-6 text-indigo-400" /></div>
                                <p className="text-slate-300 text-sm">Inserisci il codice a 6 cifre dalla tua app di autenticazione.</p>
                                <div className="flex justify-center gap-2" data-testid="admin-totp-verify">
                                    {[0,1,2,3,4,5].map(i => (
                                        <input key={i} ref={el => totpRefs.current[i] = el} type="text" inputMode="numeric" maxLength={1}
                                            value={totpCode[i] || ''} onChange={e => handleTotpChange(i, e.target.value)} onKeyDown={e => handleTotpKey(i, e)}
                                            className="w-11 h-14 text-center text-xl font-bold bg-slate-800 border border-slate-700 rounded-lg text-white focus:outline-none focus:border-indigo-500"
                                            autoFocus={i === 0} data-testid={`admin-totp-input-${i}`} />
                                    ))}
                                </div>
                                <button onClick={() => submitTotp('verify')} disabled={loading}
                                    className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
                                    data-testid="admin-verify-btn">
                                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Accedi
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    // ---- RENDER: DASHBOARD ----
    const priorityMeta = ADMIN_PRIORITIES.find(p => p.value === priority);
    return (
        <div className="min-h-screen bg-slate-950 text-slate-100" data-testid="admin-dashboard">
            {toast && (
                <div className={`fixed top-4 right-4 z-50 px-4 py-3 rounded-lg shadow-lg text-sm font-medium ${toast.type === 'success' ? 'bg-emerald-600' : 'bg-red-600'} text-white`} data-testid="admin-toast">
                    {toast.msg}
                </div>
            )}
            <header className="border-b border-slate-800 bg-slate-900/60 backdrop-blur sticky top-0 z-40">
                <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center"><BellRing className="w-5 h-5 text-white" /></div>
                        <div>
                            <h1 className="font-bold leading-tight">Spark Admin</h1>
                            <p className="text-xs text-slate-400">Centro Notifiche · {email}</p>
                        </div>
                    </div>
                    <button onClick={logout} className="text-sm text-slate-400 hover:text-white flex items-center gap-1.5" data-testid="admin-logout-btn">
                        <ArrowLeft className="w-4 h-4" /> Esci
                    </button>
                </div>
            </header>

            {/* Tab bar */}
            <div className="max-w-5xl mx-auto px-4 pt-4">
                <div className="inline-flex bg-slate-900 border border-slate-800 rounded-xl p-1 gap-1">
                    <button onClick={() => setAdminTab('notifiche')}
                        className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 ${adminTab === 'notifiche' ? 'bg-indigo-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        data-testid="admin-tab-notifiche">
                        <BellRing className="w-4 h-4" /> Notifiche
                    </button>
                    <button onClick={openMfaTab}
                        className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 ${adminTab === 'mfa' ? 'bg-indigo-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        data-testid="admin-tab-mfa">
                        <KeyRound className="w-4 h-4" /> Sicurezza Utenti
                    </button>
                    <button onClick={() => { setAdminTab('servizi'); loadServiceStatus(); }}
                        className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 ${adminTab === 'servizi' ? 'bg-indigo-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        data-testid="admin-tab-servizi">
                        <AlertTriangle className="w-4 h-4" /> Stato Servizi
                    </button>
                    <button onClick={() => setAdminTab('admins')}
                        className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 ${adminTab === 'admins' ? 'bg-indigo-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        data-testid="admin-tab-admins">
                        <KeyRound className="w-4 h-4" /> Amministratori
                    </button>
                    <button onClick={() => setAdminTab('spark')}
                        className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 ${adminTab === 'spark' ? 'bg-indigo-600 text-white' : 'text-slate-400 hover:text-white'}`}
                        data-testid="admin-tab-spark">
                        <SlidersHorizontal className="w-4 h-4" /> Gestione Spark
                    </button>
                </div>
            </div>

            {adminTab === 'notifiche' && (
            <main className="max-w-5xl mx-auto px-4 py-6 grid grid-cols-1 lg:grid-cols-5 gap-6">
                {/* Composer */}
                <section className="lg:col-span-3 space-y-4 bg-slate-900 rounded-2xl border border-slate-800 p-5">
                    <h2 className="text-lg font-semibold flex items-center gap-2"><Send className="w-5 h-5 text-indigo-400" /> Nuova notifica</h2>

                    <div>
                        <label className="block text-sm text-slate-300 mb-1">Titolo</label>
                        <input value={title} onChange={e => setTitle(e.target.value)} maxLength={80}
                            placeholder="Es. Manutenzione programmata"
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500"
                            data-testid="admin-notif-title" />
                    </div>
                    <div>
                        <label className="block text-sm text-slate-300 mb-1">Messaggio</label>
                        <textarea value={body} onChange={e => setBody(e.target.value)} rows={3} maxLength={500}
                            placeholder="Testo della notifica..."
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500 resize-none"
                            data-testid="admin-notif-body" />
                    </div>

                    {/* Immagine */}
                    <div>
                        <label className="block text-sm text-slate-300 mb-1">Immagine (opzionale)</label>
                        {imageUrl ? (
                            <div className="relative inline-block">
                                <img src={imageUrl} alt="preview" className="max-h-32 rounded-lg border border-slate-700" data-testid="admin-image-preview" />
                                <button onClick={() => setImageUrl('')} className="absolute -top-2 -right-2 bg-red-600 rounded-full p-1" data-testid="admin-image-remove"><X className="w-3 h-3 text-white" /></button>
                            </div>
                        ) : (
                            <label className="flex items-center gap-2 cursor-pointer bg-slate-800 border border-dashed border-slate-600 rounded-lg px-3 py-3 text-slate-400 hover:border-indigo-500 w-fit" data-testid="admin-image-upload">
                                {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImageIcon className="w-4 h-4" />}
                                <span className="text-sm">{uploading ? 'Caricamento...' : 'Carica immagine'}</span>
                                <input type="file" accept="image/*" className="hidden" onChange={e => handleImage(e.target.files?.[0])} />
                            </label>
                        )}
                    </div>

                    {/* Destinatari */}
                    <div>
                        <label className="block text-sm text-slate-300 mb-1.5">Destinatari</label>
                        <div className="grid grid-cols-3 gap-2">
                            {[
                                { v: 'broadcast', label: 'Tutti', icon: BellRing },
                                { v: 'site', label: 'Azienda', icon: Building2 },
                                { v: 'device', label: 'PC specifico', icon: Monitor },
                            ].map(opt => (
                                <button key={opt.v} onClick={() => setTargetType(opt.v)}
                                    className={`flex flex-col items-center gap-1 py-3 rounded-lg border text-xs font-medium transition-colors ${targetType === opt.v ? 'bg-indigo-600 border-indigo-500 text-white' : 'bg-slate-800 border-slate-700 text-slate-400 hover:border-slate-500'}`}
                                    data-testid={`admin-target-${opt.v}`}>
                                    <opt.icon className="w-4 h-4" /> {opt.label}
                                </button>
                            ))}
                        </div>
                        {targetType === 'site' && (
                            <div className="mt-2 max-h-40 overflow-y-auto space-y-1 bg-slate-800/50 rounded-lg p-2" data-testid="admin-sites-list">
                                {sites.map(s => (
                                    <label key={s.id} className="flex items-center gap-2 text-sm text-slate-300 px-2 py-1.5 rounded hover:bg-slate-800 cursor-pointer">
                                        <input type="checkbox" checked={selectedSites.includes(s.name)} onChange={() => toggleSite(s.name)} className="accent-indigo-500" />
                                        {s.name}
                                    </label>
                                ))}
                            </div>
                        )}
                        {targetType === 'device' && (
                            <input value={deviceValue} onChange={e => setDeviceValue(e.target.value)} placeholder="Nome PC (es. PC-OFFICE-01)"
                                className="mt-2 w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500"
                                data-testid="admin-device-input" />
                        )}
                    </div>

                    {/* Priorità */}
                    <div>
                        <label className="block text-sm text-slate-300 mb-1.5">Priorità</label>
                        <div className="flex gap-2">
                            {ADMIN_PRIORITIES.map(p => (
                                <button key={p.value} onClick={() => setPriority(p.value)}
                                    className={`flex items-center gap-1.5 px-3 py-2 rounded-lg border text-xs font-medium ${priority === p.value ? 'bg-slate-700 border-slate-500 text-white' : 'bg-slate-800 border-slate-700 text-slate-400'}`}
                                    data-testid={`admin-priority-${p.value}`}>
                                    <span className={`w-2 h-2 rounded-full ${p.dot}`}></span>{p.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Programmazione */}
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm text-slate-300 mb-1.5">Invio</label>
                            <div className="flex gap-2">
                                <button onClick={() => setScheduleMode('now')} className={`flex-1 py-2 rounded-lg border text-xs font-medium ${scheduleMode === 'now' ? 'bg-indigo-600 border-indigo-500 text-white' : 'bg-slate-800 border-slate-700 text-slate-400'}`} data-testid="admin-send-now">Subito</button>
                                <button onClick={() => setScheduleMode('later')} className={`flex-1 py-2 rounded-lg border text-xs font-medium ${scheduleMode === 'later' ? 'bg-indigo-600 border-indigo-500 text-white' : 'bg-slate-800 border-slate-700 text-slate-400'}`} data-testid="admin-send-later">Programma</button>
                            </div>
                            {scheduleMode === 'later' && (
                                <input type="datetime-local" value={scheduledAt} onChange={e => setScheduledAt(e.target.value)}
                                    className="mt-2 w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-indigo-500" data-testid="admin-scheduled-at" />
                            )}
                        </div>
                        <div>
                            <label className="block text-sm text-slate-300 mb-1.5">Scadenza (opzionale)</label>
                            <input type="datetime-local" value={expiresAt} onChange={e => setExpiresAt(e.target.value)}
                                className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-indigo-500" data-testid="admin-expires-at" />
                        </div>
                    </div>

                    <button onClick={sendNotification} disabled={sending}
                        className="w-full bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-500 hover:to-violet-500 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
                        data-testid="admin-send-btn">
                        {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                        {scheduleMode === 'later' ? 'Programma notifica' : 'Invia notifica'}
                    </button>
                </section>

                {/* Preview + Storico */}
                <section className="lg:col-span-2 space-y-4">
                    <div className="bg-slate-900 rounded-2xl border border-slate-800 p-5">
                        <h3 className="text-sm font-semibold text-slate-400 mb-3 flex items-center gap-2"><Eye className="w-4 h-4" /> Anteprima</h3>
                        <div className="bg-slate-800 rounded-xl p-3 border border-slate-700" data-testid="admin-preview-card">
                            <div className="flex items-start gap-3">
                                <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center flex-shrink-0"><Bell className="w-4 h-4 text-white" /></div>
                                <div className="min-w-0 flex-1">
                                    <div className="flex items-center gap-2">
                                        <p className="font-semibold text-sm truncate">{title || 'Titolo notifica'}</p>
                                        <span className={`text-[10px] ${priorityMeta.color}`}>● {priorityMeta.label}</span>
                                    </div>
                                    <p className="text-slate-300 text-sm mt-0.5 break-words">{body || 'Il messaggio apparirà qui...'}</p>
                                    {imageUrl && <img src={imageUrl} alt="" className="mt-2 rounded-lg max-h-28" />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-slate-900 rounded-2xl border border-slate-800 p-5" data-testid="admin-device-stats">
                        <div className="flex items-center justify-between mb-3">
                            <h3 className="text-sm font-semibold text-slate-400 flex items-center gap-2"><Smartphone className="w-4 h-4" /> Push attive</h3>
                            <button onClick={loadStats} className="text-slate-500 hover:text-white" data-testid="admin-refresh-stats"><RefreshCw className="w-4 h-4" /></button>
                        </div>
                        <div className="flex items-baseline gap-2">
                            <span className="text-3xl font-bold text-emerald-400" data-testid="admin-stats-total">{stats ? stats.totalActive : '—'}</span>
                            <span className="text-sm text-slate-400">dispositivi riceveranno le push</span>
                        </div>
                        {stats && stats.byCompany && stats.byCompany.length > 0 && (
                            <div className="mt-3 space-y-1.5 max-h-40 overflow-y-auto" data-testid="admin-stats-companies">
                                {stats.byCompany.map((c, i) => (
                                    <div key={i} className="flex items-center justify-between text-xs bg-slate-800/50 rounded-lg px-2.5 py-1.5">
                                        <span className="text-slate-300 truncate flex items-center gap-1.5"><Building2 className="w-3 h-3 text-slate-500" />{c.company}</span>
                                        <span className="font-semibold text-slate-200">{c.count}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                        {stats && stats.totalActive === 0 && (
                            <p className="text-xs text-amber-400/80 mt-2">Nessun dispositivo ha ancora attivato le notifiche.</p>
                        )}
                    </div>
                    <div className="bg-slate-900 rounded-2xl border border-slate-800 p-5">
                        <div className="flex items-center justify-between mb-3">
                            <h3 className="text-sm font-semibold text-slate-400 flex items-center gap-2"><History className="w-4 h-4" /> Inviate di recente</h3>
                            <button onClick={loadSent} className="text-slate-500 hover:text-white" data-testid="admin-refresh-sent"><RefreshCw className="w-4 h-4" /></button>
                        </div>
                        <div className="space-y-2 max-h-96 overflow-y-auto" data-testid="admin-sent-list">
                            {sent.length === 0 && <p className="text-slate-600 text-sm text-center py-6">Nessuna notifica inviata.</p>}
                            {sent.map(n => (
                                <div key={n.id} className="bg-slate-800/60 rounded-lg p-3 border border-slate-700/50">
                                    <div className="flex items-center justify-between gap-2">
                                        <p className="font-medium text-sm truncate">{n.title}</p>
                                        <span className={`text-[10px] px-1.5 py-0.5 rounded ${n.status === 'scheduled' ? 'bg-amber-500/20 text-amber-300' : 'bg-emerald-500/20 text-emerald-300'}`}>{n.status === 'scheduled' ? 'Programmata' : 'Inviata'}</span>
                                    </div>
                                    <p className="text-slate-400 text-xs mt-1 truncate">{n.body}</p>
                                    <div className="flex items-center gap-2 mt-1.5 text-[11px] text-slate-500">
                                        <span className="flex items-center gap-1" title="Destinatari"><User className="w-3 h-3" />{n.recipient_count}</span>
                                        <span>·</span>
                                        <button onClick={() => toggleReaders(n.id)} className="flex items-center gap-1 text-emerald-400/90 hover:text-emerald-300 hover:underline" title="Vedi chi ha letto" data-testid={`admin-read-count-${n.id}`}>
                                            <Eye className="w-3 h-3" />{n.read_count || 0} lette
                                            {(n.read_count || 0) > 0 && (readersFor === n.id ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />)}
                                        </button>
                                        <span>·</span>
                                        <span>{n.target_type === 'broadcast' ? 'Tutti' : n.target_type === 'site' ? (n.target_values || []).join(', ') : (n.target_values || []).join(', ')}</span>
                                    </div>
                                    {readersFor === n.id && (
                                        <div className="mt-2 pt-2 border-t border-slate-700/50 space-y-1 max-h-40 overflow-y-auto" data-testid={`admin-readers-${n.id}`}>
                                            {readersLoading && <p className="text-[11px] text-slate-500 flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> Caricamento...</p>}
                                            {!readersLoading && readersList.length === 0 && <p className="text-[11px] text-slate-500">Nessuno ha ancora letto questa notifica.</p>}
                                            {!readersLoading && readersList.map((rd, i) => (
                                                <div key={i} className="flex items-center justify-between text-[11px] bg-slate-900/50 rounded px-2 py-1">
                                                    <span className="text-slate-300 flex items-center gap-1.5 truncate"><User className="w-3 h-3 text-slate-500" />{rd.name}{rd.computer ? ` · ${rd.computer}` : ''}</span>
                                                    <span className="text-slate-500 flex-shrink-0">{rd.read_at ? new Date(rd.read_at).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            )}

            {adminTab === 'mfa' && (
            <main className="max-w-5xl mx-auto px-4 py-6 grid grid-cols-1 lg:grid-cols-3 gap-6" data-testid="admin-mfa-view">
                {secStats && (
                <section className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="admin-sec-stats">
                    <div className="bg-slate-900 rounded-xl border border-slate-800 p-4">
                        <p className="text-2xl font-bold text-white" data-testid="admin-sec-total">{secStats.total_users}</p>
                        <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-1"><User className="w-3 h-3" /> Utenti totali</p>
                    </div>
                    <div className="bg-slate-900 rounded-xl border border-slate-800 p-4">
                        <p className="text-2xl font-bold text-emerald-400" data-testid="admin-sec-totp">{secStats.totp_active}</p>
                        <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-1"><Lock className="w-3 h-3" /> Con 2FA attivo</p>
                    </div>
                    <div className="bg-slate-900 rounded-xl border border-slate-800 p-4">
                        <p className="text-2xl font-bold text-violet-400" data-testid="admin-sec-passkey">{secStats.passkey_users}</p>
                        <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-1"><KeyRound className="w-3 h-3" /> Con Passkey</p>
                    </div>
                    <div className="bg-slate-900 rounded-xl border border-slate-800 p-4">
                        <p className="text-2xl font-bold text-slate-300" data-testid="admin-sec-passkey-total">{secStats.passkey_total}</p>
                        <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-1"><KeyRound className="w-3 h-3" /> Passkey registrate</p>
                    </div>
                </section>
                )}
                <section className="lg:col-span-3 bg-slate-900 rounded-2xl border border-amber-500/30 p-5" data-testid="admin-privacy-purge">
                    <div className="flex items-start gap-3">
                        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center">
                            <Shield className="w-5 h-5 text-amber-400" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h2 className="text-lg font-semibold text-white flex items-center gap-2">Privacy note interne Jira</h2>
                            <p className="text-xs text-slate-400 mt-1">
                                Le note interne dei tecnici (jsdPublic=False su Jira) non vengono MAI mostrate al cliente.
                                La bonifica scansiona tutti i ticket nel database e rimuove eventuali note interne vecchie
                                già memorizzate. Operazione sicura e ripetibile; gira anche automaticamente a ogni avvio.
                            </p>
                            {purgeResult && (
                                <div className="mt-3 text-xs bg-slate-800/70 border border-slate-700 rounded-lg p-3 text-slate-300" data-testid="admin-purge-result">
                                    Ticket analizzati: <b>{purgeResult.scanned}</b> · Ticket bonificati: <b className="text-amber-400">{purgeResult.cleaned_tickets}</b> · Note interne rimosse: <b className="text-amber-400">{purgeResult.removed_notes}</b>
                                </div>
                            )}
                            <button onClick={purgeInternalNotes} disabled={purgingNotes}
                                className="mt-3 bg-amber-600 hover:bg-amber-500 text-white font-semibold px-4 py-2.5 rounded-lg transition-colors flex items-center gap-2 disabled:opacity-60"
                                data-testid="admin-purge-btn">
                                {purgingNotes ? <Loader2 className="w-4 h-4 animate-spin" /> : <Shield className="w-4 h-4" />}
                                {purgingNotes ? 'Bonifica in corso…' : 'Avvia bonifica note interne'}
                            </button>
                        </div>
                    </div>
                </section>
                <section className="lg:col-span-2 space-y-4 bg-slate-900 rounded-2xl border border-slate-800 p-5">
                    <div className="flex items-center justify-between">
                        <h2 className="text-lg font-semibold flex items-center gap-2"><KeyRound className="w-5 h-5 text-indigo-400" /> Sicurezza Utenti</h2>
                        <button onClick={() => loadMfaUsers(mfaQuery)} className="text-slate-500 hover:text-white" data-testid="admin-mfa-refresh"><RefreshCw className="w-4 h-4" /></button>
                    </div>
                    <p className="text-xs text-slate-400">Azzera il 2FA (TOTP) o revoca la Passkey di un utente. Dopo l'operazione l'utente dovrà riconfigurare il metodo al prossimo accesso a "I Miei Ticket".</p>
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                        <input value={mfaQuery} onChange={e => setMfaQuery(e.target.value)} onKeyDown={e => e.key === 'Enter' && loadMfaUsers(mfaQuery)}
                            placeholder="Cerca per nome, email, PC o azienda..."
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-10 pr-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500"
                            data-testid="admin-mfa-search" />
                    </div>
                    <div className="space-y-2 max-h-[28rem] overflow-y-auto" data-testid="admin-mfa-users">
                        {mfaUsers.length === 0 && <p className="text-slate-600 text-sm text-center py-6">Nessun utente trovato.</p>}
                        {mfaUsers.map(u => (
                            <div key={u.email} className="bg-slate-800/60 rounded-lg p-3 border border-slate-700/50 flex items-center justify-between gap-3">
                                <div className="min-w-0">
                                    <p className="font-medium text-sm truncate">{u.name}</p>
                                    <p className="text-xs text-slate-400 truncate">{u.email}</p>
                                    <div className="flex items-center gap-2 mt-1 text-[11px] text-slate-500">
                                        <span className="flex items-center gap-1"><Monitor className="w-3 h-3" />{u.computer}</span>
                                        <span>·</span>
                                        <span className="flex items-center gap-1"><Building2 className="w-3 h-3" />{u.company}</span>
                                    </div>
                                    {u.passkey_count > 0 && (
                                        <div className="mt-1.5 space-y-1" data-testid={`admin-pk-info-${u.email}`}>
                                            {(u.passkeys && u.passkeys.length ? u.passkeys : [{ device_label: `${u.passkey_count} passkey`, last_used_at: u.passkey_last_used_at, created_at: u.passkey_created_at }]).map((pk, idx) => (
                                                <p key={idx} className="text-[11px] text-violet-400/90 flex items-center gap-1">
                                                    <KeyRound className="w-3 h-3 flex-shrink-0" />
                                                    <span className="font-medium">{pk.device_label}</span>
                                                    <span className="text-slate-500">
                                                        {pk.last_used_at
                                                            ? `· usata il ${new Date(pk.last_used_at).toLocaleDateString('it-IT')}`
                                                            : (pk.created_at ? `· dal ${new Date(pk.created_at).toLocaleDateString('it-IT')}` : '· mai usata')}
                                                    </span>
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="flex flex-col items-end gap-1.5 flex-shrink-0">
                                    <div className="flex items-center gap-1.5">
                                        {u.totp_enabled ? (
                                            <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-300">2FA</span>
                                        ) : (
                                            <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-600/40 text-slate-400">no 2FA</span>
                                        )}
                                        {u.passkey_count > 0 ? (
                                            <span className="text-[10px] px-1.5 py-0.5 rounded bg-violet-500/20 text-violet-300" data-testid={`admin-pk-badge-${u.email}`}>Passkey</span>
                                        ) : (
                                            <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-600/40 text-slate-400">no Passkey</span>
                                        )}
                                    </div>
                                    <button onClick={() => setConfirmReset(u)} disabled={!u.totp_enabled}
                                        className="text-xs px-2.5 py-1.5 rounded-lg bg-red-600/90 hover:bg-red-500 text-white disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1"
                                        data-testid={`admin-mfa-reset-${u.email}`}>
                                        <KeyRound className="w-3 h-3" /> Reset 2FA
                                    </button>
                                    <button onClick={() => setConfirmRevokePk(u)} disabled={!u.passkey_count}
                                        className="text-xs px-2.5 py-1.5 rounded-lg bg-violet-600/90 hover:bg-violet-500 text-white disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1"
                                        data-testid={`admin-pk-revoke-${u.email}`}>
                                        <KeyRound className="w-3 h-3" /> Revoca Passkey
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
                <section className="bg-slate-900 rounded-2xl border border-slate-800 p-5">
                    <h3 className="text-sm font-semibold text-slate-400 mb-3 flex items-center gap-2"><History className="w-4 h-4" /> Registro sicurezza</h3>
                    <div className="space-y-2 max-h-[28rem] overflow-y-auto" data-testid="admin-mfa-audit">
                        {mfaAudit.length === 0 && <p className="text-slate-600 text-sm text-center py-6">Nessuna operazione registrata.</p>}
                        {mfaAudit.map((e, i) => (
                            <div key={i} className="bg-slate-800/60 rounded-lg p-3 border border-slate-700/50 text-xs">
                                <span className={`inline-block text-[10px] px-1.5 py-0.5 rounded mb-1 ${e.action === 'passkey_revoke' ? 'bg-violet-500/20 text-violet-300' : 'bg-red-500/20 text-red-300'}`}>
                                    {e.action === 'passkey_revoke' ? 'Revoca Passkey' : 'Reset 2FA'}
                                </span>
                                <p className="text-slate-200"><span className="font-medium">{e.target_name || e.target_user}</span></p>
                                <p className="text-slate-500 mt-0.5">da {e.actor_admin}</p>
                                <p className="text-slate-600 mt-0.5">{new Date(e.timestamp).toLocaleString('it-IT')}</p>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
            )}

            {adminTab === 'spark' && <SparkControlAdmin apiBase={API_BASE_URL} getToken={getAuthToken} />}
            {adminTab === 'admins' && <AdminManager apiBase={API_BASE_URL} getToken={getAuthToken} />}

            {adminTab === 'servizi' && (
            <main className="max-w-5xl mx-auto px-4 py-6 grid grid-cols-1 lg:grid-cols-5 gap-6" data-testid="admin-servizi-view">
                <section className="lg:col-span-3 space-y-4 bg-slate-900 rounded-2xl border border-slate-800 p-5">
                    <div className="flex items-center justify-between">
                        <h2 className="text-lg font-semibold flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-400" /> Banner Disservizio</h2>
                        <span className={`text-[11px] px-2 py-0.5 rounded-full ${svcActive ? 'bg-emerald-500/20 text-emerald-300' : 'bg-slate-600/40 text-slate-400'}`} data-testid="admin-svc-state">
                            {svcActive ? 'ATTIVO' : 'Spento'}
                        </span>
                    </div>
                    <p className="text-xs text-slate-400">Quando attivo, tutti gli utenti Spark vedranno un avviso in cima all'app. Usalo durante guasti o manutenzioni.</p>

                    <div>
                        <label className="block text-sm text-slate-300 mb-1.5">Gravità</label>
                        <div className="grid grid-cols-2 gap-2">
                            <button onClick={() => setSvcLevel('warning')}
                                className={`flex items-center justify-center gap-2 py-3 rounded-lg border text-sm font-medium ${svcLevel === 'warning' ? 'bg-amber-400 border-amber-300 text-amber-950' : 'bg-slate-800 border-slate-700 text-slate-400'}`}
                                data-testid="admin-svc-level-warning">
                                <AlertTriangle className="w-4 h-4" /> Attenzione (giallo)
                            </button>
                            <button onClick={() => setSvcLevel('critical')}
                                className={`flex items-center justify-center gap-2 py-3 rounded-lg border text-sm font-medium ${svcLevel === 'critical' ? 'bg-red-600 border-red-500 text-white' : 'bg-slate-800 border-slate-700 text-slate-400'}`}
                                data-testid="admin-svc-level-critical">
                                <AlertTriangle className="w-4 h-4" /> Critico (rosso)
                            </button>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm text-slate-300 mb-1">Titolo (opzionale)</label>
                        <input value={svcTitle} onChange={e => setSvcTitle(e.target.value)} maxLength={60}
                            placeholder="Es. Disservizio email"
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500"
                            data-testid="admin-svc-title" />
                    </div>
                    <div>
                        <label className="block text-sm text-slate-300 mb-1">Messaggio</label>
                        <textarea value={svcMessage} onChange={e => setSvcMessage(e.target.value)} rows={3} maxLength={300}
                            placeholder="Es. Stiamo lavorando a un problema sui server di posta. Ci scusiamo per il disagio."
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500 resize-none"
                            data-testid="admin-svc-message" />
                    </div>

                    <div>
                        <label className="block text-sm text-slate-300 mb-1">Spegnimento automatico (opzionale)</label>
                        <input type="datetime-local" value={svcExpiresAt} onChange={e => setSvcExpiresAt(e.target.value)}
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white text-sm focus:outline-none focus:border-indigo-500"
                            data-testid="admin-svc-expires" />
                        <p className="text-[11px] text-slate-500 mt-1">Se impostato, il banner si spegne da solo a fine manutenzione.</p>
                    </div>

                    <label className="flex items-center gap-2.5 cursor-pointer bg-slate-800/50 rounded-lg px-3 py-2.5" data-testid="admin-svc-notify-label">
                        <input type="checkbox" checked={svcNotify} onChange={e => setSvcNotify(e.target.checked)} className="accent-indigo-500 w-4 h-4" data-testid="admin-svc-notify" />
                        <span className="text-sm text-slate-300 flex items-center gap-1.5"><BellRing className="w-4 h-4 text-indigo-400" /> Invia anche una notifica push a tutti (anche ad app chiusa)</span>
                    </label>

                    <div className="flex gap-2 pt-1">
                        <button onClick={() => saveServiceStatus(true)} disabled={svcSaving}
                            className="flex-1 bg-gradient-to-r from-amber-500 to-red-500 hover:from-amber-400 hover:to-red-400 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
                            data-testid="admin-svc-activate-btn">
                            {svcSaving ? <Loader2 className="w-4 h-4 animate-spin" /> : <AlertTriangle className="w-4 h-4" />} Attiva banner
                        </button>
                        <button onClick={() => saveServiceStatus(false)} disabled={svcSaving || !svcActive}
                            className="flex-1 bg-slate-700 hover:bg-slate-600 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-40"
                            data-testid="admin-svc-deactivate-btn">
                            <CheckCircle className="w-4 h-4" /> Disattiva
                        </button>
                    </div>
                </section>

                <section className="lg:col-span-2 space-y-4">
                    <div className="bg-slate-900 rounded-2xl border border-slate-800 p-5">
                        <h3 className="text-sm font-semibold text-slate-400 mb-3 flex items-center gap-2"><Eye className="w-4 h-4" /> Anteprima banner</h3>
                        {svcMessage.trim() ? (
                            <div className={`rounded-xl px-3 py-2.5 flex items-start gap-2.5 ${svcLevel === 'critical' ? 'bg-red-600 text-white' : 'bg-amber-400 text-amber-950'}`} data-testid="admin-svc-preview">
                                <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                                <div className="text-sm min-w-0">
                                    {svcTitle.trim() && <span className="font-bold mr-1.5">{svcTitle.trim()}:</span>}
                                    <span className="break-words">{svcMessage}</span>
                                </div>
                            </div>
                        ) : (
                            <p className="text-slate-600 text-sm text-center py-6">Scrivi un messaggio per vedere l'anteprima.</p>
                        )}
                    </div>
                </section>
            </main>
            )}


            {confirmReset && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50" onClick={() => setConfirmReset(null)} data-testid="admin-mfa-confirm">
                    <div className="bg-slate-900 border border-slate-700 rounded-2xl p-6 max-w-sm w-full" onClick={e => e.stopPropagation()}>
                        <div className="flex items-center gap-2 mb-3"><AlertTriangle className="w-5 h-5 text-amber-400" /><h3 className="font-semibold text-white">Confermi il reset?</h3></div>
                        <p className="text-sm text-slate-300">Stai per azzerare il 2FA di <span className="font-semibold text-white">{confirmReset.name}</span> ({confirmReset.email}). Dovrà riconfigurare l'authenticator al prossimo accesso.</p>
                        <div className="flex gap-2 mt-5">
                            <button onClick={() => setConfirmReset(null)} className="flex-1 py-2.5 rounded-lg bg-slate-700 hover:bg-slate-600 text-white text-sm" data-testid="admin-mfa-cancel">Annulla</button>
                            <button onClick={() => doResetMfa(confirmReset)} disabled={resetting} className="flex-1 py-2.5 rounded-lg bg-red-600 hover:bg-red-500 text-white text-sm flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-mfa-confirm-btn">
                                {resetting ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Reset 2FA
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {confirmRevokePk && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50" onClick={() => setConfirmRevokePk(null)} data-testid="admin-pk-confirm">
                    <div className="bg-slate-900 border border-slate-700 rounded-2xl p-6 max-w-sm w-full" onClick={e => e.stopPropagation()}>
                        <div className="flex items-center gap-2 mb-3"><AlertTriangle className="w-5 h-5 text-amber-400" /><h3 className="font-semibold text-white">Revocare la Passkey?</h3></div>
                        <p className="text-sm text-slate-300">Stai per revocare {confirmRevokePk.passkey_count > 1 ? `le ${confirmRevokePk.passkey_count} passkey` : 'la passkey'} di <span className="font-semibold text-white">{confirmRevokePk.name}</span> ({confirmRevokePk.email}). Dovrà riattivarla (Face ID / impronta) al prossimo accesso a "I Miei Ticket". Il codice Authenticator resta come riserva.</p>
                        <div className="flex gap-2 mt-5">
                            <button onClick={() => setConfirmRevokePk(null)} className="flex-1 py-2.5 rounded-lg bg-slate-700 hover:bg-slate-600 text-white text-sm" data-testid="admin-pk-cancel">Annulla</button>
                            <button onClick={() => doRevokePasskey(confirmRevokePk)} disabled={revokingPk} className="flex-1 py-2.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-pk-confirm-btn">
                                {revokingPk ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Revoca Passkey
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <p className="text-center text-slate-600 text-xs pb-6">Invio push via Firebase gestito dal backend 86BIT</p>
        </div>
    );
};


const UpdateBanner = () => {
    const [show, setShow] = useState(false);
    const [updating, setUpdating] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined' && window.__sparkUpdateReady) setShow(true);
        const handler = () => setShow(true);
        window.addEventListener('spark:update-available', handler);
        return () => window.removeEventListener('spark:update-available', handler);
    }, []);
    if (!show) return null;
    const doUpdate = async () => {
        setUpdating(true);
        // Reset "nucleare": rompe qualsiasi Service Worker/cache bloccato
        try {
            if (window.caches) {
                const keys = await caches.keys();
                await Promise.all(keys.map((k) => caches.delete(k)));
            }
        } catch (e) {}
        try {
            if ('serviceWorker' in navigator) {
                const regs = await navigator.serviceWorker.getRegistrations();
                await Promise.all(regs.map((r) => r.unregister()));
            }
        } catch (e) {}
        try { sessionStorage.removeItem('__spark_sw_reloaded'); } catch (e) {}
        // Ricarica dalla rete (i parametri URL vengono preservati)
        window.location.reload();
        // Sicurezza extra: se il reload tardasse, forzalo di nuovo
        setTimeout(() => { window.location.reload(); }, 2000);
    };
    return (
        <div className="fixed top-0 left-0 right-0 z-[9999] flex justify-center px-3"
             style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.5rem)' }}
             data-testid="update-banner">
            <div className="bg-indigo-600 text-white rounded-xl shadow-2xl px-4 py-2.5 flex items-center gap-3 max-w-md w-full animate-fade-in-up">
                <RefreshCw className={`h-5 w-5 flex-shrink-0 ${updating ? 'animate-spin' : ''}`} />
                <span className="text-sm font-semibold flex-1">{updating ? 'Aggiornamento in corso…' : 'È disponibile una nuova versione di Spark'}</span>
                <button onClick={doUpdate} disabled={updating}
                        className="bg-white text-indigo-700 text-sm font-bold px-3 py-1.5 rounded-lg hover:bg-indigo-50 transition-colors flex-shrink-0 disabled:opacity-70"
                        data-testid="update-banner-btn">{updating ? 'Attendi…' : 'Aggiorna'}</button>
            </div>
        </div>
    );
};

// ============================================================================
// MODULO PUBBLICO - Richiesta Passkey (link nascosto: /modulo-passkey)
// Crea un ticket su Jira. Protetto da un semplice codice invito anti-spam.
// ============================================================================
const PASSKEY_TYPES_FALLBACK = [
    "Chiave di sicurezza fisica",
    "Passkey Virtuali vincolate alla Postazione (Device-Bound)",
];

const PasskeyRequestForm = () => {
    const [types, setTypes] = useState(PASSKEY_TYPES_FALLBACK);
    const [company, setCompany] = useState('');
    const [phone, setPhone] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [note, setNote] = useState('');
    const [inviteCode, setInviteCode] = useState('');
    const [employees, setEmployees] = useState([{ name: '', email: '', passkey_type: '', quantity: '' }]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(null); // { ticket_key, count }

    useEffect(() => {
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/v1/public/passkey-request/config`);
                const d = await r.json();
                if (Array.isArray(d.passkey_types) && d.passkey_types.length) setTypes(d.passkey_types);
            } catch (e) { /* usa fallback */ }
        })();
    }, []);

    const setEmp = (idx, key, val) => setEmployees(list => list.map((e, i) => i === idx ? { ...e, [key]: val } : e));
    const addRow = () => setEmployees(list => [...list, { name: '', email: '', passkey_type: '', quantity: '' }]);
    const removeRow = (idx) => setEmployees(list => list.length > 1 ? list.filter((_, i) => i !== idx) : list);
    const isPhysical = (t) => (t || '').toLowerCase().includes('chiave') || (t || '').toLowerCase().includes('fisic');

    const submit = async () => {
        setError('');
        if (!company.trim()) { setError('Inserisci il nome dell\'azienda.'); return; }
        if (!contactEmail.trim()) { setError('Inserisci l\'email di contatto.'); return; }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(contactEmail.trim())) { setError('Email di contatto non valida.'); return; }
        if (!inviteCode.trim()) { setError('Inserisci il codice invito ricevuto da 86BIT.'); return; }
        const filled = employees.filter(e => e.name.trim() || e.passkey_type || e.email.trim());
        if (filled.length === 0) { setError('Aggiungi almeno un utente.'); return; }
        for (const e of filled) {
            if (!e.name.trim()) { setError('Compila Nome e Cognome in tutte le righe.'); return; }
            if (e.email.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e.email.trim())) { setError(`Email non valida per ${e.name.trim()}.`); return; }
            if (!e.passkey_type) { setError(`Seleziona la tipologia Passkey per ${e.name.trim()}.`); return; }
        }
        const payloadEmployees = filled.map(e => isPhysical(e.passkey_type)
            ? { name: e.name, email: e.email, passkey_type: e.passkey_type, quantity: Math.max(1, parseInt(e.quantity, 10) || 1) }
            : { name: e.name, email: e.email, passkey_type: e.passkey_type });
        setLoading(true);
        try {
            const r = await fetch(`${API_BASE_URL}/api/v1/public/passkey-request`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ company, phone, contact_email: contactEmail, note, invite_code: inviteCode, employees: payloadEmployees }),
            });
            const d = await r.json();
            if (r.ok && d.success) { setDone({ ticket_key: d.ticket_key, count: filled.length }); }
            else { setError(d.detail || 'Invio non riuscito. Riprova.'); }
        } catch (e) { setError('Errore di connessione. Riprova.'); }
        setLoading(false);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 text-white flex items-center justify-center p-4" data-testid="passkey-form-page">
            <div className="w-full max-w-2xl py-8">
                <div className="text-center mb-6">
                    <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-indigo-600/20 border border-indigo-500/40 mb-3">
                        <KeyRound className="w-7 h-7 text-indigo-300" />
                    </div>
                    <h1 className="text-2xl font-bold">Richiesta Passkey</h1>
                    <p className="text-sm text-slate-400 mt-1">86BIT S.r.l. · Compila e invia la richiesta per i tuoi utenti</p>
                </div>

                {!done && (
                    <div className="bg-indigo-500/10 border border-indigo-500/30 rounded-2xl p-5 mb-5 text-sm text-slate-300 space-y-2" data-testid="passkey-form-intro">
                        <p>Gentile Cliente, La preghiamo di compilare la tabella sottostante specificando, per ciascun utente, la tipologia di Passkey da assegnare:</p>
                        <ul className="space-y-2 mt-1">
                            <li className="flex gap-2">
                                <ShieldCheck className="w-4 h-4 text-indigo-400 flex-shrink-0 mt-0.5" />
                                <span><span className="font-semibold text-white">FISICA (Chiavetta USB/NFC)</span>: indicata per titolari, dirigenti e personale in frequente mobilità che necessita di accedere da postazioni di lavoro differenti (ad esempio PC fisso e notebook).</span>
                            </li>
                            <li className="flex gap-2">
                                <KeyRound className="w-4 h-4 text-indigo-400 flex-shrink-0 mt-0.5" />
                                <span><span className="font-semibold text-white">VIRTUALE (Postazione Fissa)</span>: indicata per dipendenti che operano esclusivamente dal proprio computer aziendale principale, senza altro dispositivo.</span>
                            </li>
                        </ul>
                    </div>
                )}

                {done ? (
                    <div className="bg-slate-900/80 border border-emerald-500/30 rounded-2xl p-8 text-center" data-testid="passkey-form-success">
                        <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
                        <h2 className="text-xl font-semibold">Richiesta inviata!</h2>
                        <p className="text-sm text-slate-400 mt-2">Registrata per {done.count} utente/i con il numero</p>
                        <p className="text-lg font-mono font-bold text-emerald-300 mt-1" data-testid="passkey-form-ticket-key">{done.ticket_key}</p>
                        <p className="text-xs text-slate-500 mt-4">Il team IT di 86BIT ti ricontatterà al più presto. Puoi chiudere questa pagina.</p>
                    </div>
                ) : (
                    <div className="bg-slate-900/80 border border-slate-800 rounded-2xl p-6 space-y-5 backdrop-blur">
                        {/* Intestazione azienda */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div>
                                <label className="text-xs font-medium text-slate-400 flex items-center gap-1.5 mb-1"><Building2 className="w-3.5 h-3.5" /> Nome azienda *</label>
                                <input value={company} onChange={e => setCompany(e.target.value)} placeholder="Es. Rossi S.r.l."
                                    className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" data-testid="passkey-form-company" />
                            </div>
                            <div>
                                <label className="text-xs font-medium text-slate-400 flex items-center gap-1.5 mb-1"><Phone className="w-3.5 h-3.5" /> Numero di telefono</label>
                                <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="Es. 035 123456"
                                    className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" data-testid="passkey-form-phone" />
                            </div>
                        </div>
                        <div>
                            <label className="text-xs font-medium text-slate-400 flex items-center gap-1.5 mb-1"><AtSign className="w-3.5 h-3.5" /> Email di contatto *</label>
                            <input type="email" value={contactEmail} onChange={e => setContactEmail(e.target.value)} placeholder="referente@azienda.it"
                                className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" data-testid="passkey-form-contact-email" />
                            <p className="text-[11px] text-slate-500 mt-1">Sarà il mittente della richiesta su Jira (come per i ticket Spark).</p>
                        </div>

                        {/* Tabella dipendenti */}
                        <div className="border-t border-slate-800 pt-4">
                            <div className="flex items-center justify-between mb-1">
                                <label className="text-sm font-semibold text-slate-200 flex items-center gap-1.5"><User className="w-4 h-4 text-indigo-400" /> Utenti</label>
                                <span className="text-xs text-slate-500">{employees.length} riga/e</span>
                            </div>
                            <p className="text-[11px] text-slate-500 mb-2">Inserisci tutte le persone che utilizzano le email, ciascuna con la propria email personale.</p>
                            <div className="hidden sm:grid grid-cols-[1fr_1fr_1fr_4.5rem_auto] gap-2 px-1 pb-1 text-[11px] font-medium text-slate-500">
                                <span>Nome e Cognome</span>
                                <span>Email</span>
                                <span>Tipologia Passkey</span>
                                <span>Q.tà</span>
                                <span></span>
                            </div>
                            <div className="space-y-2" data-testid="passkey-form-employees">
                                {employees.map((emp, idx) => (
                                    <div key={idx} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_1fr_4.5rem_auto] gap-2 items-center bg-slate-800/40 sm:bg-transparent rounded-lg p-2 sm:p-0" data-testid={`passkey-emp-row-${idx}`}>
                                        <input value={emp.name} onChange={e => setEmp(idx, 'name', e.target.value)} placeholder="Nome e Cognome"
                                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" data-testid={`passkey-emp-name-${idx}`} />
                                        <input type="email" value={emp.email} onChange={e => setEmp(idx, 'email', e.target.value)} placeholder="email@azienda.it"
                                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" data-testid={`passkey-emp-email-${idx}`} />
                                        <select value={emp.passkey_type} onChange={e => setEmp(idx, 'passkey_type', e.target.value)}
                                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white focus:outline-none focus:border-indigo-500" data-testid={`passkey-emp-type-${idx}`}>
                                            <option value="">— Seleziona —</option>
                                            {types.map(t => <option key={t} value={t}>{t}</option>)}
                                        </select>
                                        {isPhysical(emp.passkey_type) ? (
                                            <input type="number" min="1" value={emp.quantity} onChange={e => setEmp(idx, 'quantity', e.target.value)} placeholder="1"
                                                className="w-full bg-slate-800 border border-indigo-500/60 rounded-lg px-2 py-2.5 text-white text-center placeholder-slate-500 focus:outline-none focus:border-indigo-500" title="Quantità chiavette" data-testid={`passkey-emp-qty-${idx}`} />
                                        ) : (
                                            <span className="hidden sm:block text-center text-slate-600">—</span>
                                        )}
                                        <button onClick={() => removeRow(idx)} disabled={employees.length === 1}
                                            className="justify-self-end p-2 rounded-lg text-slate-500 hover:text-red-400 hover:bg-red-500/10 disabled:opacity-30 disabled:cursor-not-allowed" title="Rimuovi riga" data-testid={`passkey-emp-remove-${idx}`}>
                                            <Trash2 className="w-4 h-4" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <button onClick={addRow}
                                className="mt-3 w-full py-2.5 rounded-lg border border-dashed border-indigo-500/50 text-indigo-300 hover:bg-indigo-500/10 text-sm font-medium flex items-center justify-center gap-2" data-testid="passkey-form-add-row">
                                <Plus className="w-4 h-4" /> Aggiungi utente
                            </button>
                        </div>

                        <div>
                            <label className="text-xs font-medium text-slate-400 flex items-center gap-1.5 mb-1"><FileText className="w-3.5 h-3.5" /> Note (facoltativo)</label>
                            <textarea value={note} onChange={e => setNote(e.target.value)} rows={2} placeholder="Eventuali dettagli o richieste particolari..."
                                className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500 resize-none" data-testid="passkey-form-note" />
                        </div>
                        <div>
                            <label className="text-xs font-medium text-slate-400 flex items-center gap-1.5 mb-1"><Lock className="w-3.5 h-3.5" /> Codice invito *</label>
                            <input value={inviteCode} onChange={e => setInviteCode(e.target.value)} placeholder="Codice ricevuto da 86BIT"
                                className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:border-indigo-500" data-testid="passkey-form-invite" />
                        </div>

                        {error && <p className="text-sm text-red-400 flex items-center gap-1.5" data-testid="passkey-form-error"><AlertTriangle className="w-4 h-4" /> {error}</p>}

                        <button onClick={submit} disabled={loading}
                            className="w-full py-3 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white font-medium flex items-center justify-center gap-2 disabled:opacity-60" data-testid="passkey-form-submit">
                            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-4 h-4" />} Invia richiesta
                        </button>
                        <p className="text-[11px] text-slate-500 text-center">I dati inviati vengono usati esclusivamente per gestire la richiesta di Passkey.</p>
                    </div>
                )}
                <div className="text-center mt-6 pt-5 border-t border-white/10">
                    <a href="https://www.86bit.it/" target="_blank" rel="noopener noreferrer">
                        <img src={LOGO_86BIT_BASE64} alt="86BIT" className="h-8 sm:h-9 mx-auto mb-3 opacity-90 hover:opacity-100 transition-opacity cursor-pointer" />
                    </a>
                    <div className="text-slate-500 text-[10px] leading-relaxed">
                        <p className="font-semibold text-slate-400 mb-0.5">86BIT srl Unipersonale</p>
                        <p>C.F. e P.Iva 04353030168 • Cap. Soc. € 50.000,00 i.v.</p>
                        <p>Reg. Imprese BG 04353030168 • REA n. BG456578</p>
                        <p className="mt-1 text-slate-600">Sede Operativa: Piazza Papa Giovanni XXIII, 24020 Scanzorosciate (BG)</p>
                        <p className="text-slate-600">Sede Secondaria: Piazza Manzù, 8, 24023 Clusone (BG)</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const App = () => {
    if (typeof window !== 'undefined' && window.__SPARK_PASSKEY_FORM__) {
        return (
            <ErrorBoundary>
                <PasskeyRequestForm />
            </ErrorBoundary>
        );
    }
    if (typeof window !== 'undefined' && window.__SPARK_PC_FORM__) {
        return (
            <ErrorBoundary>
                <OperationsHub apiBase={API_BASE_URL} logo={LOGO_86BIT_BASE64} />
            </ErrorBoundary>
        );
    }
    if (typeof window !== 'undefined' && window.__SPARK_ADMIN_MODE__) {
        return (
            <ErrorBoundary>
                <UpdateBanner />
                <AdminZone />
            </ErrorBoundary>
        );
    }
    return (
    <ErrorBoundary>
        <BatchLaunchGuard>
            <ChatProvider>
                <UpdateBanner />
                <TouchOptimizationStyles />
                <AppContent />
                <style>{`
                /* Animazioni */
                @keyframes talking-animation { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
                .animate-talking { animation: talking-animation 1.2s ease-in-out infinite; }
                @keyframes fade-in { 0% { opacity: 0; } 100% { opacity: 1; } }
                .animate-fade-in { animation: fade-in 0.5s ease-in-out; }
                @keyframes fade-in-up { 0% { opacity: 0; transform: translateY(10px); } 100% { opacity: 1; transform: translateY(0); } }
                .animate-fade-in-up { animation: fade-in-up 0.4s ease-out; }
                @keyframes scale-in { 0% { opacity: 0; transform: scale(0.95); } 100% { opacity: 1; transform: scale(1); } }
                .animate-scale-in { animation: scale-in 0.3s ease-out; }
                @keyframes slide-up { 0% { opacity: 0; transform: translateY(100%); } 100% { opacity: 1; transform: translateY(0); } }
                .animate-slide-up { animation: slide-up 0.4s ease-out; }
                
                /* Mobile optimizations */
                @media (max-width: 640px) {
                    /* Scrollbar sottile su mobile */
                    ::-webkit-scrollbar { width: 2px; }
                    ::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 1px; }
                    
                    /* Touch targets ragionevoli - non troppo grandi */
                    button { min-height: 36px; }
                    
                    /* Input più grande per touch - previene zoom iOS */
                    input, textarea { font-size: 16px !important; }
                    
                    /* Nascondi badge Emergent su mobile per più spazio */
                    [class*="emergent"], iframe[src*="emergent"], div[style*="position: fixed"][style*="bottom"] > div:last-child { 
                        display: none !important; 
                        visibility: hidden !important;
                        opacity: 0 !important;
                    }
                }
                
                /* Safe area per notch iPhone */
                @supports (padding-bottom: env(safe-area-inset-bottom)) {
                    .pb-safe { padding-bottom: calc(env(safe-area-inset-bottom) + 0.5rem); }
                }
                
                /* Fix per overlap su mobile */
                @media (max-width: 640px) {
                    .fixed.bottom-0 { padding-bottom: env(safe-area-inset-bottom, 0); }
                }
            `}</style>
            </ChatProvider>
        </BatchLaunchGuard>
    </ErrorBoundary>
    );
};

export default App;
